/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
    * EvEmitter v1.1.0
    * Lil' event emitter
    * MIT License
    */
   
   /* jshint unused: true, undef: true, strict: true */
   
   ( function( global, factory ) {
     // universal module definition
     /* jshint strict: false */ /* globals define, module, window */
     if ( true ) {
       // AMD - RequireJS
       !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
           __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
           (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
           __WEBPACK_AMD_DEFINE_FACTORY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   }( typeof window != 'undefined' ? window : this, function() {
   
   "use strict";
   
   function EvEmitter() {}
   
   var proto = EvEmitter.prototype;
   
   proto.on = function( eventName, listener ) {
     if ( !eventName || !listener ) {
       return;
     }
     // set events hash
     var events = this._events = this._events || {};
     // set listeners array
     var listeners = events[ eventName ] = events[ eventName ] || [];
     // only add once
     if ( listeners.indexOf( listener ) == -1 ) {
       listeners.push( listener );
     }
   
     return this;
   };
   
   proto.once = function( eventName, listener ) {
     if ( !eventName || !listener ) {
       return;
     }
     // add event
     this.on( eventName, listener );
     // set once flag
     // set onceEvents hash
     var onceEvents = this._onceEvents = this._onceEvents || {};
     // set onceListeners object
     var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
     // set flag
     onceListeners[ listener ] = true;
   
     return this;
   };
   
   proto.off = function( eventName, listener ) {
     var listeners = this._events && this._events[ eventName ];
     if ( !listeners || !listeners.length ) {
       return;
     }
     var index = listeners.indexOf( listener );
     if ( index != -1 ) {
       listeners.splice( index, 1 );
     }
   
     return this;
   };
   
   proto.emitEvent = function( eventName, args ) {
     var listeners = this._events && this._events[ eventName ];
     if ( !listeners || !listeners.length ) {
       return;
     }
     // copy over to avoid interference if .off() in listener
     listeners = listeners.slice(0);
     args = args || [];
     // once stuff
     var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
   
     for ( var i=0; i < listeners.length; i++ ) {
       var listener = listeners[i]
       var isOnce = onceListeners && onceListeners[ listener ];
       if ( isOnce ) {
         // remove listener
         // remove before trigger to prevent recursion
         this.off( eventName, listener );
         // unset once flag
         delete onceListeners[ listener ];
       }
       // trigger listener
       listener.apply( this, args );
     }
   
     return this;
   };
   
   proto.allOff = function() {
     delete this._events;
     delete this._onceEvents;
   };
   
   return EvEmitter;
   
   }));
   
   
   /***/ }),
   
   /***/ 506:
   /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {
   
   /* provided dependency */ var jQuery = __webpack_require__(755);
   /*!
    * fancyBox - jQuery Plugin
    * version: 2.1.5 (Fri, 14 Jun 2013)
    * requires jQuery v1.6 or later
    *
    * Examples at http://fancyapps.com/fancybox/
    * License: www.fancyapps.com/fancybox/#license
    *
    * Copyright 2012 Janis Skarnelis - janis@fancyapps.com
    *
    */
   
   ;(function (window, document, $, undefined) {
       "use strict";
   
       var H = $("html"),
           W = $(window),
           D = $(document),
           F = $.fancybox = function () {
               F.open.apply( this, arguments );
           },
           IE =  navigator.userAgent.match(/msie/i),
           didUpdate	= null,
           isTouch		= document.createTouch !== undefined,
   
           isQuery	= function(obj) {
               return obj && obj.hasOwnProperty && obj instanceof $;
           },
           isString = function(str) {
               return str && $.type(str) === "string";
           },
           isPercentage = function(str) {
               return isString(str) && str.indexOf('%') > 0;
           },
           isScrollable = function(el) {
               return (el && !(el.style.overflow && el.style.overflow === 'hidden') && ((el.clientWidth && el.scrollWidth > el.clientWidth) || (el.clientHeight && el.scrollHeight > el.clientHeight)));
           },
           getScalar = function(orig, dim) {
               var value = parseInt(orig, 10) || 0;
   
               if (dim && isPercentage(orig)) {
                   value = F.getViewport()[ dim ] / 100 * value;
               }
   
               return Math.ceil(value);
           },
           getValue = function(value, dim) {
               return getScalar(value, dim) + 'px';
           };
   
       $.extend(F, {
           // The current version of fancyBox
           version: '2.1.5',
   
           defaults: {
               padding : 15,
               margin  : 20,
   
               width     : 800,
               height    : 600,
               minWidth  : 100,
               minHeight : 100,
               maxWidth  : 9999,
               maxHeight : 9999,
               pixelRatio: 1, // Set to 2 for retina display support
   
               autoSize   : true,
               autoHeight : false,
               autoWidth  : false,
   
               autoResize  : true,
               autoCenter  : !isTouch,
               fitToView   : true,
               aspectRatio : false,
               topRatio    : 0.5,
               leftRatio   : 0.5,
   
               scrolling : 'auto', // 'auto', 'yes' or 'no'
               wrapCSS   : '',
   
               arrows     : true,
               closeBtn   : true,
               closeClick : false,
               nextClick  : false,
               mouseWheel : true,
               autoPlay   : false,
               playSpeed  : 3000,
               preload    : 3,
               modal      : false,
               loop       : true,
   
               ajax  : {
                   dataType : 'html',
                   headers  : { 'X-fancyBox': true }
               },
               iframe : {
                   scrolling : 'auto',
                   preload   : true
               },
               swf : {
                   wmode: 'transparent',
                   allowfullscreen   : 'true',
                   allowscriptaccess : 'always'
               },
   
               keys  : {
                   next : {
                       13 : 'left', // enter
                       34 : 'up',   // page down
                       39 : 'left', // right arrow
                       40 : 'up'    // down arrow
                   },
                   prev : {
                       8  : 'right',  // backspace
                       33 : 'down',   // page up
                       37 : 'right',  // left arrow
                       38 : 'down'    // up arrow
                   },
                   close  : [27], // escape key
                   play   : [32], // space - start/stop slideshow
                   toggle : [70]  // letter "f" - toggle fullscreen
               },
   
               direction : {
                   next : 'left',
                   prev : 'right'
               },
   
               scrollOutside  : true,
   
               // Override some properties
               index   : 0,
               type    : null,
               href    : null,
               content : null,
               title   : null,
   
               // HTML templates
               tpl: {
                   wrap     : '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                   image    : '<img class="fancybox-image" src="{href}" alt="" />',
                   iframe   : '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (IE ? ' allowtransparency="true"' : '') + '></iframe>',
                   error    : '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                   closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                   next     : '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                   prev     : '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
                   loading  : '<div id="fancybox-loading"><div></div></div>'
               },
   
               // Properties for each animation type
               // Opening fancyBox
               openEffect  : 'fade', // 'elastic', 'fade' or 'none'
               openSpeed   : 250,
               openEasing  : 'swing',
               openOpacity : true,
               openMethod  : 'zoomIn',
   
               // Closing fancyBox
               closeEffect  : 'fade', // 'elastic', 'fade' or 'none'
               closeSpeed   : 250,
               closeEasing  : 'swing',
               closeOpacity : true,
               closeMethod  : 'zoomOut',
   
               // Changing next gallery item
               nextEffect : 'elastic', // 'elastic', 'fade' or 'none'
               nextSpeed  : 250,
               nextEasing : 'swing',
               nextMethod : 'changeIn',
   
               // Changing previous gallery item
               prevEffect : 'elastic', // 'elastic', 'fade' or 'none'
               prevSpeed  : 250,
               prevEasing : 'swing',
               prevMethod : 'changeOut',
   
               // Enable default helpers
               helpers : {
                   overlay : true,
                   title   : true
               },
   
               // Callbacks
               onCancel     : $.noop, // If canceling
               beforeLoad   : $.noop, // Before loading
               afterLoad    : $.noop, // After loading
               beforeShow   : $.noop, // Before changing in current item
               afterShow    : $.noop, // After opening
               beforeChange : $.noop, // Before changing gallery item
               beforeClose  : $.noop, // Before closing
               afterClose   : $.noop  // After closing
           },
   
           //Current state
           group    : {}, // Selected group
           opts     : {}, // Group options
           previous : null,  // Previous element
           coming   : null,  // Element being loaded
           current  : null,  // Currently loaded element
           isActive : false, // Is activated
           isOpen   : false, // Is currently open
           isOpened : false, // Have been fully opened at least once
   
           wrap  : null,
           skin  : null,
           outer : null,
           inner : null,
   
           player : {
               timer    : null,
               isActive : false
           },
   
           // Loaders
           ajaxLoad   : null,
           imgPreload : null,
   
           // Some collections
           transitions : {},
           helpers     : {},
   
           /*
            *	Static methods
            */
   
           open: function (group, opts) {
               if (!group) {
                   return;
               }
   
               if (!$.isPlainObject(opts)) {
                   opts = {};
               }
   
               // Close if already active
               if (false === F.close(true)) {
                   return;
               }
   
               // Normalize group
               if (!$.isArray(group)) {
                   group = isQuery(group) ? $(group).get() : [group];
               }
   
               // Recheck if the type of each element is `object` and set content type (image, ajax, etc)
               $.each(group, function(i, element) {
                   var obj = {},
                       href,
                       title,
                       content,
                       type,
                       rez,
                       hrefParts,
                       selector;
   
                   if ($.type(element) === "object") {
                       // Check if is DOM element
                       if (element.nodeType) {
                           element = $(element);
                       }
   
                       if (isQuery(element)) {
                           obj = {
                               href    : element.data('fancybox-href') || element.attr('href'),
                               title   : $('<div/>').text( element.data('fancybox-title') || element.attr('title') || '' ).html(),
                               isDom   : true,
                               element : element
                           };
   
                           if ($.metadata) {
                               $.extend(true, obj, element.metadata());
                           }
   
                       } else {
                           obj = element;
                       }
                   }
   
                   href  = opts.href  || obj.href || (isString(element) ? element : null);
                   title = opts.title !== undefined ? opts.title : obj.title || '';
   
                   content = opts.content || obj.content;
                   type    = content ? 'html' : (opts.type  || obj.type);
   
                   if (!type && obj.isDom) {
                       type = element.data('fancybox-type');
   
                       if (!type) {
                           rez  = element.prop('class').match(/fancybox\.(\w+)/);
                           type = rez ? rez[1] : null;
                       }
                   }
   
                   if (isString(href)) {
                       // Try to guess the content type
                       if (!type) {
                           if (F.isImage(href)) {
                               type = 'image';
   
                           } else if (F.isSWF(href)) {
                               type = 'swf';
   
                           } else if (href.charAt(0) === '#') {
                               type = 'inline';
   
                           } else if (isString(element)) {
                               type    = 'html';
                               content = element;
                           }
                       }
   
                       // Split url into two pieces with source url and content selector, e.g,
                       // "/mypage.html #my_id" will load "/mypage.html" and display element having id "my_id"
                       if (type === 'ajax') {
                           hrefParts = href.split(/\s+/, 2);
                           href      = hrefParts.shift();
                           selector  = hrefParts.shift();
                       }
                   }
   
                   if (!content) {
                       if (type === 'inline') {
                           if (href) {
                               content = $( isString(href) ? href.replace(/.*(?=#[^\s]+$)/, '') : href ); //strip for ie7
   
                           } else if (obj.isDom) {
                               content = element;
                           }
   
                       } else if (type === 'html') {
                           content = href;
   
                       } else if (!type && !href && obj.isDom) {
                           type    = 'inline';
                           content = element;
                       }
                   }
   
                   $.extend(obj, {
                       href     : href,
                       type     : type,
                       content  : content,
                       title    : title,
                       selector : selector
                   });
   
                   group[ i ] = obj;
               });
   
               // Extend the defaults
               F.opts = $.extend(true, {}, F.defaults, opts);
   
               // All options are merged recursive except keys
               if (opts.keys !== undefined) {
                   F.opts.keys = opts.keys ? $.extend({}, F.defaults.keys, opts.keys) : false;
               }
   
               F.group = group;
   
               return F._start(F.opts.index);
           },
   
           // Cancel image loading or abort ajax request
           cancel: function () {
               var coming = F.coming;
   
               if (coming && false === F.trigger('onCancel')) {
                   return;
               }
   
               F.hideLoading();
   
               if (!coming) {
                   return;
               }
   
               if (F.ajaxLoad) {
                   F.ajaxLoad.abort();
               }
   
               F.ajaxLoad = null;
   
               if (F.imgPreload) {
                   F.imgPreload.onload = F.imgPreload.onerror = null;
               }
   
               if (coming.wrap) {
                   coming.wrap.stop(true, true).trigger('onReset').remove();
               }
   
               F.coming = null;
   
               // If the first item has been canceled, then clear everything
               if (!F.current) {
                   F._afterZoomOut( coming );
               }
           },
   
           // Start closing animation if is open; remove immediately if opening/closing
           close: function (event) {
               F.cancel();
   
               if (false === F.trigger('beforeClose')) {
                   return;
               }
   
               F.unbindEvents();
   
               if (!F.isActive) {
                   return;
               }
   
               if (!F.isOpen || event === true) {
                   $('.fancybox-wrap').stop(true).trigger('onReset').remove();
   
                   F._afterZoomOut();
   
               } else {
                   F.isOpen = F.isOpened = false;
                   F.isClosing = true;
   
                   $('.fancybox-item, .fancybox-nav').remove();
   
                   F.wrap.stop(true, true).removeClass('fancybox-opened');
   
                   F.transitions[ F.current.closeMethod ]();
               }
           },
   
           // Manage slideshow:
           //   $.fancybox.play(); - toggle slideshow
           //   $.fancybox.play( true ); - start
           //   $.fancybox.play( false ); - stop
           play: function ( action ) {
               var clear = function () {
                       clearTimeout(F.player.timer);
                   },
                   set = function () {
                       clear();
   
                       if (F.current && F.player.isActive) {
                           F.player.timer = setTimeout(F.next, F.current.playSpeed);
                       }
                   },
                   stop = function () {
                       clear();
   
                       D.unbind('.player');
   
                       F.player.isActive = false;
   
                       F.trigger('onPlayEnd');
                   },
                   start = function () {
                       if (F.current && (F.current.loop || F.current.index < F.group.length - 1)) {
                           F.player.isActive = true;
   
                           D.bind({
                               'onCancel.player beforeClose.player' : stop,
                               'onUpdate.player'   : set,
                               'beforeLoad.player' : clear
                           });
   
                           set();
   
                           F.trigger('onPlayStart');
                       }
                   };
   
               if (action === true || (!F.player.isActive && action !== false)) {
                   start();
               } else {
                   stop();
               }
           },
   
           // Navigate to next gallery item
           next: function ( direction ) {
               var current = F.current;
   
               if (current) {
                   if (!isString(direction)) {
                       direction = current.direction.next;
                   }
   
                   F.jumpto(current.index + 1, direction, 'next');
               }
           },
   
           // Navigate to previous gallery item
           prev: function ( direction ) {
               var current = F.current;
   
               if (current) {
                   if (!isString(direction)) {
                       direction = current.direction.prev;
                   }
   
                   F.jumpto(current.index - 1, direction, 'prev');
               }
           },
   
           // Navigate to gallery item by index
           jumpto: function ( index, direction, router ) {
               var current = F.current;
   
               if (!current) {
                   return;
               }
   
               index = getScalar(index);
   
               F.direction = direction || current.direction[ (index >= current.index ? 'next' : 'prev') ];
               F.router    = router || 'jumpto';
   
               if (current.loop) {
                   if (index < 0) {
                       index = current.group.length + (index % current.group.length);
                   }
   
                   index = index % current.group.length;
               }
   
               if (current.group[ index ] !== undefined) {
                   F.cancel();
   
                   F._start(index);
               }
           },
   
           // Center inside viewport and toggle position type to fixed or absolute if needed
           reposition: function (e, onlyAbsolute) {
               var current = F.current,
                   wrap    = current ? current.wrap : null,
                   pos;
   
               if (wrap) {
                   pos = F._getPosition(onlyAbsolute);
   
                   if (e && e.type === 'scroll') {
                       delete pos.position;
   
                       wrap.stop(true, true).animate(pos, 200);
   
                   } else {
                       wrap.css(pos);
   
                       current.pos = $.extend({}, current.dim, pos);
                   }
               }
           },
   
           update: function (e) {
               var type = (e && e.originalEvent && e.originalEvent.type),
                   anyway = !type || type === 'orientationchange';
   
               if (anyway) {
                   clearTimeout(didUpdate);
   
                   didUpdate = null;
               }
   
               if (!F.isOpen || didUpdate) {
                   return;
               }
   
               didUpdate = setTimeout(function() {
                   var current = F.current;
   
                   if (!current || F.isClosing) {
                       return;
                   }
   
                   F.wrap.removeClass('fancybox-tmp');
   
                   if (anyway || type === 'load' || (type === 'resize' && current.autoResize)) {
                       F._setDimension();
                   }
   
                   if (!(type === 'scroll' && current.canShrink)) {
                       F.reposition(e);
                   }
   
                   F.trigger('onUpdate');
   
                   didUpdate = null;
   
               }, (anyway && !isTouch ? 0 : 300));
           },
   
           // Shrink content to fit inside viewport or restore if resized
           toggle: function ( action ) {
               if (F.isOpen) {
                   F.current.fitToView = $.type(action) === "boolean" ? action : !F.current.fitToView;
   
                   // Help browser to restore document dimensions
                   if (isTouch) {
                       F.wrap.removeAttr('style').addClass('fancybox-tmp');
   
                       F.trigger('onUpdate');
                   }
   
                   F.update();
               }
           },
   
           hideLoading: function () {
               D.unbind('.loading');
   
               $('#fancybox-loading').remove();
           },
   
           showLoading: function () {
               var el, viewport;
   
               F.hideLoading();
   
               el = $(F.opts.tpl.loading).click(F.cancel).appendTo('body');
   
               // If user will press the escape-button, the request will be canceled
               D.bind('keydown.loading', function(e) {
                   if ((e.which || e.keyCode) === 27) {
                       e.preventDefault();
   
                       F.cancel();
                   }
               });
   
               if (!F.defaults.fixed) {
                   viewport = F.getViewport();
   
                   el.css({
                       position : 'absolute',
                       top  : (viewport.h * 0.5) + viewport.y,
                       left : (viewport.w * 0.5) + viewport.x
                   });
               }
   
               F.trigger('onLoading');
           },
   
           getViewport: function () {
               var locked = (F.current && F.current.locked) || false,
                   rez    = {
                       x: W.scrollLeft(),
                       y: W.scrollTop()
                   };
   
               if (locked && locked.length) {
                   rez.w = locked[0].clientWidth;
                   rez.h = locked[0].clientHeight;
   
               } else {
                   // See http://bugs.jquery.com/ticket/6724
                   rez.w = isTouch && window.innerWidth  ? window.innerWidth  : W.width();
                   rez.h = isTouch && window.innerHeight ? window.innerHeight : W.height();
               }
   
               return rez;
           },
   
           // Unbind the keyboard / clicking actions
           unbindEvents: function () {
               if (F.wrap && isQuery(F.wrap)) {
                   F.wrap.unbind('.fb');
               }
   
               D.unbind('.fb');
               W.unbind('.fb');
           },
   
           bindEvents: function () {
               var current = F.current,
                   keys;
   
               if (!current) {
                   return;
               }
   
               // Changing document height on iOS devices triggers a 'resize' event,
               // that can change document height... repeating infinitely
               W.bind('orientationchange.fb' + (isTouch ? '' : ' resize.fb') + (current.autoCenter && !current.locked ? ' scroll.fb' : ''), F.update);
   
               keys = current.keys;
   
               if (keys) {
                   D.bind('keydown.fb', function (e) {
                       var code   = e.which || e.keyCode,
                           target = e.target || e.srcElement;
   
                       // Skip esc key if loading, because showLoading will cancel preloading
                       if (code === 27 && F.coming) {
                           return false;
                       }
   
                       // Ignore key combinations and key events within form elements
                       if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && !(target && (target.type || $(target).is('[contenteditable]')))) {
                           $.each(keys, function(i, val) {
                               if (current.group.length > 1 && val[ code ] !== undefined) {
                                   F[ i ]( val[ code ] );
   
                                   e.preventDefault();
                                   return false;
                               }
   
                               if ($.inArray(code, val) > -1) {
                                   F[ i ] ();
   
                                   e.preventDefault();
                                   return false;
                               }
                           });
                       }
                   });
               }
   
               if ($.fn.mousewheel && current.mouseWheel) {
                   F.wrap.bind('mousewheel.fb', function (e, delta, deltaX, deltaY) {
                       var target = e.target || null,
                           parent = $(target),
                           canScroll = false;
   
                       while (parent.length) {
                           if (canScroll || parent.is('.fancybox-skin') || parent.is('.fancybox-wrap')) {
                               break;
                           }
   
                           canScroll = isScrollable( parent[0] );
                           parent    = $(parent).parent();
                       }
   
                       if (delta !== 0 && !canScroll) {
                           if (F.group.length > 1 && !current.canShrink) {
                               if (deltaY > 0 || deltaX > 0) {
                                   F.prev( deltaY > 0 ? 'down' : 'left' );
   
                               } else if (deltaY < 0 || deltaX < 0) {
                                   F.next( deltaY < 0 ? 'up' : 'right' );
                               }
   
                               e.preventDefault();
                           }
                       }
                   });
               }
           },
   
           trigger: function (event, o) {
               var ret, obj = o || F.coming || F.current;
   
               if (obj) {
                   if ($.isFunction( obj[event] )) {
                       ret = obj[event].apply(obj, Array.prototype.slice.call(arguments, 1));
                   }
   
                   if (ret === false) {
                       return false;
                   }
   
                   if (obj.helpers) {
                       $.each(obj.helpers, function (helper, opts) {
                           if (opts && F.helpers[helper] && $.isFunction(F.helpers[helper][event])) {
                               F.helpers[helper][event]($.extend(true, {}, F.helpers[helper].defaults, opts), obj);
                           }
                       });
                   }
               }
   
               D.trigger(event);
           },
   
           isImage: function (str) {
               return isString(str) && str.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
           },
   
           isSWF: function (str) {
               return isString(str) && str.match(/\.(swf)((\?|#).*)?$/i);
           },
   
           _start: function (index) {
               var coming = {},
                   obj,
                   href,
                   type,
                   margin,
                   padding;
   
               index = getScalar( index );
               obj   = F.group[ index ] || null;
   
               if (!obj) {
                   return false;
               }
   
               coming = $.extend(true, {}, F.opts, obj);
   
               // Convert margin and padding properties to array - top, right, bottom, left
               margin  = coming.margin;
               padding = coming.padding;
   
               if ($.type(margin) === 'number') {
                   coming.margin = [margin, margin, margin, margin];
               }
   
               if ($.type(padding) === 'number') {
                   coming.padding = [padding, padding, padding, padding];
               }
   
               // 'modal' propery is just a shortcut
               if (coming.modal) {
                   $.extend(true, coming, {
                       closeBtn   : false,
                       closeClick : false,
                       nextClick  : false,
                       arrows     : false,
                       mouseWheel : false,
                       keys       : null,
                       helpers: {
                           overlay : {
                               closeClick : false
                           }
                       }
                   });
               }
   
               // 'autoSize' property is a shortcut, too
               if (coming.autoSize) {
                   coming.autoWidth = coming.autoHeight = true;
               }
   
               if (coming.width === 'auto') {
                   coming.autoWidth = true;
               }
   
               if (coming.height === 'auto') {
                   coming.autoHeight = true;
               }
   
               /*
                * Add reference to the group, so it`s possible to access from callbacks, example:
                * afterLoad : function() {
                *     this.title = 'Image ' + (this.index + 1) + ' of ' + this.group.length + (this.title ? ' - ' + this.title : '');
                * }
                */
   
               coming.group  = F.group;
               coming.index  = index;
   
               // Give a chance for callback or helpers to update coming item (type, title, etc)
               F.coming = coming;
   
               if (false === F.trigger('beforeLoad')) {
                   F.coming = null;
   
                   return;
               }
   
               type = coming.type;
               href = coming.href;
   
               if (!type) {
                   F.coming = null;
   
                   //If we can not determine content type then drop silently or display next/prev item if looping through gallery
                   if (F.current && F.router && F.router !== 'jumpto') {
                       F.current.index = index;
   
                       return F[ F.router ]( F.direction );
                   }
   
                   return false;
               }
   
               F.isActive = true;
   
               if (type === 'image' || type === 'swf') {
                   coming.autoHeight = coming.autoWidth = false;
                   coming.scrolling  = 'visible';
               }
   
               if (type === 'image') {
                   coming.aspectRatio = true;
               }
   
               if (type === 'iframe' && isTouch) {
                   coming.scrolling = 'scroll';
               }
   
               // Build the neccessary markup
               coming.wrap = $(coming.tpl.wrap).addClass('fancybox-' + (isTouch ? 'mobile' : 'desktop') + ' fancybox-type-' + type + ' fancybox-tmp ' + coming.wrapCSS).appendTo( coming.parent || 'body' );
   
               $.extend(coming, {
                   skin  : $('.fancybox-skin',  coming.wrap),
                   outer : $('.fancybox-outer', coming.wrap),
                   inner : $('.fancybox-inner', coming.wrap)
               });
   
               $.each(["Top", "Right", "Bottom", "Left"], function(i, v) {
                   coming.skin.css('padding' + v, getValue(coming.padding[ i ]));
               });
   
               F.trigger('onReady');
   
               // Check before try to load; 'inline' and 'html' types need content, others - href
               if (type === 'inline' || type === 'html') {
                   if (!coming.content || !coming.content.length) {
                       return F._error( 'content' );
                   }
   
               } else if (!href) {
                   return F._error( 'href' );
               }
   
               if (type === 'image') {
                   F._loadImage();
   
               } else if (type === 'ajax') {
                   F._loadAjax();
   
               } else if (type === 'iframe') {
                   F._loadIframe();
   
               } else {
                   F._afterLoad();
               }
           },
   
           _error: function ( type ) {
               $.extend(F.coming, {
                   type       : 'html',
                   autoWidth  : true,
                   autoHeight : true,
                   minWidth   : 0,
                   minHeight  : 0,
                   scrolling  : 'no',
                   hasError   : type,
                   content    : F.coming.tpl.error
               });
   
               F._afterLoad();
           },
   
           _loadImage: function () {
               // Reset preload image so it is later possible to check "complete" property
               var img = F.imgPreload = new Image();
   
               img.onload = function () {
                   this.onload = this.onerror = null;
   
                   F.coming.width  = this.width / F.opts.pixelRatio;
                   F.coming.height = this.height / F.opts.pixelRatio;
   
                   F._afterLoad();
               };
   
               img.onerror = function () {
                   this.onload = this.onerror = null;
   
                   F._error( 'image' );
               };
   
               img.src = F.coming.href;
   
               if (img.complete !== true) {
                   F.showLoading();
               }
           },
   
           _loadAjax: function () {
               var coming = F.coming;
   
               F.showLoading();
   
               F.ajaxLoad = $.ajax($.extend({}, coming.ajax, {
                   url: coming.href,
                   error: function (jqXHR, textStatus) {
                       if (F.coming && textStatus !== 'abort') {
                           F._error( 'ajax', jqXHR );
   
                       } else {
                           F.hideLoading();
                       }
                   },
                   success: function (data, textStatus) {
                       if (textStatus === 'success') {
                           coming.content = data;
   
                           F._afterLoad();
                       }
                   }
               }));
           },
   
           _loadIframe: function() {
               var coming = F.coming,
                   iframe = $(coming.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime()))
                       .attr('scrolling', isTouch ? 'auto' : coming.iframe.scrolling)
                       .attr('src', coming.href);
   
               // This helps IE
               $(coming.wrap).bind('onReset', function () {
                   try {
                       $(this).find('iframe').hide().attr('src', '//about:blank').end().empty();
                   } catch (e) {}
               });
   
               if (coming.iframe.preload) {
                   F.showLoading();
   
                   iframe.one('load', function() {
                       $(this).data('ready', 1);
   
                       // iOS will lose scrolling if we resize
                       if (!isTouch) {
                           $(this).bind('load.fb', F.update);
                       }
   
                       // Without this trick:
                       //   - iframe won't scroll on iOS devices
                       //   - IE7 sometimes displays empty iframe
                       $(this).parents('.fancybox-wrap').width('100%').removeClass('fancybox-tmp').show();
   
                       F._afterLoad();
                   });
               }
   
               coming.content = iframe.appendTo( coming.inner );
   
               if (!coming.iframe.preload) {
                   F._afterLoad();
               }
           },
   
           _preloadImages: function() {
               var group   = F.group,
                   current = F.current,
                   len     = group.length,
                   cnt     = current.preload ? Math.min(current.preload, len - 1) : 0,
                   item,
                   i;
   
               for (i = 1; i <= cnt; i += 1) {
                   item = group[ (current.index + i ) % len ];
   
                   if (item.type === 'image' && item.href) {
                       new Image().src = item.href;
                   }
               }
           },
   
           _afterLoad: function () {
               var coming   = F.coming,
                   previous = F.current,
                   placeholder = 'fancybox-placeholder',
                   current,
                   content,
                   type,
                   scrolling,
                   href,
                   embed;
   
               F.hideLoading();
   
               if (!coming || F.isActive === false) {
                   return;
               }
   
               if (false === F.trigger('afterLoad', coming, previous)) {
                   coming.wrap.stop(true).trigger('onReset').remove();
   
                   F.coming = null;
   
                   return;
               }
   
               if (previous) {
                   F.trigger('beforeChange', previous);
   
                   previous.wrap.stop(true).removeClass('fancybox-opened')
                       .find('.fancybox-item, .fancybox-nav')
                       .remove();
               }
   
               F.unbindEvents();
   
               current   = coming;
               content   = coming.content;
               type      = coming.type;
               scrolling = coming.scrolling;
   
               $.extend(F, {
                   wrap  : current.wrap,
                   skin  : current.skin,
                   outer : current.outer,
                   inner : current.inner,
                   current  : current,
                   previous : previous
               });
   
               href = current.href;
   
               switch (type) {
                   case 'inline':
                   case 'ajax':
                   case 'html':
                       if (current.selector) {
                           content = $('<div>').html(content).find(current.selector);
   
                       } else if (isQuery(content)) {
                           if (!content.data(placeholder)) {
                               content.data(placeholder, $('<div class="' + placeholder + '"></div>').insertAfter( content ).hide() );
                           }
   
                           content = content.show().detach();
   
                           current.wrap.bind('onReset', function () {
                               if ($(this).find(content).length) {
                                   content.hide().replaceAll( content.data(placeholder) ).data(placeholder, false);
                               }
                           });
                       }
                   break;
   
                   case 'image':
                       content = current.tpl.image.replace(/\{href\}/g, href);
                   break;
   
                   case 'swf':
                       content = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + href + '"></param>';
                       embed   = '';
   
                       $.each(current.swf, function(name, val) {
                           content += '<param name="' + name + '" value="' + val + '"></param>';
                           embed   += ' ' + name + '="' + val + '"';
                       });
   
                       content += '<embed src="' + href + '" type="application/x-shockwave-flash" width="100%" height="100%"' + embed + '></embed></object>';
                   break;
               }
   
               if (!(isQuery(content) && content.parent().is(current.inner))) {
                   current.inner.append( content );
               }
   
               // Give a chance for helpers or callbacks to update elements
               F.trigger('beforeShow');
   
               // Set scrolling before calculating dimensions
               current.inner.css('overflow', scrolling === 'yes' ? 'scroll' : (scrolling === 'no' ? 'hidden' : scrolling));
   
               // Set initial dimensions and start position
               F._setDimension();
   
               F.reposition();
   
               F.isOpen = false;
               F.coming = null;
   
               F.bindEvents();
   
               if (!F.isOpened) {
                   $('.fancybox-wrap').not( current.wrap ).stop(true).trigger('onReset').remove();
   
               } else if (previous.prevMethod) {
                   F.transitions[ previous.prevMethod ]();
               }
   
               F.transitions[ F.isOpened ? current.nextMethod : current.openMethod ]();
   
               F._preloadImages();
           },
   
           _setDimension: function () {
               var viewport   = F.getViewport(),
                   steps      = 0,
                   canShrink  = false,
                   canExpand  = false,
                   wrap       = F.wrap,
                   skin       = F.skin,
                   inner      = F.inner,
                   current    = F.current,
                   width      = current.width,
                   height     = current.height,
                   minWidth   = current.minWidth,
                   minHeight  = current.minHeight,
                   maxWidth   = current.maxWidth,
                   maxHeight  = current.maxHeight,
                   scrolling  = current.scrolling,
                   scrollOut  = current.scrollOutside ? current.scrollbarWidth : 0,
                   margin     = current.margin,
                   wMargin    = getScalar(margin[1] + margin[3]),
                   hMargin    = getScalar(margin[0] + margin[2]),
                   wPadding,
                   hPadding,
                   wSpace,
                   hSpace,
                   origWidth,
                   origHeight,
                   origMaxWidth,
                   origMaxHeight,
                   ratio,
                   width_,
                   height_,
                   maxWidth_,
                   maxHeight_,
                   iframe,
                   body;
   
               // Reset dimensions so we could re-check actual size
               wrap.add(skin).add(inner).width('auto').height('auto').removeClass('fancybox-tmp');
   
               wPadding = getScalar(skin.outerWidth(true)  - skin.width());
               hPadding = getScalar(skin.outerHeight(true) - skin.height());
   
               // Any space between content and viewport (margin, padding, border, title)
               wSpace = wMargin + wPadding;
               hSpace = hMargin + hPadding;
   
               origWidth  = isPercentage(width)  ? (viewport.w - wSpace) * getScalar(width)  / 100 : width;
               origHeight = isPercentage(height) ? (viewport.h - hSpace) * getScalar(height) / 100 : height;
   
               if (current.type === 'iframe') {
                   iframe = current.content;
   
                   if (current.autoHeight && iframe.data('ready') === 1) {
                       try {
                           if (iframe[0].contentWindow.document.location) {
                               inner.width( origWidth ).height(9999);
   
                               body = iframe.contents().find('body');
   
                               if (scrollOut) {
                                   body.css('overflow-x', 'hidden');
                               }
   
                               origHeight = body.outerHeight(true);
                           }
   
                       } catch (e) {}
                   }
   
               } else if (current.autoWidth || current.autoHeight) {
                   inner.addClass( 'fancybox-tmp' );
   
                   // Set width or height in case we need to calculate only one dimension
                   if (!current.autoWidth) {
                       inner.width( origWidth );
                   }
   
                   if (!current.autoHeight) {
                       inner.height( origHeight );
                   }
   
                   if (current.autoWidth) {
                       origWidth = inner.width();
                   }
   
                   if (current.autoHeight) {
                       origHeight = inner.height();
                   }
   
                   inner.removeClass( 'fancybox-tmp' );
               }
   
               width  = getScalar( origWidth );
               height = getScalar( origHeight );
   
               ratio  = origWidth / origHeight;
   
               // Calculations for the content
               minWidth  = getScalar(isPercentage(minWidth) ? getScalar(minWidth, 'w') - wSpace : minWidth);
               maxWidth  = getScalar(isPercentage(maxWidth) ? getScalar(maxWidth, 'w') - wSpace : maxWidth);
   
               minHeight = getScalar(isPercentage(minHeight) ? getScalar(minHeight, 'h') - hSpace : minHeight);
               maxHeight = getScalar(isPercentage(maxHeight) ? getScalar(maxHeight, 'h') - hSpace : maxHeight);
   
               // These will be used to determine if wrap can fit in the viewport
               origMaxWidth  = maxWidth;
               origMaxHeight = maxHeight;
   
               if (current.fitToView) {
                   maxWidth  = Math.min(viewport.w - wSpace, maxWidth);
                   maxHeight = Math.min(viewport.h - hSpace, maxHeight);
               }
   
               maxWidth_  = viewport.w - wMargin;
               maxHeight_ = viewport.h - hMargin;
   
               if (current.aspectRatio) {
                   if (width > maxWidth) {
                       width  = maxWidth;
                       height = getScalar(width / ratio);
                   }
   
                   if (height > maxHeight) {
                       height = maxHeight;
                       width  = getScalar(height * ratio);
                   }
   
                   if (width < minWidth) {
                       width  = minWidth;
                       height = getScalar(width / ratio);
                   }
   
                   if (height < minHeight) {
                       height = minHeight;
                       width  = getScalar(height * ratio);
                   }
   
               } else {
                   width = Math.max(minWidth, Math.min(width, maxWidth));
   
                   if (current.autoHeight && current.type !== 'iframe') {
                       inner.width( width );
   
                       height = inner.height();
                   }
   
                   height = Math.max(minHeight, Math.min(height, maxHeight));
               }
   
               // Try to fit inside viewport (including the title)
               if (current.fitToView) {
                   inner.width( width ).height( height );
   
                   wrap.width( width + wPadding );
   
                   // Real wrap dimensions
                   width_  = wrap.width();
                   height_ = wrap.height();
   
                   if (current.aspectRatio) {
                       while ((width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight) {
                           if (steps++ > 19) {
                               break;
                           }
   
                           height = Math.max(minHeight, Math.min(maxHeight, height - 10));
                           width  = getScalar(height * ratio);
   
                           if (width < minWidth) {
                               width  = minWidth;
                               height = getScalar(width / ratio);
                           }
   
                           if (width > maxWidth) {
                               width  = maxWidth;
                               height = getScalar(width / ratio);
                           }
   
                           inner.width( width ).height( height );
   
                           wrap.width( width + wPadding );
   
                           width_  = wrap.width();
                           height_ = wrap.height();
                       }
   
                   } else {
                       width  = Math.max(minWidth,  Math.min(width,  width  - (width_  - maxWidth_)));
                       height = Math.max(minHeight, Math.min(height, height - (height_ - maxHeight_)));
                   }
               }
   
               if (scrollOut && scrolling === 'auto' && height < origHeight && (width + wPadding + scrollOut) < maxWidth_) {
                   width += scrollOut;
               }
   
               inner.width( width ).height( height );
   
               wrap.width( width + wPadding );
   
               width_  = wrap.width();
               height_ = wrap.height();
   
               canShrink = (width_ > maxWidth_ || height_ > maxHeight_) && width > minWidth && height > minHeight;
               canExpand = current.aspectRatio ? (width < origMaxWidth && height < origMaxHeight && width < origWidth && height < origHeight) : ((width < origMaxWidth || height < origMaxHeight) && (width < origWidth || height < origHeight));
   
               $.extend(current, {
                   dim : {
                       width	: getValue( width_ ),
                       height	: getValue( height_ )
                   },
                   origWidth  : origWidth,
                   origHeight : origHeight,
                   canShrink  : canShrink,
                   canExpand  : canExpand,
                   wPadding   : wPadding,
                   hPadding   : hPadding,
                   wrapSpace  : height_ - skin.outerHeight(true),
                   skinSpace  : skin.height() - height
               });
   
               if (!iframe && current.autoHeight && height > minHeight && height < maxHeight && !canExpand) {
                   inner.height('auto');
               }
           },
   
           _getPosition: function (onlyAbsolute) {
               var current  = F.current,
                   viewport = F.getViewport(),
                   margin   = current.margin,
                   width    = F.wrap.width()  + margin[1] + margin[3],
                   height   = F.wrap.height() + margin[0] + margin[2],
                   rez      = {
                       position: 'absolute',
                       top  : margin[0],
                       left : margin[3]
                   };
   
               if (current.autoCenter && current.fixed && !onlyAbsolute && height <= viewport.h && width <= viewport.w) {
                   rez.position = 'fixed';
   
               } else if (!current.locked) {
                   rez.top  += viewport.y;
                   rez.left += viewport.x;
               }
   
               rez.top  = getValue(Math.max(rez.top,  rez.top  + ((viewport.h - height) * current.topRatio)));
               rez.left = getValue(Math.max(rez.left, rez.left + ((viewport.w - width)  * current.leftRatio)));
   
               return rez;
           },
   
           _afterZoomIn: function () {
               var current = F.current;
   
               if (!current) {
                   return;
               }
   
               F.isOpen = F.isOpened = true;
   
               F.wrap.css('overflow', 'visible').addClass('fancybox-opened').hide().show(0);
   
               F.update();
   
               // Assign a click event
               if ( current.closeClick || (current.nextClick && F.group.length > 1) ) {
                   F.inner.css('cursor', 'pointer').bind('click.fb', function(e) {
                       if (!$(e.target).is('a') && !$(e.target).parent().is('a')) {
                           e.preventDefault();
   
                           F[ current.closeClick ? 'close' : 'next' ]();
                       }
                   });
               }
   
               // Create a close button
               if (current.closeBtn) {
                   $(current.tpl.closeBtn).appendTo(F.skin).bind('click.fb', function(e) {
                       e.preventDefault();
   
                       F.close();
                   });
               }
   
               // Create navigation arrows
               if (current.arrows && F.group.length > 1) {
                   if (current.loop || current.index > 0) {
                       $(current.tpl.prev).appendTo(F.outer).bind('click.fb', F.prev);
                   }
   
                   if (current.loop || current.index < F.group.length - 1) {
                       $(current.tpl.next).appendTo(F.outer).bind('click.fb', F.next);
                   }
               }
   
               F.trigger('afterShow');
   
               // Stop the slideshow if this is the last item
               if (!current.loop && current.index === current.group.length - 1) {
   
                   F.play( false );
   
               } else if (F.opts.autoPlay && !F.player.isActive) {
                   F.opts.autoPlay = false;
   
                   F.play(true);
               }
           },
   
           _afterZoomOut: function ( obj ) {
               obj = obj || F.current;
   
               $('.fancybox-wrap').trigger('onReset').remove();
   
               $.extend(F, {
                   group  : {},
                   opts   : {},
                   router : false,
                   current   : null,
                   isActive  : false,
                   isOpened  : false,
                   isOpen    : false,
                   isClosing : false,
                   wrap   : null,
                   skin   : null,
                   outer  : null,
                   inner  : null
               });
   
               F.trigger('afterClose', obj);
           }
       });
   
       /*
        *	Default transitions
        */
   
       F.transitions = {
           getOrigPosition: function () {
               var current  = F.current,
                   element  = current.element,
                   orig     = current.orig,
                   pos      = {},
                   width    = 50,
                   height   = 50,
                   hPadding = current.hPadding,
                   wPadding = current.wPadding,
                   viewport = F.getViewport();
   
               if (!orig && current.isDom && element.is(':visible')) {
                   orig = element.find('img:first');
   
                   if (!orig.length) {
                       orig = element;
                   }
               }
   
               if (isQuery(orig)) {
                   pos = orig.offset();
   
                   if (orig.is('img')) {
                       width  = orig.outerWidth();
                       height = orig.outerHeight();
                   }
   
               } else {
                   pos.top  = viewport.y + (viewport.h - height) * current.topRatio;
                   pos.left = viewport.x + (viewport.w - width)  * current.leftRatio;
               }
   
               if (F.wrap.css('position') === 'fixed' || current.locked) {
                   pos.top  -= viewport.y;
                   pos.left -= viewport.x;
               }
   
               pos = {
                   top     : getValue(pos.top  - hPadding * current.topRatio),
                   left    : getValue(pos.left - wPadding * current.leftRatio),
                   width   : getValue(width  + wPadding),
                   height  : getValue(height + hPadding)
               };
   
               return pos;
           },
   
           step: function (now, fx) {
               var ratio,
                   padding,
                   value,
                   prop       = fx.prop,
                   current    = F.current,
                   wrapSpace  = current.wrapSpace,
                   skinSpace  = current.skinSpace;
   
               if (prop === 'width' || prop === 'height') {
                   ratio = fx.end === fx.start ? 1 : (now - fx.start) / (fx.end - fx.start);
   
                   if (F.isClosing) {
                       ratio = 1 - ratio;
                   }
   
                   padding = prop === 'width' ? current.wPadding : current.hPadding;
                   value   = now - padding;
   
                   F.skin[ prop ](  getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) ) );
                   F.inner[ prop ]( getScalar( prop === 'width' ?  value : value - (wrapSpace * ratio) - (skinSpace * ratio) ) );
               }
           },
   
           zoomIn: function () {
               var current  = F.current,
                   startPos = current.pos,
                   effect   = current.openEffect,
                   elastic  = effect === 'elastic',
                   endPos   = $.extend({opacity : 1}, startPos);
   
               // Remove "position" property that breaks older IE
               delete endPos.position;
   
               if (elastic) {
                   startPos = this.getOrigPosition();
   
                   if (current.openOpacity) {
                       startPos.opacity = 0.1;
                   }
   
               } else if (effect === 'fade') {
                   startPos.opacity = 0.1;
               }
   
               F.wrap.css(startPos).animate(endPos, {
                   duration : effect === 'none' ? 0 : current.openSpeed,
                   easing   : current.openEasing,
                   step     : elastic ? this.step : null,
                   complete : F._afterZoomIn
               });
           },
   
           zoomOut: function () {
               var current  = F.current,
                   effect   = current.closeEffect,
                   elastic  = effect === 'elastic',
                   endPos   = {opacity : 0.1};
   
               if (elastic) {
                   endPos = this.getOrigPosition();
   
                   if (current.closeOpacity) {
                       endPos.opacity = 0.1;
                   }
               }
   
               F.wrap.animate(endPos, {
                   duration : effect === 'none' ? 0 : current.closeSpeed,
                   easing   : current.closeEasing,
                   step     : elastic ? this.step : null,
                   complete : F._afterZoomOut
               });
           },
   
           changeIn: function () {
               var current   = F.current,
                   effect    = current.nextEffect,
                   startPos  = current.pos,
                   endPos    = { opacity : 1 },
                   direction = F.direction,
                   distance  = 200,
                   field;
   
               startPos.opacity = 0.1;
   
               if (effect === 'elastic') {
                   field = direction === 'down' || direction === 'up' ? 'top' : 'left';
   
                   if (direction === 'down' || direction === 'right') {
                       startPos[ field ] = getValue(getScalar(startPos[ field ]) - distance);
                       endPos[ field ]   = '+=' + distance + 'px';
   
                   } else {
                       startPos[ field ] = getValue(getScalar(startPos[ field ]) + distance);
                       endPos[ field ]   = '-=' + distance + 'px';
                   }
               }
   
               // Workaround for http://bugs.jquery.com/ticket/12273
               if (effect === 'none') {
                   F._afterZoomIn();
   
               } else {
                   F.wrap.css(startPos).animate(endPos, {
                       duration : current.nextSpeed,
                       easing   : current.nextEasing,
                       complete : F._afterZoomIn
                   });
               }
           },
   
           changeOut: function () {
               var previous  = F.previous,
                   effect    = previous.prevEffect,
                   endPos    = { opacity : 0.1 },
                   direction = F.direction,
                   distance  = 200;
   
               if (effect === 'elastic') {
                   endPos[ direction === 'down' || direction === 'up' ? 'top' : 'left' ] = ( direction === 'up' || direction === 'left' ? '-' : '+' ) + '=' + distance + 'px';
               }
   
               previous.wrap.animate(endPos, {
                   duration : effect === 'none' ? 0 : previous.prevSpeed,
                   easing   : previous.prevEasing,
                   complete : function () {
                       $(this).trigger('onReset').remove();
                   }
               });
           }
       };
   
       /*
        *	Overlay helper
        */
   
       F.helpers.overlay = {
           defaults : {
               closeClick : true,      // if true, fancyBox will be closed when user clicks on the overlay
               speedOut   : 200,       // duration of fadeOut animation
               showEarly  : true,      // indicates if should be opened immediately or wait until the content is ready
               css        : {},        // custom CSS properties
               locked     : !isTouch,  // if true, the content will be locked into overlay
               fixed      : true       // if false, the overlay CSS position property will not be set to "fixed"
           },
   
           overlay : null,      // current handle
           fixed   : false,     // indicates if the overlay has position "fixed"
           el      : $('html'), // element that contains "the lock"
   
           // Public methods
           create : function(opts) {
               var parent;
   
               opts = $.extend({}, this.defaults, opts);
   
               if (this.overlay) {
                   this.close();
               }
   
               parent = F.coming ? F.coming.parent : opts.parent;
   
               this.overlay = $('<div class="fancybox-overlay"></div>').appendTo( parent && parent.length ? parent : 'body' );
               this.fixed   = false;
   
               if (opts.fixed && F.defaults.fixed) {
                   this.overlay.addClass('fancybox-overlay-fixed');
   
                   this.fixed = true;
               }
           },
   
           open : function(opts) {
               var that = this;
   
               opts = $.extend({}, this.defaults, opts);
   
               if (this.overlay) {
                   this.overlay.unbind('.overlay').width('auto').height('auto');
   
               } else {
                   this.create(opts);
               }
   
               if (!this.fixed) {
                   W.bind('resize.overlay', $.proxy( this.update, this) );
   
                   this.update();
               }
   
               if (opts.closeClick) {
                   this.overlay.bind('click.overlay', function(e) {
                       if ($(e.target).hasClass('fancybox-overlay')) {
                           if (F.isActive) {
                               F.close();
                           } else {
                               that.close();
                           }
   
                           return false;
                       }
                   });
               }
   
               this.overlay.css( opts.css ).show();
           },
   
           close : function() {
               W.unbind('resize.overlay');
   
               if (this.el.hasClass('fancybox-lock')) {
                   $('.fancybox-margin').removeClass('fancybox-margin');
   
                   this.el.removeClass('fancybox-lock');
   
                   W.scrollTop( this.scrollV ).scrollLeft( this.scrollH );
               }
   
               $('.fancybox-overlay').remove().hide();
   
               $.extend(this, {
                   overlay : null,
                   fixed   : false
               });
           },
   
           // Private, callbacks
   
           update : function () {
               var width = '100%', offsetWidth;
   
               // Reset width/height so it will not mess
               this.overlay.width(width).height('100%');
   
               // jQuery does not return reliable result for IE
               if (IE) {
                   offsetWidth = Math.max(document.documentElement.offsetWidth, document.body.offsetWidth);
   
                   if (D.width() > offsetWidth) {
                       width = D.width();
                   }
   
               } else if (D.width() > W.width()) {
                   width = D.width();
               }
   
               this.overlay.width(width).height(D.height());
           },
   
           // This is where we can manipulate DOM, because later it would cause iframes to reload
           onReady : function (opts, obj) {
               var overlay = this.overlay;
   
               $('.fancybox-overlay').stop(true, true);
   
               if (!overlay) {
                   this.create(opts);
               }
   
               if (opts.locked && this.fixed && obj.fixed) {
                   obj.locked = this.overlay.append( obj.wrap );
                   obj.fixed  = false;
               }
   
               if (opts.showEarly === true) {
                   this.beforeShow.apply(this, arguments);
               }
           },
   
           beforeShow : function(opts, obj) {
               if (obj.locked && !this.el.hasClass('fancybox-lock')) {
                   if (this.fixPosition !== false) {
                       $('*').filter(function(){
                           return ($(this).css('position') === 'fixed' && !$(this).hasClass("fancybox-overlay") && !$(this).hasClass("fancybox-wrap") );
                       }).addClass('fancybox-margin');
                   }
   
                   this.el.addClass('fancybox-margin');
   
                   this.scrollV = W.scrollTop();
                   this.scrollH = W.scrollLeft();
   
                   this.el.addClass('fancybox-lock');
   
                   W.scrollTop( this.scrollV ).scrollLeft( this.scrollH );
               }
   
               this.open(opts);
           },
   
           onUpdate : function() {
               if (!this.fixed) {
                   this.update();
               }
           },
   
           afterClose: function (opts) {
               // Remove overlay if exists and fancyBox is not opening
               // (e.g., it is not being open using afterClose callback)
               if (this.overlay && !F.coming) {
                   this.overlay.fadeOut(opts.speedOut, $.proxy( this.close, this ));
               }
           }
       };
   
       /*
        *	Title helper
        */
   
       F.helpers.title = {
           defaults : {
               type     : 'float', // 'float', 'inside', 'outside' or 'over',
               position : 'bottom' // 'top' or 'bottom'
           },
   
           beforeShow: function (opts) {
               var current = F.current,
                   text    = current.title,
                   type    = opts.type,
                   title,
                   target;
   
               if ($.isFunction(text)) {
                   text = text.call(current.element, current);
               }
   
               if (!isString(text) || $.trim(text) === '') {
                   return;
               }
   
               title = $('<div class="fancybox-title fancybox-title-' + type + '-wrap">' + text + '</div>');
   
               switch (type) {
                   case 'inside':
                       target = F.skin;
                   break;
   
                   case 'outside':
                       target = F.wrap;
                   break;
   
                   case 'over':
                       target = F.inner;
                   break;
   
                   default: // 'float'
                       target = F.skin;
   
                       title.appendTo('body');
   
                       if (IE) {
                           title.width( title.width() );
                       }
   
                       title.wrapInner('<span class="child"></span>');
   
                       //Increase bottom margin so this title will also fit into viewport
                       F.current.margin[2] += Math.abs( getScalar(title.css('margin-bottom')) );
                   break;
               }
   
               title[ (opts.position === 'top' ? 'prependTo'  : 'appendTo') ](target);
           }
       };
   
       // jQuery plugin initialization
       $.fn.fancybox = function (options) {
           var index,
               that     = $(this),
               selector = this.selector || '',
               run      = function(e) {
                   var what = $(this).blur(), idx = index, relType, relVal;
   
                   if (!(e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) && !what.is('.fancybox-wrap')) {
                       relType = options.groupAttr || 'data-fancybox-group';
                       relVal  = what.attr(relType);
   
                       if (!relVal) {
                           relType = 'rel';
                           relVal  = what.get(0)[ relType ];
                       }
   
                       if (relVal && relVal !== '' && relVal !== 'nofollow') {
                           what = selector.length ? $(selector) : that;
                           what = what.filter('[' + relType + '="' + relVal + '"]');
                           idx  = what.index(this);
                       }
   
                       options.index = idx;
   
                       // Stop an event from bubbling if everything is fine
                       if (F.open(what, options) !== false) {
                           e.preventDefault();
                       }
                   }
               };
   
           options = options || {};
           index   = options.index || 0;
   
           if (!selector || options.live === false) {
               that.unbind('click.fb-start').bind('click.fb-start', run);
   
           } else {
               D.undelegate(selector, 'click.fb-start').delegate(selector + ":not('.fancybox-item, .fancybox-nav')", 'click.fb-start', run);
           }
   
           this.filter('[data-fancybox-start=1]').trigger('click');
   
           return this;
       };
   
       // Tests that need a body at doc ready
       D.ready(function() {
           var w1, w2;
   
           if ( $.scrollbarWidth === undefined ) {
               // http://benalman.com/projects/jquery-misc-plugins/#scrollbarwidth
               $.scrollbarWidth = function() {
                   var parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body'),
                       child  = parent.children(),
                       width  = child.innerWidth() - child.height( 99 ).innerWidth();
   
                   parent.remove();
   
                   return width;
               };
           }
   
           if ( $.support.fixedPosition === undefined ) {
               $.support.fixedPosition = (function() {
                   var elem  = $('<div style="position:fixed;top:20px;"></div>').appendTo('body'),
                       fixed = ( elem[0].offsetTop === 20 || elem[0].offsetTop === 15 );
   
                   elem.remove();
   
                   return fixed;
               }());
           }
   
           $.extend(F.defaults, {
               scrollbarWidth : $.scrollbarWidth(),
               fixed  : $.support.fixedPosition,
               parent : $('body')
           });
   
           //Get real width of page scroll-bar
           w1 = $(window).width();
   
           H.addClass('fancybox-lock-test');
   
           w2 = $(window).width();
   
           H.removeClass('fancybox-lock-test');
   
           $("<style type='text/css'>.fancybox-margin{margin-right:" + (w2 - w1) + "px;}</style>").appendTo("head");
       });
   
   }(window, document, jQuery));
   
   
   /***/ }),
   
   /***/ 876:
   /***/ ((module) => {
   
   "use strict";
   
   
   module.exports = function(el, onOver, onOut) {
     var x, y, pX, pY;
     var mouseOver = false;
     var focused = false;
     var h = {},
       state = 0,
       timer = 0;
   
     var options = {
       sensitivity: 7,
       interval: 100,
       timeout: 0,
       handleFocus: false
     };
   
     function delay(el, e) {
       if (timer) timer = clearTimeout(timer);
       state = 0;
       return focused ? undefined : onOut.call(el, e);
     }
   
     function tracker(e) {
       x = e.clientX;
       y = e.clientY;
     }
   
     function compare(el, e) {
       if (timer) timer = clearTimeout(timer);
       if ((Math.abs(pX - x) + Math.abs(pY - y)) < options.sensitivity) {
         state = 1;
         return focused ? undefined : onOver.call(el, e);
       } else {
         pX = x;
         pY = y;
         timer = setTimeout(function() {
           compare(el, e);
         }, options.interval);
       }
     }
   
     // Public methods
     h.options = function(opt) {
       var focusOptionChanged = opt.handleFocus !== options.handleFocus;
       options = Object.assign({}, options, opt);
       if (focusOptionChanged) {
         options.handleFocus ? addFocus() : removeFocus();
       }
       return h;
     };
   
     function dispatchOver(e) {
       mouseOver = true;
       if (timer) timer = clearTimeout(timer);
       el.removeEventListener('mousemove', tracker, false);
   
       if (state !== 1) {
         pX = e.clientX;
         pY = e.clientY;
   
         el.addEventListener('mousemove', tracker, false);
   
         timer = setTimeout(function() {
           compare(el, e);
         }, options.interval);
       }
   
       return this;
     }
   
     function dispatchOut(e) {
       mouseOver = false;
       if (timer) timer = clearTimeout(timer);
       el.removeEventListener('mousemove', tracker, false);
   
       if (state === 1) {
         timer = setTimeout(function() {
           delay(el, e);
         }, options.timeout);
       }
   
       return this;
     }
   
     function dispatchFocus(e) {
       if (!mouseOver) {
         focused = true;
         onOver.call(el, e);
       }
     }
   
     function dispatchBlur(e) {
       if (!mouseOver && focused) {
         focused = false;
         onOut.call(el, e);
       }
     }
   
     function addFocus() {
       el.addEventListener('focus', dispatchFocus, false);
       el.addEventListener('blur', dispatchBlur, false);
     }
   
     function removeFocus() {
       el.removeEventListener('focus', dispatchFocus, false);
       el.removeEventListener('blur', dispatchBlur, false);
     }
   
     h.remove = function() {
       if (!el) return;
       el.removeEventListener('mouseover', dispatchOver, false);
       el.removeEventListener('mouseout', dispatchOut, false);
       removeFocus();
     };
   
     if (el) {
       el.addEventListener('mouseover', dispatchOver, false);
       el.addEventListener('mouseout', dispatchOut, false);
     }
   
     return h;
   };
   
   
   /***/ }),
   
   /***/ 564:
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * imagesLoaded v4.1.4
    * JavaScript is all like "You images are done yet or what?"
    * MIT License
    */
   
   ( function( window, factory ) { 'use strict';
     // universal module definition
   
     /*global define: false, module: false, require: false */
   
     if ( true ) {
       // AMD
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
         __webpack_require__(158)
       ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
         return factory( window, EvEmitter );
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   
   })( typeof window !== 'undefined' ? window : this,
   
   // --------------------------  factory -------------------------- //
   
   function factory( window, EvEmitter ) {
   
   'use strict';
   
   var $ = window.jQuery;
   var console = window.console;
   
   // -------------------------- helpers -------------------------- //
   
   // extend objects
   function extend( a, b ) {
     for ( var prop in b ) {
       a[ prop ] = b[ prop ];
     }
     return a;
   }
   
   var arraySlice = Array.prototype.slice;
   
   // turn element or nodeList into an array
   function makeArray( obj ) {
     if ( Array.isArray( obj ) ) {
       // use object if already an array
       return obj;
     }
   
     var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
     if ( isArrayLike ) {
       // convert nodeList to array
       return arraySlice.call( obj );
     }
   
     // array of single index
     return [ obj ];
   }
   
   // -------------------------- imagesLoaded -------------------------- //
   
   /**
    * @param {Array, Element, NodeList, String} elem
    * @param {Object or Function} options - if function, use as callback
    * @param {Function} onAlways - callback function
    */
   function ImagesLoaded( elem, options, onAlways ) {
     // coerce ImagesLoaded() without new, to be new ImagesLoaded()
     if ( !( this instanceof ImagesLoaded ) ) {
       return new ImagesLoaded( elem, options, onAlways );
     }
     // use elem as selector string
     var queryElem = elem;
     if ( typeof elem == 'string' ) {
       queryElem = document.querySelectorAll( elem );
     }
     // bail if bad element
     if ( !queryElem ) {
       console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
       return;
     }
   
     this.elements = makeArray( queryElem );
     this.options = extend( {}, this.options );
     // shift arguments if no options set
     if ( typeof options == 'function' ) {
       onAlways = options;
     } else {
       extend( this.options, options );
     }
   
     if ( onAlways ) {
       this.on( 'always', onAlways );
     }
   
     this.getImages();
   
     if ( $ ) {
       // add jQuery Deferred object
       this.jqDeferred = new $.Deferred();
     }
   
     // HACK check async to allow time to bind listeners
     setTimeout( this.check.bind( this ) );
   }
   
   ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
   
   ImagesLoaded.prototype.options = {};
   
   ImagesLoaded.prototype.getImages = function() {
     this.images = [];
   
     // filter & find items if we have an item selector
     this.elements.forEach( this.addElementImages, this );
   };
   
   /**
    * @param {Node} element
    */
   ImagesLoaded.prototype.addElementImages = function( elem ) {
     // filter siblings
     if ( elem.nodeName == 'IMG' ) {
       this.addImage( elem );
     }
     // get background image on element
     if ( this.options.background === true ) {
       this.addElementBackgroundImages( elem );
     }
   
     // find children
     // no non-element nodes, #143
     var nodeType = elem.nodeType;
     if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
       return;
     }
     var childImgs = elem.querySelectorAll('img');
     // concat childElems to filterFound array
     for ( var i=0; i < childImgs.length; i++ ) {
       var img = childImgs[i];
       this.addImage( img );
     }
   
     // get child background images
     if ( typeof this.options.background == 'string' ) {
       var children = elem.querySelectorAll( this.options.background );
       for ( i=0; i < children.length; i++ ) {
         var child = children[i];
         this.addElementBackgroundImages( child );
       }
     }
   };
   
   var elementNodeTypes = {
     1: true,
     9: true,
     11: true
   };
   
   ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
     var style = getComputedStyle( elem );
     if ( !style ) {
       // Firefox returns null if in a hidden iframe https://bugzil.la/548397
       return;
     }
     // get url inside url("...")
     var reURL = /url\((['"])?(.*?)\1\)/gi;
     var matches = reURL.exec( style.backgroundImage );
     while ( matches !== null ) {
       var url = matches && matches[2];
       if ( url ) {
         this.addBackground( url, elem );
       }
       matches = reURL.exec( style.backgroundImage );
     }
   };
   
   /**
    * @param {Image} img
    */
   ImagesLoaded.prototype.addImage = function( img ) {
     var loadingImage = new LoadingImage( img );
     this.images.push( loadingImage );
   };
   
   ImagesLoaded.prototype.addBackground = function( url, elem ) {
     var background = new Background( url, elem );
     this.images.push( background );
   };
   
   ImagesLoaded.prototype.check = function() {
     var _this = this;
     this.progressedCount = 0;
     this.hasAnyBroken = false;
     // complete if no images
     if ( !this.images.length ) {
       this.complete();
       return;
     }
   
     function onProgress( image, elem, message ) {
       // HACK - Chrome triggers event before object properties have changed. #83
       setTimeout( function() {
         _this.progress( image, elem, message );
       });
     }
   
     this.images.forEach( function( loadingImage ) {
       loadingImage.once( 'progress', onProgress );
       loadingImage.check();
     });
   };
   
   ImagesLoaded.prototype.progress = function( image, elem, message ) {
     this.progressedCount++;
     this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
     // progress event
     this.emitEvent( 'progress', [ this, image, elem ] );
     if ( this.jqDeferred && this.jqDeferred.notify ) {
       this.jqDeferred.notify( this, image );
     }
     // check if completed
     if ( this.progressedCount == this.images.length ) {
       this.complete();
     }
   
     if ( this.options.debug && console ) {
       console.log( 'progress: ' + message, image, elem );
     }
   };
   
   ImagesLoaded.prototype.complete = function() {
     var eventName = this.hasAnyBroken ? 'fail' : 'done';
     this.isComplete = true;
     this.emitEvent( eventName, [ this ] );
     this.emitEvent( 'always', [ this ] );
     if ( this.jqDeferred ) {
       var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
       this.jqDeferred[ jqMethod ]( this );
     }
   };
   
   // --------------------------  -------------------------- //
   
   function LoadingImage( img ) {
     this.img = img;
   }
   
   LoadingImage.prototype = Object.create( EvEmitter.prototype );
   
   LoadingImage.prototype.check = function() {
     // If complete is true and browser supports natural sizes,
     // try to check for image status manually.
     var isComplete = this.getIsImageComplete();
     if ( isComplete ) {
       // report based on naturalWidth
       this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
       return;
     }
   
     // If none of the checks above matched, simulate loading on detached element.
     this.proxyImage = new Image();
     this.proxyImage.addEventListener( 'load', this );
     this.proxyImage.addEventListener( 'error', this );
     // bind to image as well for Firefox. #191
     this.img.addEventListener( 'load', this );
     this.img.addEventListener( 'error', this );
     this.proxyImage.src = this.img.src;
   };
   
   LoadingImage.prototype.getIsImageComplete = function() {
     // check for non-zero, non-undefined naturalWidth
     // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
     return this.img.complete && this.img.naturalWidth;
   };
   
   LoadingImage.prototype.confirm = function( isLoaded, message ) {
     this.isLoaded = isLoaded;
     this.emitEvent( 'progress', [ this, this.img, message ] );
   };
   
   // ----- events ----- //
   
   // trigger specified handler for event type
   LoadingImage.prototype.handleEvent = function( event ) {
     var method = 'on' + event.type;
     if ( this[ method ] ) {
       this[ method ]( event );
     }
   };
   
   LoadingImage.prototype.onload = function() {
     this.confirm( true, 'onload' );
     this.unbindEvents();
   };
   
   LoadingImage.prototype.onerror = function() {
     this.confirm( false, 'onerror' );
     this.unbindEvents();
   };
   
   LoadingImage.prototype.unbindEvents = function() {
     this.proxyImage.removeEventListener( 'load', this );
     this.proxyImage.removeEventListener( 'error', this );
     this.img.removeEventListener( 'load', this );
     this.img.removeEventListener( 'error', this );
   };
   
   // -------------------------- Background -------------------------- //
   
   function Background( url, element ) {
     this.url = url;
     this.element = element;
     this.img = new Image();
   }
   
   // inherit LoadingImage prototype
   Background.prototype = Object.create( LoadingImage.prototype );
   
   Background.prototype.check = function() {
     this.img.addEventListener( 'load', this );
     this.img.addEventListener( 'error', this );
     this.img.src = this.url;
     // check if image is already complete
     var isComplete = this.getIsImageComplete();
     if ( isComplete ) {
       this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
       this.unbindEvents();
     }
   };
   
   Background.prototype.unbindEvents = function() {
     this.img.removeEventListener( 'load', this );
     this.img.removeEventListener( 'error', this );
   };
   
   Background.prototype.confirm = function( isLoaded, message ) {
     this.isLoaded = isLoaded;
     this.emitEvent( 'progress', [ this, this.element, message ] );
   };
   
   // -------------------------- jQuery -------------------------- //
   
   ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
     jQuery = jQuery || window.jQuery;
     if ( !jQuery ) {
       return;
     }
     // set local variable
     $ = jQuery;
     // $().imagesLoaded()
     $.fn.imagesLoaded = function( options, callback ) {
       var instance = new ImagesLoaded( this, options, callback );
       return instance.jqDeferred.promise( $(this) );
     };
   };
   // try making plugin
   ImagesLoaded.makeJQueryPlugin();
   
   // --------------------------  -------------------------- //
   
   return ImagesLoaded;
   
   });
   
   
   /***/ }),
   
   /***/ 755:
   /***/ (function(module, exports) {
   
   var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
    * jQuery JavaScript Library v3.6.1
    * https://jquery.com/
    *
    * Includes Sizzle.js
    * https://sizzlejs.com/
    *
    * Copyright OpenJS Foundation and other contributors
    * Released under the MIT license
    * https://jquery.org/license
    *
    * Date: 2022-08-26T17:52Z
    */
   ( function( global, factory ) {
   
       "use strict";
   
       if (  true && typeof module.exports === "object" ) {
   
           // For CommonJS and CommonJS-like environments where a proper `window`
           // is present, execute the factory and get jQuery.
           // For environments that do not have a `window` with a `document`
           // (such as Node.js), expose a factory as module.exports.
           // This accentuates the need for the creation of a real `window`.
           // e.g. var jQuery = require("jquery")(window);
           // See ticket trac-14549 for more info.
           module.exports = global.document ?
               factory( global, true ) :
               function( w ) {
                   if ( !w.document ) {
                       throw new Error( "jQuery requires a window with a document" );
                   }
                   return factory( w );
               };
       } else {
           factory( global );
       }
   
   // Pass this if window is not defined yet
   } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
   
   // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
   // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
   // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
   // enough that all such attempts are guarded in a try block.
   "use strict";
   
   var arr = [];
   
   var getProto = Object.getPrototypeOf;
   
   var slice = arr.slice;
   
   var flat = arr.flat ? function( array ) {
       return arr.flat.call( array );
   } : function( array ) {
       return arr.concat.apply( [], array );
   };
   
   
   var push = arr.push;
   
   var indexOf = arr.indexOf;
   
   var class2type = {};
   
   var toString = class2type.toString;
   
   var hasOwn = class2type.hasOwnProperty;
   
   var fnToString = hasOwn.toString;
   
   var ObjectFunctionString = fnToString.call( Object );
   
   var support = {};
   
   var isFunction = function isFunction( obj ) {
   
           // Support: Chrome <=57, Firefox <=52
           // In some browsers, typeof returns "function" for HTML <object> elements
           // (i.e., `typeof document.createElement( "object" ) === "function"`).
           // We don't want to classify *any* DOM node as a function.
           // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
           // Plus for old WebKit, typeof returns "function" for HTML collections
           // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
           return typeof obj === "function" && typeof obj.nodeType !== "number" &&
               typeof obj.item !== "function";
       };
   
   
   var isWindow = function isWindow( obj ) {
           return obj != null && obj === obj.window;
       };
   
   
   var document = window.document;
   
   
   
       var preservedScriptAttributes = {
           type: true,
           src: true,
           nonce: true,
           noModule: true
       };
   
       function DOMEval( code, node, doc ) {
           doc = doc || document;
   
           var i, val,
               script = doc.createElement( "script" );
   
           script.text = code;
           if ( node ) {
               for ( i in preservedScriptAttributes ) {
   
                   // Support: Firefox 64+, Edge 18+
                   // Some browsers don't support the "nonce" property on scripts.
                   // On the other hand, just using `getAttribute` is not enough as
                   // the `nonce` attribute is reset to an empty string whenever it
                   // becomes browsing-context connected.
                   // See https://github.com/whatwg/html/issues/2369
                   // See https://html.spec.whatwg.org/#nonce-attributes
                   // The `node.getAttribute` check was added for the sake of
                   // `jQuery.globalEval` so that it can fake a nonce-containing node
                   // via an object.
                   val = node[ i ] || node.getAttribute && node.getAttribute( i );
                   if ( val ) {
                       script.setAttribute( i, val );
                   }
               }
           }
           doc.head.appendChild( script ).parentNode.removeChild( script );
       }
   
   
   function toType( obj ) {
       if ( obj == null ) {
           return obj + "";
       }
   
       // Support: Android <=2.3 only (functionish RegExp)
       return typeof obj === "object" || typeof obj === "function" ?
           class2type[ toString.call( obj ) ] || "object" :
           typeof obj;
   }
   /* global Symbol */
   // Defining this global in .eslintrc.json would create a danger of using the global
   // unguarded in another place, it seems safer to define global only for this module
   
   
   
   var
       version = "3.6.1",
   
       // Define a local copy of jQuery
       jQuery = function( selector, context ) {
   
           // The jQuery object is actually just the init constructor 'enhanced'
           // Need init if jQuery is called (just allow error to be thrown if not included)
           return new jQuery.fn.init( selector, context );
       };
   
   jQuery.fn = jQuery.prototype = {
   
       // The current version of jQuery being used
       jquery: version,
   
       constructor: jQuery,
   
       // The default length of a jQuery object is 0
       length: 0,
   
       toArray: function() {
           return slice.call( this );
       },
   
       // Get the Nth element in the matched element set OR
       // Get the whole matched element set as a clean array
       get: function( num ) {
   
           // Return all the elements in a clean array
           if ( num == null ) {
               return slice.call( this );
           }
   
           // Return just the one element from the set
           return num < 0 ? this[ num + this.length ] : this[ num ];
       },
   
       // Take an array of elements and push it onto the stack
       // (returning the new matched element set)
       pushStack: function( elems ) {
   
           // Build a new jQuery matched element set
           var ret = jQuery.merge( this.constructor(), elems );
   
           // Add the old object onto the stack (as a reference)
           ret.prevObject = this;
   
           // Return the newly-formed element set
           return ret;
       },
   
       // Execute a callback for every element in the matched set.
       each: function( callback ) {
           return jQuery.each( this, callback );
       },
   
       map: function( callback ) {
           return this.pushStack( jQuery.map( this, function( elem, i ) {
               return callback.call( elem, i, elem );
           } ) );
       },
   
       slice: function() {
           return this.pushStack( slice.apply( this, arguments ) );
       },
   
       first: function() {
           return this.eq( 0 );
       },
   
       last: function() {
           return this.eq( -1 );
       },
   
       even: function() {
           return this.pushStack( jQuery.grep( this, function( _elem, i ) {
               return ( i + 1 ) % 2;
           } ) );
       },
   
       odd: function() {
           return this.pushStack( jQuery.grep( this, function( _elem, i ) {
               return i % 2;
           } ) );
       },
   
       eq: function( i ) {
           var len = this.length,
               j = +i + ( i < 0 ? len : 0 );
           return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
       },
   
       end: function() {
           return this.prevObject || this.constructor();
       },
   
       // For internal use only.
       // Behaves like an Array's method, not like a jQuery method.
       push: push,
       sort: arr.sort,
       splice: arr.splice
   };
   
   jQuery.extend = jQuery.fn.extend = function() {
       var options, name, src, copy, copyIsArray, clone,
           target = arguments[ 0 ] || {},
           i = 1,
           length = arguments.length,
           deep = false;
   
       // Handle a deep copy situation
       if ( typeof target === "boolean" ) {
           deep = target;
   
           // Skip the boolean and the target
           target = arguments[ i ] || {};
           i++;
       }
   
       // Handle case when target is a string or something (possible in deep copy)
       if ( typeof target !== "object" && !isFunction( target ) ) {
           target = {};
       }
   
       // Extend jQuery itself if only one argument is passed
       if ( i === length ) {
           target = this;
           i--;
       }
   
       for ( ; i < length; i++ ) {
   
           // Only deal with non-null/undefined values
           if ( ( options = arguments[ i ] ) != null ) {
   
               // Extend the base object
               for ( name in options ) {
                   copy = options[ name ];
   
                   // Prevent Object.prototype pollution
                   // Prevent never-ending loop
                   if ( name === "__proto__" || target === copy ) {
                       continue;
                   }
   
                   // Recurse if we're merging plain objects or arrays
                   if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                       ( copyIsArray = Array.isArray( copy ) ) ) ) {
                       src = target[ name ];
   
                       // Ensure proper type for the source value
                       if ( copyIsArray && !Array.isArray( src ) ) {
                           clone = [];
                       } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
                           clone = {};
                       } else {
                           clone = src;
                       }
                       copyIsArray = false;
   
                       // Never move original objects, clone them
                       target[ name ] = jQuery.extend( deep, clone, copy );
   
                   // Don't bring in undefined values
                   } else if ( copy !== undefined ) {
                       target[ name ] = copy;
                   }
               }
           }
       }
   
       // Return the modified object
       return target;
   };
   
   jQuery.extend( {
   
       // Unique for each copy of jQuery on the page
       expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
   
       // Assume jQuery is ready without the ready module
       isReady: true,
   
       error: function( msg ) {
           throw new Error( msg );
       },
   
       noop: function() {},
   
       isPlainObject: function( obj ) {
           var proto, Ctor;
   
           // Detect obvious negatives
           // Use toString instead of jQuery.type to catch host objects
           if ( !obj || toString.call( obj ) !== "[object Object]" ) {
               return false;
           }
   
           proto = getProto( obj );
   
           // Objects with no prototype (e.g., `Object.create( null )`) are plain
           if ( !proto ) {
               return true;
           }
   
           // Objects with prototype are plain iff they were constructed by a global Object function
           Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
           return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
       },
   
       isEmptyObject: function( obj ) {
           var name;
   
           for ( name in obj ) {
               return false;
           }
           return true;
       },
   
       // Evaluates a script in a provided context; falls back to the global one
       // if not specified.
       globalEval: function( code, options, doc ) {
           DOMEval( code, { nonce: options && options.nonce }, doc );
       },
   
       each: function( obj, callback ) {
           var length, i = 0;
   
           if ( isArrayLike( obj ) ) {
               length = obj.length;
               for ( ; i < length; i++ ) {
                   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                       break;
                   }
               }
           } else {
               for ( i in obj ) {
                   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                       break;
                   }
               }
           }
   
           return obj;
       },
   
       // results is for internal usage only
       makeArray: function( arr, results ) {
           var ret = results || [];
   
           if ( arr != null ) {
               if ( isArrayLike( Object( arr ) ) ) {
                   jQuery.merge( ret,
                       typeof arr === "string" ?
                           [ arr ] : arr
                   );
               } else {
                   push.call( ret, arr );
               }
           }
   
           return ret;
       },
   
       inArray: function( elem, arr, i ) {
           return arr == null ? -1 : indexOf.call( arr, elem, i );
       },
   
       // Support: Android <=4.0 only, PhantomJS 1 only
       // push.apply(_, arraylike) throws on ancient WebKit
       merge: function( first, second ) {
           var len = +second.length,
               j = 0,
               i = first.length;
   
           for ( ; j < len; j++ ) {
               first[ i++ ] = second[ j ];
           }
   
           first.length = i;
   
           return first;
       },
   
       grep: function( elems, callback, invert ) {
           var callbackInverse,
               matches = [],
               i = 0,
               length = elems.length,
               callbackExpect = !invert;
   
           // Go through the array, only saving the items
           // that pass the validator function
           for ( ; i < length; i++ ) {
               callbackInverse = !callback( elems[ i ], i );
               if ( callbackInverse !== callbackExpect ) {
                   matches.push( elems[ i ] );
               }
           }
   
           return matches;
       },
   
       // arg is for internal usage only
       map: function( elems, callback, arg ) {
           var length, value,
               i = 0,
               ret = [];
   
           // Go through the array, translating each of the items to their new values
           if ( isArrayLike( elems ) ) {
               length = elems.length;
               for ( ; i < length; i++ ) {
                   value = callback( elems[ i ], i, arg );
   
                   if ( value != null ) {
                       ret.push( value );
                   }
               }
   
           // Go through every key on the object,
           } else {
               for ( i in elems ) {
                   value = callback( elems[ i ], i, arg );
   
                   if ( value != null ) {
                       ret.push( value );
                   }
               }
           }
   
           // Flatten any nested arrays
           return flat( ret );
       },
   
       // A global GUID counter for objects
       guid: 1,
   
       // jQuery.support is not used in Core but other projects attach their
       // properties to it so it needs to exist.
       support: support
   } );
   
   if ( typeof Symbol === "function" ) {
       jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
   }
   
   // Populate the class2type map
   jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
       function( _i, name ) {
           class2type[ "[object " + name + "]" ] = name.toLowerCase();
       } );
   
   function isArrayLike( obj ) {
   
       // Support: real iOS 8.2 only (not reproducible in simulator)
       // `in` check used to prevent JIT error (gh-2145)
       // hasOwn isn't used here due to false negatives
       // regarding Nodelist length in IE
       var length = !!obj && "length" in obj && obj.length,
           type = toType( obj );
   
       if ( isFunction( obj ) || isWindow( obj ) ) {
           return false;
       }
   
       return type === "array" || length === 0 ||
           typeof length === "number" && length > 0 && ( length - 1 ) in obj;
   }
   var Sizzle =
   /*!
    * Sizzle CSS Selector Engine v2.3.6
    * https://sizzlejs.com/
    *
    * Copyright JS Foundation and other contributors
    * Released under the MIT license
    * https://js.foundation/
    *
    * Date: 2021-02-16
    */
   ( function( window ) {
   var i,
       support,
       Expr,
       getText,
       isXML,
       tokenize,
       compile,
       select,
       outermostContext,
       sortInput,
       hasDuplicate,
   
       // Local document vars
       setDocument,
       document,
       docElem,
       documentIsHTML,
       rbuggyQSA,
       rbuggyMatches,
       matches,
       contains,
   
       // Instance-specific data
       expando = "sizzle" + 1 * new Date(),
       preferredDoc = window.document,
       dirruns = 0,
       done = 0,
       classCache = createCache(),
       tokenCache = createCache(),
       compilerCache = createCache(),
       nonnativeSelectorCache = createCache(),
       sortOrder = function( a, b ) {
           if ( a === b ) {
               hasDuplicate = true;
           }
           return 0;
       },
   
       // Instance methods
       hasOwn = ( {} ).hasOwnProperty,
       arr = [],
       pop = arr.pop,
       pushNative = arr.push,
       push = arr.push,
       slice = arr.slice,
   
       // Use a stripped-down indexOf as it's faster than native
       // https://jsperf.com/thor-indexof-vs-for/5
       indexOf = function( list, elem ) {
           var i = 0,
               len = list.length;
           for ( ; i < len; i++ ) {
               if ( list[ i ] === elem ) {
                   return i;
               }
           }
           return -1;
       },
   
       booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
           "ismap|loop|multiple|open|readonly|required|scoped",
   
       // Regular expressions
   
       // http://www.w3.org/TR/css3-selectors/#whitespace
       whitespace = "[\\x20\\t\\r\\n\\f]",
   
       // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
       identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
           "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
   
       // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
       attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
   
           // Operator (capture 2)
           "*([*^$|!~]?=)" + whitespace +
   
           // "Attribute values must be CSS identifiers [capture 5]
           // or strings [capture 3 or capture 4]"
           "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
           whitespace + "*\\]",
   
       pseudos = ":(" + identifier + ")(?:\\((" +
   
           // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
           // 1. quoted (capture 3; capture 4 or capture 5)
           "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
   
           // 2. simple (capture 6)
           "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
   
           // 3. anything else (capture 2)
           ".*" +
           ")\\)|)",
   
       // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
       rwhitespace = new RegExp( whitespace + "+", "g" ),
       rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
           whitespace + "+$", "g" ),
   
       rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
       rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
           "*" ),
       rdescend = new RegExp( whitespace + "|>" ),
   
       rpseudo = new RegExp( pseudos ),
       ridentifier = new RegExp( "^" + identifier + "$" ),
   
       matchExpr = {
           "ID": new RegExp( "^#(" + identifier + ")" ),
           "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
           "TAG": new RegExp( "^(" + identifier + "|[*])" ),
           "ATTR": new RegExp( "^" + attributes ),
           "PSEUDO": new RegExp( "^" + pseudos ),
           "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
               whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
               whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
           "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
   
           // For use in libraries implementing .is()
           // We use this for POS matching in `select`
           "needsContext": new RegExp( "^" + whitespace +
               "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
               "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
       },
   
       rhtml = /HTML$/i,
       rinputs = /^(?:input|select|textarea|button)$/i,
       rheader = /^h\d$/i,
   
       rnative = /^[^{]+\{\s*\[native \w/,
   
       // Easily-parseable/retrievable ID or TAG or CLASS selectors
       rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
   
       rsibling = /[+~]/,
   
       // CSS escapes
       // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
       runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
       funescape = function( escape, nonHex ) {
           var high = "0x" + escape.slice( 1 ) - 0x10000;
   
           return nonHex ?
   
               // Strip the backslash prefix from a non-hex escape sequence
               nonHex :
   
               // Replace a hexadecimal escape sequence with the encoded Unicode code point
               // Support: IE <=11+
               // For values outside the Basic Multilingual Plane (BMP), manually construct a
               // surrogate pair
               high < 0 ?
                   String.fromCharCode( high + 0x10000 ) :
                   String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
       },
   
       // CSS string/identifier serialization
       // https://drafts.csswg.org/cssom/#common-serializing-idioms
       rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
       fcssescape = function( ch, asCodePoint ) {
           if ( asCodePoint ) {
   
               // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
               if ( ch === "\0" ) {
                   return "\uFFFD";
               }
   
               // Control characters and (dependent upon position) numbers get escaped as code points
               return ch.slice( 0, -1 ) + "\\" +
                   ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
           }
   
           // Other potentially-special ASCII characters get backslash-escaped
           return "\\" + ch;
       },
   
       // Used for iframes
       // See setDocument()
       // Removing the function wrapper causes a "Permission Denied"
       // error in IE
       unloadHandler = function() {
           setDocument();
       },
   
       inDisabledFieldset = addCombinator(
           function( elem ) {
               return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
           },
           { dir: "parentNode", next: "legend" }
       );
   
   // Optimize for push.apply( _, NodeList )
   try {
       push.apply(
           ( arr = slice.call( preferredDoc.childNodes ) ),
           preferredDoc.childNodes
       );
   
       // Support: Android<4.0
       // Detect silently failing push.apply
       // eslint-disable-next-line no-unused-expressions
       arr[ preferredDoc.childNodes.length ].nodeType;
   } catch ( e ) {
       push = { apply: arr.length ?
   
           // Leverage slice if possible
           function( target, els ) {
               pushNative.apply( target, slice.call( els ) );
           } :
   
           // Support: IE<9
           // Otherwise append directly
           function( target, els ) {
               var j = target.length,
                   i = 0;
   
               // Can't trust NodeList.length
               while ( ( target[ j++ ] = els[ i++ ] ) ) {}
               target.length = j - 1;
           }
       };
   }
   
   function Sizzle( selector, context, results, seed ) {
       var m, i, elem, nid, match, groups, newSelector,
           newContext = context && context.ownerDocument,
   
           // nodeType defaults to 9, since context defaults to document
           nodeType = context ? context.nodeType : 9;
   
       results = results || [];
   
       // Return early from calls with invalid selector or context
       if ( typeof selector !== "string" || !selector ||
           nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
   
           return results;
       }
   
       // Try to shortcut find operations (as opposed to filters) in HTML documents
       if ( !seed ) {
           setDocument( context );
           context = context || document;
   
           if ( documentIsHTML ) {
   
               // If the selector is sufficiently simple, try using a "get*By*" DOM method
               // (excepting DocumentFragment context, where the methods don't exist)
               if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
   
                   // ID selector
                   if ( ( m = match[ 1 ] ) ) {
   
                       // Document context
                       if ( nodeType === 9 ) {
                           if ( ( elem = context.getElementById( m ) ) ) {
   
                               // Support: IE, Opera, Webkit
                               // TODO: identify versions
                               // getElementById can match elements by name instead of ID
                               if ( elem.id === m ) {
                                   results.push( elem );
                                   return results;
                               }
                           } else {
                               return results;
                           }
   
                       // Element context
                       } else {
   
                           // Support: IE, Opera, Webkit
                           // TODO: identify versions
                           // getElementById can match elements by name instead of ID
                           if ( newContext && ( elem = newContext.getElementById( m ) ) &&
                               contains( context, elem ) &&
                               elem.id === m ) {
   
                               results.push( elem );
                               return results;
                           }
                       }
   
                   // Type selector
                   } else if ( match[ 2 ] ) {
                       push.apply( results, context.getElementsByTagName( selector ) );
                       return results;
   
                   // Class selector
                   } else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
                       context.getElementsByClassName ) {
   
                       push.apply( results, context.getElementsByClassName( m ) );
                       return results;
                   }
               }
   
               // Take advantage of querySelectorAll
               if ( support.qsa &&
                   !nonnativeSelectorCache[ selector + " " ] &&
                   ( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
   
                   // Support: IE 8 only
                   // Exclude object elements
                   ( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
   
                   newSelector = selector;
                   newContext = context;
   
                   // qSA considers elements outside a scoping root when evaluating child or
                   // descendant combinators, which is not what we want.
                   // In such cases, we work around the behavior by prefixing every selector in the
                   // list with an ID selector referencing the scope context.
                   // The technique has to be used as well when a leading combinator is used
                   // as such selectors are not recognized by querySelectorAll.
                   // Thanks to Andrew Dupont for this technique.
                   if ( nodeType === 1 &&
                       ( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
   
                       // Expand context for sibling selectors
                       newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                           context;
   
                       // We can use :scope instead of the ID hack if the browser
                       // supports it & if we're not changing the context.
                       if ( newContext !== context || !support.scope ) {
   
                           // Capture the context ID, setting it first if necessary
                           if ( ( nid = context.getAttribute( "id" ) ) ) {
                               nid = nid.replace( rcssescape, fcssescape );
                           } else {
                               context.setAttribute( "id", ( nid = expando ) );
                           }
                       }
   
                       // Prefix every selector in the list
                       groups = tokenize( selector );
                       i = groups.length;
                       while ( i-- ) {
                           groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
                               toSelector( groups[ i ] );
                       }
                       newSelector = groups.join( "," );
                   }
   
                   try {
                       push.apply( results,
                           newContext.querySelectorAll( newSelector )
                       );
                       return results;
                   } catch ( qsaError ) {
                       nonnativeSelectorCache( selector, true );
                   } finally {
                       if ( nid === expando ) {
                           context.removeAttribute( "id" );
                       }
                   }
               }
           }
       }
   
       // All others
       return select( selector.replace( rtrim, "$1" ), context, results, seed );
   }
   
   /**
    * Create key-value caches of limited size
    * @returns {function(string, object)} Returns the Object data after storing it on itself with
    *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
    *	deleting the oldest entry
    */
   function createCache() {
       var keys = [];
   
       function cache( key, value ) {
   
           // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
           if ( keys.push( key + " " ) > Expr.cacheLength ) {
   
               // Only keep the most recent entries
               delete cache[ keys.shift() ];
           }
           return ( cache[ key + " " ] = value );
       }
       return cache;
   }
   
   /**
    * Mark a function for special use by Sizzle
    * @param {Function} fn The function to mark
    */
   function markFunction( fn ) {
       fn[ expando ] = true;
       return fn;
   }
   
   /**
    * Support testing using an element
    * @param {Function} fn Passed the created element and returns a boolean result
    */
   function assert( fn ) {
       var el = document.createElement( "fieldset" );
   
       try {
           return !!fn( el );
       } catch ( e ) {
           return false;
       } finally {
   
           // Remove from its parent by default
           if ( el.parentNode ) {
               el.parentNode.removeChild( el );
           }
   
           // release memory in IE
           el = null;
       }
   }
   
   /**
    * Adds the same handler for all of the specified attrs
    * @param {String} attrs Pipe-separated list of attributes
    * @param {Function} handler The method that will be applied
    */
   function addHandle( attrs, handler ) {
       var arr = attrs.split( "|" ),
           i = arr.length;
   
       while ( i-- ) {
           Expr.attrHandle[ arr[ i ] ] = handler;
       }
   }
   
   /**
    * Checks document order of two siblings
    * @param {Element} a
    * @param {Element} b
    * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
    */
   function siblingCheck( a, b ) {
       var cur = b && a,
           diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
               a.sourceIndex - b.sourceIndex;
   
       // Use IE sourceIndex if available on both nodes
       if ( diff ) {
           return diff;
       }
   
       // Check if b follows a
       if ( cur ) {
           while ( ( cur = cur.nextSibling ) ) {
               if ( cur === b ) {
                   return -1;
               }
           }
       }
   
       return a ? 1 : -1;
   }
   
   /**
    * Returns a function to use in pseudos for input types
    * @param {String} type
    */
   function createInputPseudo( type ) {
       return function( elem ) {
           var name = elem.nodeName.toLowerCase();
           return name === "input" && elem.type === type;
       };
   }
   
   /**
    * Returns a function to use in pseudos for buttons
    * @param {String} type
    */
   function createButtonPseudo( type ) {
       return function( elem ) {
           var name = elem.nodeName.toLowerCase();
           return ( name === "input" || name === "button" ) && elem.type === type;
       };
   }
   
   /**
    * Returns a function to use in pseudos for :enabled/:disabled
    * @param {Boolean} disabled true for :disabled; false for :enabled
    */
   function createDisabledPseudo( disabled ) {
   
       // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
       return function( elem ) {
   
           // Only certain elements can match :enabled or :disabled
           // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
           // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
           if ( "form" in elem ) {
   
               // Check for inherited disabledness on relevant non-disabled elements:
               // * listed form-associated elements in a disabled fieldset
               //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
               //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
               // * option elements in a disabled optgroup
               //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
               // All such elements have a "form" property.
               if ( elem.parentNode && elem.disabled === false ) {
   
                   // Option elements defer to a parent optgroup if present
                   if ( "label" in elem ) {
                       if ( "label" in elem.parentNode ) {
                           return elem.parentNode.disabled === disabled;
                       } else {
                           return elem.disabled === disabled;
                       }
                   }
   
                   // Support: IE 6 - 11
                   // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                   return elem.isDisabled === disabled ||
   
                       // Where there is no isDisabled, check manually
                       /* jshint -W018 */
                       elem.isDisabled !== !disabled &&
                       inDisabledFieldset( elem ) === disabled;
               }
   
               return elem.disabled === disabled;
   
           // Try to winnow out elements that can't be disabled before trusting the disabled property.
           // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
           // even exist on them, let alone have a boolean value.
           } else if ( "label" in elem ) {
               return elem.disabled === disabled;
           }
   
           // Remaining elements are neither :enabled nor :disabled
           return false;
       };
   }
   
   /**
    * Returns a function to use in pseudos for positionals
    * @param {Function} fn
    */
   function createPositionalPseudo( fn ) {
       return markFunction( function( argument ) {
           argument = +argument;
           return markFunction( function( seed, matches ) {
               var j,
                   matchIndexes = fn( [], seed.length, argument ),
                   i = matchIndexes.length;
   
               // Match elements found at the specified indexes
               while ( i-- ) {
                   if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
                       seed[ j ] = !( matches[ j ] = seed[ j ] );
                   }
               }
           } );
       } );
   }
   
   /**
    * Checks a node for validity as a Sizzle context
    * @param {Element|Object=} context
    * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
    */
   function testContext( context ) {
       return context && typeof context.getElementsByTagName !== "undefined" && context;
   }
   
   // Expose support vars for convenience
   support = Sizzle.support = {};
   
   /**
    * Detects XML nodes
    * @param {Element|Object} elem An element or a document
    * @returns {Boolean} True iff elem is a non-HTML XML node
    */
   isXML = Sizzle.isXML = function( elem ) {
       var namespace = elem && elem.namespaceURI,
           docElem = elem && ( elem.ownerDocument || elem ).documentElement;
   
       // Support: IE <=8
       // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
       // https://bugs.jquery.com/ticket/4833
       return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
   };
   
   /**
    * Sets document-related variables once based on the current document
    * @param {Element|Object} [doc] An element or document object to use to set the document
    * @returns {Object} Returns the current document
    */
   setDocument = Sizzle.setDocument = function( node ) {
       var hasCompare, subWindow,
           doc = node ? node.ownerDocument || node : preferredDoc;
   
       // Return early if doc is invalid or already selected
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
           return document;
       }
   
       // Update global variables
       document = doc;
       docElem = document.documentElement;
       documentIsHTML = !isXML( document );
   
       // Support: IE 9 - 11+, Edge 12 - 18+
       // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( preferredDoc != document &&
           ( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
   
           // Support: IE 11, Edge
           if ( subWindow.addEventListener ) {
               subWindow.addEventListener( "unload", unloadHandler, false );
   
           // Support: IE 9 - 10 only
           } else if ( subWindow.attachEvent ) {
               subWindow.attachEvent( "onunload", unloadHandler );
           }
       }
   
       // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
       // Safari 4 - 5 only, Opera <=11.6 - 12.x only
       // IE/Edge & older browsers don't support the :scope pseudo-class.
       // Support: Safari 6.0 only
       // Safari 6.0 supports :scope but it's an alias of :root there.
       support.scope = assert( function( el ) {
           docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
           return typeof el.querySelectorAll !== "undefined" &&
               !el.querySelectorAll( ":scope fieldset div" ).length;
       } );
   
       /* Attributes
       ---------------------------------------------------------------------- */
   
       // Support: IE<8
       // Verify that getAttribute really returns attributes and not properties
       // (excepting IE8 booleans)
       support.attributes = assert( function( el ) {
           el.className = "i";
           return !el.getAttribute( "className" );
       } );
   
       /* getElement(s)By*
       ---------------------------------------------------------------------- */
   
       // Check if getElementsByTagName("*") returns only elements
       support.getElementsByTagName = assert( function( el ) {
           el.appendChild( document.createComment( "" ) );
           return !el.getElementsByTagName( "*" ).length;
       } );
   
       // Support: IE<9
       support.getElementsByClassName = rnative.test( document.getElementsByClassName );
   
       // Support: IE<10
       // Check if getElementById returns elements by name
       // The broken getElementById methods don't pick up programmatically-set names,
       // so use a roundabout getElementsByName test
       support.getById = assert( function( el ) {
           docElem.appendChild( el ).id = expando;
           return !document.getElementsByName || !document.getElementsByName( expando ).length;
       } );
   
       // ID filter and find
       if ( support.getById ) {
           Expr.filter[ "ID" ] = function( id ) {
               var attrId = id.replace( runescape, funescape );
               return function( elem ) {
                   return elem.getAttribute( "id" ) === attrId;
               };
           };
           Expr.find[ "ID" ] = function( id, context ) {
               if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                   var elem = context.getElementById( id );
                   return elem ? [ elem ] : [];
               }
           };
       } else {
           Expr.filter[ "ID" ] =  function( id ) {
               var attrId = id.replace( runescape, funescape );
               return function( elem ) {
                   var node = typeof elem.getAttributeNode !== "undefined" &&
                       elem.getAttributeNode( "id" );
                   return node && node.value === attrId;
               };
           };
   
           // Support: IE 6 - 7 only
           // getElementById is not reliable as a find shortcut
           Expr.find[ "ID" ] = function( id, context ) {
               if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                   var node, i, elems,
                       elem = context.getElementById( id );
   
                   if ( elem ) {
   
                       // Verify the id attribute
                       node = elem.getAttributeNode( "id" );
                       if ( node && node.value === id ) {
                           return [ elem ];
                       }
   
                       // Fall back on getElementsByName
                       elems = context.getElementsByName( id );
                       i = 0;
                       while ( ( elem = elems[ i++ ] ) ) {
                           node = elem.getAttributeNode( "id" );
                           if ( node && node.value === id ) {
                               return [ elem ];
                           }
                       }
                   }
   
                   return [];
               }
           };
       }
   
       // Tag
       Expr.find[ "TAG" ] = support.getElementsByTagName ?
           function( tag, context ) {
               if ( typeof context.getElementsByTagName !== "undefined" ) {
                   return context.getElementsByTagName( tag );
   
               // DocumentFragment nodes don't have gEBTN
               } else if ( support.qsa ) {
                   return context.querySelectorAll( tag );
               }
           } :
   
           function( tag, context ) {
               var elem,
                   tmp = [],
                   i = 0,
   
                   // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                   results = context.getElementsByTagName( tag );
   
               // Filter out possible comments
               if ( tag === "*" ) {
                   while ( ( elem = results[ i++ ] ) ) {
                       if ( elem.nodeType === 1 ) {
                           tmp.push( elem );
                       }
                   }
   
                   return tmp;
               }
               return results;
           };
   
       // Class
       Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
           if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
               return context.getElementsByClassName( className );
           }
       };
   
       /* QSA/matchesSelector
       ---------------------------------------------------------------------- */
   
       // QSA and matchesSelector support
   
       // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
       rbuggyMatches = [];
   
       // qSa(:focus) reports false when true (Chrome 21)
       // We allow this because of a bug in IE8/9 that throws an error
       // whenever `document.activeElement` is accessed on an iframe
       // So, we allow :focus to pass through QSA all the time to avoid the IE error
       // See https://bugs.jquery.com/ticket/13378
       rbuggyQSA = [];
   
       if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
   
           // Build QSA regex
           // Regex strategy adopted from Diego Perini
           assert( function( el ) {
   
               var input;
   
               // Select is set to empty string on purpose
               // This is to test IE's treatment of not explicitly
               // setting a boolean content attribute,
               // since its presence should be enough
               // https://bugs.jquery.com/ticket/12359
               docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                   "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                   "<option selected=''></option></select>";
   
               // Support: IE8, Opera 11-12.16
               // Nothing should be selected when empty strings follow ^= or $= or *=
               // The test attribute must be unknown in Opera but "safe" for WinRT
               // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
               if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
                   rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
               }
   
               // Support: IE8
               // Boolean attributes and "value" are not treated correctly
               if ( !el.querySelectorAll( "[selected]" ).length ) {
                   rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
               }
   
               // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
               if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                   rbuggyQSA.push( "~=" );
               }
   
               // Support: IE 11+, Edge 15 - 18+
               // IE 11/Edge don't find elements on a `[name='']` query in some cases.
               // Adding a temporary attribute to the document before the selection works
               // around the issue.
               // Interestingly, IE 10 & older don't seem to have the issue.
               input = document.createElement( "input" );
               input.setAttribute( "name", "" );
               el.appendChild( input );
               if ( !el.querySelectorAll( "[name='']" ).length ) {
                   rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
                       whitespace + "*(?:''|\"\")" );
               }
   
               // Webkit/Opera - :checked should return selected option elements
               // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
               // IE8 throws error here and will not see later tests
               if ( !el.querySelectorAll( ":checked" ).length ) {
                   rbuggyQSA.push( ":checked" );
               }
   
               // Support: Safari 8+, iOS 8+
               // https://bugs.webkit.org/show_bug.cgi?id=136851
               // In-page `selector#id sibling-combinator selector` fails
               if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                   rbuggyQSA.push( ".#.+[+~]" );
               }
   
               // Support: Firefox <=3.6 - 5 only
               // Old Firefox doesn't throw on a badly-escaped identifier.
               el.querySelectorAll( "\\\f" );
               rbuggyQSA.push( "[\\r\\n\\f]" );
           } );
   
           assert( function( el ) {
               el.innerHTML = "<a href='' disabled='disabled'></a>" +
                   "<select disabled='disabled'><option/></select>";
   
               // Support: Windows 8 Native Apps
               // The type and name attributes are restricted during .innerHTML assignment
               var input = document.createElement( "input" );
               input.setAttribute( "type", "hidden" );
               el.appendChild( input ).setAttribute( "name", "D" );
   
               // Support: IE8
               // Enforce case-sensitivity of name attribute
               if ( el.querySelectorAll( "[name=d]" ).length ) {
                   rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
               }
   
               // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
               // IE8 throws error here and will not see later tests
               if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
                   rbuggyQSA.push( ":enabled", ":disabled" );
               }
   
               // Support: IE9-11+
               // IE's :disabled selector does not pick up the children of disabled fieldsets
               docElem.appendChild( el ).disabled = true;
               if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
                   rbuggyQSA.push( ":enabled", ":disabled" );
               }
   
               // Support: Opera 10 - 11 only
               // Opera 10-11 does not throw on post-comma invalid pseudos
               el.querySelectorAll( "*,:x" );
               rbuggyQSA.push( ",.*:" );
           } );
       }
   
       if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
           docElem.webkitMatchesSelector ||
           docElem.mozMatchesSelector ||
           docElem.oMatchesSelector ||
           docElem.msMatchesSelector ) ) ) ) {
   
           assert( function( el ) {
   
               // Check to see if it's possible to do matchesSelector
               // on a disconnected node (IE 9)
               support.disconnectedMatch = matches.call( el, "*" );
   
               // This should fail with an exception
               // Gecko does not error, returns false instead
               matches.call( el, "[s!='']:x" );
               rbuggyMatches.push( "!=", pseudos );
           } );
       }
   
       rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
       rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
   
       /* Contains
       ---------------------------------------------------------------------- */
       hasCompare = rnative.test( docElem.compareDocumentPosition );
   
       // Element contains another
       // Purposefully self-exclusive
       // As in, an element does not contain itself
       contains = hasCompare || rnative.test( docElem.contains ) ?
           function( a, b ) {
               var adown = a.nodeType === 9 ? a.documentElement : a,
                   bup = b && b.parentNode;
               return a === bup || !!( bup && bup.nodeType === 1 && (
                   adown.contains ?
                       adown.contains( bup ) :
                       a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
               ) );
           } :
           function( a, b ) {
               if ( b ) {
                   while ( ( b = b.parentNode ) ) {
                       if ( b === a ) {
                           return true;
                       }
                   }
               }
               return false;
           };
   
       /* Sorting
       ---------------------------------------------------------------------- */
   
       // Document order sorting
       sortOrder = hasCompare ?
       function( a, b ) {
   
           // Flag for duplicate removal
           if ( a === b ) {
               hasDuplicate = true;
               return 0;
           }
   
           // Sort on method existence if only one input has compareDocumentPosition
           var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
           if ( compare ) {
               return compare;
           }
   
           // Calculate position if both inputs belong to the same document
           // Support: IE 11+, Edge 17 - 18+
           // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
           // two documents; shallow comparisons work.
           // eslint-disable-next-line eqeqeq
           compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
               a.compareDocumentPosition( b ) :
   
               // Otherwise we know they are disconnected
               1;
   
           // Disconnected nodes
           if ( compare & 1 ||
               ( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
   
               // Choose the first element that is related to our preferred document
               // Support: IE 11+, Edge 17 - 18+
               // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
               // two documents; shallow comparisons work.
               // eslint-disable-next-line eqeqeq
               if ( a == document || a.ownerDocument == preferredDoc &&
                   contains( preferredDoc, a ) ) {
                   return -1;
               }
   
               // Support: IE 11+, Edge 17 - 18+
               // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
               // two documents; shallow comparisons work.
               // eslint-disable-next-line eqeqeq
               if ( b == document || b.ownerDocument == preferredDoc &&
                   contains( preferredDoc, b ) ) {
                   return 1;
               }
   
               // Maintain original order
               return sortInput ?
                   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                   0;
           }
   
           return compare & 4 ? -1 : 1;
       } :
       function( a, b ) {
   
           // Exit early if the nodes are identical
           if ( a === b ) {
               hasDuplicate = true;
               return 0;
           }
   
           var cur,
               i = 0,
               aup = a.parentNode,
               bup = b.parentNode,
               ap = [ a ],
               bp = [ b ];
   
           // Parentless nodes are either documents or disconnected
           if ( !aup || !bup ) {
   
               // Support: IE 11+, Edge 17 - 18+
               // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
               // two documents; shallow comparisons work.
               /* eslint-disable eqeqeq */
               return a == document ? -1 :
                   b == document ? 1 :
                   /* eslint-enable eqeqeq */
                   aup ? -1 :
                   bup ? 1 :
                   sortInput ?
                   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                   0;
   
           // If the nodes are siblings, we can do a quick check
           } else if ( aup === bup ) {
               return siblingCheck( a, b );
           }
   
           // Otherwise we need full lists of their ancestors for comparison
           cur = a;
           while ( ( cur = cur.parentNode ) ) {
               ap.unshift( cur );
           }
           cur = b;
           while ( ( cur = cur.parentNode ) ) {
               bp.unshift( cur );
           }
   
           // Walk down the tree looking for a discrepancy
           while ( ap[ i ] === bp[ i ] ) {
               i++;
           }
   
           return i ?
   
               // Do a sibling check if the nodes have a common ancestor
               siblingCheck( ap[ i ], bp[ i ] ) :
   
               // Otherwise nodes in our document sort first
               // Support: IE 11+, Edge 17 - 18+
               // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
               // two documents; shallow comparisons work.
               /* eslint-disable eqeqeq */
               ap[ i ] == preferredDoc ? -1 :
               bp[ i ] == preferredDoc ? 1 :
               /* eslint-enable eqeqeq */
               0;
       };
   
       return document;
   };
   
   Sizzle.matches = function( expr, elements ) {
       return Sizzle( expr, null, null, elements );
   };
   
   Sizzle.matchesSelector = function( elem, expr ) {
       setDocument( elem );
   
       if ( support.matchesSelector && documentIsHTML &&
           !nonnativeSelectorCache[ expr + " " ] &&
           ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
           ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
   
           try {
               var ret = matches.call( elem, expr );
   
               // IE 9's matchesSelector returns false on disconnected nodes
               if ( ret || support.disconnectedMatch ||
   
                   // As well, disconnected nodes are said to be in a document
                   // fragment in IE 9
                   elem.document && elem.document.nodeType !== 11 ) {
                   return ret;
               }
           } catch ( e ) {
               nonnativeSelectorCache( expr, true );
           }
       }
   
       return Sizzle( expr, document, null, [ elem ] ).length > 0;
   };
   
   Sizzle.contains = function( context, elem ) {
   
       // Set document vars if needed
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( ( context.ownerDocument || context ) != document ) {
           setDocument( context );
       }
       return contains( context, elem );
   };
   
   Sizzle.attr = function( elem, name ) {
   
       // Set document vars if needed
       // Support: IE 11+, Edge 17 - 18+
       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
       // two documents; shallow comparisons work.
       // eslint-disable-next-line eqeqeq
       if ( ( elem.ownerDocument || elem ) != document ) {
           setDocument( elem );
       }
   
       var fn = Expr.attrHandle[ name.toLowerCase() ],
   
           // Don't get fooled by Object.prototype properties (jQuery #13807)
           val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
               fn( elem, name, !documentIsHTML ) :
               undefined;
   
       return val !== undefined ?
           val :
           support.attributes || !documentIsHTML ?
               elem.getAttribute( name ) :
               ( val = elem.getAttributeNode( name ) ) && val.specified ?
                   val.value :
                   null;
   };
   
   Sizzle.escape = function( sel ) {
       return ( sel + "" ).replace( rcssescape, fcssescape );
   };
   
   Sizzle.error = function( msg ) {
       throw new Error( "Syntax error, unrecognized expression: " + msg );
   };
   
   /**
    * Document sorting and removing duplicates
    * @param {ArrayLike} results
    */
   Sizzle.uniqueSort = function( results ) {
       var elem,
           duplicates = [],
           j = 0,
           i = 0;
   
       // Unless we *know* we can detect duplicates, assume their presence
       hasDuplicate = !support.detectDuplicates;
       sortInput = !support.sortStable && results.slice( 0 );
       results.sort( sortOrder );
   
       if ( hasDuplicate ) {
           while ( ( elem = results[ i++ ] ) ) {
               if ( elem === results[ i ] ) {
                   j = duplicates.push( i );
               }
           }
           while ( j-- ) {
               results.splice( duplicates[ j ], 1 );
           }
       }
   
       // Clear input after sorting to release objects
       // See https://github.com/jquery/sizzle/pull/225
       sortInput = null;
   
       return results;
   };
   
   /**
    * Utility function for retrieving the text value of an array of DOM nodes
    * @param {Array|Element} elem
    */
   getText = Sizzle.getText = function( elem ) {
       var node,
           ret = "",
           i = 0,
           nodeType = elem.nodeType;
   
       if ( !nodeType ) {
   
           // If no nodeType, this is expected to be an array
           while ( ( node = elem[ i++ ] ) ) {
   
               // Do not traverse comment nodes
               ret += getText( node );
           }
       } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
   
           // Use textContent for elements
           // innerText usage removed for consistency of new lines (jQuery #11153)
           if ( typeof elem.textContent === "string" ) {
               return elem.textContent;
           } else {
   
               // Traverse its children
               for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                   ret += getText( elem );
               }
           }
       } else if ( nodeType === 3 || nodeType === 4 ) {
           return elem.nodeValue;
       }
   
       // Do not include comment or processing instruction nodes
   
       return ret;
   };
   
   Expr = Sizzle.selectors = {
   
       // Can be adjusted by the user
       cacheLength: 50,
   
       createPseudo: markFunction,
   
       match: matchExpr,
   
       attrHandle: {},
   
       find: {},
   
       relative: {
           ">": { dir: "parentNode", first: true },
           " ": { dir: "parentNode" },
           "+": { dir: "previousSibling", first: true },
           "~": { dir: "previousSibling" }
       },
   
       preFilter: {
           "ATTR": function( match ) {
               match[ 1 ] = match[ 1 ].replace( runescape, funescape );
   
               // Move the given value to match[3] whether quoted or unquoted
               match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
                   match[ 5 ] || "" ).replace( runescape, funescape );
   
               if ( match[ 2 ] === "~=" ) {
                   match[ 3 ] = " " + match[ 3 ] + " ";
               }
   
               return match.slice( 0, 4 );
           },
   
           "CHILD": function( match ) {
   
               /* matches from matchExpr["CHILD"]
                   1 type (only|nth|...)
                   2 what (child|of-type)
                   3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                   4 xn-component of xn+y argument ([+-]?\d*n|)
                   5 sign of xn-component
                   6 x of xn-component
                   7 sign of y-component
                   8 y of y-component
               */
               match[ 1 ] = match[ 1 ].toLowerCase();
   
               if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
   
                   // nth-* requires argument
                   if ( !match[ 3 ] ) {
                       Sizzle.error( match[ 0 ] );
                   }
   
                   // numeric x and y parameters for Expr.filter.CHILD
                   // remember that false/true cast respectively to 0/1
                   match[ 4 ] = +( match[ 4 ] ?
                       match[ 5 ] + ( match[ 6 ] || 1 ) :
                       2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
                   match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
   
                   // other types prohibit arguments
               } else if ( match[ 3 ] ) {
                   Sizzle.error( match[ 0 ] );
               }
   
               return match;
           },
   
           "PSEUDO": function( match ) {
               var excess,
                   unquoted = !match[ 6 ] && match[ 2 ];
   
               if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
                   return null;
               }
   
               // Accept quoted arguments as-is
               if ( match[ 3 ] ) {
                   match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
   
               // Strip excess characters from unquoted arguments
               } else if ( unquoted && rpseudo.test( unquoted ) &&
   
                   // Get excess from tokenize (recursively)
                   ( excess = tokenize( unquoted, true ) ) &&
   
                   // advance to the next closing parenthesis
                   ( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
   
                   // excess is a negative index
                   match[ 0 ] = match[ 0 ].slice( 0, excess );
                   match[ 2 ] = unquoted.slice( 0, excess );
               }
   
               // Return only captures needed by the pseudo filter method (type and argument)
               return match.slice( 0, 3 );
           }
       },
   
       filter: {
   
           "TAG": function( nodeNameSelector ) {
               var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
               return nodeNameSelector === "*" ?
                   function() {
                       return true;
                   } :
                   function( elem ) {
                       return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                   };
           },
   
           "CLASS": function( className ) {
               var pattern = classCache[ className + " " ];
   
               return pattern ||
                   ( pattern = new RegExp( "(^|" + whitespace +
                       ")" + className + "(" + whitespace + "|$)" ) ) && classCache(
                           className, function( elem ) {
                               return pattern.test(
                                   typeof elem.className === "string" && elem.className ||
                                   typeof elem.getAttribute !== "undefined" &&
                                       elem.getAttribute( "class" ) ||
                                   ""
                               );
                   } );
           },
   
           "ATTR": function( name, operator, check ) {
               return function( elem ) {
                   var result = Sizzle.attr( elem, name );
   
                   if ( result == null ) {
                       return operator === "!=";
                   }
                   if ( !operator ) {
                       return true;
                   }
   
                   result += "";
   
                   /* eslint-disable max-len */
   
                   return operator === "=" ? result === check :
                       operator === "!=" ? result !== check :
                       operator === "^=" ? check && result.indexOf( check ) === 0 :
                       operator === "*=" ? check && result.indexOf( check ) > -1 :
                       operator === "$=" ? check && result.slice( -check.length ) === check :
                       operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                       operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                       false;
                   /* eslint-enable max-len */
   
               };
           },
   
           "CHILD": function( type, what, _argument, first, last ) {
               var simple = type.slice( 0, 3 ) !== "nth",
                   forward = type.slice( -4 ) !== "last",
                   ofType = what === "of-type";
   
               return first === 1 && last === 0 ?
   
                   // Shortcut for :nth-*(n)
                   function( elem ) {
                       return !!elem.parentNode;
                   } :
   
                   function( elem, _context, xml ) {
                       var cache, uniqueCache, outerCache, node, nodeIndex, start,
                           dir = simple !== forward ? "nextSibling" : "previousSibling",
                           parent = elem.parentNode,
                           name = ofType && elem.nodeName.toLowerCase(),
                           useCache = !xml && !ofType,
                           diff = false;
   
                       if ( parent ) {
   
                           // :(first|last|only)-(child|of-type)
                           if ( simple ) {
                               while ( dir ) {
                                   node = elem;
                                   while ( ( node = node[ dir ] ) ) {
                                       if ( ofType ?
                                           node.nodeName.toLowerCase() === name :
                                           node.nodeType === 1 ) {
   
                                           return false;
                                       }
                                   }
   
                                   // Reverse direction for :only-* (if we haven't yet done so)
                                   start = dir = type === "only" && !start && "nextSibling";
                               }
                               return true;
                           }
   
                           start = [ forward ? parent.firstChild : parent.lastChild ];
   
                           // non-xml :nth-child(...) stores cache data on `parent`
                           if ( forward && useCache ) {
   
                               // Seek `elem` from a previously-cached index
   
                               // ...in a gzip-friendly way
                               node = parent;
                               outerCache = node[ expando ] || ( node[ expando ] = {} );
   
                               // Support: IE <9 only
                               // Defend against cloned attroperties (jQuery gh-1709)
                               uniqueCache = outerCache[ node.uniqueID ] ||
                                   ( outerCache[ node.uniqueID ] = {} );
   
                               cache = uniqueCache[ type ] || [];
                               nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                               diff = nodeIndex && cache[ 2 ];
                               node = nodeIndex && parent.childNodes[ nodeIndex ];
   
                               while ( ( node = ++nodeIndex && node && node[ dir ] ||
   
                                   // Fallback to seeking `elem` from the start
                                   ( diff = nodeIndex = 0 ) || start.pop() ) ) {
   
                                   // When found, cache indexes on `parent` and break
                                   if ( node.nodeType === 1 && ++diff && node === elem ) {
                                       uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                       break;
                                   }
                               }
   
                           } else {
   
                               // Use previously-cached element index if available
                               if ( useCache ) {
   
                                   // ...in a gzip-friendly way
                                   node = elem;
                                   outerCache = node[ expando ] || ( node[ expando ] = {} );
   
                                   // Support: IE <9 only
                                   // Defend against cloned attroperties (jQuery gh-1709)
                                   uniqueCache = outerCache[ node.uniqueID ] ||
                                       ( outerCache[ node.uniqueID ] = {} );
   
                                   cache = uniqueCache[ type ] || [];
                                   nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                   diff = nodeIndex;
                               }
   
                               // xml :nth-child(...)
                               // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                               if ( diff === false ) {
   
                                   // Use the same loop as above to seek `elem` from the start
                                   while ( ( node = ++nodeIndex && node && node[ dir ] ||
                                       ( diff = nodeIndex = 0 ) || start.pop() ) ) {
   
                                       if ( ( ofType ?
                                           node.nodeName.toLowerCase() === name :
                                           node.nodeType === 1 ) &&
                                           ++diff ) {
   
                                           // Cache the index of each encountered element
                                           if ( useCache ) {
                                               outerCache = node[ expando ] ||
                                                   ( node[ expando ] = {} );
   
                                               // Support: IE <9 only
                                               // Defend against cloned attroperties (jQuery gh-1709)
                                               uniqueCache = outerCache[ node.uniqueID ] ||
                                                   ( outerCache[ node.uniqueID ] = {} );
   
                                               uniqueCache[ type ] = [ dirruns, diff ];
                                           }
   
                                           if ( node === elem ) {
                                               break;
                                           }
                                       }
                                   }
                               }
                           }
   
                           // Incorporate the offset, then check against cycle size
                           diff -= last;
                           return diff === first || ( diff % first === 0 && diff / first >= 0 );
                       }
                   };
           },
   
           "PSEUDO": function( pseudo, argument ) {
   
               // pseudo-class names are case-insensitive
               // http://www.w3.org/TR/selectors/#pseudo-classes
               // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
               // Remember that setFilters inherits from pseudos
               var args,
                   fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                       Sizzle.error( "unsupported pseudo: " + pseudo );
   
               // The user may use createPseudo to indicate that
               // arguments are needed to create the filter function
               // just as Sizzle does
               if ( fn[ expando ] ) {
                   return fn( argument );
               }
   
               // But maintain support for old signatures
               if ( fn.length > 1 ) {
                   args = [ pseudo, pseudo, "", argument ];
                   return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                       markFunction( function( seed, matches ) {
                           var idx,
                               matched = fn( seed, argument ),
                               i = matched.length;
                           while ( i-- ) {
                               idx = indexOf( seed, matched[ i ] );
                               seed[ idx ] = !( matches[ idx ] = matched[ i ] );
                           }
                       } ) :
                       function( elem ) {
                           return fn( elem, 0, args );
                       };
               }
   
               return fn;
           }
       },
   
       pseudos: {
   
           // Potentially complex pseudos
           "not": markFunction( function( selector ) {
   
               // Trim the selector passed to compile
               // to avoid treating leading and trailing
               // spaces as combinators
               var input = [],
                   results = [],
                   matcher = compile( selector.replace( rtrim, "$1" ) );
   
               return matcher[ expando ] ?
                   markFunction( function( seed, matches, _context, xml ) {
                       var elem,
                           unmatched = matcher( seed, null, xml, [] ),
                           i = seed.length;
   
                       // Match elements unmatched by `matcher`
                       while ( i-- ) {
                           if ( ( elem = unmatched[ i ] ) ) {
                               seed[ i ] = !( matches[ i ] = elem );
                           }
                       }
                   } ) :
                   function( elem, _context, xml ) {
                       input[ 0 ] = elem;
                       matcher( input, null, xml, results );
   
                       // Don't keep the element (issue #299)
                       input[ 0 ] = null;
                       return !results.pop();
                   };
           } ),
   
           "has": markFunction( function( selector ) {
               return function( elem ) {
                   return Sizzle( selector, elem ).length > 0;
               };
           } ),
   
           "contains": markFunction( function( text ) {
               text = text.replace( runescape, funescape );
               return function( elem ) {
                   return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
               };
           } ),
   
           // "Whether an element is represented by a :lang() selector
           // is based solely on the element's language value
           // being equal to the identifier C,
           // or beginning with the identifier C immediately followed by "-".
           // The matching of C against the element's language value is performed case-insensitively.
           // The identifier C does not have to be a valid language name."
           // http://www.w3.org/TR/selectors/#lang-pseudo
           "lang": markFunction( function( lang ) {
   
               // lang value must be a valid identifier
               if ( !ridentifier.test( lang || "" ) ) {
                   Sizzle.error( "unsupported lang: " + lang );
               }
               lang = lang.replace( runescape, funescape ).toLowerCase();
               return function( elem ) {
                   var elemLang;
                   do {
                       if ( ( elemLang = documentIsHTML ?
                           elem.lang :
                           elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
   
                           elemLang = elemLang.toLowerCase();
                           return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                       }
                   } while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
                   return false;
               };
           } ),
   
           // Miscellaneous
           "target": function( elem ) {
               var hash = window.location && window.location.hash;
               return hash && hash.slice( 1 ) === elem.id;
           },
   
           "root": function( elem ) {
               return elem === docElem;
           },
   
           "focus": function( elem ) {
               return elem === document.activeElement &&
                   ( !document.hasFocus || document.hasFocus() ) &&
                   !!( elem.type || elem.href || ~elem.tabIndex );
           },
   
           // Boolean properties
           "enabled": createDisabledPseudo( false ),
           "disabled": createDisabledPseudo( true ),
   
           "checked": function( elem ) {
   
               // In CSS3, :checked should return both checked and selected elements
               // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
               var nodeName = elem.nodeName.toLowerCase();
               return ( nodeName === "input" && !!elem.checked ) ||
                   ( nodeName === "option" && !!elem.selected );
           },
   
           "selected": function( elem ) {
   
               // Accessing this property makes selected-by-default
               // options in Safari work properly
               if ( elem.parentNode ) {
                   // eslint-disable-next-line no-unused-expressions
                   elem.parentNode.selectedIndex;
               }
   
               return elem.selected === true;
           },
   
           // Contents
           "empty": function( elem ) {
   
               // http://www.w3.org/TR/selectors/#empty-pseudo
               // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
               //   but not by others (comment: 8; processing instruction: 7; etc.)
               // nodeType < 6 works because attributes (2) do not appear as children
               for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                   if ( elem.nodeType < 6 ) {
                       return false;
                   }
               }
               return true;
           },
   
           "parent": function( elem ) {
               return !Expr.pseudos[ "empty" ]( elem );
           },
   
           // Element/input types
           "header": function( elem ) {
               return rheader.test( elem.nodeName );
           },
   
           "input": function( elem ) {
               return rinputs.test( elem.nodeName );
           },
   
           "button": function( elem ) {
               var name = elem.nodeName.toLowerCase();
               return name === "input" && elem.type === "button" || name === "button";
           },
   
           "text": function( elem ) {
               var attr;
               return elem.nodeName.toLowerCase() === "input" &&
                   elem.type === "text" &&
   
                   // Support: IE<8
                   // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                   ( ( attr = elem.getAttribute( "type" ) ) == null ||
                       attr.toLowerCase() === "text" );
           },
   
           // Position-in-collection
           "first": createPositionalPseudo( function() {
               return [ 0 ];
           } ),
   
           "last": createPositionalPseudo( function( _matchIndexes, length ) {
               return [ length - 1 ];
           } ),
   
           "eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
               return [ argument < 0 ? argument + length : argument ];
           } ),
   
           "even": createPositionalPseudo( function( matchIndexes, length ) {
               var i = 0;
               for ( ; i < length; i += 2 ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           } ),
   
           "odd": createPositionalPseudo( function( matchIndexes, length ) {
               var i = 1;
               for ( ; i < length; i += 2 ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           } ),
   
           "lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
               var i = argument < 0 ?
                   argument + length :
                   argument > length ?
                       length :
                       argument;
               for ( ; --i >= 0; ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           } ),
   
           "gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
               var i = argument < 0 ? argument + length : argument;
               for ( ; ++i < length; ) {
                   matchIndexes.push( i );
               }
               return matchIndexes;
           } )
       }
   };
   
   Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
   
   // Add button/input type pseudos
   for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
       Expr.pseudos[ i ] = createInputPseudo( i );
   }
   for ( i in { submit: true, reset: true } ) {
       Expr.pseudos[ i ] = createButtonPseudo( i );
   }
   
   // Easy API for creating new setFilters
   function setFilters() {}
   setFilters.prototype = Expr.filters = Expr.pseudos;
   Expr.setFilters = new setFilters();
   
   tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
       var matched, match, tokens, type,
           soFar, groups, preFilters,
           cached = tokenCache[ selector + " " ];
   
       if ( cached ) {
           return parseOnly ? 0 : cached.slice( 0 );
       }
   
       soFar = selector;
       groups = [];
       preFilters = Expr.preFilter;
   
       while ( soFar ) {
   
           // Comma and first run
           if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
               if ( match ) {
   
                   // Don't consume trailing commas as valid
                   soFar = soFar.slice( match[ 0 ].length ) || soFar;
               }
               groups.push( ( tokens = [] ) );
           }
   
           matched = false;
   
           // Combinators
           if ( ( match = rcombinators.exec( soFar ) ) ) {
               matched = match.shift();
               tokens.push( {
                   value: matched,
   
                   // Cast descendant combinators to space
                   type: match[ 0 ].replace( rtrim, " " )
               } );
               soFar = soFar.slice( matched.length );
           }
   
           // Filters
           for ( type in Expr.filter ) {
               if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
                   ( match = preFilters[ type ]( match ) ) ) ) {
                   matched = match.shift();
                   tokens.push( {
                       value: matched,
                       type: type,
                       matches: match
                   } );
                   soFar = soFar.slice( matched.length );
               }
           }
   
           if ( !matched ) {
               break;
           }
       }
   
       // Return the length of the invalid excess
       // if we're just parsing
       // Otherwise, throw an error or return tokens
       return parseOnly ?
           soFar.length :
           soFar ?
               Sizzle.error( selector ) :
   
               // Cache the tokens
               tokenCache( selector, groups ).slice( 0 );
   };
   
   function toSelector( tokens ) {
       var i = 0,
           len = tokens.length,
           selector = "";
       for ( ; i < len; i++ ) {
           selector += tokens[ i ].value;
       }
       return selector;
   }
   
   function addCombinator( matcher, combinator, base ) {
       var dir = combinator.dir,
           skip = combinator.next,
           key = skip || dir,
           checkNonElements = base && key === "parentNode",
           doneName = done++;
   
       return combinator.first ?
   
           // Check against closest ancestor/preceding element
           function( elem, context, xml ) {
               while ( ( elem = elem[ dir ] ) ) {
                   if ( elem.nodeType === 1 || checkNonElements ) {
                       return matcher( elem, context, xml );
                   }
               }
               return false;
           } :
   
           // Check against all ancestor/preceding elements
           function( elem, context, xml ) {
               var oldCache, uniqueCache, outerCache,
                   newCache = [ dirruns, doneName ];
   
               // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
               if ( xml ) {
                   while ( ( elem = elem[ dir ] ) ) {
                       if ( elem.nodeType === 1 || checkNonElements ) {
                           if ( matcher( elem, context, xml ) ) {
                               return true;
                           }
                       }
                   }
               } else {
                   while ( ( elem = elem[ dir ] ) ) {
                       if ( elem.nodeType === 1 || checkNonElements ) {
                           outerCache = elem[ expando ] || ( elem[ expando ] = {} );
   
                           // Support: IE <9 only
                           // Defend against cloned attroperties (jQuery gh-1709)
                           uniqueCache = outerCache[ elem.uniqueID ] ||
                               ( outerCache[ elem.uniqueID ] = {} );
   
                           if ( skip && skip === elem.nodeName.toLowerCase() ) {
                               elem = elem[ dir ] || elem;
                           } else if ( ( oldCache = uniqueCache[ key ] ) &&
                               oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
   
                               // Assign to newCache so results back-propagate to previous elements
                               return ( newCache[ 2 ] = oldCache[ 2 ] );
                           } else {
   
                               // Reuse newcache so results back-propagate to previous elements
                               uniqueCache[ key ] = newCache;
   
                               // A match means we're done; a fail means we have to keep checking
                               if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
                                   return true;
                               }
                           }
                       }
                   }
               }
               return false;
           };
   }
   
   function elementMatcher( matchers ) {
       return matchers.length > 1 ?
           function( elem, context, xml ) {
               var i = matchers.length;
               while ( i-- ) {
                   if ( !matchers[ i ]( elem, context, xml ) ) {
                       return false;
                   }
               }
               return true;
           } :
           matchers[ 0 ];
   }
   
   function multipleContexts( selector, contexts, results ) {
       var i = 0,
           len = contexts.length;
       for ( ; i < len; i++ ) {
           Sizzle( selector, contexts[ i ], results );
       }
       return results;
   }
   
   function condense( unmatched, map, filter, context, xml ) {
       var elem,
           newUnmatched = [],
           i = 0,
           len = unmatched.length,
           mapped = map != null;
   
       for ( ; i < len; i++ ) {
           if ( ( elem = unmatched[ i ] ) ) {
               if ( !filter || filter( elem, context, xml ) ) {
                   newUnmatched.push( elem );
                   if ( mapped ) {
                       map.push( i );
                   }
               }
           }
       }
   
       return newUnmatched;
   }
   
   function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
       if ( postFilter && !postFilter[ expando ] ) {
           postFilter = setMatcher( postFilter );
       }
       if ( postFinder && !postFinder[ expando ] ) {
           postFinder = setMatcher( postFinder, postSelector );
       }
       return markFunction( function( seed, results, context, xml ) {
           var temp, i, elem,
               preMap = [],
               postMap = [],
               preexisting = results.length,
   
               // Get initial elements from seed or context
               elems = seed || multipleContexts(
                   selector || "*",
                   context.nodeType ? [ context ] : context,
                   []
               ),
   
               // Prefilter to get matcher input, preserving a map for seed-results synchronization
               matcherIn = preFilter && ( seed || !selector ) ?
                   condense( elems, preMap, preFilter, context, xml ) :
                   elems,
   
               matcherOut = matcher ?
   
                   // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                   postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
   
                       // ...intermediate processing is necessary
                       [] :
   
                       // ...otherwise use results directly
                       results :
                   matcherIn;
   
           // Find primary matches
           if ( matcher ) {
               matcher( matcherIn, matcherOut, context, xml );
           }
   
           // Apply postFilter
           if ( postFilter ) {
               temp = condense( matcherOut, postMap );
               postFilter( temp, [], context, xml );
   
               // Un-match failing elements by moving them back to matcherIn
               i = temp.length;
               while ( i-- ) {
                   if ( ( elem = temp[ i ] ) ) {
                       matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
                   }
               }
           }
   
           if ( seed ) {
               if ( postFinder || preFilter ) {
                   if ( postFinder ) {
   
                       // Get the final matcherOut by condensing this intermediate into postFinder contexts
                       temp = [];
                       i = matcherOut.length;
                       while ( i-- ) {
                           if ( ( elem = matcherOut[ i ] ) ) {
   
                               // Restore matcherIn since elem is not yet a final match
                               temp.push( ( matcherIn[ i ] = elem ) );
                           }
                       }
                       postFinder( null, ( matcherOut = [] ), temp, xml );
                   }
   
                   // Move matched elements from seed to results to keep them synchronized
                   i = matcherOut.length;
                   while ( i-- ) {
                       if ( ( elem = matcherOut[ i ] ) &&
                           ( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
   
                           seed[ temp ] = !( results[ temp ] = elem );
                       }
                   }
               }
   
           // Add elements to results, through postFinder if defined
           } else {
               matcherOut = condense(
                   matcherOut === results ?
                       matcherOut.splice( preexisting, matcherOut.length ) :
                       matcherOut
               );
               if ( postFinder ) {
                   postFinder( null, results, matcherOut, xml );
               } else {
                   push.apply( results, matcherOut );
               }
           }
       } );
   }
   
   function matcherFromTokens( tokens ) {
       var checkContext, matcher, j,
           len = tokens.length,
           leadingRelative = Expr.relative[ tokens[ 0 ].type ],
           implicitRelative = leadingRelative || Expr.relative[ " " ],
           i = leadingRelative ? 1 : 0,
   
           // The foundational matcher ensures that elements are reachable from top-level context(s)
           matchContext = addCombinator( function( elem ) {
               return elem === checkContext;
           }, implicitRelative, true ),
           matchAnyContext = addCombinator( function( elem ) {
               return indexOf( checkContext, elem ) > -1;
           }, implicitRelative, true ),
           matchers = [ function( elem, context, xml ) {
               var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                   ( checkContext = context ).nodeType ?
                       matchContext( elem, context, xml ) :
                       matchAnyContext( elem, context, xml ) );
   
               // Avoid hanging onto element (issue #299)
               checkContext = null;
               return ret;
           } ];
   
       for ( ; i < len; i++ ) {
           if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
               matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
           } else {
               matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
   
               // Return special upon seeing a positional matcher
               if ( matcher[ expando ] ) {
   
                   // Find the next relative operator (if any) for proper handling
                   j = ++i;
                   for ( ; j < len; j++ ) {
                       if ( Expr.relative[ tokens[ j ].type ] ) {
                           break;
                       }
                   }
                   return setMatcher(
                       i > 1 && elementMatcher( matchers ),
                       i > 1 && toSelector(
   
                       // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                       tokens
                           .slice( 0, i - 1 )
                           .concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
                       ).replace( rtrim, "$1" ),
                       matcher,
                       i < j && matcherFromTokens( tokens.slice( i, j ) ),
                       j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
                       j < len && toSelector( tokens )
                   );
               }
               matchers.push( matcher );
           }
       }
   
       return elementMatcher( matchers );
   }
   
   function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
       var bySet = setMatchers.length > 0,
           byElement = elementMatchers.length > 0,
           superMatcher = function( seed, context, xml, results, outermost ) {
               var elem, j, matcher,
                   matchedCount = 0,
                   i = "0",
                   unmatched = seed && [],
                   setMatched = [],
                   contextBackup = outermostContext,
   
                   // We must always have either seed elements or outermost context
                   elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
   
                   // Use integer dirruns iff this is the outermost matcher
                   dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
                   len = elems.length;
   
               if ( outermost ) {
   
                   // Support: IE 11+, Edge 17 - 18+
                   // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                   // two documents; shallow comparisons work.
                   // eslint-disable-next-line eqeqeq
                   outermostContext = context == document || context || outermost;
               }
   
               // Add elements passing elementMatchers directly to results
               // Support: IE<9, Safari
               // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
               for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
                   if ( byElement && elem ) {
                       j = 0;
   
                       // Support: IE 11+, Edge 17 - 18+
                       // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                       // two documents; shallow comparisons work.
                       // eslint-disable-next-line eqeqeq
                       if ( !context && elem.ownerDocument != document ) {
                           setDocument( elem );
                           xml = !documentIsHTML;
                       }
                       while ( ( matcher = elementMatchers[ j++ ] ) ) {
                           if ( matcher( elem, context || document, xml ) ) {
                               results.push( elem );
                               break;
                           }
                       }
                       if ( outermost ) {
                           dirruns = dirrunsUnique;
                       }
                   }
   
                   // Track unmatched elements for set filters
                   if ( bySet ) {
   
                       // They will have gone through all possible matchers
                       if ( ( elem = !matcher && elem ) ) {
                           matchedCount--;
                       }
   
                       // Lengthen the array for every element, matched or not
                       if ( seed ) {
                           unmatched.push( elem );
                       }
                   }
               }
   
               // `i` is now the count of elements visited above, and adding it to `matchedCount`
               // makes the latter nonnegative.
               matchedCount += i;
   
               // Apply set filters to unmatched elements
               // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
               // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
               // no element matchers and no seed.
               // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
               // case, which will result in a "00" `matchedCount` that differs from `i` but is also
               // numerically zero.
               if ( bySet && i !== matchedCount ) {
                   j = 0;
                   while ( ( matcher = setMatchers[ j++ ] ) ) {
                       matcher( unmatched, setMatched, context, xml );
                   }
   
                   if ( seed ) {
   
                       // Reintegrate element matches to eliminate the need for sorting
                       if ( matchedCount > 0 ) {
                           while ( i-- ) {
                               if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
                                   setMatched[ i ] = pop.call( results );
                               }
                           }
                       }
   
                       // Discard index placeholder values to get only actual matches
                       setMatched = condense( setMatched );
                   }
   
                   // Add matches to results
                   push.apply( results, setMatched );
   
                   // Seedless set matches succeeding multiple successful matchers stipulate sorting
                   if ( outermost && !seed && setMatched.length > 0 &&
                       ( matchedCount + setMatchers.length ) > 1 ) {
   
                       Sizzle.uniqueSort( results );
                   }
               }
   
               // Override manipulation of globals by nested matchers
               if ( outermost ) {
                   dirruns = dirrunsUnique;
                   outermostContext = contextBackup;
               }
   
               return unmatched;
           };
   
       return bySet ?
           markFunction( superMatcher ) :
           superMatcher;
   }
   
   compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
       var i,
           setMatchers = [],
           elementMatchers = [],
           cached = compilerCache[ selector + " " ];
   
       if ( !cached ) {
   
           // Generate a function of recursive functions that can be used to check each element
           if ( !match ) {
               match = tokenize( selector );
           }
           i = match.length;
           while ( i-- ) {
               cached = matcherFromTokens( match[ i ] );
               if ( cached[ expando ] ) {
                   setMatchers.push( cached );
               } else {
                   elementMatchers.push( cached );
               }
           }
   
           // Cache the compiled function
           cached = compilerCache(
               selector,
               matcherFromGroupMatchers( elementMatchers, setMatchers )
           );
   
           // Save selector and tokenization
           cached.selector = selector;
       }
       return cached;
   };
   
   /**
    * A low-level selection function that works with Sizzle's compiled
    *  selector functions
    * @param {String|Function} selector A selector or a pre-compiled
    *  selector function built with Sizzle.compile
    * @param {Element} context
    * @param {Array} [results]
    * @param {Array} [seed] A set of elements to match against
    */
   select = Sizzle.select = function( selector, context, results, seed ) {
       var i, tokens, token, type, find,
           compiled = typeof selector === "function" && selector,
           match = !seed && tokenize( ( selector = compiled.selector || selector ) );
   
       results = results || [];
   
       // Try to minimize operations if there is only one selector in the list and no seed
       // (the latter of which guarantees us context)
       if ( match.length === 1 ) {
   
           // Reduce context if the leading compound selector is an ID
           tokens = match[ 0 ] = match[ 0 ].slice( 0 );
           if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
               context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
   
               context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
                   .replace( runescape, funescape ), context ) || [] )[ 0 ];
               if ( !context ) {
                   return results;
   
               // Precompiled matchers will still verify ancestry, so step up a level
               } else if ( compiled ) {
                   context = context.parentNode;
               }
   
               selector = selector.slice( tokens.shift().value.length );
           }
   
           // Fetch a seed set for right-to-left matching
           i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
           while ( i-- ) {
               token = tokens[ i ];
   
               // Abort if we hit a combinator
               if ( Expr.relative[ ( type = token.type ) ] ) {
                   break;
               }
               if ( ( find = Expr.find[ type ] ) ) {
   
                   // Search, expanding context for leading sibling combinators
                   if ( ( seed = find(
                       token.matches[ 0 ].replace( runescape, funescape ),
                       rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
                           context
                   ) ) ) {
   
                       // If seed is empty or no tokens remain, we can return early
                       tokens.splice( i, 1 );
                       selector = seed.length && toSelector( tokens );
                       if ( !selector ) {
                           push.apply( results, seed );
                           return results;
                       }
   
                       break;
                   }
               }
           }
       }
   
       // Compile and execute a filtering function if one is not provided
       // Provide `match` to avoid retokenization if we modified the selector above
       ( compiled || compile( selector, match ) )(
           seed,
           context,
           !documentIsHTML,
           results,
           !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
       );
       return results;
   };
   
   // One-time assignments
   
   // Sort stability
   support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
   
   // Support: Chrome 14-35+
   // Always assume duplicates if they aren't passed to the comparison function
   support.detectDuplicates = !!hasDuplicate;
   
   // Initialize against the default document
   setDocument();
   
   // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
   // Detached nodes confoundingly follow *each other*
   support.sortDetached = assert( function( el ) {
   
       // Should return 1, but returns 4 (following)
       return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
   } );
   
   // Support: IE<8
   // Prevent attribute/property "interpolation"
   // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
   if ( !assert( function( el ) {
       el.innerHTML = "<a href='#'></a>";
       return el.firstChild.getAttribute( "href" ) === "#";
   } ) ) {
       addHandle( "type|href|height|width", function( elem, name, isXML ) {
           if ( !isXML ) {
               return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
           }
       } );
   }
   
   // Support: IE<9
   // Use defaultValue in place of getAttribute("value")
   if ( !support.attributes || !assert( function( el ) {
       el.innerHTML = "<input/>";
       el.firstChild.setAttribute( "value", "" );
       return el.firstChild.getAttribute( "value" ) === "";
   } ) ) {
       addHandle( "value", function( elem, _name, isXML ) {
           if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
               return elem.defaultValue;
           }
       } );
   }
   
   // Support: IE<9
   // Use getAttributeNode to fetch booleans when getAttribute lies
   if ( !assert( function( el ) {
       return el.getAttribute( "disabled" ) == null;
   } ) ) {
       addHandle( booleans, function( elem, name, isXML ) {
           var val;
           if ( !isXML ) {
               return elem[ name ] === true ? name.toLowerCase() :
                   ( val = elem.getAttributeNode( name ) ) && val.specified ?
                       val.value :
                       null;
           }
       } );
   }
   
   return Sizzle;
   
   } )( window );
   
   
   
   jQuery.find = Sizzle;
   jQuery.expr = Sizzle.selectors;
   
   // Deprecated
   jQuery.expr[ ":" ] = jQuery.expr.pseudos;
   jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
   jQuery.text = Sizzle.getText;
   jQuery.isXMLDoc = Sizzle.isXML;
   jQuery.contains = Sizzle.contains;
   jQuery.escapeSelector = Sizzle.escape;
   
   
   
   
   var dir = function( elem, dir, until ) {
       var matched = [],
           truncate = until !== undefined;
   
       while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
           if ( elem.nodeType === 1 ) {
               if ( truncate && jQuery( elem ).is( until ) ) {
                   break;
               }
               matched.push( elem );
           }
       }
       return matched;
   };
   
   
   var siblings = function( n, elem ) {
       var matched = [];
   
       for ( ; n; n = n.nextSibling ) {
           if ( n.nodeType === 1 && n !== elem ) {
               matched.push( n );
           }
       }
   
       return matched;
   };
   
   
   var rneedsContext = jQuery.expr.match.needsContext;
   
   
   
   function nodeName( elem, name ) {
   
       return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
   
   }
   var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
   
   
   
   // Implement the identical functionality for filter and not
   function winnow( elements, qualifier, not ) {
       if ( isFunction( qualifier ) ) {
           return jQuery.grep( elements, function( elem, i ) {
               return !!qualifier.call( elem, i, elem ) !== not;
           } );
       }
   
       // Single element
       if ( qualifier.nodeType ) {
           return jQuery.grep( elements, function( elem ) {
               return ( elem === qualifier ) !== not;
           } );
       }
   
       // Arraylike of elements (jQuery, arguments, Array)
       if ( typeof qualifier !== "string" ) {
           return jQuery.grep( elements, function( elem ) {
               return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
           } );
       }
   
       // Filtered directly for both simple and complex selectors
       return jQuery.filter( qualifier, elements, not );
   }
   
   jQuery.filter = function( expr, elems, not ) {
       var elem = elems[ 0 ];
   
       if ( not ) {
           expr = ":not(" + expr + ")";
       }
   
       if ( elems.length === 1 && elem.nodeType === 1 ) {
           return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
       }
   
       return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
           return elem.nodeType === 1;
       } ) );
   };
   
   jQuery.fn.extend( {
       find: function( selector ) {
           var i, ret,
               len = this.length,
               self = this;
   
           if ( typeof selector !== "string" ) {
               return this.pushStack( jQuery( selector ).filter( function() {
                   for ( i = 0; i < len; i++ ) {
                       if ( jQuery.contains( self[ i ], this ) ) {
                           return true;
                       }
                   }
               } ) );
           }
   
           ret = this.pushStack( [] );
   
           for ( i = 0; i < len; i++ ) {
               jQuery.find( selector, self[ i ], ret );
           }
   
           return len > 1 ? jQuery.uniqueSort( ret ) : ret;
       },
       filter: function( selector ) {
           return this.pushStack( winnow( this, selector || [], false ) );
       },
       not: function( selector ) {
           return this.pushStack( winnow( this, selector || [], true ) );
       },
       is: function( selector ) {
           return !!winnow(
               this,
   
               // If this is a positional/relative selector, check membership in the returned set
               // so $("p:first").is("p:last") won't return true for a doc with two "p".
               typeof selector === "string" && rneedsContext.test( selector ) ?
                   jQuery( selector ) :
                   selector || [],
               false
           ).length;
       }
   } );
   
   
   // Initialize a jQuery object
   
   
   // A central reference to the root jQuery(document)
   var rootjQuery,
   
       // A simple way to check for HTML strings
       // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
       // Strict HTML recognition (trac-11290: must start with <)
       // Shortcut simple #id case for speed
       rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
   
       init = jQuery.fn.init = function( selector, context, root ) {
           var match, elem;
   
           // HANDLE: $(""), $(null), $(undefined), $(false)
           if ( !selector ) {
               return this;
           }
   
           // Method init() accepts an alternate rootjQuery
           // so migrate can support jQuery.sub (gh-2101)
           root = root || rootjQuery;
   
           // Handle HTML strings
           if ( typeof selector === "string" ) {
               if ( selector[ 0 ] === "<" &&
                   selector[ selector.length - 1 ] === ">" &&
                   selector.length >= 3 ) {
   
                   // Assume that strings that start and end with <> are HTML and skip the regex check
                   match = [ null, selector, null ];
   
               } else {
                   match = rquickExpr.exec( selector );
               }
   
               // Match html or make sure no context is specified for #id
               if ( match && ( match[ 1 ] || !context ) ) {
   
                   // HANDLE: $(html) -> $(array)
                   if ( match[ 1 ] ) {
                       context = context instanceof jQuery ? context[ 0 ] : context;
   
                       // Option to run scripts is true for back-compat
                       // Intentionally let the error be thrown if parseHTML is not present
                       jQuery.merge( this, jQuery.parseHTML(
                           match[ 1 ],
                           context && context.nodeType ? context.ownerDocument || context : document,
                           true
                       ) );
   
                       // HANDLE: $(html, props)
                       if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                           for ( match in context ) {
   
                               // Properties of context are called as methods if possible
                               if ( isFunction( this[ match ] ) ) {
                                   this[ match ]( context[ match ] );
   
                               // ...and otherwise set as attributes
                               } else {
                                   this.attr( match, context[ match ] );
                               }
                           }
                       }
   
                       return this;
   
                   // HANDLE: $(#id)
                   } else {
                       elem = document.getElementById( match[ 2 ] );
   
                       if ( elem ) {
   
                           // Inject the element directly into the jQuery object
                           this[ 0 ] = elem;
                           this.length = 1;
                       }
                       return this;
                   }
   
               // HANDLE: $(expr, $(...))
               } else if ( !context || context.jquery ) {
                   return ( context || root ).find( selector );
   
               // HANDLE: $(expr, context)
               // (which is just equivalent to: $(context).find(expr)
               } else {
                   return this.constructor( context ).find( selector );
               }
   
           // HANDLE: $(DOMElement)
           } else if ( selector.nodeType ) {
               this[ 0 ] = selector;
               this.length = 1;
               return this;
   
           // HANDLE: $(function)
           // Shortcut for document ready
           } else if ( isFunction( selector ) ) {
               return root.ready !== undefined ?
                   root.ready( selector ) :
   
                   // Execute immediately if ready is not present
                   selector( jQuery );
           }
   
           return jQuery.makeArray( selector, this );
       };
   
   // Give the init function the jQuery prototype for later instantiation
   init.prototype = jQuery.fn;
   
   // Initialize central reference
   rootjQuery = jQuery( document );
   
   
   var rparentsprev = /^(?:parents|prev(?:Until|All))/,
   
       // Methods guaranteed to produce a unique set when starting from a unique set
       guaranteedUnique = {
           children: true,
           contents: true,
           next: true,
           prev: true
       };
   
   jQuery.fn.extend( {
       has: function( target ) {
           var targets = jQuery( target, this ),
               l = targets.length;
   
           return this.filter( function() {
               var i = 0;
               for ( ; i < l; i++ ) {
                   if ( jQuery.contains( this, targets[ i ] ) ) {
                       return true;
                   }
               }
           } );
       },
   
       closest: function( selectors, context ) {
           var cur,
               i = 0,
               l = this.length,
               matched = [],
               targets = typeof selectors !== "string" && jQuery( selectors );
   
           // Positional selectors never match, since there's no _selection_ context
           if ( !rneedsContext.test( selectors ) ) {
               for ( ; i < l; i++ ) {
                   for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
   
                       // Always skip document fragments
                       if ( cur.nodeType < 11 && ( targets ?
                           targets.index( cur ) > -1 :
   
                           // Don't pass non-elements to Sizzle
                           cur.nodeType === 1 &&
                               jQuery.find.matchesSelector( cur, selectors ) ) ) {
   
                           matched.push( cur );
                           break;
                       }
                   }
               }
           }
   
           return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
       },
   
       // Determine the position of an element within the set
       index: function( elem ) {
   
           // No argument, return index in parent
           if ( !elem ) {
               return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
           }
   
           // Index in selector
           if ( typeof elem === "string" ) {
               return indexOf.call( jQuery( elem ), this[ 0 ] );
           }
   
           // Locate the position of the desired element
           return indexOf.call( this,
   
               // If it receives a jQuery object, the first element is used
               elem.jquery ? elem[ 0 ] : elem
           );
       },
   
       add: function( selector, context ) {
           return this.pushStack(
               jQuery.uniqueSort(
                   jQuery.merge( this.get(), jQuery( selector, context ) )
               )
           );
       },
   
       addBack: function( selector ) {
           return this.add( selector == null ?
               this.prevObject : this.prevObject.filter( selector )
           );
       }
   } );
   
   function sibling( cur, dir ) {
       while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
       return cur;
   }
   
   jQuery.each( {
       parent: function( elem ) {
           var parent = elem.parentNode;
           return parent && parent.nodeType !== 11 ? parent : null;
       },
       parents: function( elem ) {
           return dir( elem, "parentNode" );
       },
       parentsUntil: function( elem, _i, until ) {
           return dir( elem, "parentNode", until );
       },
       next: function( elem ) {
           return sibling( elem, "nextSibling" );
       },
       prev: function( elem ) {
           return sibling( elem, "previousSibling" );
       },
       nextAll: function( elem ) {
           return dir( elem, "nextSibling" );
       },
       prevAll: function( elem ) {
           return dir( elem, "previousSibling" );
       },
       nextUntil: function( elem, _i, until ) {
           return dir( elem, "nextSibling", until );
       },
       prevUntil: function( elem, _i, until ) {
           return dir( elem, "previousSibling", until );
       },
       siblings: function( elem ) {
           return siblings( ( elem.parentNode || {} ).firstChild, elem );
       },
       children: function( elem ) {
           return siblings( elem.firstChild );
       },
       contents: function( elem ) {
           if ( elem.contentDocument != null &&
   
               // Support: IE 11+
               // <object> elements with no `data` attribute has an object
               // `contentDocument` with a `null` prototype.
               getProto( elem.contentDocument ) ) {
   
               return elem.contentDocument;
           }
   
           // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
           // Treat the template element as a regular one in browsers that
           // don't support it.
           if ( nodeName( elem, "template" ) ) {
               elem = elem.content || elem;
           }
   
           return jQuery.merge( [], elem.childNodes );
       }
   }, function( name, fn ) {
       jQuery.fn[ name ] = function( until, selector ) {
           var matched = jQuery.map( this, fn, until );
   
           if ( name.slice( -5 ) !== "Until" ) {
               selector = until;
           }
   
           if ( selector && typeof selector === "string" ) {
               matched = jQuery.filter( selector, matched );
           }
   
           if ( this.length > 1 ) {
   
               // Remove duplicates
               if ( !guaranteedUnique[ name ] ) {
                   jQuery.uniqueSort( matched );
               }
   
               // Reverse order for parents* and prev-derivatives
               if ( rparentsprev.test( name ) ) {
                   matched.reverse();
               }
           }
   
           return this.pushStack( matched );
       };
   } );
   var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
   
   
   
   // Convert String-formatted options into Object-formatted ones
   function createOptions( options ) {
       var object = {};
       jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
           object[ flag ] = true;
       } );
       return object;
   }
   
   /*
    * Create a callback list using the following parameters:
    *
    *	options: an optional list of space-separated options that will change how
    *			the callback list behaves or a more traditional option object
    *
    * By default a callback list will act like an event callback list and can be
    * "fired" multiple times.
    *
    * Possible options:
    *
    *	once:			will ensure the callback list can only be fired once (like a Deferred)
    *
    *	memory:			will keep track of previous values and will call any callback added
    *					after the list has been fired right away with the latest "memorized"
    *					values (like a Deferred)
    *
    *	unique:			will ensure a callback can only be added once (no duplicate in the list)
    *
    *	stopOnFalse:	interrupt callings when a callback returns false
    *
    */
   jQuery.Callbacks = function( options ) {
   
       // Convert options from String-formatted to Object-formatted if needed
       // (we check in cache first)
       options = typeof options === "string" ?
           createOptions( options ) :
           jQuery.extend( {}, options );
   
       var // Flag to know if list is currently firing
           firing,
   
           // Last fire value for non-forgettable lists
           memory,
   
           // Flag to know if list was already fired
           fired,
   
           // Flag to prevent firing
           locked,
   
           // Actual callback list
           list = [],
   
           // Queue of execution data for repeatable lists
           queue = [],
   
           // Index of currently firing callback (modified by add/remove as needed)
           firingIndex = -1,
   
           // Fire callbacks
           fire = function() {
   
               // Enforce single-firing
               locked = locked || options.once;
   
               // Execute callbacks for all pending executions,
               // respecting firingIndex overrides and runtime changes
               fired = firing = true;
               for ( ; queue.length; firingIndex = -1 ) {
                   memory = queue.shift();
                   while ( ++firingIndex < list.length ) {
   
                       // Run callback and check for early termination
                       if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                           options.stopOnFalse ) {
   
                           // Jump to end and forget the data so .add doesn't re-fire
                           firingIndex = list.length;
                           memory = false;
                       }
                   }
               }
   
               // Forget the data if we're done with it
               if ( !options.memory ) {
                   memory = false;
               }
   
               firing = false;
   
               // Clean up if we're done firing for good
               if ( locked ) {
   
                   // Keep an empty list if we have data for future add calls
                   if ( memory ) {
                       list = [];
   
                   // Otherwise, this object is spent
                   } else {
                       list = "";
                   }
               }
           },
   
           // Actual Callbacks object
           self = {
   
               // Add a callback or a collection of callbacks to the list
               add: function() {
                   if ( list ) {
   
                       // If we have memory from a past run, we should fire after adding
                       if ( memory && !firing ) {
                           firingIndex = list.length - 1;
                           queue.push( memory );
                       }
   
                       ( function add( args ) {
                           jQuery.each( args, function( _, arg ) {
                               if ( isFunction( arg ) ) {
                                   if ( !options.unique || !self.has( arg ) ) {
                                       list.push( arg );
                                   }
                               } else if ( arg && arg.length && toType( arg ) !== "string" ) {
   
                                   // Inspect recursively
                                   add( arg );
                               }
                           } );
                       } )( arguments );
   
                       if ( memory && !firing ) {
                           fire();
                       }
                   }
                   return this;
               },
   
               // Remove a callback from the list
               remove: function() {
                   jQuery.each( arguments, function( _, arg ) {
                       var index;
                       while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                           list.splice( index, 1 );
   
                           // Handle firing indexes
                           if ( index <= firingIndex ) {
                               firingIndex--;
                           }
                       }
                   } );
                   return this;
               },
   
               // Check if a given callback is in the list.
               // If no argument is given, return whether or not list has callbacks attached.
               has: function( fn ) {
                   return fn ?
                       jQuery.inArray( fn, list ) > -1 :
                       list.length > 0;
               },
   
               // Remove all callbacks from the list
               empty: function() {
                   if ( list ) {
                       list = [];
                   }
                   return this;
               },
   
               // Disable .fire and .add
               // Abort any current/pending executions
               // Clear all callbacks and values
               disable: function() {
                   locked = queue = [];
                   list = memory = "";
                   return this;
               },
               disabled: function() {
                   return !list;
               },
   
               // Disable .fire
               // Also disable .add unless we have memory (since it would have no effect)
               // Abort any pending executions
               lock: function() {
                   locked = queue = [];
                   if ( !memory && !firing ) {
                       list = memory = "";
                   }
                   return this;
               },
               locked: function() {
                   return !!locked;
               },
   
               // Call all callbacks with the given context and arguments
               fireWith: function( context, args ) {
                   if ( !locked ) {
                       args = args || [];
                       args = [ context, args.slice ? args.slice() : args ];
                       queue.push( args );
                       if ( !firing ) {
                           fire();
                       }
                   }
                   return this;
               },
   
               // Call all the callbacks with the given arguments
               fire: function() {
                   self.fireWith( this, arguments );
                   return this;
               },
   
               // To know if the callbacks have already been called at least once
               fired: function() {
                   return !!fired;
               }
           };
   
       return self;
   };
   
   
   function Identity( v ) {
       return v;
   }
   function Thrower( ex ) {
       throw ex;
   }
   
   function adoptValue( value, resolve, reject, noValue ) {
       var method;
   
       try {
   
           // Check for promise aspect first to privilege synchronous behavior
           if ( value && isFunction( ( method = value.promise ) ) ) {
               method.call( value ).done( resolve ).fail( reject );
   
           // Other thenables
           } else if ( value && isFunction( ( method = value.then ) ) ) {
               method.call( value, resolve, reject );
   
           // Other non-thenables
           } else {
   
               // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
               // * false: [ value ].slice( 0 ) => resolve( value )
               // * true: [ value ].slice( 1 ) => resolve()
               resolve.apply( undefined, [ value ].slice( noValue ) );
           }
   
       // For Promises/A+, convert exceptions into rejections
       // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
       // Deferred#then to conditionally suppress rejection.
       } catch ( value ) {
   
           // Support: Android 4.0 only
           // Strict mode functions invoked without .call/.apply get global-object context
           reject.apply( undefined, [ value ] );
       }
   }
   
   jQuery.extend( {
   
       Deferred: function( func ) {
           var tuples = [
   
                   // action, add listener, callbacks,
                   // ... .then handlers, argument index, [final state]
                   [ "notify", "progress", jQuery.Callbacks( "memory" ),
                       jQuery.Callbacks( "memory" ), 2 ],
                   [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                       jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                   [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                       jQuery.Callbacks( "once memory" ), 1, "rejected" ]
               ],
               state = "pending",
               promise = {
                   state: function() {
                       return state;
                   },
                   always: function() {
                       deferred.done( arguments ).fail( arguments );
                       return this;
                   },
                   "catch": function( fn ) {
                       return promise.then( null, fn );
                   },
   
                   // Keep pipe for back-compat
                   pipe: function( /* fnDone, fnFail, fnProgress */ ) {
                       var fns = arguments;
   
                       return jQuery.Deferred( function( newDefer ) {
                           jQuery.each( tuples, function( _i, tuple ) {
   
                               // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                               var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
   
                               // deferred.progress(function() { bind to newDefer or newDefer.notify })
                               // deferred.done(function() { bind to newDefer or newDefer.resolve })
                               // deferred.fail(function() { bind to newDefer or newDefer.reject })
                               deferred[ tuple[ 1 ] ]( function() {
                                   var returned = fn && fn.apply( this, arguments );
                                   if ( returned && isFunction( returned.promise ) ) {
                                       returned.promise()
                                           .progress( newDefer.notify )
                                           .done( newDefer.resolve )
                                           .fail( newDefer.reject );
                                   } else {
                                       newDefer[ tuple[ 0 ] + "With" ](
                                           this,
                                           fn ? [ returned ] : arguments
                                       );
                                   }
                               } );
                           } );
                           fns = null;
                       } ).promise();
                   },
                   then: function( onFulfilled, onRejected, onProgress ) {
                       var maxDepth = 0;
                       function resolve( depth, deferred, handler, special ) {
                           return function() {
                               var that = this,
                                   args = arguments,
                                   mightThrow = function() {
                                       var returned, then;
   
                                       // Support: Promises/A+ section 2.3.3.3.3
                                       // https://promisesaplus.com/#point-59
                                       // Ignore double-resolution attempts
                                       if ( depth < maxDepth ) {
                                           return;
                                       }
   
                                       returned = handler.apply( that, args );
   
                                       // Support: Promises/A+ section 2.3.1
                                       // https://promisesaplus.com/#point-48
                                       if ( returned === deferred.promise() ) {
                                           throw new TypeError( "Thenable self-resolution" );
                                       }
   
                                       // Support: Promises/A+ sections 2.3.3.1, 3.5
                                       // https://promisesaplus.com/#point-54
                                       // https://promisesaplus.com/#point-75
                                       // Retrieve `then` only once
                                       then = returned &&
   
                                           // Support: Promises/A+ section 2.3.4
                                           // https://promisesaplus.com/#point-64
                                           // Only check objects and functions for thenability
                                           ( typeof returned === "object" ||
                                               typeof returned === "function" ) &&
                                           returned.then;
   
                                       // Handle a returned thenable
                                       if ( isFunction( then ) ) {
   
                                           // Special processors (notify) just wait for resolution
                                           if ( special ) {
                                               then.call(
                                                   returned,
                                                   resolve( maxDepth, deferred, Identity, special ),
                                                   resolve( maxDepth, deferred, Thrower, special )
                                               );
   
                                           // Normal processors (resolve) also hook into progress
                                           } else {
   
                                               // ...and disregard older resolution values
                                               maxDepth++;
   
                                               then.call(
                                                   returned,
                                                   resolve( maxDepth, deferred, Identity, special ),
                                                   resolve( maxDepth, deferred, Thrower, special ),
                                                   resolve( maxDepth, deferred, Identity,
                                                       deferred.notifyWith )
                                               );
                                           }
   
                                       // Handle all other returned values
                                       } else {
   
                                           // Only substitute handlers pass on context
                                           // and multiple values (non-spec behavior)
                                           if ( handler !== Identity ) {
                                               that = undefined;
                                               args = [ returned ];
                                           }
   
                                           // Process the value(s)
                                           // Default process is resolve
                                           ( special || deferred.resolveWith )( that, args );
                                       }
                                   },
   
                                   // Only normal processors (resolve) catch and reject exceptions
                                   process = special ?
                                       mightThrow :
                                       function() {
                                           try {
                                               mightThrow();
                                           } catch ( e ) {
   
                                               if ( jQuery.Deferred.exceptionHook ) {
                                                   jQuery.Deferred.exceptionHook( e,
                                                       process.stackTrace );
                                               }
   
                                               // Support: Promises/A+ section 2.3.3.3.4.1
                                               // https://promisesaplus.com/#point-61
                                               // Ignore post-resolution exceptions
                                               if ( depth + 1 >= maxDepth ) {
   
                                                   // Only substitute handlers pass on context
                                                   // and multiple values (non-spec behavior)
                                                   if ( handler !== Thrower ) {
                                                       that = undefined;
                                                       args = [ e ];
                                                   }
   
                                                   deferred.rejectWith( that, args );
                                               }
                                           }
                                       };
   
                               // Support: Promises/A+ section 2.3.3.3.1
                               // https://promisesaplus.com/#point-57
                               // Re-resolve promises immediately to dodge false rejection from
                               // subsequent errors
                               if ( depth ) {
                                   process();
                               } else {
   
                                   // Call an optional hook to record the stack, in case of exception
                                   // since it's otherwise lost when execution goes async
                                   if ( jQuery.Deferred.getStackHook ) {
                                       process.stackTrace = jQuery.Deferred.getStackHook();
                                   }
                                   window.setTimeout( process );
                               }
                           };
                       }
   
                       return jQuery.Deferred( function( newDefer ) {
   
                           // progress_handlers.add( ... )
                           tuples[ 0 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onProgress ) ?
                                       onProgress :
                                       Identity,
                                   newDefer.notifyWith
                               )
                           );
   
                           // fulfilled_handlers.add( ... )
                           tuples[ 1 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onFulfilled ) ?
                                       onFulfilled :
                                       Identity
                               )
                           );
   
                           // rejected_handlers.add( ... )
                           tuples[ 2 ][ 3 ].add(
                               resolve(
                                   0,
                                   newDefer,
                                   isFunction( onRejected ) ?
                                       onRejected :
                                       Thrower
                               )
                           );
                       } ).promise();
                   },
   
                   // Get a promise for this deferred
                   // If obj is provided, the promise aspect is added to the object
                   promise: function( obj ) {
                       return obj != null ? jQuery.extend( obj, promise ) : promise;
                   }
               },
               deferred = {};
   
           // Add list-specific methods
           jQuery.each( tuples, function( i, tuple ) {
               var list = tuple[ 2 ],
                   stateString = tuple[ 5 ];
   
               // promise.progress = list.add
               // promise.done = list.add
               // promise.fail = list.add
               promise[ tuple[ 1 ] ] = list.add;
   
               // Handle state
               if ( stateString ) {
                   list.add(
                       function() {
   
                           // state = "resolved" (i.e., fulfilled)
                           // state = "rejected"
                           state = stateString;
                       },
   
                       // rejected_callbacks.disable
                       // fulfilled_callbacks.disable
                       tuples[ 3 - i ][ 2 ].disable,
   
                       // rejected_handlers.disable
                       // fulfilled_handlers.disable
                       tuples[ 3 - i ][ 3 ].disable,
   
                       // progress_callbacks.lock
                       tuples[ 0 ][ 2 ].lock,
   
                       // progress_handlers.lock
                       tuples[ 0 ][ 3 ].lock
                   );
               }
   
               // progress_handlers.fire
               // fulfilled_handlers.fire
               // rejected_handlers.fire
               list.add( tuple[ 3 ].fire );
   
               // deferred.notify = function() { deferred.notifyWith(...) }
               // deferred.resolve = function() { deferred.resolveWith(...) }
               // deferred.reject = function() { deferred.rejectWith(...) }
               deferred[ tuple[ 0 ] ] = function() {
                   deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                   return this;
               };
   
               // deferred.notifyWith = list.fireWith
               // deferred.resolveWith = list.fireWith
               // deferred.rejectWith = list.fireWith
               deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
           } );
   
           // Make the deferred a promise
           promise.promise( deferred );
   
           // Call given func if any
           if ( func ) {
               func.call( deferred, deferred );
           }
   
           // All done!
           return deferred;
       },
   
       // Deferred helper
       when: function( singleValue ) {
           var
   
               // count of uncompleted subordinates
               remaining = arguments.length,
   
               // count of unprocessed arguments
               i = remaining,
   
               // subordinate fulfillment data
               resolveContexts = Array( i ),
               resolveValues = slice.call( arguments ),
   
               // the primary Deferred
               primary = jQuery.Deferred(),
   
               // subordinate callback factory
               updateFunc = function( i ) {
                   return function( value ) {
                       resolveContexts[ i ] = this;
                       resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                       if ( !( --remaining ) ) {
                           primary.resolveWith( resolveContexts, resolveValues );
                       }
                   };
               };
   
           // Single- and empty arguments are adopted like Promise.resolve
           if ( remaining <= 1 ) {
               adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
                   !remaining );
   
               // Use .then() to unwrap secondary thenables (cf. gh-3000)
               if ( primary.state() === "pending" ||
                   isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
   
                   return primary.then();
               }
           }
   
           // Multiple arguments are aggregated like Promise.all array elements
           while ( i-- ) {
               adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
           }
   
           return primary.promise();
       }
   } );
   
   
   // These usually indicate a programmer mistake during development,
   // warn about them ASAP rather than swallowing them by default.
   var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
   
   jQuery.Deferred.exceptionHook = function( error, stack ) {
   
       // Support: IE 8 - 9 only
       // Console exists when dev tools are open, which can happen at any time
       if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
           window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
       }
   };
   
   
   
   
   jQuery.readyException = function( error ) {
       window.setTimeout( function() {
           throw error;
       } );
   };
   
   
   
   
   // The deferred used on DOM ready
   var readyList = jQuery.Deferred();
   
   jQuery.fn.ready = function( fn ) {
   
       readyList
           .then( fn )
   
           // Wrap jQuery.readyException in a function so that the lookup
           // happens at the time of error handling instead of callback
           // registration.
           .catch( function( error ) {
               jQuery.readyException( error );
           } );
   
       return this;
   };
   
   jQuery.extend( {
   
       // Is the DOM ready to be used? Set to true once it occurs.
       isReady: false,
   
       // A counter to track how many items to wait for before
       // the ready event fires. See trac-6781
       readyWait: 1,
   
       // Handle when the DOM is ready
       ready: function( wait ) {
   
           // Abort if there are pending holds or we're already ready
           if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
               return;
           }
   
           // Remember that the DOM is ready
           jQuery.isReady = true;
   
           // If a normal DOM Ready event fired, decrement, and wait if need be
           if ( wait !== true && --jQuery.readyWait > 0 ) {
               return;
           }
   
           // If there are functions bound, to execute
           readyList.resolveWith( document, [ jQuery ] );
       }
   } );
   
   jQuery.ready.then = readyList.then;
   
   // The ready event handler and self cleanup method
   function completed() {
       document.removeEventListener( "DOMContentLoaded", completed );
       window.removeEventListener( "load", completed );
       jQuery.ready();
   }
   
   // Catch cases where $(document).ready() is called
   // after the browser event has already occurred.
   // Support: IE <=9 - 10 only
   // Older IE sometimes signals "interactive" too soon
   if ( document.readyState === "complete" ||
       ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
   
       // Handle it asynchronously to allow scripts the opportunity to delay ready
       window.setTimeout( jQuery.ready );
   
   } else {
   
       // Use the handy event callback
       document.addEventListener( "DOMContentLoaded", completed );
   
       // A fallback to window.onload, that will always work
       window.addEventListener( "load", completed );
   }
   
   
   
   
   // Multifunctional method to get and set values of a collection
   // The value/s can optionally be executed if it's a function
   var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
       var i = 0,
           len = elems.length,
           bulk = key == null;
   
       // Sets many values
       if ( toType( key ) === "object" ) {
           chainable = true;
           for ( i in key ) {
               access( elems, fn, i, key[ i ], true, emptyGet, raw );
           }
   
       // Sets one value
       } else if ( value !== undefined ) {
           chainable = true;
   
           if ( !isFunction( value ) ) {
               raw = true;
           }
   
           if ( bulk ) {
   
               // Bulk operations run against the entire set
               if ( raw ) {
                   fn.call( elems, value );
                   fn = null;
   
               // ...except when executing function values
               } else {
                   bulk = fn;
                   fn = function( elem, _key, value ) {
                       return bulk.call( jQuery( elem ), value );
                   };
               }
           }
   
           if ( fn ) {
               for ( ; i < len; i++ ) {
                   fn(
                       elems[ i ], key, raw ?
                           value :
                           value.call( elems[ i ], i, fn( elems[ i ], key ) )
                   );
               }
           }
       }
   
       if ( chainable ) {
           return elems;
       }
   
       // Gets
       if ( bulk ) {
           return fn.call( elems );
       }
   
       return len ? fn( elems[ 0 ], key ) : emptyGet;
   };
   
   
   // Matches dashed string for camelizing
   var rmsPrefix = /^-ms-/,
       rdashAlpha = /-([a-z])/g;
   
   // Used by camelCase as callback to replace()
   function fcamelCase( _all, letter ) {
       return letter.toUpperCase();
   }
   
   // Convert dashed to camelCase; used by the css and data modules
   // Support: IE <=9 - 11, Edge 12 - 15
   // Microsoft forgot to hump their vendor prefix (trac-9572)
   function camelCase( string ) {
       return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
   }
   var acceptData = function( owner ) {
   
       // Accepts only:
       //  - Node
       //    - Node.ELEMENT_NODE
       //    - Node.DOCUMENT_NODE
       //  - Object
       //    - Any
       return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
   };
   
   
   
   
   function Data() {
       this.expando = jQuery.expando + Data.uid++;
   }
   
   Data.uid = 1;
   
   Data.prototype = {
   
       cache: function( owner ) {
   
           // Check if the owner object already has a cache
           var value = owner[ this.expando ];
   
           // If not, create one
           if ( !value ) {
               value = {};
   
               // We can accept data for non-element nodes in modern browsers,
               // but we should not, see trac-8335.
               // Always return an empty object.
               if ( acceptData( owner ) ) {
   
                   // If it is a node unlikely to be stringify-ed or looped over
                   // use plain assignment
                   if ( owner.nodeType ) {
                       owner[ this.expando ] = value;
   
                   // Otherwise secure it in a non-enumerable property
                   // configurable must be true to allow the property to be
                   // deleted when data is removed
                   } else {
                       Object.defineProperty( owner, this.expando, {
                           value: value,
                           configurable: true
                       } );
                   }
               }
           }
   
           return value;
       },
       set: function( owner, data, value ) {
           var prop,
               cache = this.cache( owner );
   
           // Handle: [ owner, key, value ] args
           // Always use camelCase key (gh-2257)
           if ( typeof data === "string" ) {
               cache[ camelCase( data ) ] = value;
   
           // Handle: [ owner, { properties } ] args
           } else {
   
               // Copy the properties one-by-one to the cache object
               for ( prop in data ) {
                   cache[ camelCase( prop ) ] = data[ prop ];
               }
           }
           return cache;
       },
       get: function( owner, key ) {
           return key === undefined ?
               this.cache( owner ) :
   
               // Always use camelCase key (gh-2257)
               owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
       },
       access: function( owner, key, value ) {
   
           // In cases where either:
           //
           //   1. No key was specified
           //   2. A string key was specified, but no value provided
           //
           // Take the "read" path and allow the get method to determine
           // which value to return, respectively either:
           //
           //   1. The entire cache object
           //   2. The data stored at the key
           //
           if ( key === undefined ||
                   ( ( key && typeof key === "string" ) && value === undefined ) ) {
   
               return this.get( owner, key );
           }
   
           // When the key is not a string, or both a key and value
           // are specified, set or extend (existing objects) with either:
           //
           //   1. An object of properties
           //   2. A key and value
           //
           this.set( owner, key, value );
   
           // Since the "set" path can have two possible entry points
           // return the expected data based on which path was taken[*]
           return value !== undefined ? value : key;
       },
       remove: function( owner, key ) {
           var i,
               cache = owner[ this.expando ];
   
           if ( cache === undefined ) {
               return;
           }
   
           if ( key !== undefined ) {
   
               // Support array or space separated string of keys
               if ( Array.isArray( key ) ) {
   
                   // If key is an array of keys...
                   // We always set camelCase keys, so remove that.
                   key = key.map( camelCase );
               } else {
                   key = camelCase( key );
   
                   // If a key with the spaces exists, use it.
                   // Otherwise, create an array by matching non-whitespace
                   key = key in cache ?
                       [ key ] :
                       ( key.match( rnothtmlwhite ) || [] );
               }
   
               i = key.length;
   
               while ( i-- ) {
                   delete cache[ key[ i ] ];
               }
           }
   
           // Remove the expando if there's no more data
           if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
   
               // Support: Chrome <=35 - 45
               // Webkit & Blink performance suffers when deleting properties
               // from DOM nodes, so set to undefined instead
               // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
               if ( owner.nodeType ) {
                   owner[ this.expando ] = undefined;
               } else {
                   delete owner[ this.expando ];
               }
           }
       },
       hasData: function( owner ) {
           var cache = owner[ this.expando ];
           return cache !== undefined && !jQuery.isEmptyObject( cache );
       }
   };
   var dataPriv = new Data();
   
   var dataUser = new Data();
   
   
   
   //	Implementation Summary
   //
   //	1. Enforce API surface and semantic compatibility with 1.9.x branch
   //	2. Improve the module's maintainability by reducing the storage
   //		paths to a single mechanism.
   //	3. Use the same single mechanism to support "private" and "user" data.
   //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
   //	5. Avoid exposing implementation details on user objects (eg. expando properties)
   //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
   
   var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
       rmultiDash = /[A-Z]/g;
   
   function getData( data ) {
       if ( data === "true" ) {
           return true;
       }
   
       if ( data === "false" ) {
           return false;
       }
   
       if ( data === "null" ) {
           return null;
       }
   
       // Only convert to a number if it doesn't change the string
       if ( data === +data + "" ) {
           return +data;
       }
   
       if ( rbrace.test( data ) ) {
           return JSON.parse( data );
       }
   
       return data;
   }
   
   function dataAttr( elem, key, data ) {
       var name;
   
       // If nothing was found internally, try to fetch any
       // data from the HTML5 data-* attribute
       if ( data === undefined && elem.nodeType === 1 ) {
           name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
           data = elem.getAttribute( name );
   
           if ( typeof data === "string" ) {
               try {
                   data = getData( data );
               } catch ( e ) {}
   
               // Make sure we set the data so it isn't changed later
               dataUser.set( elem, key, data );
           } else {
               data = undefined;
           }
       }
       return data;
   }
   
   jQuery.extend( {
       hasData: function( elem ) {
           return dataUser.hasData( elem ) || dataPriv.hasData( elem );
       },
   
       data: function( elem, name, data ) {
           return dataUser.access( elem, name, data );
       },
   
       removeData: function( elem, name ) {
           dataUser.remove( elem, name );
       },
   
       // TODO: Now that all calls to _data and _removeData have been replaced
       // with direct calls to dataPriv methods, these can be deprecated.
       _data: function( elem, name, data ) {
           return dataPriv.access( elem, name, data );
       },
   
       _removeData: function( elem, name ) {
           dataPriv.remove( elem, name );
       }
   } );
   
   jQuery.fn.extend( {
       data: function( key, value ) {
           var i, name, data,
               elem = this[ 0 ],
               attrs = elem && elem.attributes;
   
           // Gets all values
           if ( key === undefined ) {
               if ( this.length ) {
                   data = dataUser.get( elem );
   
                   if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                       i = attrs.length;
                       while ( i-- ) {
   
                           // Support: IE 11 only
                           // The attrs elements can be null (trac-14894)
                           if ( attrs[ i ] ) {
                               name = attrs[ i ].name;
                               if ( name.indexOf( "data-" ) === 0 ) {
                                   name = camelCase( name.slice( 5 ) );
                                   dataAttr( elem, name, data[ name ] );
                               }
                           }
                       }
                       dataPriv.set( elem, "hasDataAttrs", true );
                   }
               }
   
               return data;
           }
   
           // Sets multiple values
           if ( typeof key === "object" ) {
               return this.each( function() {
                   dataUser.set( this, key );
               } );
           }
   
           return access( this, function( value ) {
               var data;
   
               // The calling jQuery object (element matches) is not empty
               // (and therefore has an element appears at this[ 0 ]) and the
               // `value` parameter was not undefined. An empty jQuery object
               // will result in `undefined` for elem = this[ 0 ] which will
               // throw an exception if an attempt to read a data cache is made.
               if ( elem && value === undefined ) {
   
                   // Attempt to get data from the cache
                   // The key will always be camelCased in Data
                   data = dataUser.get( elem, key );
                   if ( data !== undefined ) {
                       return data;
                   }
   
                   // Attempt to "discover" the data in
                   // HTML5 custom data-* attrs
                   data = dataAttr( elem, key );
                   if ( data !== undefined ) {
                       return data;
                   }
   
                   // We tried really hard, but the data doesn't exist.
                   return;
               }
   
               // Set the data...
               this.each( function() {
   
                   // We always store the camelCased key
                   dataUser.set( this, key, value );
               } );
           }, null, value, arguments.length > 1, null, true );
       },
   
       removeData: function( key ) {
           return this.each( function() {
               dataUser.remove( this, key );
           } );
       }
   } );
   
   
   jQuery.extend( {
       queue: function( elem, type, data ) {
           var queue;
   
           if ( elem ) {
               type = ( type || "fx" ) + "queue";
               queue = dataPriv.get( elem, type );
   
               // Speed up dequeue by getting out quickly if this is just a lookup
               if ( data ) {
                   if ( !queue || Array.isArray( data ) ) {
                       queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                   } else {
                       queue.push( data );
                   }
               }
               return queue || [];
           }
       },
   
       dequeue: function( elem, type ) {
           type = type || "fx";
   
           var queue = jQuery.queue( elem, type ),
               startLength = queue.length,
               fn = queue.shift(),
               hooks = jQuery._queueHooks( elem, type ),
               next = function() {
                   jQuery.dequeue( elem, type );
               };
   
           // If the fx queue is dequeued, always remove the progress sentinel
           if ( fn === "inprogress" ) {
               fn = queue.shift();
               startLength--;
           }
   
           if ( fn ) {
   
               // Add a progress sentinel to prevent the fx queue from being
               // automatically dequeued
               if ( type === "fx" ) {
                   queue.unshift( "inprogress" );
               }
   
               // Clear up the last queue stop function
               delete hooks.stop;
               fn.call( elem, next, hooks );
           }
   
           if ( !startLength && hooks ) {
               hooks.empty.fire();
           }
       },
   
       // Not public - generate a queueHooks object, or return the current one
       _queueHooks: function( elem, type ) {
           var key = type + "queueHooks";
           return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
               empty: jQuery.Callbacks( "once memory" ).add( function() {
                   dataPriv.remove( elem, [ type + "queue", key ] );
               } )
           } );
       }
   } );
   
   jQuery.fn.extend( {
       queue: function( type, data ) {
           var setter = 2;
   
           if ( typeof type !== "string" ) {
               data = type;
               type = "fx";
               setter--;
           }
   
           if ( arguments.length < setter ) {
               return jQuery.queue( this[ 0 ], type );
           }
   
           return data === undefined ?
               this :
               this.each( function() {
                   var queue = jQuery.queue( this, type, data );
   
                   // Ensure a hooks for this queue
                   jQuery._queueHooks( this, type );
   
                   if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                       jQuery.dequeue( this, type );
                   }
               } );
       },
       dequeue: function( type ) {
           return this.each( function() {
               jQuery.dequeue( this, type );
           } );
       },
       clearQueue: function( type ) {
           return this.queue( type || "fx", [] );
       },
   
       // Get a promise resolved when queues of a certain type
       // are emptied (fx is the type by default)
       promise: function( type, obj ) {
           var tmp,
               count = 1,
               defer = jQuery.Deferred(),
               elements = this,
               i = this.length,
               resolve = function() {
                   if ( !( --count ) ) {
                       defer.resolveWith( elements, [ elements ] );
                   }
               };
   
           if ( typeof type !== "string" ) {
               obj = type;
               type = undefined;
           }
           type = type || "fx";
   
           while ( i-- ) {
               tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
               if ( tmp && tmp.empty ) {
                   count++;
                   tmp.empty.add( resolve );
               }
           }
           resolve();
           return defer.promise( obj );
       }
   } );
   var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
   
   var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
   
   
   var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
   
   var documentElement = document.documentElement;
   
   
   
       var isAttached = function( elem ) {
               return jQuery.contains( elem.ownerDocument, elem );
           },
           composed = { composed: true };
   
       // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
       // Check attachment across shadow DOM boundaries when possible (gh-3504)
       // Support: iOS 10.0-10.2 only
       // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
       // leading to errors. We need to check for `getRootNode`.
       if ( documentElement.getRootNode ) {
           isAttached = function( elem ) {
               return jQuery.contains( elem.ownerDocument, elem ) ||
                   elem.getRootNode( composed ) === elem.ownerDocument;
           };
       }
   var isHiddenWithinTree = function( elem, el ) {
   
           // isHiddenWithinTree might be called from jQuery#filter function;
           // in that case, element will be second argument
           elem = el || elem;
   
           // Inline style trumps all
           return elem.style.display === "none" ||
               elem.style.display === "" &&
   
               // Otherwise, check computed style
               // Support: Firefox <=43 - 45
               // Disconnected elements can have computed display: none, so first confirm that elem is
               // in the document.
               isAttached( elem ) &&
   
               jQuery.css( elem, "display" ) === "none";
       };
   
   
   
   function adjustCSS( elem, prop, valueParts, tween ) {
       var adjusted, scale,
           maxIterations = 20,
           currentValue = tween ?
               function() {
                   return tween.cur();
               } :
               function() {
                   return jQuery.css( elem, prop, "" );
               },
           initial = currentValue(),
           unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
   
           // Starting value computation is required for potential unit mismatches
           initialInUnit = elem.nodeType &&
               ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
               rcssNum.exec( jQuery.css( elem, prop ) );
   
       if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
   
           // Support: Firefox <=54
           // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
           initial = initial / 2;
   
           // Trust units reported by jQuery.css
           unit = unit || initialInUnit[ 3 ];
   
           // Iteratively approximate from a nonzero starting point
           initialInUnit = +initial || 1;
   
           while ( maxIterations-- ) {
   
               // Evaluate and update our best guess (doubling guesses that zero out).
               // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
               jQuery.style( elem, prop, initialInUnit + unit );
               if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
                   maxIterations = 0;
               }
               initialInUnit = initialInUnit / scale;
   
           }
   
           initialInUnit = initialInUnit * 2;
           jQuery.style( elem, prop, initialInUnit + unit );
   
           // Make sure we update the tween properties later on
           valueParts = valueParts || [];
       }
   
       if ( valueParts ) {
           initialInUnit = +initialInUnit || +initial || 0;
   
           // Apply relative offset (+=/-=) if specified
           adjusted = valueParts[ 1 ] ?
               initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
               +valueParts[ 2 ];
           if ( tween ) {
               tween.unit = unit;
               tween.start = initialInUnit;
               tween.end = adjusted;
           }
       }
       return adjusted;
   }
   
   
   var defaultDisplayMap = {};
   
   function getDefaultDisplay( elem ) {
       var temp,
           doc = elem.ownerDocument,
           nodeName = elem.nodeName,
           display = defaultDisplayMap[ nodeName ];
   
       if ( display ) {
           return display;
       }
   
       temp = doc.body.appendChild( doc.createElement( nodeName ) );
       display = jQuery.css( temp, "display" );
   
       temp.parentNode.removeChild( temp );
   
       if ( display === "none" ) {
           display = "block";
       }
       defaultDisplayMap[ nodeName ] = display;
   
       return display;
   }
   
   function showHide( elements, show ) {
       var display, elem,
           values = [],
           index = 0,
           length = elements.length;
   
       // Determine new display value for elements that need to change
       for ( ; index < length; index++ ) {
           elem = elements[ index ];
           if ( !elem.style ) {
               continue;
           }
   
           display = elem.style.display;
           if ( show ) {
   
               // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
               // check is required in this first loop unless we have a nonempty display value (either
               // inline or about-to-be-restored)
               if ( display === "none" ) {
                   values[ index ] = dataPriv.get( elem, "display" ) || null;
                   if ( !values[ index ] ) {
                       elem.style.display = "";
                   }
               }
               if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                   values[ index ] = getDefaultDisplay( elem );
               }
           } else {
               if ( display !== "none" ) {
                   values[ index ] = "none";
   
                   // Remember what we're overwriting
                   dataPriv.set( elem, "display", display );
               }
           }
       }
   
       // Set the display of the elements in a second loop to avoid constant reflow
       for ( index = 0; index < length; index++ ) {
           if ( values[ index ] != null ) {
               elements[ index ].style.display = values[ index ];
           }
       }
   
       return elements;
   }
   
   jQuery.fn.extend( {
       show: function() {
           return showHide( this, true );
       },
       hide: function() {
           return showHide( this );
       },
       toggle: function( state ) {
           if ( typeof state === "boolean" ) {
               return state ? this.show() : this.hide();
           }
   
           return this.each( function() {
               if ( isHiddenWithinTree( this ) ) {
                   jQuery( this ).show();
               } else {
                   jQuery( this ).hide();
               }
           } );
       }
   } );
   var rcheckableType = ( /^(?:checkbox|radio)$/i );
   
   var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
   
   var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
   
   
   
   ( function() {
       var fragment = document.createDocumentFragment(),
           div = fragment.appendChild( document.createElement( "div" ) ),
           input = document.createElement( "input" );
   
       // Support: Android 4.0 - 4.3 only
       // Check state lost if the name is set (trac-11217)
       // Support: Windows Web Apps (WWA)
       // `name` and `type` must use .setAttribute for WWA (trac-14901)
       input.setAttribute( "type", "radio" );
       input.setAttribute( "checked", "checked" );
       input.setAttribute( "name", "t" );
   
       div.appendChild( input );
   
       // Support: Android <=4.1 only
       // Older WebKit doesn't clone checked state correctly in fragments
       support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
   
       // Support: IE <=11 only
       // Make sure textarea (and checkbox) defaultValue is properly cloned
       div.innerHTML = "<textarea>x</textarea>";
       support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
   
       // Support: IE <=9 only
       // IE <=9 replaces <option> tags with their contents when inserted outside of
       // the select element.
       div.innerHTML = "<option></option>";
       support.option = !!div.lastChild;
   } )();
   
   
   // We have to close these tags to support XHTML (trac-13200)
   var wrapMap = {
   
       // XHTML parsers do not magically insert elements in the
       // same way that tag soup parsers do. So we cannot shorten
       // this by omitting <tbody> or other required elements.
       thead: [ 1, "<table>", "</table>" ],
       col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
       tr: [ 2, "<table><tbody>", "</tbody></table>" ],
       td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
   
       _default: [ 0, "", "" ]
   };
   
   wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
   wrapMap.th = wrapMap.td;
   
   // Support: IE <=9 only
   if ( !support.option ) {
       wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
   }
   
   
   function getAll( context, tag ) {
   
       // Support: IE <=9 - 11 only
       // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
       var ret;
   
       if ( typeof context.getElementsByTagName !== "undefined" ) {
           ret = context.getElementsByTagName( tag || "*" );
   
       } else if ( typeof context.querySelectorAll !== "undefined" ) {
           ret = context.querySelectorAll( tag || "*" );
   
       } else {
           ret = [];
       }
   
       if ( tag === undefined || tag && nodeName( context, tag ) ) {
           return jQuery.merge( [ context ], ret );
       }
   
       return ret;
   }
   
   
   // Mark scripts as having already been evaluated
   function setGlobalEval( elems, refElements ) {
       var i = 0,
           l = elems.length;
   
       for ( ; i < l; i++ ) {
           dataPriv.set(
               elems[ i ],
               "globalEval",
               !refElements || dataPriv.get( refElements[ i ], "globalEval" )
           );
       }
   }
   
   
   var rhtml = /<|&#?\w+;/;
   
   function buildFragment( elems, context, scripts, selection, ignored ) {
       var elem, tmp, tag, wrap, attached, j,
           fragment = context.createDocumentFragment(),
           nodes = [],
           i = 0,
           l = elems.length;
   
       for ( ; i < l; i++ ) {
           elem = elems[ i ];
   
           if ( elem || elem === 0 ) {
   
               // Add nodes directly
               if ( toType( elem ) === "object" ) {
   
                   // Support: Android <=4.0 only, PhantomJS 1 only
                   // push.apply(_, arraylike) throws on ancient WebKit
                   jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
   
               // Convert non-html into a text node
               } else if ( !rhtml.test( elem ) ) {
                   nodes.push( context.createTextNode( elem ) );
   
               // Convert html into DOM nodes
               } else {
                   tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
   
                   // Deserialize a standard representation
                   tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                   wrap = wrapMap[ tag ] || wrapMap._default;
                   tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
   
                   // Descend through wrappers to the right content
                   j = wrap[ 0 ];
                   while ( j-- ) {
                       tmp = tmp.lastChild;
                   }
   
                   // Support: Android <=4.0 only, PhantomJS 1 only
                   // push.apply(_, arraylike) throws on ancient WebKit
                   jQuery.merge( nodes, tmp.childNodes );
   
                   // Remember the top-level container
                   tmp = fragment.firstChild;
   
                   // Ensure the created nodes are orphaned (trac-12392)
                   tmp.textContent = "";
               }
           }
       }
   
       // Remove wrapper from fragment
       fragment.textContent = "";
   
       i = 0;
       while ( ( elem = nodes[ i++ ] ) ) {
   
           // Skip elements already in the context collection (trac-4087)
           if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
               if ( ignored ) {
                   ignored.push( elem );
               }
               continue;
           }
   
           attached = isAttached( elem );
   
           // Append to fragment
           tmp = getAll( fragment.appendChild( elem ), "script" );
   
           // Preserve script evaluation history
           if ( attached ) {
               setGlobalEval( tmp );
           }
   
           // Capture executables
           if ( scripts ) {
               j = 0;
               while ( ( elem = tmp[ j++ ] ) ) {
                   if ( rscriptType.test( elem.type || "" ) ) {
                       scripts.push( elem );
                   }
               }
           }
       }
   
       return fragment;
   }
   
   
   var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
   
   function returnTrue() {
       return true;
   }
   
   function returnFalse() {
       return false;
   }
   
   // Support: IE <=9 - 11+
   // focus() and blur() are asynchronous, except when they are no-op.
   // So expect focus to be synchronous when the element is already active,
   // and blur to be synchronous when the element is not already active.
   // (focus and blur are always synchronous in other supported browsers,
   // this just defines when we can count on it).
   function expectSync( elem, type ) {
       return ( elem === safeActiveElement() ) === ( type === "focus" );
   }
   
   // Support: IE <=9 only
   // Accessing document.activeElement can throw unexpectedly
   // https://bugs.jquery.com/ticket/13393
   function safeActiveElement() {
       try {
           return document.activeElement;
       } catch ( err ) { }
   }
   
   function on( elem, types, selector, data, fn, one ) {
       var origFn, type;
   
       // Types can be a map of types/handlers
       if ( typeof types === "object" ) {
   
           // ( types-Object, selector, data )
           if ( typeof selector !== "string" ) {
   
               // ( types-Object, data )
               data = data || selector;
               selector = undefined;
           }
           for ( type in types ) {
               on( elem, type, selector, data, types[ type ], one );
           }
           return elem;
       }
   
       if ( data == null && fn == null ) {
   
           // ( types, fn )
           fn = selector;
           data = selector = undefined;
       } else if ( fn == null ) {
           if ( typeof selector === "string" ) {
   
               // ( types, selector, fn )
               fn = data;
               data = undefined;
           } else {
   
               // ( types, data, fn )
               fn = data;
               data = selector;
               selector = undefined;
           }
       }
       if ( fn === false ) {
           fn = returnFalse;
       } else if ( !fn ) {
           return elem;
       }
   
       if ( one === 1 ) {
           origFn = fn;
           fn = function( event ) {
   
               // Can use an empty set, since event contains the info
               jQuery().off( event );
               return origFn.apply( this, arguments );
           };
   
           // Use same guid so caller can remove using origFn
           fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
       }
       return elem.each( function() {
           jQuery.event.add( this, types, fn, data, selector );
       } );
   }
   
   /*
    * Helper functions for managing events -- not part of the public interface.
    * Props to Dean Edwards' addEvent library for many of the ideas.
    */
   jQuery.event = {
   
       global: {},
   
       add: function( elem, types, handler, data, selector ) {
   
           var handleObjIn, eventHandle, tmp,
               events, t, handleObj,
               special, handlers, type, namespaces, origType,
               elemData = dataPriv.get( elem );
   
           // Only attach events to objects that accept data
           if ( !acceptData( elem ) ) {
               return;
           }
   
           // Caller can pass in an object of custom data in lieu of the handler
           if ( handler.handler ) {
               handleObjIn = handler;
               handler = handleObjIn.handler;
               selector = handleObjIn.selector;
           }
   
           // Ensure that invalid selectors throw exceptions at attach time
           // Evaluate against documentElement in case elem is a non-element node (e.g., document)
           if ( selector ) {
               jQuery.find.matchesSelector( documentElement, selector );
           }
   
           // Make sure that the handler has a unique ID, used to find/remove it later
           if ( !handler.guid ) {
               handler.guid = jQuery.guid++;
           }
   
           // Init the element's event structure and main handler, if this is the first
           if ( !( events = elemData.events ) ) {
               events = elemData.events = Object.create( null );
           }
           if ( !( eventHandle = elemData.handle ) ) {
               eventHandle = elemData.handle = function( e ) {
   
                   // Discard the second event of a jQuery.event.trigger() and
                   // when an event is called after a page has unloaded
                   return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                       jQuery.event.dispatch.apply( elem, arguments ) : undefined;
               };
           }
   
           // Handle multiple events separated by a space
           types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
           t = types.length;
           while ( t-- ) {
               tmp = rtypenamespace.exec( types[ t ] ) || [];
               type = origType = tmp[ 1 ];
               namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
               // There *must* be a type, no attaching namespace-only handlers
               if ( !type ) {
                   continue;
               }
   
               // If event changes its type, use the special event handlers for the changed type
               special = jQuery.event.special[ type ] || {};
   
               // If selector defined, determine special event api type, otherwise given type
               type = ( selector ? special.delegateType : special.bindType ) || type;
   
               // Update special based on newly reset type
               special = jQuery.event.special[ type ] || {};
   
               // handleObj is passed to all event handlers
               handleObj = jQuery.extend( {
                   type: type,
                   origType: origType,
                   data: data,
                   handler: handler,
                   guid: handler.guid,
                   selector: selector,
                   needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                   namespace: namespaces.join( "." )
               }, handleObjIn );
   
               // Init the event handler queue if we're the first
               if ( !( handlers = events[ type ] ) ) {
                   handlers = events[ type ] = [];
                   handlers.delegateCount = 0;
   
                   // Only use addEventListener if the special events handler returns false
                   if ( !special.setup ||
                       special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
   
                       if ( elem.addEventListener ) {
                           elem.addEventListener( type, eventHandle );
                       }
                   }
               }
   
               if ( special.add ) {
                   special.add.call( elem, handleObj );
   
                   if ( !handleObj.handler.guid ) {
                       handleObj.handler.guid = handler.guid;
                   }
               }
   
               // Add to the element's handler list, delegates in front
               if ( selector ) {
                   handlers.splice( handlers.delegateCount++, 0, handleObj );
               } else {
                   handlers.push( handleObj );
               }
   
               // Keep track of which events have ever been used, for event optimization
               jQuery.event.global[ type ] = true;
           }
   
       },
   
       // Detach an event or set of events from an element
       remove: function( elem, types, handler, selector, mappedTypes ) {
   
           var j, origCount, tmp,
               events, t, handleObj,
               special, handlers, type, namespaces, origType,
               elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
   
           if ( !elemData || !( events = elemData.events ) ) {
               return;
           }
   
           // Once for each type.namespace in types; type may be omitted
           types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
           t = types.length;
           while ( t-- ) {
               tmp = rtypenamespace.exec( types[ t ] ) || [];
               type = origType = tmp[ 1 ];
               namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
               // Unbind all events (on this namespace, if provided) for the element
               if ( !type ) {
                   for ( type in events ) {
                       jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                   }
                   continue;
               }
   
               special = jQuery.event.special[ type ] || {};
               type = ( selector ? special.delegateType : special.bindType ) || type;
               handlers = events[ type ] || [];
               tmp = tmp[ 2 ] &&
                   new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
   
               // Remove matching events
               origCount = j = handlers.length;
               while ( j-- ) {
                   handleObj = handlers[ j ];
   
                   if ( ( mappedTypes || origType === handleObj.origType ) &&
                       ( !handler || handler.guid === handleObj.guid ) &&
                       ( !tmp || tmp.test( handleObj.namespace ) ) &&
                       ( !selector || selector === handleObj.selector ||
                           selector === "**" && handleObj.selector ) ) {
                       handlers.splice( j, 1 );
   
                       if ( handleObj.selector ) {
                           handlers.delegateCount--;
                       }
                       if ( special.remove ) {
                           special.remove.call( elem, handleObj );
                       }
                   }
               }
   
               // Remove generic event handler if we removed something and no more handlers exist
               // (avoids potential for endless recursion during removal of special event handlers)
               if ( origCount && !handlers.length ) {
                   if ( !special.teardown ||
                       special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
   
                       jQuery.removeEvent( elem, type, elemData.handle );
                   }
   
                   delete events[ type ];
               }
           }
   
           // Remove data and the expando if it's no longer used
           if ( jQuery.isEmptyObject( events ) ) {
               dataPriv.remove( elem, "handle events" );
           }
       },
   
       dispatch: function( nativeEvent ) {
   
           var i, j, ret, matched, handleObj, handlerQueue,
               args = new Array( arguments.length ),
   
               // Make a writable jQuery.Event from the native event object
               event = jQuery.event.fix( nativeEvent ),
   
               handlers = (
                   dataPriv.get( this, "events" ) || Object.create( null )
               )[ event.type ] || [],
               special = jQuery.event.special[ event.type ] || {};
   
           // Use the fix-ed jQuery.Event rather than the (read-only) native event
           args[ 0 ] = event;
   
           for ( i = 1; i < arguments.length; i++ ) {
               args[ i ] = arguments[ i ];
           }
   
           event.delegateTarget = this;
   
           // Call the preDispatch hook for the mapped type, and let it bail if desired
           if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
               return;
           }
   
           // Determine handlers
           handlerQueue = jQuery.event.handlers.call( this, event, handlers );
   
           // Run delegates first; they may want to stop propagation beneath us
           i = 0;
           while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
               event.currentTarget = matched.elem;
   
               j = 0;
               while ( ( handleObj = matched.handlers[ j++ ] ) &&
                   !event.isImmediatePropagationStopped() ) {
   
                   // If the event is namespaced, then each handler is only invoked if it is
                   // specially universal or its namespaces are a superset of the event's.
                   if ( !event.rnamespace || handleObj.namespace === false ||
                       event.rnamespace.test( handleObj.namespace ) ) {
   
                       event.handleObj = handleObj;
                       event.data = handleObj.data;
   
                       ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                           handleObj.handler ).apply( matched.elem, args );
   
                       if ( ret !== undefined ) {
                           if ( ( event.result = ret ) === false ) {
                               event.preventDefault();
                               event.stopPropagation();
                           }
                       }
                   }
               }
           }
   
           // Call the postDispatch hook for the mapped type
           if ( special.postDispatch ) {
               special.postDispatch.call( this, event );
           }
   
           return event.result;
       },
   
       handlers: function( event, handlers ) {
           var i, handleObj, sel, matchedHandlers, matchedSelectors,
               handlerQueue = [],
               delegateCount = handlers.delegateCount,
               cur = event.target;
   
           // Find delegate handlers
           if ( delegateCount &&
   
               // Support: IE <=9
               // Black-hole SVG <use> instance trees (trac-13180)
               cur.nodeType &&
   
               // Support: Firefox <=42
               // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
               // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
               // Support: IE 11 only
               // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
               !( event.type === "click" && event.button >= 1 ) ) {
   
               for ( ; cur !== this; cur = cur.parentNode || this ) {
   
                   // Don't check non-elements (trac-13208)
                   // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                   if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                       matchedHandlers = [];
                       matchedSelectors = {};
                       for ( i = 0; i < delegateCount; i++ ) {
                           handleObj = handlers[ i ];
   
                           // Don't conflict with Object.prototype properties (trac-13203)
                           sel = handleObj.selector + " ";
   
                           if ( matchedSelectors[ sel ] === undefined ) {
                               matchedSelectors[ sel ] = handleObj.needsContext ?
                                   jQuery( sel, this ).index( cur ) > -1 :
                                   jQuery.find( sel, this, null, [ cur ] ).length;
                           }
                           if ( matchedSelectors[ sel ] ) {
                               matchedHandlers.push( handleObj );
                           }
                       }
                       if ( matchedHandlers.length ) {
                           handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                       }
                   }
               }
           }
   
           // Add the remaining (directly-bound) handlers
           cur = this;
           if ( delegateCount < handlers.length ) {
               handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
           }
   
           return handlerQueue;
       },
   
       addProp: function( name, hook ) {
           Object.defineProperty( jQuery.Event.prototype, name, {
               enumerable: true,
               configurable: true,
   
               get: isFunction( hook ) ?
                   function() {
                       if ( this.originalEvent ) {
                           return hook( this.originalEvent );
                       }
                   } :
                   function() {
                       if ( this.originalEvent ) {
                           return this.originalEvent[ name ];
                       }
                   },
   
               set: function( value ) {
                   Object.defineProperty( this, name, {
                       enumerable: true,
                       configurable: true,
                       writable: true,
                       value: value
                   } );
               }
           } );
       },
   
       fix: function( originalEvent ) {
           return originalEvent[ jQuery.expando ] ?
               originalEvent :
               new jQuery.Event( originalEvent );
       },
   
       special: {
           load: {
   
               // Prevent triggered image.load events from bubbling to window.load
               noBubble: true
           },
           click: {
   
               // Utilize native event to ensure correct state for checkable inputs
               setup: function( data ) {
   
                   // For mutual compressibility with _default, replace `this` access with a local var.
                   // `|| data` is dead code meant only to preserve the variable through minification.
                   var el = this || data;
   
                   // Claim the first handler
                   if ( rcheckableType.test( el.type ) &&
                       el.click && nodeName( el, "input" ) ) {
   
                       // dataPriv.set( el, "click", ... )
                       leverageNative( el, "click", returnTrue );
                   }
   
                   // Return false to allow normal processing in the caller
                   return false;
               },
               trigger: function( data ) {
   
                   // For mutual compressibility with _default, replace `this` access with a local var.
                   // `|| data` is dead code meant only to preserve the variable through minification.
                   var el = this || data;
   
                   // Force setup before triggering a click
                   if ( rcheckableType.test( el.type ) &&
                       el.click && nodeName( el, "input" ) ) {
   
                       leverageNative( el, "click" );
                   }
   
                   // Return non-false to allow normal event-path propagation
                   return true;
               },
   
               // For cross-browser consistency, suppress native .click() on links
               // Also prevent it if we're currently inside a leveraged native-event stack
               _default: function( event ) {
                   var target = event.target;
                   return rcheckableType.test( target.type ) &&
                       target.click && nodeName( target, "input" ) &&
                       dataPriv.get( target, "click" ) ||
                       nodeName( target, "a" );
               }
           },
   
           beforeunload: {
               postDispatch: function( event ) {
   
                   // Support: Firefox 20+
                   // Firefox doesn't alert if the returnValue field is not set.
                   if ( event.result !== undefined && event.originalEvent ) {
                       event.originalEvent.returnValue = event.result;
                   }
               }
           }
       }
   };
   
   // Ensure the presence of an event listener that handles manually-triggered
   // synthetic events by interrupting progress until reinvoked in response to
   // *native* events that it fires directly, ensuring that state changes have
   // already occurred before other listeners are invoked.
   function leverageNative( el, type, expectSync ) {
   
       // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
       if ( !expectSync ) {
           if ( dataPriv.get( el, type ) === undefined ) {
               jQuery.event.add( el, type, returnTrue );
           }
           return;
       }
   
       // Register the controller as a special universal handler for all event namespaces
       dataPriv.set( el, type, false );
       jQuery.event.add( el, type, {
           namespace: false,
           handler: function( event ) {
               var notAsync, result,
                   saved = dataPriv.get( this, type );
   
               if ( ( event.isTrigger & 1 ) && this[ type ] ) {
   
                   // Interrupt processing of the outer synthetic .trigger()ed event
                   // Saved data should be false in such cases, but might be a leftover capture object
                   // from an async native handler (gh-4350)
                   if ( !saved.length ) {
   
                       // Store arguments for use when handling the inner native event
                       // There will always be at least one argument (an event object), so this array
                       // will not be confused with a leftover capture object.
                       saved = slice.call( arguments );
                       dataPriv.set( this, type, saved );
   
                       // Trigger the native event and capture its result
                       // Support: IE <=9 - 11+
                       // focus() and blur() are asynchronous
                       notAsync = expectSync( this, type );
                       this[ type ]();
                       result = dataPriv.get( this, type );
                       if ( saved !== result || notAsync ) {
                           dataPriv.set( this, type, false );
                       } else {
                           result = {};
                       }
                       if ( saved !== result ) {
   
                           // Cancel the outer synthetic event
                           event.stopImmediatePropagation();
                           event.preventDefault();
   
                           // Support: Chrome 86+
                           // In Chrome, if an element having a focusout handler is blurred by
                           // clicking outside of it, it invokes the handler synchronously. If
                           // that handler calls `.remove()` on the element, the data is cleared,
                           // leaving `result` undefined. We need to guard against this.
                           return result && result.value;
                       }
   
                   // If this is an inner synthetic event for an event with a bubbling surrogate
                   // (focus or blur), assume that the surrogate already propagated from triggering the
                   // native event and prevent that from happening again here.
                   // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                   // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                   // less bad than duplication.
                   } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
                       event.stopPropagation();
                   }
   
               // If this is a native event triggered above, everything is now in order
               // Fire an inner synthetic event with the original arguments
               } else if ( saved.length ) {
   
                   // ...and capture the result
                   dataPriv.set( this, type, {
                       value: jQuery.event.trigger(
   
                           // Support: IE <=9 - 11+
                           // Extend with the prototype to reset the above stopImmediatePropagation()
                           jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
                           saved.slice( 1 ),
                           this
                       )
                   } );
   
                   // Abort handling of the native event
                   event.stopImmediatePropagation();
               }
           }
       } );
   }
   
   jQuery.removeEvent = function( elem, type, handle ) {
   
       // This "if" is needed for plain objects
       if ( elem.removeEventListener ) {
           elem.removeEventListener( type, handle );
       }
   };
   
   jQuery.Event = function( src, props ) {
   
       // Allow instantiation without the 'new' keyword
       if ( !( this instanceof jQuery.Event ) ) {
           return new jQuery.Event( src, props );
       }
   
       // Event object
       if ( src && src.type ) {
           this.originalEvent = src;
           this.type = src.type;
   
           // Events bubbling up the document may have been marked as prevented
           // by a handler lower down the tree; reflect the correct value.
           this.isDefaultPrevented = src.defaultPrevented ||
                   src.defaultPrevented === undefined &&
   
                   // Support: Android <=2.3 only
                   src.returnValue === false ?
               returnTrue :
               returnFalse;
   
           // Create target properties
           // Support: Safari <=6 - 7 only
           // Target should not be a text node (trac-504, trac-13143)
           this.target = ( src.target && src.target.nodeType === 3 ) ?
               src.target.parentNode :
               src.target;
   
           this.currentTarget = src.currentTarget;
           this.relatedTarget = src.relatedTarget;
   
       // Event type
       } else {
           this.type = src;
       }
   
       // Put explicitly provided properties onto the event object
       if ( props ) {
           jQuery.extend( this, props );
       }
   
       // Create a timestamp if incoming event doesn't have one
       this.timeStamp = src && src.timeStamp || Date.now();
   
       // Mark it as fixed
       this[ jQuery.expando ] = true;
   };
   
   // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
   // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
   jQuery.Event.prototype = {
       constructor: jQuery.Event,
       isDefaultPrevented: returnFalse,
       isPropagationStopped: returnFalse,
       isImmediatePropagationStopped: returnFalse,
       isSimulated: false,
   
       preventDefault: function() {
           var e = this.originalEvent;
   
           this.isDefaultPrevented = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.preventDefault();
           }
       },
       stopPropagation: function() {
           var e = this.originalEvent;
   
           this.isPropagationStopped = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.stopPropagation();
           }
       },
       stopImmediatePropagation: function() {
           var e = this.originalEvent;
   
           this.isImmediatePropagationStopped = returnTrue;
   
           if ( e && !this.isSimulated ) {
               e.stopImmediatePropagation();
           }
   
           this.stopPropagation();
       }
   };
   
   // Includes all common event props including KeyEvent and MouseEvent specific props
   jQuery.each( {
       altKey: true,
       bubbles: true,
       cancelable: true,
       changedTouches: true,
       ctrlKey: true,
       detail: true,
       eventPhase: true,
       metaKey: true,
       pageX: true,
       pageY: true,
       shiftKey: true,
       view: true,
       "char": true,
       code: true,
       charCode: true,
       key: true,
       keyCode: true,
       button: true,
       buttons: true,
       clientX: true,
       clientY: true,
       offsetX: true,
       offsetY: true,
       pointerId: true,
       pointerType: true,
       screenX: true,
       screenY: true,
       targetTouches: true,
       toElement: true,
       touches: true,
       which: true
   }, jQuery.event.addProp );
   
   jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
       jQuery.event.special[ type ] = {
   
           // Utilize native event if possible so blur/focus sequence is correct
           setup: function() {
   
               // Claim the first handler
               // dataPriv.set( this, "focus", ... )
               // dataPriv.set( this, "blur", ... )
               leverageNative( this, type, expectSync );
   
               // Return false to allow normal processing in the caller
               return false;
           },
           trigger: function() {
   
               // Force setup before trigger
               leverageNative( this, type );
   
               // Return non-false to allow normal event-path propagation
               return true;
           },
   
           // Suppress native focus or blur if we're currently inside
           // a leveraged native-event stack
           _default: function( event ) {
               return dataPriv.get( event.target, type );
           },
   
           delegateType: delegateType
       };
   } );
   
   // Create mouseenter/leave events using mouseover/out and event-time checks
   // so that event delegation works in jQuery.
   // Do the same for pointerenter/pointerleave and pointerover/pointerout
   //
   // Support: Safari 7 only
   // Safari sends mouseenter too often; see:
   // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
   // for the description of the bug (it existed in older Chrome versions as well).
   jQuery.each( {
       mouseenter: "mouseover",
       mouseleave: "mouseout",
       pointerenter: "pointerover",
       pointerleave: "pointerout"
   }, function( orig, fix ) {
       jQuery.event.special[ orig ] = {
           delegateType: fix,
           bindType: fix,
   
           handle: function( event ) {
               var ret,
                   target = this,
                   related = event.relatedTarget,
                   handleObj = event.handleObj;
   
               // For mouseenter/leave call the handler if related is outside the target.
               // NB: No relatedTarget if the mouse left/entered the browser window
               if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                   event.type = handleObj.origType;
                   ret = handleObj.handler.apply( this, arguments );
                   event.type = fix;
               }
               return ret;
           }
       };
   } );
   
   jQuery.fn.extend( {
   
       on: function( types, selector, data, fn ) {
           return on( this, types, selector, data, fn );
       },
       one: function( types, selector, data, fn ) {
           return on( this, types, selector, data, fn, 1 );
       },
       off: function( types, selector, fn ) {
           var handleObj, type;
           if ( types && types.preventDefault && types.handleObj ) {
   
               // ( event )  dispatched jQuery.Event
               handleObj = types.handleObj;
               jQuery( types.delegateTarget ).off(
                   handleObj.namespace ?
                       handleObj.origType + "." + handleObj.namespace :
                       handleObj.origType,
                   handleObj.selector,
                   handleObj.handler
               );
               return this;
           }
           if ( typeof types === "object" ) {
   
               // ( types-object [, selector] )
               for ( type in types ) {
                   this.off( type, selector, types[ type ] );
               }
               return this;
           }
           if ( selector === false || typeof selector === "function" ) {
   
               // ( types [, fn] )
               fn = selector;
               selector = undefined;
           }
           if ( fn === false ) {
               fn = returnFalse;
           }
           return this.each( function() {
               jQuery.event.remove( this, types, fn, selector );
           } );
       }
   } );
   
   
   var
   
       // Support: IE <=10 - 11, Edge 12 - 13 only
       // In IE/Edge using regex groups here causes severe slowdowns.
       // See https://connect.microsoft.com/IE/feedback/details/1736512/
       rnoInnerhtml = /<script|<style|<link/i,
   
       // checked="checked" or checked
       rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
   
       rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
   
   // Prefer a tbody over its parent table for containing new rows
   function manipulationTarget( elem, content ) {
       if ( nodeName( elem, "table" ) &&
           nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
   
           return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
       }
   
       return elem;
   }
   
   // Replace/restore the type attribute of script elements for safe DOM manipulation
   function disableScript( elem ) {
       elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
       return elem;
   }
   function restoreScript( elem ) {
       if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
           elem.type = elem.type.slice( 5 );
       } else {
           elem.removeAttribute( "type" );
       }
   
       return elem;
   }
   
   function cloneCopyEvent( src, dest ) {
       var i, l, type, pdataOld, udataOld, udataCur, events;
   
       if ( dest.nodeType !== 1 ) {
           return;
       }
   
       // 1. Copy private data: events, handlers, etc.
       if ( dataPriv.hasData( src ) ) {
           pdataOld = dataPriv.get( src );
           events = pdataOld.events;
   
           if ( events ) {
               dataPriv.remove( dest, "handle events" );
   
               for ( type in events ) {
                   for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                       jQuery.event.add( dest, type, events[ type ][ i ] );
                   }
               }
           }
       }
   
       // 2. Copy user data
       if ( dataUser.hasData( src ) ) {
           udataOld = dataUser.access( src );
           udataCur = jQuery.extend( {}, udataOld );
   
           dataUser.set( dest, udataCur );
       }
   }
   
   // Fix IE bugs, see support tests
   function fixInput( src, dest ) {
       var nodeName = dest.nodeName.toLowerCase();
   
       // Fails to persist the checked state of a cloned checkbox or radio button.
       if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
           dest.checked = src.checked;
   
       // Fails to return the selected option to the default selected state when cloning options
       } else if ( nodeName === "input" || nodeName === "textarea" ) {
           dest.defaultValue = src.defaultValue;
       }
   }
   
   function domManip( collection, args, callback, ignored ) {
   
       // Flatten any nested arrays
       args = flat( args );
   
       var fragment, first, scripts, hasScripts, node, doc,
           i = 0,
           l = collection.length,
           iNoClone = l - 1,
           value = args[ 0 ],
           valueIsFunction = isFunction( value );
   
       // We can't cloneNode fragments that contain checked, in WebKit
       if ( valueIsFunction ||
               ( l > 1 && typeof value === "string" &&
                   !support.checkClone && rchecked.test( value ) ) ) {
           return collection.each( function( index ) {
               var self = collection.eq( index );
               if ( valueIsFunction ) {
                   args[ 0 ] = value.call( this, index, self.html() );
               }
               domManip( self, args, callback, ignored );
           } );
       }
   
       if ( l ) {
           fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
           first = fragment.firstChild;
   
           if ( fragment.childNodes.length === 1 ) {
               fragment = first;
           }
   
           // Require either new content or an interest in ignored elements to invoke the callback
           if ( first || ignored ) {
               scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
               hasScripts = scripts.length;
   
               // Use the original fragment for the last item
               // instead of the first because it can end up
               // being emptied incorrectly in certain situations (trac-8070).
               for ( ; i < l; i++ ) {
                   node = fragment;
   
                   if ( i !== iNoClone ) {
                       node = jQuery.clone( node, true, true );
   
                       // Keep references to cloned scripts for later restoration
                       if ( hasScripts ) {
   
                           // Support: Android <=4.0 only, PhantomJS 1 only
                           // push.apply(_, arraylike) throws on ancient WebKit
                           jQuery.merge( scripts, getAll( node, "script" ) );
                       }
                   }
   
                   callback.call( collection[ i ], node, i );
               }
   
               if ( hasScripts ) {
                   doc = scripts[ scripts.length - 1 ].ownerDocument;
   
                   // Reenable scripts
                   jQuery.map( scripts, restoreScript );
   
                   // Evaluate executable scripts on first document insertion
                   for ( i = 0; i < hasScripts; i++ ) {
                       node = scripts[ i ];
                       if ( rscriptType.test( node.type || "" ) &&
                           !dataPriv.access( node, "globalEval" ) &&
                           jQuery.contains( doc, node ) ) {
   
                           if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
   
                               // Optional AJAX dependency, but won't run scripts if not present
                               if ( jQuery._evalUrl && !node.noModule ) {
                                   jQuery._evalUrl( node.src, {
                                       nonce: node.nonce || node.getAttribute( "nonce" )
                                   }, doc );
                               }
                           } else {
   
                               // Unwrap a CDATA section containing script contents. This shouldn't be
                               // needed as in XML documents they're already not visible when
                               // inspecting element contents and in HTML documents they have no
                               // meaning but we're preserving that logic for backwards compatibility.
                               // This will be removed completely in 4.0. See gh-4904.
                               DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
                           }
                       }
                   }
               }
           }
       }
   
       return collection;
   }
   
   function remove( elem, selector, keepData ) {
       var node,
           nodes = selector ? jQuery.filter( selector, elem ) : elem,
           i = 0;
   
       for ( ; ( node = nodes[ i ] ) != null; i++ ) {
           if ( !keepData && node.nodeType === 1 ) {
               jQuery.cleanData( getAll( node ) );
           }
   
           if ( node.parentNode ) {
               if ( keepData && isAttached( node ) ) {
                   setGlobalEval( getAll( node, "script" ) );
               }
               node.parentNode.removeChild( node );
           }
       }
   
       return elem;
   }
   
   jQuery.extend( {
       htmlPrefilter: function( html ) {
           return html;
       },
   
       clone: function( elem, dataAndEvents, deepDataAndEvents ) {
           var i, l, srcElements, destElements,
               clone = elem.cloneNode( true ),
               inPage = isAttached( elem );
   
           // Fix IE cloning issues
           if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                   !jQuery.isXMLDoc( elem ) ) {
   
               // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
               destElements = getAll( clone );
               srcElements = getAll( elem );
   
               for ( i = 0, l = srcElements.length; i < l; i++ ) {
                   fixInput( srcElements[ i ], destElements[ i ] );
               }
           }
   
           // Copy the events from the original to the clone
           if ( dataAndEvents ) {
               if ( deepDataAndEvents ) {
                   srcElements = srcElements || getAll( elem );
                   destElements = destElements || getAll( clone );
   
                   for ( i = 0, l = srcElements.length; i < l; i++ ) {
                       cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                   }
               } else {
                   cloneCopyEvent( elem, clone );
               }
           }
   
           // Preserve script evaluation history
           destElements = getAll( clone, "script" );
           if ( destElements.length > 0 ) {
               setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
           }
   
           // Return the cloned set
           return clone;
       },
   
       cleanData: function( elems ) {
           var data, elem, type,
               special = jQuery.event.special,
               i = 0;
   
           for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
               if ( acceptData( elem ) ) {
                   if ( ( data = elem[ dataPriv.expando ] ) ) {
                       if ( data.events ) {
                           for ( type in data.events ) {
                               if ( special[ type ] ) {
                                   jQuery.event.remove( elem, type );
   
                               // This is a shortcut to avoid jQuery.event.remove's overhead
                               } else {
                                   jQuery.removeEvent( elem, type, data.handle );
                               }
                           }
                       }
   
                       // Support: Chrome <=35 - 45+
                       // Assign undefined instead of using delete, see Data#remove
                       elem[ dataPriv.expando ] = undefined;
                   }
                   if ( elem[ dataUser.expando ] ) {
   
                       // Support: Chrome <=35 - 45+
                       // Assign undefined instead of using delete, see Data#remove
                       elem[ dataUser.expando ] = undefined;
                   }
               }
           }
       }
   } );
   
   jQuery.fn.extend( {
       detach: function( selector ) {
           return remove( this, selector, true );
       },
   
       remove: function( selector ) {
           return remove( this, selector );
       },
   
       text: function( value ) {
           return access( this, function( value ) {
               return value === undefined ?
                   jQuery.text( this ) :
                   this.empty().each( function() {
                       if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                           this.textContent = value;
                       }
                   } );
           }, null, value, arguments.length );
       },
   
       append: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                   var target = manipulationTarget( this, elem );
                   target.appendChild( elem );
               }
           } );
       },
   
       prepend: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                   var target = manipulationTarget( this, elem );
                   target.insertBefore( elem, target.firstChild );
               }
           } );
       },
   
       before: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.parentNode ) {
                   this.parentNode.insertBefore( elem, this );
               }
           } );
       },
   
       after: function() {
           return domManip( this, arguments, function( elem ) {
               if ( this.parentNode ) {
                   this.parentNode.insertBefore( elem, this.nextSibling );
               }
           } );
       },
   
       empty: function() {
           var elem,
               i = 0;
   
           for ( ; ( elem = this[ i ] ) != null; i++ ) {
               if ( elem.nodeType === 1 ) {
   
                   // Prevent memory leaks
                   jQuery.cleanData( getAll( elem, false ) );
   
                   // Remove any remaining nodes
                   elem.textContent = "";
               }
           }
   
           return this;
       },
   
       clone: function( dataAndEvents, deepDataAndEvents ) {
           dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
           deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
   
           return this.map( function() {
               return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
           } );
       },
   
       html: function( value ) {
           return access( this, function( value ) {
               var elem = this[ 0 ] || {},
                   i = 0,
                   l = this.length;
   
               if ( value === undefined && elem.nodeType === 1 ) {
                   return elem.innerHTML;
               }
   
               // See if we can take a shortcut and just use innerHTML
               if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                   !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
   
                   value = jQuery.htmlPrefilter( value );
   
                   try {
                       for ( ; i < l; i++ ) {
                           elem = this[ i ] || {};
   
                           // Remove element nodes and prevent memory leaks
                           if ( elem.nodeType === 1 ) {
                               jQuery.cleanData( getAll( elem, false ) );
                               elem.innerHTML = value;
                           }
                       }
   
                       elem = 0;
   
                   // If using innerHTML throws an exception, use the fallback method
                   } catch ( e ) {}
               }
   
               if ( elem ) {
                   this.empty().append( value );
               }
           }, null, value, arguments.length );
       },
   
       replaceWith: function() {
           var ignored = [];
   
           // Make the changes, replacing each non-ignored context element with the new content
           return domManip( this, arguments, function( elem ) {
               var parent = this.parentNode;
   
               if ( jQuery.inArray( this, ignored ) < 0 ) {
                   jQuery.cleanData( getAll( this ) );
                   if ( parent ) {
                       parent.replaceChild( elem, this );
                   }
               }
   
           // Force callback invocation
           }, ignored );
       }
   } );
   
   jQuery.each( {
       appendTo: "append",
       prependTo: "prepend",
       insertBefore: "before",
       insertAfter: "after",
       replaceAll: "replaceWith"
   }, function( name, original ) {
       jQuery.fn[ name ] = function( selector ) {
           var elems,
               ret = [],
               insert = jQuery( selector ),
               last = insert.length - 1,
               i = 0;
   
           for ( ; i <= last; i++ ) {
               elems = i === last ? this : this.clone( true );
               jQuery( insert[ i ] )[ original ]( elems );
   
               // Support: Android <=4.0 only, PhantomJS 1 only
               // .get() because push.apply(_, arraylike) throws on ancient WebKit
               push.apply( ret, elems.get() );
           }
   
           return this.pushStack( ret );
       };
   } );
   var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
   
   var rcustomProp = /^--/;
   
   
   var getStyles = function( elem ) {
   
           // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
           // IE throws on elements created in popups
           // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
           var view = elem.ownerDocument.defaultView;
   
           if ( !view || !view.opener ) {
               view = window;
           }
   
           return view.getComputedStyle( elem );
       };
   
   var swap = function( elem, options, callback ) {
       var ret, name,
           old = {};
   
       // Remember the old values, and insert the new ones
       for ( name in options ) {
           old[ name ] = elem.style[ name ];
           elem.style[ name ] = options[ name ];
       }
   
       ret = callback.call( elem );
   
       // Revert the old values
       for ( name in options ) {
           elem.style[ name ] = old[ name ];
       }
   
       return ret;
   };
   
   
   var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
   
   var whitespace = "[\\x20\\t\\r\\n\\f]";
   
   
   var rtrimCSS = new RegExp(
       "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
       "g"
   );
   
   
   
   
   ( function() {
   
       // Executing both pixelPosition & boxSizingReliable tests require only one layout
       // so they're executed at the same time to save the second computation.
       function computeStyleTests() {
   
           // This is a singleton, we need to execute it only once
           if ( !div ) {
               return;
           }
   
           container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
               "margin-top:1px;padding:0;border:0";
           div.style.cssText =
               "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
               "margin:auto;border:1px;padding:1px;" +
               "width:60%;top:1%";
           documentElement.appendChild( container ).appendChild( div );
   
           var divStyle = window.getComputedStyle( div );
           pixelPositionVal = divStyle.top !== "1%";
   
           // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
           reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
   
           // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
           // Some styles come back with percentage values, even though they shouldn't
           div.style.right = "60%";
           pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
   
           // Support: IE 9 - 11 only
           // Detect misreporting of content dimensions for box-sizing:border-box elements
           boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
   
           // Support: IE 9 only
           // Detect overflow:scroll screwiness (gh-3699)
           // Support: Chrome <=64
           // Don't get tricked when zoom affects offsetWidth (gh-4029)
           div.style.position = "absolute";
           scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
   
           documentElement.removeChild( container );
   
           // Nullify the div so it wouldn't be stored in the memory and
           // it will also be a sign that checks already performed
           div = null;
       }
   
       function roundPixelMeasures( measure ) {
           return Math.round( parseFloat( measure ) );
       }
   
       var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
           reliableTrDimensionsVal, reliableMarginLeftVal,
           container = document.createElement( "div" ),
           div = document.createElement( "div" );
   
       // Finish early in limited (non-browser) environments
       if ( !div.style ) {
           return;
       }
   
       // Support: IE <=9 - 11 only
       // Style of cloned element affects source element cloned (trac-8908)
       div.style.backgroundClip = "content-box";
       div.cloneNode( true ).style.backgroundClip = "";
       support.clearCloneStyle = div.style.backgroundClip === "content-box";
   
       jQuery.extend( support, {
           boxSizingReliable: function() {
               computeStyleTests();
               return boxSizingReliableVal;
           },
           pixelBoxStyles: function() {
               computeStyleTests();
               return pixelBoxStylesVal;
           },
           pixelPosition: function() {
               computeStyleTests();
               return pixelPositionVal;
           },
           reliableMarginLeft: function() {
               computeStyleTests();
               return reliableMarginLeftVal;
           },
           scrollboxSize: function() {
               computeStyleTests();
               return scrollboxSizeVal;
           },
   
           // Support: IE 9 - 11+, Edge 15 - 18+
           // IE/Edge misreport `getComputedStyle` of table rows with width/height
           // set in CSS while `offset*` properties report correct values.
           // Behavior in IE 9 is more subtle than in newer versions & it passes
           // some versions of this test; make sure not to make it pass there!
           //
           // Support: Firefox 70+
           // Only Firefox includes border widths
           // in computed dimensions. (gh-4529)
           reliableTrDimensions: function() {
               var table, tr, trChild, trStyle;
               if ( reliableTrDimensionsVal == null ) {
                   table = document.createElement( "table" );
                   tr = document.createElement( "tr" );
                   trChild = document.createElement( "div" );
   
                   table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                   tr.style.cssText = "border:1px solid";
   
                   // Support: Chrome 86+
                   // Height set through cssText does not get applied.
                   // Computed height then comes back as 0.
                   tr.style.height = "1px";
                   trChild.style.height = "9px";
   
                   // Support: Android 8 Chrome 86+
                   // In our bodyBackground.html iframe,
                   // display for all div elements is set to "inline",
                   // which causes a problem only in Android 8 Chrome 86.
                   // Ensuring the div is display: block
                   // gets around this issue.
                   trChild.style.display = "block";
   
                   documentElement
                       .appendChild( table )
                       .appendChild( tr )
                       .appendChild( trChild );
   
                   trStyle = window.getComputedStyle( tr );
                   reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
                       parseInt( trStyle.borderTopWidth, 10 ) +
                       parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
   
                   documentElement.removeChild( table );
               }
               return reliableTrDimensionsVal;
           }
       } );
   } )();
   
   
   function curCSS( elem, name, computed ) {
       var width, minWidth, maxWidth, ret,
           isCustomProp = rcustomProp.test( name ),
   
           // Support: Firefox 51+
           // Retrieving style before computed somehow
           // fixes an issue with getting wrong values
           // on detached elements
           style = elem.style;
   
       computed = computed || getStyles( elem );
   
       // getPropertyValue is needed for:
       //   .css('filter') (IE 9 only, trac-12537)
       //   .css('--customProperty) (gh-3144)
       if ( computed ) {
           ret = computed.getPropertyValue( name ) || computed[ name ];
   
           // trim whitespace for custom property (issue gh-4926)
           if ( isCustomProp ) {
   
               // rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
               // as whitespace while CSS does not, but this is not a problem
               // because CSS preprocessing replaces them with U+000A LINE FEED
               // (which *is* CSS whitespace)
               // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
               ret = ret.replace( rtrimCSS, "$1" );
           }
   
           if ( ret === "" && !isAttached( elem ) ) {
               ret = jQuery.style( elem, name );
           }
   
           // A tribute to the "awesome hack by Dean Edwards"
           // Android Browser returns percentage for some values,
           // but width seems to be reliably pixels.
           // This is against the CSSOM draft spec:
           // https://drafts.csswg.org/cssom/#resolved-values
           if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
   
               // Remember the original values
               width = style.width;
               minWidth = style.minWidth;
               maxWidth = style.maxWidth;
   
               // Put in the new values to get a computed value out
               style.minWidth = style.maxWidth = style.width = ret;
               ret = computed.width;
   
               // Revert the changed values
               style.width = width;
               style.minWidth = minWidth;
               style.maxWidth = maxWidth;
           }
       }
   
       return ret !== undefined ?
   
           // Support: IE <=9 - 11 only
           // IE returns zIndex value as an integer.
           ret + "" :
           ret;
   }
   
   
   function addGetHookIf( conditionFn, hookFn ) {
   
       // Define the hook, we'll check on the first run if it's really needed.
       return {
           get: function() {
               if ( conditionFn() ) {
   
                   // Hook not needed (or it's not possible to use it due
                   // to missing dependency), remove it.
                   delete this.get;
                   return;
               }
   
               // Hook needed; redefine it so that the support test is not executed again.
               return ( this.get = hookFn ).apply( this, arguments );
           }
       };
   }
   
   
   var cssPrefixes = [ "Webkit", "Moz", "ms" ],
       emptyStyle = document.createElement( "div" ).style,
       vendorProps = {};
   
   // Return a vendor-prefixed property or undefined
   function vendorPropName( name ) {
   
       // Check for vendor prefixed names
       var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
           i = cssPrefixes.length;
   
       while ( i-- ) {
           name = cssPrefixes[ i ] + capName;
           if ( name in emptyStyle ) {
               return name;
           }
       }
   }
   
   // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
   function finalPropName( name ) {
       var final = jQuery.cssProps[ name ] || vendorProps[ name ];
   
       if ( final ) {
           return final;
       }
       if ( name in emptyStyle ) {
           return name;
       }
       return vendorProps[ name ] = vendorPropName( name ) || name;
   }
   
   
   var
   
       // Swappable if display is none or starts with table
       // except "table", "table-cell", or "table-caption"
       // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
       rdisplayswap = /^(none|table(?!-c[ea]).+)/,
       cssShow = { position: "absolute", visibility: "hidden", display: "block" },
       cssNormalTransform = {
           letterSpacing: "0",
           fontWeight: "400"
       };
   
   function setPositiveNumber( _elem, value, subtract ) {
   
       // Any relative (+/-) values have already been
       // normalized at this point
       var matches = rcssNum.exec( value );
       return matches ?
   
           // Guard against undefined "subtract", e.g., when used as in cssHooks
           Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
           value;
   }
   
   function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
       var i = dimension === "width" ? 1 : 0,
           extra = 0,
           delta = 0;
   
       // Adjustment may not be necessary
       if ( box === ( isBorderBox ? "border" : "content" ) ) {
           return 0;
       }
   
       for ( ; i < 4; i += 2 ) {
   
           // Both box models exclude margin
           if ( box === "margin" ) {
               delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
           }
   
           // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
           if ( !isBorderBox ) {
   
               // Add padding
               delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
   
               // For "border" or "margin", add border
               if ( box !== "padding" ) {
                   delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
   
               // But still keep track of it otherwise
               } else {
                   extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
               }
   
           // If we get here with a border-box (content + padding + border), we're seeking "content" or
           // "padding" or "margin"
           } else {
   
               // For "content", subtract padding
               if ( box === "content" ) {
                   delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
               }
   
               // For "content" or "padding", subtract border
               if ( box !== "margin" ) {
                   delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
               }
           }
       }
   
       // Account for positive content-box scroll gutter when requested by providing computedVal
       if ( !isBorderBox && computedVal >= 0 ) {
   
           // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
           // Assuming integer scroll gutter, subtract the rest and round down
           delta += Math.max( 0, Math.ceil(
               elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
               computedVal -
               delta -
               extra -
               0.5
   
           // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
           // Use an explicit zero to avoid NaN (gh-3964)
           ) ) || 0;
       }
   
       return delta;
   }
   
   function getWidthOrHeight( elem, dimension, extra ) {
   
       // Start with computed style
       var styles = getStyles( elem ),
   
           // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
           // Fake content-box until we know it's needed to know the true value.
           boxSizingNeeded = !support.boxSizingReliable() || extra,
           isBorderBox = boxSizingNeeded &&
               jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
           valueIsBorderBox = isBorderBox,
   
           val = curCSS( elem, dimension, styles ),
           offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
   
       // Support: Firefox <=54
       // Return a confounding non-pixel value or feign ignorance, as appropriate.
       if ( rnumnonpx.test( val ) ) {
           if ( !extra ) {
               return val;
           }
           val = "auto";
       }
   
   
       // Support: IE 9 - 11 only
       // Use offsetWidth/offsetHeight for when box sizing is unreliable.
       // In those cases, the computed value can be trusted to be border-box.
       if ( ( !support.boxSizingReliable() && isBorderBox ||
   
           // Support: IE 10 - 11+, Edge 15 - 18+
           // IE/Edge misreport `getComputedStyle` of table rows with width/height
           // set in CSS while `offset*` properties report correct values.
           // Interestingly, in some cases IE 9 doesn't suffer from this issue.
           !support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
   
           // Fall back to offsetWidth/offsetHeight when value is "auto"
           // This happens for inline elements with no explicit setting (gh-3571)
           val === "auto" ||
   
           // Support: Android <=4.1 - 4.3 only
           // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
           !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
   
           // Make sure the element is visible & connected
           elem.getClientRects().length ) {
   
           isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
   
           // Where available, offsetWidth/offsetHeight approximate border box dimensions.
           // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
           // retrieved value as a content box dimension.
           valueIsBorderBox = offsetProp in elem;
           if ( valueIsBorderBox ) {
               val = elem[ offsetProp ];
           }
       }
   
       // Normalize "" and auto
       val = parseFloat( val ) || 0;
   
       // Adjust for the element's box model
       return ( val +
           boxModelAdjustment(
               elem,
               dimension,
               extra || ( isBorderBox ? "border" : "content" ),
               valueIsBorderBox,
               styles,
   
               // Provide the current computed size to request scroll gutter calculation (gh-3589)
               val
           )
       ) + "px";
   }
   
   jQuery.extend( {
   
       // Add in style property hooks for overriding the default
       // behavior of getting and setting a style property
       cssHooks: {
           opacity: {
               get: function( elem, computed ) {
                   if ( computed ) {
   
                       // We should always get a number back from opacity
                       var ret = curCSS( elem, "opacity" );
                       return ret === "" ? "1" : ret;
                   }
               }
           }
       },
   
       // Don't automatically add "px" to these possibly-unitless properties
       cssNumber: {
           "animationIterationCount": true,
           "columnCount": true,
           "fillOpacity": true,
           "flexGrow": true,
           "flexShrink": true,
           "fontWeight": true,
           "gridArea": true,
           "gridColumn": true,
           "gridColumnEnd": true,
           "gridColumnStart": true,
           "gridRow": true,
           "gridRowEnd": true,
           "gridRowStart": true,
           "lineHeight": true,
           "opacity": true,
           "order": true,
           "orphans": true,
           "widows": true,
           "zIndex": true,
           "zoom": true
       },
   
       // Add in properties whose names you wish to fix before
       // setting or getting the value
       cssProps: {},
   
       // Get and set the style property on a DOM Node
       style: function( elem, name, value, extra ) {
   
           // Don't set styles on text and comment nodes
           if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
               return;
           }
   
           // Make sure that we're working with the right name
           var ret, type, hooks,
               origName = camelCase( name ),
               isCustomProp = rcustomProp.test( name ),
               style = elem.style;
   
           // Make sure that we're working with the right name. We don't
           // want to query the value if it is a CSS custom property
           // since they are user-defined.
           if ( !isCustomProp ) {
               name = finalPropName( origName );
           }
   
           // Gets hook for the prefixed version, then unprefixed version
           hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
           // Check if we're setting a value
           if ( value !== undefined ) {
               type = typeof value;
   
               // Convert "+=" or "-=" to relative numbers (trac-7345)
               if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                   value = adjustCSS( elem, name, ret );
   
                   // Fixes bug trac-9237
                   type = "number";
               }
   
               // Make sure that null and NaN values aren't set (trac-7116)
               if ( value == null || value !== value ) {
                   return;
               }
   
               // If a number was passed in, add the unit (except for certain CSS properties)
               // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
               // "px" to a few hardcoded values.
               if ( type === "number" && !isCustomProp ) {
                   value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
               }
   
               // background-* props affect original clone's values
               if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                   style[ name ] = "inherit";
               }
   
               // If a hook was provided, use that value, otherwise just set the specified value
               if ( !hooks || !( "set" in hooks ) ||
                   ( value = hooks.set( elem, value, extra ) ) !== undefined ) {
   
                   if ( isCustomProp ) {
                       style.setProperty( name, value );
                   } else {
                       style[ name ] = value;
                   }
               }
   
           } else {
   
               // If a hook was provided get the non-computed value from there
               if ( hooks && "get" in hooks &&
                   ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
   
                   return ret;
               }
   
               // Otherwise just get the value from the style object
               return style[ name ];
           }
       },
   
       css: function( elem, name, extra, styles ) {
           var val, num, hooks,
               origName = camelCase( name ),
               isCustomProp = rcustomProp.test( name );
   
           // Make sure that we're working with the right name. We don't
           // want to modify the value if it is a CSS custom property
           // since they are user-defined.
           if ( !isCustomProp ) {
               name = finalPropName( origName );
           }
   
           // Try prefixed name followed by the unprefixed name
           hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
           // If a hook was provided get the computed value from there
           if ( hooks && "get" in hooks ) {
               val = hooks.get( elem, true, extra );
           }
   
           // Otherwise, if a way to get the computed value exists, use that
           if ( val === undefined ) {
               val = curCSS( elem, name, styles );
           }
   
           // Convert "normal" to computed value
           if ( val === "normal" && name in cssNormalTransform ) {
               val = cssNormalTransform[ name ];
           }
   
           // Make numeric if forced or a qualifier was provided and val looks numeric
           if ( extra === "" || extra ) {
               num = parseFloat( val );
               return extra === true || isFinite( num ) ? num || 0 : val;
           }
   
           return val;
       }
   } );
   
   jQuery.each( [ "height", "width" ], function( _i, dimension ) {
       jQuery.cssHooks[ dimension ] = {
           get: function( elem, computed, extra ) {
               if ( computed ) {
   
                   // Certain elements can have dimension info if we invisibly show them
                   // but it must have a current display style that would benefit
                   return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
   
                       // Support: Safari 8+
                       // Table columns in Safari have non-zero offsetWidth & zero
                       // getBoundingClientRect().width unless display is changed.
                       // Support: IE <=11 only
                       // Running getBoundingClientRect on a disconnected node
                       // in IE throws an error.
                       ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                       swap( elem, cssShow, function() {
                           return getWidthOrHeight( elem, dimension, extra );
                       } ) :
                       getWidthOrHeight( elem, dimension, extra );
               }
           },
   
           set: function( elem, value, extra ) {
               var matches,
                   styles = getStyles( elem ),
   
                   // Only read styles.position if the test has a chance to fail
                   // to avoid forcing a reflow.
                   scrollboxSizeBuggy = !support.scrollboxSize() &&
                       styles.position === "absolute",
   
                   // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                   boxSizingNeeded = scrollboxSizeBuggy || extra,
                   isBorderBox = boxSizingNeeded &&
                       jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                   subtract = extra ?
                       boxModelAdjustment(
                           elem,
                           dimension,
                           extra,
                           isBorderBox,
                           styles
                       ) :
                       0;
   
               // Account for unreliable border-box dimensions by comparing offset* to computed and
               // faking a content-box to get border and padding (gh-3699)
               if ( isBorderBox && scrollboxSizeBuggy ) {
                   subtract -= Math.ceil(
                       elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                       parseFloat( styles[ dimension ] ) -
                       boxModelAdjustment( elem, dimension, "border", false, styles ) -
                       0.5
                   );
               }
   
               // Convert to pixels if value adjustment is needed
               if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                   ( matches[ 3 ] || "px" ) !== "px" ) {
   
                   elem.style[ dimension ] = value;
                   value = jQuery.css( elem, dimension );
               }
   
               return setPositiveNumber( elem, value, subtract );
           }
       };
   } );
   
   jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
       function( elem, computed ) {
           if ( computed ) {
               return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                   elem.getBoundingClientRect().left -
                       swap( elem, { marginLeft: 0 }, function() {
                           return elem.getBoundingClientRect().left;
                       } )
               ) + "px";
           }
       }
   );
   
   // These hooks are used by animate to expand properties
   jQuery.each( {
       margin: "",
       padding: "",
       border: "Width"
   }, function( prefix, suffix ) {
       jQuery.cssHooks[ prefix + suffix ] = {
           expand: function( value ) {
               var i = 0,
                   expanded = {},
   
                   // Assumes a single number if not a string
                   parts = typeof value === "string" ? value.split( " " ) : [ value ];
   
               for ( ; i < 4; i++ ) {
                   expanded[ prefix + cssExpand[ i ] + suffix ] =
                       parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
               }
   
               return expanded;
           }
       };
   
       if ( prefix !== "margin" ) {
           jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
       }
   } );
   
   jQuery.fn.extend( {
       css: function( name, value ) {
           return access( this, function( elem, name, value ) {
               var styles, len,
                   map = {},
                   i = 0;
   
               if ( Array.isArray( name ) ) {
                   styles = getStyles( elem );
                   len = name.length;
   
                   for ( ; i < len; i++ ) {
                       map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                   }
   
                   return map;
               }
   
               return value !== undefined ?
                   jQuery.style( elem, name, value ) :
                   jQuery.css( elem, name );
           }, name, value, arguments.length > 1 );
       }
   } );
   
   
   function Tween( elem, options, prop, end, easing ) {
       return new Tween.prototype.init( elem, options, prop, end, easing );
   }
   jQuery.Tween = Tween;
   
   Tween.prototype = {
       constructor: Tween,
       init: function( elem, options, prop, end, easing, unit ) {
           this.elem = elem;
           this.prop = prop;
           this.easing = easing || jQuery.easing._default;
           this.options = options;
           this.start = this.now = this.cur();
           this.end = end;
           this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
       },
       cur: function() {
           var hooks = Tween.propHooks[ this.prop ];
   
           return hooks && hooks.get ?
               hooks.get( this ) :
               Tween.propHooks._default.get( this );
       },
       run: function( percent ) {
           var eased,
               hooks = Tween.propHooks[ this.prop ];
   
           if ( this.options.duration ) {
               this.pos = eased = jQuery.easing[ this.easing ](
                   percent, this.options.duration * percent, 0, 1, this.options.duration
               );
           } else {
               this.pos = eased = percent;
           }
           this.now = ( this.end - this.start ) * eased + this.start;
   
           if ( this.options.step ) {
               this.options.step.call( this.elem, this.now, this );
           }
   
           if ( hooks && hooks.set ) {
               hooks.set( this );
           } else {
               Tween.propHooks._default.set( this );
           }
           return this;
       }
   };
   
   Tween.prototype.init.prototype = Tween.prototype;
   
   Tween.propHooks = {
       _default: {
           get: function( tween ) {
               var result;
   
               // Use a property on the element directly when it is not a DOM element,
               // or when there is no matching style property that exists.
               if ( tween.elem.nodeType !== 1 ||
                   tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                   return tween.elem[ tween.prop ];
               }
   
               // Passing an empty string as a 3rd parameter to .css will automatically
               // attempt a parseFloat and fallback to a string if the parse fails.
               // Simple values such as "10px" are parsed to Float;
               // complex values such as "rotate(1rad)" are returned as-is.
               result = jQuery.css( tween.elem, tween.prop, "" );
   
               // Empty strings, null, undefined and "auto" are converted to 0.
               return !result || result === "auto" ? 0 : result;
           },
           set: function( tween ) {
   
               // Use step hook for back compat.
               // Use cssHook if its there.
               // Use .style if available and use plain properties where available.
               if ( jQuery.fx.step[ tween.prop ] ) {
                   jQuery.fx.step[ tween.prop ]( tween );
               } else if ( tween.elem.nodeType === 1 && (
                   jQuery.cssHooks[ tween.prop ] ||
                       tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
                   jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
               } else {
                   tween.elem[ tween.prop ] = tween.now;
               }
           }
       }
   };
   
   // Support: IE <=9 only
   // Panic based approach to setting things on disconnected nodes
   Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
       set: function( tween ) {
           if ( tween.elem.nodeType && tween.elem.parentNode ) {
               tween.elem[ tween.prop ] = tween.now;
           }
       }
   };
   
   jQuery.easing = {
       linear: function( p ) {
           return p;
       },
       swing: function( p ) {
           return 0.5 - Math.cos( p * Math.PI ) / 2;
       },
       _default: "swing"
   };
   
   jQuery.fx = Tween.prototype.init;
   
   // Back compat <1.8 extension point
   jQuery.fx.step = {};
   
   
   
   
   var
       fxNow, inProgress,
       rfxtypes = /^(?:toggle|show|hide)$/,
       rrun = /queueHooks$/;
   
   function schedule() {
       if ( inProgress ) {
           if ( document.hidden === false && window.requestAnimationFrame ) {
               window.requestAnimationFrame( schedule );
           } else {
               window.setTimeout( schedule, jQuery.fx.interval );
           }
   
           jQuery.fx.tick();
       }
   }
   
   // Animations created synchronously will run synchronously
   function createFxNow() {
       window.setTimeout( function() {
           fxNow = undefined;
       } );
       return ( fxNow = Date.now() );
   }
   
   // Generate parameters to create a standard animation
   function genFx( type, includeWidth ) {
       var which,
           i = 0,
           attrs = { height: type };
   
       // If we include width, step value is 1 to do all cssExpand values,
       // otherwise step value is 2 to skip over Left and Right
       includeWidth = includeWidth ? 1 : 0;
       for ( ; i < 4; i += 2 - includeWidth ) {
           which = cssExpand[ i ];
           attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
       }
   
       if ( includeWidth ) {
           attrs.opacity = attrs.width = type;
       }
   
       return attrs;
   }
   
   function createTween( value, prop, animation ) {
       var tween,
           collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
           index = 0,
           length = collection.length;
       for ( ; index < length; index++ ) {
           if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
   
               // We're done with this property
               return tween;
           }
       }
   }
   
   function defaultPrefilter( elem, props, opts ) {
       var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
           isBox = "width" in props || "height" in props,
           anim = this,
           orig = {},
           style = elem.style,
           hidden = elem.nodeType && isHiddenWithinTree( elem ),
           dataShow = dataPriv.get( elem, "fxshow" );
   
       // Queue-skipping animations hijack the fx hooks
       if ( !opts.queue ) {
           hooks = jQuery._queueHooks( elem, "fx" );
           if ( hooks.unqueued == null ) {
               hooks.unqueued = 0;
               oldfire = hooks.empty.fire;
               hooks.empty.fire = function() {
                   if ( !hooks.unqueued ) {
                       oldfire();
                   }
               };
           }
           hooks.unqueued++;
   
           anim.always( function() {
   
               // Ensure the complete handler is called before this completes
               anim.always( function() {
                   hooks.unqueued--;
                   if ( !jQuery.queue( elem, "fx" ).length ) {
                       hooks.empty.fire();
                   }
               } );
           } );
       }
   
       // Detect show/hide animations
       for ( prop in props ) {
           value = props[ prop ];
           if ( rfxtypes.test( value ) ) {
               delete props[ prop ];
               toggle = toggle || value === "toggle";
               if ( value === ( hidden ? "hide" : "show" ) ) {
   
                   // Pretend to be hidden if this is a "show" and
                   // there is still data from a stopped show/hide
                   if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                       hidden = true;
   
                   // Ignore all other no-op show/hide data
                   } else {
                       continue;
                   }
               }
               orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
           }
       }
   
       // Bail out if this is a no-op like .hide().hide()
       propTween = !jQuery.isEmptyObject( props );
       if ( !propTween && jQuery.isEmptyObject( orig ) ) {
           return;
       }
   
       // Restrict "overflow" and "display" styles during box animations
       if ( isBox && elem.nodeType === 1 ) {
   
           // Support: IE <=9 - 11, Edge 12 - 15
           // Record all 3 overflow attributes because IE does not infer the shorthand
           // from identically-valued overflowX and overflowY and Edge just mirrors
           // the overflowX value there.
           opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
   
           // Identify a display type, preferring old show/hide data over the CSS cascade
           restoreDisplay = dataShow && dataShow.display;
           if ( restoreDisplay == null ) {
               restoreDisplay = dataPriv.get( elem, "display" );
           }
           display = jQuery.css( elem, "display" );
           if ( display === "none" ) {
               if ( restoreDisplay ) {
                   display = restoreDisplay;
               } else {
   
                   // Get nonempty value(s) by temporarily forcing visibility
                   showHide( [ elem ], true );
                   restoreDisplay = elem.style.display || restoreDisplay;
                   display = jQuery.css( elem, "display" );
                   showHide( [ elem ] );
               }
           }
   
           // Animate inline elements as inline-block
           if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
               if ( jQuery.css( elem, "float" ) === "none" ) {
   
                   // Restore the original display value at the end of pure show/hide animations
                   if ( !propTween ) {
                       anim.done( function() {
                           style.display = restoreDisplay;
                       } );
                       if ( restoreDisplay == null ) {
                           display = style.display;
                           restoreDisplay = display === "none" ? "" : display;
                       }
                   }
                   style.display = "inline-block";
               }
           }
       }
   
       if ( opts.overflow ) {
           style.overflow = "hidden";
           anim.always( function() {
               style.overflow = opts.overflow[ 0 ];
               style.overflowX = opts.overflow[ 1 ];
               style.overflowY = opts.overflow[ 2 ];
           } );
       }
   
       // Implement show/hide animations
       propTween = false;
       for ( prop in orig ) {
   
           // General show/hide setup for this element animation
           if ( !propTween ) {
               if ( dataShow ) {
                   if ( "hidden" in dataShow ) {
                       hidden = dataShow.hidden;
                   }
               } else {
                   dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
               }
   
               // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
               if ( toggle ) {
                   dataShow.hidden = !hidden;
               }
   
               // Show elements before animating them
               if ( hidden ) {
                   showHide( [ elem ], true );
               }
   
               /* eslint-disable no-loop-func */
   
               anim.done( function() {
   
                   /* eslint-enable no-loop-func */
   
                   // The final step of a "hide" animation is actually hiding the element
                   if ( !hidden ) {
                       showHide( [ elem ] );
                   }
                   dataPriv.remove( elem, "fxshow" );
                   for ( prop in orig ) {
                       jQuery.style( elem, prop, orig[ prop ] );
                   }
               } );
           }
   
           // Per-property setup
           propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
           if ( !( prop in dataShow ) ) {
               dataShow[ prop ] = propTween.start;
               if ( hidden ) {
                   propTween.end = propTween.start;
                   propTween.start = 0;
               }
           }
       }
   }
   
   function propFilter( props, specialEasing ) {
       var index, name, easing, value, hooks;
   
       // camelCase, specialEasing and expand cssHook pass
       for ( index in props ) {
           name = camelCase( index );
           easing = specialEasing[ name ];
           value = props[ index ];
           if ( Array.isArray( value ) ) {
               easing = value[ 1 ];
               value = props[ index ] = value[ 0 ];
           }
   
           if ( index !== name ) {
               props[ name ] = value;
               delete props[ index ];
           }
   
           hooks = jQuery.cssHooks[ name ];
           if ( hooks && "expand" in hooks ) {
               value = hooks.expand( value );
               delete props[ name ];
   
               // Not quite $.extend, this won't overwrite existing keys.
               // Reusing 'index' because we have the correct "name"
               for ( index in value ) {
                   if ( !( index in props ) ) {
                       props[ index ] = value[ index ];
                       specialEasing[ index ] = easing;
                   }
               }
           } else {
               specialEasing[ name ] = easing;
           }
       }
   }
   
   function Animation( elem, properties, options ) {
       var result,
           stopped,
           index = 0,
           length = Animation.prefilters.length,
           deferred = jQuery.Deferred().always( function() {
   
               // Don't match elem in the :animated selector
               delete tick.elem;
           } ),
           tick = function() {
               if ( stopped ) {
                   return false;
               }
               var currentTime = fxNow || createFxNow(),
                   remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
   
                   // Support: Android 2.3 only
                   // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
                   temp = remaining / animation.duration || 0,
                   percent = 1 - temp,
                   index = 0,
                   length = animation.tweens.length;
   
               for ( ; index < length; index++ ) {
                   animation.tweens[ index ].run( percent );
               }
   
               deferred.notifyWith( elem, [ animation, percent, remaining ] );
   
               // If there's more to do, yield
               if ( percent < 1 && length ) {
                   return remaining;
               }
   
               // If this was an empty animation, synthesize a final progress notification
               if ( !length ) {
                   deferred.notifyWith( elem, [ animation, 1, 0 ] );
               }
   
               // Resolve the animation and report its conclusion
               deferred.resolveWith( elem, [ animation ] );
               return false;
           },
           animation = deferred.promise( {
               elem: elem,
               props: jQuery.extend( {}, properties ),
               opts: jQuery.extend( true, {
                   specialEasing: {},
                   easing: jQuery.easing._default
               }, options ),
               originalProperties: properties,
               originalOptions: options,
               startTime: fxNow || createFxNow(),
               duration: options.duration,
               tweens: [],
               createTween: function( prop, end ) {
                   var tween = jQuery.Tween( elem, animation.opts, prop, end,
                       animation.opts.specialEasing[ prop ] || animation.opts.easing );
                   animation.tweens.push( tween );
                   return tween;
               },
               stop: function( gotoEnd ) {
                   var index = 0,
   
                       // If we are going to the end, we want to run all the tweens
                       // otherwise we skip this part
                       length = gotoEnd ? animation.tweens.length : 0;
                   if ( stopped ) {
                       return this;
                   }
                   stopped = true;
                   for ( ; index < length; index++ ) {
                       animation.tweens[ index ].run( 1 );
                   }
   
                   // Resolve when we played the last frame; otherwise, reject
                   if ( gotoEnd ) {
                       deferred.notifyWith( elem, [ animation, 1, 0 ] );
                       deferred.resolveWith( elem, [ animation, gotoEnd ] );
                   } else {
                       deferred.rejectWith( elem, [ animation, gotoEnd ] );
                   }
                   return this;
               }
           } ),
           props = animation.props;
   
       propFilter( props, animation.opts.specialEasing );
   
       for ( ; index < length; index++ ) {
           result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
           if ( result ) {
               if ( isFunction( result.stop ) ) {
                   jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                       result.stop.bind( result );
               }
               return result;
           }
       }
   
       jQuery.map( props, createTween, animation );
   
       if ( isFunction( animation.opts.start ) ) {
           animation.opts.start.call( elem, animation );
       }
   
       // Attach callbacks from options
       animation
           .progress( animation.opts.progress )
           .done( animation.opts.done, animation.opts.complete )
           .fail( animation.opts.fail )
           .always( animation.opts.always );
   
       jQuery.fx.timer(
           jQuery.extend( tick, {
               elem: elem,
               anim: animation,
               queue: animation.opts.queue
           } )
       );
   
       return animation;
   }
   
   jQuery.Animation = jQuery.extend( Animation, {
   
       tweeners: {
           "*": [ function( prop, value ) {
               var tween = this.createTween( prop, value );
               adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
               return tween;
           } ]
       },
   
       tweener: function( props, callback ) {
           if ( isFunction( props ) ) {
               callback = props;
               props = [ "*" ];
           } else {
               props = props.match( rnothtmlwhite );
           }
   
           var prop,
               index = 0,
               length = props.length;
   
           for ( ; index < length; index++ ) {
               prop = props[ index ];
               Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
               Animation.tweeners[ prop ].unshift( callback );
           }
       },
   
       prefilters: [ defaultPrefilter ],
   
       prefilter: function( callback, prepend ) {
           if ( prepend ) {
               Animation.prefilters.unshift( callback );
           } else {
               Animation.prefilters.push( callback );
           }
       }
   } );
   
   jQuery.speed = function( speed, easing, fn ) {
       var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
           complete: fn || !fn && easing ||
               isFunction( speed ) && speed,
           duration: speed,
           easing: fn && easing || easing && !isFunction( easing ) && easing
       };
   
       // Go to the end state if fx are off
       if ( jQuery.fx.off ) {
           opt.duration = 0;
   
       } else {
           if ( typeof opt.duration !== "number" ) {
               if ( opt.duration in jQuery.fx.speeds ) {
                   opt.duration = jQuery.fx.speeds[ opt.duration ];
   
               } else {
                   opt.duration = jQuery.fx.speeds._default;
               }
           }
       }
   
       // Normalize opt.queue - true/undefined/null -> "fx"
       if ( opt.queue == null || opt.queue === true ) {
           opt.queue = "fx";
       }
   
       // Queueing
       opt.old = opt.complete;
   
       opt.complete = function() {
           if ( isFunction( opt.old ) ) {
               opt.old.call( this );
           }
   
           if ( opt.queue ) {
               jQuery.dequeue( this, opt.queue );
           }
       };
   
       return opt;
   };
   
   jQuery.fn.extend( {
       fadeTo: function( speed, to, easing, callback ) {
   
           // Show any hidden elements after setting opacity to 0
           return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
   
               // Animate to the value specified
               .end().animate( { opacity: to }, speed, easing, callback );
       },
       animate: function( prop, speed, easing, callback ) {
           var empty = jQuery.isEmptyObject( prop ),
               optall = jQuery.speed( speed, easing, callback ),
               doAnimation = function() {
   
                   // Operate on a copy of prop so per-property easing won't be lost
                   var anim = Animation( this, jQuery.extend( {}, prop ), optall );
   
                   // Empty animations, or finishing resolves immediately
                   if ( empty || dataPriv.get( this, "finish" ) ) {
                       anim.stop( true );
                   }
               };
   
           doAnimation.finish = doAnimation;
   
           return empty || optall.queue === false ?
               this.each( doAnimation ) :
               this.queue( optall.queue, doAnimation );
       },
       stop: function( type, clearQueue, gotoEnd ) {
           var stopQueue = function( hooks ) {
               var stop = hooks.stop;
               delete hooks.stop;
               stop( gotoEnd );
           };
   
           if ( typeof type !== "string" ) {
               gotoEnd = clearQueue;
               clearQueue = type;
               type = undefined;
           }
           if ( clearQueue ) {
               this.queue( type || "fx", [] );
           }
   
           return this.each( function() {
               var dequeue = true,
                   index = type != null && type + "queueHooks",
                   timers = jQuery.timers,
                   data = dataPriv.get( this );
   
               if ( index ) {
                   if ( data[ index ] && data[ index ].stop ) {
                       stopQueue( data[ index ] );
                   }
               } else {
                   for ( index in data ) {
                       if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                           stopQueue( data[ index ] );
                       }
                   }
               }
   
               for ( index = timers.length; index--; ) {
                   if ( timers[ index ].elem === this &&
                       ( type == null || timers[ index ].queue === type ) ) {
   
                       timers[ index ].anim.stop( gotoEnd );
                       dequeue = false;
                       timers.splice( index, 1 );
                   }
               }
   
               // Start the next in the queue if the last step wasn't forced.
               // Timers currently will call their complete callbacks, which
               // will dequeue but only if they were gotoEnd.
               if ( dequeue || !gotoEnd ) {
                   jQuery.dequeue( this, type );
               }
           } );
       },
       finish: function( type ) {
           if ( type !== false ) {
               type = type || "fx";
           }
           return this.each( function() {
               var index,
                   data = dataPriv.get( this ),
                   queue = data[ type + "queue" ],
                   hooks = data[ type + "queueHooks" ],
                   timers = jQuery.timers,
                   length = queue ? queue.length : 0;
   
               // Enable finishing flag on private data
               data.finish = true;
   
               // Empty the queue first
               jQuery.queue( this, type, [] );
   
               if ( hooks && hooks.stop ) {
                   hooks.stop.call( this, true );
               }
   
               // Look for any active animations, and finish them
               for ( index = timers.length; index--; ) {
                   if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                       timers[ index ].anim.stop( true );
                       timers.splice( index, 1 );
                   }
               }
   
               // Look for any animations in the old queue and finish them
               for ( index = 0; index < length; index++ ) {
                   if ( queue[ index ] && queue[ index ].finish ) {
                       queue[ index ].finish.call( this );
                   }
               }
   
               // Turn off finishing flag
               delete data.finish;
           } );
       }
   } );
   
   jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
       var cssFn = jQuery.fn[ name ];
       jQuery.fn[ name ] = function( speed, easing, callback ) {
           return speed == null || typeof speed === "boolean" ?
               cssFn.apply( this, arguments ) :
               this.animate( genFx( name, true ), speed, easing, callback );
       };
   } );
   
   // Generate shortcuts for custom animations
   jQuery.each( {
       slideDown: genFx( "show" ),
       slideUp: genFx( "hide" ),
       slideToggle: genFx( "toggle" ),
       fadeIn: { opacity: "show" },
       fadeOut: { opacity: "hide" },
       fadeToggle: { opacity: "toggle" }
   }, function( name, props ) {
       jQuery.fn[ name ] = function( speed, easing, callback ) {
           return this.animate( props, speed, easing, callback );
       };
   } );
   
   jQuery.timers = [];
   jQuery.fx.tick = function() {
       var timer,
           i = 0,
           timers = jQuery.timers;
   
       fxNow = Date.now();
   
       for ( ; i < timers.length; i++ ) {
           timer = timers[ i ];
   
           // Run the timer and safely remove it when done (allowing for external removal)
           if ( !timer() && timers[ i ] === timer ) {
               timers.splice( i--, 1 );
           }
       }
   
       if ( !timers.length ) {
           jQuery.fx.stop();
       }
       fxNow = undefined;
   };
   
   jQuery.fx.timer = function( timer ) {
       jQuery.timers.push( timer );
       jQuery.fx.start();
   };
   
   jQuery.fx.interval = 13;
   jQuery.fx.start = function() {
       if ( inProgress ) {
           return;
       }
   
       inProgress = true;
       schedule();
   };
   
   jQuery.fx.stop = function() {
       inProgress = null;
   };
   
   jQuery.fx.speeds = {
       slow: 600,
       fast: 200,
   
       // Default speed
       _default: 400
   };
   
   
   // Based off of the plugin by Clint Helfers, with permission.
   jQuery.fn.delay = function( time, type ) {
       time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
       type = type || "fx";
   
       return this.queue( type, function( next, hooks ) {
           var timeout = window.setTimeout( next, time );
           hooks.stop = function() {
               window.clearTimeout( timeout );
           };
       } );
   };
   
   
   ( function() {
       var input = document.createElement( "input" ),
           select = document.createElement( "select" ),
           opt = select.appendChild( document.createElement( "option" ) );
   
       input.type = "checkbox";
   
       // Support: Android <=4.3 only
       // Default value for a checkbox should be "on"
       support.checkOn = input.value !== "";
   
       // Support: IE <=11 only
       // Must access selectedIndex to make default options select
       support.optSelected = opt.selected;
   
       // Support: IE <=11 only
       // An input loses its value after becoming a radio
       input = document.createElement( "input" );
       input.value = "t";
       input.type = "radio";
       support.radioValue = input.value === "t";
   } )();
   
   
   var boolHook,
       attrHandle = jQuery.expr.attrHandle;
   
   jQuery.fn.extend( {
       attr: function( name, value ) {
           return access( this, jQuery.attr, name, value, arguments.length > 1 );
       },
   
       removeAttr: function( name ) {
           return this.each( function() {
               jQuery.removeAttr( this, name );
           } );
       }
   } );
   
   jQuery.extend( {
       attr: function( elem, name, value ) {
           var ret, hooks,
               nType = elem.nodeType;
   
           // Don't get/set attributes on text, comment and attribute nodes
           if ( nType === 3 || nType === 8 || nType === 2 ) {
               return;
           }
   
           // Fallback to prop when attributes are not supported
           if ( typeof elem.getAttribute === "undefined" ) {
               return jQuery.prop( elem, name, value );
           }
   
           // Attribute hooks are determined by the lowercase version
           // Grab necessary hook if one is defined
           if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
               hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                   ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
           }
   
           if ( value !== undefined ) {
               if ( value === null ) {
                   jQuery.removeAttr( elem, name );
                   return;
               }
   
               if ( hooks && "set" in hooks &&
                   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                   return ret;
               }
   
               elem.setAttribute( name, value + "" );
               return value;
           }
   
           if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
               return ret;
           }
   
           ret = jQuery.find.attr( elem, name );
   
           // Non-existent attributes return null, we normalize to undefined
           return ret == null ? undefined : ret;
       },
   
       attrHooks: {
           type: {
               set: function( elem, value ) {
                   if ( !support.radioValue && value === "radio" &&
                       nodeName( elem, "input" ) ) {
                       var val = elem.value;
                       elem.setAttribute( "type", value );
                       if ( val ) {
                           elem.value = val;
                       }
                       return value;
                   }
               }
           }
       },
   
       removeAttr: function( elem, value ) {
           var name,
               i = 0,
   
               // Attribute names can contain non-HTML whitespace characters
               // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
               attrNames = value && value.match( rnothtmlwhite );
   
           if ( attrNames && elem.nodeType === 1 ) {
               while ( ( name = attrNames[ i++ ] ) ) {
                   elem.removeAttribute( name );
               }
           }
       }
   } );
   
   // Hooks for boolean attributes
   boolHook = {
       set: function( elem, value, name ) {
           if ( value === false ) {
   
               // Remove boolean attributes when set to false
               jQuery.removeAttr( elem, name );
           } else {
               elem.setAttribute( name, name );
           }
           return name;
       }
   };
   
   jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
       var getter = attrHandle[ name ] || jQuery.find.attr;
   
       attrHandle[ name ] = function( elem, name, isXML ) {
           var ret, handle,
               lowercaseName = name.toLowerCase();
   
           if ( !isXML ) {
   
               // Avoid an infinite loop by temporarily removing this function from the getter
               handle = attrHandle[ lowercaseName ];
               attrHandle[ lowercaseName ] = ret;
               ret = getter( elem, name, isXML ) != null ?
                   lowercaseName :
                   null;
               attrHandle[ lowercaseName ] = handle;
           }
           return ret;
       };
   } );
   
   
   
   
   var rfocusable = /^(?:input|select|textarea|button)$/i,
       rclickable = /^(?:a|area)$/i;
   
   jQuery.fn.extend( {
       prop: function( name, value ) {
           return access( this, jQuery.prop, name, value, arguments.length > 1 );
       },
   
       removeProp: function( name ) {
           return this.each( function() {
               delete this[ jQuery.propFix[ name ] || name ];
           } );
       }
   } );
   
   jQuery.extend( {
       prop: function( elem, name, value ) {
           var ret, hooks,
               nType = elem.nodeType;
   
           // Don't get/set properties on text, comment and attribute nodes
           if ( nType === 3 || nType === 8 || nType === 2 ) {
               return;
           }
   
           if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
   
               // Fix name and attach hooks
               name = jQuery.propFix[ name ] || name;
               hooks = jQuery.propHooks[ name ];
           }
   
           if ( value !== undefined ) {
               if ( hooks && "set" in hooks &&
                   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                   return ret;
               }
   
               return ( elem[ name ] = value );
           }
   
           if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
               return ret;
           }
   
           return elem[ name ];
       },
   
       propHooks: {
           tabIndex: {
               get: function( elem ) {
   
                   // Support: IE <=9 - 11 only
                   // elem.tabIndex doesn't always return the
                   // correct value when it hasn't been explicitly set
                   // Use proper attribute retrieval (trac-12072)
                   var tabindex = jQuery.find.attr( elem, "tabindex" );
   
                   if ( tabindex ) {
                       return parseInt( tabindex, 10 );
                   }
   
                   if (
                       rfocusable.test( elem.nodeName ) ||
                       rclickable.test( elem.nodeName ) &&
                       elem.href
                   ) {
                       return 0;
                   }
   
                   return -1;
               }
           }
       },
   
       propFix: {
           "for": "htmlFor",
           "class": "className"
       }
   } );
   
   // Support: IE <=11 only
   // Accessing the selectedIndex property
   // forces the browser to respect setting selected
   // on the option
   // The getter ensures a default option is selected
   // when in an optgroup
   // eslint rule "no-unused-expressions" is disabled for this code
   // since it considers such accessions noop
   if ( !support.optSelected ) {
       jQuery.propHooks.selected = {
           get: function( elem ) {
   
               /* eslint no-unused-expressions: "off" */
   
               var parent = elem.parentNode;
               if ( parent && parent.parentNode ) {
                   parent.parentNode.selectedIndex;
               }
               return null;
           },
           set: function( elem ) {
   
               /* eslint no-unused-expressions: "off" */
   
               var parent = elem.parentNode;
               if ( parent ) {
                   parent.selectedIndex;
   
                   if ( parent.parentNode ) {
                       parent.parentNode.selectedIndex;
                   }
               }
           }
       };
   }
   
   jQuery.each( [
       "tabIndex",
       "readOnly",
       "maxLength",
       "cellSpacing",
       "cellPadding",
       "rowSpan",
       "colSpan",
       "useMap",
       "frameBorder",
       "contentEditable"
   ], function() {
       jQuery.propFix[ this.toLowerCase() ] = this;
   } );
   
   
   
   
       // Strip and collapse whitespace according to HTML spec
       // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
       function stripAndCollapse( value ) {
           var tokens = value.match( rnothtmlwhite ) || [];
           return tokens.join( " " );
       }
   
   
   function getClass( elem ) {
       return elem.getAttribute && elem.getAttribute( "class" ) || "";
   }
   
   function classesToArray( value ) {
       if ( Array.isArray( value ) ) {
           return value;
       }
       if ( typeof value === "string" ) {
           return value.match( rnothtmlwhite ) || [];
       }
       return [];
   }
   
   jQuery.fn.extend( {
       addClass: function( value ) {
           var classNames, cur, curValue, className, i, finalValue;
   
           if ( isFunction( value ) ) {
               return this.each( function( j ) {
                   jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
               } );
           }
   
           classNames = classesToArray( value );
   
           if ( classNames.length ) {
               return this.each( function() {
                   curValue = getClass( this );
                   cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
                   if ( cur ) {
                       for ( i = 0; i < classNames.length; i++ ) {
                           className = classNames[ i ];
                           if ( cur.indexOf( " " + className + " " ) < 0 ) {
                               cur += className + " ";
                           }
                       }
   
                       // Only assign if different to avoid unneeded rendering.
                       finalValue = stripAndCollapse( cur );
                       if ( curValue !== finalValue ) {
                           this.setAttribute( "class", finalValue );
                       }
                   }
               } );
           }
   
           return this;
       },
   
       removeClass: function( value ) {
           var classNames, cur, curValue, className, i, finalValue;
   
           if ( isFunction( value ) ) {
               return this.each( function( j ) {
                   jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
               } );
           }
   
           if ( !arguments.length ) {
               return this.attr( "class", "" );
           }
   
           classNames = classesToArray( value );
   
           if ( classNames.length ) {
               return this.each( function() {
                   curValue = getClass( this );
   
                   // This expression is here for better compressibility (see addClass)
                   cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
                   if ( cur ) {
                       for ( i = 0; i < classNames.length; i++ ) {
                           className = classNames[ i ];
   
                           // Remove *all* instances
                           while ( cur.indexOf( " " + className + " " ) > -1 ) {
                               cur = cur.replace( " " + className + " ", " " );
                           }
                       }
   
                       // Only assign if different to avoid unneeded rendering.
                       finalValue = stripAndCollapse( cur );
                       if ( curValue !== finalValue ) {
                           this.setAttribute( "class", finalValue );
                       }
                   }
               } );
           }
   
           return this;
       },
   
       toggleClass: function( value, stateVal ) {
           var classNames, className, i, self,
               type = typeof value,
               isValidValue = type === "string" || Array.isArray( value );
   
           if ( isFunction( value ) ) {
               return this.each( function( i ) {
                   jQuery( this ).toggleClass(
                       value.call( this, i, getClass( this ), stateVal ),
                       stateVal
                   );
               } );
           }
   
           if ( typeof stateVal === "boolean" && isValidValue ) {
               return stateVal ? this.addClass( value ) : this.removeClass( value );
           }
   
           classNames = classesToArray( value );
   
           return this.each( function() {
               if ( isValidValue ) {
   
                   // Toggle individual class names
                   self = jQuery( this );
   
                   for ( i = 0; i < classNames.length; i++ ) {
                       className = classNames[ i ];
   
                       // Check each className given, space separated list
                       if ( self.hasClass( className ) ) {
                           self.removeClass( className );
                       } else {
                           self.addClass( className );
                       }
                   }
   
               // Toggle whole class name
               } else if ( value === undefined || type === "boolean" ) {
                   className = getClass( this );
                   if ( className ) {
   
                       // Store className if set
                       dataPriv.set( this, "__className__", className );
                   }
   
                   // If the element has a class name or if we're passed `false`,
                   // then remove the whole classname (if there was one, the above saved it).
                   // Otherwise bring back whatever was previously saved (if anything),
                   // falling back to the empty string if nothing was stored.
                   if ( this.setAttribute ) {
                       this.setAttribute( "class",
                           className || value === false ?
                               "" :
                               dataPriv.get( this, "__className__" ) || ""
                       );
                   }
               }
           } );
       },
   
       hasClass: function( selector ) {
           var className, elem,
               i = 0;
   
           className = " " + selector + " ";
           while ( ( elem = this[ i++ ] ) ) {
               if ( elem.nodeType === 1 &&
                   ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                   return true;
               }
           }
   
           return false;
       }
   } );
   
   
   
   
   var rreturn = /\r/g;
   
   jQuery.fn.extend( {
       val: function( value ) {
           var hooks, ret, valueIsFunction,
               elem = this[ 0 ];
   
           if ( !arguments.length ) {
               if ( elem ) {
                   hooks = jQuery.valHooks[ elem.type ] ||
                       jQuery.valHooks[ elem.nodeName.toLowerCase() ];
   
                   if ( hooks &&
                       "get" in hooks &&
                       ( ret = hooks.get( elem, "value" ) ) !== undefined
                   ) {
                       return ret;
                   }
   
                   ret = elem.value;
   
                   // Handle most common string cases
                   if ( typeof ret === "string" ) {
                       return ret.replace( rreturn, "" );
                   }
   
                   // Handle cases where value is null/undef or number
                   return ret == null ? "" : ret;
               }
   
               return;
           }
   
           valueIsFunction = isFunction( value );
   
           return this.each( function( i ) {
               var val;
   
               if ( this.nodeType !== 1 ) {
                   return;
               }
   
               if ( valueIsFunction ) {
                   val = value.call( this, i, jQuery( this ).val() );
               } else {
                   val = value;
               }
   
               // Treat null/undefined as ""; convert numbers to string
               if ( val == null ) {
                   val = "";
   
               } else if ( typeof val === "number" ) {
                   val += "";
   
               } else if ( Array.isArray( val ) ) {
                   val = jQuery.map( val, function( value ) {
                       return value == null ? "" : value + "";
                   } );
               }
   
               hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
   
               // If set returns undefined, fall back to normal setting
               if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                   this.value = val;
               }
           } );
       }
   } );
   
   jQuery.extend( {
       valHooks: {
           option: {
               get: function( elem ) {
   
                   var val = jQuery.find.attr( elem, "value" );
                   return val != null ?
                       val :
   
                       // Support: IE <=10 - 11 only
                       // option.text throws exceptions (trac-14686, trac-14858)
                       // Strip and collapse whitespace
                       // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                       stripAndCollapse( jQuery.text( elem ) );
               }
           },
           select: {
               get: function( elem ) {
                   var value, option, i,
                       options = elem.options,
                       index = elem.selectedIndex,
                       one = elem.type === "select-one",
                       values = one ? null : [],
                       max = one ? index + 1 : options.length;
   
                   if ( index < 0 ) {
                       i = max;
   
                   } else {
                       i = one ? index : 0;
                   }
   
                   // Loop through all the selected options
                   for ( ; i < max; i++ ) {
                       option = options[ i ];
   
                       // Support: IE <=9 only
                       // IE8-9 doesn't update selected after form reset (trac-2551)
                       if ( ( option.selected || i === index ) &&
   
                               // Don't return options that are disabled or in a disabled optgroup
                               !option.disabled &&
                               ( !option.parentNode.disabled ||
                                   !nodeName( option.parentNode, "optgroup" ) ) ) {
   
                           // Get the specific value for the option
                           value = jQuery( option ).val();
   
                           // We don't need an array for one selects
                           if ( one ) {
                               return value;
                           }
   
                           // Multi-Selects return an array
                           values.push( value );
                       }
                   }
   
                   return values;
               },
   
               set: function( elem, value ) {
                   var optionSet, option,
                       options = elem.options,
                       values = jQuery.makeArray( value ),
                       i = options.length;
   
                   while ( i-- ) {
                       option = options[ i ];
   
                       /* eslint-disable no-cond-assign */
   
                       if ( option.selected =
                           jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                       ) {
                           optionSet = true;
                       }
   
                       /* eslint-enable no-cond-assign */
                   }
   
                   // Force browsers to behave consistently when non-matching value is set
                   if ( !optionSet ) {
                       elem.selectedIndex = -1;
                   }
                   return values;
               }
           }
       }
   } );
   
   // Radios and checkboxes getter/setter
   jQuery.each( [ "radio", "checkbox" ], function() {
       jQuery.valHooks[ this ] = {
           set: function( elem, value ) {
               if ( Array.isArray( value ) ) {
                   return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
               }
           }
       };
       if ( !support.checkOn ) {
           jQuery.valHooks[ this ].get = function( elem ) {
               return elem.getAttribute( "value" ) === null ? "on" : elem.value;
           };
       }
   } );
   
   
   
   
   // Return jQuery for attributes-only inclusion
   
   
   support.focusin = "onfocusin" in window;
   
   
   var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
       stopPropagationCallback = function( e ) {
           e.stopPropagation();
       };
   
   jQuery.extend( jQuery.event, {
   
       trigger: function( event, data, elem, onlyHandlers ) {
   
           var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
               eventPath = [ elem || document ],
               type = hasOwn.call( event, "type" ) ? event.type : event,
               namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
   
           cur = lastElement = tmp = elem = elem || document;
   
           // Don't do events on text and comment nodes
           if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
               return;
           }
   
           // focus/blur morphs to focusin/out; ensure we're not firing them right now
           if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
               return;
           }
   
           if ( type.indexOf( "." ) > -1 ) {
   
               // Namespaced trigger; create a regexp to match event type in handle()
               namespaces = type.split( "." );
               type = namespaces.shift();
               namespaces.sort();
           }
           ontype = type.indexOf( ":" ) < 0 && "on" + type;
   
           // Caller can pass in a jQuery.Event object, Object, or just an event type string
           event = event[ jQuery.expando ] ?
               event :
               new jQuery.Event( type, typeof event === "object" && event );
   
           // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
           event.isTrigger = onlyHandlers ? 2 : 3;
           event.namespace = namespaces.join( "." );
           event.rnamespace = event.namespace ?
               new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
               null;
   
           // Clean up the event in case it is being reused
           event.result = undefined;
           if ( !event.target ) {
               event.target = elem;
           }
   
           // Clone any incoming data and prepend the event, creating the handler arg list
           data = data == null ?
               [ event ] :
               jQuery.makeArray( data, [ event ] );
   
           // Allow special events to draw outside the lines
           special = jQuery.event.special[ type ] || {};
           if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
               return;
           }
   
           // Determine event propagation path in advance, per W3C events spec (trac-9951)
           // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
           if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
   
               bubbleType = special.delegateType || type;
               if ( !rfocusMorph.test( bubbleType + type ) ) {
                   cur = cur.parentNode;
               }
               for ( ; cur; cur = cur.parentNode ) {
                   eventPath.push( cur );
                   tmp = cur;
               }
   
               // Only add window if we got to document (e.g., not plain obj or detached DOM)
               if ( tmp === ( elem.ownerDocument || document ) ) {
                   eventPath.push( tmp.defaultView || tmp.parentWindow || window );
               }
           }
   
           // Fire handlers on the event path
           i = 0;
           while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
               lastElement = cur;
               event.type = i > 1 ?
                   bubbleType :
                   special.bindType || type;
   
               // jQuery handler
               handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
                   dataPriv.get( cur, "handle" );
               if ( handle ) {
                   handle.apply( cur, data );
               }
   
               // Native handler
               handle = ontype && cur[ ontype ];
               if ( handle && handle.apply && acceptData( cur ) ) {
                   event.result = handle.apply( cur, data );
                   if ( event.result === false ) {
                       event.preventDefault();
                   }
               }
           }
           event.type = type;
   
           // If nobody prevented the default action, do it now
           if ( !onlyHandlers && !event.isDefaultPrevented() ) {
   
               if ( ( !special._default ||
                   special._default.apply( eventPath.pop(), data ) === false ) &&
                   acceptData( elem ) ) {
   
                   // Call a native DOM method on the target with the same name as the event.
                   // Don't do default actions on window, that's where global variables be (trac-6170)
                   if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
   
                       // Don't re-trigger an onFOO event when we call its FOO() method
                       tmp = elem[ ontype ];
   
                       if ( tmp ) {
                           elem[ ontype ] = null;
                       }
   
                       // Prevent re-triggering of the same event, since we already bubbled it above
                       jQuery.event.triggered = type;
   
                       if ( event.isPropagationStopped() ) {
                           lastElement.addEventListener( type, stopPropagationCallback );
                       }
   
                       elem[ type ]();
   
                       if ( event.isPropagationStopped() ) {
                           lastElement.removeEventListener( type, stopPropagationCallback );
                       }
   
                       jQuery.event.triggered = undefined;
   
                       if ( tmp ) {
                           elem[ ontype ] = tmp;
                       }
                   }
               }
           }
   
           return event.result;
       },
   
       // Piggyback on a donor event to simulate a different one
       // Used only for `focus(in | out)` events
       simulate: function( type, elem, event ) {
           var e = jQuery.extend(
               new jQuery.Event(),
               event,
               {
                   type: type,
                   isSimulated: true
               }
           );
   
           jQuery.event.trigger( e, null, elem );
       }
   
   } );
   
   jQuery.fn.extend( {
   
       trigger: function( type, data ) {
           return this.each( function() {
               jQuery.event.trigger( type, data, this );
           } );
       },
       triggerHandler: function( type, data ) {
           var elem = this[ 0 ];
           if ( elem ) {
               return jQuery.event.trigger( type, data, elem, true );
           }
       }
   } );
   
   
   // Support: Firefox <=44
   // Firefox doesn't have focus(in | out) events
   // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
   //
   // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
   // focus(in | out) events fire after focus & blur events,
   // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
   // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
   if ( !support.focusin ) {
       jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
   
           // Attach a single capturing handler on the document while someone wants focusin/focusout
           var handler = function( event ) {
               jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
           };
   
           jQuery.event.special[ fix ] = {
               setup: function() {
   
                   // Handle: regular nodes (via `this.ownerDocument`), window
                   // (via `this.document`) & document (via `this`).
                   var doc = this.ownerDocument || this.document || this,
                       attaches = dataPriv.access( doc, fix );
   
                   if ( !attaches ) {
                       doc.addEventListener( orig, handler, true );
                   }
                   dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
               },
               teardown: function() {
                   var doc = this.ownerDocument || this.document || this,
                       attaches = dataPriv.access( doc, fix ) - 1;
   
                   if ( !attaches ) {
                       doc.removeEventListener( orig, handler, true );
                       dataPriv.remove( doc, fix );
   
                   } else {
                       dataPriv.access( doc, fix, attaches );
                   }
               }
           };
       } );
   }
   var location = window.location;
   
   var nonce = { guid: Date.now() };
   
   var rquery = ( /\?/ );
   
   
   
   // Cross-browser xml parsing
   jQuery.parseXML = function( data ) {
       var xml, parserErrorElem;
       if ( !data || typeof data !== "string" ) {
           return null;
       }
   
       // Support: IE 9 - 11 only
       // IE throws on parseFromString with invalid input.
       try {
           xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
       } catch ( e ) {}
   
       parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
       if ( !xml || parserErrorElem ) {
           jQuery.error( "Invalid XML: " + (
               parserErrorElem ?
                   jQuery.map( parserErrorElem.childNodes, function( el ) {
                       return el.textContent;
                   } ).join( "\n" ) :
                   data
           ) );
       }
       return xml;
   };
   
   
   var
       rbracket = /\[\]$/,
       rCRLF = /\r?\n/g,
       rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
       rsubmittable = /^(?:input|select|textarea|keygen)/i;
   
   function buildParams( prefix, obj, traditional, add ) {
       var name;
   
       if ( Array.isArray( obj ) ) {
   
           // Serialize array item.
           jQuery.each( obj, function( i, v ) {
               if ( traditional || rbracket.test( prefix ) ) {
   
                   // Treat each array item as a scalar.
                   add( prefix, v );
   
               } else {
   
                   // Item is non-scalar (array or object), encode its numeric index.
                   buildParams(
                       prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                       v,
                       traditional,
                       add
                   );
               }
           } );
   
       } else if ( !traditional && toType( obj ) === "object" ) {
   
           // Serialize object item.
           for ( name in obj ) {
               buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
           }
   
       } else {
   
           // Serialize scalar item.
           add( prefix, obj );
       }
   }
   
   // Serialize an array of form elements or a set of
   // key/values into a query string
   jQuery.param = function( a, traditional ) {
       var prefix,
           s = [],
           add = function( key, valueOrFunction ) {
   
               // If value is a function, invoke it and use its return value
               var value = isFunction( valueOrFunction ) ?
                   valueOrFunction() :
                   valueOrFunction;
   
               s[ s.length ] = encodeURIComponent( key ) + "=" +
                   encodeURIComponent( value == null ? "" : value );
           };
   
       if ( a == null ) {
           return "";
       }
   
       // If an array was passed in, assume that it is an array of form elements.
       if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
   
           // Serialize the form elements
           jQuery.each( a, function() {
               add( this.name, this.value );
           } );
   
       } else {
   
           // If traditional, encode the "old" way (the way 1.3.2 or older
           // did it), otherwise encode params recursively.
           for ( prefix in a ) {
               buildParams( prefix, a[ prefix ], traditional, add );
           }
       }
   
       // Return the resulting serialization
       return s.join( "&" );
   };
   
   jQuery.fn.extend( {
       serialize: function() {
           return jQuery.param( this.serializeArray() );
       },
       serializeArray: function() {
           return this.map( function() {
   
               // Can add propHook for "elements" to filter or add form elements
               var elements = jQuery.prop( this, "elements" );
               return elements ? jQuery.makeArray( elements ) : this;
           } ).filter( function() {
               var type = this.type;
   
               // Use .is( ":disabled" ) so that fieldset[disabled] works
               return this.name && !jQuery( this ).is( ":disabled" ) &&
                   rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                   ( this.checked || !rcheckableType.test( type ) );
           } ).map( function( _i, elem ) {
               var val = jQuery( this ).val();
   
               if ( val == null ) {
                   return null;
               }
   
               if ( Array.isArray( val ) ) {
                   return jQuery.map( val, function( val ) {
                       return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                   } );
               }
   
               return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
           } ).get();
       }
   } );
   
   
   var
       r20 = /%20/g,
       rhash = /#.*$/,
       rantiCache = /([?&])_=[^&]*/,
       rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
   
       // trac-7653, trac-8125, trac-8152: local protocol detection
       rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
       rnoContent = /^(?:GET|HEAD)$/,
       rprotocol = /^\/\//,
   
       /* Prefilters
        * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
        * 2) These are called:
        *    - BEFORE asking for a transport
        *    - AFTER param serialization (s.data is a string if s.processData is true)
        * 3) key is the dataType
        * 4) the catchall symbol "*" can be used
        * 5) execution will start with transport dataType and THEN continue down to "*" if needed
        */
       prefilters = {},
   
       /* Transports bindings
        * 1) key is the dataType
        * 2) the catchall symbol "*" can be used
        * 3) selection will start with transport dataType and THEN go to "*" if needed
        */
       transports = {},
   
       // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
       allTypes = "*/".concat( "*" ),
   
       // Anchor tag for parsing the document origin
       originAnchor = document.createElement( "a" );
   
   originAnchor.href = location.href;
   
   // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
   function addToPrefiltersOrTransports( structure ) {
   
       // dataTypeExpression is optional and defaults to "*"
       return function( dataTypeExpression, func ) {
   
           if ( typeof dataTypeExpression !== "string" ) {
               func = dataTypeExpression;
               dataTypeExpression = "*";
           }
   
           var dataType,
               i = 0,
               dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
   
           if ( isFunction( func ) ) {
   
               // For each dataType in the dataTypeExpression
               while ( ( dataType = dataTypes[ i++ ] ) ) {
   
                   // Prepend if requested
                   if ( dataType[ 0 ] === "+" ) {
                       dataType = dataType.slice( 1 ) || "*";
                       ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
   
                   // Otherwise append
                   } else {
                       ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                   }
               }
           }
       };
   }
   
   // Base inspection function for prefilters and transports
   function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
   
       var inspected = {},
           seekingTransport = ( structure === transports );
   
       function inspect( dataType ) {
           var selected;
           inspected[ dataType ] = true;
           jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
               var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
               if ( typeof dataTypeOrTransport === "string" &&
                   !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
   
                   options.dataTypes.unshift( dataTypeOrTransport );
                   inspect( dataTypeOrTransport );
                   return false;
               } else if ( seekingTransport ) {
                   return !( selected = dataTypeOrTransport );
               }
           } );
           return selected;
       }
   
       return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
   }
   
   // A special extend for ajax options
   // that takes "flat" options (not to be deep extended)
   // Fixes trac-9887
   function ajaxExtend( target, src ) {
       var key, deep,
           flatOptions = jQuery.ajaxSettings.flatOptions || {};
   
       for ( key in src ) {
           if ( src[ key ] !== undefined ) {
               ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
           }
       }
       if ( deep ) {
           jQuery.extend( true, target, deep );
       }
   
       return target;
   }
   
   /* Handles responses to an ajax request:
    * - finds the right dataType (mediates between content-type and expected dataType)
    * - returns the corresponding response
    */
   function ajaxHandleResponses( s, jqXHR, responses ) {
   
       var ct, type, finalDataType, firstDataType,
           contents = s.contents,
           dataTypes = s.dataTypes;
   
       // Remove auto dataType and get content-type in the process
       while ( dataTypes[ 0 ] === "*" ) {
           dataTypes.shift();
           if ( ct === undefined ) {
               ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
           }
       }
   
       // Check if we're dealing with a known content-type
       if ( ct ) {
           for ( type in contents ) {
               if ( contents[ type ] && contents[ type ].test( ct ) ) {
                   dataTypes.unshift( type );
                   break;
               }
           }
       }
   
       // Check to see if we have a response for the expected dataType
       if ( dataTypes[ 0 ] in responses ) {
           finalDataType = dataTypes[ 0 ];
       } else {
   
           // Try convertible dataTypes
           for ( type in responses ) {
               if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                   finalDataType = type;
                   break;
               }
               if ( !firstDataType ) {
                   firstDataType = type;
               }
           }
   
           // Or just use first one
           finalDataType = finalDataType || firstDataType;
       }
   
       // If we found a dataType
       // We add the dataType to the list if needed
       // and return the corresponding response
       if ( finalDataType ) {
           if ( finalDataType !== dataTypes[ 0 ] ) {
               dataTypes.unshift( finalDataType );
           }
           return responses[ finalDataType ];
       }
   }
   
   /* Chain conversions given the request and the original response
    * Also sets the responseXXX fields on the jqXHR instance
    */
   function ajaxConvert( s, response, jqXHR, isSuccess ) {
       var conv2, current, conv, tmp, prev,
           converters = {},
   
           // Work with a copy of dataTypes in case we need to modify it for conversion
           dataTypes = s.dataTypes.slice();
   
       // Create converters map with lowercased keys
       if ( dataTypes[ 1 ] ) {
           for ( conv in s.converters ) {
               converters[ conv.toLowerCase() ] = s.converters[ conv ];
           }
       }
   
       current = dataTypes.shift();
   
       // Convert to each sequential dataType
       while ( current ) {
   
           if ( s.responseFields[ current ] ) {
               jqXHR[ s.responseFields[ current ] ] = response;
           }
   
           // Apply the dataFilter if provided
           if ( !prev && isSuccess && s.dataFilter ) {
               response = s.dataFilter( response, s.dataType );
           }
   
           prev = current;
           current = dataTypes.shift();
   
           if ( current ) {
   
               // There's only work to do if current dataType is non-auto
               if ( current === "*" ) {
   
                   current = prev;
   
               // Convert response if prev dataType is non-auto and differs from current
               } else if ( prev !== "*" && prev !== current ) {
   
                   // Seek a direct converter
                   conv = converters[ prev + " " + current ] || converters[ "* " + current ];
   
                   // If none found, seek a pair
                   if ( !conv ) {
                       for ( conv2 in converters ) {
   
                           // If conv2 outputs current
                           tmp = conv2.split( " " );
                           if ( tmp[ 1 ] === current ) {
   
                               // If prev can be converted to accepted input
                               conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                   converters[ "* " + tmp[ 0 ] ];
                               if ( conv ) {
   
                                   // Condense equivalence converters
                                   if ( conv === true ) {
                                       conv = converters[ conv2 ];
   
                                   // Otherwise, insert the intermediate dataType
                                   } else if ( converters[ conv2 ] !== true ) {
                                       current = tmp[ 0 ];
                                       dataTypes.unshift( tmp[ 1 ] );
                                   }
                                   break;
                               }
                           }
                       }
                   }
   
                   // Apply converter (if not an equivalence)
                   if ( conv !== true ) {
   
                       // Unless errors are allowed to bubble, catch and return them
                       if ( conv && s.throws ) {
                           response = conv( response );
                       } else {
                           try {
                               response = conv( response );
                           } catch ( e ) {
                               return {
                                   state: "parsererror",
                                   error: conv ? e : "No conversion from " + prev + " to " + current
                               };
                           }
                       }
                   }
               }
           }
       }
   
       return { state: "success", data: response };
   }
   
   jQuery.extend( {
   
       // Counter for holding the number of active queries
       active: 0,
   
       // Last-Modified header cache for next request
       lastModified: {},
       etag: {},
   
       ajaxSettings: {
           url: location.href,
           type: "GET",
           isLocal: rlocalProtocol.test( location.protocol ),
           global: true,
           processData: true,
           async: true,
           contentType: "application/x-www-form-urlencoded; charset=UTF-8",
   
           /*
           timeout: 0,
           data: null,
           dataType: null,
           username: null,
           password: null,
           cache: null,
           throws: false,
           traditional: false,
           headers: {},
           */
   
           accepts: {
               "*": allTypes,
               text: "text/plain",
               html: "text/html",
               xml: "application/xml, text/xml",
               json: "application/json, text/javascript"
           },
   
           contents: {
               xml: /\bxml\b/,
               html: /\bhtml/,
               json: /\bjson\b/
           },
   
           responseFields: {
               xml: "responseXML",
               text: "responseText",
               json: "responseJSON"
           },
   
           // Data converters
           // Keys separate source (or catchall "*") and destination types with a single space
           converters: {
   
               // Convert anything to text
               "* text": String,
   
               // Text to html (true = no transformation)
               "text html": true,
   
               // Evaluate text as a json expression
               "text json": JSON.parse,
   
               // Parse text as xml
               "text xml": jQuery.parseXML
           },
   
           // For options that shouldn't be deep extended:
           // you can add your own custom options here if
           // and when you create one that shouldn't be
           // deep extended (see ajaxExtend)
           flatOptions: {
               url: true,
               context: true
           }
       },
   
       // Creates a full fledged settings object into target
       // with both ajaxSettings and settings fields.
       // If target is omitted, writes into ajaxSettings.
       ajaxSetup: function( target, settings ) {
           return settings ?
   
               // Building a settings object
               ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
   
               // Extending ajaxSettings
               ajaxExtend( jQuery.ajaxSettings, target );
       },
   
       ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
       ajaxTransport: addToPrefiltersOrTransports( transports ),
   
       // Main method
       ajax: function( url, options ) {
   
           // If url is an object, simulate pre-1.5 signature
           if ( typeof url === "object" ) {
               options = url;
               url = undefined;
           }
   
           // Force options to be an object
           options = options || {};
   
           var transport,
   
               // URL without anti-cache param
               cacheURL,
   
               // Response headers
               responseHeadersString,
               responseHeaders,
   
               // timeout handle
               timeoutTimer,
   
               // Url cleanup var
               urlAnchor,
   
               // Request state (becomes false upon send and true upon completion)
               completed,
   
               // To know if global events are to be dispatched
               fireGlobals,
   
               // Loop variable
               i,
   
               // uncached part of the url
               uncached,
   
               // Create the final options object
               s = jQuery.ajaxSetup( {}, options ),
   
               // Callbacks context
               callbackContext = s.context || s,
   
               // Context for global events is callbackContext if it is a DOM node or jQuery collection
               globalEventContext = s.context &&
                   ( callbackContext.nodeType || callbackContext.jquery ) ?
                   jQuery( callbackContext ) :
                   jQuery.event,
   
               // Deferreds
               deferred = jQuery.Deferred(),
               completeDeferred = jQuery.Callbacks( "once memory" ),
   
               // Status-dependent callbacks
               statusCode = s.statusCode || {},
   
               // Headers (they are sent all at once)
               requestHeaders = {},
               requestHeadersNames = {},
   
               // Default abort message
               strAbort = "canceled",
   
               // Fake xhr
               jqXHR = {
                   readyState: 0,
   
                   // Builds headers hashtable if needed
                   getResponseHeader: function( key ) {
                       var match;
                       if ( completed ) {
                           if ( !responseHeaders ) {
                               responseHeaders = {};
                               while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                   responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
                                       ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
                                           .concat( match[ 2 ] );
                               }
                           }
                           match = responseHeaders[ key.toLowerCase() + " " ];
                       }
                       return match == null ? null : match.join( ", " );
                   },
   
                   // Raw string
                   getAllResponseHeaders: function() {
                       return completed ? responseHeadersString : null;
                   },
   
                   // Caches the header
                   setRequestHeader: function( name, value ) {
                       if ( completed == null ) {
                           name = requestHeadersNames[ name.toLowerCase() ] =
                               requestHeadersNames[ name.toLowerCase() ] || name;
                           requestHeaders[ name ] = value;
                       }
                       return this;
                   },
   
                   // Overrides response content-type header
                   overrideMimeType: function( type ) {
                       if ( completed == null ) {
                           s.mimeType = type;
                       }
                       return this;
                   },
   
                   // Status-dependent callbacks
                   statusCode: function( map ) {
                       var code;
                       if ( map ) {
                           if ( completed ) {
   
                               // Execute the appropriate callbacks
                               jqXHR.always( map[ jqXHR.status ] );
                           } else {
   
                               // Lazy-add the new callbacks in a way that preserves old ones
                               for ( code in map ) {
                                   statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                               }
                           }
                       }
                       return this;
                   },
   
                   // Cancel the request
                   abort: function( statusText ) {
                       var finalText = statusText || strAbort;
                       if ( transport ) {
                           transport.abort( finalText );
                       }
                       done( 0, finalText );
                       return this;
                   }
               };
   
           // Attach deferreds
           deferred.promise( jqXHR );
   
           // Add protocol if not provided (prefilters might expect it)
           // Handle falsy url in the settings object (trac-10093: consistency with old signature)
           // We also use the url parameter if available
           s.url = ( ( url || s.url || location.href ) + "" )
               .replace( rprotocol, location.protocol + "//" );
   
           // Alias method option to type as per ticket trac-12004
           s.type = options.method || options.type || s.method || s.type;
   
           // Extract dataTypes list
           s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
   
           // A cross-domain request is in order when the origin doesn't match the current origin.
           if ( s.crossDomain == null ) {
               urlAnchor = document.createElement( "a" );
   
               // Support: IE <=8 - 11, Edge 12 - 15
               // IE throws exception on accessing the href property if url is malformed,
               // e.g. http://example.com:80x/
               try {
                   urlAnchor.href = s.url;
   
                   // Support: IE <=8 - 11 only
                   // Anchor's host property isn't correctly set when s.url is relative
                   urlAnchor.href = urlAnchor.href;
                   s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                       urlAnchor.protocol + "//" + urlAnchor.host;
               } catch ( e ) {
   
                   // If there is an error parsing the URL, assume it is crossDomain,
                   // it can be rejected by the transport if it is invalid
                   s.crossDomain = true;
               }
           }
   
           // Convert data if not already a string
           if ( s.data && s.processData && typeof s.data !== "string" ) {
               s.data = jQuery.param( s.data, s.traditional );
           }
   
           // Apply prefilters
           inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
   
           // If request was aborted inside a prefilter, stop there
           if ( completed ) {
               return jqXHR;
           }
   
           // We can fire global events as of now if asked to
           // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
           fireGlobals = jQuery.event && s.global;
   
           // Watch for a new set of requests
           if ( fireGlobals && jQuery.active++ === 0 ) {
               jQuery.event.trigger( "ajaxStart" );
           }
   
           // Uppercase the type
           s.type = s.type.toUpperCase();
   
           // Determine if request has content
           s.hasContent = !rnoContent.test( s.type );
   
           // Save the URL in case we're toying with the If-Modified-Since
           // and/or If-None-Match header later on
           // Remove hash to simplify url manipulation
           cacheURL = s.url.replace( rhash, "" );
   
           // More options handling for requests with no content
           if ( !s.hasContent ) {
   
               // Remember the hash so we can put it back
               uncached = s.url.slice( cacheURL.length );
   
               // If data is available and should be processed, append data to url
               if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
                   cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
   
                   // trac-9682: remove data so that it's not used in an eventual retry
                   delete s.data;
               }
   
               // Add or update anti-cache param if needed
               if ( s.cache === false ) {
                   cacheURL = cacheURL.replace( rantiCache, "$1" );
                   uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
                       uncached;
               }
   
               // Put hash and anti-cache on the URL that will be requested (gh-1732)
               s.url = cacheURL + uncached;
   
           // Change '%20' to '+' if this is encoded form body content (gh-2658)
           } else if ( s.data && s.processData &&
               ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
               s.data = s.data.replace( r20, "+" );
           }
   
           // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
           if ( s.ifModified ) {
               if ( jQuery.lastModified[ cacheURL ] ) {
                   jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
               }
               if ( jQuery.etag[ cacheURL ] ) {
                   jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
               }
           }
   
           // Set the correct header, if data is being sent
           if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
               jqXHR.setRequestHeader( "Content-Type", s.contentType );
           }
   
           // Set the Accepts header for the server, depending on the dataType
           jqXHR.setRequestHeader(
               "Accept",
               s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                   s.accepts[ s.dataTypes[ 0 ] ] +
                       ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                   s.accepts[ "*" ]
           );
   
           // Check for headers option
           for ( i in s.headers ) {
               jqXHR.setRequestHeader( i, s.headers[ i ] );
           }
   
           // Allow custom headers/mimetypes and early abort
           if ( s.beforeSend &&
               ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
   
               // Abort if not done already and return
               return jqXHR.abort();
           }
   
           // Aborting is no longer a cancellation
           strAbort = "abort";
   
           // Install callbacks on deferreds
           completeDeferred.add( s.complete );
           jqXHR.done( s.success );
           jqXHR.fail( s.error );
   
           // Get transport
           transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
   
           // If no transport, we auto-abort
           if ( !transport ) {
               done( -1, "No Transport" );
           } else {
               jqXHR.readyState = 1;
   
               // Send global event
               if ( fireGlobals ) {
                   globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
               }
   
               // If request was aborted inside ajaxSend, stop there
               if ( completed ) {
                   return jqXHR;
               }
   
               // Timeout
               if ( s.async && s.timeout > 0 ) {
                   timeoutTimer = window.setTimeout( function() {
                       jqXHR.abort( "timeout" );
                   }, s.timeout );
               }
   
               try {
                   completed = false;
                   transport.send( requestHeaders, done );
               } catch ( e ) {
   
                   // Rethrow post-completion exceptions
                   if ( completed ) {
                       throw e;
                   }
   
                   // Propagate others as results
                   done( -1, e );
               }
           }
   
           // Callback for when everything is done
           function done( status, nativeStatusText, responses, headers ) {
               var isSuccess, success, error, response, modified,
                   statusText = nativeStatusText;
   
               // Ignore repeat invocations
               if ( completed ) {
                   return;
               }
   
               completed = true;
   
               // Clear timeout if it exists
               if ( timeoutTimer ) {
                   window.clearTimeout( timeoutTimer );
               }
   
               // Dereference transport for early garbage collection
               // (no matter how long the jqXHR object will be used)
               transport = undefined;
   
               // Cache response headers
               responseHeadersString = headers || "";
   
               // Set readyState
               jqXHR.readyState = status > 0 ? 4 : 0;
   
               // Determine if successful
               isSuccess = status >= 200 && status < 300 || status === 304;
   
               // Get response data
               if ( responses ) {
                   response = ajaxHandleResponses( s, jqXHR, responses );
               }
   
               // Use a noop converter for missing script but not if jsonp
               if ( !isSuccess &&
                   jQuery.inArray( "script", s.dataTypes ) > -1 &&
                   jQuery.inArray( "json", s.dataTypes ) < 0 ) {
                   s.converters[ "text script" ] = function() {};
               }
   
               // Convert no matter what (that way responseXXX fields are always set)
               response = ajaxConvert( s, response, jqXHR, isSuccess );
   
               // If successful, handle type chaining
               if ( isSuccess ) {
   
                   // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                   if ( s.ifModified ) {
                       modified = jqXHR.getResponseHeader( "Last-Modified" );
                       if ( modified ) {
                           jQuery.lastModified[ cacheURL ] = modified;
                       }
                       modified = jqXHR.getResponseHeader( "etag" );
                       if ( modified ) {
                           jQuery.etag[ cacheURL ] = modified;
                       }
                   }
   
                   // if no content
                   if ( status === 204 || s.type === "HEAD" ) {
                       statusText = "nocontent";
   
                   // if not modified
                   } else if ( status === 304 ) {
                       statusText = "notmodified";
   
                   // If we have data, let's convert it
                   } else {
                       statusText = response.state;
                       success = response.data;
                       error = response.error;
                       isSuccess = !error;
                   }
               } else {
   
                   // Extract error from statusText and normalize for non-aborts
                   error = statusText;
                   if ( status || !statusText ) {
                       statusText = "error";
                       if ( status < 0 ) {
                           status = 0;
                       }
                   }
               }
   
               // Set data for the fake xhr object
               jqXHR.status = status;
               jqXHR.statusText = ( nativeStatusText || statusText ) + "";
   
               // Success/Error
               if ( isSuccess ) {
                   deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
               } else {
                   deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
               }
   
               // Status-dependent callbacks
               jqXHR.statusCode( statusCode );
               statusCode = undefined;
   
               if ( fireGlobals ) {
                   globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                       [ jqXHR, s, isSuccess ? success : error ] );
               }
   
               // Complete
               completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
   
               if ( fireGlobals ) {
                   globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
   
                   // Handle the global AJAX counter
                   if ( !( --jQuery.active ) ) {
                       jQuery.event.trigger( "ajaxStop" );
                   }
               }
           }
   
           return jqXHR;
       },
   
       getJSON: function( url, data, callback ) {
           return jQuery.get( url, data, callback, "json" );
       },
   
       getScript: function( url, callback ) {
           return jQuery.get( url, undefined, callback, "script" );
       }
   } );
   
   jQuery.each( [ "get", "post" ], function( _i, method ) {
       jQuery[ method ] = function( url, data, callback, type ) {
   
           // Shift arguments if data argument was omitted
           if ( isFunction( data ) ) {
               type = type || callback;
               callback = data;
               data = undefined;
           }
   
           // The url can be an options object (which then must have .url)
           return jQuery.ajax( jQuery.extend( {
               url: url,
               type: method,
               dataType: type,
               data: data,
               success: callback
           }, jQuery.isPlainObject( url ) && url ) );
       };
   } );
   
   jQuery.ajaxPrefilter( function( s ) {
       var i;
       for ( i in s.headers ) {
           if ( i.toLowerCase() === "content-type" ) {
               s.contentType = s.headers[ i ] || "";
           }
       }
   } );
   
   
   jQuery._evalUrl = function( url, options, doc ) {
       return jQuery.ajax( {
           url: url,
   
           // Make this explicit, since user can override this through ajaxSetup (trac-11264)
           type: "GET",
           dataType: "script",
           cache: true,
           async: false,
           global: false,
   
           // Only evaluate the response if it is successful (gh-4126)
           // dataFilter is not invoked for failure responses, so using it instead
           // of the default converter is kludgy but it works.
           converters: {
               "text script": function() {}
           },
           dataFilter: function( response ) {
               jQuery.globalEval( response, options, doc );
           }
       } );
   };
   
   
   jQuery.fn.extend( {
       wrapAll: function( html ) {
           var wrap;
   
           if ( this[ 0 ] ) {
               if ( isFunction( html ) ) {
                   html = html.call( this[ 0 ] );
               }
   
               // The elements to wrap the target around
               wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
   
               if ( this[ 0 ].parentNode ) {
                   wrap.insertBefore( this[ 0 ] );
               }
   
               wrap.map( function() {
                   var elem = this;
   
                   while ( elem.firstElementChild ) {
                       elem = elem.firstElementChild;
                   }
   
                   return elem;
               } ).append( this );
           }
   
           return this;
       },
   
       wrapInner: function( html ) {
           if ( isFunction( html ) ) {
               return this.each( function( i ) {
                   jQuery( this ).wrapInner( html.call( this, i ) );
               } );
           }
   
           return this.each( function() {
               var self = jQuery( this ),
                   contents = self.contents();
   
               if ( contents.length ) {
                   contents.wrapAll( html );
   
               } else {
                   self.append( html );
               }
           } );
       },
   
       wrap: function( html ) {
           var htmlIsFunction = isFunction( html );
   
           return this.each( function( i ) {
               jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
           } );
       },
   
       unwrap: function( selector ) {
           this.parent( selector ).not( "body" ).each( function() {
               jQuery( this ).replaceWith( this.childNodes );
           } );
           return this;
       }
   } );
   
   
   jQuery.expr.pseudos.hidden = function( elem ) {
       return !jQuery.expr.pseudos.visible( elem );
   };
   jQuery.expr.pseudos.visible = function( elem ) {
       return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
   };
   
   
   
   
   jQuery.ajaxSettings.xhr = function() {
       try {
           return new window.XMLHttpRequest();
       } catch ( e ) {}
   };
   
   var xhrSuccessStatus = {
   
           // File protocol always yields status code 0, assume 200
           0: 200,
   
           // Support: IE <=9 only
           // trac-1450: sometimes IE returns 1223 when it should be 204
           1223: 204
       },
       xhrSupported = jQuery.ajaxSettings.xhr();
   
   support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
   support.ajax = xhrSupported = !!xhrSupported;
   
   jQuery.ajaxTransport( function( options ) {
       var callback, errorCallback;
   
       // Cross domain only allowed if supported through XMLHttpRequest
       if ( support.cors || xhrSupported && !options.crossDomain ) {
           return {
               send: function( headers, complete ) {
                   var i,
                       xhr = options.xhr();
   
                   xhr.open(
                       options.type,
                       options.url,
                       options.async,
                       options.username,
                       options.password
                   );
   
                   // Apply custom fields if provided
                   if ( options.xhrFields ) {
                       for ( i in options.xhrFields ) {
                           xhr[ i ] = options.xhrFields[ i ];
                       }
                   }
   
                   // Override mime type if needed
                   if ( options.mimeType && xhr.overrideMimeType ) {
                       xhr.overrideMimeType( options.mimeType );
                   }
   
                   // X-Requested-With header
                   // For cross-domain requests, seeing as conditions for a preflight are
                   // akin to a jigsaw puzzle, we simply never set it to be sure.
                   // (it can always be set on a per-request basis or even using ajaxSetup)
                   // For same-domain requests, won't change header if already provided.
                   if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                       headers[ "X-Requested-With" ] = "XMLHttpRequest";
                   }
   
                   // Set headers
                   for ( i in headers ) {
                       xhr.setRequestHeader( i, headers[ i ] );
                   }
   
                   // Callback
                   callback = function( type ) {
                       return function() {
                           if ( callback ) {
                               callback = errorCallback = xhr.onload =
                                   xhr.onerror = xhr.onabort = xhr.ontimeout =
                                       xhr.onreadystatechange = null;
   
                               if ( type === "abort" ) {
                                   xhr.abort();
                               } else if ( type === "error" ) {
   
                                   // Support: IE <=9 only
                                   // On a manual native abort, IE9 throws
                                   // errors on any property access that is not readyState
                                   if ( typeof xhr.status !== "number" ) {
                                       complete( 0, "error" );
                                   } else {
                                       complete(
   
                                           // File: protocol always yields status 0; see trac-8605, trac-14207
                                           xhr.status,
                                           xhr.statusText
                                       );
                                   }
                               } else {
                                   complete(
                                       xhrSuccessStatus[ xhr.status ] || xhr.status,
                                       xhr.statusText,
   
                                       // Support: IE <=9 only
                                       // IE9 has no XHR2 but throws on binary (trac-11426)
                                       // For XHR2 non-text, let the caller handle it (gh-2498)
                                       ( xhr.responseType || "text" ) !== "text"  ||
                                       typeof xhr.responseText !== "string" ?
                                           { binary: xhr.response } :
                                           { text: xhr.responseText },
                                       xhr.getAllResponseHeaders()
                                   );
                               }
                           }
                       };
                   };
   
                   // Listen to events
                   xhr.onload = callback();
                   errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
   
                   // Support: IE 9 only
                   // Use onreadystatechange to replace onabort
                   // to handle uncaught aborts
                   if ( xhr.onabort !== undefined ) {
                       xhr.onabort = errorCallback;
                   } else {
                       xhr.onreadystatechange = function() {
   
                           // Check readyState before timeout as it changes
                           if ( xhr.readyState === 4 ) {
   
                               // Allow onerror to be called first,
                               // but that will not handle a native abort
                               // Also, save errorCallback to a variable
                               // as xhr.onerror cannot be accessed
                               window.setTimeout( function() {
                                   if ( callback ) {
                                       errorCallback();
                                   }
                               } );
                           }
                       };
                   }
   
                   // Create the abort callback
                   callback = callback( "abort" );
   
                   try {
   
                       // Do send the request (this may raise an exception)
                       xhr.send( options.hasContent && options.data || null );
                   } catch ( e ) {
   
                       // trac-14683: Only rethrow if this hasn't been notified as an error yet
                       if ( callback ) {
                           throw e;
                       }
                   }
               },
   
               abort: function() {
                   if ( callback ) {
                       callback();
                   }
               }
           };
       }
   } );
   
   
   
   
   // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
   jQuery.ajaxPrefilter( function( s ) {
       if ( s.crossDomain ) {
           s.contents.script = false;
       }
   } );
   
   // Install script dataType
   jQuery.ajaxSetup( {
       accepts: {
           script: "text/javascript, application/javascript, " +
               "application/ecmascript, application/x-ecmascript"
       },
       contents: {
           script: /\b(?:java|ecma)script\b/
       },
       converters: {
           "text script": function( text ) {
               jQuery.globalEval( text );
               return text;
           }
       }
   } );
   
   // Handle cache's special case and crossDomain
   jQuery.ajaxPrefilter( "script", function( s ) {
       if ( s.cache === undefined ) {
           s.cache = false;
       }
       if ( s.crossDomain ) {
           s.type = "GET";
       }
   } );
   
   // Bind script tag hack transport
   jQuery.ajaxTransport( "script", function( s ) {
   
       // This transport only deals with cross domain or forced-by-attrs requests
       if ( s.crossDomain || s.scriptAttrs ) {
           var script, callback;
           return {
               send: function( _, complete ) {
                   script = jQuery( "<script>" )
                       .attr( s.scriptAttrs || {} )
                       .prop( { charset: s.scriptCharset, src: s.url } )
                       .on( "load error", callback = function( evt ) {
                           script.remove();
                           callback = null;
                           if ( evt ) {
                               complete( evt.type === "error" ? 404 : 200, evt.type );
                           }
                       } );
   
                   // Use native DOM manipulation to avoid our domManip AJAX trickery
                   document.head.appendChild( script[ 0 ] );
               },
               abort: function() {
                   if ( callback ) {
                       callback();
                   }
               }
           };
       }
   } );
   
   
   
   
   var oldCallbacks = [],
       rjsonp = /(=)\?(?=&|$)|\?\?/;
   
   // Default jsonp settings
   jQuery.ajaxSetup( {
       jsonp: "callback",
       jsonpCallback: function() {
           var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
           this[ callback ] = true;
           return callback;
       }
   } );
   
   // Detect, normalize options and install callbacks for jsonp requests
   jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
   
       var callbackName, overwritten, responseContainer,
           jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
               "url" :
               typeof s.data === "string" &&
                   ( s.contentType || "" )
                       .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                   rjsonp.test( s.data ) && "data"
           );
   
       // Handle iff the expected data type is "jsonp" or we have a parameter to set
       if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
   
           // Get callback name, remembering preexisting value associated with it
           callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
               s.jsonpCallback() :
               s.jsonpCallback;
   
           // Insert callback into url or form data
           if ( jsonProp ) {
               s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
           } else if ( s.jsonp !== false ) {
               s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
           }
   
           // Use data converter to retrieve json after script execution
           s.converters[ "script json" ] = function() {
               if ( !responseContainer ) {
                   jQuery.error( callbackName + " was not called" );
               }
               return responseContainer[ 0 ];
           };
   
           // Force json dataType
           s.dataTypes[ 0 ] = "json";
   
           // Install callback
           overwritten = window[ callbackName ];
           window[ callbackName ] = function() {
               responseContainer = arguments;
           };
   
           // Clean-up function (fires after converters)
           jqXHR.always( function() {
   
               // If previous value didn't exist - remove it
               if ( overwritten === undefined ) {
                   jQuery( window ).removeProp( callbackName );
   
               // Otherwise restore preexisting value
               } else {
                   window[ callbackName ] = overwritten;
               }
   
               // Save back as free
               if ( s[ callbackName ] ) {
   
                   // Make sure that re-using the options doesn't screw things around
                   s.jsonpCallback = originalSettings.jsonpCallback;
   
                   // Save the callback name for future use
                   oldCallbacks.push( callbackName );
               }
   
               // Call if it was a function and we have a response
               if ( responseContainer && isFunction( overwritten ) ) {
                   overwritten( responseContainer[ 0 ] );
               }
   
               responseContainer = overwritten = undefined;
           } );
   
           // Delegate to script
           return "script";
       }
   } );
   
   
   
   
   // Support: Safari 8 only
   // In Safari 8 documents created via document.implementation.createHTMLDocument
   // collapse sibling forms: the second one becomes a child of the first one.
   // Because of that, this security measure has to be disabled in Safari 8.
   // https://bugs.webkit.org/show_bug.cgi?id=137337
   support.createHTMLDocument = ( function() {
       var body = document.implementation.createHTMLDocument( "" ).body;
       body.innerHTML = "<form></form><form></form>";
       return body.childNodes.length === 2;
   } )();
   
   
   // Argument "data" should be string of html
   // context (optional): If specified, the fragment will be created in this context,
   // defaults to document
   // keepScripts (optional): If true, will include scripts passed in the html string
   jQuery.parseHTML = function( data, context, keepScripts ) {
       if ( typeof data !== "string" ) {
           return [];
       }
       if ( typeof context === "boolean" ) {
           keepScripts = context;
           context = false;
       }
   
       var base, parsed, scripts;
   
       if ( !context ) {
   
           // Stop scripts or inline event handlers from being executed immediately
           // by using document.implementation
           if ( support.createHTMLDocument ) {
               context = document.implementation.createHTMLDocument( "" );
   
               // Set the base href for the created document
               // so any parsed elements with URLs
               // are based on the document's URL (gh-2965)
               base = context.createElement( "base" );
               base.href = document.location.href;
               context.head.appendChild( base );
           } else {
               context = document;
           }
       }
   
       parsed = rsingleTag.exec( data );
       scripts = !keepScripts && [];
   
       // Single tag
       if ( parsed ) {
           return [ context.createElement( parsed[ 1 ] ) ];
       }
   
       parsed = buildFragment( [ data ], context, scripts );
   
       if ( scripts && scripts.length ) {
           jQuery( scripts ).remove();
       }
   
       return jQuery.merge( [], parsed.childNodes );
   };
   
   
   /**
    * Load a url into a page
    */
   jQuery.fn.load = function( url, params, callback ) {
       var selector, type, response,
           self = this,
           off = url.indexOf( " " );
   
       if ( off > -1 ) {
           selector = stripAndCollapse( url.slice( off ) );
           url = url.slice( 0, off );
       }
   
       // If it's a function
       if ( isFunction( params ) ) {
   
           // We assume that it's the callback
           callback = params;
           params = undefined;
   
       // Otherwise, build a param string
       } else if ( params && typeof params === "object" ) {
           type = "POST";
       }
   
       // If we have elements to modify, make the request
       if ( self.length > 0 ) {
           jQuery.ajax( {
               url: url,
   
               // If "type" variable is undefined, then "GET" method will be used.
               // Make value of this field explicit since
               // user can override it through ajaxSetup method
               type: type || "GET",
               dataType: "html",
               data: params
           } ).done( function( responseText ) {
   
               // Save response for use in complete callback
               response = arguments;
   
               self.html( selector ?
   
                   // If a selector was specified, locate the right elements in a dummy div
                   // Exclude scripts to avoid IE 'Permission Denied' errors
                   jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
   
                   // Otherwise use the full result
                   responseText );
   
           // If the request succeeds, this function gets "data", "status", "jqXHR"
           // but they are ignored because response was set above.
           // If it fails, this function gets "jqXHR", "status", "error"
           } ).always( callback && function( jqXHR, status ) {
               self.each( function() {
                   callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
               } );
           } );
       }
   
       return this;
   };
   
   
   
   
   jQuery.expr.pseudos.animated = function( elem ) {
       return jQuery.grep( jQuery.timers, function( fn ) {
           return elem === fn.elem;
       } ).length;
   };
   
   
   
   
   jQuery.offset = {
       setOffset: function( elem, options, i ) {
           var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
               position = jQuery.css( elem, "position" ),
               curElem = jQuery( elem ),
               props = {};
   
           // Set position first, in-case top/left are set even on static elem
           if ( position === "static" ) {
               elem.style.position = "relative";
           }
   
           curOffset = curElem.offset();
           curCSSTop = jQuery.css( elem, "top" );
           curCSSLeft = jQuery.css( elem, "left" );
           calculatePosition = ( position === "absolute" || position === "fixed" ) &&
               ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
   
           // Need to be able to calculate position if either
           // top or left is auto and position is either absolute or fixed
           if ( calculatePosition ) {
               curPosition = curElem.position();
               curTop = curPosition.top;
               curLeft = curPosition.left;
   
           } else {
               curTop = parseFloat( curCSSTop ) || 0;
               curLeft = parseFloat( curCSSLeft ) || 0;
           }
   
           if ( isFunction( options ) ) {
   
               // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
               options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
           }
   
           if ( options.top != null ) {
               props.top = ( options.top - curOffset.top ) + curTop;
           }
           if ( options.left != null ) {
               props.left = ( options.left - curOffset.left ) + curLeft;
           }
   
           if ( "using" in options ) {
               options.using.call( elem, props );
   
           } else {
               curElem.css( props );
           }
       }
   };
   
   jQuery.fn.extend( {
   
       // offset() relates an element's border box to the document origin
       offset: function( options ) {
   
           // Preserve chaining for setter
           if ( arguments.length ) {
               return options === undefined ?
                   this :
                   this.each( function( i ) {
                       jQuery.offset.setOffset( this, options, i );
                   } );
           }
   
           var rect, win,
               elem = this[ 0 ];
   
           if ( !elem ) {
               return;
           }
   
           // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
           // Support: IE <=11 only
           // Running getBoundingClientRect on a
           // disconnected node in IE throws an error
           if ( !elem.getClientRects().length ) {
               return { top: 0, left: 0 };
           }
   
           // Get document-relative position by adding viewport scroll to viewport-relative gBCR
           rect = elem.getBoundingClientRect();
           win = elem.ownerDocument.defaultView;
           return {
               top: rect.top + win.pageYOffset,
               left: rect.left + win.pageXOffset
           };
       },
   
       // position() relates an element's margin box to its offset parent's padding box
       // This corresponds to the behavior of CSS absolute positioning
       position: function() {
           if ( !this[ 0 ] ) {
               return;
           }
   
           var offsetParent, offset, doc,
               elem = this[ 0 ],
               parentOffset = { top: 0, left: 0 };
   
           // position:fixed elements are offset from the viewport, which itself always has zero offset
           if ( jQuery.css( elem, "position" ) === "fixed" ) {
   
               // Assume position:fixed implies availability of getBoundingClientRect
               offset = elem.getBoundingClientRect();
   
           } else {
               offset = this.offset();
   
               // Account for the *real* offset parent, which can be the document or its root element
               // when a statically positioned element is identified
               doc = elem.ownerDocument;
               offsetParent = elem.offsetParent || doc.documentElement;
               while ( offsetParent &&
                   ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
                   jQuery.css( offsetParent, "position" ) === "static" ) {
   
                   offsetParent = offsetParent.parentNode;
               }
               if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
   
                   // Incorporate borders into its offset, since they are outside its content origin
                   parentOffset = jQuery( offsetParent ).offset();
                   parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
                   parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
               }
           }
   
           // Subtract parent offsets and element margins
           return {
               top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
               left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
           };
       },
   
       // This method will return documentElement in the following cases:
       // 1) For the element inside the iframe without offsetParent, this method will return
       //    documentElement of the parent window
       // 2) For the hidden or detached element
       // 3) For body or html element, i.e. in case of the html node - it will return itself
       //
       // but those exceptions were never presented as a real life use-cases
       // and might be considered as more preferable results.
       //
       // This logic, however, is not guaranteed and can change at any point in the future
       offsetParent: function() {
           return this.map( function() {
               var offsetParent = this.offsetParent;
   
               while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                   offsetParent = offsetParent.offsetParent;
               }
   
               return offsetParent || documentElement;
           } );
       }
   } );
   
   // Create scrollLeft and scrollTop methods
   jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
       var top = "pageYOffset" === prop;
   
       jQuery.fn[ method ] = function( val ) {
           return access( this, function( elem, method, val ) {
   
               // Coalesce documents and windows
               var win;
               if ( isWindow( elem ) ) {
                   win = elem;
               } else if ( elem.nodeType === 9 ) {
                   win = elem.defaultView;
               }
   
               if ( val === undefined ) {
                   return win ? win[ prop ] : elem[ method ];
               }
   
               if ( win ) {
                   win.scrollTo(
                       !top ? val : win.pageXOffset,
                       top ? val : win.pageYOffset
                   );
   
               } else {
                   elem[ method ] = val;
               }
           }, method, val, arguments.length );
       };
   } );
   
   // Support: Safari <=7 - 9.1, Chrome <=37 - 49
   // Add the top/left cssHooks using jQuery.fn.position
   // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
   // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
   // getComputedStyle returns percent when specified for top/left/bottom/right;
   // rather than make the css module depend on the offset module, just check for it here
   jQuery.each( [ "top", "left" ], function( _i, prop ) {
       jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
           function( elem, computed ) {
               if ( computed ) {
                   computed = curCSS( elem, prop );
   
                   // If curCSS returns percentage, fallback to offset
                   return rnumnonpx.test( computed ) ?
                       jQuery( elem ).position()[ prop ] + "px" :
                       computed;
               }
           }
       );
   } );
   
   
   // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
   jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
       jQuery.each( {
           padding: "inner" + name,
           content: type,
           "": "outer" + name
       }, function( defaultExtra, funcName ) {
   
           // Margin is only for outerHeight, outerWidth
           jQuery.fn[ funcName ] = function( margin, value ) {
               var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                   extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
   
               return access( this, function( elem, type, value ) {
                   var doc;
   
                   if ( isWindow( elem ) ) {
   
                       // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                       return funcName.indexOf( "outer" ) === 0 ?
                           elem[ "inner" + name ] :
                           elem.document.documentElement[ "client" + name ];
                   }
   
                   // Get document width or height
                   if ( elem.nodeType === 9 ) {
                       doc = elem.documentElement;
   
                       // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                       // whichever is greatest
                       return Math.max(
                           elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                           elem.body[ "offset" + name ], doc[ "offset" + name ],
                           doc[ "client" + name ]
                       );
                   }
   
                   return value === undefined ?
   
                       // Get width or height on the element, requesting but not forcing parseFloat
                       jQuery.css( elem, type, extra ) :
   
                       // Set width or height on the element
                       jQuery.style( elem, type, value, extra );
               }, type, chainable ? margin : undefined, chainable );
           };
       } );
   } );
   
   
   jQuery.each( [
       "ajaxStart",
       "ajaxStop",
       "ajaxComplete",
       "ajaxError",
       "ajaxSuccess",
       "ajaxSend"
   ], function( _i, type ) {
       jQuery.fn[ type ] = function( fn ) {
           return this.on( type, fn );
       };
   } );
   
   
   
   
   jQuery.fn.extend( {
   
       bind: function( types, data, fn ) {
           return this.on( types, null, data, fn );
       },
       unbind: function( types, fn ) {
           return this.off( types, null, fn );
       },
   
       delegate: function( selector, types, data, fn ) {
           return this.on( types, selector, data, fn );
       },
       undelegate: function( selector, types, fn ) {
   
           // ( namespace ) or ( selector, types [, fn] )
           return arguments.length === 1 ?
               this.off( selector, "**" ) :
               this.off( types, selector || "**", fn );
       },
   
       hover: function( fnOver, fnOut ) {
           return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
       }
   } );
   
   jQuery.each(
       ( "blur focus focusin focusout resize scroll click dblclick " +
       "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
       "change select submit keydown keypress keyup contextmenu" ).split( " " ),
       function( _i, name ) {
   
           // Handle event binding
           jQuery.fn[ name ] = function( data, fn ) {
               return arguments.length > 0 ?
                   this.on( name, null, data, fn ) :
                   this.trigger( name );
           };
       }
   );
   
   
   
   
   // Support: Android <=4.0 only
   // Make sure we trim BOM and NBSP
   // Require that the "whitespace run" starts from a non-whitespace
   // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
   var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
   
   // Bind a function to a context, optionally partially applying any
   // arguments.
   // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
   // However, it is not slated for removal any time soon
   jQuery.proxy = function( fn, context ) {
       var tmp, args, proxy;
   
       if ( typeof context === "string" ) {
           tmp = fn[ context ];
           context = fn;
           fn = tmp;
       }
   
       // Quick check to determine if target is callable, in the spec
       // this throws a TypeError, but we will just return undefined.
       if ( !isFunction( fn ) ) {
           return undefined;
       }
   
       // Simulated bind
       args = slice.call( arguments, 2 );
       proxy = function() {
           return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
       };
   
       // Set the guid of unique handler to the same of original handler, so it can be removed
       proxy.guid = fn.guid = fn.guid || jQuery.guid++;
   
       return proxy;
   };
   
   jQuery.holdReady = function( hold ) {
       if ( hold ) {
           jQuery.readyWait++;
       } else {
           jQuery.ready( true );
       }
   };
   jQuery.isArray = Array.isArray;
   jQuery.parseJSON = JSON.parse;
   jQuery.nodeName = nodeName;
   jQuery.isFunction = isFunction;
   jQuery.isWindow = isWindow;
   jQuery.camelCase = camelCase;
   jQuery.type = toType;
   
   jQuery.now = Date.now;
   
   jQuery.isNumeric = function( obj ) {
   
       // As of jQuery 3.0, isNumeric is limited to
       // strings and numbers (primitives or objects)
       // that can be coerced to finite numbers (gh-2662)
       var type = jQuery.type( obj );
       return ( type === "number" || type === "string" ) &&
   
           // parseFloat NaNs numeric-cast false positives ("")
           // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
           // subtraction forces infinities to NaN
           !isNaN( obj - parseFloat( obj ) );
   };
   
   jQuery.trim = function( text ) {
       return text == null ?
           "" :
           ( text + "" ).replace( rtrim, "$1" );
   };
   
   
   
   // Register as a named AMD module, since jQuery can be concatenated with other
   // files that may use define, but not via a proper concatenation script that
   // understands anonymous AMD modules. A named AMD is safest and most robust
   // way to register. Lowercase jquery is used because AMD module names are
   // derived from file names, and jQuery is normally delivered in a lowercase
   // file name. Do this after creating the global so that if an AMD module wants
   // to call noConflict to hide this version of jQuery, it will work.
   
   // Note that for maximum portability, libraries that are not jQuery should
   // declare themselves as anonymous modules, and avoid setting a global if an
   // AMD loader is present. jQuery is a special case. For more information, see
   // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
   
   if ( true ) {
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
           return jQuery;
       }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
   }
   
   
   
   
   var
   
       // Map over jQuery in case of overwrite
       _jQuery = window.jQuery,
   
       // Map over the $ in case of overwrite
       _$ = window.$;
   
   jQuery.noConflict = function( deep ) {
       if ( window.$ === jQuery ) {
           window.$ = _$;
       }
   
       if ( deep && window.jQuery === jQuery ) {
           window.jQuery = _jQuery;
       }
   
       return jQuery;
   };
   
   // Expose jQuery and $ identifiers, even in AMD
   // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
   // and CommonJS for browser emulators (trac-13566)
   if ( typeof noGlobal === "undefined" ) {
       window.jQuery = window.$ = jQuery;
   }
   
   
   
   
   return jQuery;
   } );
   
   
   /***/ }),
   
   /***/ 926:
   /***/ ((module, exports, __webpack_require__) => {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
   // ------------------------------------------
   // Rellax.js
   // Buttery smooth parallax library
   // Copyright (c) 2016 Moe Amaya (@moeamaya)
   // MIT license
   //
   // Thanks to Paraxify.js and Jaime Cabllero
   // for parallax concepts
   // ------------------------------------------
   
   (function (root, factory) {
     if (true) {
       // AMD. Register as an anonymous module.
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
           __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
           (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else {}
   }(typeof window !== "undefined" ? window : __webpack_require__.g, function () {
     var Rellax = function(el, options){
       "use strict";
   
       var self = Object.create(Rellax.prototype);
   
       var posY = 0;
       var screenY = 0;
       var posX = 0;
       var screenX = 0;
       var blocks = [];
       var pause = true;
   
       // check what requestAnimationFrame to use, and if
       // it's not supported, use the onscroll event
       var loop = window.requestAnimationFrame ||
         window.webkitRequestAnimationFrame ||
         window.mozRequestAnimationFrame ||
         window.msRequestAnimationFrame ||
         window.oRequestAnimationFrame ||
         function(callback){ return setTimeout(callback, 1000 / 60); };
   
       // store the id for later use
       var loopId = null;
   
       // Test via a getter in the options object to see if the passive property is accessed
       var supportsPassive = false;
       try {
         var opts = Object.defineProperty({}, 'passive', {
           get: function() {
             supportsPassive = true;
           }
         });
         window.addEventListener("testPassive", null, opts);
         window.removeEventListener("testPassive", null, opts);
       } catch (e) {}
   
       // check what cancelAnimation method to use
       var clearLoop = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout;
   
       // check which transform property to use
       var transformProp = window.transformProp || (function(){
           var testEl = document.createElement('div');
           if (testEl.style.transform === null) {
             var vendors = ['Webkit', 'Moz', 'ms'];
             for (var vendor in vendors) {
               if (testEl.style[ vendors[vendor] + 'Transform' ] !== undefined) {
                 return vendors[vendor] + 'Transform';
               }
             }
           }
           return 'transform';
         })();
   
       // Default Settings
       self.options = {
         speed: -2,
           verticalSpeed: null,
           horizontalSpeed: null,
         breakpoints: [576, 768, 1201],
         center: false,
         wrapper: null,
         relativeToWrapper: false,
         round: true,
         vertical: true,
         horizontal: false,
         verticalScrollAxis: "y",
         horizontalScrollAxis: "x",
         callback: function() {},
       };
   
       // User defined options (might have more in the future)
       if (options){
         Object.keys(options).forEach(function(key){
           self.options[key] = options[key];
         });
       }
   
       function validateCustomBreakpoints () {
         if (self.options.breakpoints.length === 3 && Array.isArray(self.options.breakpoints)) {
           var isAscending = true;
           var isNumerical = true;
           var lastVal;
           self.options.breakpoints.forEach(function (i) {
             if (typeof i !== 'number') isNumerical = false;
             if (lastVal !== null) {
               if (i < lastVal) isAscending = false;
             }
             lastVal = i;
           });
           if (isAscending && isNumerical) return;
         }
         // revert defaults if set incorrectly
         self.options.breakpoints = [576, 768, 1201];
         console.warn("Rellax: You must pass an array of 3 numbers in ascending order to the breakpoints option. Defaults reverted");
       }
   
       if (options && options.breakpoints) {
         validateCustomBreakpoints();
       }
   
       // By default, rellax class
       if (!el) {
         el = '.rellax';
       }
   
       // check if el is a className or a node
       var elements = typeof el === 'string' ? document.querySelectorAll(el) : [el];
   
       // Now query selector
       if (elements.length > 0) {
         self.elems = elements;
       }
   
       // The elements don't exist
       else {
         console.warn("Rellax: The elements you're trying to select don't exist.");
         return;
       }
   
       // Has a wrapper and it exists
       if (self.options.wrapper) {
         if (!self.options.wrapper.nodeType) {
           var wrapper = document.querySelector(self.options.wrapper);
   
           if (wrapper) {
             self.options.wrapper = wrapper;
           } else {
             console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
             return;
           }
         }
       }
   
       // set a placeholder for the current breakpoint
       var currentBreakpoint;
   
       // helper to determine current breakpoint
       var getCurrentBreakpoint = function (w) {
         var bp = self.options.breakpoints;
         if (w < bp[0]) return 'xs';
         if (w >= bp[0] && w < bp[1]) return 'sm';
         if (w >= bp[1] && w < bp[2]) return 'md';
         return 'lg';
       };
   
       // Get and cache initial position of all elements
       var cacheBlocks = function() {
         for (var i = 0; i < self.elems.length; i++){
           var block = createBlock(self.elems[i]);
           blocks.push(block);
         }
       };
   
   
       // Let's kick this script off
       // Build array for cached element values
       var init = function() {
         for (var i = 0; i < blocks.length; i++){
           self.elems[i].style.cssText = blocks[i].style;
         }
   
         blocks = [];
   
         screenY = window.innerHeight;
         screenX = window.innerWidth;
         currentBreakpoint = getCurrentBreakpoint(screenX);
   
         setPosition();
   
         cacheBlocks();
   
         animate();
   
         // If paused, unpause and set listener for window resizing events
         if (pause) {
           window.addEventListener('resize', init);
           pause = false;
           // Start the loop
           update();
         }
       };
   
       // We want to cache the parallax blocks'
       // values: base, top, height, speed
       // el: is dom object, return: el cache values
       var createBlock = function(el) {
         var dataPercentage = el.getAttribute( 'data-rellax-percentage' );
         var dataSpeed = el.getAttribute( 'data-rellax-speed' );
         var dataXsSpeed = el.getAttribute( 'data-rellax-xs-speed' );
         var dataMobileSpeed = el.getAttribute( 'data-rellax-mobile-speed' );
         var dataTabletSpeed = el.getAttribute( 'data-rellax-tablet-speed' );
         var dataDesktopSpeed = el.getAttribute( 'data-rellax-desktop-speed' );
         var dataVerticalSpeed = el.getAttribute('data-rellax-vertical-speed');
         var dataHorizontalSpeed = el.getAttribute('data-rellax-horizontal-speed');
         var dataVericalScrollAxis = el.getAttribute('data-rellax-vertical-scroll-axis');
         var dataHorizontalScrollAxis = el.getAttribute('data-rellax-horizontal-scroll-axis');
         var dataZindex = el.getAttribute( 'data-rellax-zindex' ) || 0;
         var dataMin = el.getAttribute( 'data-rellax-min' );
         var dataMax = el.getAttribute( 'data-rellax-max' );
         var dataMinX = el.getAttribute('data-rellax-min-x');
         var dataMaxX = el.getAttribute('data-rellax-max-x');
         var dataMinY = el.getAttribute('data-rellax-min-y');
         var dataMaxY = el.getAttribute('data-rellax-max-y');
         var mapBreakpoints;
         var breakpoints = true;
   
         if (!dataXsSpeed && !dataMobileSpeed && !dataTabletSpeed && !dataDesktopSpeed) {
           breakpoints = false;
         } else {
           mapBreakpoints = {
             'xs': dataXsSpeed,
             'sm': dataMobileSpeed,
             'md': dataTabletSpeed,
             'lg': dataDesktopSpeed
           };
         }
   
         // initializing at scrollY = 0 (top of browser), scrollX = 0 (left of browser)
         // ensures elements are positioned based on HTML layout.
         //
         // If the element has the percentage attribute, the posY and posX needs to be
         // the current scroll position's value, so that the elements are still positioned based on HTML layout
         var wrapperPosY = self.options.wrapper ? self.options.wrapper.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
         // If the option relativeToWrapper is true, use the wrappers offset to top, subtracted from the current page scroll.
         if (self.options.relativeToWrapper) {
           var scrollPosY = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
           wrapperPosY = scrollPosY - self.options.wrapper.offsetTop;
         }
         var posY = self.options.vertical ? ( dataPercentage || self.options.center ? wrapperPosY : 0 ) : 0;
         var posX = self.options.horizontal ? ( dataPercentage || self.options.center ? self.options.wrapper ? self.options.wrapper.scrollLeft : (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft) : 0 ) : 0;
   
         var blockTop = posY + el.getBoundingClientRect().top;
         var blockHeight = el.clientHeight || el.offsetHeight || el.scrollHeight;
   
         var blockLeft = posX + el.getBoundingClientRect().left;
         var blockWidth = el.clientWidth || el.offsetWidth || el.scrollWidth;
   
         // apparently parallax equation everyone uses
         var percentageY = dataPercentage ? dataPercentage : (posY - blockTop + screenY) / (blockHeight + screenY);
         var percentageX = dataPercentage ? dataPercentage : (posX - blockLeft + screenX) / (blockWidth + screenX);
         if(self.options.center){ percentageX = 0.5; percentageY = 0.5; }
   
         // Optional individual block speed as data attr, otherwise global speed
         var speed = (breakpoints && mapBreakpoints[currentBreakpoint] !== null) ? Number(mapBreakpoints[currentBreakpoint]) : (dataSpeed ? dataSpeed : self.options.speed);
         var verticalSpeed = dataVerticalSpeed ? dataVerticalSpeed : self.options.verticalSpeed;
         var horizontalSpeed = dataHorizontalSpeed ? dataHorizontalSpeed : self.options.horizontalSpeed;
   
         // Optional individual block movement axis direction as data attr, otherwise gobal movement direction
         var verticalScrollAxis = dataVericalScrollAxis ? dataVericalScrollAxis : self.options.verticalScrollAxis;
         var horizontalScrollAxis = dataHorizontalScrollAxis ? dataHorizontalScrollAxis : self.options.horizontalScrollAxis;
   
         var bases = updatePosition(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed);
   
         // ~~Store non-translate3d transforms~~
         // Store inline styles and extract transforms
         var style = el.style.cssText;
         var transform = '';
   
         // Check if there's an inline styled transform
         var searchResult = /transform\s*:/i.exec(style);
         if (searchResult) {
           // Get the index of the transform
           var index = searchResult.index;
   
           // Trim the style to the transform point and get the following semi-colon index
           var trimmedStyle = style.slice(index);
           var delimiter = trimmedStyle.indexOf(';');
   
           // Remove "transform" string and save the attribute
           if (delimiter) {
             transform = " " + trimmedStyle.slice(11, delimiter).replace(/\s/g,'');
           } else {
             transform = " " + trimmedStyle.slice(11).replace(/\s/g,'');
           }
         }
   
         return {
           baseX: bases.x,
           baseY: bases.y,
           top: blockTop,
           left: blockLeft,
           height: blockHeight,
           width: blockWidth,
           speed: speed,
           verticalSpeed: verticalSpeed,
           horizontalSpeed: horizontalSpeed,
           verticalScrollAxis: verticalScrollAxis,
           horizontalScrollAxis: horizontalScrollAxis,
           style: style,
           transform: transform,
           zindex: dataZindex,
           min: dataMin,
           max: dataMax,
           minX: dataMinX,
           maxX: dataMaxX,
           minY: dataMinY,
           maxY: dataMaxY
         };
       };
   
       // set scroll position (posY, posX)
       // side effect method is not ideal, but okay for now
       // returns true if the scroll changed, false if nothing happened
       var setPosition = function() {
         var oldY = posY;
         var oldX = posX;
   
         posY = self.options.wrapper ? self.options.wrapper.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
         posX = self.options.wrapper ? self.options.wrapper.scrollLeft : (document.documentElement || document.body.parentNode || document.body).scrollLeft || window.pageXOffset;
         // If option relativeToWrapper is true, use relative wrapper value instead.
         if (self.options.relativeToWrapper) {
           var scrollPosY = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
           posY = scrollPosY - self.options.wrapper.offsetTop;
         }
   
   
         if (oldY != posY && self.options.vertical) {
           // scroll changed, return true
           return true;
         }
   
         if (oldX != posX && self.options.horizontal) {
           // scroll changed, return true
           return true;
         }
   
         // scroll did not change
         return false;
       };
   
       // Ahh a pure function, gets new transform value
       // based on scrollPosition and speed
       // Allow for decimal pixel values
       var updatePosition = function(percentageX, percentageY, speed, verticalSpeed, horizontalSpeed) {
         var result = {};
         var valueX = ((horizontalSpeed ? horizontalSpeed : speed) * (100 * (1 - percentageX)));
         var valueY = ((verticalSpeed ? verticalSpeed : speed) * (100 * (1 - percentageY)));
   
         result.x = self.options.round ? Math.round(valueX) : Math.round(valueX * 100) / 100;
         result.y = self.options.round ? Math.round(valueY) : Math.round(valueY * 100) / 100;
   
         return result;
       };
   
       // Remove event listeners and loop again
       var deferredUpdate = function() {
         window.removeEventListener('resize', deferredUpdate);
         window.removeEventListener('orientationchange', deferredUpdate);
         (self.options.wrapper ? self.options.wrapper : window).removeEventListener('scroll', deferredUpdate);
         (self.options.wrapper ? self.options.wrapper : document).removeEventListener('touchmove', deferredUpdate);
   
         // loop again
         loopId = loop(update);
       };
   
       // Loop
       var update = function() {
         if (setPosition() && pause === false) {
           animate();
   
           // loop again
           loopId = loop(update);
         } else {
           loopId = null;
   
           // Don't animate until we get a position updating event
           window.addEventListener('resize', deferredUpdate);
           window.addEventListener('orientationchange', deferredUpdate);
           (self.options.wrapper ? self.options.wrapper : window).addEventListener('scroll', deferredUpdate, supportsPassive ? { passive: true } : false);
           (self.options.wrapper ? self.options.wrapper : document).addEventListener('touchmove', deferredUpdate, supportsPassive ? { passive: true } : false);
         }
       };
   
       // Transform3d on parallax element
       var animate = function() {
         var positions;
         for (var i = 0; i < self.elems.length; i++){
           // Determine relevant movement directions
           var verticalScrollAxis = blocks[i].verticalScrollAxis.toLowerCase();
           var horizontalScrollAxis = blocks[i].horizontalScrollAxis.toLowerCase();
           var verticalScrollX = verticalScrollAxis.indexOf("x") != -1 ? posY : 0;
           var verticalScrollY = verticalScrollAxis.indexOf("y") != -1 ? posY : 0;
           var horizontalScrollX = horizontalScrollAxis.indexOf("x") != -1 ? posX : 0;
           var horizontalScrollY = horizontalScrollAxis.indexOf("y") != -1 ? posX : 0;
   
           var percentageY = ((verticalScrollY + horizontalScrollY - blocks[i].top + screenY) / (blocks[i].height + screenY));
           var percentageX = ((verticalScrollX + horizontalScrollX - blocks[i].left + screenX) / (blocks[i].width + screenX));
   
           // Subtracting initialize value, so element stays in same spot as HTML
           positions = updatePosition(percentageX, percentageY, blocks[i].speed, blocks[i].verticalSpeed, blocks[i].horizontalSpeed);
           var positionY = positions.y - blocks[i].baseY;
           var positionX = positions.x - blocks[i].baseX;
   
           // The next two "if" blocks go like this:
           // Check if a limit is defined (first "min", then "max");
           // Check if we need to change the Y or the X
           // (Currently working only if just one of the axes is enabled)
           // Then, check if the new position is inside the allowed limit
           // If so, use new position. If not, set position to limit.
   
           // Check if a min limit is defined
           if (blocks[i].min !== null) {
             if (self.options.vertical && !self.options.horizontal) {
               positionY = positionY <= blocks[i].min ? blocks[i].min : positionY;
             }
             if (self.options.horizontal && !self.options.vertical) {
               positionX = positionX <= blocks[i].min ? blocks[i].min : positionX;
             }
           }
   
           // Check if directional min limits are defined
           if (blocks[i].minY != null) {
               positionY = positionY <= blocks[i].minY ? blocks[i].minY : positionY;
           }
           if (blocks[i].minX != null) {
               positionX = positionX <= blocks[i].minX ? blocks[i].minX : positionX;
           }
   
           // Check if a max limit is defined
           if (blocks[i].max !== null) {
             if (self.options.vertical && !self.options.horizontal) {
               positionY = positionY >= blocks[i].max ? blocks[i].max : positionY;
             }
             if (self.options.horizontal && !self.options.vertical) {
               positionX = positionX >= blocks[i].max ? blocks[i].max : positionX;
             }
           }
   
           // Check if directional max limits are defined
           if (blocks[i].maxY != null) {
               positionY = positionY >= blocks[i].maxY ? blocks[i].maxY : positionY;
           }
           if (blocks[i].maxX != null) {
               positionX = positionX >= blocks[i].maxX ? blocks[i].maxX : positionX;
           }
   
           var zindex = blocks[i].zindex;
   
           // Move that element
           // (Set the new translation and append initial inline transforms.)
           var translate = 'translate3d(' + (self.options.horizontal ? positionX : '0') + 'px,' + (self.options.vertical ? positionY : '0') + 'px,' + zindex + 'px) ' + blocks[i].transform;
           self.elems[i].style[transformProp] = translate;
         }
         self.options.callback(positions);
       };
   
       self.destroy = function() {
         for (var i = 0; i < self.elems.length; i++){
           self.elems[i].style.cssText = blocks[i].style;
         }
   
         // Remove resize event listener if not pause, and pause
         if (!pause) {
           window.removeEventListener('resize', init);
           pause = true;
         }
   
         // Clear the animation loop to prevent possible memory leak
         clearLoop(loopId);
         loopId = null;
       };
   
       // Init
       init();
   
       // Allow to recalculate the initial values whenever we want
       self.refresh = init;
   
       return self;
     };
     return Rellax;
   }));
   
   
   /***/ }),
   
   /***/ 725:
   /***/ (function(__unused_webpack_module, exports, __webpack_require__) {
   
   (function (global, factory) {
      true ? factory(exports) :
     0;
   }(this, function (exports) { 'use strict';
   
     var splitRE = /\r?\n/g;
     var emptyRE = /^\s*$/;
     var needFixRE = /^(\r?\n)*[\t\s]/;
   
     var deIndent = function deindent (str) {
       if (!needFixRE.test(str)) {
         return str
       }
       var lines = str.split(splitRE);
       var min = Infinity;
       var type, cur, c;
       for (var i = 0; i < lines.length; i++) {
         var line = lines[i];
         if (!emptyRE.test(line)) {
           if (!type) {
             c = line.charAt(0);
             if (c === ' ' || c === '\t') {
               type = c;
               cur = count(line, type);
               if (cur < min) {
                 min = cur;
               }
             } else {
               return str
             }
           } else {
             cur = count(line, type);
             if (cur < min) {
               min = cur;
             }
           }
         }
       }
       return lines.map(function (line) {
         return line.slice(min)
       }).join('\n')
     };
   
     function count (line, type) {
       var i = 0;
       while (line.charAt(i) === type) {
         i++;
       }
       return i
     }
   
     /*  */
   
     var emptyObject = Object.freeze({});
   
     // These helpers produce better VM code in JS engines due to their
     // explicitness and function inlining.
     function isUndef (v) {
       return v === undefined || v === null
     }
   
     /**
      * Check if value is primitive.
      */
     function isPrimitive (value) {
       return (
         typeof value === 'string' ||
         typeof value === 'number' ||
         // $flow-disable-line
         typeof value === 'symbol' ||
         typeof value === 'boolean'
       )
     }
   
     /**
      * Quick object check - this is primarily used to tell
      * Objects from primitive values when we know the value
      * is a JSON-compliant type.
      */
     function isObject (obj) {
       return obj !== null && typeof obj === 'object'
     }
   
     /**
      * Get the raw type string of a value, e.g., [object Object].
      */
     var _toString = Object.prototype.toString;
   
     function toRawType (value) {
       return _toString.call(value).slice(8, -1)
     }
   
     /**
      * Strict object type check. Only returns true
      * for plain JavaScript objects.
      */
     function isPlainObject (obj) {
       return _toString.call(obj) === '[object Object]'
     }
   
     /**
      * Check if val is a valid array index.
      */
     function isValidArrayIndex (val) {
       var n = parseFloat(String(val));
       return n >= 0 && Math.floor(n) === n && isFinite(val)
     }
   
     /**
      * Make a map and return a function for checking if a key
      * is in that map.
      */
     function makeMap (
       str,
       expectsLowerCase
     ) {
       var map = Object.create(null);
       var list = str.split(',');
       for (var i = 0; i < list.length; i++) {
         map[list[i]] = true;
       }
       return expectsLowerCase
         ? function (val) { return map[val.toLowerCase()]; }
         : function (val) { return map[val]; }
     }
   
     /**
      * Check if a tag is a built-in tag.
      */
     var isBuiltInTag = makeMap('slot,component', true);
   
     /**
      * Check if an attribute is a reserved attribute.
      */
     var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
   
     /**
      * Remove an item from an array.
      */
     function remove (arr, item) {
       if (arr.length) {
         var index = arr.indexOf(item);
         if (index > -1) {
           return arr.splice(index, 1)
         }
       }
     }
   
     /**
      * Check whether an object has the property.
      */
     var hasOwnProperty = Object.prototype.hasOwnProperty;
     function hasOwn (obj, key) {
       return hasOwnProperty.call(obj, key)
     }
   
     /**
      * Create a cached version of a pure function.
      */
     function cached (fn) {
       var cache = Object.create(null);
       return (function cachedFn (str) {
         var hit = cache[str];
         return hit || (cache[str] = fn(str))
       })
     }
   
     /**
      * Camelize a hyphen-delimited string.
      */
     var camelizeRE = /-(\w)/g;
     var camelize = cached(function (str) {
       return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
     });
   
     /**
      * Hyphenate a camelCase string.
      */
     var hyphenateRE = /\B([A-Z])/g;
     var hyphenate = cached(function (str) {
       return str.replace(hyphenateRE, '-$1').toLowerCase()
     });
   
     /**
      * Simple bind polyfill for environments that do not support it,
      * e.g., PhantomJS 1.x. Technically, we don't need this anymore
      * since native bind is now performant enough in most browsers.
      * But removing it would mean breaking code that was able to run in
      * PhantomJS 1.x, so this must be kept for backward compatibility.
      */
   
     /* istanbul ignore next */
     function polyfillBind (fn, ctx) {
       function boundFn (a) {
         var l = arguments.length;
         return l
           ? l > 1
             ? fn.apply(ctx, arguments)
             : fn.call(ctx, a)
           : fn.call(ctx)
       }
   
       boundFn._length = fn.length;
       return boundFn
     }
   
     function nativeBind (fn, ctx) {
       return fn.bind(ctx)
     }
   
     var bind = Function.prototype.bind
       ? nativeBind
       : polyfillBind;
   
     /**
      * Mix properties into target object.
      */
     function extend (to, _from) {
       for (var key in _from) {
         to[key] = _from[key];
       }
       return to
     }
   
     /* eslint-disable no-unused-vars */
   
     /**
      * Perform no operation.
      * Stubbing args to make Flow happy without leaving useless transpiled code
      * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
      */
     function noop (a, b, c) {}
   
     /**
      * Always return false.
      */
     var no = function (a, b, c) { return false; };
   
     /* eslint-enable no-unused-vars */
   
     /**
      * Return the same value.
      */
     var identity = function (_) { return _; };
   
     /**
      * Generate a string containing static keys from compiler modules.
      */
     function genStaticKeys (modules) {
       return modules.reduce(function (keys, m) {
         return keys.concat(m.staticKeys || [])
       }, []).join(',')
     }
   
     /*  */
   
     var isUnaryTag = makeMap(
       'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
       'link,meta,param,source,track,wbr'
     );
   
     // Elements that you can, intentionally, leave open
     // (and which close themselves)
     var canBeLeftOpenTag = makeMap(
       'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
     );
   
     // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
     // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
     var isNonPhrasingTag = makeMap(
       'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
       'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
       'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
       'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
       'title,tr,track'
     );
   
     /*  */
   
     /**
      * unicode letters used for parsing html tags, component names and property paths.
      * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
      * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
      */
     var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
   
     /**
      * Define a property.
      */
     function def (obj, key, val, enumerable) {
       Object.defineProperty(obj, key, {
         value: val,
         enumerable: !!enumerable,
         writable: true,
         configurable: true
       });
     }
   
     /**
      * Not type-checking this file because it's mostly vendor code.
      */
   
     // Regular Expressions for parsing tags and attributes
     var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
     var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
     var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
     var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
     var startTagOpen = new RegExp(("^<" + qnameCapture));
     var startTagClose = /^\s*(\/?)>/;
     var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
     var doctype = /^<!DOCTYPE [^>]+>/i;
     // #7298: escape - to avoid being passed as HTML comment when inlined in page
     var comment = /^<!\--/;
     var conditionalComment = /^<!\[/;
   
     // Special Elements (can contain anything)
     var isPlainTextElement = makeMap('script,style,textarea', true);
     var reCache = {};
   
     var decodingMap = {
       '&lt;': '<',
       '&gt;': '>',
       '&quot;': '"',
       '&amp;': '&',
       '&#10;': '\n',
       '&#9;': '\t',
       '&#39;': "'"
     };
     var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
     var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
   
     // #5992
     var isIgnoreNewlineTag = makeMap('pre,textarea', true);
     var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };
   
     function decodeAttr (value, shouldDecodeNewlines) {
       var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
       return value.replace(re, function (match) { return decodingMap[match]; })
     }
   
     function parseHTML (html, options) {
       var stack = [];
       var expectHTML = options.expectHTML;
       var isUnaryTag$$1 = options.isUnaryTag || no;
       var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
       var index = 0;
       var last, lastTag;
       while (html) {
         last = html;
         // Make sure we're not in a plaintext content element like script/style
         if (!lastTag || !isPlainTextElement(lastTag)) {
           var textEnd = html.indexOf('<');
           if (textEnd === 0) {
             // Comment:
             if (comment.test(html)) {
               var commentEnd = html.indexOf('-->');
   
               if (commentEnd >= 0) {
                 if (options.shouldKeepComment) {
                   options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                 }
                 advance(commentEnd + 3);
                 continue
               }
             }
   
             // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
             if (conditionalComment.test(html)) {
               var conditionalEnd = html.indexOf(']>');
   
               if (conditionalEnd >= 0) {
                 advance(conditionalEnd + 2);
                 continue
               }
             }
   
             // Doctype:
             var doctypeMatch = html.match(doctype);
             if (doctypeMatch) {
               advance(doctypeMatch[0].length);
               continue
             }
   
             // End tag:
             var endTagMatch = html.match(endTag);
             if (endTagMatch) {
               var curIndex = index;
               advance(endTagMatch[0].length);
               parseEndTag(endTagMatch[1], curIndex, index);
               continue
             }
   
             // Start tag:
             var startTagMatch = parseStartTag();
             if (startTagMatch) {
               handleStartTag(startTagMatch);
               if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                 advance(1);
               }
               continue
             }
           }
   
           var text = (void 0), rest = (void 0), next = (void 0);
           if (textEnd >= 0) {
             rest = html.slice(textEnd);
             while (
               !endTag.test(rest) &&
               !startTagOpen.test(rest) &&
               !comment.test(rest) &&
               !conditionalComment.test(rest)
             ) {
               // < in plain text, be forgiving and treat it as text
               next = rest.indexOf('<', 1);
               if (next < 0) { break }
               textEnd += next;
               rest = html.slice(textEnd);
             }
             text = html.substring(0, textEnd);
           }
   
           if (textEnd < 0) {
             text = html;
           }
   
           if (text) {
             advance(text.length);
           }
   
           if (options.chars && text) {
             options.chars(text, index - text.length, index);
           }
         } else {
           var endTagLength = 0;
           var stackedTag = lastTag.toLowerCase();
           var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
           var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
             endTagLength = endTag.length;
             if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
               text = text
                 .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                 .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
             }
             if (shouldIgnoreFirstNewline(stackedTag, text)) {
               text = text.slice(1);
             }
             if (options.chars) {
               options.chars(text);
             }
             return ''
           });
           index += html.length - rest$1.length;
           html = rest$1;
           parseEndTag(stackedTag, index - endTagLength, index);
         }
   
         if (html === last) {
           options.chars && options.chars(html);
           if (!stack.length && options.warn) {
             options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
           }
           break
         }
       }
   
       // Clean up any remaining tags
       parseEndTag();
   
       function advance (n) {
         index += n;
         html = html.substring(n);
       }
   
       function parseStartTag () {
         var start = html.match(startTagOpen);
         if (start) {
           var match = {
             tagName: start[1],
             attrs: [],
             start: index
           };
           advance(start[0].length);
           var end, attr;
           while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
             attr.start = index;
             advance(attr[0].length);
             attr.end = index;
             match.attrs.push(attr);
           }
           if (end) {
             match.unarySlash = end[1];
             advance(end[0].length);
             match.end = index;
             return match
           }
         }
       }
   
       function handleStartTag (match) {
         var tagName = match.tagName;
         var unarySlash = match.unarySlash;
   
         if (expectHTML) {
           if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
             parseEndTag(lastTag);
           }
           if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
             parseEndTag(tagName);
           }
         }
   
         var unary = isUnaryTag$$1(tagName) || !!unarySlash;
   
         var l = match.attrs.length;
         var attrs = new Array(l);
         for (var i = 0; i < l; i++) {
           var args = match.attrs[i];
           var value = args[3] || args[4] || args[5] || '';
           var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
             ? options.shouldDecodeNewlinesForHref
             : options.shouldDecodeNewlines;
           attrs[i] = {
             name: args[1],
             value: decodeAttr(value, shouldDecodeNewlines)
           };
           if (options.outputSourceRange) {
             attrs[i].start = args.start + args[0].match(/^\s*/).length;
             attrs[i].end = args.end;
           }
         }
   
         if (!unary) {
           stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
           lastTag = tagName;
         }
   
         if (options.start) {
           options.start(tagName, attrs, unary, match.start, match.end);
         }
       }
   
       function parseEndTag (tagName, start, end) {
         var pos, lowerCasedTagName;
         if (start == null) { start = index; }
         if (end == null) { end = index; }
   
         // Find the closest opened tag of the same type
         if (tagName) {
           lowerCasedTagName = tagName.toLowerCase();
           for (pos = stack.length - 1; pos >= 0; pos--) {
             if (stack[pos].lowerCasedTag === lowerCasedTagName) {
               break
             }
           }
         } else {
           // If no tag name is provided, clean shop
           pos = 0;
         }
   
         if (pos >= 0) {
           // Close all the open elements, up the stack
           for (var i = stack.length - 1; i >= pos; i--) {
             if (i > pos || !tagName &&
               options.warn
             ) {
               options.warn(
                 ("tag <" + (stack[i].tag) + "> has no matching end tag."),
                 { start: stack[i].start, end: stack[i].end }
               );
             }
             if (options.end) {
               options.end(stack[i].tag, start, end);
             }
           }
   
           // Remove the open elements from the stack
           stack.length = pos;
           lastTag = pos && stack[pos - 1].tag;
         } else if (lowerCasedTagName === 'br') {
           if (options.start) {
             options.start(tagName, [], true, start, end);
           }
         } else if (lowerCasedTagName === 'p') {
           if (options.start) {
             options.start(tagName, [], false, start, end);
           }
           if (options.end) {
             options.end(tagName, start, end);
           }
         }
       }
     }
   
     /*  */
   
     var splitRE$1 = /\r?\n/g;
     var replaceRE = /./g;
     var isSpecialTag = makeMap('script,style,template', true);
   
     /**
      * Parse a single-file component (*.vue) file into an SFC Descriptor Object.
      */
     function parseComponent (
       content,
       options
     ) {
       if ( options === void 0 ) options = {};
   
       var sfc = {
         template: null,
         script: null,
         styles: [],
         customBlocks: [],
         errors: []
       };
       var depth = 0;
       var currentBlock = null;
   
       var warn = function (msg) {
         sfc.errors.push(msg);
       };
   
       if (options.outputSourceRange) {
         warn = function (msg, range) {
           var data = { msg: msg };
           if (range.start != null) {
             data.start = range.start;
           }
           if (range.end != null) {
             data.end = range.end;
           }
           sfc.errors.push(data);
         };
       }
   
       function start (
         tag,
         attrs,
         unary,
         start,
         end
       ) {
         if (depth === 0) {
           currentBlock = {
             type: tag,
             content: '',
             start: end,
             attrs: attrs.reduce(function (cumulated, ref) {
               var name = ref.name;
               var value = ref.value;
   
               cumulated[name] = value || true;
               return cumulated
             }, {})
           };
           if (isSpecialTag(tag)) {
             checkAttrs(currentBlock, attrs);
             if (tag === 'style') {
               sfc.styles.push(currentBlock);
             } else {
               sfc[tag] = currentBlock;
             }
           } else { // custom blocks
             sfc.customBlocks.push(currentBlock);
           }
         }
         if (!unary) {
           depth++;
         }
       }
   
       function checkAttrs (block, attrs) {
         for (var i = 0; i < attrs.length; i++) {
           var attr = attrs[i];
           if (attr.name === 'lang') {
             block.lang = attr.value;
           }
           if (attr.name === 'scoped') {
             block.scoped = true;
           }
           if (attr.name === 'module') {
             block.module = attr.value || true;
           }
           if (attr.name === 'src') {
             block.src = attr.value;
           }
         }
       }
   
       function end (tag, start) {
         if (depth === 1 && currentBlock) {
           currentBlock.end = start;
           var text = content.slice(currentBlock.start, currentBlock.end);
           if (options.deindent !== false) {
             text = deIndent(text);
           }
           // pad content so that linters and pre-processors can output correct
           // line numbers in errors and warnings
           if (currentBlock.type !== 'template' && options.pad) {
             text = padContent(currentBlock, options.pad) + text;
           }
           currentBlock.content = text;
           currentBlock = null;
         }
         depth--;
       }
   
       function padContent (block, pad) {
         if (pad === 'space') {
           return content.slice(0, block.start).replace(replaceRE, ' ')
         } else {
           var offset = content.slice(0, block.start).split(splitRE$1).length;
           var padChar = block.type === 'script' && !block.lang
             ? '//\n'
             : '\n';
           return Array(offset).join(padChar)
         }
       }
   
       parseHTML(content, {
         warn: warn,
         start: start,
         end: end,
         outputSourceRange: options.outputSourceRange
       });
   
       return sfc
     }
   
     /*  */
   
     // can we use __proto__?
     var hasProto = '__proto__' in {};
   
     // Browser environment sniffing
     var inBrowser = typeof window !== 'undefined';
     var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
     var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
     var UA = inBrowser && window.navigator.userAgent.toLowerCase();
     var isIE = UA && /msie|trident/.test(UA);
     var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
     var isEdge = UA && UA.indexOf('edge/') > 0;
     var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
     var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
     var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
     var isPhantomJS = UA && /phantomjs/.test(UA);
     var isFF = UA && UA.match(/firefox\/(\d+)/);
   
     // Firefox has a "watch" function on Object.prototype...
     var nativeWatch = ({}).watch;
     if (inBrowser) {
       try {
         var opts = {};
         Object.defineProperty(opts, 'passive', ({
           get: function get () {
           }
         })); // https://github.com/facebook/flow/issues/285
         window.addEventListener('test-passive', null, opts);
       } catch (e) {}
     }
   
     // this needs to be lazy-evaled because vue may be required before
     // vue-server-renderer can set VUE_ENV
     var _isServer;
     var isServerRendering = function () {
       if (_isServer === undefined) {
         /* istanbul ignore if */
         if (!inBrowser && !inWeex && typeof __webpack_require__.g !== 'undefined') {
           // detect presence of vue-server-renderer and avoid
           // Webpack shimming the process
           _isServer = __webpack_require__.g['process'] && __webpack_require__.g['process'].env.VUE_ENV === 'server';
         } else {
           _isServer = false;
         }
       }
       return _isServer
     };
   
     // detect devtools
     var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
   
     /* istanbul ignore next */
     function isNative (Ctor) {
       return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
     }
   
     var hasSymbol =
       typeof Symbol !== 'undefined' && isNative(Symbol) &&
       typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
   
     var _Set;
     /* istanbul ignore if */ // $flow-disable-line
     if (typeof Set !== 'undefined' && isNative(Set)) {
       // use native Set when available.
       _Set = Set;
     } else {
       // a non-standard Set polyfill that only works with primitive keys.
       _Set = /*@__PURE__*/(function () {
         function Set () {
           this.set = Object.create(null);
         }
         Set.prototype.has = function has (key) {
           return this.set[key] === true
         };
         Set.prototype.add = function add (key) {
           this.set[key] = true;
         };
         Set.prototype.clear = function clear () {
           this.set = Object.create(null);
         };
   
         return Set;
       }());
     }
   
     var ASSET_TYPES = [
       'component',
       'directive',
       'filter'
     ];
   
     var LIFECYCLE_HOOKS = [
       'beforeCreate',
       'created',
       'beforeMount',
       'mounted',
       'beforeUpdate',
       'updated',
       'beforeDestroy',
       'destroyed',
       'activated',
       'deactivated',
       'errorCaptured',
       'serverPrefetch'
     ];
   
     /*  */
   
   
   
     var config = ({
       /**
        * Option merge strategies (used in core/util/options)
        */
       // $flow-disable-line
       optionMergeStrategies: Object.create(null),
   
       /**
        * Whether to suppress warnings.
        */
       silent: false,
   
       /**
        * Show production mode tip message on boot?
        */
       productionTip: "development" !== 'production',
   
       /**
        * Whether to enable devtools
        */
       devtools: "development" !== 'production',
   
       /**
        * Whether to record perf
        */
       performance: false,
   
       /**
        * Error handler for watcher errors
        */
       errorHandler: null,
   
       /**
        * Warn handler for watcher warns
        */
       warnHandler: null,
   
       /**
        * Ignore certain custom elements
        */
       ignoredElements: [],
   
       /**
        * Custom user key aliases for v-on
        */
       // $flow-disable-line
       keyCodes: Object.create(null),
   
       /**
        * Check if a tag is reserved so that it cannot be registered as a
        * component. This is platform-dependent and may be overwritten.
        */
       isReservedTag: no,
   
       /**
        * Check if an attribute is reserved so that it cannot be used as a component
        * prop. This is platform-dependent and may be overwritten.
        */
       isReservedAttr: no,
   
       /**
        * Check if a tag is an unknown element.
        * Platform-dependent.
        */
       isUnknownElement: no,
   
       /**
        * Get the namespace of an element
        */
       getTagNamespace: noop,
   
       /**
        * Parse the real tag name for the specific platform.
        */
       parsePlatformTagName: identity,
   
       /**
        * Check if an attribute must be bound using property, e.g. value
        * Platform-dependent.
        */
       mustUseProp: no,
   
       /**
        * Perform updates asynchronously. Intended to be used by Vue Test Utils
        * This will significantly reduce performance if set to false.
        */
       async: true,
   
       /**
        * Exposed for legacy reasons
        */
       _lifecycleHooks: LIFECYCLE_HOOKS
     });
   
     /*  */
   
     var warn = noop;
     var tip = noop;
     var generateComponentTrace = (noop); // work around flow check
     var formatComponentName = (noop);
   
     {
       var hasConsole = typeof console !== 'undefined';
       var classifyRE = /(?:^|[-_])(\w)/g;
       var classify = function (str) { return str
         .replace(classifyRE, function (c) { return c.toUpperCase(); })
         .replace(/[-_]/g, ''); };
   
       warn = function (msg, vm) {
         var trace = vm ? generateComponentTrace(vm) : '';
   
         if (hasConsole && (!config.silent)) {
           console.error(("[Vue warn]: " + msg + trace));
         }
       };
   
       tip = function (msg, vm) {
         if (hasConsole && (!config.silent)) {
           console.warn("[Vue tip]: " + msg + (
             vm ? generateComponentTrace(vm) : ''
           ));
         }
       };
   
       formatComponentName = function (vm, includeFile) {
         if (vm.$root === vm) {
           return '<Root>'
         }
         var options = typeof vm === 'function' && vm.cid != null
           ? vm.options
           : vm._isVue
             ? vm.$options || vm.constructor.options
             : vm;
         var name = options.name || options._componentTag;
         var file = options.__file;
         if (!name && file) {
           var match = file.match(/([^/\\]+)\.vue$/);
           name = match && match[1];
         }
   
         return (
           (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
           (file && includeFile !== false ? (" at " + file) : '')
         )
       };
   
       var repeat = function (str, n) {
         var res = '';
         while (n) {
           if (n % 2 === 1) { res += str; }
           if (n > 1) { str += str; }
           n >>= 1;
         }
         return res
       };
   
       generateComponentTrace = function (vm) {
         if (vm._isVue && vm.$parent) {
           var tree = [];
           var currentRecursiveSequence = 0;
           while (vm) {
             if (tree.length > 0) {
               var last = tree[tree.length - 1];
               if (last.constructor === vm.constructor) {
                 currentRecursiveSequence++;
                 vm = vm.$parent;
                 continue
               } else if (currentRecursiveSequence > 0) {
                 tree[tree.length - 1] = [last, currentRecursiveSequence];
                 currentRecursiveSequence = 0;
               }
             }
             tree.push(vm);
             vm = vm.$parent;
           }
           return '\n\nfound in\n\n' + tree
             .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
                 ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
                 : formatComponentName(vm))); })
             .join('\n')
         } else {
           return ("\n\n(found in " + (formatComponentName(vm)) + ")")
         }
       };
     }
   
     /*  */
   
     var uid = 0;
   
     /**
      * A dep is an observable that can have multiple
      * directives subscribing to it.
      */
     var Dep = function Dep () {
       this.id = uid++;
       this.subs = [];
     };
   
     Dep.prototype.addSub = function addSub (sub) {
       this.subs.push(sub);
     };
   
     Dep.prototype.removeSub = function removeSub (sub) {
       remove(this.subs, sub);
     };
   
     Dep.prototype.depend = function depend () {
       if (Dep.target) {
         Dep.target.addDep(this);
       }
     };
   
     Dep.prototype.notify = function notify () {
       // stabilize the subscriber list first
       var subs = this.subs.slice();
       for (var i = 0, l = subs.length; i < l; i++) {
         subs[i].update();
       }
     };
   
     // The current target watcher being evaluated.
     // This is globally unique because only one watcher
     // can be evaluated at a time.
     Dep.target = null;
   
     /*  */
   
     var VNode = function VNode (
       tag,
       data,
       children,
       text,
       elm,
       context,
       componentOptions,
       asyncFactory
     ) {
       this.tag = tag;
       this.data = data;
       this.children = children;
       this.text = text;
       this.elm = elm;
       this.ns = undefined;
       this.context = context;
       this.fnContext = undefined;
       this.fnOptions = undefined;
       this.fnScopeId = undefined;
       this.key = data && data.key;
       this.componentOptions = componentOptions;
       this.componentInstance = undefined;
       this.parent = undefined;
       this.raw = false;
       this.isStatic = false;
       this.isRootInsert = true;
       this.isComment = false;
       this.isCloned = false;
       this.isOnce = false;
       this.asyncFactory = asyncFactory;
       this.asyncMeta = undefined;
       this.isAsyncPlaceholder = false;
     };
   
     var prototypeAccessors = { child: { configurable: true } };
   
     // DEPRECATED: alias for componentInstance for backwards compat.
     /* istanbul ignore next */
     prototypeAccessors.child.get = function () {
       return this.componentInstance
     };
   
     Object.defineProperties( VNode.prototype, prototypeAccessors );
   
     /*
      * not type checking this file because flow doesn't play well with
      * dynamically accessing methods on Array prototype
      */
   
     var arrayProto = Array.prototype;
     var arrayMethods = Object.create(arrayProto);
   
     var methodsToPatch = [
       'push',
       'pop',
       'shift',
       'unshift',
       'splice',
       'sort',
       'reverse'
     ];
   
     /**
      * Intercept mutating methods and emit events
      */
     methodsToPatch.forEach(function (method) {
       // cache original method
       var original = arrayProto[method];
       def(arrayMethods, method, function mutator () {
         var args = [], len = arguments.length;
         while ( len-- ) args[ len ] = arguments[ len ];
   
         var result = original.apply(this, args);
         var ob = this.__ob__;
         var inserted;
         switch (method) {
           case 'push':
           case 'unshift':
             inserted = args;
             break
           case 'splice':
             inserted = args.slice(2);
             break
         }
         if (inserted) { ob.observeArray(inserted); }
         // notify change
         ob.dep.notify();
         return result
       });
     });
   
     /*  */
   
     var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
   
     /**
      * In some cases we may want to disable observation inside a component's
      * update computation.
      */
     var shouldObserve = true;
   
     /**
      * Observer class that is attached to each observed
      * object. Once attached, the observer converts the target
      * object's property keys into getter/setters that
      * collect dependencies and dispatch updates.
      */
     var Observer = function Observer (value) {
       this.value = value;
       this.dep = new Dep();
       this.vmCount = 0;
       def(value, '__ob__', this);
       if (Array.isArray(value)) {
         if (hasProto) {
           protoAugment(value, arrayMethods);
         } else {
           copyAugment(value, arrayMethods, arrayKeys);
         }
         this.observeArray(value);
       } else {
         this.walk(value);
       }
     };
   
     /**
      * Walk through all properties and convert them into
      * getter/setters. This method should only be called when
      * value type is Object.
      */
     Observer.prototype.walk = function walk (obj) {
       var keys = Object.keys(obj);
       for (var i = 0; i < keys.length; i++) {
         defineReactive$$1(obj, keys[i]);
       }
     };
   
     /**
      * Observe a list of Array items.
      */
     Observer.prototype.observeArray = function observeArray (items) {
       for (var i = 0, l = items.length; i < l; i++) {
         observe(items[i]);
       }
     };
   
     // helpers
   
     /**
      * Augment a target Object or Array by intercepting
      * the prototype chain using __proto__
      */
     function protoAugment (target, src) {
       /* eslint-disable no-proto */
       target.__proto__ = src;
       /* eslint-enable no-proto */
     }
   
     /**
      * Augment a target Object or Array by defining
      * hidden properties.
      */
     /* istanbul ignore next */
     function copyAugment (target, src, keys) {
       for (var i = 0, l = keys.length; i < l; i++) {
         var key = keys[i];
         def(target, key, src[key]);
       }
     }
   
     /**
      * Attempt to create an observer instance for a value,
      * returns the new observer if successfully observed,
      * or the existing observer if the value already has one.
      */
     function observe (value, asRootData) {
       if (!isObject(value) || value instanceof VNode) {
         return
       }
       var ob;
       if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
         ob = value.__ob__;
       } else if (
         shouldObserve &&
         !isServerRendering() &&
         (Array.isArray(value) || isPlainObject(value)) &&
         Object.isExtensible(value) &&
         !value._isVue
       ) {
         ob = new Observer(value);
       }
       if (asRootData && ob) {
         ob.vmCount++;
       }
       return ob
     }
   
     /**
      * Define a reactive property on an Object.
      */
     function defineReactive$$1 (
       obj,
       key,
       val,
       customSetter,
       shallow
     ) {
       var dep = new Dep();
   
       var property = Object.getOwnPropertyDescriptor(obj, key);
       if (property && property.configurable === false) {
         return
       }
   
       // cater for pre-defined getter/setters
       var getter = property && property.get;
       var setter = property && property.set;
       if ((!getter || setter) && arguments.length === 2) {
         val = obj[key];
       }
   
       var childOb = !shallow && observe(val);
       Object.defineProperty(obj, key, {
         enumerable: true,
         configurable: true,
         get: function reactiveGetter () {
           var value = getter ? getter.call(obj) : val;
           if (Dep.target) {
             dep.depend();
             if (childOb) {
               childOb.dep.depend();
               if (Array.isArray(value)) {
                 dependArray(value);
               }
             }
           }
           return value
         },
         set: function reactiveSetter (newVal) {
           var value = getter ? getter.call(obj) : val;
           /* eslint-disable no-self-compare */
           if (newVal === value || (newVal !== newVal && value !== value)) {
             return
           }
           /* eslint-enable no-self-compare */
           if (customSetter) {
             customSetter();
           }
           // #7981: for accessor properties without setter
           if (getter && !setter) { return }
           if (setter) {
             setter.call(obj, newVal);
           } else {
             val = newVal;
           }
           childOb = !shallow && observe(newVal);
           dep.notify();
         }
       });
     }
   
     /**
      * Set a property on an object. Adds the new property and
      * triggers change notification if the property doesn't
      * already exist.
      */
     function set (target, key, val) {
       if (isUndef(target) || isPrimitive(target)
       ) {
         warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
       }
       if (Array.isArray(target) && isValidArrayIndex(key)) {
         target.length = Math.max(target.length, key);
         target.splice(key, 1, val);
         return val
       }
       if (key in target && !(key in Object.prototype)) {
         target[key] = val;
         return val
       }
       var ob = (target).__ob__;
       if (target._isVue || (ob && ob.vmCount)) {
         warn(
           'Avoid adding reactive properties to a Vue instance or its root $data ' +
           'at runtime - declare it upfront in the data option.'
         );
         return val
       }
       if (!ob) {
         target[key] = val;
         return val
       }
       defineReactive$$1(ob.value, key, val);
       ob.dep.notify();
       return val
     }
   
     /**
      * Collect dependencies on array elements when the array is touched, since
      * we cannot intercept array element access like property getters.
      */
     function dependArray (value) {
       for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
         e = value[i];
         e && e.__ob__ && e.__ob__.dep.depend();
         if (Array.isArray(e)) {
           dependArray(e);
         }
       }
     }
   
     /*  */
   
     /**
      * Option overwriting strategies are functions that handle
      * how to merge a parent option value and a child option
      * value into the final value.
      */
     var strats = config.optionMergeStrategies;
   
     /**
      * Options with restrictions
      */
     {
       strats.el = strats.propsData = function (parent, child, vm, key) {
         if (!vm) {
           warn(
             "option \"" + key + "\" can only be used during instance " +
             'creation with the `new` keyword.'
           );
         }
         return defaultStrat(parent, child)
       };
     }
   
     /**
      * Helper that recursively merges two data objects together.
      */
     function mergeData (to, from) {
       if (!from) { return to }
       var key, toVal, fromVal;
   
       var keys = hasSymbol
         ? Reflect.ownKeys(from)
         : Object.keys(from);
   
       for (var i = 0; i < keys.length; i++) {
         key = keys[i];
         // in case the object is already observed...
         if (key === '__ob__') { continue }
         toVal = to[key];
         fromVal = from[key];
         if (!hasOwn(to, key)) {
           set(to, key, fromVal);
         } else if (
           toVal !== fromVal &&
           isPlainObject(toVal) &&
           isPlainObject(fromVal)
         ) {
           mergeData(toVal, fromVal);
         }
       }
       return to
     }
   
     /**
      * Data
      */
     function mergeDataOrFn (
       parentVal,
       childVal,
       vm
     ) {
       if (!vm) {
         // in a Vue.extend merge, both should be functions
         if (!childVal) {
           return parentVal
         }
         if (!parentVal) {
           return childVal
         }
         // when parentVal & childVal are both present,
         // we need to return a function that returns the
         // merged result of both functions... no need to
         // check if parentVal is a function here because
         // it has to be a function to pass previous merges.
         return function mergedDataFn () {
           return mergeData(
             typeof childVal === 'function' ? childVal.call(this, this) : childVal,
             typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
           )
         }
       } else {
         return function mergedInstanceDataFn () {
           // instance merge
           var instanceData = typeof childVal === 'function'
             ? childVal.call(vm, vm)
             : childVal;
           var defaultData = typeof parentVal === 'function'
             ? parentVal.call(vm, vm)
             : parentVal;
           if (instanceData) {
             return mergeData(instanceData, defaultData)
           } else {
             return defaultData
           }
         }
       }
     }
   
     strats.data = function (
       parentVal,
       childVal,
       vm
     ) {
       if (!vm) {
         if (childVal && typeof childVal !== 'function') {
           warn(
             'The "data" option should be a function ' +
             'that returns a per-instance value in component ' +
             'definitions.',
             vm
           );
   
           return parentVal
         }
         return mergeDataOrFn(parentVal, childVal)
       }
   
       return mergeDataOrFn(parentVal, childVal, vm)
     };
   
     /**
      * Hooks and props are merged as arrays.
      */
     function mergeHook (
       parentVal,
       childVal
     ) {
       var res = childVal
         ? parentVal
           ? parentVal.concat(childVal)
           : Array.isArray(childVal)
             ? childVal
             : [childVal]
         : parentVal;
       return res
         ? dedupeHooks(res)
         : res
     }
   
     function dedupeHooks (hooks) {
       var res = [];
       for (var i = 0; i < hooks.length; i++) {
         if (res.indexOf(hooks[i]) === -1) {
           res.push(hooks[i]);
         }
       }
       return res
     }
   
     LIFECYCLE_HOOKS.forEach(function (hook) {
       strats[hook] = mergeHook;
     });
   
     /**
      * Assets
      *
      * When a vm is present (instance creation), we need to do
      * a three-way merge between constructor options, instance
      * options and parent options.
      */
     function mergeAssets (
       parentVal,
       childVal,
       vm,
       key
     ) {
       var res = Object.create(parentVal || null);
       if (childVal) {
         assertObjectType(key, childVal, vm);
         return extend(res, childVal)
       } else {
         return res
       }
     }
   
     ASSET_TYPES.forEach(function (type) {
       strats[type + 's'] = mergeAssets;
     });
   
     /**
      * Watchers.
      *
      * Watchers hashes should not overwrite one
      * another, so we merge them as arrays.
      */
     strats.watch = function (
       parentVal,
       childVal,
       vm,
       key
     ) {
       // work around Firefox's Object.prototype.watch...
       if (parentVal === nativeWatch) { parentVal = undefined; }
       if (childVal === nativeWatch) { childVal = undefined; }
       /* istanbul ignore if */
       if (!childVal) { return Object.create(parentVal || null) }
       {
         assertObjectType(key, childVal, vm);
       }
       if (!parentVal) { return childVal }
       var ret = {};
       extend(ret, parentVal);
       for (var key$1 in childVal) {
         var parent = ret[key$1];
         var child = childVal[key$1];
         if (parent && !Array.isArray(parent)) {
           parent = [parent];
         }
         ret[key$1] = parent
           ? parent.concat(child)
           : Array.isArray(child) ? child : [child];
       }
       return ret
     };
   
     /**
      * Other object hashes.
      */
     strats.props =
     strats.methods =
     strats.inject =
     strats.computed = function (
       parentVal,
       childVal,
       vm,
       key
     ) {
       if (childVal && "development" !== 'production') {
         assertObjectType(key, childVal, vm);
       }
       if (!parentVal) { return childVal }
       var ret = Object.create(null);
       extend(ret, parentVal);
       if (childVal) { extend(ret, childVal); }
       return ret
     };
     strats.provide = mergeDataOrFn;
   
     /**
      * Default strategy.
      */
     var defaultStrat = function (parentVal, childVal) {
       return childVal === undefined
         ? parentVal
         : childVal
     };
   
     function assertObjectType (name, value, vm) {
       if (!isPlainObject(value)) {
         warn(
           "Invalid value for option \"" + name + "\": expected an Object, " +
           "but got " + (toRawType(value)) + ".",
           vm
         );
       }
     }
   
     /*  */
   
     /*  */
   
     /*  */
   
     var callbacks = [];
   
     function flushCallbacks () {
       var copies = callbacks.slice(0);
       callbacks.length = 0;
       for (var i = 0; i < copies.length; i++) {
         copies[i]();
       }
     }
   
     // The nextTick behavior leverages the microtask queue, which can be accessed
     // via either native Promise.then or MutationObserver.
     // MutationObserver has wider support, however it is seriously bugged in
     // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
     // completely stops working after triggering a few times... so, if native
     // Promise is available, we will use it:
     /* istanbul ignore next, $flow-disable-line */
     if (typeof Promise !== 'undefined' && isNative(Promise)) ; else if (!isIE && typeof MutationObserver !== 'undefined' && (
       isNative(MutationObserver) ||
       // PhantomJS and iOS 7.x
       MutationObserver.toString() === '[object MutationObserverConstructor]'
     )) {
       // Use MutationObserver where native Promise is not available,
       // e.g. PhantomJS, iOS7, Android 4.4
       // (#6466 MutationObserver is unreliable in IE11)
       var counter = 1;
       var observer = new MutationObserver(flushCallbacks);
       var textNode = document.createTextNode(String(counter));
       observer.observe(textNode, {
         characterData: true
       });
     } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) ;
   
     /*  */
   
     /*  */
   
     // these are reserved for web because they are directly compiled away
     // during template compilation
     var isReservedAttr = makeMap('style,class');
   
     // attributes that should be using props for binding
     var acceptValue = makeMap('input,textarea,option,select,progress');
     var mustUseProp = function (tag, type, attr) {
       return (
         (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
         (attr === 'selected' && tag === 'option') ||
         (attr === 'checked' && tag === 'input') ||
         (attr === 'muted' && tag === 'video')
       )
     };
   
     var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
   
     var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
   
     var isBooleanAttr = makeMap(
       'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
       'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
       'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
       'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
       'required,reversed,scoped,seamless,selected,sortable,' +
       'truespeed,typemustmatch,visible'
     );
   
     /*  */
   
     /*  */
   
     var isHTMLTag = makeMap(
       'html,body,base,head,link,meta,style,title,' +
       'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
       'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
       'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
       's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
       'embed,object,param,source,canvas,script,noscript,del,ins,' +
       'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
       'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
       'output,progress,select,textarea,' +
       'details,dialog,menu,menuitem,summary,' +
       'content,element,shadow,template,blockquote,iframe,tfoot'
     );
   
     // this map is intentionally selective, only covering SVG elements that may
     // contain child elements.
     var isSVG = makeMap(
       'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
       'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
       'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
       true
     );
   
     var isPreTag = function (tag) { return tag === 'pre'; };
   
     var isReservedTag = function (tag) {
       return isHTMLTag(tag) || isSVG(tag)
     };
   
     function getTagNamespace (tag) {
       if (isSVG(tag)) {
         return 'svg'
       }
       // basic support for MathML
       // note it doesn't support other MathML elements being component roots
       if (tag === 'math') {
         return 'math'
       }
     }
   
     var isTextInputType = makeMap('text,number,password,search,email,tel,url');
   
     /*  */
   
     /*  */
   
     var validDivisionCharRE = /[\w).+\-_$\]]/;
   
     function parseFilters (exp) {
       var inSingle = false;
       var inDouble = false;
       var inTemplateString = false;
       var inRegex = false;
       var curly = 0;
       var square = 0;
       var paren = 0;
       var lastFilterIndex = 0;
       var c, prev, i, expression, filters;
   
       for (i = 0; i < exp.length; i++) {
         prev = c;
         c = exp.charCodeAt(i);
         if (inSingle) {
           if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
         } else if (inDouble) {
           if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
         } else if (inTemplateString) {
           if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
         } else if (inRegex) {
           if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
         } else if (
           c === 0x7C && // pipe
           exp.charCodeAt(i + 1) !== 0x7C &&
           exp.charCodeAt(i - 1) !== 0x7C &&
           !curly && !square && !paren
         ) {
           if (expression === undefined) {
             // first filter, end of expression
             lastFilterIndex = i + 1;
             expression = exp.slice(0, i).trim();
           } else {
             pushFilter();
           }
         } else {
           switch (c) {
             case 0x22: inDouble = true; break         // "
             case 0x27: inSingle = true; break         // '
             case 0x60: inTemplateString = true; break // `
             case 0x28: paren++; break                 // (
             case 0x29: paren--; break                 // )
             case 0x5B: square++; break                // [
             case 0x5D: square--; break                // ]
             case 0x7B: curly++; break                 // {
             case 0x7D: curly--; break                 // }
           }
           if (c === 0x2f) { // /
             var j = i - 1;
             var p = (void 0);
             // find first non-whitespace prev char
             for (; j >= 0; j--) {
               p = exp.charAt(j);
               if (p !== ' ') { break }
             }
             if (!p || !validDivisionCharRE.test(p)) {
               inRegex = true;
             }
           }
         }
       }
   
       if (expression === undefined) {
         expression = exp.slice(0, i).trim();
       } else if (lastFilterIndex !== 0) {
         pushFilter();
       }
   
       function pushFilter () {
         (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
         lastFilterIndex = i + 1;
       }
   
       if (filters) {
         for (i = 0; i < filters.length; i++) {
           expression = wrapFilter(expression, filters[i]);
         }
       }
   
       return expression
     }
   
     function wrapFilter (exp, filter) {
       var i = filter.indexOf('(');
       if (i < 0) {
         // _f: resolveFilter
         return ("_f(\"" + filter + "\")(" + exp + ")")
       } else {
         var name = filter.slice(0, i);
         var args = filter.slice(i + 1);
         return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
       }
     }
   
     /*  */
   
     var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
     var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
   
     var buildRegex = cached(function (delimiters) {
       var open = delimiters[0].replace(regexEscapeRE, '\\$&');
       var close = delimiters[1].replace(regexEscapeRE, '\\$&');
       return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
     });
   
   
   
     function parseText (
       text,
       delimiters
     ) {
       var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
       if (!tagRE.test(text)) {
         return
       }
       var tokens = [];
       var rawTokens = [];
       var lastIndex = tagRE.lastIndex = 0;
       var match, index, tokenValue;
       while ((match = tagRE.exec(text))) {
         index = match.index;
         // push text token
         if (index > lastIndex) {
           rawTokens.push(tokenValue = text.slice(lastIndex, index));
           tokens.push(JSON.stringify(tokenValue));
         }
         // tag token
         var exp = parseFilters(match[1].trim());
         tokens.push(("_s(" + exp + ")"));
         rawTokens.push({ '@binding': exp });
         lastIndex = index + match[0].length;
       }
       if (lastIndex < text.length) {
         rawTokens.push(tokenValue = text.slice(lastIndex));
         tokens.push(JSON.stringify(tokenValue));
       }
       return {
         expression: tokens.join('+'),
         tokens: rawTokens
       }
     }
   
     /*  */
   
   
   
     /* eslint-disable no-unused-vars */
     function baseWarn (msg, range) {
       console.error(("[Vue compiler]: " + msg));
     }
     /* eslint-enable no-unused-vars */
   
     function pluckModuleFunction (
       modules,
       key
     ) {
       return modules
         ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
         : []
     }
   
     function addProp (el, name, value, range, dynamic) {
       (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
       el.plain = false;
     }
   
     function addAttr (el, name, value, range, dynamic) {
       var attrs = dynamic
         ? (el.dynamicAttrs || (el.dynamicAttrs = []))
         : (el.attrs || (el.attrs = []));
       attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
       el.plain = false;
     }
   
     // add a raw attr (use this in preTransforms)
     function addRawAttr (el, name, value, range) {
       el.attrsMap[name] = value;
       el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
     }
   
     function addDirective (
       el,
       name,
       rawName,
       value,
       arg,
       isDynamicArg,
       modifiers,
       range
     ) {
       (el.directives || (el.directives = [])).push(rangeSetItem({
         name: name,
         rawName: rawName,
         value: value,
         arg: arg,
         isDynamicArg: isDynamicArg,
         modifiers: modifiers
       }, range));
       el.plain = false;
     }
   
     function prependModifierMarker (symbol, name, dynamic) {
       return dynamic
         ? ("_p(" + name + ",\"" + symbol + "\")")
         : symbol + name // mark the event as captured
     }
   
     function addHandler (
       el,
       name,
       value,
       modifiers,
       important,
       warn,
       range,
       dynamic
     ) {
       modifiers = modifiers || emptyObject;
       // warn prevent and passive modifier
       /* istanbul ignore if */
       if (
         warn &&
         modifiers.prevent && modifiers.passive
       ) {
         warn(
           'passive and prevent can\'t be used together. ' +
           'Passive handler can\'t prevent default event.',
           range
         );
       }
   
       // normalize click.right and click.middle since they don't actually fire
       // this is technically browser-specific, but at least for now browsers are
       // the only target envs that have right/middle clicks.
       if (modifiers.right) {
         if (dynamic) {
           name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
         } else if (name === 'click') {
           name = 'contextmenu';
           delete modifiers.right;
         }
       } else if (modifiers.middle) {
         if (dynamic) {
           name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
         } else if (name === 'click') {
           name = 'mouseup';
         }
       }
   
       // check capture modifier
       if (modifiers.capture) {
         delete modifiers.capture;
         name = prependModifierMarker('!', name, dynamic);
       }
       if (modifiers.once) {
         delete modifiers.once;
         name = prependModifierMarker('~', name, dynamic);
       }
       /* istanbul ignore if */
       if (modifiers.passive) {
         delete modifiers.passive;
         name = prependModifierMarker('&', name, dynamic);
       }
   
       var events;
       if (modifiers.native) {
         delete modifiers.native;
         events = el.nativeEvents || (el.nativeEvents = {});
       } else {
         events = el.events || (el.events = {});
       }
   
       var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
       if (modifiers !== emptyObject) {
         newHandler.modifiers = modifiers;
       }
   
       var handlers = events[name];
       /* istanbul ignore if */
       if (Array.isArray(handlers)) {
         important ? handlers.unshift(newHandler) : handlers.push(newHandler);
       } else if (handlers) {
         events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
       } else {
         events[name] = newHandler;
       }
   
       el.plain = false;
     }
   
     function getRawBindingAttr (
       el,
       name
     ) {
       return el.rawAttrsMap[':' + name] ||
         el.rawAttrsMap['v-bind:' + name] ||
         el.rawAttrsMap[name]
     }
   
     function getBindingAttr (
       el,
       name,
       getStatic
     ) {
       var dynamicValue =
         getAndRemoveAttr(el, ':' + name) ||
         getAndRemoveAttr(el, 'v-bind:' + name);
       if (dynamicValue != null) {
         return parseFilters(dynamicValue)
       } else if (getStatic !== false) {
         var staticValue = getAndRemoveAttr(el, name);
         if (staticValue != null) {
           return JSON.stringify(staticValue)
         }
       }
     }
   
     // note: this only removes the attr from the Array (attrsList) so that it
     // doesn't get processed by processAttrs.
     // By default it does NOT remove it from the map (attrsMap) because the map is
     // needed during codegen.
     function getAndRemoveAttr (
       el,
       name,
       removeFromMap
     ) {
       var val;
       if ((val = el.attrsMap[name]) != null) {
         var list = el.attrsList;
         for (var i = 0, l = list.length; i < l; i++) {
           if (list[i].name === name) {
             list.splice(i, 1);
             break
           }
         }
       }
       if (removeFromMap) {
         delete el.attrsMap[name];
       }
       return val
     }
   
     function getAndRemoveAttrByRegex (
       el,
       name
     ) {
       var list = el.attrsList;
       for (var i = 0, l = list.length; i < l; i++) {
         var attr = list[i];
         if (name.test(attr.name)) {
           list.splice(i, 1);
           return attr
         }
       }
     }
   
     function rangeSetItem (
       item,
       range
     ) {
       if (range) {
         if (range.start != null) {
           item.start = range.start;
         }
         if (range.end != null) {
           item.end = range.end;
         }
       }
       return item
     }
   
     /*  */
   
     function transformNode (el, options) {
       var warn = options.warn || baseWarn;
       var staticClass = getAndRemoveAttr(el, 'class');
       if (staticClass) {
         var res = parseText(staticClass, options.delimiters);
         if (res) {
           warn(
             "class=\"" + staticClass + "\": " +
             'Interpolation inside attributes has been removed. ' +
             'Use v-bind or the colon shorthand instead. For example, ' +
             'instead of <div class="{{ val }}">, use <div :class="val">.',
             el.rawAttrsMap['class']
           );
         }
       }
       if (staticClass) {
         el.staticClass = JSON.stringify(staticClass);
       }
       var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
       if (classBinding) {
         el.classBinding = classBinding;
       }
     }
   
     function genData (el) {
       var data = '';
       if (el.staticClass) {
         data += "staticClass:" + (el.staticClass) + ",";
       }
       if (el.classBinding) {
         data += "class:" + (el.classBinding) + ",";
       }
       return data
     }
   
     var klass = {
       staticKeys: ['staticClass'],
       transformNode: transformNode,
       genData: genData
     };
   
     /*  */
   
     var parseStyleText = cached(function (cssText) {
       var res = {};
       var listDelimiter = /;(?![^(]*\))/g;
       var propertyDelimiter = /:(.+)/;
       cssText.split(listDelimiter).forEach(function (item) {
         if (item) {
           var tmp = item.split(propertyDelimiter);
           tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
         }
       });
       return res
     });
   
     /*  */
   
     function transformNode$1 (el, options) {
       var warn = options.warn || baseWarn;
       var staticStyle = getAndRemoveAttr(el, 'style');
       if (staticStyle) {
         /* istanbul ignore if */
         {
           var res = parseText(staticStyle, options.delimiters);
           if (res) {
             warn(
               "style=\"" + staticStyle + "\": " +
               'Interpolation inside attributes has been removed. ' +
               'Use v-bind or the colon shorthand instead. For example, ' +
               'instead of <div style="{{ val }}">, use <div :style="val">.',
               el.rawAttrsMap['style']
             );
           }
         }
         el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
       }
   
       var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
       if (styleBinding) {
         el.styleBinding = styleBinding;
       }
     }
   
     function genData$1 (el) {
       var data = '';
       if (el.staticStyle) {
         data += "staticStyle:" + (el.staticStyle) + ",";
       }
       if (el.styleBinding) {
         data += "style:(" + (el.styleBinding) + "),";
       }
       return data
     }
   
     var style = {
       staticKeys: ['staticStyle'],
       transformNode: transformNode$1,
       genData: genData$1
     };
   
     var commonjsGlobal = typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};
   
     function createCommonjsModule(fn, module) {
         return module = { exports: {} }, fn(module, module.exports), module.exports;
     }
   
     var he = createCommonjsModule(function (module, exports) {
     (function(root) {
   
         // Detect free variables `exports`.
         var freeExports = exports;
   
         // Detect free variable `module`.
         var freeModule = module &&
             module.exports == freeExports && module;
   
         // Detect free variable `global`, from Node.js or Browserified code,
         // and use it as `root`.
         var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
         if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
             root = freeGlobal;
         }
   
         /*--------------------------------------------------------------------------*/
   
         // All astral symbols.
         var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
         // All ASCII symbols (not just printable ASCII) except those listed in the
         // first column of the overrides table.
         // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
         var regexAsciiWhitelist = /[\x01-\x7F]/g;
         // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
         // code points listed in the first column of the overrides table on
         // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
         var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
   
         var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
         var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};
   
         var regexEscape = /["&'<>`]/g;
         var escapeMap = {
             '"': '&quot;',
             '&': '&amp;',
             '\'': '&#x27;',
             '<': '&lt;',
             // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
             // following is not strictly necessary unless it’s part of a tag or an
             // unquoted attribute value. We’re only escaping it to support those
             // situations, and for XML support.
             '>': '&gt;',
             // In Internet Explorer ≤ 8, the backtick character can be used
             // to break out of (un)quoted attribute values or HTML comments.
             // See http://html5sec.org/#102, http://html5sec.org/#108, and
             // http://html5sec.org/#133.
             '`': '&#x60;'
         };
   
         var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
         var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
         var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
         var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
         var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
         var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
         var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];
   
         /*--------------------------------------------------------------------------*/
   
         var stringFromCharCode = String.fromCharCode;
   
         var object = {};
         var hasOwnProperty = object.hasOwnProperty;
         var has = function(object, propertyName) {
             return hasOwnProperty.call(object, propertyName);
         };
   
         var contains = function(array, value) {
             var index = -1;
             var length = array.length;
             while (++index < length) {
                 if (array[index] == value) {
                     return true;
                 }
             }
             return false;
         };
   
         var merge = function(options, defaults) {
             if (!options) {
                 return defaults;
             }
             var result = {};
             var key;
             for (key in defaults) {
                 // A `hasOwnProperty` check is not needed here, since only recognized
                 // option names are used anyway. Any others are ignored.
                 result[key] = has(options, key) ? options[key] : defaults[key];
             }
             return result;
         };
   
         // Modified version of `ucs2encode`; see https://mths.be/punycode.
         var codePointToSymbol = function(codePoint, strict) {
             var output = '';
             if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
                 // See issue #4:
                 // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
                 // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
                 // REPLACEMENT CHARACTER.”
                 if (strict) {
                     parseError('character reference outside the permissible Unicode range');
                 }
                 return '\uFFFD';
             }
             if (has(decodeMapNumeric, codePoint)) {
                 if (strict) {
                     parseError('disallowed character reference');
                 }
                 return decodeMapNumeric[codePoint];
             }
             if (strict && contains(invalidReferenceCodePoints, codePoint)) {
                 parseError('disallowed character reference');
             }
             if (codePoint > 0xFFFF) {
                 codePoint -= 0x10000;
                 output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
                 codePoint = 0xDC00 | codePoint & 0x3FF;
             }
             output += stringFromCharCode(codePoint);
             return output;
         };
   
         var hexEscape = function(codePoint) {
             return '&#x' + codePoint.toString(16).toUpperCase() + ';';
         };
   
         var decEscape = function(codePoint) {
             return '&#' + codePoint + ';';
         };
   
         var parseError = function(message) {
             throw Error('Parse error: ' + message);
         };
   
         /*--------------------------------------------------------------------------*/
   
         var encode = function(string, options) {
             options = merge(options, encode.options);
             var strict = options.strict;
             if (strict && regexInvalidRawCodePoint.test(string)) {
                 parseError('forbidden code point');
             }
             var encodeEverything = options.encodeEverything;
             var useNamedReferences = options.useNamedReferences;
             var allowUnsafeSymbols = options.allowUnsafeSymbols;
             var escapeCodePoint = options.decimal ? decEscape : hexEscape;
   
             var escapeBmpSymbol = function(symbol) {
                 return escapeCodePoint(symbol.charCodeAt(0));
             };
   
             if (encodeEverything) {
                 // Encode ASCII symbols.
                 string = string.replace(regexAsciiWhitelist, function(symbol) {
                     // Use named references if requested & possible.
                     if (useNamedReferences && has(encodeMap, symbol)) {
                         return '&' + encodeMap[symbol] + ';';
                     }
                     return escapeBmpSymbol(symbol);
                 });
                 // Shorten a few escapes that represent two symbols, of which at least one
                 // is within the ASCII range.
                 if (useNamedReferences) {
                     string = string
                         .replace(/&gt;\u20D2/g, '&nvgt;')
                         .replace(/&lt;\u20D2/g, '&nvlt;')
                         .replace(/&#x66;&#x6A;/g, '&fjlig;');
                 }
                 // Encode non-ASCII symbols.
                 if (useNamedReferences) {
                     // Encode non-ASCII symbols that can be replaced with a named reference.
                     string = string.replace(regexEncodeNonAscii, function(string) {
                         // Note: there is no need to check `has(encodeMap, string)` here.
                         return '&' + encodeMap[string] + ';';
                     });
                 }
                 // Note: any remaining non-ASCII symbols are handled outside of the `if`.
             } else if (useNamedReferences) {
                 // Apply named character references.
                 // Encode `<>"'&` using named character references.
                 if (!allowUnsafeSymbols) {
                     string = string.replace(regexEscape, function(string) {
                         return '&' + encodeMap[string] + ';'; // no need to check `has()` here
                     });
                 }
                 // Shorten escapes that represent two symbols, of which at least one is
                 // `<>"'&`.
                 string = string
                     .replace(/&gt;\u20D2/g, '&nvgt;')
                     .replace(/&lt;\u20D2/g, '&nvlt;');
                 // Encode non-ASCII symbols that can be replaced with a named reference.
                 string = string.replace(regexEncodeNonAscii, function(string) {
                     // Note: there is no need to check `has(encodeMap, string)` here.
                     return '&' + encodeMap[string] + ';';
                 });
             } else if (!allowUnsafeSymbols) {
                 // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
                 // using named character references.
                 string = string.replace(regexEscape, escapeBmpSymbol);
             }
             return string
                 // Encode astral symbols.
                 .replace(regexAstralSymbols, function($0) {
                     // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                     var high = $0.charCodeAt(0);
                     var low = $0.charCodeAt(1);
                     var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
                     return escapeCodePoint(codePoint);
                 })
                 // Encode any remaining BMP symbols that are not printable ASCII symbols
                 // using a hexadecimal escape.
                 .replace(regexBmpWhitelist, escapeBmpSymbol);
         };
         // Expose default options (so they can be overridden globally).
         encode.options = {
             'allowUnsafeSymbols': false,
             'encodeEverything': false,
             'strict': false,
             'useNamedReferences': false,
             'decimal' : false
         };
   
         var decode = function(html, options) {
             options = merge(options, decode.options);
             var strict = options.strict;
             if (strict && regexInvalidEntity.test(html)) {
                 parseError('malformed character reference');
             }
             return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
                 var codePoint;
                 var semicolon;
                 var decDigits;
                 var hexDigits;
                 var reference;
                 var next;
   
                 if ($1) {
                     reference = $1;
                     // Note: there is no need to check `has(decodeMap, reference)`.
                     return decodeMap[reference];
                 }
   
                 if ($2) {
                     // Decode named character references without trailing `;`, e.g. `&amp`.
                     // This is only a parse error if it gets converted to `&`, or if it is
                     // followed by `=` in an attribute context.
                     reference = $2;
                     next = $3;
                     if (next && options.isAttributeValue) {
                         if (strict && next == '=') {
                             parseError('`&` did not start a character reference');
                         }
                         return $0;
                     } else {
                         if (strict) {
                             parseError(
                                 'named character reference was not terminated by a semicolon'
                             );
                         }
                         // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                         return decodeMapLegacy[reference] + (next || '');
                     }
                 }
   
                 if ($4) {
                     // Decode decimal escapes, e.g. `&#119558;`.
                     decDigits = $4;
                     semicolon = $5;
                     if (strict && !semicolon) {
                         parseError('character reference was not terminated by a semicolon');
                     }
                     codePoint = parseInt(decDigits, 10);
                     return codePointToSymbol(codePoint, strict);
                 }
   
                 if ($6) {
                     // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                     hexDigits = $6;
                     semicolon = $7;
                     if (strict && !semicolon) {
                         parseError('character reference was not terminated by a semicolon');
                     }
                     codePoint = parseInt(hexDigits, 16);
                     return codePointToSymbol(codePoint, strict);
                 }
   
                 // If we’re still here, `if ($7)` is implied; it’s an ambiguous
                 // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
                 if (strict) {
                     parseError(
                         'named character reference was not terminated by a semicolon'
                     );
                 }
                 return $0;
             });
         };
         // Expose default options (so they can be overridden globally).
         decode.options = {
             'isAttributeValue': false,
             'strict': false
         };
   
         var escape = function(string) {
             return string.replace(regexEscape, function($0) {
                 // Note: there is no need to check `has(escapeMap, $0)` here.
                 return escapeMap[$0];
             });
         };
   
         /*--------------------------------------------------------------------------*/
   
         var he = {
             'version': '1.2.0',
             'encode': encode,
             'decode': decode,
             'escape': escape,
             'unescape': decode
         };
   
         // Some AMD build optimizers, like r.js, check for specific condition patterns
         // like the following:
         if (freeExports && !freeExports.nodeType) {
             if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
                 freeModule.exports = he;
             } else { // in Narwhal or RingoJS v0.7.0-
                 for (var key in he) {
                     has(he, key) && (freeExports[key] = he[key]);
                 }
             }
         } else { // in Rhino or a web browser
             root.he = he;
         }
   
     }(commonjsGlobal));
     });
   
     /*  */
   
     /**
      * Cross-platform code generation for component v-model
      */
     function genComponentModel (
       el,
       value,
       modifiers
     ) {
       var ref = modifiers || {};
       var number = ref.number;
       var trim = ref.trim;
   
       var baseValueExpression = '$$v';
       var valueExpression = baseValueExpression;
       if (trim) {
         valueExpression =
           "(typeof " + baseValueExpression + " === 'string'" +
           "? " + baseValueExpression + ".trim()" +
           ": " + baseValueExpression + ")";
       }
       if (number) {
         valueExpression = "_n(" + valueExpression + ")";
       }
       var assignment = genAssignmentCode(value, valueExpression);
   
       el.model = {
         value: ("(" + value + ")"),
         expression: JSON.stringify(value),
         callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
       };
     }
   
     /**
      * Cross-platform codegen helper for generating v-model value assignment code.
      */
     function genAssignmentCode (
       value,
       assignment
     ) {
       var res = parseModel(value);
       if (res.key === null) {
         return (value + "=" + assignment)
       } else {
         return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
       }
     }
   
     /**
      * Parse a v-model expression into a base path and a final key segment.
      * Handles both dot-path and possible square brackets.
      *
      * Possible cases:
      *
      * - test
      * - test[key]
      * - test[test1[key]]
      * - test["a"][key]
      * - xxx.test[a[a].test1[key]]
      * - test.xxx.a["asa"][test1[key]]
      *
      */
   
     var len, str, chr, index, expressionPos, expressionEndPos;
   
   
   
     function parseModel (val) {
       // Fix https://github.com/vuejs/vue/pull/7730
       // allow v-model="obj.val " (trailing whitespace)
       val = val.trim();
       len = val.length;
   
       if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
         index = val.lastIndexOf('.');
         if (index > -1) {
           return {
             exp: val.slice(0, index),
             key: '"' + val.slice(index + 1) + '"'
           }
         } else {
           return {
             exp: val,
             key: null
           }
         }
       }
   
       str = val;
       index = expressionPos = expressionEndPos = 0;
   
       while (!eof()) {
         chr = next();
         /* istanbul ignore if */
         if (isStringStart(chr)) {
           parseString(chr);
         } else if (chr === 0x5B) {
           parseBracket(chr);
         }
       }
   
       return {
         exp: val.slice(0, expressionPos),
         key: val.slice(expressionPos + 1, expressionEndPos)
       }
     }
   
     function next () {
       return str.charCodeAt(++index)
     }
   
     function eof () {
       return index >= len
     }
   
     function isStringStart (chr) {
       return chr === 0x22 || chr === 0x27
     }
   
     function parseBracket (chr) {
       var inBracket = 1;
       expressionPos = index;
       while (!eof()) {
         chr = next();
         if (isStringStart(chr)) {
           parseString(chr);
           continue
         }
         if (chr === 0x5B) { inBracket++; }
         if (chr === 0x5D) { inBracket--; }
         if (inBracket === 0) {
           expressionEndPos = index;
           break
         }
       }
     }
   
     function parseString (chr) {
       var stringQuote = chr;
       while (!eof()) {
         chr = next();
         if (chr === stringQuote) {
           break
         }
       }
     }
   
     /*  */
   
     var onRE = /^@|^v-on:/;
     var dirRE = /^v-|^@|^:|^#/;
     var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
     var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
     var stripParensRE = /^\(|\)$/g;
     var dynamicArgRE = /^\[.*\]$/;
   
     var argRE = /:(.*)$/;
     var bindRE = /^:|^\.|^v-bind:/;
     var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
   
     var slotRE = /^v-slot(:|$)|^#/;
   
     var lineBreakRE = /[\r\n]/;
     var whitespaceRE = /[ \f\t\r\n]+/g;
   
     var invalidAttributeRE = /[\s"'<>\/=]/;
   
     var decodeHTMLCached = cached(he.decode);
   
     var emptySlotScopeToken = "_empty_";
   
     // configurable state
     var warn$1;
     var delimiters;
     var transforms;
     var preTransforms;
     var postTransforms;
     var platformIsPreTag;
     var platformMustUseProp;
     var platformGetTagNamespace;
     var maybeComponent;
   
     function createASTElement (
       tag,
       attrs,
       parent
     ) {
       return {
         type: 1,
         tag: tag,
         attrsList: attrs,
         attrsMap: makeAttrsMap(attrs),
         rawAttrsMap: {},
         parent: parent,
         children: []
       }
     }
   
     /**
      * Convert HTML string to AST.
      */
     function parse (
       template,
       options
     ) {
       warn$1 = options.warn || baseWarn;
   
       platformIsPreTag = options.isPreTag || no;
       platformMustUseProp = options.mustUseProp || no;
       platformGetTagNamespace = options.getTagNamespace || no;
       var isReservedTag = options.isReservedTag || no;
       maybeComponent = function (el) { return !!(
         el.component ||
         el.attrsMap[':is'] ||
         el.attrsMap['v-bind:is'] ||
         !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
       ); };
       transforms = pluckModuleFunction(options.modules, 'transformNode');
       preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
       postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
   
       delimiters = options.delimiters;
   
       var stack = [];
       var preserveWhitespace = options.preserveWhitespace !== false;
       var whitespaceOption = options.whitespace;
       var root;
       var currentParent;
       var inVPre = false;
       var inPre = false;
       var warned = false;
   
       function warnOnce (msg, range) {
         if (!warned) {
           warned = true;
           warn$1(msg, range);
         }
       }
   
       function closeElement (element) {
         trimEndingWhitespace(element);
         if (!inVPre && !element.processed) {
           element = processElement(element, options);
         }
         // tree management
         if (!stack.length && element !== root) {
           // allow root elements with v-if, v-else-if and v-else
           if (root.if && (element.elseif || element.else)) {
             {
               checkRootConstraints(element);
             }
             addIfCondition(root, {
               exp: element.elseif,
               block: element
             });
           } else {
             warnOnce(
               "Component template should contain exactly one root element. " +
               "If you are using v-if on multiple elements, " +
               "use v-else-if to chain them instead.",
               { start: element.start }
             );
           }
         }
         if (currentParent && !element.forbidden) {
           if (element.elseif || element.else) {
             processIfConditions(element, currentParent);
           } else {
             if (element.slotScope) {
               // scoped slot
               // keep it in the children list so that v-else(-if) conditions can
               // find it as the prev node.
               var name = element.slotTarget || '"default"'
               ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
             }
             currentParent.children.push(element);
             element.parent = currentParent;
           }
         }
   
         // final children cleanup
         // filter out scoped slots
         element.children = element.children.filter(function (c) { return !(c).slotScope; });
         // remove trailing whitespace node again
         trimEndingWhitespace(element);
   
         // check pre state
         if (element.pre) {
           inVPre = false;
         }
         if (platformIsPreTag(element.tag)) {
           inPre = false;
         }
         // apply post-transforms
         for (var i = 0; i < postTransforms.length; i++) {
           postTransforms[i](element, options);
         }
       }
   
       function trimEndingWhitespace (el) {
         // remove trailing whitespace node
         if (!inPre) {
           var lastNode;
           while (
             (lastNode = el.children[el.children.length - 1]) &&
             lastNode.type === 3 &&
             lastNode.text === ' '
           ) {
             el.children.pop();
           }
         }
       }
   
       function checkRootConstraints (el) {
         if (el.tag === 'slot' || el.tag === 'template') {
           warnOnce(
             "Cannot use <" + (el.tag) + "> as component root element because it may " +
             'contain multiple nodes.',
             { start: el.start }
           );
         }
         if (el.attrsMap.hasOwnProperty('v-for')) {
           warnOnce(
             'Cannot use v-for on stateful component root element because ' +
             'it renders multiple elements.',
             el.rawAttrsMap['v-for']
           );
         }
       }
   
       parseHTML(template, {
         warn: warn$1,
         expectHTML: options.expectHTML,
         isUnaryTag: options.isUnaryTag,
         canBeLeftOpenTag: options.canBeLeftOpenTag,
         shouldDecodeNewlines: options.shouldDecodeNewlines,
         shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
         shouldKeepComment: options.comments,
         outputSourceRange: options.outputSourceRange,
         start: function start (tag, attrs, unary, start$1, end) {
           // check namespace.
           // inherit parent ns if there is one
           var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
   
           // handle IE svg bug
           /* istanbul ignore if */
           if (isIE && ns === 'svg') {
             attrs = guardIESVGBug(attrs);
           }
   
           var element = createASTElement(tag, attrs, currentParent);
           if (ns) {
             element.ns = ns;
           }
   
           {
             if (options.outputSourceRange) {
               element.start = start$1;
               element.end = end;
               element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                 cumulated[attr.name] = attr;
                 return cumulated
               }, {});
             }
             attrs.forEach(function (attr) {
               if (invalidAttributeRE.test(attr.name)) {
                 warn$1(
                   "Invalid dynamic argument expression: attribute names cannot contain " +
                   "spaces, quotes, <, >, / or =.",
                   {
                     start: attr.start + attr.name.indexOf("["),
                     end: attr.start + attr.name.length
                   }
                 );
               }
             });
           }
   
           if (isForbiddenTag(element) && !isServerRendering()) {
             element.forbidden = true;
             warn$1(
               'Templates should only be responsible for mapping the state to the ' +
               'UI. Avoid placing tags with side-effects in your templates, such as ' +
               "<" + tag + ">" + ', as they will not be parsed.',
               { start: element.start }
             );
           }
   
           // apply pre-transforms
           for (var i = 0; i < preTransforms.length; i++) {
             element = preTransforms[i](element, options) || element;
           }
   
           if (!inVPre) {
             processPre(element);
             if (element.pre) {
               inVPre = true;
             }
           }
           if (platformIsPreTag(element.tag)) {
             inPre = true;
           }
           if (inVPre) {
             processRawAttrs(element);
           } else if (!element.processed) {
             // structural directives
             processFor(element);
             processIf(element);
             processOnce(element);
           }
   
           if (!root) {
             root = element;
             {
               checkRootConstraints(root);
             }
           }
   
           if (!unary) {
             currentParent = element;
             stack.push(element);
           } else {
             closeElement(element);
           }
         },
   
         end: function end (tag, start, end$1) {
           var element = stack[stack.length - 1];
           // pop stack
           stack.length -= 1;
           currentParent = stack[stack.length - 1];
           if (options.outputSourceRange) {
             element.end = end$1;
           }
           closeElement(element);
         },
   
         chars: function chars (text, start, end) {
           if (!currentParent) {
             {
               if (text === template) {
                 warnOnce(
                   'Component template requires a root element, rather than just text.',
                   { start: start }
                 );
               } else if ((text = text.trim())) {
                 warnOnce(
                   ("text \"" + text + "\" outside root element will be ignored."),
                   { start: start }
                 );
               }
             }
             return
           }
           // IE textarea placeholder bug
           /* istanbul ignore if */
           if (isIE &&
             currentParent.tag === 'textarea' &&
             currentParent.attrsMap.placeholder === text
           ) {
             return
           }
           var children = currentParent.children;
           if (inPre || text.trim()) {
             text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
           } else if (!children.length) {
             // remove the whitespace-only node right after an opening tag
             text = '';
           } else if (whitespaceOption) {
             if (whitespaceOption === 'condense') {
               // in condense mode, remove the whitespace node if it contains
               // line break, otherwise condense to a single space
               text = lineBreakRE.test(text) ? '' : ' ';
             } else {
               text = ' ';
             }
           } else {
             text = preserveWhitespace ? ' ' : '';
           }
           if (text) {
             if (!inPre && whitespaceOption === 'condense') {
               // condense consecutive whitespaces into single space
               text = text.replace(whitespaceRE, ' ');
             }
             var res;
             var child;
             if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
               child = {
                 type: 2,
                 expression: res.expression,
                 tokens: res.tokens,
                 text: text
               };
             } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
               child = {
                 type: 3,
                 text: text
               };
             }
             if (child) {
               if (options.outputSourceRange) {
                 child.start = start;
                 child.end = end;
               }
               children.push(child);
             }
           }
         },
         comment: function comment (text, start, end) {
           // adding anything as a sibling to the root node is forbidden
           // comments should still be allowed, but ignored
           if (currentParent) {
             var child = {
               type: 3,
               text: text,
               isComment: true
             };
             if (options.outputSourceRange) {
               child.start = start;
               child.end = end;
             }
             currentParent.children.push(child);
           }
         }
       });
       return root
     }
   
     function processPre (el) {
       if (getAndRemoveAttr(el, 'v-pre') != null) {
         el.pre = true;
       }
     }
   
     function processRawAttrs (el) {
       var list = el.attrsList;
       var len = list.length;
       if (len) {
         var attrs = el.attrs = new Array(len);
         for (var i = 0; i < len; i++) {
           attrs[i] = {
             name: list[i].name,
             value: JSON.stringify(list[i].value)
           };
           if (list[i].start != null) {
             attrs[i].start = list[i].start;
             attrs[i].end = list[i].end;
           }
         }
       } else if (!el.pre) {
         // non root node in pre blocks with no attributes
         el.plain = true;
       }
     }
   
     function processElement (
       element,
       options
     ) {
       processKey(element);
   
       // determine whether this is a plain element after
       // removing structural attributes
       element.plain = (
         !element.key &&
         !element.scopedSlots &&
         !element.attrsList.length
       );
   
       processRef(element);
       processSlotContent(element);
       processSlotOutlet(element);
       processComponent(element);
       for (var i = 0; i < transforms.length; i++) {
         element = transforms[i](element, options) || element;
       }
       processAttrs(element);
       return element
     }
   
     function processKey (el) {
       var exp = getBindingAttr(el, 'key');
       if (exp) {
         {
           if (el.tag === 'template') {
             warn$1(
               "<template> cannot be keyed. Place the key on real elements instead.",
               getRawBindingAttr(el, 'key')
             );
           }
           if (el.for) {
             var iterator = el.iterator2 || el.iterator1;
             var parent = el.parent;
             if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
               warn$1(
                 "Do not use v-for index as key on <transition-group> children, " +
                 "this is the same as not using keys.",
                 getRawBindingAttr(el, 'key'),
                 true /* tip */
               );
             }
           }
         }
         el.key = exp;
       }
     }
   
     function processRef (el) {
       var ref = getBindingAttr(el, 'ref');
       if (ref) {
         el.ref = ref;
         el.refInFor = checkInFor(el);
       }
     }
   
     function processFor (el) {
       var exp;
       if ((exp = getAndRemoveAttr(el, 'v-for'))) {
         var res = parseFor(exp);
         if (res) {
           extend(el, res);
         } else {
           warn$1(
             ("Invalid v-for expression: " + exp),
             el.rawAttrsMap['v-for']
           );
         }
       }
     }
   
   
   
     function parseFor (exp) {
       var inMatch = exp.match(forAliasRE);
       if (!inMatch) { return }
       var res = {};
       res.for = inMatch[2].trim();
       var alias = inMatch[1].trim().replace(stripParensRE, '');
       var iteratorMatch = alias.match(forIteratorRE);
       if (iteratorMatch) {
         res.alias = alias.replace(forIteratorRE, '').trim();
         res.iterator1 = iteratorMatch[1].trim();
         if (iteratorMatch[2]) {
           res.iterator2 = iteratorMatch[2].trim();
         }
       } else {
         res.alias = alias;
       }
       return res
     }
   
     function processIf (el) {
       var exp = getAndRemoveAttr(el, 'v-if');
       if (exp) {
         el.if = exp;
         addIfCondition(el, {
           exp: exp,
           block: el
         });
       } else {
         if (getAndRemoveAttr(el, 'v-else') != null) {
           el.else = true;
         }
         var elseif = getAndRemoveAttr(el, 'v-else-if');
         if (elseif) {
           el.elseif = elseif;
         }
       }
     }
   
     function processIfConditions (el, parent) {
       var prev = findPrevElement(parent.children);
       if (prev && prev.if) {
         addIfCondition(prev, {
           exp: el.elseif,
           block: el
         });
       } else {
         warn$1(
           "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
           "used on element <" + (el.tag) + "> without corresponding v-if.",
           el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
         );
       }
     }
   
     function findPrevElement (children) {
       var i = children.length;
       while (i--) {
         if (children[i].type === 1) {
           return children[i]
         } else {
           if (children[i].text !== ' ') {
             warn$1(
               "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
               "will be ignored.",
               children[i]
             );
           }
           children.pop();
         }
       }
     }
   
     function addIfCondition (el, condition) {
       if (!el.ifConditions) {
         el.ifConditions = [];
       }
       el.ifConditions.push(condition);
     }
   
     function processOnce (el) {
       var once$$1 = getAndRemoveAttr(el, 'v-once');
       if (once$$1 != null) {
         el.once = true;
       }
     }
   
     // handle content being passed to a component as slot,
     // e.g. <template slot="xxx">, <div slot-scope="xxx">
     function processSlotContent (el) {
       var slotScope;
       if (el.tag === 'template') {
         slotScope = getAndRemoveAttr(el, 'scope');
         /* istanbul ignore if */
         if (slotScope) {
           warn$1(
             "the \"scope\" attribute for scoped slots have been deprecated and " +
             "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
             "can also be used on plain elements in addition to <template> to " +
             "denote scoped slots.",
             el.rawAttrsMap['scope'],
             true
           );
         }
         el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
       } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
         /* istanbul ignore if */
         if (el.attrsMap['v-for']) {
           warn$1(
             "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
             "(v-for takes higher priority). Use a wrapper <template> for the " +
             "scoped slot to make it clearer.",
             el.rawAttrsMap['slot-scope'],
             true
           );
         }
         el.slotScope = slotScope;
       }
   
       // slot="xxx"
       var slotTarget = getBindingAttr(el, 'slot');
       if (slotTarget) {
         el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
         el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
         // preserve slot as an attribute for native shadow DOM compat
         // only for non-scoped slots.
         if (el.tag !== 'template' && !el.slotScope) {
           addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
         }
       }
   
       // 2.6 v-slot syntax
       {
         if (el.tag === 'template') {
           // v-slot on <template>
           var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
           if (slotBinding) {
             {
               if (el.slotTarget || el.slotScope) {
                 warn$1(
                   "Unexpected mixed usage of different slot syntaxes.",
                   el
                 );
               }
               if (el.parent && !maybeComponent(el.parent)) {
                 warn$1(
                   "<template v-slot> can only appear at the root level inside " +
                   "the receiving component",
                   el
                 );
               }
             }
             var ref = getSlotName(slotBinding);
             var name = ref.name;
             var dynamic = ref.dynamic;
             el.slotTarget = name;
             el.slotTargetDynamic = dynamic;
             el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
           }
         } else {
           // v-slot on component, denotes default slot
           var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
           if (slotBinding$1) {
             {
               if (!maybeComponent(el)) {
                 warn$1(
                   "v-slot can only be used on components or <template>.",
                   slotBinding$1
                 );
               }
               if (el.slotScope || el.slotTarget) {
                 warn$1(
                   "Unexpected mixed usage of different slot syntaxes.",
                   el
                 );
               }
               if (el.scopedSlots) {
                 warn$1(
                   "To avoid scope ambiguity, the default slot should also use " +
                   "<template> syntax when there are other named slots.",
                   slotBinding$1
                 );
               }
             }
             // add the component's children to its default slot
             var slots = el.scopedSlots || (el.scopedSlots = {});
             var ref$1 = getSlotName(slotBinding$1);
             var name$1 = ref$1.name;
             var dynamic$1 = ref$1.dynamic;
             var slotContainer = slots[name$1] = createASTElement('template', [], el);
             slotContainer.slotTarget = name$1;
             slotContainer.slotTargetDynamic = dynamic$1;
             slotContainer.children = el.children.filter(function (c) {
               if (!c.slotScope) {
                 c.parent = slotContainer;
                 return true
               }
             });
             slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
             // remove children as they are returned from scopedSlots now
             el.children = [];
             // mark el non-plain so data gets generated
             el.plain = false;
           }
         }
       }
     }
   
     function getSlotName (binding) {
       var name = binding.name.replace(slotRE, '');
       if (!name) {
         if (binding.name[0] !== '#') {
           name = 'default';
         } else {
           warn$1(
             "v-slot shorthand syntax requires a slot name.",
             binding
           );
         }
       }
       return dynamicArgRE.test(name)
         // dynamic [name]
         ? { name: name.slice(1, -1), dynamic: true }
         // static name
         : { name: ("\"" + name + "\""), dynamic: false }
     }
   
     // handle <slot/> outlets
     function processSlotOutlet (el) {
       if (el.tag === 'slot') {
         el.slotName = getBindingAttr(el, 'name');
         if (el.key) {
           warn$1(
             "`key` does not work on <slot> because slots are abstract outlets " +
             "and can possibly expand into multiple elements. " +
             "Use the key on a wrapping element instead.",
             getRawBindingAttr(el, 'key')
           );
         }
       }
     }
   
     function processComponent (el) {
       var binding;
       if ((binding = getBindingAttr(el, 'is'))) {
         el.component = binding;
       }
       if (getAndRemoveAttr(el, 'inline-template') != null) {
         el.inlineTemplate = true;
       }
     }
   
     function processAttrs (el) {
       var list = el.attrsList;
       var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
       for (i = 0, l = list.length; i < l; i++) {
         name = rawName = list[i].name;
         value = list[i].value;
         if (dirRE.test(name)) {
           // mark element as dynamic
           el.hasBindings = true;
           // modifiers
           modifiers = parseModifiers(name.replace(dirRE, ''));
           // support .foo shorthand syntax for the .prop modifier
           if (modifiers) {
             name = name.replace(modifierRE, '');
           }
           if (bindRE.test(name)) { // v-bind
             name = name.replace(bindRE, '');
             value = parseFilters(value);
             isDynamic = dynamicArgRE.test(name);
             if (isDynamic) {
               name = name.slice(1, -1);
             }
             if (
               value.trim().length === 0
             ) {
               warn$1(
                 ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
               );
             }
             if (modifiers) {
               if (modifiers.prop && !isDynamic) {
                 name = camelize(name);
                 if (name === 'innerHtml') { name = 'innerHTML'; }
               }
               if (modifiers.camel && !isDynamic) {
                 name = camelize(name);
               }
               if (modifiers.sync) {
                 syncGen = genAssignmentCode(value, "$event");
                 if (!isDynamic) {
                   addHandler(
                     el,
                     ("update:" + (camelize(name))),
                     syncGen,
                     null,
                     false,
                     warn$1,
                     list[i]
                   );
                   if (hyphenate(name) !== camelize(name)) {
                     addHandler(
                       el,
                       ("update:" + (hyphenate(name))),
                       syncGen,
                       null,
                       false,
                       warn$1,
                       list[i]
                     );
                   }
                 } else {
                   // handler w/ dynamic event name
                   addHandler(
                     el,
                     ("\"update:\"+(" + name + ")"),
                     syncGen,
                     null,
                     false,
                     warn$1,
                     list[i],
                     true // dynamic
                   );
                 }
               }
             }
             if ((modifiers && modifiers.prop) || (
               !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
             )) {
               addProp(el, name, value, list[i], isDynamic);
             } else {
               addAttr(el, name, value, list[i], isDynamic);
             }
           } else if (onRE.test(name)) { // v-on
             name = name.replace(onRE, '');
             isDynamic = dynamicArgRE.test(name);
             if (isDynamic) {
               name = name.slice(1, -1);
             }
             addHandler(el, name, value, modifiers, false, warn$1, list[i], isDynamic);
           } else { // normal directives
             name = name.replace(dirRE, '');
             // parse arg
             var argMatch = name.match(argRE);
             var arg = argMatch && argMatch[1];
             isDynamic = false;
             if (arg) {
               name = name.slice(0, -(arg.length + 1));
               if (dynamicArgRE.test(arg)) {
                 arg = arg.slice(1, -1);
                 isDynamic = true;
               }
             }
             addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
             if (name === 'model') {
               checkForAliasModel(el, value);
             }
           }
         } else {
           // literal attribute
           {
             var res = parseText(value, delimiters);
             if (res) {
               warn$1(
                 name + "=\"" + value + "\": " +
                 'Interpolation inside attributes has been removed. ' +
                 'Use v-bind or the colon shorthand instead. For example, ' +
                 'instead of <div id="{{ val }}">, use <div :id="val">.',
                 list[i]
               );
             }
           }
           addAttr(el, name, JSON.stringify(value), list[i]);
           // #6887 firefox doesn't update muted state if set via attribute
           // even immediately after element creation
           if (!el.component &&
               name === 'muted' &&
               platformMustUseProp(el.tag, el.attrsMap.type, name)) {
             addProp(el, name, 'true', list[i]);
           }
         }
       }
     }
   
     function checkInFor (el) {
       var parent = el;
       while (parent) {
         if (parent.for !== undefined) {
           return true
         }
         parent = parent.parent;
       }
       return false
     }
   
     function parseModifiers (name) {
       var match = name.match(modifierRE);
       if (match) {
         var ret = {};
         match.forEach(function (m) { ret[m.slice(1)] = true; });
         return ret
       }
     }
   
     function makeAttrsMap (attrs) {
       var map = {};
       for (var i = 0, l = attrs.length; i < l; i++) {
         if (
           map[attrs[i].name] && !isIE && !isEdge
         ) {
           warn$1('duplicate attribute: ' + attrs[i].name, attrs[i]);
         }
         map[attrs[i].name] = attrs[i].value;
       }
       return map
     }
   
     // for script (e.g. type="x/template") or style, do not decode content
     function isTextTag (el) {
       return el.tag === 'script' || el.tag === 'style'
     }
   
     function isForbiddenTag (el) {
       return (
         el.tag === 'style' ||
         (el.tag === 'script' && (
           !el.attrsMap.type ||
           el.attrsMap.type === 'text/javascript'
         ))
       )
     }
   
     var ieNSBug = /^xmlns:NS\d+/;
     var ieNSPrefix = /^NS\d+:/;
   
     /* istanbul ignore next */
     function guardIESVGBug (attrs) {
       var res = [];
       for (var i = 0; i < attrs.length; i++) {
         var attr = attrs[i];
         if (!ieNSBug.test(attr.name)) {
           attr.name = attr.name.replace(ieNSPrefix, '');
           res.push(attr);
         }
       }
       return res
     }
   
     function checkForAliasModel (el, value) {
       var _el = el;
       while (_el) {
         if (_el.for && _el.alias === value) {
           warn$1(
             "<" + (el.tag) + " v-model=\"" + value + "\">: " +
             "You are binding v-model directly to a v-for iteration alias. " +
             "This will not be able to modify the v-for source array because " +
             "writing to the alias is like modifying a function local variable. " +
             "Consider using an array of objects and use v-model on an object property instead.",
             el.rawAttrsMap['v-model']
           );
         }
         _el = _el.parent;
       }
     }
   
     /*  */
   
     function preTransformNode (el, options) {
       if (el.tag === 'input') {
         var map = el.attrsMap;
         if (!map['v-model']) {
           return
         }
   
         var typeBinding;
         if (map[':type'] || map['v-bind:type']) {
           typeBinding = getBindingAttr(el, 'type');
         }
         if (!map.type && !typeBinding && map['v-bind']) {
           typeBinding = "(" + (map['v-bind']) + ").type";
         }
   
         if (typeBinding) {
           var ifCondition = getAndRemoveAttr(el, 'v-if', true);
           var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
           var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
           var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
           // 1. checkbox
           var branch0 = cloneASTElement(el);
           // process for on the main node
           processFor(branch0);
           addRawAttr(branch0, 'type', 'checkbox');
           processElement(branch0, options);
           branch0.processed = true; // prevent it from double-processed
           branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
           addIfCondition(branch0, {
             exp: branch0.if,
             block: branch0
           });
           // 2. add radio else-if condition
           var branch1 = cloneASTElement(el);
           getAndRemoveAttr(branch1, 'v-for', true);
           addRawAttr(branch1, 'type', 'radio');
           processElement(branch1, options);
           addIfCondition(branch0, {
             exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
             block: branch1
           });
           // 3. other
           var branch2 = cloneASTElement(el);
           getAndRemoveAttr(branch2, 'v-for', true);
           addRawAttr(branch2, ':type', typeBinding);
           processElement(branch2, options);
           addIfCondition(branch0, {
             exp: ifCondition,
             block: branch2
           });
   
           if (hasElse) {
             branch0.else = true;
           } else if (elseIfCondition) {
             branch0.elseif = elseIfCondition;
           }
   
           return branch0
         }
       }
     }
   
     function cloneASTElement (el) {
       return createASTElement(el.tag, el.attrsList.slice(), el.parent)
     }
   
     var model = {
       preTransformNode: preTransformNode
     };
   
     var modules = [
       klass,
       style,
       model
     ];
   
     /*  */
   
     var warn$2;
   
     // in some cases, the event used has to be determined at runtime
     // so we used some reserved tokens during compile.
     var RANGE_TOKEN = '__r';
   
     function model$1 (
       el,
       dir,
       _warn
     ) {
       warn$2 = _warn;
       var value = dir.value;
       var modifiers = dir.modifiers;
       var tag = el.tag;
       var type = el.attrsMap.type;
   
       {
         // inputs with type="file" are read only and setting the input's
         // value will throw an error.
         if (tag === 'input' && type === 'file') {
           warn$2(
             "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
             "File inputs are read only. Use a v-on:change listener instead.",
             el.rawAttrsMap['v-model']
           );
         }
       }
   
       if (el.component) {
         genComponentModel(el, value, modifiers);
         // component v-model doesn't need extra runtime
         return false
       } else if (tag === 'select') {
         genSelect(el, value, modifiers);
       } else if (tag === 'input' && type === 'checkbox') {
         genCheckboxModel(el, value, modifiers);
       } else if (tag === 'input' && type === 'radio') {
         genRadioModel(el, value, modifiers);
       } else if (tag === 'input' || tag === 'textarea') {
         genDefaultModel(el, value, modifiers);
       } else {
         genComponentModel(el, value, modifiers);
         // component v-model doesn't need extra runtime
         return false
       }
   
       // ensure runtime directive metadata
       return true
     }
   
     function genCheckboxModel (
       el,
       value,
       modifiers
     ) {
       var number = modifiers && modifiers.number;
       var valueBinding = getBindingAttr(el, 'value') || 'null';
       var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
       var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
       addProp(el, 'checked',
         "Array.isArray(" + value + ")" +
         "?_i(" + value + "," + valueBinding + ")>-1" + (
           trueValueBinding === 'true'
             ? (":(" + value + ")")
             : (":_q(" + value + "," + trueValueBinding + ")")
         )
       );
       addHandler(el, 'change',
         "var $$a=" + value + "," +
             '$$el=$event.target,' +
             "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
         'if(Array.isArray($$a)){' +
           "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
               '$$i=_i($$a,$$v);' +
           "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
           "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
         "}else{" + (genAssignmentCode(value, '$$c')) + "}",
         null, true
       );
     }
   
     function genRadioModel (
       el,
       value,
       modifiers
     ) {
       var number = modifiers && modifiers.number;
       var valueBinding = getBindingAttr(el, 'value') || 'null';
       valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
       addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
       addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
     }
   
     function genSelect (
       el,
       value,
       modifiers
     ) {
       var number = modifiers && modifiers.number;
       var selectedVal = "Array.prototype.filter" +
         ".call($event.target.options,function(o){return o.selected})" +
         ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
         "return " + (number ? '_n(val)' : 'val') + "})";
   
       var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
       var code = "var $$selectedVal = " + selectedVal + ";";
       code = code + " " + (genAssignmentCode(value, assignment));
       addHandler(el, 'change', code, null, true);
     }
   
     function genDefaultModel (
       el,
       value,
       modifiers
     ) {
       var type = el.attrsMap.type;
   
       // warn if v-bind:value conflicts with v-model
       // except for inputs with v-bind:type
       {
         var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
         var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
         if (value$1 && !typeBinding) {
           var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
           warn$2(
             binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
             'because the latter already expands to a value binding internally',
             el.rawAttrsMap[binding]
           );
         }
       }
   
       var ref = modifiers || {};
       var lazy = ref.lazy;
       var number = ref.number;
       var trim = ref.trim;
       var needCompositionGuard = !lazy && type !== 'range';
       var event = lazy
         ? 'change'
         : type === 'range'
           ? RANGE_TOKEN
           : 'input';
   
       var valueExpression = '$event.target.value';
       if (trim) {
         valueExpression = "$event.target.value.trim()";
       }
       if (number) {
         valueExpression = "_n(" + valueExpression + ")";
       }
   
       var code = genAssignmentCode(value, valueExpression);
       if (needCompositionGuard) {
         code = "if($event.target.composing)return;" + code;
       }
   
       addProp(el, 'value', ("(" + value + ")"));
       addHandler(el, event, code, null, true);
       if (trim || number) {
         addHandler(el, 'blur', '$forceUpdate()');
       }
     }
   
     /*  */
   
     function text (el, dir) {
       if (dir.value) {
         addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
       }
     }
   
     /*  */
   
     function html (el, dir) {
       if (dir.value) {
         addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
       }
     }
   
     var directives = {
       model: model$1,
       text: text,
       html: html
     };
   
     /*  */
   
     var baseOptions = {
       expectHTML: true,
       modules: modules,
       directives: directives,
       isPreTag: isPreTag,
       isUnaryTag: isUnaryTag,
       mustUseProp: mustUseProp,
       canBeLeftOpenTag: canBeLeftOpenTag,
       isReservedTag: isReservedTag,
       getTagNamespace: getTagNamespace,
       staticKeys: genStaticKeys(modules)
     };
   
     /*  */
   
     var isStaticKey;
     var isPlatformReservedTag;
   
     var genStaticKeysCached = cached(genStaticKeys$1);
   
     /**
      * Goal of the optimizer: walk the generated template AST tree
      * and detect sub-trees that are purely static, i.e. parts of
      * the DOM that never needs to change.
      *
      * Once we detect these sub-trees, we can:
      *
      * 1. Hoist them into constants, so that we no longer need to
      *    create fresh nodes for them on each re-render;
      * 2. Completely skip them in the patching process.
      */
     function optimize (root, options) {
       if (!root) { return }
       isStaticKey = genStaticKeysCached(options.staticKeys || '');
       isPlatformReservedTag = options.isReservedTag || no;
       // first pass: mark all non-static nodes.
       markStatic(root);
       // second pass: mark static roots.
       markStaticRoots(root, false);
     }
   
     function genStaticKeys$1 (keys) {
       return makeMap(
         'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
         (keys ? ',' + keys : '')
       )
     }
   
     function markStatic (node) {
       node.static = isStatic(node);
       if (node.type === 1) {
         // do not make component slot content static. this avoids
         // 1. components not able to mutate slot nodes
         // 2. static slot content fails for hot-reloading
         if (
           !isPlatformReservedTag(node.tag) &&
           node.tag !== 'slot' &&
           node.attrsMap['inline-template'] == null
         ) {
           return
         }
         for (var i = 0, l = node.children.length; i < l; i++) {
           var child = node.children[i];
           markStatic(child);
           if (!child.static) {
             node.static = false;
           }
         }
         if (node.ifConditions) {
           for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
             var block = node.ifConditions[i$1].block;
             markStatic(block);
             if (!block.static) {
               node.static = false;
             }
           }
         }
       }
     }
   
     function markStaticRoots (node, isInFor) {
       if (node.type === 1) {
         if (node.static || node.once) {
           node.staticInFor = isInFor;
         }
         // For a node to qualify as a static root, it should have children that
         // are not just static text. Otherwise the cost of hoisting out will
         // outweigh the benefits and it's better off to just always render it fresh.
         if (node.static && node.children.length && !(
           node.children.length === 1 &&
           node.children[0].type === 3
         )) {
           node.staticRoot = true;
           return
         } else {
           node.staticRoot = false;
         }
         if (node.children) {
           for (var i = 0, l = node.children.length; i < l; i++) {
             markStaticRoots(node.children[i], isInFor || !!node.for);
           }
         }
         if (node.ifConditions) {
           for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
             markStaticRoots(node.ifConditions[i$1].block, isInFor);
           }
         }
       }
     }
   
     function isStatic (node) {
       if (node.type === 2) { // expression
         return false
       }
       if (node.type === 3) { // text
         return true
       }
       return !!(node.pre || (
         !node.hasBindings && // no dynamic bindings
         !node.if && !node.for && // not v-if or v-for or v-else
         !isBuiltInTag(node.tag) && // not a built-in
         isPlatformReservedTag(node.tag) && // not a component
         !isDirectChildOfTemplateFor(node) &&
         Object.keys(node).every(isStaticKey)
       ))
     }
   
     function isDirectChildOfTemplateFor (node) {
       while (node.parent) {
         node = node.parent;
         if (node.tag !== 'template') {
           return false
         }
         if (node.for) {
           return true
         }
       }
       return false
     }
   
     /*  */
   
     var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
     var fnInvokeRE = /\([^)]*?\);*$/;
     var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
   
     // KeyboardEvent.keyCode aliases
     var keyCodes = {
       esc: 27,
       tab: 9,
       enter: 13,
       space: 32,
       up: 38,
       left: 37,
       right: 39,
       down: 40,
       'delete': [8, 46]
     };
   
     // KeyboardEvent.key aliases
     var keyNames = {
       // #7880: IE11 and Edge use `Esc` for Escape key name.
       esc: ['Esc', 'Escape'],
       tab: 'Tab',
       enter: 'Enter',
       // #9112: IE11 uses `Spacebar` for Space key name.
       space: [' ', 'Spacebar'],
       // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
       up: ['Up', 'ArrowUp'],
       left: ['Left', 'ArrowLeft'],
       right: ['Right', 'ArrowRight'],
       down: ['Down', 'ArrowDown'],
       // #9112: IE11 uses `Del` for Delete key name.
       'delete': ['Backspace', 'Delete', 'Del']
     };
   
     // #4868: modifiers that prevent the execution of the listener
     // need to explicitly return null so that we can determine whether to remove
     // the listener for .once
     var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };
   
     var modifierCode = {
       stop: '$event.stopPropagation();',
       prevent: '$event.preventDefault();',
       self: genGuard("$event.target !== $event.currentTarget"),
       ctrl: genGuard("!$event.ctrlKey"),
       shift: genGuard("!$event.shiftKey"),
       alt: genGuard("!$event.altKey"),
       meta: genGuard("!$event.metaKey"),
       left: genGuard("'button' in $event && $event.button !== 0"),
       middle: genGuard("'button' in $event && $event.button !== 1"),
       right: genGuard("'button' in $event && $event.button !== 2")
     };
   
     function genHandlers (
       events,
       isNative
     ) {
       var prefix = isNative ? 'nativeOn:' : 'on:';
       var staticHandlers = "";
       var dynamicHandlers = "";
       for (var name in events) {
         var handlerCode = genHandler(events[name]);
         if (events[name] && events[name].dynamic) {
           dynamicHandlers += name + "," + handlerCode + ",";
         } else {
           staticHandlers += "\"" + name + "\":" + handlerCode + ",";
         }
       }
       staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
       if (dynamicHandlers) {
         return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
       } else {
         return prefix + staticHandlers
       }
     }
   
     function genHandler (handler) {
       if (!handler) {
         return 'function(){}'
       }
   
       if (Array.isArray(handler)) {
         return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
       }
   
       var isMethodPath = simplePathRE.test(handler.value);
       var isFunctionExpression = fnExpRE.test(handler.value);
       var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
   
       if (!handler.modifiers) {
         if (isMethodPath || isFunctionExpression) {
           return handler.value
         }
         return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
       } else {
         var code = '';
         var genModifierCode = '';
         var keys = [];
         for (var key in handler.modifiers) {
           if (modifierCode[key]) {
             genModifierCode += modifierCode[key];
             // left/right
             if (keyCodes[key]) {
               keys.push(key);
             }
           } else if (key === 'exact') {
             var modifiers = (handler.modifiers);
             genModifierCode += genGuard(
               ['ctrl', 'shift', 'alt', 'meta']
                 .filter(function (keyModifier) { return !modifiers[keyModifier]; })
                 .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
                 .join('||')
             );
           } else {
             keys.push(key);
           }
         }
         if (keys.length) {
           code += genKeyFilter(keys);
         }
         // Make sure modifiers like prevent and stop get executed after key filtering
         if (genModifierCode) {
           code += genModifierCode;
         }
         var handlerCode = isMethodPath
           ? ("return " + (handler.value) + ".apply(null, arguments)")
           : isFunctionExpression
             ? ("return (" + (handler.value) + ").apply(null, arguments)")
             : isFunctionInvocation
               ? ("return " + (handler.value))
               : handler.value;
         return ("function($event){" + code + handlerCode + "}")
       }
     }
   
     function genKeyFilter (keys) {
       return (
         // make sure the key filters only apply to KeyboardEvents
         // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
         // key events that do not have keyCode property...
         "if(!$event.type.indexOf('key')&&" +
         (keys.map(genFilterCode).join('&&')) + ")return null;"
       )
     }
   
     function genFilterCode (key) {
       var keyVal = parseInt(key, 10);
       if (keyVal) {
         return ("$event.keyCode!==" + keyVal)
       }
       var keyCode = keyCodes[key];
       var keyName = keyNames[key];
       return (
         "_k($event.keyCode," +
         (JSON.stringify(key)) + "," +
         (JSON.stringify(keyCode)) + "," +
         "$event.key," +
         "" + (JSON.stringify(keyName)) +
         ")"
       )
     }
   
     /*  */
   
     function on (el, dir) {
       if (dir.modifiers) {
         warn("v-on without argument does not support modifiers.");
       }
       el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
     }
   
     /*  */
   
     function bind$1 (el, dir) {
       el.wrapData = function (code) {
         return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
       };
     }
   
     /*  */
   
     var baseDirectives = {
       on: on,
       bind: bind$1,
       cloak: noop
     };
   
     /*  */
   
   
   
   
   
     var CodegenState = function CodegenState (options) {
       this.options = options;
       this.warn = options.warn || baseWarn;
       this.transforms = pluckModuleFunction(options.modules, 'transformCode');
       this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
       this.directives = extend(extend({}, baseDirectives), options.directives);
       var isReservedTag = options.isReservedTag || no;
       this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
       this.onceId = 0;
       this.staticRenderFns = [];
       this.pre = false;
     };
   
   
   
     function generate (
       ast,
       options
     ) {
       var state = new CodegenState(options);
       // fix #11483, Root level <script> tags should not be rendered.
       var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
       return {
         render: ("with(this){return " + code + "}"),
         staticRenderFns: state.staticRenderFns
       }
     }
   
     function genElement (el, state) {
       if (el.parent) {
         el.pre = el.pre || el.parent.pre;
       }
   
       if (el.staticRoot && !el.staticProcessed) {
         return genStatic(el, state)
       } else if (el.once && !el.onceProcessed) {
         return genOnce(el, state)
       } else if (el.for && !el.forProcessed) {
         return genFor(el, state)
       } else if (el.if && !el.ifProcessed) {
         return genIf(el, state)
       } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
         return genChildren(el, state) || 'void 0'
       } else if (el.tag === 'slot') {
         return genSlot(el, state)
       } else {
         // component or element
         var code;
         if (el.component) {
           code = genComponent(el.component, el, state);
         } else {
           var data;
           if (!el.plain || (el.pre && state.maybeComponent(el))) {
             data = genData$2(el, state);
           }
   
           var children = el.inlineTemplate ? null : genChildren(el, state, true);
           code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
         }
         // module transforms
         for (var i = 0; i < state.transforms.length; i++) {
           code = state.transforms[i](el, code);
         }
         return code
       }
     }
   
     // hoist static sub-trees out
     function genStatic (el, state) {
       el.staticProcessed = true;
       // Some elements (templates) need to behave differently inside of a v-pre
       // node.  All pre nodes are static roots, so we can use this as a location to
       // wrap a state change and reset it upon exiting the pre node.
       var originalPreState = state.pre;
       if (el.pre) {
         state.pre = el.pre;
       }
       state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
       state.pre = originalPreState;
       return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
     }
   
     // v-once
     function genOnce (el, state) {
       el.onceProcessed = true;
       if (el.if && !el.ifProcessed) {
         return genIf(el, state)
       } else if (el.staticInFor) {
         var key = '';
         var parent = el.parent;
         while (parent) {
           if (parent.for) {
             key = parent.key;
             break
           }
           parent = parent.parent;
         }
         if (!key) {
           state.warn(
             "v-once can only be used inside v-for that is keyed. ",
             el.rawAttrsMap['v-once']
           );
           return genElement(el, state)
         }
         return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
       } else {
         return genStatic(el, state)
       }
     }
   
     function genIf (
       el,
       state,
       altGen,
       altEmpty
     ) {
       el.ifProcessed = true; // avoid recursion
       return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
     }
   
     function genIfConditions (
       conditions,
       state,
       altGen,
       altEmpty
     ) {
       if (!conditions.length) {
         return altEmpty || '_e()'
       }
   
       var condition = conditions.shift();
       if (condition.exp) {
         return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
       } else {
         return ("" + (genTernaryExp(condition.block)))
       }
   
       // v-if with v-once should generate code like (a)?_m(0):_m(1)
       function genTernaryExp (el) {
         return altGen
           ? altGen(el, state)
           : el.once
             ? genOnce(el, state)
             : genElement(el, state)
       }
     }
   
     function genFor (
       el,
       state,
       altGen,
       altHelper
     ) {
       var exp = el.for;
       var alias = el.alias;
       var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
       var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
   
       if (state.maybeComponent(el) &&
         el.tag !== 'slot' &&
         el.tag !== 'template' &&
         !el.key
       ) {
         state.warn(
           "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
           "v-for should have explicit keys. " +
           "See https://vuejs.org/guide/list.html#key for more info.",
           el.rawAttrsMap['v-for'],
           true /* tip */
         );
       }
   
       el.forProcessed = true; // avoid recursion
       return (altHelper || '_l') + "((" + exp + ")," +
         "function(" + alias + iterator1 + iterator2 + "){" +
           "return " + ((altGen || genElement)(el, state)) +
         '})'
     }
   
     function genData$2 (el, state) {
       var data = '{';
   
       // directives first.
       // directives may mutate the el's other properties before they are generated.
       var dirs = genDirectives(el, state);
       if (dirs) { data += dirs + ','; }
   
       // key
       if (el.key) {
         data += "key:" + (el.key) + ",";
       }
       // ref
       if (el.ref) {
         data += "ref:" + (el.ref) + ",";
       }
       if (el.refInFor) {
         data += "refInFor:true,";
       }
       // pre
       if (el.pre) {
         data += "pre:true,";
       }
       // record original tag name for components using "is" attribute
       if (el.component) {
         data += "tag:\"" + (el.tag) + "\",";
       }
       // module data generation functions
       for (var i = 0; i < state.dataGenFns.length; i++) {
         data += state.dataGenFns[i](el);
       }
       // attributes
       if (el.attrs) {
         data += "attrs:" + (genProps(el.attrs)) + ",";
       }
       // DOM props
       if (el.props) {
         data += "domProps:" + (genProps(el.props)) + ",";
       }
       // event handlers
       if (el.events) {
         data += (genHandlers(el.events, false)) + ",";
       }
       if (el.nativeEvents) {
         data += (genHandlers(el.nativeEvents, true)) + ",";
       }
       // slot target
       // only for non-scoped slots
       if (el.slotTarget && !el.slotScope) {
         data += "slot:" + (el.slotTarget) + ",";
       }
       // scoped slots
       if (el.scopedSlots) {
         data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
       }
       // component v-model
       if (el.model) {
         data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
       }
       // inline-template
       if (el.inlineTemplate) {
         var inlineTemplate = genInlineTemplate(el, state);
         if (inlineTemplate) {
           data += inlineTemplate + ",";
         }
       }
       data = data.replace(/,$/, '') + '}';
       // v-bind dynamic argument wrap
       // v-bind with dynamic arguments must be applied using the same v-bind object
       // merge helper so that class/style/mustUseProp attrs are handled correctly.
       if (el.dynamicAttrs) {
         data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
       }
       // v-bind data wrap
       if (el.wrapData) {
         data = el.wrapData(data);
       }
       // v-on data wrap
       if (el.wrapListeners) {
         data = el.wrapListeners(data);
       }
       return data
     }
   
     function genDirectives (el, state) {
       var dirs = el.directives;
       if (!dirs) { return }
       var res = 'directives:[';
       var hasRuntime = false;
       var i, l, dir, needRuntime;
       for (i = 0, l = dirs.length; i < l; i++) {
         dir = dirs[i];
         needRuntime = true;
         var gen = state.directives[dir.name];
         if (gen) {
           // compile-time directive that manipulates AST.
           // returns true if it also needs a runtime counterpart.
           needRuntime = !!gen(el, dir, state.warn);
         }
         if (needRuntime) {
           hasRuntime = true;
           res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
         }
       }
       if (hasRuntime) {
         return res.slice(0, -1) + ']'
       }
     }
   
     function genInlineTemplate (el, state) {
       var ast = el.children[0];
       if (el.children.length !== 1 || ast.type !== 1) {
         state.warn(
           'Inline-template components must have exactly one child element.',
           { start: el.start }
         );
       }
       if (ast && ast.type === 1) {
         var inlineRenderFns = generate(ast, state.options);
         return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
       }
     }
   
     function genScopedSlots (
       el,
       slots,
       state
     ) {
       // by default scoped slots are considered "stable", this allows child
       // components with only scoped slots to skip forced updates from parent.
       // but in some cases we have to bail-out of this optimization
       // for example if the slot contains dynamic names, has v-if or v-for on them...
       var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
         var slot = slots[key];
         return (
           slot.slotTargetDynamic ||
           slot.if ||
           slot.for ||
           containsSlotChild(slot) // is passing down slot from parent which may be dynamic
         )
       });
   
       // #9534: if a component with scoped slots is inside a conditional branch,
       // it's possible for the same component to be reused but with different
       // compiled slot content. To avoid that, we generate a unique key based on
       // the generated code of all the slot contents.
       var needsKey = !!el.if;
   
       // OR when it is inside another scoped slot or v-for (the reactivity may be
       // disconnected due to the intermediate scope variable)
       // #9438, #9506
       // TODO: this can be further optimized by properly analyzing in-scope bindings
       // and skip force updating ones that do not actually use scope variables.
       if (!needsForceUpdate) {
         var parent = el.parent;
         while (parent) {
           if (
             (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
             parent.for
           ) {
             needsForceUpdate = true;
             break
           }
           if (parent.if) {
             needsKey = true;
           }
           parent = parent.parent;
         }
       }
   
       var generatedSlots = Object.keys(slots)
         .map(function (key) { return genScopedSlot(slots[key], state); })
         .join(',');
   
       return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
     }
   
     function hash(str) {
       var hash = 5381;
       var i = str.length;
       while(i) {
         hash = (hash * 33) ^ str.charCodeAt(--i);
       }
       return hash >>> 0
     }
   
     function containsSlotChild (el) {
       if (el.type === 1) {
         if (el.tag === 'slot') {
           return true
         }
         return el.children.some(containsSlotChild)
       }
       return false
     }
   
     function genScopedSlot (
       el,
       state
     ) {
       var isLegacySyntax = el.attrsMap['slot-scope'];
       if (el.if && !el.ifProcessed && !isLegacySyntax) {
         return genIf(el, state, genScopedSlot, "null")
       }
       if (el.for && !el.forProcessed) {
         return genFor(el, state, genScopedSlot)
       }
       var slotScope = el.slotScope === emptySlotScopeToken
         ? ""
         : String(el.slotScope);
       var fn = "function(" + slotScope + "){" +
         "return " + (el.tag === 'template'
           ? el.if && isLegacySyntax
             ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
             : genChildren(el, state) || 'undefined'
           : genElement(el, state)) + "}";
       // reverse proxy v-slot without scope on this.$slots
       var reverseProxy = slotScope ? "" : ",proxy:true";
       return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
     }
   
     function genChildren (
       el,
       state,
       checkSkip,
       altGenElement,
       altGenNode
     ) {
       var children = el.children;
       if (children.length) {
         var el$1 = children[0];
         // optimize single v-for
         if (children.length === 1 &&
           el$1.for &&
           el$1.tag !== 'template' &&
           el$1.tag !== 'slot'
         ) {
           var normalizationType = checkSkip
             ? state.maybeComponent(el$1) ? ",1" : ",0"
             : "";
           return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
         }
         var normalizationType$1 = checkSkip
           ? getNormalizationType(children, state.maybeComponent)
           : 0;
         var gen = altGenNode || genNode;
         return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
       }
     }
   
     // determine the normalization needed for the children array.
     // 0: no normalization needed
     // 1: simple normalization needed (possible 1-level deep nested array)
     // 2: full normalization needed
     function getNormalizationType (
       children,
       maybeComponent
     ) {
       var res = 0;
       for (var i = 0; i < children.length; i++) {
         var el = children[i];
         if (el.type !== 1) {
           continue
         }
         if (needsNormalization(el) ||
             (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
           res = 2;
           break
         }
         if (maybeComponent(el) ||
             (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
           res = 1;
         }
       }
       return res
     }
   
     function needsNormalization (el) {
       return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
     }
   
     function genNode (node, state) {
       if (node.type === 1) {
         return genElement(node, state)
       } else if (node.type === 3 && node.isComment) {
         return genComment(node)
       } else {
         return genText(node)
       }
     }
   
     function genText (text) {
       return ("_v(" + (text.type === 2
         ? text.expression // no need for () because already wrapped in _s()
         : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
     }
   
     function genComment (comment) {
       return ("_e(" + (JSON.stringify(comment.text)) + ")")
     }
   
     function genSlot (el, state) {
       var slotName = el.slotName || '"default"';
       var children = genChildren(el, state);
       var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
       var attrs = el.attrs || el.dynamicAttrs
         ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
             // slot props are camelized
             name: camelize(attr.name),
             value: attr.value,
             dynamic: attr.dynamic
           }); }))
         : null;
       var bind$$1 = el.attrsMap['v-bind'];
       if ((attrs || bind$$1) && !children) {
         res += ",null";
       }
       if (attrs) {
         res += "," + attrs;
       }
       if (bind$$1) {
         res += (attrs ? '' : ',null') + "," + bind$$1;
       }
       return res + ')'
     }
   
     // componentName is el.component, take it as argument to shun flow's pessimistic refinement
     function genComponent (
       componentName,
       el,
       state
     ) {
       var children = el.inlineTemplate ? null : genChildren(el, state, true);
       return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
     }
   
     function genProps (props) {
       var staticProps = "";
       var dynamicProps = "";
       for (var i = 0; i < props.length; i++) {
         var prop = props[i];
         var value = transformSpecialNewlines(prop.value);
         if (prop.dynamic) {
           dynamicProps += (prop.name) + "," + value + ",";
         } else {
           staticProps += "\"" + (prop.name) + "\":" + value + ",";
         }
       }
       staticProps = "{" + (staticProps.slice(0, -1)) + "}";
       if (dynamicProps) {
         return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
       } else {
         return staticProps
       }
     }
   
     // #3895, #4268
     function transformSpecialNewlines (text) {
       return text
         .replace(/\u2028/g, '\\u2028')
         .replace(/\u2029/g, '\\u2029')
     }
   
     /*  */
   
   
   
     // these keywords should not appear inside expressions, but operators like
     // typeof, instanceof and in are allowed
     var prohibitedKeywordRE = new RegExp('\\b' + (
       'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
       'super,throw,while,yield,delete,export,import,return,switch,default,' +
       'extends,finally,continue,debugger,function,arguments'
     ).split(',').join('\\b|\\b') + '\\b');
   
     // these unary operators should not be used as property/method names
     var unaryOperatorsRE = new RegExp('\\b' + (
       'delete,typeof,void'
     ).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
   
     // strip strings in expressions
     var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
   
     // detect problematic expressions in a template
     function detectErrors (ast, warn) {
       if (ast) {
         checkNode(ast, warn);
       }
     }
   
     function checkNode (node, warn) {
       if (node.type === 1) {
         for (var name in node.attrsMap) {
           if (dirRE.test(name)) {
             var value = node.attrsMap[name];
             if (value) {
               var range = node.rawAttrsMap[name];
               if (name === 'v-for') {
                 checkFor(node, ("v-for=\"" + value + "\""), warn, range);
               } else if (name === 'v-slot' || name[0] === '#') {
                 checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
               } else if (onRE.test(name)) {
                 checkEvent(value, (name + "=\"" + value + "\""), warn, range);
               } else {
                 checkExpression(value, (name + "=\"" + value + "\""), warn, range);
               }
             }
           }
         }
         if (node.children) {
           for (var i = 0; i < node.children.length; i++) {
             checkNode(node.children[i], warn);
           }
         }
       } else if (node.type === 2) {
         checkExpression(node.expression, node.text, warn, node);
       }
     }
   
     function checkEvent (exp, text, warn, range) {
       var stripped = exp.replace(stripStringRE, '');
       var keywordMatch = stripped.match(unaryOperatorsRE);
       if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
         warn(
           "avoid using JavaScript unary operator as property name: " +
           "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
           range
         );
       }
       checkExpression(exp, text, warn, range);
     }
   
     function checkFor (node, text, warn, range) {
       checkExpression(node.for || '', text, warn, range);
       checkIdentifier(node.alias, 'v-for alias', text, warn, range);
       checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
       checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
     }
   
     function checkIdentifier (
       ident,
       type,
       text,
       warn,
       range
     ) {
       if (typeof ident === 'string') {
         try {
           new Function(("var " + ident + "=_"));
         } catch (e) {
           warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
         }
       }
     }
   
     function checkExpression (exp, text, warn, range) {
       try {
         new Function(("return " + exp));
       } catch (e) {
         var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
         if (keywordMatch) {
           warn(
             "avoid using JavaScript keyword as property name: " +
             "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
             range
           );
         } else {
           warn(
             "invalid expression: " + (e.message) + " in\n\n" +
             "    " + exp + "\n\n" +
             "  Raw expression: " + (text.trim()) + "\n",
             range
           );
         }
       }
     }
   
     function checkFunctionParameterExpression (exp, text, warn, range) {
       try {
         new Function(exp, '');
       } catch (e) {
         warn(
           "invalid function parameter expression: " + (e.message) + " in\n\n" +
           "    " + exp + "\n\n" +
           "  Raw expression: " + (text.trim()) + "\n",
           range
         );
       }
     }
   
     /*  */
   
     var range = 2;
   
     function generateCodeFrame (
       source,
       start,
       end
     ) {
       if ( start === void 0 ) start = 0;
       if ( end === void 0 ) end = source.length;
   
       var lines = source.split(/\r?\n/);
       var count = 0;
       var res = [];
       for (var i = 0; i < lines.length; i++) {
         count += lines[i].length + 1;
         if (count >= start) {
           for (var j = i - range; j <= i + range || end > count; j++) {
             if (j < 0 || j >= lines.length) { continue }
             res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
             var lineLength = lines[j].length;
             if (j === i) {
               // push underline
               var pad = start - (count - lineLength) + 1;
               var length = end > count ? lineLength - pad : end - start;
               res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
             } else if (j > i) {
               if (end > count) {
                 var length$1 = Math.min(end - count, lineLength);
                 res.push("   |  " + repeat$1("^", length$1));
               }
               count += lineLength + 1;
             }
           }
           break
         }
       }
       return res.join('\n')
     }
   
     function repeat$1 (str, n) {
       var result = '';
       if (n > 0) {
         while (true) { // eslint-disable-line
           if (n & 1) { result += str; }
           n >>>= 1;
           if (n <= 0) { break }
           str += str;
         }
       }
       return result
     }
   
     /*  */
   
   
   
     function createFunction (code, errors) {
       try {
         return new Function(code)
       } catch (err) {
         errors.push({ err: err, code: code });
         return noop
       }
     }
   
     function createCompileToFunctionFn (compile) {
       var cache = Object.create(null);
   
       return function compileToFunctions (
         template,
         options,
         vm
       ) {
         options = extend({}, options);
         var warn$$1 = options.warn || warn;
         delete options.warn;
   
         /* istanbul ignore if */
         {
           // detect possible CSP restriction
           try {
             new Function('return 1');
           } catch (e) {
             if (e.toString().match(/unsafe-eval|CSP/)) {
               warn$$1(
                 'It seems you are using the standalone build of Vue.js in an ' +
                 'environment with Content Security Policy that prohibits unsafe-eval. ' +
                 'The template compiler cannot work in this environment. Consider ' +
                 'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                 'templates into render functions.'
               );
             }
           }
         }
   
         // check cache
         var key = options.delimiters
           ? String(options.delimiters) + template
           : template;
         if (cache[key]) {
           return cache[key]
         }
   
         // compile
         var compiled = compile(template, options);
   
         // check compilation errors/tips
         {
           if (compiled.errors && compiled.errors.length) {
             if (options.outputSourceRange) {
               compiled.errors.forEach(function (e) {
                 warn$$1(
                   "Error compiling template:\n\n" + (e.msg) + "\n\n" +
                   generateCodeFrame(template, e.start, e.end),
                   vm
                 );
               });
             } else {
               warn$$1(
                 "Error compiling template:\n\n" + template + "\n\n" +
                 compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
                 vm
               );
             }
           }
           if (compiled.tips && compiled.tips.length) {
             if (options.outputSourceRange) {
               compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
             } else {
               compiled.tips.forEach(function (msg) { return tip(msg, vm); });
             }
           }
         }
   
         // turn code into functions
         var res = {};
         var fnGenErrors = [];
         res.render = createFunction(compiled.render, fnGenErrors);
         res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
           return createFunction(code, fnGenErrors)
         });
   
         // check function generation errors.
         // this should only happen if there is a bug in the compiler itself.
         // mostly for codegen development use
         /* istanbul ignore if */
         {
           if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
             warn$$1(
               "Failed to generate render function:\n\n" +
               fnGenErrors.map(function (ref) {
                 var err = ref.err;
                 var code = ref.code;
   
                 return ((err.toString()) + " in\n\n" + code + "\n");
             }).join('\n'),
               vm
             );
           }
         }
   
         return (cache[key] = res)
       }
     }
   
     /*  */
   
     function createCompilerCreator (baseCompile) {
       return function createCompiler (baseOptions) {
         function compile (
           template,
           options
         ) {
           var finalOptions = Object.create(baseOptions);
           var errors = [];
           var tips = [];
   
           var warn = function (msg, range, tip) {
             (tip ? tips : errors).push(msg);
           };
   
           if (options) {
             if (options.outputSourceRange) {
               // $flow-disable-line
               var leadingSpaceLength = template.match(/^\s*/)[0].length;
   
               warn = function (msg, range, tip) {
                 var data = { msg: msg };
                 if (range) {
                   if (range.start != null) {
                     data.start = range.start + leadingSpaceLength;
                   }
                   if (range.end != null) {
                     data.end = range.end + leadingSpaceLength;
                   }
                 }
                 (tip ? tips : errors).push(data);
               };
             }
             // merge custom modules
             if (options.modules) {
               finalOptions.modules =
                 (baseOptions.modules || []).concat(options.modules);
             }
             // merge custom directives
             if (options.directives) {
               finalOptions.directives = extend(
                 Object.create(baseOptions.directives || null),
                 options.directives
               );
             }
             // copy other options
             for (var key in options) {
               if (key !== 'modules' && key !== 'directives') {
                 finalOptions[key] = options[key];
               }
             }
           }
   
           finalOptions.warn = warn;
   
           var compiled = baseCompile(template.trim(), finalOptions);
           {
             detectErrors(compiled.ast, warn);
           }
           compiled.errors = errors;
           compiled.tips = tips;
           return compiled
         }
   
         return {
           compile: compile,
           compileToFunctions: createCompileToFunctionFn(compile)
         }
       }
     }
   
     /*  */
   
     // `createCompilerCreator` allows creating compilers that use alternative
     // parser/optimizer/codegen, e.g the SSR optimizing compiler.
     // Here we just export a default compiler using the default parts.
     var createCompiler = createCompilerCreator(function baseCompile (
       template,
       options
     ) {
       var ast = parse(template.trim(), options);
       if (options.optimize !== false) {
         optimize(ast, options);
       }
       var code = generate(ast, options);
       return {
         ast: ast,
         render: code.render,
         staticRenderFns: code.staticRenderFns
       }
     });
   
     /*  */
   
     var ref = createCompiler(baseOptions);
     var compile = ref.compile;
     var compileToFunctions = ref.compileToFunctions;
   
     /*  */
   
     var isAttr = makeMap(
       'accept,accept-charset,accesskey,action,align,alt,async,autocomplete,' +
       'autofocus,autoplay,autosave,bgcolor,border,buffered,challenge,charset,' +
       'checked,cite,class,code,codebase,color,cols,colspan,content,' +
       'contenteditable,contextmenu,controls,coords,data,datetime,default,' +
       'defer,dir,dirname,disabled,download,draggable,dropzone,enctype,for,' +
       'form,formaction,headers,height,hidden,high,href,hreflang,http-equiv,' +
       'icon,id,ismap,itemprop,keytype,kind,label,lang,language,list,loop,low,' +
       'manifest,max,maxlength,media,method,GET,POST,min,multiple,email,file,' +
       'muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,' +
       'preload,radiogroup,readonly,rel,required,reversed,rows,rowspan,sandbox,' +
       'scope,scoped,seamless,selected,shape,size,type,text,password,sizes,span,' +
       'spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,' +
       'target,title,usemap,value,width,wrap'
     );
   
     /* istanbul ignore next */
     var isRenderableAttr = function (name) {
       return (
         isAttr(name) ||
         name.indexOf('data-') === 0 ||
         name.indexOf('aria-') === 0
       )
     };
   
     var propsToAttrMap = {
       acceptCharset: 'accept-charset',
       className: 'class',
       htmlFor: 'for',
       httpEquiv: 'http-equiv'
     };
   
     var ESC = {
       '<': '&lt;',
       '>': '&gt;',
       '"': '&quot;',
       '&': '&amp;'
     };
   
     function escape (s) {
       return s.replace(/[<>"&]/g, escapeChar)
     }
   
     function escapeChar (a) {
       return ESC[a] || a
     }
   
     /*  */
   
   
   
   
     var plainStringRE = /^"(?:[^"\\]|\\.)*"$|^'(?:[^'\\]|\\.)*'$/;
   
     // let the model AST transform translate v-model into appropriate
     // props bindings
     function applyModelTransform (el, state) {
       if (el.directives) {
         for (var i = 0; i < el.directives.length; i++) {
           var dir = el.directives[i];
           if (dir.name === 'model') {
             state.directives.model(el, dir, state.warn);
             // remove value for textarea as its converted to text
             if (el.tag === 'textarea' && el.props) {
               el.props = el.props.filter(function (p) { return p.name !== 'value'; });
             }
             break
           }
         }
       }
     }
   
     function genAttrSegments (
       attrs
     ) {
       return attrs.map(function (ref) {
         var name = ref.name;
         var value = ref.value;
   
         return genAttrSegment(name, value);
       })
     }
   
     function genDOMPropSegments (
       props,
       attrs
     ) {
       var segments = [];
       props.forEach(function (ref) {
         var name = ref.name;
         var value = ref.value;
   
         name = propsToAttrMap[name] || name.toLowerCase();
         if (isRenderableAttr(name) &&
           !(attrs && attrs.some(function (a) { return a.name === name; }))
         ) {
           segments.push(genAttrSegment(name, value));
         }
       });
       return segments
     }
   
     function genAttrSegment (name, value) {
       if (plainStringRE.test(value)) {
         // force double quote
         value = value.replace(/^'|'$/g, '"');
         // force enumerated attr to "true"
         if (isEnumeratedAttr(name) && value !== "\"false\"") {
           value = "\"true\"";
         }
         return {
           type: RAW,
           value: isBooleanAttr(name)
             ? (" " + name + "=\"" + name + "\"")
             : value === '""'
               ? (" " + name)
               : (" " + name + "=\"" + (JSON.parse(value)) + "\"")
         }
       } else {
         return {
           type: EXPRESSION,
           value: ("_ssrAttr(" + (JSON.stringify(name)) + "," + value + ")")
         }
       }
     }
   
     function genClassSegments (
       staticClass,
       classBinding
     ) {
       if (staticClass && !classBinding) {
         return [{ type: RAW, value: (" class=\"" + (JSON.parse(staticClass)) + "\"") }]
       } else {
         return [{
           type: EXPRESSION,
           value: ("_ssrClass(" + (staticClass || 'null') + "," + (classBinding || 'null') + ")")
         }]
       }
     }
   
     function genStyleSegments (
       staticStyle,
       parsedStaticStyle,
       styleBinding,
       vShowExpression
     ) {
       if (staticStyle && !styleBinding && !vShowExpression) {
         return [{ type: RAW, value: (" style=" + (JSON.stringify(staticStyle))) }]
       } else {
         return [{
           type: EXPRESSION,
           value: ("_ssrStyle(" + (parsedStaticStyle || 'null') + "," + (styleBinding || 'null') + ", " + (vShowExpression
               ? ("{ display: (" + vShowExpression + ") ? '' : 'none' }")
               : 'null') + ")")
         }]
       }
     }
   
     /*  */
   
     // optimizability constants
     var optimizability = {
       FALSE: 0,    // whole sub tree un-optimizable
       FULL: 1,     // whole sub tree optimizable
       SELF: 2,     // self optimizable but has some un-optimizable children
       CHILDREN: 3, // self un-optimizable but have fully optimizable children
       PARTIAL: 4   // self un-optimizable with some un-optimizable children
     };
   
     var isPlatformReservedTag$1;
   
     function optimize$1 (root, options) {
       if (!root) { return }
       isPlatformReservedTag$1 = options.isReservedTag || no;
       walk(root, true);
     }
   
     function walk (node, isRoot) {
       if (isUnOptimizableTree(node)) {
         node.ssrOptimizability = optimizability.FALSE;
         return
       }
       // root node or nodes with custom directives should always be a VNode
       var selfUnoptimizable = isRoot || hasCustomDirective(node);
       var check = function (child) {
         if (child.ssrOptimizability !== optimizability.FULL) {
           node.ssrOptimizability = selfUnoptimizable
             ? optimizability.PARTIAL
             : optimizability.SELF;
         }
       };
       if (selfUnoptimizable) {
         node.ssrOptimizability = optimizability.CHILDREN;
       }
       if (node.type === 1) {
         for (var i = 0, l = node.children.length; i < l; i++) {
           var child = node.children[i];
           walk(child);
           check(child);
         }
         if (node.ifConditions) {
           for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
             var block = node.ifConditions[i$1].block;
             walk(block, isRoot);
             check(block);
           }
         }
         if (node.ssrOptimizability == null ||
           (!isRoot && (node.attrsMap['v-html'] || node.attrsMap['v-text']))
         ) {
           node.ssrOptimizability = optimizability.FULL;
         } else {
           node.children = optimizeSiblings(node);
         }
       } else {
         node.ssrOptimizability = optimizability.FULL;
       }
     }
   
     function optimizeSiblings (el) {
       var children = el.children;
       var optimizedChildren = [];
   
       var currentOptimizableGroup = [];
       var pushGroup = function () {
         if (currentOptimizableGroup.length) {
           optimizedChildren.push({
             type: 1,
             parent: el,
             tag: 'template',
             attrsList: [],
             attrsMap: {},
             rawAttrsMap: {},
             children: currentOptimizableGroup,
             ssrOptimizability: optimizability.FULL
           });
         }
         currentOptimizableGroup = [];
       };
   
       for (var i = 0; i < children.length; i++) {
         var c = children[i];
         if (c.ssrOptimizability === optimizability.FULL) {
           currentOptimizableGroup.push(c);
         } else {
           // wrap fully-optimizable adjacent siblings inside a template tag
           // so that they can be optimized into a single ssrNode by codegen
           pushGroup();
           optimizedChildren.push(c);
         }
       }
       pushGroup();
       return optimizedChildren
     }
   
     function isUnOptimizableTree (node) {
       if (node.type === 2 || node.type === 3) { // text or expression
         return false
       }
       return (
         isBuiltInTag(node.tag) || // built-in (slot, component)
         !isPlatformReservedTag$1(node.tag) || // custom component
         !!node.component || // "is" component
         isSelectWithModel(node) // <select v-model> requires runtime inspection
       )
     }
   
     var isBuiltInDir = makeMap('text,html,show,on,bind,model,pre,cloak,once');
   
     function hasCustomDirective (node) {
       return (
         node.type === 1 &&
         node.directives &&
         node.directives.some(function (d) { return !isBuiltInDir(d.name); })
       )
     }
   
     // <select v-model> cannot be optimized because it requires a runtime check
     // to determine proper selected option
     function isSelectWithModel (node) {
       return (
         node.type === 1 &&
         node.tag === 'select' &&
         node.directives != null &&
         node.directives.some(function (d) { return d.name === 'model'; })
       )
     }
   
     /*  */
   
   
   
   
     // segment types
     var RAW = 0;
     var INTERPOLATION = 1;
     var EXPRESSION = 2;
   
     function generate$1 (
       ast,
       options
     ) {
       var state = new CodegenState(options);
       var code = ast ? genSSRElement(ast, state) : '_c("div")';
       return {
         render: ("with(this){return " + code + "}"),
         staticRenderFns: state.staticRenderFns
       }
     }
   
     function genSSRElement (el, state) {
       if (el.for && !el.forProcessed) {
         return genFor(el, state, genSSRElement)
       } else if (el.if && !el.ifProcessed) {
         return genIf(el, state, genSSRElement)
       } else if (el.tag === 'template' && !el.slotTarget) {
         return el.ssrOptimizability === optimizability.FULL
           ? genChildrenAsStringNode(el, state)
           : genSSRChildren(el, state) || 'void 0'
       }
   
       switch (el.ssrOptimizability) {
         case optimizability.FULL:
           // stringify whole tree
           return genStringElement(el, state)
         case optimizability.SELF:
           // stringify self and check children
           return genStringElementWithChildren(el, state)
         case optimizability.CHILDREN:
           // generate self as VNode and stringify children
           return genNormalElement(el, state, true)
         case optimizability.PARTIAL:
           // generate self as VNode and check children
           return genNormalElement(el, state, false)
         default:
           // bail whole tree
           return genElement(el, state)
       }
     }
   
     function genNormalElement (el, state, stringifyChildren) {
       var data = el.plain ? undefined : genData$2(el, state);
       var children = stringifyChildren
         ? ("[" + (genChildrenAsStringNode(el, state)) + "]")
         : genSSRChildren(el, state, true);
       return ("_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")")
     }
   
     function genSSRChildren (el, state, checkSkip) {
       return genChildren(el, state, checkSkip, genSSRElement, genSSRNode)
     }
   
     function genSSRNode (el, state) {
       return el.type === 1
         ? genSSRElement(el, state)
         : genText(el)
     }
   
     function genChildrenAsStringNode (el, state) {
       return el.children.length
         ? ("_ssrNode(" + (flattenSegments(childrenToSegments(el, state))) + ")")
         : ''
     }
   
     function genStringElement (el, state) {
       return ("_ssrNode(" + (elementToString(el, state)) + ")")
     }
   
     function genStringElementWithChildren (el, state) {
       var children = genSSRChildren(el, state, true);
       return ("_ssrNode(" + (flattenSegments(elementToOpenTagSegments(el, state))) + ",\"</" + (el.tag) + ">\"" + (children ? ("," + children) : '') + ")")
     }
   
     function elementToString (el, state) {
       return ("(" + (flattenSegments(elementToSegments(el, state))) + ")")
     }
   
     function elementToSegments (el, state) {
       // v-for / v-if
       if (el.for && !el.forProcessed) {
         el.forProcessed = true;
         return [{
           type: EXPRESSION,
           value: genFor(el, state, elementToString, '_ssrList')
         }]
       } else if (el.if && !el.ifProcessed) {
         el.ifProcessed = true;
         return [{
           type: EXPRESSION,
           value: genIf(el, state, elementToString, '"<!---->"')
         }]
       } else if (el.tag === 'template') {
         return childrenToSegments(el, state)
       }
   
       var openSegments = elementToOpenTagSegments(el, state);
       var childrenSegments = childrenToSegments(el, state);
       var ref = state.options;
       var isUnaryTag = ref.isUnaryTag;
       var close = (isUnaryTag && isUnaryTag(el.tag))
         ? []
         : [{ type: RAW, value: ("</" + (el.tag) + ">") }];
       return openSegments.concat(childrenSegments, close)
     }
   
     function elementToOpenTagSegments (el, state) {
       applyModelTransform(el, state);
       var binding;
       var segments = [{ type: RAW, value: ("<" + (el.tag)) }];
       // attrs
       if (el.attrs) {
         segments.push.apply(segments, genAttrSegments(el.attrs));
       }
       // domProps
       if (el.props) {
         segments.push.apply(segments, genDOMPropSegments(el.props, el.attrs));
       }
       // v-bind="object"
       if ((binding = el.attrsMap['v-bind'])) {
         segments.push({ type: EXPRESSION, value: ("_ssrAttrs(" + binding + ")") });
       }
       // v-bind.prop="object"
       if ((binding = el.attrsMap['v-bind.prop'])) {
         segments.push({ type: EXPRESSION, value: ("_ssrDOMProps(" + binding + ")") });
       }
       // class
       if (el.staticClass || el.classBinding) {
         segments.push.apply(
           segments,
           genClassSegments(el.staticClass, el.classBinding)
         );
       }
       // style & v-show
       if (el.staticStyle || el.styleBinding || el.attrsMap['v-show']) {
         segments.push.apply(
           segments,
           genStyleSegments(
             el.attrsMap.style,
             el.staticStyle,
             el.styleBinding,
             el.attrsMap['v-show']
           )
         );
       }
       // _scopedId
       if (state.options.scopeId) {
         segments.push({ type: RAW, value: (" " + (state.options.scopeId)) });
       }
       segments.push({ type: RAW, value: ">" });
       return segments
     }
   
     function childrenToSegments (el, state) {
       var binding;
       if ((binding = el.attrsMap['v-html'])) {
         return [{ type: EXPRESSION, value: ("_s(" + binding + ")") }]
       }
       if ((binding = el.attrsMap['v-text'])) {
         return [{ type: INTERPOLATION, value: ("_s(" + binding + ")") }]
       }
       if (el.tag === 'textarea' && (binding = el.attrsMap['v-model'])) {
         return [{ type: INTERPOLATION, value: ("_s(" + binding + ")") }]
       }
       return el.children
         ? nodesToSegments(el.children, state)
         : []
     }
   
     function nodesToSegments (
       children,
       state
     ) {
       var segments = [];
       for (var i = 0; i < children.length; i++) {
         var c = children[i];
         if (c.type === 1) {
           segments.push.apply(segments, elementToSegments(c, state));
         } else if (c.type === 2) {
           segments.push({ type: INTERPOLATION, value: c.expression });
         } else if (c.type === 3) {
           var text = escape(c.text);
           if (c.isComment) {
             text = '<!--' + text + '-->';
           }
           segments.push({ type: RAW, value: text });
         }
       }
       return segments
     }
   
     function flattenSegments (segments) {
       var mergedSegments = [];
       var textBuffer = '';
   
       var pushBuffer = function () {
         if (textBuffer) {
           mergedSegments.push(JSON.stringify(textBuffer));
           textBuffer = '';
         }
       };
   
       for (var i = 0; i < segments.length; i++) {
         var s = segments[i];
         if (s.type === RAW) {
           textBuffer += s.value;
         } else if (s.type === INTERPOLATION) {
           pushBuffer();
           mergedSegments.push(("_ssrEscape(" + (s.value) + ")"));
         } else if (s.type === EXPRESSION) {
           pushBuffer();
           mergedSegments.push(("(" + (s.value) + ")"));
         }
       }
       pushBuffer();
   
       return mergedSegments.join('+')
     }
   
     /*  */
   
     var createCompiler$1 = createCompilerCreator(function baseCompile (
       template,
       options
     ) {
       var ast = parse(template.trim(), options);
       optimize$1(ast, options);
       var code = generate$1(ast, options);
       return {
         ast: ast,
         render: code.render,
         staticRenderFns: code.staticRenderFns
       }
     });
   
     /*  */
   
     var ref$1 = createCompiler$1(baseOptions);
     var compile$1 = ref$1.compile;
     var compileToFunctions$1 = ref$1.compileToFunctions;
   
     /*  */
   
     exports.parseComponent = parseComponent;
     exports.compile = compile;
     exports.compileToFunctions = compileToFunctions;
     exports.ssrCompile = compile$1;
     exports.ssrCompileToFunctions = compileToFunctions$1;
     exports.generateCodeFrame = generateCodeFrame;
   
     Object.defineProperty(exports, '__esModule', { value: true });
   
   }));
   
   
   /***/ }),
   
   /***/ 630:
   /***/ (function(module, exports) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
     if (true) {
       !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
           __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
           (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
     } else { var mod; }
   })(this, function (module, exports) {
     'use strict';
   
     Object.defineProperty(exports, "__esModule", {
       value: true
     });
   
     var _class, _temp;
   
     function _classCallCheck(instance, Constructor) {
       if (!(instance instanceof Constructor)) {
         throw new TypeError("Cannot call a class as a function");
       }
     }
   
     var _createClass = function () {
       function defineProperties(target, props) {
         for (var i = 0; i < props.length; i++) {
           var descriptor = props[i];
           descriptor.enumerable = descriptor.enumerable || false;
           descriptor.configurable = true;
           if ("value" in descriptor) descriptor.writable = true;
           Object.defineProperty(target, descriptor.key, descriptor);
         }
       }
   
       return function (Constructor, protoProps, staticProps) {
         if (protoProps) defineProperties(Constructor.prototype, protoProps);
         if (staticProps) defineProperties(Constructor, staticProps);
         return Constructor;
       };
     }();
   
     function isIn(needle, haystack) {
       return haystack.indexOf(needle) >= 0;
     }
   
     function extend(custom, defaults) {
       for (var key in defaults) {
         if (custom[key] == null) {
           var value = defaults[key];
           custom[key] = value;
         }
       }
       return custom;
     }
   
     function isMobile(agent) {
       return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)
       );
     }
   
     function createEvent(event) {
       var bubble = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
       var cancel = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
       var detail = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
   
       var customEvent = void 0;
       if (document.createEvent != null) {
         // W3C DOM
         customEvent = document.createEvent('CustomEvent');
         customEvent.initCustomEvent(event, bubble, cancel, detail);
       } else if (document.createEventObject != null) {
         // IE DOM < 9
         customEvent = document.createEventObject();
         customEvent.eventType = event;
       } else {
         customEvent.eventName = event;
       }
   
       return customEvent;
     }
   
     function emitEvent(elem, event) {
       if (elem.dispatchEvent != null) {
         // W3C DOM
         elem.dispatchEvent(event);
       } else if (event in (elem != null)) {
         elem[event]();
       } else if ('on' + event in (elem != null)) {
         elem['on' + event]();
       }
     }
   
     function addEvent(elem, event, fn) {
       if (elem.addEventListener != null) {
         // W3C DOM
         elem.addEventListener(event, fn, false);
       } else if (elem.attachEvent != null) {
         // IE DOM
         elem.attachEvent('on' + event, fn);
       } else {
         // fallback
         elem[event] = fn;
       }
     }
   
     function removeEvent(elem, event, fn) {
       if (elem.removeEventListener != null) {
         // W3C DOM
         elem.removeEventListener(event, fn, false);
       } else if (elem.detachEvent != null) {
         // IE DOM
         elem.detachEvent('on' + event, fn);
       } else {
         // fallback
         delete elem[event];
       }
     }
   
     function getInnerHeight() {
       if ('innerHeight' in window) {
         return window.innerHeight;
       }
   
       return document.documentElement.clientHeight;
     }
   
     // Minimalistic WeakMap shim, just in case.
     var WeakMap = window.WeakMap || window.MozWeakMap || function () {
       function WeakMap() {
         _classCallCheck(this, WeakMap);
   
         this.keys = [];
         this.values = [];
       }
   
       _createClass(WeakMap, [{
         key: 'get',
         value: function get(key) {
           for (var i = 0; i < this.keys.length; i++) {
             var item = this.keys[i];
             if (item === key) {
               return this.values[i];
             }
           }
           return undefined;
         }
       }, {
         key: 'set',
         value: function set(key, value) {
           for (var i = 0; i < this.keys.length; i++) {
             var item = this.keys[i];
             if (item === key) {
               this.values[i] = value;
               return this;
             }
           }
           this.keys.push(key);
           this.values.push(value);
           return this;
         }
       }]);
   
       return WeakMap;
     }();
   
     // Dummy MutationObserver, to avoid raising exceptions.
     var MutationObserver = window.MutationObserver || window.WebkitMutationObserver || window.MozMutationObserver || (_temp = _class = function () {
       function MutationObserver() {
         _classCallCheck(this, MutationObserver);
   
         if (typeof console !== 'undefined' && console !== null) {
           console.warn('MutationObserver is not supported by your browser.');
           console.warn('WOW.js cannot detect dom mutations, please call .sync() after loading new content.');
         }
       }
   
       _createClass(MutationObserver, [{
         key: 'observe',
         value: function observe() {}
       }]);
   
       return MutationObserver;
     }(), _class.notSupported = true, _temp);
   
     // getComputedStyle shim, from http://stackoverflow.com/a/21797294
     var getComputedStyle = window.getComputedStyle || function getComputedStyle(el) {
       var getComputedStyleRX = /(\-([a-z]){1})/g;
       return {
         getPropertyValue: function getPropertyValue(prop) {
           if (prop === 'float') {
             prop = 'styleFloat';
           }
           if (getComputedStyleRX.test(prop)) {
             prop.replace(getComputedStyleRX, function (_, _char) {
               return _char.toUpperCase();
             });
           }
           var currentStyle = el.currentStyle;
   
           return (currentStyle != null ? currentStyle[prop] : void 0) || null;
         }
       };
     };
   
     var WOW = function () {
       function WOW() {
         var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
   
         _classCallCheck(this, WOW);
   
         this.defaults = {
           boxClass: 'wow',
           animateClass: 'animated',
           offset: 0,
           mobile: true,
           live: true,
           callback: null,
           scrollContainer: null
         };
   
         this.animate = function animateFactory() {
           if ('requestAnimationFrame' in window) {
             return function (callback) {
               return window.requestAnimationFrame(callback);
             };
           }
           return function (callback) {
             return callback();
           };
         }();
   
         this.vendors = ['moz', 'webkit'];
   
         this.start = this.start.bind(this);
         this.resetAnimation = this.resetAnimation.bind(this);
         this.scrollHandler = this.scrollHandler.bind(this);
         this.scrollCallback = this.scrollCallback.bind(this);
         this.scrolled = true;
         this.config = extend(options, this.defaults);
         if (options.scrollContainer != null) {
           this.config.scrollContainer = document.querySelector(options.scrollContainer);
         }
         // Map of elements to animation names:
         this.animationNameCache = new WeakMap();
         this.wowEvent = createEvent(this.config.boxClass);
       }
   
       _createClass(WOW, [{
         key: 'init',
         value: function init() {
           this.element = window.document.documentElement;
           if (isIn(document.readyState, ['interactive', 'complete'])) {
             this.start();
           } else {
             addEvent(document, 'DOMContentLoaded', this.start);
           }
           this.finished = [];
         }
       }, {
         key: 'start',
         value: function start() {
           var _this = this;
   
           this.stopped = false;
           this.boxes = [].slice.call(this.element.querySelectorAll('.' + this.config.boxClass));
           this.all = this.boxes.slice(0);
           if (this.boxes.length) {
             if (this.disabled()) {
               this.resetStyle();
             } else {
               for (var i = 0; i < this.boxes.length; i++) {
                 var box = this.boxes[i];
                 this.applyStyle(box, true);
               }
             }
           }
           if (!this.disabled()) {
             addEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
             addEvent(window, 'resize', this.scrollHandler);
             this.interval = setInterval(this.scrollCallback, 50);
           }
           if (this.config.live) {
             var mut = new MutationObserver(function (records) {
               for (var j = 0; j < records.length; j++) {
                 var record = records[j];
                 for (var k = 0; k < record.addedNodes.length; k++) {
                   var node = record.addedNodes[k];
                   _this.doSync(node);
                 }
               }
               return undefined;
             });
             mut.observe(document.body, {
               childList: true,
               subtree: true
             });
           }
         }
       }, {
         key: 'stop',
         value: function stop() {
           this.stopped = true;
           removeEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
           removeEvent(window, 'resize', this.scrollHandler);
           if (this.interval != null) {
             clearInterval(this.interval);
           }
         }
       }, {
         key: 'sync',
         value: function sync() {
           if (MutationObserver.notSupported) {
             this.doSync(this.element);
           }
         }
       }, {
         key: 'doSync',
         value: function doSync(element) {
           if (typeof element === 'undefined' || element === null) {
             element = this.element;
           }
           if (element.nodeType !== 1) {
             return;
           }
           element = element.parentNode || element;
           var iterable = element.querySelectorAll('.' + this.config.boxClass);
           for (var i = 0; i < iterable.length; i++) {
             var box = iterable[i];
             if (!isIn(box, this.all)) {
               this.boxes.push(box);
               this.all.push(box);
               if (this.stopped || this.disabled()) {
                 this.resetStyle();
               } else {
                 this.applyStyle(box, true);
               }
               this.scrolled = true;
             }
           }
         }
       }, {
         key: 'show',
         value: function show(box) {
           this.applyStyle(box);
           box.className = box.className + ' ' + this.config.animateClass;
           if (this.config.callback != null) {
             this.config.callback(box);
           }
           emitEvent(box, this.wowEvent);
   
           addEvent(box, 'animationend', this.resetAnimation);
           addEvent(box, 'oanimationend', this.resetAnimation);
           addEvent(box, 'webkitAnimationEnd', this.resetAnimation);
           addEvent(box, 'MSAnimationEnd', this.resetAnimation);
   
           return box;
         }
       }, {
         key: 'applyStyle',
         value: function applyStyle(box, hidden) {
           var _this2 = this;
   
           var duration = box.getAttribute('data-wow-duration');
           var delay = box.getAttribute('data-wow-delay');
           var iteration = box.getAttribute('data-wow-iteration');
   
           return this.animate(function () {
             return _this2.customStyle(box, hidden, duration, delay, iteration);
           });
         }
       }, {
         key: 'resetStyle',
         value: function resetStyle() {
           for (var i = 0; i < this.boxes.length; i++) {
             var box = this.boxes[i];
             box.style.visibility = 'visible';
           }
           return undefined;
         }
       }, {
         key: 'resetAnimation',
         value: function resetAnimation(event) {
           if (event.type.toLowerCase().indexOf('animationend') >= 0) {
             var target = event.target || event.srcElement;
             target.className = target.className.replace(this.config.animateClass, '').trim();
           }
         }
       }, {
         key: 'customStyle',
         value: function customStyle(box, hidden, duration, delay, iteration) {
           if (hidden) {
             this.cacheAnimationName(box);
           }
           box.style.visibility = hidden ? 'hidden' : 'visible';
   
           if (duration) {
             this.vendorSet(box.style, { animationDuration: duration });
           }
           if (delay) {
             this.vendorSet(box.style, { animationDelay: delay });
           }
           if (iteration) {
             this.vendorSet(box.style, { animationIterationCount: iteration });
           }
           this.vendorSet(box.style, { animationName: hidden ? 'none' : this.cachedAnimationName(box) });
   
           return box;
         }
       }, {
         key: 'vendorSet',
         value: function vendorSet(elem, properties) {
           for (var name in properties) {
             if (properties.hasOwnProperty(name)) {
               var value = properties[name];
               elem['' + name] = value;
               for (var i = 0; i < this.vendors.length; i++) {
                 var vendor = this.vendors[i];
                 elem['' + vendor + name.charAt(0).toUpperCase() + name.substr(1)] = value;
               }
             }
           }
         }
       }, {
         key: 'vendorCSS',
         value: function vendorCSS(elem, property) {
           var style = getComputedStyle(elem);
           var result = style.getPropertyCSSValue(property);
           for (var i = 0; i < this.vendors.length; i++) {
             var vendor = this.vendors[i];
             result = result || style.getPropertyCSSValue('-' + vendor + '-' + property);
           }
           return result;
         }
       }, {
         key: 'animationName',
         value: function animationName(box) {
           var aName = void 0;
           try {
             aName = this.vendorCSS(box, 'animation-name').cssText;
           } catch (error) {
             // Opera, fall back to plain property value
             aName = getComputedStyle(box).getPropertyValue('animation-name');
           }
   
           if (aName === 'none') {
             return ''; // SVG/Firefox, unable to get animation name?
           }
   
           return aName;
         }
       }, {
         key: 'cacheAnimationName',
         value: function cacheAnimationName(box) {
           // https://bugzilla.mozilla.org/show_bug.cgi?id=921834
           // box.dataset is not supported for SVG elements in Firefox
           return this.animationNameCache.set(box, this.animationName(box));
         }
       }, {
         key: 'cachedAnimationName',
         value: function cachedAnimationName(box) {
           return this.animationNameCache.get(box);
         }
       }, {
         key: 'scrollHandler',
         value: function scrollHandler() {
           this.scrolled = true;
         }
       }, {
         key: 'scrollCallback',
         value: function scrollCallback() {
           if (this.scrolled) {
             this.scrolled = false;
             var results = [];
             for (var i = 0; i < this.boxes.length; i++) {
               var box = this.boxes[i];
               if (box) {
                 if (this.isVisible(box)) {
                   this.show(box);
                   continue;
                 }
                 results.push(box);
               }
             }
             this.boxes = results;
             if (!this.boxes.length && !this.config.live) {
               this.stop();
             }
           }
         }
       }, {
         key: 'offsetTop',
         value: function offsetTop(element) {
           // SVG elements don't have an offsetTop in Firefox.
           // This will use their nearest parent that has an offsetTop.
           // Also, using ('offsetTop' of element) causes an exception in Firefox.
           while (element.offsetTop === undefined) {
             element = element.parentNode;
           }
           var top = element.offsetTop;
           while (element.offsetParent) {
             element = element.offsetParent;
             top += element.offsetTop;
           }
           return top;
         }
       }, {
         key: 'isVisible',
         value: function isVisible(box) {
           var offset = box.getAttribute('data-wow-offset') || this.config.offset;
           var viewTop = this.config.scrollContainer && this.config.scrollContainer.scrollTop || window.pageYOffset;
           var viewBottom = viewTop + Math.min(this.element.clientHeight, getInnerHeight()) - offset;
           var top = this.offsetTop(box);
           var bottom = top + box.clientHeight;
   
           return top <= viewBottom && bottom >= viewTop;
         }
       }, {
         key: 'disabled',
         value: function disabled() {
           return !this.config.mobile && isMobile(navigator.userAgent);
         }
       }]);
   
       return WOW;
     }();
   
     exports.default = WOW;
     module.exports = exports['default'];
   });
   
   
   /***/ })
   
   /******/ 	});
   /************************************************************************/
   /******/ 	// The module cache
   /******/ 	var __webpack_module_cache__ = {};
   /******/ 	
   /******/ 	// The require function
   /******/ 	function __webpack_require__(moduleId) {
   /******/ 		// Check if module is in cache
   /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
   /******/ 		if (cachedModule !== undefined) {
   /******/ 			return cachedModule.exports;
   /******/ 		}
   /******/ 		// Create a new module (and put it into the cache)
   /******/ 		var module = __webpack_module_cache__[moduleId] = {
   /******/ 			// no module.id needed
   /******/ 			// no module.loaded needed
   /******/ 			exports: {}
   /******/ 		};
   /******/ 	
   /******/ 		// Execute the module function
   /******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
   /******/ 	
   /******/ 		// Return the exports of the module
   /******/ 		return module.exports;
   /******/ 	}
   /******/ 	
   /************************************************************************/
   /******/ 	/* webpack/runtime/compat get default export */
   /******/ 	(() => {
   /******/ 		// getDefaultExport function for compatibility with non-harmony modules
   /******/ 		__webpack_require__.n = (module) => {
   /******/ 			var getter = module && module.__esModule ?
   /******/ 				() => (module['default']) :
   /******/ 				() => (module);
   /******/ 			__webpack_require__.d(getter, { a: getter });
   /******/ 			return getter;
   /******/ 		};
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/define property getters */
   /******/ 	(() => {
   /******/ 		// define getter functions for harmony exports
   /******/ 		__webpack_require__.d = (exports, definition) => {
   /******/ 			for(var key in definition) {
   /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
   /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
   /******/ 				}
   /******/ 			}
   /******/ 		};
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/global */
   /******/ 	(() => {
   /******/ 		__webpack_require__.g = (function() {
   /******/ 			if (typeof globalThis === 'object') return globalThis;
   /******/ 			try {
   /******/ 				return this || new Function('return this')();
   /******/ 			} catch (e) {
   /******/ 				if (typeof window === 'object') return window;
   /******/ 			}
   /******/ 		})();
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
   /******/ 	(() => {
   /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
   /******/ 	})();
   /******/ 	
   /************************************************************************/
   var __webpack_exports__ = {};
   // This entry need to be wrapped in an IIFE because it need to be in strict mode.
   (() => {
   "use strict";
   
   // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
   var jquery = __webpack_require__(755);
   var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
   // EXTERNAL MODULE: ./node_modules/wow.js/dist/wow.js
   var wow = __webpack_require__(630);
   var wow_default = /*#__PURE__*/__webpack_require__.n(wow);
   ;// CONCATENATED MODULE: ./node_modules/vue/dist/vue.esm.js
   /*!
    * Vue.js v2.6.14
    * (c) 2014-2021 Evan You
    * Released under the MIT License.
    */
   /*  */
   
   var emptyObject = Object.freeze({});
   
   // These helpers produce better VM code in JS engines due to their
   // explicitness and function inlining.
   function isUndef (v) {
     return v === undefined || v === null
   }
   
   function isDef (v) {
     return v !== undefined && v !== null
   }
   
   function isTrue (v) {
     return v === true
   }
   
   function isFalse (v) {
     return v === false
   }
   
   /**
    * Check if value is primitive.
    */
   function isPrimitive (value) {
     return (
       typeof value === 'string' ||
       typeof value === 'number' ||
       // $flow-disable-line
       typeof value === 'symbol' ||
       typeof value === 'boolean'
     )
   }
   
   /**
    * Quick object check - this is primarily used to tell
    * Objects from primitive values when we know the value
    * is a JSON-compliant type.
    */
   function isObject (obj) {
     return obj !== null && typeof obj === 'object'
   }
   
   /**
    * Get the raw type string of a value, e.g., [object Object].
    */
   var _toString = Object.prototype.toString;
   
   function toRawType (value) {
     return _toString.call(value).slice(8, -1)
   }
   
   /**
    * Strict object type check. Only returns true
    * for plain JavaScript objects.
    */
   function isPlainObject (obj) {
     return _toString.call(obj) === '[object Object]'
   }
   
   function isRegExp (v) {
     return _toString.call(v) === '[object RegExp]'
   }
   
   /**
    * Check if val is a valid array index.
    */
   function isValidArrayIndex (val) {
     var n = parseFloat(String(val));
     return n >= 0 && Math.floor(n) === n && isFinite(val)
   }
   
   function isPromise (val) {
     return (
       isDef(val) &&
       typeof val.then === 'function' &&
       typeof val.catch === 'function'
     )
   }
   
   /**
    * Convert a value to a string that is actually rendered.
    */
   function vue_esm_toString (val) {
     return val == null
       ? ''
       : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
         ? JSON.stringify(val, null, 2)
         : String(val)
   }
   
   /**
    * Convert an input value to a number for persistence.
    * If the conversion fails, return original string.
    */
   function toNumber (val) {
     var n = parseFloat(val);
     return isNaN(n) ? val : n
   }
   
   /**
    * Make a map and return a function for checking if a key
    * is in that map.
    */
   function makeMap (
     str,
     expectsLowerCase
   ) {
     var map = Object.create(null);
     var list = str.split(',');
     for (var i = 0; i < list.length; i++) {
       map[list[i]] = true;
     }
     return expectsLowerCase
       ? function (val) { return map[val.toLowerCase()]; }
       : function (val) { return map[val]; }
   }
   
   /**
    * Check if a tag is a built-in tag.
    */
   var isBuiltInTag = makeMap('slot,component', true);
   
   /**
    * Check if an attribute is a reserved attribute.
    */
   var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
   
   /**
    * Remove an item from an array.
    */
   function remove (arr, item) {
     if (arr.length) {
       var index = arr.indexOf(item);
       if (index > -1) {
         return arr.splice(index, 1)
       }
     }
   }
   
   /**
    * Check whether an object has the property.
    */
   var vue_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
   function hasOwn (obj, key) {
     return vue_esm_hasOwnProperty.call(obj, key)
   }
   
   /**
    * Create a cached version of a pure function.
    */
   function cached (fn) {
     var cache = Object.create(null);
     return (function cachedFn (str) {
       var hit = cache[str];
       return hit || (cache[str] = fn(str))
     })
   }
   
   /**
    * Camelize a hyphen-delimited string.
    */
   var camelizeRE = /-(\w)/g;
   var camelize = cached(function (str) {
     return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
   });
   
   /**
    * Capitalize a string.
    */
   var capitalize = cached(function (str) {
     return str.charAt(0).toUpperCase() + str.slice(1)
   });
   
   /**
    * Hyphenate a camelCase string.
    */
   var hyphenateRE = /\B([A-Z])/g;
   var hyphenate = cached(function (str) {
     return str.replace(hyphenateRE, '-$1').toLowerCase()
   });
   
   /**
    * Simple bind polyfill for environments that do not support it,
    * e.g., PhantomJS 1.x. Technically, we don't need this anymore
    * since native bind is now performant enough in most browsers.
    * But removing it would mean breaking code that was able to run in
    * PhantomJS 1.x, so this must be kept for backward compatibility.
    */
   
   /* istanbul ignore next */
   function polyfillBind (fn, ctx) {
     function boundFn (a) {
       var l = arguments.length;
       return l
         ? l > 1
           ? fn.apply(ctx, arguments)
           : fn.call(ctx, a)
         : fn.call(ctx)
     }
   
     boundFn._length = fn.length;
     return boundFn
   }
   
   function nativeBind (fn, ctx) {
     return fn.bind(ctx)
   }
   
   var bind = Function.prototype.bind
     ? nativeBind
     : polyfillBind;
   
   /**
    * Convert an Array-like object to a real Array.
    */
   function toArray (list, start) {
     start = start || 0;
     var i = list.length - start;
     var ret = new Array(i);
     while (i--) {
       ret[i] = list[i + start];
     }
     return ret
   }
   
   /**
    * Mix properties into target object.
    */
   function extend (to, _from) {
     for (var key in _from) {
       to[key] = _from[key];
     }
     return to
   }
   
   /**
    * Merge an Array of Objects into a single Object.
    */
   function toObject (arr) {
     var res = {};
     for (var i = 0; i < arr.length; i++) {
       if (arr[i]) {
         extend(res, arr[i]);
       }
     }
     return res
   }
   
   /* eslint-disable no-unused-vars */
   
   /**
    * Perform no operation.
    * Stubbing args to make Flow happy without leaving useless transpiled code
    * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
    */
   function noop (a, b, c) {}
   
   /**
    * Always return false.
    */
   var no = function (a, b, c) { return false; };
   
   /* eslint-enable no-unused-vars */
   
   /**
    * Return the same value.
    */
   var identity = function (_) { return _; };
   
   /**
    * Generate a string containing static keys from compiler modules.
    */
   function genStaticKeys (modules) {
     return modules.reduce(function (keys, m) {
       return keys.concat(m.staticKeys || [])
     }, []).join(',')
   }
   
   /**
    * Check if two values are loosely equal - that is,
    * if they are plain objects, do they have the same shape?
    */
   function looseEqual (a, b) {
     if (a === b) { return true }
     var isObjectA = isObject(a);
     var isObjectB = isObject(b);
     if (isObjectA && isObjectB) {
       try {
         var isArrayA = Array.isArray(a);
         var isArrayB = Array.isArray(b);
         if (isArrayA && isArrayB) {
           return a.length === b.length && a.every(function (e, i) {
             return looseEqual(e, b[i])
           })
         } else if (a instanceof Date && b instanceof Date) {
           return a.getTime() === b.getTime()
         } else if (!isArrayA && !isArrayB) {
           var keysA = Object.keys(a);
           var keysB = Object.keys(b);
           return keysA.length === keysB.length && keysA.every(function (key) {
             return looseEqual(a[key], b[key])
           })
         } else {
           /* istanbul ignore next */
           return false
         }
       } catch (e) {
         /* istanbul ignore next */
         return false
       }
     } else if (!isObjectA && !isObjectB) {
       return String(a) === String(b)
     } else {
       return false
     }
   }
   
   /**
    * Return the first index at which a loosely equal value can be
    * found in the array (if value is a plain object, the array must
    * contain an object of the same shape), or -1 if it is not present.
    */
   function looseIndexOf (arr, val) {
     for (var i = 0; i < arr.length; i++) {
       if (looseEqual(arr[i], val)) { return i }
     }
     return -1
   }
   
   /**
    * Ensure a function is called only once.
    */
   function once (fn) {
     var called = false;
     return function () {
       if (!called) {
         called = true;
         fn.apply(this, arguments);
       }
     }
   }
   
   var SSR_ATTR = 'data-server-rendered';
   
   var ASSET_TYPES = [
     'component',
     'directive',
     'filter'
   ];
   
   var LIFECYCLE_HOOKS = [
     'beforeCreate',
     'created',
     'beforeMount',
     'mounted',
     'beforeUpdate',
     'updated',
     'beforeDestroy',
     'destroyed',
     'activated',
     'deactivated',
     'errorCaptured',
     'serverPrefetch'
   ];
   
   /*  */
   
   
   
   var config = ({
     /**
      * Option merge strategies (used in core/util/options)
      */
     // $flow-disable-line
     optionMergeStrategies: Object.create(null),
   
     /**
      * Whether to suppress warnings.
      */
     silent: false,
   
     /**
      * Show production mode tip message on boot?
      */
     productionTip: "production" !== 'production',
   
     /**
      * Whether to enable devtools
      */
     devtools: "production" !== 'production',
   
     /**
      * Whether to record perf
      */
     performance: false,
   
     /**
      * Error handler for watcher errors
      */
     errorHandler: null,
   
     /**
      * Warn handler for watcher warns
      */
     warnHandler: null,
   
     /**
      * Ignore certain custom elements
      */
     ignoredElements: [],
   
     /**
      * Custom user key aliases for v-on
      */
     // $flow-disable-line
     keyCodes: Object.create(null),
   
     /**
      * Check if a tag is reserved so that it cannot be registered as a
      * component. This is platform-dependent and may be overwritten.
      */
     isReservedTag: no,
   
     /**
      * Check if an attribute is reserved so that it cannot be used as a component
      * prop. This is platform-dependent and may be overwritten.
      */
     isReservedAttr: no,
   
     /**
      * Check if a tag is an unknown element.
      * Platform-dependent.
      */
     isUnknownElement: no,
   
     /**
      * Get the namespace of an element
      */
     getTagNamespace: noop,
   
     /**
      * Parse the real tag name for the specific platform.
      */
     parsePlatformTagName: identity,
   
     /**
      * Check if an attribute must be bound using property, e.g. value
      * Platform-dependent.
      */
     mustUseProp: no,
   
     /**
      * Perform updates asynchronously. Intended to be used by Vue Test Utils
      * This will significantly reduce performance if set to false.
      */
     async: true,
   
     /**
      * Exposed for legacy reasons
      */
     _lifecycleHooks: LIFECYCLE_HOOKS
   });
   
   /*  */
   
   /**
    * unicode letters used for parsing html tags, component names and property paths.
    * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
    * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
    */
   var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
   
   /**
    * Check if a string starts with $ or _
    */
   function isReserved (str) {
     var c = (str + '').charCodeAt(0);
     return c === 0x24 || c === 0x5F
   }
   
   /**
    * Define a property.
    */
   function def (obj, key, val, enumerable) {
     Object.defineProperty(obj, key, {
       value: val,
       enumerable: !!enumerable,
       writable: true,
       configurable: true
     });
   }
   
   /**
    * Parse simple path.
    */
   var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
   function parsePath (path) {
     if (bailRE.test(path)) {
       return
     }
     var segments = path.split('.');
     return function (obj) {
       for (var i = 0; i < segments.length; i++) {
         if (!obj) { return }
         obj = obj[segments[i]];
       }
       return obj
     }
   }
   
   /*  */
   
   // can we use __proto__?
   var hasProto = '__proto__' in {};
   
   // Browser environment sniffing
   var inBrowser = typeof window !== 'undefined';
   var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
   var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
   var UA = inBrowser && window.navigator.userAgent.toLowerCase();
   var isIE = UA && /msie|trident/.test(UA);
   var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
   var isEdge = UA && UA.indexOf('edge/') > 0;
   var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
   var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
   var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
   var isPhantomJS = UA && /phantomjs/.test(UA);
   var isFF = UA && UA.match(/firefox\/(\d+)/);
   
   // Firefox has a "watch" function on Object.prototype...
   var nativeWatch = ({}).watch;
   
   var supportsPassive = false;
   if (inBrowser) {
     try {
       var opts = {};
       Object.defineProperty(opts, 'passive', ({
         get: function get () {
           /* istanbul ignore next */
           supportsPassive = true;
         }
       })); // https://github.com/facebook/flow/issues/285
       window.addEventListener('test-passive', null, opts);
     } catch (e) {}
   }
   
   // this needs to be lazy-evaled because vue may be required before
   // vue-server-renderer can set VUE_ENV
   var _isServer;
   var isServerRendering = function () {
     if (_isServer === undefined) {
       /* istanbul ignore if */
       if (!inBrowser && !inWeex && typeof __webpack_require__.g !== 'undefined') {
         // detect presence of vue-server-renderer and avoid
         // Webpack shimming the process
         _isServer = __webpack_require__.g['process'] && __webpack_require__.g['process'].env.VUE_ENV === 'server';
       } else {
         _isServer = false;
       }
     }
     return _isServer
   };
   
   // detect devtools
   var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
   
   /* istanbul ignore next */
   function isNative (Ctor) {
     return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
   }
   
   var hasSymbol =
     typeof Symbol !== 'undefined' && isNative(Symbol) &&
     typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
   
   var _Set;
   /* istanbul ignore if */ // $flow-disable-line
   if (typeof Set !== 'undefined' && isNative(Set)) {
     // use native Set when available.
     _Set = Set;
   } else {
     // a non-standard Set polyfill that only works with primitive keys.
     _Set = /*@__PURE__*/(function () {
       function Set () {
         this.set = Object.create(null);
       }
       Set.prototype.has = function has (key) {
         return this.set[key] === true
       };
       Set.prototype.add = function add (key) {
         this.set[key] = true;
       };
       Set.prototype.clear = function clear () {
         this.set = Object.create(null);
       };
   
       return Set;
     }());
   }
   
   /*  */
   
   var warn = noop;
   var tip = (/* unused pure expression or super */ null && (noop));
   var generateComponentTrace = ((/* unused pure expression or super */ null && (noop))); // work around flow check
   var formatComponentName = ((/* unused pure expression or super */ null && (noop)));
   
   if (false) { var repeat, classify, classifyRE, hasConsole; }
   
   /*  */
   
   var uid = 0;
   
   /**
    * A dep is an observable that can have multiple
    * directives subscribing to it.
    */
   var Dep = function Dep () {
     this.id = uid++;
     this.subs = [];
   };
   
   Dep.prototype.addSub = function addSub (sub) {
     this.subs.push(sub);
   };
   
   Dep.prototype.removeSub = function removeSub (sub) {
     remove(this.subs, sub);
   };
   
   Dep.prototype.depend = function depend () {
     if (Dep.target) {
       Dep.target.addDep(this);
     }
   };
   
   Dep.prototype.notify = function notify () {
     // stabilize the subscriber list first
     var subs = this.subs.slice();
     if (false) {}
     for (var i = 0, l = subs.length; i < l; i++) {
       subs[i].update();
     }
   };
   
   // The current target watcher being evaluated.
   // This is globally unique because only one watcher
   // can be evaluated at a time.
   Dep.target = null;
   var targetStack = [];
   
   function pushTarget (target) {
     targetStack.push(target);
     Dep.target = target;
   }
   
   function popTarget () {
     targetStack.pop();
     Dep.target = targetStack[targetStack.length - 1];
   }
   
   /*  */
   
   var VNode = function VNode (
     tag,
     data,
     children,
     text,
     elm,
     context,
     componentOptions,
     asyncFactory
   ) {
     this.tag = tag;
     this.data = data;
     this.children = children;
     this.text = text;
     this.elm = elm;
     this.ns = undefined;
     this.context = context;
     this.fnContext = undefined;
     this.fnOptions = undefined;
     this.fnScopeId = undefined;
     this.key = data && data.key;
     this.componentOptions = componentOptions;
     this.componentInstance = undefined;
     this.parent = undefined;
     this.raw = false;
     this.isStatic = false;
     this.isRootInsert = true;
     this.isComment = false;
     this.isCloned = false;
     this.isOnce = false;
     this.asyncFactory = asyncFactory;
     this.asyncMeta = undefined;
     this.isAsyncPlaceholder = false;
   };
   
   var prototypeAccessors = { child: { configurable: true } };
   
   // DEPRECATED: alias for componentInstance for backwards compat.
   /* istanbul ignore next */
   prototypeAccessors.child.get = function () {
     return this.componentInstance
   };
   
   Object.defineProperties( VNode.prototype, prototypeAccessors );
   
   var createEmptyVNode = function (text) {
     if ( text === void 0 ) text = '';
   
     var node = new VNode();
     node.text = text;
     node.isComment = true;
     return node
   };
   
   function createTextVNode (val) {
     return new VNode(undefined, undefined, undefined, String(val))
   }
   
   // optimized shallow clone
   // used for static nodes and slot nodes because they may be reused across
   // multiple renders, cloning them avoids errors when DOM manipulations rely
   // on their elm reference.
   function cloneVNode (vnode) {
     var cloned = new VNode(
       vnode.tag,
       vnode.data,
       // #7975
       // clone children array to avoid mutating original in case of cloning
       // a child.
       vnode.children && vnode.children.slice(),
       vnode.text,
       vnode.elm,
       vnode.context,
       vnode.componentOptions,
       vnode.asyncFactory
     );
     cloned.ns = vnode.ns;
     cloned.isStatic = vnode.isStatic;
     cloned.key = vnode.key;
     cloned.isComment = vnode.isComment;
     cloned.fnContext = vnode.fnContext;
     cloned.fnOptions = vnode.fnOptions;
     cloned.fnScopeId = vnode.fnScopeId;
     cloned.asyncMeta = vnode.asyncMeta;
     cloned.isCloned = true;
     return cloned
   }
   
   /*
    * not type checking this file because flow doesn't play well with
    * dynamically accessing methods on Array prototype
    */
   
   var arrayProto = Array.prototype;
   var arrayMethods = Object.create(arrayProto);
   
   var methodsToPatch = [
     'push',
     'pop',
     'shift',
     'unshift',
     'splice',
     'sort',
     'reverse'
   ];
   
   /**
    * Intercept mutating methods and emit events
    */
   methodsToPatch.forEach(function (method) {
     // cache original method
     var original = arrayProto[method];
     def(arrayMethods, method, function mutator () {
       var args = [], len = arguments.length;
       while ( len-- ) args[ len ] = arguments[ len ];
   
       var result = original.apply(this, args);
       var ob = this.__ob__;
       var inserted;
       switch (method) {
         case 'push':
         case 'unshift':
           inserted = args;
           break
         case 'splice':
           inserted = args.slice(2);
           break
       }
       if (inserted) { ob.observeArray(inserted); }
       // notify change
       ob.dep.notify();
       return result
     });
   });
   
   /*  */
   
   var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
   
   /**
    * In some cases we may want to disable observation inside a component's
    * update computation.
    */
   var shouldObserve = true;
   
   function toggleObserving (value) {
     shouldObserve = value;
   }
   
   /**
    * Observer class that is attached to each observed
    * object. Once attached, the observer converts the target
    * object's property keys into getter/setters that
    * collect dependencies and dispatch updates.
    */
   var Observer = function Observer (value) {
     this.value = value;
     this.dep = new Dep();
     this.vmCount = 0;
     def(value, '__ob__', this);
     if (Array.isArray(value)) {
       if (hasProto) {
         protoAugment(value, arrayMethods);
       } else {
         copyAugment(value, arrayMethods, arrayKeys);
       }
       this.observeArray(value);
     } else {
       this.walk(value);
     }
   };
   
   /**
    * Walk through all properties and convert them into
    * getter/setters. This method should only be called when
    * value type is Object.
    */
   Observer.prototype.walk = function walk (obj) {
     var keys = Object.keys(obj);
     for (var i = 0; i < keys.length; i++) {
       defineReactive$$1(obj, keys[i]);
     }
   };
   
   /**
    * Observe a list of Array items.
    */
   Observer.prototype.observeArray = function observeArray (items) {
     for (var i = 0, l = items.length; i < l; i++) {
       observe(items[i]);
     }
   };
   
   // helpers
   
   /**
    * Augment a target Object or Array by intercepting
    * the prototype chain using __proto__
    */
   function protoAugment (target, src) {
     /* eslint-disable no-proto */
     target.__proto__ = src;
     /* eslint-enable no-proto */
   }
   
   /**
    * Augment a target Object or Array by defining
    * hidden properties.
    */
   /* istanbul ignore next */
   function copyAugment (target, src, keys) {
     for (var i = 0, l = keys.length; i < l; i++) {
       var key = keys[i];
       def(target, key, src[key]);
     }
   }
   
   /**
    * Attempt to create an observer instance for a value,
    * returns the new observer if successfully observed,
    * or the existing observer if the value already has one.
    */
   function observe (value, asRootData) {
     if (!isObject(value) || value instanceof VNode) {
       return
     }
     var ob;
     if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
       ob = value.__ob__;
     } else if (
       shouldObserve &&
       !isServerRendering() &&
       (Array.isArray(value) || isPlainObject(value)) &&
       Object.isExtensible(value) &&
       !value._isVue
     ) {
       ob = new Observer(value);
     }
     if (asRootData && ob) {
       ob.vmCount++;
     }
     return ob
   }
   
   /**
    * Define a reactive property on an Object.
    */
   function defineReactive$$1 (
     obj,
     key,
     val,
     customSetter,
     shallow
   ) {
     var dep = new Dep();
   
     var property = Object.getOwnPropertyDescriptor(obj, key);
     if (property && property.configurable === false) {
       return
     }
   
     // cater for pre-defined getter/setters
     var getter = property && property.get;
     var setter = property && property.set;
     if ((!getter || setter) && arguments.length === 2) {
       val = obj[key];
     }
   
     var childOb = !shallow && observe(val);
     Object.defineProperty(obj, key, {
       enumerable: true,
       configurable: true,
       get: function reactiveGetter () {
         var value = getter ? getter.call(obj) : val;
         if (Dep.target) {
           dep.depend();
           if (childOb) {
             childOb.dep.depend();
             if (Array.isArray(value)) {
               dependArray(value);
             }
           }
         }
         return value
       },
       set: function reactiveSetter (newVal) {
         var value = getter ? getter.call(obj) : val;
         /* eslint-disable no-self-compare */
         if (newVal === value || (newVal !== newVal && value !== value)) {
           return
         }
         /* eslint-enable no-self-compare */
         if (false) {}
         // #7981: for accessor properties without setter
         if (getter && !setter) { return }
         if (setter) {
           setter.call(obj, newVal);
         } else {
           val = newVal;
         }
         childOb = !shallow && observe(newVal);
         dep.notify();
       }
     });
   }
   
   /**
    * Set a property on an object. Adds the new property and
    * triggers change notification if the property doesn't
    * already exist.
    */
   function set (target, key, val) {
     if (false
     ) {}
     if (Array.isArray(target) && isValidArrayIndex(key)) {
       target.length = Math.max(target.length, key);
       target.splice(key, 1, val);
       return val
     }
     if (key in target && !(key in Object.prototype)) {
       target[key] = val;
       return val
     }
     var ob = (target).__ob__;
     if (target._isVue || (ob && ob.vmCount)) {
        false && 0;
       return val
     }
     if (!ob) {
       target[key] = val;
       return val
     }
     defineReactive$$1(ob.value, key, val);
     ob.dep.notify();
     return val
   }
   
   /**
    * Delete a property and trigger change if necessary.
    */
   function del (target, key) {
     if (false
     ) {}
     if (Array.isArray(target) && isValidArrayIndex(key)) {
       target.splice(key, 1);
       return
     }
     var ob = (target).__ob__;
     if (target._isVue || (ob && ob.vmCount)) {
        false && 0;
       return
     }
     if (!hasOwn(target, key)) {
       return
     }
     delete target[key];
     if (!ob) {
       return
     }
     ob.dep.notify();
   }
   
   /**
    * Collect dependencies on array elements when the array is touched, since
    * we cannot intercept array element access like property getters.
    */
   function dependArray (value) {
     for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
       e = value[i];
       e && e.__ob__ && e.__ob__.dep.depend();
       if (Array.isArray(e)) {
         dependArray(e);
       }
     }
   }
   
   /*  */
   
   /**
    * Option overwriting strategies are functions that handle
    * how to merge a parent option value and a child option
    * value into the final value.
    */
   var strats = config.optionMergeStrategies;
   
   /**
    * Options with restrictions
    */
   if (false) {}
   
   /**
    * Helper that recursively merges two data objects together.
    */
   function mergeData (to, from) {
     if (!from) { return to }
     var key, toVal, fromVal;
   
     var keys = hasSymbol
       ? Reflect.ownKeys(from)
       : Object.keys(from);
   
     for (var i = 0; i < keys.length; i++) {
       key = keys[i];
       // in case the object is already observed...
       if (key === '__ob__') { continue }
       toVal = to[key];
       fromVal = from[key];
       if (!hasOwn(to, key)) {
         set(to, key, fromVal);
       } else if (
         toVal !== fromVal &&
         isPlainObject(toVal) &&
         isPlainObject(fromVal)
       ) {
         mergeData(toVal, fromVal);
       }
     }
     return to
   }
   
   /**
    * Data
    */
   function mergeDataOrFn (
     parentVal,
     childVal,
     vm
   ) {
     if (!vm) {
       // in a Vue.extend merge, both should be functions
       if (!childVal) {
         return parentVal
       }
       if (!parentVal) {
         return childVal
       }
       // when parentVal & childVal are both present,
       // we need to return a function that returns the
       // merged result of both functions... no need to
       // check if parentVal is a function here because
       // it has to be a function to pass previous merges.
       return function mergedDataFn () {
         return mergeData(
           typeof childVal === 'function' ? childVal.call(this, this) : childVal,
           typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
         )
       }
     } else {
       return function mergedInstanceDataFn () {
         // instance merge
         var instanceData = typeof childVal === 'function'
           ? childVal.call(vm, vm)
           : childVal;
         var defaultData = typeof parentVal === 'function'
           ? parentVal.call(vm, vm)
           : parentVal;
         if (instanceData) {
           return mergeData(instanceData, defaultData)
         } else {
           return defaultData
         }
       }
     }
   }
   
   strats.data = function (
     parentVal,
     childVal,
     vm
   ) {
     if (!vm) {
       if (childVal && typeof childVal !== 'function') {
          false && 0;
   
         return parentVal
       }
       return mergeDataOrFn(parentVal, childVal)
     }
   
     return mergeDataOrFn(parentVal, childVal, vm)
   };
   
   /**
    * Hooks and props are merged as arrays.
    */
   function mergeHook (
     parentVal,
     childVal
   ) {
     var res = childVal
       ? parentVal
         ? parentVal.concat(childVal)
         : Array.isArray(childVal)
           ? childVal
           : [childVal]
       : parentVal;
     return res
       ? dedupeHooks(res)
       : res
   }
   
   function dedupeHooks (hooks) {
     var res = [];
     for (var i = 0; i < hooks.length; i++) {
       if (res.indexOf(hooks[i]) === -1) {
         res.push(hooks[i]);
       }
     }
     return res
   }
   
   LIFECYCLE_HOOKS.forEach(function (hook) {
     strats[hook] = mergeHook;
   });
   
   /**
    * Assets
    *
    * When a vm is present (instance creation), we need to do
    * a three-way merge between constructor options, instance
    * options and parent options.
    */
   function mergeAssets (
     parentVal,
     childVal,
     vm,
     key
   ) {
     var res = Object.create(parentVal || null);
     if (childVal) {
        false && 0;
       return extend(res, childVal)
     } else {
       return res
     }
   }
   
   ASSET_TYPES.forEach(function (type) {
     strats[type + 's'] = mergeAssets;
   });
   
   /**
    * Watchers.
    *
    * Watchers hashes should not overwrite one
    * another, so we merge them as arrays.
    */
   strats.watch = function (
     parentVal,
     childVal,
     vm,
     key
   ) {
     // work around Firefox's Object.prototype.watch...
     if (parentVal === nativeWatch) { parentVal = undefined; }
     if (childVal === nativeWatch) { childVal = undefined; }
     /* istanbul ignore if */
     if (!childVal) { return Object.create(parentVal || null) }
     if (false) {}
     if (!parentVal) { return childVal }
     var ret = {};
     extend(ret, parentVal);
     for (var key$1 in childVal) {
       var parent = ret[key$1];
       var child = childVal[key$1];
       if (parent && !Array.isArray(parent)) {
         parent = [parent];
       }
       ret[key$1] = parent
         ? parent.concat(child)
         : Array.isArray(child) ? child : [child];
     }
     return ret
   };
   
   /**
    * Other object hashes.
    */
   strats.props =
   strats.methods =
   strats.inject =
   strats.computed = function (
     parentVal,
     childVal,
     vm,
     key
   ) {
     if (childVal && "production" !== 'production') {}
     if (!parentVal) { return childVal }
     var ret = Object.create(null);
     extend(ret, parentVal);
     if (childVal) { extend(ret, childVal); }
     return ret
   };
   strats.provide = mergeDataOrFn;
   
   /**
    * Default strategy.
    */
   var defaultStrat = function (parentVal, childVal) {
     return childVal === undefined
       ? parentVal
       : childVal
   };
   
   /**
    * Validate component names
    */
   function checkComponents (options) {
     for (var key in options.components) {
       validateComponentName(key);
     }
   }
   
   function validateComponentName (name) {
     if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
       warn(
         'Invalid component name: "' + name + '". Component names ' +
         'should conform to valid custom element name in html5 specification.'
       );
     }
     if (isBuiltInTag(name) || config.isReservedTag(name)) {
       warn(
         'Do not use built-in or reserved HTML elements as component ' +
         'id: ' + name
       );
     }
   }
   
   /**
    * Ensure all props option syntax are normalized into the
    * Object-based format.
    */
   function normalizeProps (options, vm) {
     var props = options.props;
     if (!props) { return }
     var res = {};
     var i, val, name;
     if (Array.isArray(props)) {
       i = props.length;
       while (i--) {
         val = props[i];
         if (typeof val === 'string') {
           name = camelize(val);
           res[name] = { type: null };
         } else if (false) {}
       }
     } else if (isPlainObject(props)) {
       for (var key in props) {
         val = props[key];
         name = camelize(key);
         res[name] = isPlainObject(val)
           ? val
           : { type: val };
       }
     } else if (false) {}
     options.props = res;
   }
   
   /**
    * Normalize all injections into Object-based format
    */
   function normalizeInject (options, vm) {
     var inject = options.inject;
     if (!inject) { return }
     var normalized = options.inject = {};
     if (Array.isArray(inject)) {
       for (var i = 0; i < inject.length; i++) {
         normalized[inject[i]] = { from: inject[i] };
       }
     } else if (isPlainObject(inject)) {
       for (var key in inject) {
         var val = inject[key];
         normalized[key] = isPlainObject(val)
           ? extend({ from: key }, val)
           : { from: val };
       }
     } else if (false) {}
   }
   
   /**
    * Normalize raw function directives into object format.
    */
   function normalizeDirectives (options) {
     var dirs = options.directives;
     if (dirs) {
       for (var key in dirs) {
         var def$$1 = dirs[key];
         if (typeof def$$1 === 'function') {
           dirs[key] = { bind: def$$1, update: def$$1 };
         }
       }
     }
   }
   
   function assertObjectType (name, value, vm) {
     if (!isPlainObject(value)) {
       warn(
         "Invalid value for option \"" + name + "\": expected an Object, " +
         "but got " + (toRawType(value)) + ".",
         vm
       );
     }
   }
   
   /**
    * Merge two option objects into a new one.
    * Core utility used in both instantiation and inheritance.
    */
   function mergeOptions (
     parent,
     child,
     vm
   ) {
     if (false) {}
   
     if (typeof child === 'function') {
       child = child.options;
     }
   
     normalizeProps(child, vm);
     normalizeInject(child, vm);
     normalizeDirectives(child);
   
     // Apply extends and mixins on the child options,
     // but only if it is a raw options object that isn't
     // the result of another mergeOptions call.
     // Only merged options has the _base property.
     if (!child._base) {
       if (child.extends) {
         parent = mergeOptions(parent, child.extends, vm);
       }
       if (child.mixins) {
         for (var i = 0, l = child.mixins.length; i < l; i++) {
           parent = mergeOptions(parent, child.mixins[i], vm);
         }
       }
     }
   
     var options = {};
     var key;
     for (key in parent) {
       mergeField(key);
     }
     for (key in child) {
       if (!hasOwn(parent, key)) {
         mergeField(key);
       }
     }
     function mergeField (key) {
       var strat = strats[key] || defaultStrat;
       options[key] = strat(parent[key], child[key], vm, key);
     }
     return options
   }
   
   /**
    * Resolve an asset.
    * This function is used because child instances need access
    * to assets defined in its ancestor chain.
    */
   function resolveAsset (
     options,
     type,
     id,
     warnMissing
   ) {
     /* istanbul ignore if */
     if (typeof id !== 'string') {
       return
     }
     var assets = options[type];
     // check local registration variations first
     if (hasOwn(assets, id)) { return assets[id] }
     var camelizedId = camelize(id);
     if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
     var PascalCaseId = capitalize(camelizedId);
     if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
     // fallback to prototype chain
     var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
     if (false) {}
     return res
   }
   
   /*  */
   
   
   
   function validateProp (
     key,
     propOptions,
     propsData,
     vm
   ) {
     var prop = propOptions[key];
     var absent = !hasOwn(propsData, key);
     var value = propsData[key];
     // boolean casting
     var booleanIndex = getTypeIndex(Boolean, prop.type);
     if (booleanIndex > -1) {
       if (absent && !hasOwn(prop, 'default')) {
         value = false;
       } else if (value === '' || value === hyphenate(key)) {
         // only cast empty string / same name to boolean if
         // boolean has higher priority
         var stringIndex = getTypeIndex(String, prop.type);
         if (stringIndex < 0 || booleanIndex < stringIndex) {
           value = true;
         }
       }
     }
     // check default value
     if (value === undefined) {
       value = getPropDefaultValue(vm, prop, key);
       // since the default value is a fresh copy,
       // make sure to observe it.
       var prevShouldObserve = shouldObserve;
       toggleObserving(true);
       observe(value);
       toggleObserving(prevShouldObserve);
     }
     if (
       false
     ) {}
     return value
   }
   
   /**
    * Get the default value of a prop.
    */
   function getPropDefaultValue (vm, prop, key) {
     // no default, return undefined
     if (!hasOwn(prop, 'default')) {
       return undefined
     }
     var def = prop.default;
     // warn against non-factory defaults for Object & Array
     if (false) {}
     // the raw prop value was also undefined from previous render,
     // return previous default value to avoid unnecessary watcher trigger
     if (vm && vm.$options.propsData &&
       vm.$options.propsData[key] === undefined &&
       vm._props[key] !== undefined
     ) {
       return vm._props[key]
     }
     // call factory function for non-Function types
     // a value is Function if its prototype is function even across different execution context
     return typeof def === 'function' && getType(prop.type) !== 'Function'
       ? def.call(vm)
       : def
   }
   
   /**
    * Assert whether a prop is valid.
    */
   function assertProp (
     prop,
     name,
     value,
     vm,
     absent
   ) {
     if (prop.required && absent) {
       warn(
         'Missing required prop: "' + name + '"',
         vm
       );
       return
     }
     if (value == null && !prop.required) {
       return
     }
     var type = prop.type;
     var valid = !type || type === true;
     var expectedTypes = [];
     if (type) {
       if (!Array.isArray(type)) {
         type = [type];
       }
       for (var i = 0; i < type.length && !valid; i++) {
         var assertedType = assertType(value, type[i], vm);
         expectedTypes.push(assertedType.expectedType || '');
         valid = assertedType.valid;
       }
     }
   
     var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
     if (!valid && haveExpectedTypes) {
       warn(
         getInvalidTypeMessage(name, value, expectedTypes),
         vm
       );
       return
     }
     var validator = prop.validator;
     if (validator) {
       if (!validator(value)) {
         warn(
           'Invalid prop: custom validator check failed for prop "' + name + '".',
           vm
         );
       }
     }
   }
   
   var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
   
   function assertType (value, type, vm) {
     var valid;
     var expectedType = getType(type);
     if (simpleCheckRE.test(expectedType)) {
       var t = typeof value;
       valid = t === expectedType.toLowerCase();
       // for primitive wrapper objects
       if (!valid && t === 'object') {
         valid = value instanceof type;
       }
     } else if (expectedType === 'Object') {
       valid = isPlainObject(value);
     } else if (expectedType === 'Array') {
       valid = Array.isArray(value);
     } else {
       try {
         valid = value instanceof type;
       } catch (e) {
         warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
         valid = false;
       }
     }
     return {
       valid: valid,
       expectedType: expectedType
     }
   }
   
   var functionTypeCheckRE = /^\s*function (\w+)/;
   
   /**
    * Use function string name to check built-in types,
    * because a simple equality check will fail when running
    * across different vms / iframes.
    */
   function getType (fn) {
     var match = fn && fn.toString().match(functionTypeCheckRE);
     return match ? match[1] : ''
   }
   
   function isSameType (a, b) {
     return getType(a) === getType(b)
   }
   
   function getTypeIndex (type, expectedTypes) {
     if (!Array.isArray(expectedTypes)) {
       return isSameType(expectedTypes, type) ? 0 : -1
     }
     for (var i = 0, len = expectedTypes.length; i < len; i++) {
       if (isSameType(expectedTypes[i], type)) {
         return i
       }
     }
     return -1
   }
   
   function getInvalidTypeMessage (name, value, expectedTypes) {
     var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
       " Expected " + (expectedTypes.map(capitalize).join(', '));
     var expectedType = expectedTypes[0];
     var receivedType = toRawType(value);
     // check if we need to specify expected value
     if (
       expectedTypes.length === 1 &&
       isExplicable(expectedType) &&
       isExplicable(typeof value) &&
       !isBoolean(expectedType, receivedType)
     ) {
       message += " with value " + (styleValue(value, expectedType));
     }
     message += ", got " + receivedType + " ";
     // check if we need to specify received value
     if (isExplicable(receivedType)) {
       message += "with value " + (styleValue(value, receivedType)) + ".";
     }
     return message
   }
   
   function styleValue (value, type) {
     if (type === 'String') {
       return ("\"" + value + "\"")
     } else if (type === 'Number') {
       return ("" + (Number(value)))
     } else {
       return ("" + value)
     }
   }
   
   var EXPLICABLE_TYPES = (/* unused pure expression or super */ null && (['string', 'number', 'boolean']));
   function isExplicable (value) {
     return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
   }
   
   function isBoolean () {
     var args = [], len = arguments.length;
     while ( len-- ) args[ len ] = arguments[ len ];
   
     return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
   }
   
   /*  */
   
   function handleError (err, vm, info) {
     // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
     // See: https://github.com/vuejs/vuex/issues/1505
     pushTarget();
     try {
       if (vm) {
         var cur = vm;
         while ((cur = cur.$parent)) {
           var hooks = cur.$options.errorCaptured;
           if (hooks) {
             for (var i = 0; i < hooks.length; i++) {
               try {
                 var capture = hooks[i].call(cur, err, vm, info) === false;
                 if (capture) { return }
               } catch (e) {
                 globalHandleError(e, cur, 'errorCaptured hook');
               }
             }
           }
         }
       }
       globalHandleError(err, vm, info);
     } finally {
       popTarget();
     }
   }
   
   function invokeWithErrorHandling (
     handler,
     context,
     args,
     vm,
     info
   ) {
     var res;
     try {
       res = args ? handler.apply(context, args) : handler.call(context);
       if (res && !res._isVue && isPromise(res) && !res._handled) {
         res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
         // issue #9511
         // avoid catch triggering multiple times when nested calls
         res._handled = true;
       }
     } catch (e) {
       handleError(e, vm, info);
     }
     return res
   }
   
   function globalHandleError (err, vm, info) {
     if (config.errorHandler) {
       try {
         return config.errorHandler.call(null, err, vm, info)
       } catch (e) {
         // if the user intentionally throws the original error in the handler,
         // do not log it twice
         if (e !== err) {
           logError(e, null, 'config.errorHandler');
         }
       }
     }
     logError(err, vm, info);
   }
   
   function logError (err, vm, info) {
     if (false) {}
     /* istanbul ignore else */
     if ((inBrowser || inWeex) && typeof console !== 'undefined') {
       console.error(err);
     } else {
       throw err
     }
   }
   
   /*  */
   
   var isUsingMicroTask = false;
   
   var callbacks = [];
   var pending = false;
   
   function flushCallbacks () {
     pending = false;
     var copies = callbacks.slice(0);
     callbacks.length = 0;
     for (var i = 0; i < copies.length; i++) {
       copies[i]();
     }
   }
   
   // Here we have async deferring wrappers using microtasks.
   // In 2.5 we used (macro) tasks (in combination with microtasks).
   // However, it has subtle problems when state is changed right before repaint
   // (e.g. #6813, out-in transitions).
   // Also, using (macro) tasks in event handler would cause some weird behaviors
   // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
   // So we now use microtasks everywhere, again.
   // A major drawback of this tradeoff is that there are some scenarios
   // where microtasks have too high a priority and fire in between supposedly
   // sequential events (e.g. #4521, #6690, which have workarounds)
   // or even between bubbling of the same event (#6566).
   var timerFunc;
   
   // The nextTick behavior leverages the microtask queue, which can be accessed
   // via either native Promise.then or MutationObserver.
   // MutationObserver has wider support, however it is seriously bugged in
   // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
   // completely stops working after triggering a few times... so, if native
   // Promise is available, we will use it:
   /* istanbul ignore next, $flow-disable-line */
   if (typeof Promise !== 'undefined' && isNative(Promise)) {
     var p = Promise.resolve();
     timerFunc = function () {
       p.then(flushCallbacks);
       // In problematic UIWebViews, Promise.then doesn't completely break, but
       // it can get stuck in a weird state where callbacks are pushed into the
       // microtask queue but the queue isn't being flushed, until the browser
       // needs to do some other work, e.g. handle a timer. Therefore we can
       // "force" the microtask queue to be flushed by adding an empty timer.
       if (isIOS) { setTimeout(noop); }
     };
     isUsingMicroTask = true;
   } else if (!isIE && typeof MutationObserver !== 'undefined' && (
     isNative(MutationObserver) ||
     // PhantomJS and iOS 7.x
     MutationObserver.toString() === '[object MutationObserverConstructor]'
   )) {
     // Use MutationObserver where native Promise is not available,
     // e.g. PhantomJS, iOS7, Android 4.4
     // (#6466 MutationObserver is unreliable in IE11)
     var counter = 1;
     var observer = new MutationObserver(flushCallbacks);
     var textNode = document.createTextNode(String(counter));
     observer.observe(textNode, {
       characterData: true
     });
     timerFunc = function () {
       counter = (counter + 1) % 2;
       textNode.data = String(counter);
     };
     isUsingMicroTask = true;
   } else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
     // Fallback to setImmediate.
     // Technically it leverages the (macro) task queue,
     // but it is still a better choice than setTimeout.
     timerFunc = function () {
       setImmediate(flushCallbacks);
     };
   } else {
     // Fallback to setTimeout.
     timerFunc = function () {
       setTimeout(flushCallbacks, 0);
     };
   }
   
   function nextTick (cb, ctx) {
     var _resolve;
     callbacks.push(function () {
       if (cb) {
         try {
           cb.call(ctx);
         } catch (e) {
           handleError(e, ctx, 'nextTick');
         }
       } else if (_resolve) {
         _resolve(ctx);
       }
     });
     if (!pending) {
       pending = true;
       timerFunc();
     }
     // $flow-disable-line
     if (!cb && typeof Promise !== 'undefined') {
       return new Promise(function (resolve) {
         _resolve = resolve;
       })
     }
   }
   
   /*  */
   
   var mark;
   var measure;
   
   if (false) { var perf; }
   
   /* not type checking this file because flow doesn't play well with Proxy */
   
   var initProxy;
   
   if (false) { var getHandler, hasHandler, isBuiltInModifier, hasProxy, warnReservedPrefix, warnNonPresent, allowedGlobals; }
   
   /*  */
   
   var seenObjects = new _Set();
   
   /**
    * Recursively traverse an object to evoke all converted
    * getters, so that every nested property inside the object
    * is collected as a "deep" dependency.
    */
   function traverse (val) {
     _traverse(val, seenObjects);
     seenObjects.clear();
   }
   
   function _traverse (val, seen) {
     var i, keys;
     var isA = Array.isArray(val);
     if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
       return
     }
     if (val.__ob__) {
       var depId = val.__ob__.dep.id;
       if (seen.has(depId)) {
         return
       }
       seen.add(depId);
     }
     if (isA) {
       i = val.length;
       while (i--) { _traverse(val[i], seen); }
     } else {
       keys = Object.keys(val);
       i = keys.length;
       while (i--) { _traverse(val[keys[i]], seen); }
     }
   }
   
   /*  */
   
   var normalizeEvent = cached(function (name) {
     var passive = name.charAt(0) === '&';
     name = passive ? name.slice(1) : name;
     var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
     name = once$$1 ? name.slice(1) : name;
     var capture = name.charAt(0) === '!';
     name = capture ? name.slice(1) : name;
     return {
       name: name,
       once: once$$1,
       capture: capture,
       passive: passive
     }
   });
   
   function createFnInvoker (fns, vm) {
     function invoker () {
       var arguments$1 = arguments;
   
       var fns = invoker.fns;
       if (Array.isArray(fns)) {
         var cloned = fns.slice();
         for (var i = 0; i < cloned.length; i++) {
           invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
         }
       } else {
         // return handler return value for single handlers
         return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
       }
     }
     invoker.fns = fns;
     return invoker
   }
   
   function updateListeners (
     on,
     oldOn,
     add,
     remove$$1,
     createOnceHandler,
     vm
   ) {
     var name, def$$1, cur, old, event;
     for (name in on) {
       def$$1 = cur = on[name];
       old = oldOn[name];
       event = normalizeEvent(name);
       if (isUndef(cur)) {
          false && 0;
       } else if (isUndef(old)) {
         if (isUndef(cur.fns)) {
           cur = on[name] = createFnInvoker(cur, vm);
         }
         if (isTrue(event.once)) {
           cur = on[name] = createOnceHandler(event.name, cur, event.capture);
         }
         add(event.name, cur, event.capture, event.passive, event.params);
       } else if (cur !== old) {
         old.fns = cur;
         on[name] = old;
       }
     }
     for (name in oldOn) {
       if (isUndef(on[name])) {
         event = normalizeEvent(name);
         remove$$1(event.name, oldOn[name], event.capture);
       }
     }
   }
   
   /*  */
   
   function mergeVNodeHook (def, hookKey, hook) {
     if (def instanceof VNode) {
       def = def.data.hook || (def.data.hook = {});
     }
     var invoker;
     var oldHook = def[hookKey];
   
     function wrappedHook () {
       hook.apply(this, arguments);
       // important: remove merged hook to ensure it's called only once
       // and prevent memory leak
       remove(invoker.fns, wrappedHook);
     }
   
     if (isUndef(oldHook)) {
       // no existing hook
       invoker = createFnInvoker([wrappedHook]);
     } else {
       /* istanbul ignore if */
       if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
         // already a merged invoker
         invoker = oldHook;
         invoker.fns.push(wrappedHook);
       } else {
         // existing plain hook
         invoker = createFnInvoker([oldHook, wrappedHook]);
       }
     }
   
     invoker.merged = true;
     def[hookKey] = invoker;
   }
   
   /*  */
   
   function extractPropsFromVNodeData (
     data,
     Ctor,
     tag
   ) {
     // we are only extracting raw values here.
     // validation and default values are handled in the child
     // component itself.
     var propOptions = Ctor.options.props;
     if (isUndef(propOptions)) {
       return
     }
     var res = {};
     var attrs = data.attrs;
     var props = data.props;
     if (isDef(attrs) || isDef(props)) {
       for (var key in propOptions) {
         var altKey = hyphenate(key);
         if (false) { var keyInLowerCase; }
         checkProp(res, props, key, altKey, true) ||
         checkProp(res, attrs, key, altKey, false);
       }
     }
     return res
   }
   
   function checkProp (
     res,
     hash,
     key,
     altKey,
     preserve
   ) {
     if (isDef(hash)) {
       if (hasOwn(hash, key)) {
         res[key] = hash[key];
         if (!preserve) {
           delete hash[key];
         }
         return true
       } else if (hasOwn(hash, altKey)) {
         res[key] = hash[altKey];
         if (!preserve) {
           delete hash[altKey];
         }
         return true
       }
     }
     return false
   }
   
   /*  */
   
   // The template compiler attempts to minimize the need for normalization by
   // statically analyzing the template at compile time.
   //
   // For plain HTML markup, normalization can be completely skipped because the
   // generated render function is guaranteed to return Array<VNode>. There are
   // two cases where extra normalization is needed:
   
   // 1. When the children contains components - because a functional component
   // may return an Array instead of a single root. In this case, just a simple
   // normalization is needed - if any child is an Array, we flatten the whole
   // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
   // because functional components already normalize their own children.
   function simpleNormalizeChildren (children) {
     for (var i = 0; i < children.length; i++) {
       if (Array.isArray(children[i])) {
         return Array.prototype.concat.apply([], children)
       }
     }
     return children
   }
   
   // 2. When the children contains constructs that always generated nested Arrays,
   // e.g. <template>, <slot>, v-for, or when the children is provided by user
   // with hand-written render functions / JSX. In such cases a full normalization
   // is needed to cater to all possible types of children values.
   function normalizeChildren (children) {
     return isPrimitive(children)
       ? [createTextVNode(children)]
       : Array.isArray(children)
         ? normalizeArrayChildren(children)
         : undefined
   }
   
   function isTextNode (node) {
     return isDef(node) && isDef(node.text) && isFalse(node.isComment)
   }
   
   function normalizeArrayChildren (children, nestedIndex) {
     var res = [];
     var i, c, lastIndex, last;
     for (i = 0; i < children.length; i++) {
       c = children[i];
       if (isUndef(c) || typeof c === 'boolean') { continue }
       lastIndex = res.length - 1;
       last = res[lastIndex];
       //  nested
       if (Array.isArray(c)) {
         if (c.length > 0) {
           c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
           // merge adjacent text nodes
           if (isTextNode(c[0]) && isTextNode(last)) {
             res[lastIndex] = createTextVNode(last.text + (c[0]).text);
             c.shift();
           }
           res.push.apply(res, c);
         }
       } else if (isPrimitive(c)) {
         if (isTextNode(last)) {
           // merge adjacent text nodes
           // this is necessary for SSR hydration because text nodes are
           // essentially merged when rendered to HTML strings
           res[lastIndex] = createTextVNode(last.text + c);
         } else if (c !== '') {
           // convert primitive to vnode
           res.push(createTextVNode(c));
         }
       } else {
         if (isTextNode(c) && isTextNode(last)) {
           // merge adjacent text nodes
           res[lastIndex] = createTextVNode(last.text + c.text);
         } else {
           // default key for nested array children (likely generated by v-for)
           if (isTrue(children._isVList) &&
             isDef(c.tag) &&
             isUndef(c.key) &&
             isDef(nestedIndex)) {
             c.key = "__vlist" + nestedIndex + "_" + i + "__";
           }
           res.push(c);
         }
       }
     }
     return res
   }
   
   /*  */
   
   function initProvide (vm) {
     var provide = vm.$options.provide;
     if (provide) {
       vm._provided = typeof provide === 'function'
         ? provide.call(vm)
         : provide;
     }
   }
   
   function initInjections (vm) {
     var result = resolveInject(vm.$options.inject, vm);
     if (result) {
       toggleObserving(false);
       Object.keys(result).forEach(function (key) {
         /* istanbul ignore else */
         if (false) {} else {
           defineReactive$$1(vm, key, result[key]);
         }
       });
       toggleObserving(true);
     }
   }
   
   function resolveInject (inject, vm) {
     if (inject) {
       // inject is :any because flow is not smart enough to figure out cached
       var result = Object.create(null);
       var keys = hasSymbol
         ? Reflect.ownKeys(inject)
         : Object.keys(inject);
   
       for (var i = 0; i < keys.length; i++) {
         var key = keys[i];
         // #6574 in case the inject object is observed...
         if (key === '__ob__') { continue }
         var provideKey = inject[key].from;
         var source = vm;
         while (source) {
           if (source._provided && hasOwn(source._provided, provideKey)) {
             result[key] = source._provided[provideKey];
             break
           }
           source = source.$parent;
         }
         if (!source) {
           if ('default' in inject[key]) {
             var provideDefault = inject[key].default;
             result[key] = typeof provideDefault === 'function'
               ? provideDefault.call(vm)
               : provideDefault;
           } else if (false) {}
         }
       }
       return result
     }
   }
   
   /*  */
   
   
   
   /**
    * Runtime helper for resolving raw children VNodes into a slot object.
    */
   function resolveSlots (
     children,
     context
   ) {
     if (!children || !children.length) {
       return {}
     }
     var slots = {};
     for (var i = 0, l = children.length; i < l; i++) {
       var child = children[i];
       var data = child.data;
       // remove slot attribute if the node is resolved as a Vue slot node
       if (data && data.attrs && data.attrs.slot) {
         delete data.attrs.slot;
       }
       // named slots should only be respected if the vnode was rendered in the
       // same context.
       if ((child.context === context || child.fnContext === context) &&
         data && data.slot != null
       ) {
         var name = data.slot;
         var slot = (slots[name] || (slots[name] = []));
         if (child.tag === 'template') {
           slot.push.apply(slot, child.children || []);
         } else {
           slot.push(child);
         }
       } else {
         (slots.default || (slots.default = [])).push(child);
       }
     }
     // ignore slots that contains only whitespace
     for (var name$1 in slots) {
       if (slots[name$1].every(isWhitespace)) {
         delete slots[name$1];
       }
     }
     return slots
   }
   
   function isWhitespace (node) {
     return (node.isComment && !node.asyncFactory) || node.text === ' '
   }
   
   /*  */
   
   function isAsyncPlaceholder (node) {
     return node.isComment && node.asyncFactory
   }
   
   /*  */
   
   function normalizeScopedSlots (
     slots,
     normalSlots,
     prevSlots
   ) {
     var res;
     var hasNormalSlots = Object.keys(normalSlots).length > 0;
     var isStable = slots ? !!slots.$stable : !hasNormalSlots;
     var key = slots && slots.$key;
     if (!slots) {
       res = {};
     } else if (slots._normalized) {
       // fast path 1: child component re-render only, parent did not change
       return slots._normalized
     } else if (
       isStable &&
       prevSlots &&
       prevSlots !== emptyObject &&
       key === prevSlots.$key &&
       !hasNormalSlots &&
       !prevSlots.$hasNormal
     ) {
       // fast path 2: stable scoped slots w/ no normal slots to proxy,
       // only need to normalize once
       return prevSlots
     } else {
       res = {};
       for (var key$1 in slots) {
         if (slots[key$1] && key$1[0] !== '$') {
           res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
         }
       }
     }
     // expose normal slots on scopedSlots
     for (var key$2 in normalSlots) {
       if (!(key$2 in res)) {
         res[key$2] = proxyNormalSlot(normalSlots, key$2);
       }
     }
     // avoriaz seems to mock a non-extensible $scopedSlots object
     // and when that is passed down this would cause an error
     if (slots && Object.isExtensible(slots)) {
       (slots)._normalized = res;
     }
     def(res, '$stable', isStable);
     def(res, '$key', key);
     def(res, '$hasNormal', hasNormalSlots);
     return res
   }
   
   function normalizeScopedSlot(normalSlots, key, fn) {
     var normalized = function () {
       var res = arguments.length ? fn.apply(null, arguments) : fn({});
       res = res && typeof res === 'object' && !Array.isArray(res)
         ? [res] // single vnode
         : normalizeChildren(res);
       var vnode = res && res[0];
       return res && (
         !vnode ||
         (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
       ) ? undefined
         : res
     };
     // this is a slot using the new v-slot syntax without scope. although it is
     // compiled as a scoped slot, render fn users would expect it to be present
     // on this.$slots because the usage is semantically a normal slot.
     if (fn.proxy) {
       Object.defineProperty(normalSlots, key, {
         get: normalized,
         enumerable: true,
         configurable: true
       });
     }
     return normalized
   }
   
   function proxyNormalSlot(slots, key) {
     return function () { return slots[key]; }
   }
   
   /*  */
   
   /**
    * Runtime helper for rendering v-for lists.
    */
   function renderList (
     val,
     render
   ) {
     var ret, i, l, keys, key;
     if (Array.isArray(val) || typeof val === 'string') {
       ret = new Array(val.length);
       for (i = 0, l = val.length; i < l; i++) {
         ret[i] = render(val[i], i);
       }
     } else if (typeof val === 'number') {
       ret = new Array(val);
       for (i = 0; i < val; i++) {
         ret[i] = render(i + 1, i);
       }
     } else if (isObject(val)) {
       if (hasSymbol && val[Symbol.iterator]) {
         ret = [];
         var iterator = val[Symbol.iterator]();
         var result = iterator.next();
         while (!result.done) {
           ret.push(render(result.value, ret.length));
           result = iterator.next();
         }
       } else {
         keys = Object.keys(val);
         ret = new Array(keys.length);
         for (i = 0, l = keys.length; i < l; i++) {
           key = keys[i];
           ret[i] = render(val[key], key, i);
         }
       }
     }
     if (!isDef(ret)) {
       ret = [];
     }
     (ret)._isVList = true;
     return ret
   }
   
   /*  */
   
   /**
    * Runtime helper for rendering <slot>
    */
   function renderSlot (
     name,
     fallbackRender,
     props,
     bindObject
   ) {
     var scopedSlotFn = this.$scopedSlots[name];
     var nodes;
     if (scopedSlotFn) {
       // scoped slot
       props = props || {};
       if (bindObject) {
         if (false) {}
         props = extend(extend({}, bindObject), props);
       }
       nodes =
         scopedSlotFn(props) ||
         (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
     } else {
       nodes =
         this.$slots[name] ||
         (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
     }
   
     var target = props && props.slot;
     if (target) {
       return this.$createElement('template', { slot: target }, nodes)
     } else {
       return nodes
     }
   }
   
   /*  */
   
   /**
    * Runtime helper for resolving filters
    */
   function resolveFilter (id) {
     return resolveAsset(this.$options, 'filters', id, true) || identity
   }
   
   /*  */
   
   function isKeyNotMatch (expect, actual) {
     if (Array.isArray(expect)) {
       return expect.indexOf(actual) === -1
     } else {
       return expect !== actual
     }
   }
   
   /**
    * Runtime helper for checking keyCodes from config.
    * exposed as Vue.prototype._k
    * passing in eventKeyName as last argument separately for backwards compat
    */
   function checkKeyCodes (
     eventKeyCode,
     key,
     builtInKeyCode,
     eventKeyName,
     builtInKeyName
   ) {
     var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
     if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
       return isKeyNotMatch(builtInKeyName, eventKeyName)
     } else if (mappedKeyCode) {
       return isKeyNotMatch(mappedKeyCode, eventKeyCode)
     } else if (eventKeyName) {
       return hyphenate(eventKeyName) !== key
     }
     return eventKeyCode === undefined
   }
   
   /*  */
   
   /**
    * Runtime helper for merging v-bind="object" into a VNode's data.
    */
   function bindObjectProps (
     data,
     tag,
     value,
     asProp,
     isSync
   ) {
     if (value) {
       if (!isObject(value)) {
          false && 0;
       } else {
         if (Array.isArray(value)) {
           value = toObject(value);
         }
         var hash;
         var loop = function ( key ) {
           if (
             key === 'class' ||
             key === 'style' ||
             isReservedAttribute(key)
           ) {
             hash = data;
           } else {
             var type = data.attrs && data.attrs.type;
             hash = asProp || config.mustUseProp(tag, type, key)
               ? data.domProps || (data.domProps = {})
               : data.attrs || (data.attrs = {});
           }
           var camelizedKey = camelize(key);
           var hyphenatedKey = hyphenate(key);
           if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
             hash[key] = value[key];
   
             if (isSync) {
               var on = data.on || (data.on = {});
               on[("update:" + key)] = function ($event) {
                 value[key] = $event;
               };
             }
           }
         };
   
         for (var key in value) loop( key );
       }
     }
     return data
   }
   
   /*  */
   
   /**
    * Runtime helper for rendering static trees.
    */
   function renderStatic (
     index,
     isInFor
   ) {
     var cached = this._staticTrees || (this._staticTrees = []);
     var tree = cached[index];
     // if has already-rendered static tree and not inside v-for,
     // we can reuse the same tree.
     if (tree && !isInFor) {
       return tree
     }
     // otherwise, render a fresh tree.
     tree = cached[index] = this.$options.staticRenderFns[index].call(
       this._renderProxy,
       null,
       this // for render fns generated for functional component templates
     );
     markStatic(tree, ("__static__" + index), false);
     return tree
   }
   
   /**
    * Runtime helper for v-once.
    * Effectively it means marking the node as static with a unique key.
    */
   function markOnce (
     tree,
     index,
     key
   ) {
     markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
     return tree
   }
   
   function markStatic (
     tree,
     key,
     isOnce
   ) {
     if (Array.isArray(tree)) {
       for (var i = 0; i < tree.length; i++) {
         if (tree[i] && typeof tree[i] !== 'string') {
           markStaticNode(tree[i], (key + "_" + i), isOnce);
         }
       }
     } else {
       markStaticNode(tree, key, isOnce);
     }
   }
   
   function markStaticNode (node, key, isOnce) {
     node.isStatic = true;
     node.key = key;
     node.isOnce = isOnce;
   }
   
   /*  */
   
   function bindObjectListeners (data, value) {
     if (value) {
       if (!isPlainObject(value)) {
          false && 0;
       } else {
         var on = data.on = data.on ? extend({}, data.on) : {};
         for (var key in value) {
           var existing = on[key];
           var ours = value[key];
           on[key] = existing ? [].concat(existing, ours) : ours;
         }
       }
     }
     return data
   }
   
   /*  */
   
   function resolveScopedSlots (
     fns, // see flow/vnode
     res,
     // the following are added in 2.6
     hasDynamicKeys,
     contentHashKey
   ) {
     res = res || { $stable: !hasDynamicKeys };
     for (var i = 0; i < fns.length; i++) {
       var slot = fns[i];
       if (Array.isArray(slot)) {
         resolveScopedSlots(slot, res, hasDynamicKeys);
       } else if (slot) {
         // marker for reverse proxying v-slot without scope on this.$slots
         if (slot.proxy) {
           slot.fn.proxy = true;
         }
         res[slot.key] = slot.fn;
       }
     }
     if (contentHashKey) {
       (res).$key = contentHashKey;
     }
     return res
   }
   
   /*  */
   
   function bindDynamicKeys (baseObj, values) {
     for (var i = 0; i < values.length; i += 2) {
       var key = values[i];
       if (typeof key === 'string' && key) {
         baseObj[values[i]] = values[i + 1];
       } else if (false) {}
     }
     return baseObj
   }
   
   // helper to dynamically append modifier runtime markers to event names.
   // ensure only append when value is already string, otherwise it will be cast
   // to string and cause the type check to miss.
   function prependModifier (value, symbol) {
     return typeof value === 'string' ? symbol + value : value
   }
   
   /*  */
   
   function installRenderHelpers (target) {
     target._o = markOnce;
     target._n = toNumber;
     target._s = vue_esm_toString;
     target._l = renderList;
     target._t = renderSlot;
     target._q = looseEqual;
     target._i = looseIndexOf;
     target._m = renderStatic;
     target._f = resolveFilter;
     target._k = checkKeyCodes;
     target._b = bindObjectProps;
     target._v = createTextVNode;
     target._e = createEmptyVNode;
     target._u = resolveScopedSlots;
     target._g = bindObjectListeners;
     target._d = bindDynamicKeys;
     target._p = prependModifier;
   }
   
   /*  */
   
   function FunctionalRenderContext (
     data,
     props,
     children,
     parent,
     Ctor
   ) {
     var this$1 = this;
   
     var options = Ctor.options;
     // ensure the createElement function in functional components
     // gets a unique context - this is necessary for correct named slot check
     var contextVm;
     if (hasOwn(parent, '_uid')) {
       contextVm = Object.create(parent);
       // $flow-disable-line
       contextVm._original = parent;
     } else {
       // the context vm passed in is a functional context as well.
       // in this case we want to make sure we are able to get a hold to the
       // real context instance.
       contextVm = parent;
       // $flow-disable-line
       parent = parent._original;
     }
     var isCompiled = isTrue(options._compiled);
     var needNormalization = !isCompiled;
   
     this.data = data;
     this.props = props;
     this.children = children;
     this.parent = parent;
     this.listeners = data.on || emptyObject;
     this.injections = resolveInject(options.inject, parent);
     this.slots = function () {
       if (!this$1.$slots) {
         normalizeScopedSlots(
           data.scopedSlots,
           this$1.$slots = resolveSlots(children, parent)
         );
       }
       return this$1.$slots
     };
   
     Object.defineProperty(this, 'scopedSlots', ({
       enumerable: true,
       get: function get () {
         return normalizeScopedSlots(data.scopedSlots, this.slots())
       }
     }));
   
     // support for compiled functional template
     if (isCompiled) {
       // exposing $options for renderStatic()
       this.$options = options;
       // pre-resolve slots for renderSlot()
       this.$slots = this.slots();
       this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
     }
   
     if (options._scopeId) {
       this._c = function (a, b, c, d) {
         var vnode = createElement(contextVm, a, b, c, d, needNormalization);
         if (vnode && !Array.isArray(vnode)) {
           vnode.fnScopeId = options._scopeId;
           vnode.fnContext = parent;
         }
         return vnode
       };
     } else {
       this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
     }
   }
   
   installRenderHelpers(FunctionalRenderContext.prototype);
   
   function createFunctionalComponent (
     Ctor,
     propsData,
     data,
     contextVm,
     children
   ) {
     var options = Ctor.options;
     var props = {};
     var propOptions = options.props;
     if (isDef(propOptions)) {
       for (var key in propOptions) {
         props[key] = validateProp(key, propOptions, propsData || emptyObject);
       }
     } else {
       if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
       if (isDef(data.props)) { mergeProps(props, data.props); }
     }
   
     var renderContext = new FunctionalRenderContext(
       data,
       props,
       children,
       contextVm,
       Ctor
     );
   
     var vnode = options.render.call(null, renderContext._c, renderContext);
   
     if (vnode instanceof VNode) {
       return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
     } else if (Array.isArray(vnode)) {
       var vnodes = normalizeChildren(vnode) || [];
       var res = new Array(vnodes.length);
       for (var i = 0; i < vnodes.length; i++) {
         res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
       }
       return res
     }
   }
   
   function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
     // #7817 clone node before setting fnContext, otherwise if the node is reused
     // (e.g. it was from a cached normal slot) the fnContext causes named slots
     // that should not be matched to match.
     var clone = cloneVNode(vnode);
     clone.fnContext = contextVm;
     clone.fnOptions = options;
     if (false) {}
     if (data.slot) {
       (clone.data || (clone.data = {})).slot = data.slot;
     }
     return clone
   }
   
   function mergeProps (to, from) {
     for (var key in from) {
       to[camelize(key)] = from[key];
     }
   }
   
   /*  */
   
   /*  */
   
   /*  */
   
   /*  */
   
   // inline hooks to be invoked on component VNodes during patch
   var componentVNodeHooks = {
     init: function init (vnode, hydrating) {
       if (
         vnode.componentInstance &&
         !vnode.componentInstance._isDestroyed &&
         vnode.data.keepAlive
       ) {
         // kept-alive components, treat as a patch
         var mountedNode = vnode; // work around flow
         componentVNodeHooks.prepatch(mountedNode, mountedNode);
       } else {
         var child = vnode.componentInstance = createComponentInstanceForVnode(
           vnode,
           activeInstance
         );
         child.$mount(hydrating ? vnode.elm : undefined, hydrating);
       }
     },
   
     prepatch: function prepatch (oldVnode, vnode) {
       var options = vnode.componentOptions;
       var child = vnode.componentInstance = oldVnode.componentInstance;
       updateChildComponent(
         child,
         options.propsData, // updated props
         options.listeners, // updated listeners
         vnode, // new parent vnode
         options.children // new children
       );
     },
   
     insert: function insert (vnode) {
       var context = vnode.context;
       var componentInstance = vnode.componentInstance;
       if (!componentInstance._isMounted) {
         componentInstance._isMounted = true;
         callHook(componentInstance, 'mounted');
       }
       if (vnode.data.keepAlive) {
         if (context._isMounted) {
           // vue-router#1212
           // During updates, a kept-alive component's child components may
           // change, so directly walking the tree here may call activated hooks
           // on incorrect children. Instead we push them into a queue which will
           // be processed after the whole patch process ended.
           queueActivatedComponent(componentInstance);
         } else {
           activateChildComponent(componentInstance, true /* direct */);
         }
       }
     },
   
     destroy: function destroy (vnode) {
       var componentInstance = vnode.componentInstance;
       if (!componentInstance._isDestroyed) {
         if (!vnode.data.keepAlive) {
           componentInstance.$destroy();
         } else {
           deactivateChildComponent(componentInstance, true /* direct */);
         }
       }
     }
   };
   
   var hooksToMerge = Object.keys(componentVNodeHooks);
   
   function createComponent (
     Ctor,
     data,
     context,
     children,
     tag
   ) {
     if (isUndef(Ctor)) {
       return
     }
   
     var baseCtor = context.$options._base;
   
     // plain options object: turn it into a constructor
     if (isObject(Ctor)) {
       Ctor = baseCtor.extend(Ctor);
     }
   
     // if at this stage it's not a constructor or an async component factory,
     // reject.
     if (typeof Ctor !== 'function') {
       if (false) {}
       return
     }
   
     // async component
     var asyncFactory;
     if (isUndef(Ctor.cid)) {
       asyncFactory = Ctor;
       Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
       if (Ctor === undefined) {
         // return a placeholder node for async component, which is rendered
         // as a comment node but preserves all the raw information for the node.
         // the information will be used for async server-rendering and hydration.
         return createAsyncPlaceholder(
           asyncFactory,
           data,
           context,
           children,
           tag
         )
       }
     }
   
     data = data || {};
   
     // resolve constructor options in case global mixins are applied after
     // component constructor creation
     resolveConstructorOptions(Ctor);
   
     // transform component v-model data into props & events
     if (isDef(data.model)) {
       transformModel(Ctor.options, data);
     }
   
     // extract props
     var propsData = extractPropsFromVNodeData(data, Ctor, tag);
   
     // functional component
     if (isTrue(Ctor.options.functional)) {
       return createFunctionalComponent(Ctor, propsData, data, context, children)
     }
   
     // extract listeners, since these needs to be treated as
     // child component listeners instead of DOM listeners
     var listeners = data.on;
     // replace with listeners with .native modifier
     // so it gets processed during parent component patch.
     data.on = data.nativeOn;
   
     if (isTrue(Ctor.options.abstract)) {
       // abstract components do not keep anything
       // other than props & listeners & slot
   
       // work around flow
       var slot = data.slot;
       data = {};
       if (slot) {
         data.slot = slot;
       }
     }
   
     // install component management hooks onto the placeholder node
     installComponentHooks(data);
   
     // return a placeholder vnode
     var name = Ctor.options.name || tag;
     var vnode = new VNode(
       ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
       data, undefined, undefined, undefined, context,
       { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
       asyncFactory
     );
   
     return vnode
   }
   
   function createComponentInstanceForVnode (
     // we know it's MountedComponentVNode but flow doesn't
     vnode,
     // activeInstance in lifecycle state
     parent
   ) {
     var options = {
       _isComponent: true,
       _parentVnode: vnode,
       parent: parent
     };
     // check inline-template render functions
     var inlineTemplate = vnode.data.inlineTemplate;
     if (isDef(inlineTemplate)) {
       options.render = inlineTemplate.render;
       options.staticRenderFns = inlineTemplate.staticRenderFns;
     }
     return new vnode.componentOptions.Ctor(options)
   }
   
   function installComponentHooks (data) {
     var hooks = data.hook || (data.hook = {});
     for (var i = 0; i < hooksToMerge.length; i++) {
       var key = hooksToMerge[i];
       var existing = hooks[key];
       var toMerge = componentVNodeHooks[key];
       if (existing !== toMerge && !(existing && existing._merged)) {
         hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
       }
     }
   }
   
   function mergeHook$1 (f1, f2) {
     var merged = function (a, b) {
       // flow complains about extra args which is why we use any
       f1(a, b);
       f2(a, b);
     };
     merged._merged = true;
     return merged
   }
   
   // transform component v-model info (value and callback) into
   // prop and event handler respectively.
   function transformModel (options, data) {
     var prop = (options.model && options.model.prop) || 'value';
     var event = (options.model && options.model.event) || 'input'
     ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
     var on = data.on || (data.on = {});
     var existing = on[event];
     var callback = data.model.callback;
     if (isDef(existing)) {
       if (
         Array.isArray(existing)
           ? existing.indexOf(callback) === -1
           : existing !== callback
       ) {
         on[event] = [callback].concat(existing);
       }
     } else {
       on[event] = callback;
     }
   }
   
   /*  */
   
   var SIMPLE_NORMALIZE = 1;
   var ALWAYS_NORMALIZE = 2;
   
   // wrapper function for providing a more flexible interface
   // without getting yelled at by flow
   function createElement (
     context,
     tag,
     data,
     children,
     normalizationType,
     alwaysNormalize
   ) {
     if (Array.isArray(data) || isPrimitive(data)) {
       normalizationType = children;
       children = data;
       data = undefined;
     }
     if (isTrue(alwaysNormalize)) {
       normalizationType = ALWAYS_NORMALIZE;
     }
     return _createElement(context, tag, data, children, normalizationType)
   }
   
   function _createElement (
     context,
     tag,
     data,
     children,
     normalizationType
   ) {
     if (isDef(data) && isDef((data).__ob__)) {
        false && 0;
       return createEmptyVNode()
     }
     // object syntax in v-bind
     if (isDef(data) && isDef(data.is)) {
       tag = data.is;
     }
     if (!tag) {
       // in case of component :is set to falsy value
       return createEmptyVNode()
     }
     // warn against non-primitive key
     if (false
     ) {}
     // support single function children as default scoped slot
     if (Array.isArray(children) &&
       typeof children[0] === 'function'
     ) {
       data = data || {};
       data.scopedSlots = { default: children[0] };
       children.length = 0;
     }
     if (normalizationType === ALWAYS_NORMALIZE) {
       children = normalizeChildren(children);
     } else if (normalizationType === SIMPLE_NORMALIZE) {
       children = simpleNormalizeChildren(children);
     }
     var vnode, ns;
     if (typeof tag === 'string') {
       var Ctor;
       ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
       if (config.isReservedTag(tag)) {
         // platform built-in elements
         if (false) {}
         vnode = new VNode(
           config.parsePlatformTagName(tag), data, children,
           undefined, undefined, context
         );
       } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
         // component
         vnode = createComponent(Ctor, data, context, children, tag);
       } else {
         // unknown or unlisted namespaced elements
         // check at runtime because it may get assigned a namespace when its
         // parent normalizes children
         vnode = new VNode(
           tag, data, children,
           undefined, undefined, context
         );
       }
     } else {
       // direct component options / constructor
       vnode = createComponent(tag, data, context, children);
     }
     if (Array.isArray(vnode)) {
       return vnode
     } else if (isDef(vnode)) {
       if (isDef(ns)) { applyNS(vnode, ns); }
       if (isDef(data)) { registerDeepBindings(data); }
       return vnode
     } else {
       return createEmptyVNode()
     }
   }
   
   function applyNS (vnode, ns, force) {
     vnode.ns = ns;
     if (vnode.tag === 'foreignObject') {
       // use default namespace inside foreignObject
       ns = undefined;
       force = true;
     }
     if (isDef(vnode.children)) {
       for (var i = 0, l = vnode.children.length; i < l; i++) {
         var child = vnode.children[i];
         if (isDef(child.tag) && (
           isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
           applyNS(child, ns, force);
         }
       }
     }
   }
   
   // ref #5318
   // necessary to ensure parent re-render when deep bindings like :style and
   // :class are used on slot nodes
   function registerDeepBindings (data) {
     if (isObject(data.style)) {
       traverse(data.style);
     }
     if (isObject(data.class)) {
       traverse(data.class);
     }
   }
   
   /*  */
   
   function initRender (vm) {
     vm._vnode = null; // the root of the child tree
     vm._staticTrees = null; // v-once cached trees
     var options = vm.$options;
     var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
     var renderContext = parentVnode && parentVnode.context;
     vm.$slots = resolveSlots(options._renderChildren, renderContext);
     vm.$scopedSlots = emptyObject;
     // bind the createElement fn to this instance
     // so that we get proper render context inside it.
     // args order: tag, data, children, normalizationType, alwaysNormalize
     // internal version is used by render functions compiled from templates
     vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
     // normalization is always applied for the public version, used in
     // user-written render functions.
     vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
   
     // $attrs & $listeners are exposed for easier HOC creation.
     // they need to be reactive so that HOCs using them are always updated
     var parentData = parentVnode && parentVnode.data;
   
     /* istanbul ignore else */
     if (false) {} else {
       defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
       defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
     }
   }
   
   var currentRenderingInstance = null;
   
   function renderMixin (Vue) {
     // install runtime convenience helpers
     installRenderHelpers(Vue.prototype);
   
     Vue.prototype.$nextTick = function (fn) {
       return nextTick(fn, this)
     };
   
     Vue.prototype._render = function () {
       var vm = this;
       var ref = vm.$options;
       var render = ref.render;
       var _parentVnode = ref._parentVnode;
   
       if (_parentVnode) {
         vm.$scopedSlots = normalizeScopedSlots(
           _parentVnode.data.scopedSlots,
           vm.$slots,
           vm.$scopedSlots
         );
       }
   
       // set parent vnode. this allows render functions to have access
       // to the data on the placeholder node.
       vm.$vnode = _parentVnode;
       // render self
       var vnode;
       try {
         // There's no need to maintain a stack because all render fns are called
         // separately from one another. Nested component's render fns are called
         // when parent component is patched.
         currentRenderingInstance = vm;
         vnode = render.call(vm._renderProxy, vm.$createElement);
       } catch (e) {
         handleError(e, vm, "render");
         // return error render result,
         // or previous vnode to prevent render error causing blank component
         /* istanbul ignore else */
         if (false) {} else {
           vnode = vm._vnode;
         }
       } finally {
         currentRenderingInstance = null;
       }
       // if the returned array contains only a single node, allow it
       if (Array.isArray(vnode) && vnode.length === 1) {
         vnode = vnode[0];
       }
       // return empty vnode in case the render function errored out
       if (!(vnode instanceof VNode)) {
         if (false) {}
         vnode = createEmptyVNode();
       }
       // set parent
       vnode.parent = _parentVnode;
       return vnode
     };
   }
   
   /*  */
   
   function ensureCtor (comp, base) {
     if (
       comp.__esModule ||
       (hasSymbol && comp[Symbol.toStringTag] === 'Module')
     ) {
       comp = comp.default;
     }
     return isObject(comp)
       ? base.extend(comp)
       : comp
   }
   
   function createAsyncPlaceholder (
     factory,
     data,
     context,
     children,
     tag
   ) {
     var node = createEmptyVNode();
     node.asyncFactory = factory;
     node.asyncMeta = { data: data, context: context, children: children, tag: tag };
     return node
   }
   
   function resolveAsyncComponent (
     factory,
     baseCtor
   ) {
     if (isTrue(factory.error) && isDef(factory.errorComp)) {
       return factory.errorComp
     }
   
     if (isDef(factory.resolved)) {
       return factory.resolved
     }
   
     var owner = currentRenderingInstance;
     if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
       // already pending
       factory.owners.push(owner);
     }
   
     if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
       return factory.loadingComp
     }
   
     if (owner && !isDef(factory.owners)) {
       var owners = factory.owners = [owner];
       var sync = true;
       var timerLoading = null;
       var timerTimeout = null
   
       ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });
   
       var forceRender = function (renderCompleted) {
         for (var i = 0, l = owners.length; i < l; i++) {
           (owners[i]).$forceUpdate();
         }
   
         if (renderCompleted) {
           owners.length = 0;
           if (timerLoading !== null) {
             clearTimeout(timerLoading);
             timerLoading = null;
           }
           if (timerTimeout !== null) {
             clearTimeout(timerTimeout);
             timerTimeout = null;
           }
         }
       };
   
       var resolve = once(function (res) {
         // cache resolved
         factory.resolved = ensureCtor(res, baseCtor);
         // invoke callbacks only if this is not a synchronous resolve
         // (async resolves are shimmed as synchronous during SSR)
         if (!sync) {
           forceRender(true);
         } else {
           owners.length = 0;
         }
       });
   
       var reject = once(function (reason) {
          false && 0;
         if (isDef(factory.errorComp)) {
           factory.error = true;
           forceRender(true);
         }
       });
   
       var res = factory(resolve, reject);
   
       if (isObject(res)) {
         if (isPromise(res)) {
           // () => Promise
           if (isUndef(factory.resolved)) {
             res.then(resolve, reject);
           }
         } else if (isPromise(res.component)) {
           res.component.then(resolve, reject);
   
           if (isDef(res.error)) {
             factory.errorComp = ensureCtor(res.error, baseCtor);
           }
   
           if (isDef(res.loading)) {
             factory.loadingComp = ensureCtor(res.loading, baseCtor);
             if (res.delay === 0) {
               factory.loading = true;
             } else {
               timerLoading = setTimeout(function () {
                 timerLoading = null;
                 if (isUndef(factory.resolved) && isUndef(factory.error)) {
                   factory.loading = true;
                   forceRender(false);
                 }
               }, res.delay || 200);
             }
           }
   
           if (isDef(res.timeout)) {
             timerTimeout = setTimeout(function () {
               timerTimeout = null;
               if (isUndef(factory.resolved)) {
                 reject(
                    false
                     ? (0)
                     : null
                 );
               }
             }, res.timeout);
           }
         }
       }
   
       sync = false;
       // return in case resolved synchronously
       return factory.loading
         ? factory.loadingComp
         : factory.resolved
     }
   }
   
   /*  */
   
   function getFirstComponentChild (children) {
     if (Array.isArray(children)) {
       for (var i = 0; i < children.length; i++) {
         var c = children[i];
         if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
           return c
         }
       }
     }
   }
   
   /*  */
   
   /*  */
   
   function initEvents (vm) {
     vm._events = Object.create(null);
     vm._hasHookEvent = false;
     // init parent attached events
     var listeners = vm.$options._parentListeners;
     if (listeners) {
       updateComponentListeners(vm, listeners);
     }
   }
   
   var target;
   
   function add (event, fn) {
     target.$on(event, fn);
   }
   
   function remove$1 (event, fn) {
     target.$off(event, fn);
   }
   
   function createOnceHandler (event, fn) {
     var _target = target;
     return function onceHandler () {
       var res = fn.apply(null, arguments);
       if (res !== null) {
         _target.$off(event, onceHandler);
       }
     }
   }
   
   function updateComponentListeners (
     vm,
     listeners,
     oldListeners
   ) {
     target = vm;
     updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
     target = undefined;
   }
   
   function eventsMixin (Vue) {
     var hookRE = /^hook:/;
     Vue.prototype.$on = function (event, fn) {
       var vm = this;
       if (Array.isArray(event)) {
         for (var i = 0, l = event.length; i < l; i++) {
           vm.$on(event[i], fn);
         }
       } else {
         (vm._events[event] || (vm._events[event] = [])).push(fn);
         // optimize hook:event cost by using a boolean flag marked at registration
         // instead of a hash lookup
         if (hookRE.test(event)) {
           vm._hasHookEvent = true;
         }
       }
       return vm
     };
   
     Vue.prototype.$once = function (event, fn) {
       var vm = this;
       function on () {
         vm.$off(event, on);
         fn.apply(vm, arguments);
       }
       on.fn = fn;
       vm.$on(event, on);
       return vm
     };
   
     Vue.prototype.$off = function (event, fn) {
       var vm = this;
       // all
       if (!arguments.length) {
         vm._events = Object.create(null);
         return vm
       }
       // array of events
       if (Array.isArray(event)) {
         for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
           vm.$off(event[i$1], fn);
         }
         return vm
       }
       // specific event
       var cbs = vm._events[event];
       if (!cbs) {
         return vm
       }
       if (!fn) {
         vm._events[event] = null;
         return vm
       }
       // specific handler
       var cb;
       var i = cbs.length;
       while (i--) {
         cb = cbs[i];
         if (cb === fn || cb.fn === fn) {
           cbs.splice(i, 1);
           break
         }
       }
       return vm
     };
   
     Vue.prototype.$emit = function (event) {
       var vm = this;
       if (false) { var lowerCaseEvent; }
       var cbs = vm._events[event];
       if (cbs) {
         cbs = cbs.length > 1 ? toArray(cbs) : cbs;
         var args = toArray(arguments, 1);
         var info = "event handler for \"" + event + "\"";
         for (var i = 0, l = cbs.length; i < l; i++) {
           invokeWithErrorHandling(cbs[i], vm, args, vm, info);
         }
       }
       return vm
     };
   }
   
   /*  */
   
   var activeInstance = null;
   var isUpdatingChildComponent = false;
   
   function setActiveInstance(vm) {
     var prevActiveInstance = activeInstance;
     activeInstance = vm;
     return function () {
       activeInstance = prevActiveInstance;
     }
   }
   
   function initLifecycle (vm) {
     var options = vm.$options;
   
     // locate first non-abstract parent
     var parent = options.parent;
     if (parent && !options.abstract) {
       while (parent.$options.abstract && parent.$parent) {
         parent = parent.$parent;
       }
       parent.$children.push(vm);
     }
   
     vm.$parent = parent;
     vm.$root = parent ? parent.$root : vm;
   
     vm.$children = [];
     vm.$refs = {};
   
     vm._watcher = null;
     vm._inactive = null;
     vm._directInactive = false;
     vm._isMounted = false;
     vm._isDestroyed = false;
     vm._isBeingDestroyed = false;
   }
   
   function lifecycleMixin (Vue) {
     Vue.prototype._update = function (vnode, hydrating) {
       var vm = this;
       var prevEl = vm.$el;
       var prevVnode = vm._vnode;
       var restoreActiveInstance = setActiveInstance(vm);
       vm._vnode = vnode;
       // Vue.prototype.__patch__ is injected in entry points
       // based on the rendering backend used.
       if (!prevVnode) {
         // initial render
         vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
       } else {
         // updates
         vm.$el = vm.__patch__(prevVnode, vnode);
       }
       restoreActiveInstance();
       // update __vue__ reference
       if (prevEl) {
         prevEl.__vue__ = null;
       }
       if (vm.$el) {
         vm.$el.__vue__ = vm;
       }
       // if parent is an HOC, update its $el as well
       if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
         vm.$parent.$el = vm.$el;
       }
       // updated hook is called by the scheduler to ensure that children are
       // updated in a parent's updated hook.
     };
   
     Vue.prototype.$forceUpdate = function () {
       var vm = this;
       if (vm._watcher) {
         vm._watcher.update();
       }
     };
   
     Vue.prototype.$destroy = function () {
       var vm = this;
       if (vm._isBeingDestroyed) {
         return
       }
       callHook(vm, 'beforeDestroy');
       vm._isBeingDestroyed = true;
       // remove self from parent
       var parent = vm.$parent;
       if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
         remove(parent.$children, vm);
       }
       // teardown watchers
       if (vm._watcher) {
         vm._watcher.teardown();
       }
       var i = vm._watchers.length;
       while (i--) {
         vm._watchers[i].teardown();
       }
       // remove reference from data ob
       // frozen object may not have observer.
       if (vm._data.__ob__) {
         vm._data.__ob__.vmCount--;
       }
       // call the last hook...
       vm._isDestroyed = true;
       // invoke destroy hooks on current rendered tree
       vm.__patch__(vm._vnode, null);
       // fire destroyed hook
       callHook(vm, 'destroyed');
       // turn off all instance listeners.
       vm.$off();
       // remove __vue__ reference
       if (vm.$el) {
         vm.$el.__vue__ = null;
       }
       // release circular reference (#6759)
       if (vm.$vnode) {
         vm.$vnode.parent = null;
       }
     };
   }
   
   function mountComponent (
     vm,
     el,
     hydrating
   ) {
     vm.$el = el;
     if (!vm.$options.render) {
       vm.$options.render = createEmptyVNode;
       if (false) {}
     }
     callHook(vm, 'beforeMount');
   
     var updateComponent;
     /* istanbul ignore if */
     if (false) {} else {
       updateComponent = function () {
         vm._update(vm._render(), hydrating);
       };
     }
   
     // we set this to vm._watcher inside the watcher's constructor
     // since the watcher's initial patch may call $forceUpdate (e.g. inside child
     // component's mounted hook), which relies on vm._watcher being already defined
     new Watcher(vm, updateComponent, noop, {
       before: function before () {
         if (vm._isMounted && !vm._isDestroyed) {
           callHook(vm, 'beforeUpdate');
         }
       }
     }, true /* isRenderWatcher */);
     hydrating = false;
   
     // manually mounted instance, call mounted on self
     // mounted is called for render-created child components in its inserted hook
     if (vm.$vnode == null) {
       vm._isMounted = true;
       callHook(vm, 'mounted');
     }
     return vm
   }
   
   function updateChildComponent (
     vm,
     propsData,
     listeners,
     parentVnode,
     renderChildren
   ) {
     if (false) {}
   
     // determine whether component has slot children
     // we need to do this before overwriting $options._renderChildren.
   
     // check if there are dynamic scopedSlots (hand-written or compiled but with
     // dynamic slot names). Static scoped slots compiled from template has the
     // "$stable" marker.
     var newScopedSlots = parentVnode.data.scopedSlots;
     var oldScopedSlots = vm.$scopedSlots;
     var hasDynamicScopedSlot = !!(
       (newScopedSlots && !newScopedSlots.$stable) ||
       (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
       (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
       (!newScopedSlots && vm.$scopedSlots.$key)
     );
   
     // Any static slot children from the parent may have changed during parent's
     // update. Dynamic scoped slots may also have changed. In such cases, a forced
     // update is necessary to ensure correctness.
     var needsForceUpdate = !!(
       renderChildren ||               // has new static slots
       vm.$options._renderChildren ||  // has old static slots
       hasDynamicScopedSlot
     );
   
     vm.$options._parentVnode = parentVnode;
     vm.$vnode = parentVnode; // update vm's placeholder node without re-render
   
     if (vm._vnode) { // update child tree's parent
       vm._vnode.parent = parentVnode;
     }
     vm.$options._renderChildren = renderChildren;
   
     // update $attrs and $listeners hash
     // these are also reactive so they may trigger child update if the child
     // used them during render
     vm.$attrs = parentVnode.data.attrs || emptyObject;
     vm.$listeners = listeners || emptyObject;
   
     // update props
     if (propsData && vm.$options.props) {
       toggleObserving(false);
       var props = vm._props;
       var propKeys = vm.$options._propKeys || [];
       for (var i = 0; i < propKeys.length; i++) {
         var key = propKeys[i];
         var propOptions = vm.$options.props; // wtf flow?
         props[key] = validateProp(key, propOptions, propsData, vm);
       }
       toggleObserving(true);
       // keep a copy of raw propsData
       vm.$options.propsData = propsData;
     }
   
     // update listeners
     listeners = listeners || emptyObject;
     var oldListeners = vm.$options._parentListeners;
     vm.$options._parentListeners = listeners;
     updateComponentListeners(vm, listeners, oldListeners);
   
     // resolve slots + force update if has children
     if (needsForceUpdate) {
       vm.$slots = resolveSlots(renderChildren, parentVnode.context);
       vm.$forceUpdate();
     }
   
     if (false) {}
   }
   
   function isInInactiveTree (vm) {
     while (vm && (vm = vm.$parent)) {
       if (vm._inactive) { return true }
     }
     return false
   }
   
   function activateChildComponent (vm, direct) {
     if (direct) {
       vm._directInactive = false;
       if (isInInactiveTree(vm)) {
         return
       }
     } else if (vm._directInactive) {
       return
     }
     if (vm._inactive || vm._inactive === null) {
       vm._inactive = false;
       for (var i = 0; i < vm.$children.length; i++) {
         activateChildComponent(vm.$children[i]);
       }
       callHook(vm, 'activated');
     }
   }
   
   function deactivateChildComponent (vm, direct) {
     if (direct) {
       vm._directInactive = true;
       if (isInInactiveTree(vm)) {
         return
       }
     }
     if (!vm._inactive) {
       vm._inactive = true;
       for (var i = 0; i < vm.$children.length; i++) {
         deactivateChildComponent(vm.$children[i]);
       }
       callHook(vm, 'deactivated');
     }
   }
   
   function callHook (vm, hook) {
     // #7573 disable dep collection when invoking lifecycle hooks
     pushTarget();
     var handlers = vm.$options[hook];
     var info = hook + " hook";
     if (handlers) {
       for (var i = 0, j = handlers.length; i < j; i++) {
         invokeWithErrorHandling(handlers[i], vm, null, vm, info);
       }
     }
     if (vm._hasHookEvent) {
       vm.$emit('hook:' + hook);
     }
     popTarget();
   }
   
   /*  */
   
   var MAX_UPDATE_COUNT = 100;
   
   var queue = [];
   var activatedChildren = [];
   var has = {};
   var circular = {};
   var waiting = false;
   var flushing = false;
   var index = 0;
   
   /**
    * Reset the scheduler's state.
    */
   function resetSchedulerState () {
     index = queue.length = activatedChildren.length = 0;
     has = {};
     if (false) {}
     waiting = flushing = false;
   }
   
   // Async edge case #6566 requires saving the timestamp when event listeners are
   // attached. However, calling performance.now() has a perf overhead especially
   // if the page has thousands of event listeners. Instead, we take a timestamp
   // every time the scheduler flushes and use that for all event listeners
   // attached during that flush.
   var currentFlushTimestamp = 0;
   
   // Async edge case fix requires storing an event listener's attach timestamp.
   var getNow = Date.now;
   
   // Determine what event timestamp the browser is using. Annoyingly, the
   // timestamp can either be hi-res (relative to page load) or low-res
   // (relative to UNIX epoch), so in order to compare time we have to use the
   // same timestamp type when saving the flush timestamp.
   // All IE versions use low-res event timestamps, and have problematic clock
   // implementations (#9632)
   if (inBrowser && !isIE) {
     var vue_esm_performance = window.performance;
     if (
       vue_esm_performance &&
       typeof vue_esm_performance.now === 'function' &&
       getNow() > document.createEvent('Event').timeStamp
     ) {
       // if the event timestamp, although evaluated AFTER the Date.now(), is
       // smaller than it, it means the event is using a hi-res timestamp,
       // and we need to use the hi-res version for event listener timestamps as
       // well.
       getNow = function () { return vue_esm_performance.now(); };
     }
   }
   
   /**
    * Flush both queues and run the watchers.
    */
   function flushSchedulerQueue () {
     currentFlushTimestamp = getNow();
     flushing = true;
     var watcher, id;
   
     // Sort queue before flush.
     // This ensures that:
     // 1. Components are updated from parent to child. (because parent is always
     //    created before the child)
     // 2. A component's user watchers are run before its render watcher (because
     //    user watchers are created before the render watcher)
     // 3. If a component is destroyed during a parent component's watcher run,
     //    its watchers can be skipped.
     queue.sort(function (a, b) { return a.id - b.id; });
   
     // do not cache length because more watchers might be pushed
     // as we run existing watchers
     for (index = 0; index < queue.length; index++) {
       watcher = queue[index];
       if (watcher.before) {
         watcher.before();
       }
       id = watcher.id;
       has[id] = null;
       watcher.run();
       // in dev build, check and stop circular updates.
       if (false) {}
     }
   
     // keep copies of post queues before resetting state
     var activatedQueue = activatedChildren.slice();
     var updatedQueue = queue.slice();
   
     resetSchedulerState();
   
     // call component updated and activated hooks
     callActivatedHooks(activatedQueue);
     callUpdatedHooks(updatedQueue);
   
     // devtool hook
     /* istanbul ignore if */
     if (devtools && config.devtools) {
       devtools.emit('flush');
     }
   }
   
   function callUpdatedHooks (queue) {
     var i = queue.length;
     while (i--) {
       var watcher = queue[i];
       var vm = watcher.vm;
       if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
         callHook(vm, 'updated');
       }
     }
   }
   
   /**
    * Queue a kept-alive component that was activated during patch.
    * The queue will be processed after the entire tree has been patched.
    */
   function queueActivatedComponent (vm) {
     // setting _inactive to false here so that a render function can
     // rely on checking whether it's in an inactive tree (e.g. router-view)
     vm._inactive = false;
     activatedChildren.push(vm);
   }
   
   function callActivatedHooks (queue) {
     for (var i = 0; i < queue.length; i++) {
       queue[i]._inactive = true;
       activateChildComponent(queue[i], true /* true */);
     }
   }
   
   /**
    * Push a watcher into the watcher queue.
    * Jobs with duplicate IDs will be skipped unless it's
    * pushed when the queue is being flushed.
    */
   function queueWatcher (watcher) {
     var id = watcher.id;
     if (has[id] == null) {
       has[id] = true;
       if (!flushing) {
         queue.push(watcher);
       } else {
         // if already flushing, splice the watcher based on its id
         // if already past its id, it will be run next immediately.
         var i = queue.length - 1;
         while (i > index && queue[i].id > watcher.id) {
           i--;
         }
         queue.splice(i + 1, 0, watcher);
       }
       // queue the flush
       if (!waiting) {
         waiting = true;
   
         if (false) {}
         nextTick(flushSchedulerQueue);
       }
     }
   }
   
   /*  */
   
   
   
   var uid$2 = 0;
   
   /**
    * A watcher parses an expression, collects dependencies,
    * and fires callback when the expression value changes.
    * This is used for both the $watch() api and directives.
    */
   var Watcher = function Watcher (
     vm,
     expOrFn,
     cb,
     options,
     isRenderWatcher
   ) {
     this.vm = vm;
     if (isRenderWatcher) {
       vm._watcher = this;
     }
     vm._watchers.push(this);
     // options
     if (options) {
       this.deep = !!options.deep;
       this.user = !!options.user;
       this.lazy = !!options.lazy;
       this.sync = !!options.sync;
       this.before = options.before;
     } else {
       this.deep = this.user = this.lazy = this.sync = false;
     }
     this.cb = cb;
     this.id = ++uid$2; // uid for batching
     this.active = true;
     this.dirty = this.lazy; // for lazy watchers
     this.deps = [];
     this.newDeps = [];
     this.depIds = new _Set();
     this.newDepIds = new _Set();
     this.expression =  false
       ? 0
       : '';
     // parse expression for getter
     if (typeof expOrFn === 'function') {
       this.getter = expOrFn;
     } else {
       this.getter = parsePath(expOrFn);
       if (!this.getter) {
         this.getter = noop;
          false && 0;
       }
     }
     this.value = this.lazy
       ? undefined
       : this.get();
   };
   
   /**
    * Evaluate the getter, and re-collect dependencies.
    */
   Watcher.prototype.get = function get () {
     pushTarget(this);
     var value;
     var vm = this.vm;
     try {
       value = this.getter.call(vm, vm);
     } catch (e) {
       if (this.user) {
         handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
       } else {
         throw e
       }
     } finally {
       // "touch" every property so they are all tracked as
       // dependencies for deep watching
       if (this.deep) {
         traverse(value);
       }
       popTarget();
       this.cleanupDeps();
     }
     return value
   };
   
   /**
    * Add a dependency to this directive.
    */
   Watcher.prototype.addDep = function addDep (dep) {
     var id = dep.id;
     if (!this.newDepIds.has(id)) {
       this.newDepIds.add(id);
       this.newDeps.push(dep);
       if (!this.depIds.has(id)) {
         dep.addSub(this);
       }
     }
   };
   
   /**
    * Clean up for dependency collection.
    */
   Watcher.prototype.cleanupDeps = function cleanupDeps () {
     var i = this.deps.length;
     while (i--) {
       var dep = this.deps[i];
       if (!this.newDepIds.has(dep.id)) {
         dep.removeSub(this);
       }
     }
     var tmp = this.depIds;
     this.depIds = this.newDepIds;
     this.newDepIds = tmp;
     this.newDepIds.clear();
     tmp = this.deps;
     this.deps = this.newDeps;
     this.newDeps = tmp;
     this.newDeps.length = 0;
   };
   
   /**
    * Subscriber interface.
    * Will be called when a dependency changes.
    */
   Watcher.prototype.update = function update () {
     /* istanbul ignore else */
     if (this.lazy) {
       this.dirty = true;
     } else if (this.sync) {
       this.run();
     } else {
       queueWatcher(this);
     }
   };
   
   /**
    * Scheduler job interface.
    * Will be called by the scheduler.
    */
   Watcher.prototype.run = function run () {
     if (this.active) {
       var value = this.get();
       if (
         value !== this.value ||
         // Deep watchers and watchers on Object/Arrays should fire even
         // when the value is the same, because the value may
         // have mutated.
         isObject(value) ||
         this.deep
       ) {
         // set new value
         var oldValue = this.value;
         this.value = value;
         if (this.user) {
           var info = "callback for watcher \"" + (this.expression) + "\"";
           invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
         } else {
           this.cb.call(this.vm, value, oldValue);
         }
       }
     }
   };
   
   /**
    * Evaluate the value of the watcher.
    * This only gets called for lazy watchers.
    */
   Watcher.prototype.evaluate = function evaluate () {
     this.value = this.get();
     this.dirty = false;
   };
   
   /**
    * Depend on all deps collected by this watcher.
    */
   Watcher.prototype.depend = function depend () {
     var i = this.deps.length;
     while (i--) {
       this.deps[i].depend();
     }
   };
   
   /**
    * Remove self from all dependencies' subscriber list.
    */
   Watcher.prototype.teardown = function teardown () {
     if (this.active) {
       // remove self from vm's watcher list
       // this is a somewhat expensive operation so we skip it
       // if the vm is being destroyed.
       if (!this.vm._isBeingDestroyed) {
         remove(this.vm._watchers, this);
       }
       var i = this.deps.length;
       while (i--) {
         this.deps[i].removeSub(this);
       }
       this.active = false;
     }
   };
   
   /*  */
   
   var sharedPropertyDefinition = {
     enumerable: true,
     configurable: true,
     get: noop,
     set: noop
   };
   
   function proxy (target, sourceKey, key) {
     sharedPropertyDefinition.get = function proxyGetter () {
       return this[sourceKey][key]
     };
     sharedPropertyDefinition.set = function proxySetter (val) {
       this[sourceKey][key] = val;
     };
     Object.defineProperty(target, key, sharedPropertyDefinition);
   }
   
   function initState (vm) {
     vm._watchers = [];
     var opts = vm.$options;
     if (opts.props) { initProps(vm, opts.props); }
     if (opts.methods) { initMethods(vm, opts.methods); }
     if (opts.data) {
       initData(vm);
     } else {
       observe(vm._data = {}, true /* asRootData */);
     }
     if (opts.computed) { initComputed(vm, opts.computed); }
     if (opts.watch && opts.watch !== nativeWatch) {
       initWatch(vm, opts.watch);
     }
   }
   
   function initProps (vm, propsOptions) {
     var propsData = vm.$options.propsData || {};
     var props = vm._props = {};
     // cache prop keys so that future props updates can iterate using Array
     // instead of dynamic object key enumeration.
     var keys = vm.$options._propKeys = [];
     var isRoot = !vm.$parent;
     // root instance props should be converted
     if (!isRoot) {
       toggleObserving(false);
     }
     var loop = function ( key ) {
       keys.push(key);
       var value = validateProp(key, propsOptions, propsData, vm);
       /* istanbul ignore else */
       if (false) { var hyphenatedKey; } else {
         defineReactive$$1(props, key, value);
       }
       // static props are already proxied on the component's prototype
       // during Vue.extend(). We only need to proxy props defined at
       // instantiation here.
       if (!(key in vm)) {
         proxy(vm, "_props", key);
       }
     };
   
     for (var key in propsOptions) loop( key );
     toggleObserving(true);
   }
   
   function initData (vm) {
     var data = vm.$options.data;
     data = vm._data = typeof data === 'function'
       ? getData(data, vm)
       : data || {};
     if (!isPlainObject(data)) {
       data = {};
        false && 0;
     }
     // proxy data on instance
     var keys = Object.keys(data);
     var props = vm.$options.props;
     var methods = vm.$options.methods;
     var i = keys.length;
     while (i--) {
       var key = keys[i];
       if (false) {}
       if (props && hasOwn(props, key)) {
          false && 0;
       } else if (!isReserved(key)) {
         proxy(vm, "_data", key);
       }
     }
     // observe data
     observe(data, true /* asRootData */);
   }
   
   function getData (data, vm) {
     // #7573 disable dep collection when invoking data getters
     pushTarget();
     try {
       return data.call(vm, vm)
     } catch (e) {
       handleError(e, vm, "data()");
       return {}
     } finally {
       popTarget();
     }
   }
   
   var computedWatcherOptions = { lazy: true };
   
   function initComputed (vm, computed) {
     // $flow-disable-line
     var watchers = vm._computedWatchers = Object.create(null);
     // computed properties are just getters during SSR
     var isSSR = isServerRendering();
   
     for (var key in computed) {
       var userDef = computed[key];
       var getter = typeof userDef === 'function' ? userDef : userDef.get;
       if (false) {}
   
       if (!isSSR) {
         // create internal watcher for the computed property.
         watchers[key] = new Watcher(
           vm,
           getter || noop,
           noop,
           computedWatcherOptions
         );
       }
   
       // component-defined computed properties are already defined on the
       // component prototype. We only need to define computed properties defined
       // at instantiation here.
       if (!(key in vm)) {
         defineComputed(vm, key, userDef);
       } else if (false) {}
     }
   }
   
   function defineComputed (
     target,
     key,
     userDef
   ) {
     var shouldCache = !isServerRendering();
     if (typeof userDef === 'function') {
       sharedPropertyDefinition.get = shouldCache
         ? createComputedGetter(key)
         : createGetterInvoker(userDef);
       sharedPropertyDefinition.set = noop;
     } else {
       sharedPropertyDefinition.get = userDef.get
         ? shouldCache && userDef.cache !== false
           ? createComputedGetter(key)
           : createGetterInvoker(userDef.get)
         : noop;
       sharedPropertyDefinition.set = userDef.set || noop;
     }
     if (false) {}
     Object.defineProperty(target, key, sharedPropertyDefinition);
   }
   
   function createComputedGetter (key) {
     return function computedGetter () {
       var watcher = this._computedWatchers && this._computedWatchers[key];
       if (watcher) {
         if (watcher.dirty) {
           watcher.evaluate();
         }
         if (Dep.target) {
           watcher.depend();
         }
         return watcher.value
       }
     }
   }
   
   function createGetterInvoker(fn) {
     return function computedGetter () {
       return fn.call(this, this)
     }
   }
   
   function initMethods (vm, methods) {
     var props = vm.$options.props;
     for (var key in methods) {
       if (false) {}
       vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
     }
   }
   
   function initWatch (vm, watch) {
     for (var key in watch) {
       var handler = watch[key];
       if (Array.isArray(handler)) {
         for (var i = 0; i < handler.length; i++) {
           createWatcher(vm, key, handler[i]);
         }
       } else {
         createWatcher(vm, key, handler);
       }
     }
   }
   
   function createWatcher (
     vm,
     expOrFn,
     handler,
     options
   ) {
     if (isPlainObject(handler)) {
       options = handler;
       handler = handler.handler;
     }
     if (typeof handler === 'string') {
       handler = vm[handler];
     }
     return vm.$watch(expOrFn, handler, options)
   }
   
   function stateMixin (Vue) {
     // flow somehow has problems with directly declared definition object
     // when using Object.defineProperty, so we have to procedurally build up
     // the object here.
     var dataDef = {};
     dataDef.get = function () { return this._data };
     var propsDef = {};
     propsDef.get = function () { return this._props };
     if (false) {}
     Object.defineProperty(Vue.prototype, '$data', dataDef);
     Object.defineProperty(Vue.prototype, '$props', propsDef);
   
     Vue.prototype.$set = set;
     Vue.prototype.$delete = del;
   
     Vue.prototype.$watch = function (
       expOrFn,
       cb,
       options
     ) {
       var vm = this;
       if (isPlainObject(cb)) {
         return createWatcher(vm, expOrFn, cb, options)
       }
       options = options || {};
       options.user = true;
       var watcher = new Watcher(vm, expOrFn, cb, options);
       if (options.immediate) {
         var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
         pushTarget();
         invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
         popTarget();
       }
       return function unwatchFn () {
         watcher.teardown();
       }
     };
   }
   
   /*  */
   
   var uid$3 = 0;
   
   function initMixin (Vue) {
     Vue.prototype._init = function (options) {
       var vm = this;
       // a uid
       vm._uid = uid$3++;
   
       var startTag, endTag;
       /* istanbul ignore if */
       if (false) {}
   
       // a flag to avoid this being observed
       vm._isVue = true;
       // merge options
       if (options && options._isComponent) {
         // optimize internal component instantiation
         // since dynamic options merging is pretty slow, and none of the
         // internal component options needs special treatment.
         initInternalComponent(vm, options);
       } else {
         vm.$options = mergeOptions(
           resolveConstructorOptions(vm.constructor),
           options || {},
           vm
         );
       }
       /* istanbul ignore else */
       if (false) {} else {
         vm._renderProxy = vm;
       }
       // expose real self
       vm._self = vm;
       initLifecycle(vm);
       initEvents(vm);
       initRender(vm);
       callHook(vm, 'beforeCreate');
       initInjections(vm); // resolve injections before data/props
       initState(vm);
       initProvide(vm); // resolve provide after data/props
       callHook(vm, 'created');
   
       /* istanbul ignore if */
       if (false) {}
   
       if (vm.$options.el) {
         vm.$mount(vm.$options.el);
       }
     };
   }
   
   function initInternalComponent (vm, options) {
     var opts = vm.$options = Object.create(vm.constructor.options);
     // doing this because it's faster than dynamic enumeration.
     var parentVnode = options._parentVnode;
     opts.parent = options.parent;
     opts._parentVnode = parentVnode;
   
     var vnodeComponentOptions = parentVnode.componentOptions;
     opts.propsData = vnodeComponentOptions.propsData;
     opts._parentListeners = vnodeComponentOptions.listeners;
     opts._renderChildren = vnodeComponentOptions.children;
     opts._componentTag = vnodeComponentOptions.tag;
   
     if (options.render) {
       opts.render = options.render;
       opts.staticRenderFns = options.staticRenderFns;
     }
   }
   
   function resolveConstructorOptions (Ctor) {
     var options = Ctor.options;
     if (Ctor.super) {
       var superOptions = resolveConstructorOptions(Ctor.super);
       var cachedSuperOptions = Ctor.superOptions;
       if (superOptions !== cachedSuperOptions) {
         // super option changed,
         // need to resolve new options.
         Ctor.superOptions = superOptions;
         // check if there are any late-modified/attached options (#4976)
         var modifiedOptions = resolveModifiedOptions(Ctor);
         // update base extend options
         if (modifiedOptions) {
           extend(Ctor.extendOptions, modifiedOptions);
         }
         options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
         if (options.name) {
           options.components[options.name] = Ctor;
         }
       }
     }
     return options
   }
   
   function resolveModifiedOptions (Ctor) {
     var modified;
     var latest = Ctor.options;
     var sealed = Ctor.sealedOptions;
     for (var key in latest) {
       if (latest[key] !== sealed[key]) {
         if (!modified) { modified = {}; }
         modified[key] = latest[key];
       }
     }
     return modified
   }
   
   function vue_esm_Vue (options) {
     if (false
     ) {}
     this._init(options);
   }
   
   initMixin(vue_esm_Vue);
   stateMixin(vue_esm_Vue);
   eventsMixin(vue_esm_Vue);
   lifecycleMixin(vue_esm_Vue);
   renderMixin(vue_esm_Vue);
   
   /*  */
   
   function initUse (Vue) {
     Vue.use = function (plugin) {
       var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
       if (installedPlugins.indexOf(plugin) > -1) {
         return this
       }
   
       // additional parameters
       var args = toArray(arguments, 1);
       args.unshift(this);
       if (typeof plugin.install === 'function') {
         plugin.install.apply(plugin, args);
       } else if (typeof plugin === 'function') {
         plugin.apply(null, args);
       }
       installedPlugins.push(plugin);
       return this
     };
   }
   
   /*  */
   
   function initMixin$1 (Vue) {
     Vue.mixin = function (mixin) {
       this.options = mergeOptions(this.options, mixin);
       return this
     };
   }
   
   /*  */
   
   function initExtend (Vue) {
     /**
      * Each instance constructor, including Vue, has a unique
      * cid. This enables us to create wrapped "child
      * constructors" for prototypal inheritance and cache them.
      */
     Vue.cid = 0;
     var cid = 1;
   
     /**
      * Class inheritance
      */
     Vue.extend = function (extendOptions) {
       extendOptions = extendOptions || {};
       var Super = this;
       var SuperId = Super.cid;
       var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
       if (cachedCtors[SuperId]) {
         return cachedCtors[SuperId]
       }
   
       var name = extendOptions.name || Super.options.name;
       if (false) {}
   
       var Sub = function VueComponent (options) {
         this._init(options);
       };
       Sub.prototype = Object.create(Super.prototype);
       Sub.prototype.constructor = Sub;
       Sub.cid = cid++;
       Sub.options = mergeOptions(
         Super.options,
         extendOptions
       );
       Sub['super'] = Super;
   
       // For props and computed properties, we define the proxy getters on
       // the Vue instances at extension time, on the extended prototype. This
       // avoids Object.defineProperty calls for each instance created.
       if (Sub.options.props) {
         initProps$1(Sub);
       }
       if (Sub.options.computed) {
         initComputed$1(Sub);
       }
   
       // allow further extension/mixin/plugin usage
       Sub.extend = Super.extend;
       Sub.mixin = Super.mixin;
       Sub.use = Super.use;
   
       // create asset registers, so extended classes
       // can have their private assets too.
       ASSET_TYPES.forEach(function (type) {
         Sub[type] = Super[type];
       });
       // enable recursive self-lookup
       if (name) {
         Sub.options.components[name] = Sub;
       }
   
       // keep a reference to the super options at extension time.
       // later at instantiation we can check if Super's options have
       // been updated.
       Sub.superOptions = Super.options;
       Sub.extendOptions = extendOptions;
       Sub.sealedOptions = extend({}, Sub.options);
   
       // cache constructor
       cachedCtors[SuperId] = Sub;
       return Sub
     };
   }
   
   function initProps$1 (Comp) {
     var props = Comp.options.props;
     for (var key in props) {
       proxy(Comp.prototype, "_props", key);
     }
   }
   
   function initComputed$1 (Comp) {
     var computed = Comp.options.computed;
     for (var key in computed) {
       defineComputed(Comp.prototype, key, computed[key]);
     }
   }
   
   /*  */
   
   function initAssetRegisters (Vue) {
     /**
      * Create asset registration methods.
      */
     ASSET_TYPES.forEach(function (type) {
       Vue[type] = function (
         id,
         definition
       ) {
         if (!definition) {
           return this.options[type + 's'][id]
         } else {
           /* istanbul ignore if */
           if (false) {}
           if (type === 'component' && isPlainObject(definition)) {
             definition.name = definition.name || id;
             definition = this.options._base.extend(definition);
           }
           if (type === 'directive' && typeof definition === 'function') {
             definition = { bind: definition, update: definition };
           }
           this.options[type + 's'][id] = definition;
           return definition
         }
       };
     });
   }
   
   /*  */
   
   
   
   
   
   function getComponentName (opts) {
     return opts && (opts.Ctor.options.name || opts.tag)
   }
   
   function matches (pattern, name) {
     if (Array.isArray(pattern)) {
       return pattern.indexOf(name) > -1
     } else if (typeof pattern === 'string') {
       return pattern.split(',').indexOf(name) > -1
     } else if (isRegExp(pattern)) {
       return pattern.test(name)
     }
     /* istanbul ignore next */
     return false
   }
   
   function pruneCache (keepAliveInstance, filter) {
     var cache = keepAliveInstance.cache;
     var keys = keepAliveInstance.keys;
     var _vnode = keepAliveInstance._vnode;
     for (var key in cache) {
       var entry = cache[key];
       if (entry) {
         var name = entry.name;
         if (name && !filter(name)) {
           pruneCacheEntry(cache, key, keys, _vnode);
         }
       }
     }
   }
   
   function pruneCacheEntry (
     cache,
     key,
     keys,
     current
   ) {
     var entry = cache[key];
     if (entry && (!current || entry.tag !== current.tag)) {
       entry.componentInstance.$destroy();
     }
     cache[key] = null;
     remove(keys, key);
   }
   
   var patternTypes = [String, RegExp, Array];
   
   var KeepAlive = {
     name: 'keep-alive',
     abstract: true,
   
     props: {
       include: patternTypes,
       exclude: patternTypes,
       max: [String, Number]
     },
   
     methods: {
       cacheVNode: function cacheVNode() {
         var ref = this;
         var cache = ref.cache;
         var keys = ref.keys;
         var vnodeToCache = ref.vnodeToCache;
         var keyToCache = ref.keyToCache;
         if (vnodeToCache) {
           var tag = vnodeToCache.tag;
           var componentInstance = vnodeToCache.componentInstance;
           var componentOptions = vnodeToCache.componentOptions;
           cache[keyToCache] = {
             name: getComponentName(componentOptions),
             tag: tag,
             componentInstance: componentInstance,
           };
           keys.push(keyToCache);
           // prune oldest entry
           if (this.max && keys.length > parseInt(this.max)) {
             pruneCacheEntry(cache, keys[0], keys, this._vnode);
           }
           this.vnodeToCache = null;
         }
       }
     },
   
     created: function created () {
       this.cache = Object.create(null);
       this.keys = [];
     },
   
     destroyed: function destroyed () {
       for (var key in this.cache) {
         pruneCacheEntry(this.cache, key, this.keys);
       }
     },
   
     mounted: function mounted () {
       var this$1 = this;
   
       this.cacheVNode();
       this.$watch('include', function (val) {
         pruneCache(this$1, function (name) { return matches(val, name); });
       });
       this.$watch('exclude', function (val) {
         pruneCache(this$1, function (name) { return !matches(val, name); });
       });
     },
   
     updated: function updated () {
       this.cacheVNode();
     },
   
     render: function render () {
       var slot = this.$slots.default;
       var vnode = getFirstComponentChild(slot);
       var componentOptions = vnode && vnode.componentOptions;
       if (componentOptions) {
         // check pattern
         var name = getComponentName(componentOptions);
         var ref = this;
         var include = ref.include;
         var exclude = ref.exclude;
         if (
           // not included
           (include && (!name || !matches(include, name))) ||
           // excluded
           (exclude && name && matches(exclude, name))
         ) {
           return vnode
         }
   
         var ref$1 = this;
         var cache = ref$1.cache;
         var keys = ref$1.keys;
         var key = vnode.key == null
           // same constructor may get registered as different local components
           // so cid alone is not enough (#3269)
           ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
           : vnode.key;
         if (cache[key]) {
           vnode.componentInstance = cache[key].componentInstance;
           // make current key freshest
           remove(keys, key);
           keys.push(key);
         } else {
           // delay setting the cache until update
           this.vnodeToCache = vnode;
           this.keyToCache = key;
         }
   
         vnode.data.keepAlive = true;
       }
       return vnode || (slot && slot[0])
     }
   };
   
   var builtInComponents = {
     KeepAlive: KeepAlive
   };
   
   /*  */
   
   function initGlobalAPI (Vue) {
     // config
     var configDef = {};
     configDef.get = function () { return config; };
     if (false) {}
     Object.defineProperty(Vue, 'config', configDef);
   
     // exposed util methods.
     // NOTE: these are not considered part of the public API - avoid relying on
     // them unless you are aware of the risk.
     Vue.util = {
       warn: warn,
       extend: extend,
       mergeOptions: mergeOptions,
       defineReactive: defineReactive$$1
     };
   
     Vue.set = set;
     Vue.delete = del;
     Vue.nextTick = nextTick;
   
     // 2.6 explicit observable API
     Vue.observable = function (obj) {
       observe(obj);
       return obj
     };
   
     Vue.options = Object.create(null);
     ASSET_TYPES.forEach(function (type) {
       Vue.options[type + 's'] = Object.create(null);
     });
   
     // this is used to identify the "base" constructor to extend all plain-object
     // components with in Weex's multi-instance scenarios.
     Vue.options._base = Vue;
   
     extend(Vue.options.components, builtInComponents);
   
     initUse(Vue);
     initMixin$1(Vue);
     initExtend(Vue);
     initAssetRegisters(Vue);
   }
   
   initGlobalAPI(vue_esm_Vue);
   
   Object.defineProperty(vue_esm_Vue.prototype, '$isServer', {
     get: isServerRendering
   });
   
   Object.defineProperty(vue_esm_Vue.prototype, '$ssrContext', {
     get: function get () {
       /* istanbul ignore next */
       return this.$vnode && this.$vnode.ssrContext
     }
   });
   
   // expose FunctionalRenderContext for ssr runtime helper installation
   Object.defineProperty(vue_esm_Vue, 'FunctionalRenderContext', {
     value: FunctionalRenderContext
   });
   
   vue_esm_Vue.version = '2.6.14';
   
   /*  */
   
   // these are reserved for web because they are directly compiled away
   // during template compilation
   var isReservedAttr = makeMap('style,class');
   
   // attributes that should be using props for binding
   var acceptValue = makeMap('input,textarea,option,select,progress');
   var mustUseProp = function (tag, type, attr) {
     return (
       (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
       (attr === 'selected' && tag === 'option') ||
       (attr === 'checked' && tag === 'input') ||
       (attr === 'muted' && tag === 'video')
     )
   };
   
   var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
   
   var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
   
   var convertEnumeratedValue = function (key, value) {
     return isFalsyAttrValue(value) || value === 'false'
       ? 'false'
       // allow arbitrary string value for contenteditable
       : key === 'contenteditable' && isValidContentEditableValue(value)
         ? value
         : 'true'
   };
   
   var isBooleanAttr = makeMap(
     'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
     'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
     'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
     'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
     'required,reversed,scoped,seamless,selected,sortable,' +
     'truespeed,typemustmatch,visible'
   );
   
   var xlinkNS = 'http://www.w3.org/1999/xlink';
   
   var isXlink = function (name) {
     return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
   };
   
   var getXlinkProp = function (name) {
     return isXlink(name) ? name.slice(6, name.length) : ''
   };
   
   var isFalsyAttrValue = function (val) {
     return val == null || val === false
   };
   
   /*  */
   
   function genClassForVnode (vnode) {
     var data = vnode.data;
     var parentNode = vnode;
     var childNode = vnode;
     while (isDef(childNode.componentInstance)) {
       childNode = childNode.componentInstance._vnode;
       if (childNode && childNode.data) {
         data = mergeClassData(childNode.data, data);
       }
     }
     while (isDef(parentNode = parentNode.parent)) {
       if (parentNode && parentNode.data) {
         data = mergeClassData(data, parentNode.data);
       }
     }
     return renderClass(data.staticClass, data.class)
   }
   
   function mergeClassData (child, parent) {
     return {
       staticClass: concat(child.staticClass, parent.staticClass),
       class: isDef(child.class)
         ? [child.class, parent.class]
         : parent.class
     }
   }
   
   function renderClass (
     staticClass,
     dynamicClass
   ) {
     if (isDef(staticClass) || isDef(dynamicClass)) {
       return concat(staticClass, stringifyClass(dynamicClass))
     }
     /* istanbul ignore next */
     return ''
   }
   
   function concat (a, b) {
     return a ? b ? (a + ' ' + b) : a : (b || '')
   }
   
   function stringifyClass (value) {
     if (Array.isArray(value)) {
       return stringifyArray(value)
     }
     if (isObject(value)) {
       return stringifyObject(value)
     }
     if (typeof value === 'string') {
       return value
     }
     /* istanbul ignore next */
     return ''
   }
   
   function stringifyArray (value) {
     var res = '';
     var stringified;
     for (var i = 0, l = value.length; i < l; i++) {
       if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
         if (res) { res += ' '; }
         res += stringified;
       }
     }
     return res
   }
   
   function stringifyObject (value) {
     var res = '';
     for (var key in value) {
       if (value[key]) {
         if (res) { res += ' '; }
         res += key;
       }
     }
     return res
   }
   
   /*  */
   
   var namespaceMap = {
     svg: 'http://www.w3.org/2000/svg',
     math: 'http://www.w3.org/1998/Math/MathML'
   };
   
   var isHTMLTag = makeMap(
     'html,body,base,head,link,meta,style,title,' +
     'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
     'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
     'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
     's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
     'embed,object,param,source,canvas,script,noscript,del,ins,' +
     'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
     'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
     'output,progress,select,textarea,' +
     'details,dialog,menu,menuitem,summary,' +
     'content,element,shadow,template,blockquote,iframe,tfoot'
   );
   
   // this map is intentionally selective, only covering SVG elements that may
   // contain child elements.
   var isSVG = makeMap(
     'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
     'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
     'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
     true
   );
   
   var isPreTag = function (tag) { return tag === 'pre'; };
   
   var isReservedTag = function (tag) {
     return isHTMLTag(tag) || isSVG(tag)
   };
   
   function getTagNamespace (tag) {
     if (isSVG(tag)) {
       return 'svg'
     }
     // basic support for MathML
     // note it doesn't support other MathML elements being component roots
     if (tag === 'math') {
       return 'math'
     }
   }
   
   var unknownElementCache = Object.create(null);
   function isUnknownElement (tag) {
     /* istanbul ignore if */
     if (!inBrowser) {
       return true
     }
     if (isReservedTag(tag)) {
       return false
     }
     tag = tag.toLowerCase();
     /* istanbul ignore if */
     if (unknownElementCache[tag] != null) {
       return unknownElementCache[tag]
     }
     var el = document.createElement(tag);
     if (tag.indexOf('-') > -1) {
       // http://stackoverflow.com/a/28210364/1070244
       return (unknownElementCache[tag] = (
         el.constructor === window.HTMLUnknownElement ||
         el.constructor === window.HTMLElement
       ))
     } else {
       return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
     }
   }
   
   var isTextInputType = makeMap('text,number,password,search,email,tel,url');
   
   /*  */
   
   /**
    * Query an element selector if it's not an element already.
    */
   function query (el) {
     if (typeof el === 'string') {
       var selected = document.querySelector(el);
       if (!selected) {
          false && 0;
         return document.createElement('div')
       }
       return selected
     } else {
       return el
     }
   }
   
   /*  */
   
   function createElement$1 (tagName, vnode) {
     var elm = document.createElement(tagName);
     if (tagName !== 'select') {
       return elm
     }
     // false or null will remove the attribute but undefined will not
     if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
       elm.setAttribute('multiple', 'multiple');
     }
     return elm
   }
   
   function createElementNS (namespace, tagName) {
     return document.createElementNS(namespaceMap[namespace], tagName)
   }
   
   function createTextNode (text) {
     return document.createTextNode(text)
   }
   
   function createComment (text) {
     return document.createComment(text)
   }
   
   function insertBefore (parentNode, newNode, referenceNode) {
     parentNode.insertBefore(newNode, referenceNode);
   }
   
   function removeChild (node, child) {
     node.removeChild(child);
   }
   
   function appendChild (node, child) {
     node.appendChild(child);
   }
   
   function parentNode (node) {
     return node.parentNode
   }
   
   function nextSibling (node) {
     return node.nextSibling
   }
   
   function tagName (node) {
     return node.tagName
   }
   
   function setTextContent (node, text) {
     node.textContent = text;
   }
   
   function setStyleScope (node, scopeId) {
     node.setAttribute(scopeId, '');
   }
   
   var nodeOps = /*#__PURE__*/Object.freeze({
     createElement: createElement$1,
     createElementNS: createElementNS,
     createTextNode: createTextNode,
     createComment: createComment,
     insertBefore: insertBefore,
     removeChild: removeChild,
     appendChild: appendChild,
     parentNode: parentNode,
     nextSibling: nextSibling,
     tagName: tagName,
     setTextContent: setTextContent,
     setStyleScope: setStyleScope
   });
   
   /*  */
   
   var ref = {
     create: function create (_, vnode) {
       registerRef(vnode);
     },
     update: function update (oldVnode, vnode) {
       if (oldVnode.data.ref !== vnode.data.ref) {
         registerRef(oldVnode, true);
         registerRef(vnode);
       }
     },
     destroy: function destroy (vnode) {
       registerRef(vnode, true);
     }
   };
   
   function registerRef (vnode, isRemoval) {
     var key = vnode.data.ref;
     if (!isDef(key)) { return }
   
     var vm = vnode.context;
     var ref = vnode.componentInstance || vnode.elm;
     var refs = vm.$refs;
     if (isRemoval) {
       if (Array.isArray(refs[key])) {
         remove(refs[key], ref);
       } else if (refs[key] === ref) {
         refs[key] = undefined;
       }
     } else {
       if (vnode.data.refInFor) {
         if (!Array.isArray(refs[key])) {
           refs[key] = [ref];
         } else if (refs[key].indexOf(ref) < 0) {
           // $flow-disable-line
           refs[key].push(ref);
         }
       } else {
         refs[key] = ref;
       }
     }
   }
   
   /**
    * Virtual DOM patching algorithm based on Snabbdom by
    * Simon Friis Vindum (@paldepind)
    * Licensed under the MIT License
    * https://github.com/paldepind/snabbdom/blob/master/LICENSE
    *
    * modified by Evan You (@yyx990803)
    *
    * Not type-checking this because this file is perf-critical and the cost
    * of making flow understand it is not worth it.
    */
   
   var emptyNode = new VNode('', {}, []);
   
   var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
   
   function sameVnode (a, b) {
     return (
       a.key === b.key &&
       a.asyncFactory === b.asyncFactory && (
         (
           a.tag === b.tag &&
           a.isComment === b.isComment &&
           isDef(a.data) === isDef(b.data) &&
           sameInputType(a, b)
         ) || (
           isTrue(a.isAsyncPlaceholder) &&
           isUndef(b.asyncFactory.error)
         )
       )
     )
   }
   
   function sameInputType (a, b) {
     if (a.tag !== 'input') { return true }
     var i;
     var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
     var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
     return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
   }
   
   function createKeyToOldIdx (children, beginIdx, endIdx) {
     var i, key;
     var map = {};
     for (i = beginIdx; i <= endIdx; ++i) {
       key = children[i].key;
       if (isDef(key)) { map[key] = i; }
     }
     return map
   }
   
   function createPatchFunction (backend) {
     var i, j;
     var cbs = {};
   
     var modules = backend.modules;
     var nodeOps = backend.nodeOps;
   
     for (i = 0; i < hooks.length; ++i) {
       cbs[hooks[i]] = [];
       for (j = 0; j < modules.length; ++j) {
         if (isDef(modules[j][hooks[i]])) {
           cbs[hooks[i]].push(modules[j][hooks[i]]);
         }
       }
     }
   
     function emptyNodeAt (elm) {
       return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
     }
   
     function createRmCb (childElm, listeners) {
       function remove$$1 () {
         if (--remove$$1.listeners === 0) {
           removeNode(childElm);
         }
       }
       remove$$1.listeners = listeners;
       return remove$$1
     }
   
     function removeNode (el) {
       var parent = nodeOps.parentNode(el);
       // element may have already been removed due to v-html / v-text
       if (isDef(parent)) {
         nodeOps.removeChild(parent, el);
       }
     }
   
     function isUnknownElement$$1 (vnode, inVPre) {
       return (
         !inVPre &&
         !vnode.ns &&
         !(
           config.ignoredElements.length &&
           config.ignoredElements.some(function (ignore) {
             return isRegExp(ignore)
               ? ignore.test(vnode.tag)
               : ignore === vnode.tag
           })
         ) &&
         config.isUnknownElement(vnode.tag)
       )
     }
   
     var creatingElmInVPre = 0;
   
     function createElm (
       vnode,
       insertedVnodeQueue,
       parentElm,
       refElm,
       nested,
       ownerArray,
       index
     ) {
       if (isDef(vnode.elm) && isDef(ownerArray)) {
         // This vnode was used in a previous render!
         // now it's used as a new node, overwriting its elm would cause
         // potential patch errors down the road when it's used as an insertion
         // reference node. Instead, we clone the node on-demand before creating
         // associated DOM element for it.
         vnode = ownerArray[index] = cloneVNode(vnode);
       }
   
       vnode.isRootInsert = !nested; // for transition enter check
       if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
         return
       }
   
       var data = vnode.data;
       var children = vnode.children;
       var tag = vnode.tag;
       if (isDef(tag)) {
         if (false) {}
   
         vnode.elm = vnode.ns
           ? nodeOps.createElementNS(vnode.ns, tag)
           : nodeOps.createElement(tag, vnode);
         setScope(vnode);
   
         /* istanbul ignore if */
         {
           createChildren(vnode, children, insertedVnodeQueue);
           if (isDef(data)) {
             invokeCreateHooks(vnode, insertedVnodeQueue);
           }
           insert(parentElm, vnode.elm, refElm);
         }
   
         if (false) {}
       } else if (isTrue(vnode.isComment)) {
         vnode.elm = nodeOps.createComment(vnode.text);
         insert(parentElm, vnode.elm, refElm);
       } else {
         vnode.elm = nodeOps.createTextNode(vnode.text);
         insert(parentElm, vnode.elm, refElm);
       }
     }
   
     function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
       var i = vnode.data;
       if (isDef(i)) {
         var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
         if (isDef(i = i.hook) && isDef(i = i.init)) {
           i(vnode, false /* hydrating */);
         }
         // after calling the init hook, if the vnode is a child component
         // it should've created a child instance and mounted it. the child
         // component also has set the placeholder vnode's elm.
         // in that case we can just return the element and be done.
         if (isDef(vnode.componentInstance)) {
           initComponent(vnode, insertedVnodeQueue);
           insert(parentElm, vnode.elm, refElm);
           if (isTrue(isReactivated)) {
             reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
           }
           return true
         }
       }
     }
   
     function initComponent (vnode, insertedVnodeQueue) {
       if (isDef(vnode.data.pendingInsert)) {
         insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
         vnode.data.pendingInsert = null;
       }
       vnode.elm = vnode.componentInstance.$el;
       if (isPatchable(vnode)) {
         invokeCreateHooks(vnode, insertedVnodeQueue);
         setScope(vnode);
       } else {
         // empty component root.
         // skip all element-related modules except for ref (#3455)
         registerRef(vnode);
         // make sure to invoke the insert hook
         insertedVnodeQueue.push(vnode);
       }
     }
   
     function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
       var i;
       // hack for #4339: a reactivated component with inner transition
       // does not trigger because the inner node's created hooks are not called
       // again. It's not ideal to involve module-specific logic in here but
       // there doesn't seem to be a better way to do it.
       var innerNode = vnode;
       while (innerNode.componentInstance) {
         innerNode = innerNode.componentInstance._vnode;
         if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
           for (i = 0; i < cbs.activate.length; ++i) {
             cbs.activate[i](emptyNode, innerNode);
           }
           insertedVnodeQueue.push(innerNode);
           break
         }
       }
       // unlike a newly created component,
       // a reactivated keep-alive component doesn't insert itself
       insert(parentElm, vnode.elm, refElm);
     }
   
     function insert (parent, elm, ref$$1) {
       if (isDef(parent)) {
         if (isDef(ref$$1)) {
           if (nodeOps.parentNode(ref$$1) === parent) {
             nodeOps.insertBefore(parent, elm, ref$$1);
           }
         } else {
           nodeOps.appendChild(parent, elm);
         }
       }
     }
   
     function createChildren (vnode, children, insertedVnodeQueue) {
       if (Array.isArray(children)) {
         if (false) {}
         for (var i = 0; i < children.length; ++i) {
           createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
         }
       } else if (isPrimitive(vnode.text)) {
         nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
       }
     }
   
     function isPatchable (vnode) {
       while (vnode.componentInstance) {
         vnode = vnode.componentInstance._vnode;
       }
       return isDef(vnode.tag)
     }
   
     function invokeCreateHooks (vnode, insertedVnodeQueue) {
       for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
         cbs.create[i$1](emptyNode, vnode);
       }
       i = vnode.data.hook; // Reuse variable
       if (isDef(i)) {
         if (isDef(i.create)) { i.create(emptyNode, vnode); }
         if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
       }
     }
   
     // set scope id attribute for scoped CSS.
     // this is implemented as a special case to avoid the overhead
     // of going through the normal attribute patching process.
     function setScope (vnode) {
       var i;
       if (isDef(i = vnode.fnScopeId)) {
         nodeOps.setStyleScope(vnode.elm, i);
       } else {
         var ancestor = vnode;
         while (ancestor) {
           if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
             nodeOps.setStyleScope(vnode.elm, i);
           }
           ancestor = ancestor.parent;
         }
       }
       // for slot content they should also get the scopeId from the host instance.
       if (isDef(i = activeInstance) &&
         i !== vnode.context &&
         i !== vnode.fnContext &&
         isDef(i = i.$options._scopeId)
       ) {
         nodeOps.setStyleScope(vnode.elm, i);
       }
     }
   
     function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
       for (; startIdx <= endIdx; ++startIdx) {
         createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
       }
     }
   
     function invokeDestroyHook (vnode) {
       var i, j;
       var data = vnode.data;
       if (isDef(data)) {
         if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
         for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
       }
       if (isDef(i = vnode.children)) {
         for (j = 0; j < vnode.children.length; ++j) {
           invokeDestroyHook(vnode.children[j]);
         }
       }
     }
   
     function removeVnodes (vnodes, startIdx, endIdx) {
       for (; startIdx <= endIdx; ++startIdx) {
         var ch = vnodes[startIdx];
         if (isDef(ch)) {
           if (isDef(ch.tag)) {
             removeAndInvokeRemoveHook(ch);
             invokeDestroyHook(ch);
           } else { // Text node
             removeNode(ch.elm);
           }
         }
       }
     }
   
     function removeAndInvokeRemoveHook (vnode, rm) {
       if (isDef(rm) || isDef(vnode.data)) {
         var i;
         var listeners = cbs.remove.length + 1;
         if (isDef(rm)) {
           // we have a recursively passed down rm callback
           // increase the listeners count
           rm.listeners += listeners;
         } else {
           // directly removing
           rm = createRmCb(vnode.elm, listeners);
         }
         // recursively invoke hooks on child component root node
         if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
           removeAndInvokeRemoveHook(i, rm);
         }
         for (i = 0; i < cbs.remove.length; ++i) {
           cbs.remove[i](vnode, rm);
         }
         if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
           i(vnode, rm);
         } else {
           rm();
         }
       } else {
         removeNode(vnode.elm);
       }
     }
   
     function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
       var oldStartIdx = 0;
       var newStartIdx = 0;
       var oldEndIdx = oldCh.length - 1;
       var oldStartVnode = oldCh[0];
       var oldEndVnode = oldCh[oldEndIdx];
       var newEndIdx = newCh.length - 1;
       var newStartVnode = newCh[0];
       var newEndVnode = newCh[newEndIdx];
       var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
   
       // removeOnly is a special flag used only by <transition-group>
       // to ensure removed elements stay in correct relative positions
       // during leaving transitions
       var canMove = !removeOnly;
   
       if (false) {}
   
       while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
         if (isUndef(oldStartVnode)) {
           oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
         } else if (isUndef(oldEndVnode)) {
           oldEndVnode = oldCh[--oldEndIdx];
         } else if (sameVnode(oldStartVnode, newStartVnode)) {
           patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
           oldStartVnode = oldCh[++oldStartIdx];
           newStartVnode = newCh[++newStartIdx];
         } else if (sameVnode(oldEndVnode, newEndVnode)) {
           patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
           oldEndVnode = oldCh[--oldEndIdx];
           newEndVnode = newCh[--newEndIdx];
         } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
           patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
           canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
           oldStartVnode = oldCh[++oldStartIdx];
           newEndVnode = newCh[--newEndIdx];
         } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
           patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
           canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
           oldEndVnode = oldCh[--oldEndIdx];
           newStartVnode = newCh[++newStartIdx];
         } else {
           if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
           idxInOld = isDef(newStartVnode.key)
             ? oldKeyToIdx[newStartVnode.key]
             : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
           if (isUndef(idxInOld)) { // New element
             createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
           } else {
             vnodeToMove = oldCh[idxInOld];
             if (sameVnode(vnodeToMove, newStartVnode)) {
               patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
               oldCh[idxInOld] = undefined;
               canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
             } else {
               // same key but different element. treat as new element
               createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
             }
           }
           newStartVnode = newCh[++newStartIdx];
         }
       }
       if (oldStartIdx > oldEndIdx) {
         refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
         addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
       } else if (newStartIdx > newEndIdx) {
         removeVnodes(oldCh, oldStartIdx, oldEndIdx);
       }
     }
   
     function checkDuplicateKeys (children) {
       var seenKeys = {};
       for (var i = 0; i < children.length; i++) {
         var vnode = children[i];
         var key = vnode.key;
         if (isDef(key)) {
           if (seenKeys[key]) {
             warn(
               ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
               vnode.context
             );
           } else {
             seenKeys[key] = true;
           }
         }
       }
     }
   
     function findIdxInOld (node, oldCh, start, end) {
       for (var i = start; i < end; i++) {
         var c = oldCh[i];
         if (isDef(c) && sameVnode(node, c)) { return i }
       }
     }
   
     function patchVnode (
       oldVnode,
       vnode,
       insertedVnodeQueue,
       ownerArray,
       index,
       removeOnly
     ) {
       if (oldVnode === vnode) {
         return
       }
   
       if (isDef(vnode.elm) && isDef(ownerArray)) {
         // clone reused vnode
         vnode = ownerArray[index] = cloneVNode(vnode);
       }
   
       var elm = vnode.elm = oldVnode.elm;
   
       if (isTrue(oldVnode.isAsyncPlaceholder)) {
         if (isDef(vnode.asyncFactory.resolved)) {
           hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
         } else {
           vnode.isAsyncPlaceholder = true;
         }
         return
       }
   
       // reuse element for static trees.
       // note we only do this if the vnode is cloned -
       // if the new node is not cloned it means the render functions have been
       // reset by the hot-reload-api and we need to do a proper re-render.
       if (isTrue(vnode.isStatic) &&
         isTrue(oldVnode.isStatic) &&
         vnode.key === oldVnode.key &&
         (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
       ) {
         vnode.componentInstance = oldVnode.componentInstance;
         return
       }
   
       var i;
       var data = vnode.data;
       if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
         i(oldVnode, vnode);
       }
   
       var oldCh = oldVnode.children;
       var ch = vnode.children;
       if (isDef(data) && isPatchable(vnode)) {
         for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
         if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
       }
       if (isUndef(vnode.text)) {
         if (isDef(oldCh) && isDef(ch)) {
           if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
         } else if (isDef(ch)) {
           if (false) {}
           if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
           addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
         } else if (isDef(oldCh)) {
           removeVnodes(oldCh, 0, oldCh.length - 1);
         } else if (isDef(oldVnode.text)) {
           nodeOps.setTextContent(elm, '');
         }
       } else if (oldVnode.text !== vnode.text) {
         nodeOps.setTextContent(elm, vnode.text);
       }
       if (isDef(data)) {
         if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
       }
     }
   
     function invokeInsertHook (vnode, queue, initial) {
       // delay insert hooks for component root nodes, invoke them after the
       // element is really inserted
       if (isTrue(initial) && isDef(vnode.parent)) {
         vnode.parent.data.pendingInsert = queue;
       } else {
         for (var i = 0; i < queue.length; ++i) {
           queue[i].data.hook.insert(queue[i]);
         }
       }
     }
   
     var hydrationBailed = false;
     // list of modules that can skip create hook during hydration because they
     // are already rendered on the client or has no need for initialization
     // Note: style is excluded because it relies on initial clone for future
     // deep updates (#7063).
     var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
   
     // Note: this is a browser-only function so we can assume elms are DOM nodes.
     function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
       var i;
       var tag = vnode.tag;
       var data = vnode.data;
       var children = vnode.children;
       inVPre = inVPre || (data && data.pre);
       vnode.elm = elm;
   
       if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
         vnode.isAsyncPlaceholder = true;
         return true
       }
       // assert node match
       if (false) {}
       if (isDef(data)) {
         if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
         if (isDef(i = vnode.componentInstance)) {
           // child component. it should have hydrated its own tree.
           initComponent(vnode, insertedVnodeQueue);
           return true
         }
       }
       if (isDef(tag)) {
         if (isDef(children)) {
           // empty element, allow client to pick up and populate children
           if (!elm.hasChildNodes()) {
             createChildren(vnode, children, insertedVnodeQueue);
           } else {
             // v-html and domProps: innerHTML
             if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
               if (i !== elm.innerHTML) {
                 /* istanbul ignore if */
                 if (false
                 ) {}
                 return false
               }
             } else {
               // iterate and compare children lists
               var childrenMatch = true;
               var childNode = elm.firstChild;
               for (var i$1 = 0; i$1 < children.length; i$1++) {
                 if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                   childrenMatch = false;
                   break
                 }
                 childNode = childNode.nextSibling;
               }
               // if childNode is not null, it means the actual childNodes list is
               // longer than the virtual children list.
               if (!childrenMatch || childNode) {
                 /* istanbul ignore if */
                 if (false
                 ) {}
                 return false
               }
             }
           }
         }
         if (isDef(data)) {
           var fullInvoke = false;
           for (var key in data) {
             if (!isRenderedModule(key)) {
               fullInvoke = true;
               invokeCreateHooks(vnode, insertedVnodeQueue);
               break
             }
           }
           if (!fullInvoke && data['class']) {
             // ensure collecting deps for deep class bindings for future updates
             traverse(data['class']);
           }
         }
       } else if (elm.data !== vnode.text) {
         elm.data = vnode.text;
       }
       return true
     }
   
     function assertNodeMatch (node, vnode, inVPre) {
       if (isDef(vnode.tag)) {
         return vnode.tag.indexOf('vue-component') === 0 || (
           !isUnknownElement$$1(vnode, inVPre) &&
           vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
         )
       } else {
         return node.nodeType === (vnode.isComment ? 8 : 3)
       }
     }
   
     return function patch (oldVnode, vnode, hydrating, removeOnly) {
       if (isUndef(vnode)) {
         if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
         return
       }
   
       var isInitialPatch = false;
       var insertedVnodeQueue = [];
   
       if (isUndef(oldVnode)) {
         // empty mount (likely as component), create new root element
         isInitialPatch = true;
         createElm(vnode, insertedVnodeQueue);
       } else {
         var isRealElement = isDef(oldVnode.nodeType);
         if (!isRealElement && sameVnode(oldVnode, vnode)) {
           // patch existing root node
           patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
         } else {
           if (isRealElement) {
             // mounting to a real element
             // check if this is server-rendered content and if we can perform
             // a successful hydration.
             if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
               oldVnode.removeAttribute(SSR_ATTR);
               hydrating = true;
             }
             if (isTrue(hydrating)) {
               if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                 invokeInsertHook(vnode, insertedVnodeQueue, true);
                 return oldVnode
               } else if (false) {}
             }
             // either not server-rendered, or hydration failed.
             // create an empty node and replace it
             oldVnode = emptyNodeAt(oldVnode);
           }
   
           // replacing existing element
           var oldElm = oldVnode.elm;
           var parentElm = nodeOps.parentNode(oldElm);
   
           // create new node
           createElm(
             vnode,
             insertedVnodeQueue,
             // extremely rare edge case: do not insert if old element is in a
             // leaving transition. Only happens when combining transition +
             // keep-alive + HOCs. (#4590)
             oldElm._leaveCb ? null : parentElm,
             nodeOps.nextSibling(oldElm)
           );
   
           // update parent placeholder node element, recursively
           if (isDef(vnode.parent)) {
             var ancestor = vnode.parent;
             var patchable = isPatchable(vnode);
             while (ancestor) {
               for (var i = 0; i < cbs.destroy.length; ++i) {
                 cbs.destroy[i](ancestor);
               }
               ancestor.elm = vnode.elm;
               if (patchable) {
                 for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                   cbs.create[i$1](emptyNode, ancestor);
                 }
                 // #6513
                 // invoke insert hooks that may have been merged by create hooks.
                 // e.g. for directives that uses the "inserted" hook.
                 var insert = ancestor.data.hook.insert;
                 if (insert.merged) {
                   // start at index 1 to avoid re-invoking component mounted hook
                   for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                     insert.fns[i$2]();
                   }
                 }
               } else {
                 registerRef(ancestor);
               }
               ancestor = ancestor.parent;
             }
           }
   
           // destroy old node
           if (isDef(parentElm)) {
             removeVnodes([oldVnode], 0, 0);
           } else if (isDef(oldVnode.tag)) {
             invokeDestroyHook(oldVnode);
           }
         }
       }
   
       invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
       return vnode.elm
     }
   }
   
   /*  */
   
   var directives = {
     create: updateDirectives,
     update: updateDirectives,
     destroy: function unbindDirectives (vnode) {
       updateDirectives(vnode, emptyNode);
     }
   };
   
   function updateDirectives (oldVnode, vnode) {
     if (oldVnode.data.directives || vnode.data.directives) {
       _update(oldVnode, vnode);
     }
   }
   
   function _update (oldVnode, vnode) {
     var isCreate = oldVnode === emptyNode;
     var isDestroy = vnode === emptyNode;
     var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
     var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
   
     var dirsWithInsert = [];
     var dirsWithPostpatch = [];
   
     var key, oldDir, dir;
     for (key in newDirs) {
       oldDir = oldDirs[key];
       dir = newDirs[key];
       if (!oldDir) {
         // new directive, bind
         callHook$1(dir, 'bind', vnode, oldVnode);
         if (dir.def && dir.def.inserted) {
           dirsWithInsert.push(dir);
         }
       } else {
         // existing directive, update
         dir.oldValue = oldDir.value;
         dir.oldArg = oldDir.arg;
         callHook$1(dir, 'update', vnode, oldVnode);
         if (dir.def && dir.def.componentUpdated) {
           dirsWithPostpatch.push(dir);
         }
       }
     }
   
     if (dirsWithInsert.length) {
       var callInsert = function () {
         for (var i = 0; i < dirsWithInsert.length; i++) {
           callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
         }
       };
       if (isCreate) {
         mergeVNodeHook(vnode, 'insert', callInsert);
       } else {
         callInsert();
       }
     }
   
     if (dirsWithPostpatch.length) {
       mergeVNodeHook(vnode, 'postpatch', function () {
         for (var i = 0; i < dirsWithPostpatch.length; i++) {
           callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
         }
       });
     }
   
     if (!isCreate) {
       for (key in oldDirs) {
         if (!newDirs[key]) {
           // no longer present, unbind
           callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
         }
       }
     }
   }
   
   var emptyModifiers = Object.create(null);
   
   function normalizeDirectives$1 (
     dirs,
     vm
   ) {
     var res = Object.create(null);
     if (!dirs) {
       // $flow-disable-line
       return res
     }
     var i, dir;
     for (i = 0; i < dirs.length; i++) {
       dir = dirs[i];
       if (!dir.modifiers) {
         // $flow-disable-line
         dir.modifiers = emptyModifiers;
       }
       res[getRawDirName(dir)] = dir;
       dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
     }
     // $flow-disable-line
     return res
   }
   
   function getRawDirName (dir) {
     return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
   }
   
   function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
     var fn = dir.def && dir.def[hook];
     if (fn) {
       try {
         fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
       } catch (e) {
         handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
       }
     }
   }
   
   var baseModules = [
     ref,
     directives
   ];
   
   /*  */
   
   function updateAttrs (oldVnode, vnode) {
     var opts = vnode.componentOptions;
     if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
       return
     }
     if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
       return
     }
     var key, cur, old;
     var elm = vnode.elm;
     var oldAttrs = oldVnode.data.attrs || {};
     var attrs = vnode.data.attrs || {};
     // clone observed objects, as the user probably wants to mutate it
     if (isDef(attrs.__ob__)) {
       attrs = vnode.data.attrs = extend({}, attrs);
     }
   
     for (key in attrs) {
       cur = attrs[key];
       old = oldAttrs[key];
       if (old !== cur) {
         setAttr(elm, key, cur, vnode.data.pre);
       }
     }
     // #4391: in IE9, setting type can reset value for input[type=radio]
     // #6666: IE/Edge forces progress value down to 1 before setting a max
     /* istanbul ignore if */
     if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
       setAttr(elm, 'value', attrs.value);
     }
     for (key in oldAttrs) {
       if (isUndef(attrs[key])) {
         if (isXlink(key)) {
           elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
         } else if (!isEnumeratedAttr(key)) {
           elm.removeAttribute(key);
         }
       }
     }
   }
   
   function setAttr (el, key, value, isInPre) {
     if (isInPre || el.tagName.indexOf('-') > -1) {
       baseSetAttr(el, key, value);
     } else if (isBooleanAttr(key)) {
       // set attribute for blank value
       // e.g. <option disabled>Select one</option>
       if (isFalsyAttrValue(value)) {
         el.removeAttribute(key);
       } else {
         // technically allowfullscreen is a boolean attribute for <iframe>,
         // but Flash expects a value of "true" when used on <embed> tag
         value = key === 'allowfullscreen' && el.tagName === 'EMBED'
           ? 'true'
           : key;
         el.setAttribute(key, value);
       }
     } else if (isEnumeratedAttr(key)) {
       el.setAttribute(key, convertEnumeratedValue(key, value));
     } else if (isXlink(key)) {
       if (isFalsyAttrValue(value)) {
         el.removeAttributeNS(xlinkNS, getXlinkProp(key));
       } else {
         el.setAttributeNS(xlinkNS, key, value);
       }
     } else {
       baseSetAttr(el, key, value);
     }
   }
   
   function baseSetAttr (el, key, value) {
     if (isFalsyAttrValue(value)) {
       el.removeAttribute(key);
     } else {
       // #7138: IE10 & 11 fires input event when setting placeholder on
       // <textarea>... block the first input event and remove the blocker
       // immediately.
       /* istanbul ignore if */
       if (
         isIE && !isIE9 &&
         el.tagName === 'TEXTAREA' &&
         key === 'placeholder' && value !== '' && !el.__ieph
       ) {
         var blocker = function (e) {
           e.stopImmediatePropagation();
           el.removeEventListener('input', blocker);
         };
         el.addEventListener('input', blocker);
         // $flow-disable-line
         el.__ieph = true; /* IE placeholder patched */
       }
       el.setAttribute(key, value);
     }
   }
   
   var attrs = {
     create: updateAttrs,
     update: updateAttrs
   };
   
   /*  */
   
   function updateClass (oldVnode, vnode) {
     var el = vnode.elm;
     var data = vnode.data;
     var oldData = oldVnode.data;
     if (
       isUndef(data.staticClass) &&
       isUndef(data.class) && (
         isUndef(oldData) || (
           isUndef(oldData.staticClass) &&
           isUndef(oldData.class)
         )
       )
     ) {
       return
     }
   
     var cls = genClassForVnode(vnode);
   
     // handle transition classes
     var transitionClass = el._transitionClasses;
     if (isDef(transitionClass)) {
       cls = concat(cls, stringifyClass(transitionClass));
     }
   
     // set the class
     if (cls !== el._prevClass) {
       el.setAttribute('class', cls);
       el._prevClass = cls;
     }
   }
   
   var klass = {
     create: updateClass,
     update: updateClass
   };
   
   /*  */
   
   var validDivisionCharRE = /[\w).+\-_$\]]/;
   
   function parseFilters (exp) {
     var inSingle = false;
     var inDouble = false;
     var inTemplateString = false;
     var inRegex = false;
     var curly = 0;
     var square = 0;
     var paren = 0;
     var lastFilterIndex = 0;
     var c, prev, i, expression, filters;
   
     for (i = 0; i < exp.length; i++) {
       prev = c;
       c = exp.charCodeAt(i);
       if (inSingle) {
         if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
       } else if (inDouble) {
         if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
       } else if (inTemplateString) {
         if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
       } else if (inRegex) {
         if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
       } else if (
         c === 0x7C && // pipe
         exp.charCodeAt(i + 1) !== 0x7C &&
         exp.charCodeAt(i - 1) !== 0x7C &&
         !curly && !square && !paren
       ) {
         if (expression === undefined) {
           // first filter, end of expression
           lastFilterIndex = i + 1;
           expression = exp.slice(0, i).trim();
         } else {
           pushFilter();
         }
       } else {
         switch (c) {
           case 0x22: inDouble = true; break         // "
           case 0x27: inSingle = true; break         // '
           case 0x60: inTemplateString = true; break // `
           case 0x28: paren++; break                 // (
           case 0x29: paren--; break                 // )
           case 0x5B: square++; break                // [
           case 0x5D: square--; break                // ]
           case 0x7B: curly++; break                 // {
           case 0x7D: curly--; break                 // }
         }
         if (c === 0x2f) { // /
           var j = i - 1;
           var p = (void 0);
           // find first non-whitespace prev char
           for (; j >= 0; j--) {
             p = exp.charAt(j);
             if (p !== ' ') { break }
           }
           if (!p || !validDivisionCharRE.test(p)) {
             inRegex = true;
           }
         }
       }
     }
   
     if (expression === undefined) {
       expression = exp.slice(0, i).trim();
     } else if (lastFilterIndex !== 0) {
       pushFilter();
     }
   
     function pushFilter () {
       (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
       lastFilterIndex = i + 1;
     }
   
     if (filters) {
       for (i = 0; i < filters.length; i++) {
         expression = wrapFilter(expression, filters[i]);
       }
     }
   
     return expression
   }
   
   function wrapFilter (exp, filter) {
     var i = filter.indexOf('(');
     if (i < 0) {
       // _f: resolveFilter
       return ("_f(\"" + filter + "\")(" + exp + ")")
     } else {
       var name = filter.slice(0, i);
       var args = filter.slice(i + 1);
       return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
     }
   }
   
   /*  */
   
   
   
   /* eslint-disable no-unused-vars */
   function baseWarn (msg, range) {
     console.error(("[Vue compiler]: " + msg));
   }
   /* eslint-enable no-unused-vars */
   
   function pluckModuleFunction (
     modules,
     key
   ) {
     return modules
       ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
       : []
   }
   
   function addProp (el, name, value, range, dynamic) {
     (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
     el.plain = false;
   }
   
   function addAttr (el, name, value, range, dynamic) {
     var attrs = dynamic
       ? (el.dynamicAttrs || (el.dynamicAttrs = []))
       : (el.attrs || (el.attrs = []));
     attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
     el.plain = false;
   }
   
   // add a raw attr (use this in preTransforms)
   function addRawAttr (el, name, value, range) {
     el.attrsMap[name] = value;
     el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
   }
   
   function addDirective (
     el,
     name,
     rawName,
     value,
     arg,
     isDynamicArg,
     modifiers,
     range
   ) {
     (el.directives || (el.directives = [])).push(rangeSetItem({
       name: name,
       rawName: rawName,
       value: value,
       arg: arg,
       isDynamicArg: isDynamicArg,
       modifiers: modifiers
     }, range));
     el.plain = false;
   }
   
   function prependModifierMarker (symbol, name, dynamic) {
     return dynamic
       ? ("_p(" + name + ",\"" + symbol + "\")")
       : symbol + name // mark the event as captured
   }
   
   function addHandler (
     el,
     name,
     value,
     modifiers,
     important,
     warn,
     range,
     dynamic
   ) {
     modifiers = modifiers || emptyObject;
     // warn prevent and passive modifier
     /* istanbul ignore if */
     if (
       false
     ) {}
   
     // normalize click.right and click.middle since they don't actually fire
     // this is technically browser-specific, but at least for now browsers are
     // the only target envs that have right/middle clicks.
     if (modifiers.right) {
       if (dynamic) {
         name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
       } else if (name === 'click') {
         name = 'contextmenu';
         delete modifiers.right;
       }
     } else if (modifiers.middle) {
       if (dynamic) {
         name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
       } else if (name === 'click') {
         name = 'mouseup';
       }
     }
   
     // check capture modifier
     if (modifiers.capture) {
       delete modifiers.capture;
       name = prependModifierMarker('!', name, dynamic);
     }
     if (modifiers.once) {
       delete modifiers.once;
       name = prependModifierMarker('~', name, dynamic);
     }
     /* istanbul ignore if */
     if (modifiers.passive) {
       delete modifiers.passive;
       name = prependModifierMarker('&', name, dynamic);
     }
   
     var events;
     if (modifiers.native) {
       delete modifiers.native;
       events = el.nativeEvents || (el.nativeEvents = {});
     } else {
       events = el.events || (el.events = {});
     }
   
     var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
     if (modifiers !== emptyObject) {
       newHandler.modifiers = modifiers;
     }
   
     var handlers = events[name];
     /* istanbul ignore if */
     if (Array.isArray(handlers)) {
       important ? handlers.unshift(newHandler) : handlers.push(newHandler);
     } else if (handlers) {
       events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
     } else {
       events[name] = newHandler;
     }
   
     el.plain = false;
   }
   
   function getRawBindingAttr (
     el,
     name
   ) {
     return el.rawAttrsMap[':' + name] ||
       el.rawAttrsMap['v-bind:' + name] ||
       el.rawAttrsMap[name]
   }
   
   function getBindingAttr (
     el,
     name,
     getStatic
   ) {
     var dynamicValue =
       getAndRemoveAttr(el, ':' + name) ||
       getAndRemoveAttr(el, 'v-bind:' + name);
     if (dynamicValue != null) {
       return parseFilters(dynamicValue)
     } else if (getStatic !== false) {
       var staticValue = getAndRemoveAttr(el, name);
       if (staticValue != null) {
         return JSON.stringify(staticValue)
       }
     }
   }
   
   // note: this only removes the attr from the Array (attrsList) so that it
   // doesn't get processed by processAttrs.
   // By default it does NOT remove it from the map (attrsMap) because the map is
   // needed during codegen.
   function getAndRemoveAttr (
     el,
     name,
     removeFromMap
   ) {
     var val;
     if ((val = el.attrsMap[name]) != null) {
       var list = el.attrsList;
       for (var i = 0, l = list.length; i < l; i++) {
         if (list[i].name === name) {
           list.splice(i, 1);
           break
         }
       }
     }
     if (removeFromMap) {
       delete el.attrsMap[name];
     }
     return val
   }
   
   function getAndRemoveAttrByRegex (
     el,
     name
   ) {
     var list = el.attrsList;
     for (var i = 0, l = list.length; i < l; i++) {
       var attr = list[i];
       if (name.test(attr.name)) {
         list.splice(i, 1);
         return attr
       }
     }
   }
   
   function rangeSetItem (
     item,
     range
   ) {
     if (range) {
       if (range.start != null) {
         item.start = range.start;
       }
       if (range.end != null) {
         item.end = range.end;
       }
     }
     return item
   }
   
   /*  */
   
   /**
    * Cross-platform code generation for component v-model
    */
   function genComponentModel (
     el,
     value,
     modifiers
   ) {
     var ref = modifiers || {};
     var number = ref.number;
     var trim = ref.trim;
   
     var baseValueExpression = '$$v';
     var valueExpression = baseValueExpression;
     if (trim) {
       valueExpression =
         "(typeof " + baseValueExpression + " === 'string'" +
         "? " + baseValueExpression + ".trim()" +
         ": " + baseValueExpression + ")";
     }
     if (number) {
       valueExpression = "_n(" + valueExpression + ")";
     }
     var assignment = genAssignmentCode(value, valueExpression);
   
     el.model = {
       value: ("(" + value + ")"),
       expression: JSON.stringify(value),
       callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
     };
   }
   
   /**
    * Cross-platform codegen helper for generating v-model value assignment code.
    */
   function genAssignmentCode (
     value,
     assignment
   ) {
     var res = parseModel(value);
     if (res.key === null) {
       return (value + "=" + assignment)
     } else {
       return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
     }
   }
   
   /**
    * Parse a v-model expression into a base path and a final key segment.
    * Handles both dot-path and possible square brackets.
    *
    * Possible cases:
    *
    * - test
    * - test[key]
    * - test[test1[key]]
    * - test["a"][key]
    * - xxx.test[a[a].test1[key]]
    * - test.xxx.a["asa"][test1[key]]
    *
    */
   
   var len, str, chr, index$1, expressionPos, expressionEndPos;
   
   
   
   function parseModel (val) {
     // Fix https://github.com/vuejs/vue/pull/7730
     // allow v-model="obj.val " (trailing whitespace)
     val = val.trim();
     len = val.length;
   
     if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
       index$1 = val.lastIndexOf('.');
       if (index$1 > -1) {
         return {
           exp: val.slice(0, index$1),
           key: '"' + val.slice(index$1 + 1) + '"'
         }
       } else {
         return {
           exp: val,
           key: null
         }
       }
     }
   
     str = val;
     index$1 = expressionPos = expressionEndPos = 0;
   
     while (!eof()) {
       chr = next();
       /* istanbul ignore if */
       if (isStringStart(chr)) {
         parseString(chr);
       } else if (chr === 0x5B) {
         parseBracket(chr);
       }
     }
   
     return {
       exp: val.slice(0, expressionPos),
       key: val.slice(expressionPos + 1, expressionEndPos)
     }
   }
   
   function next () {
     return str.charCodeAt(++index$1)
   }
   
   function eof () {
     return index$1 >= len
   }
   
   function isStringStart (chr) {
     return chr === 0x22 || chr === 0x27
   }
   
   function parseBracket (chr) {
     var inBracket = 1;
     expressionPos = index$1;
     while (!eof()) {
       chr = next();
       if (isStringStart(chr)) {
         parseString(chr);
         continue
       }
       if (chr === 0x5B) { inBracket++; }
       if (chr === 0x5D) { inBracket--; }
       if (inBracket === 0) {
         expressionEndPos = index$1;
         break
       }
     }
   }
   
   function parseString (chr) {
     var stringQuote = chr;
     while (!eof()) {
       chr = next();
       if (chr === stringQuote) {
         break
       }
     }
   }
   
   /*  */
   
   var warn$1;
   
   // in some cases, the event used has to be determined at runtime
   // so we used some reserved tokens during compile.
   var RANGE_TOKEN = '__r';
   var CHECKBOX_RADIO_TOKEN = '__c';
   
   function model (
     el,
     dir,
     _warn
   ) {
     warn$1 = _warn;
     var value = dir.value;
     var modifiers = dir.modifiers;
     var tag = el.tag;
     var type = el.attrsMap.type;
   
     if (false) {}
   
     if (el.component) {
       genComponentModel(el, value, modifiers);
       // component v-model doesn't need extra runtime
       return false
     } else if (tag === 'select') {
       genSelect(el, value, modifiers);
     } else if (tag === 'input' && type === 'checkbox') {
       genCheckboxModel(el, value, modifiers);
     } else if (tag === 'input' && type === 'radio') {
       genRadioModel(el, value, modifiers);
     } else if (tag === 'input' || tag === 'textarea') {
       genDefaultModel(el, value, modifiers);
     } else if (!config.isReservedTag(tag)) {
       genComponentModel(el, value, modifiers);
       // component v-model doesn't need extra runtime
       return false
     } else if (false) {}
   
     // ensure runtime directive metadata
     return true
   }
   
   function genCheckboxModel (
     el,
     value,
     modifiers
   ) {
     var number = modifiers && modifiers.number;
     var valueBinding = getBindingAttr(el, 'value') || 'null';
     var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
     var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
     addProp(el, 'checked',
       "Array.isArray(" + value + ")" +
       "?_i(" + value + "," + valueBinding + ")>-1" + (
         trueValueBinding === 'true'
           ? (":(" + value + ")")
           : (":_q(" + value + "," + trueValueBinding + ")")
       )
     );
     addHandler(el, 'change',
       "var $$a=" + value + "," +
           '$$el=$event.target,' +
           "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
       'if(Array.isArray($$a)){' +
         "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
             '$$i=_i($$a,$$v);' +
         "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
         "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
       "}else{" + (genAssignmentCode(value, '$$c')) + "}",
       null, true
     );
   }
   
   function genRadioModel (
     el,
     value,
     modifiers
   ) {
     var number = modifiers && modifiers.number;
     var valueBinding = getBindingAttr(el, 'value') || 'null';
     valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
     addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
     addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
   }
   
   function genSelect (
     el,
     value,
     modifiers
   ) {
     var number = modifiers && modifiers.number;
     var selectedVal = "Array.prototype.filter" +
       ".call($event.target.options,function(o){return o.selected})" +
       ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
       "return " + (number ? '_n(val)' : 'val') + "})";
   
     var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
     var code = "var $$selectedVal = " + selectedVal + ";";
     code = code + " " + (genAssignmentCode(value, assignment));
     addHandler(el, 'change', code, null, true);
   }
   
   function genDefaultModel (
     el,
     value,
     modifiers
   ) {
     var type = el.attrsMap.type;
   
     // warn if v-bind:value conflicts with v-model
     // except for inputs with v-bind:type
     if (false) { var binding, typeBinding, value$1; }
   
     var ref = modifiers || {};
     var lazy = ref.lazy;
     var number = ref.number;
     var trim = ref.trim;
     var needCompositionGuard = !lazy && type !== 'range';
     var event = lazy
       ? 'change'
       : type === 'range'
         ? RANGE_TOKEN
         : 'input';
   
     var valueExpression = '$event.target.value';
     if (trim) {
       valueExpression = "$event.target.value.trim()";
     }
     if (number) {
       valueExpression = "_n(" + valueExpression + ")";
     }
   
     var code = genAssignmentCode(value, valueExpression);
     if (needCompositionGuard) {
       code = "if($event.target.composing)return;" + code;
     }
   
     addProp(el, 'value', ("(" + value + ")"));
     addHandler(el, event, code, null, true);
     if (trim || number) {
       addHandler(el, 'blur', '$forceUpdate()');
     }
   }
   
   /*  */
   
   // normalize v-model event tokens that can only be determined at runtime.
   // it's important to place the event as the first in the array because
   // the whole point is ensuring the v-model callback gets called before
   // user-attached handlers.
   function normalizeEvents (on) {
     /* istanbul ignore if */
     if (isDef(on[RANGE_TOKEN])) {
       // IE input[type=range] only supports `change` event
       var event = isIE ? 'change' : 'input';
       on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
       delete on[RANGE_TOKEN];
     }
     // This was originally intended to fix #4521 but no longer necessary
     // after 2.5. Keeping it for backwards compat with generated code from < 2.4
     /* istanbul ignore if */
     if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
       on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
       delete on[CHECKBOX_RADIO_TOKEN];
     }
   }
   
   var target$1;
   
   function createOnceHandler$1 (event, handler, capture) {
     var _target = target$1; // save current target element in closure
     return function onceHandler () {
       var res = handler.apply(null, arguments);
       if (res !== null) {
         remove$2(event, onceHandler, capture, _target);
       }
     }
   }
   
   // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
   // implementation and does not fire microtasks in between event propagation, so
   // safe to exclude.
   var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
   
   function add$1 (
     name,
     handler,
     capture,
     passive
   ) {
     // async edge case #6566: inner click event triggers patch, event handler
     // attached to outer element during patch, and triggered again. This
     // happens because browsers fire microtask ticks between event propagation.
     // the solution is simple: we save the timestamp when a handler is attached,
     // and the handler would only fire if the event passed to it was fired
     // AFTER it was attached.
     if (useMicrotaskFix) {
       var attachedTimestamp = currentFlushTimestamp;
       var original = handler;
       handler = original._wrapper = function (e) {
         if (
           // no bubbling, should always fire.
           // this is just a safety net in case event.timeStamp is unreliable in
           // certain weird environments...
           e.target === e.currentTarget ||
           // event is fired after handler attachment
           e.timeStamp >= attachedTimestamp ||
           // bail for environments that have buggy event.timeStamp implementations
           // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
           // #9681 QtWebEngine event.timeStamp is negative value
           e.timeStamp <= 0 ||
           // #9448 bail if event is fired in another document in a multi-page
           // electron/nw.js app, since event.timeStamp will be using a different
           // starting reference
           e.target.ownerDocument !== document
         ) {
           return original.apply(this, arguments)
         }
       };
     }
     target$1.addEventListener(
       name,
       handler,
       supportsPassive
         ? { capture: capture, passive: passive }
         : capture
     );
   }
   
   function remove$2 (
     name,
     handler,
     capture,
     _target
   ) {
     (_target || target$1).removeEventListener(
       name,
       handler._wrapper || handler,
       capture
     );
   }
   
   function updateDOMListeners (oldVnode, vnode) {
     if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
       return
     }
     var on = vnode.data.on || {};
     var oldOn = oldVnode.data.on || {};
     target$1 = vnode.elm;
     normalizeEvents(on);
     updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
     target$1 = undefined;
   }
   
   var events = {
     create: updateDOMListeners,
     update: updateDOMListeners
   };
   
   /*  */
   
   var svgContainer;
   
   function updateDOMProps (oldVnode, vnode) {
     if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
       return
     }
     var key, cur;
     var elm = vnode.elm;
     var oldProps = oldVnode.data.domProps || {};
     var props = vnode.data.domProps || {};
     // clone observed objects, as the user probably wants to mutate it
     if (isDef(props.__ob__)) {
       props = vnode.data.domProps = extend({}, props);
     }
   
     for (key in oldProps) {
       if (!(key in props)) {
         elm[key] = '';
       }
     }
   
     for (key in props) {
       cur = props[key];
       // ignore children if the node has textContent or innerHTML,
       // as these will throw away existing DOM nodes and cause removal errors
       // on subsequent patches (#3360)
       if (key === 'textContent' || key === 'innerHTML') {
         if (vnode.children) { vnode.children.length = 0; }
         if (cur === oldProps[key]) { continue }
         // #6601 work around Chrome version <= 55 bug where single textNode
         // replaced by innerHTML/textContent retains its parentNode property
         if (elm.childNodes.length === 1) {
           elm.removeChild(elm.childNodes[0]);
         }
       }
   
       if (key === 'value' && elm.tagName !== 'PROGRESS') {
         // store value as _value as well since
         // non-string values will be stringified
         elm._value = cur;
         // avoid resetting cursor position when value is the same
         var strCur = isUndef(cur) ? '' : String(cur);
         if (shouldUpdateValue(elm, strCur)) {
           elm.value = strCur;
         }
       } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
         // IE doesn't support innerHTML for SVG elements
         svgContainer = svgContainer || document.createElement('div');
         svgContainer.innerHTML = "<svg>" + cur + "</svg>";
         var svg = svgContainer.firstChild;
         while (elm.firstChild) {
           elm.removeChild(elm.firstChild);
         }
         while (svg.firstChild) {
           elm.appendChild(svg.firstChild);
         }
       } else if (
         // skip the update if old and new VDOM state is the same.
         // `value` is handled separately because the DOM value may be temporarily
         // out of sync with VDOM state due to focus, composition and modifiers.
         // This  #4521 by skipping the unnecessary `checked` update.
         cur !== oldProps[key]
       ) {
         // some property updates can throw
         // e.g. `value` on <progress> w/ non-finite value
         try {
           elm[key] = cur;
         } catch (e) {}
       }
     }
   }
   
   // check platforms/web/util/attrs.js acceptValue
   
   
   function shouldUpdateValue (elm, checkVal) {
     return (!elm.composing && (
       elm.tagName === 'OPTION' ||
       isNotInFocusAndDirty(elm, checkVal) ||
       isDirtyWithModifiers(elm, checkVal)
     ))
   }
   
   function isNotInFocusAndDirty (elm, checkVal) {
     // return true when textbox (.number and .trim) loses focus and its value is
     // not equal to the updated value
     var notInFocus = true;
     // #6157
     // work around IE bug when accessing document.activeElement in an iframe
     try { notInFocus = document.activeElement !== elm; } catch (e) {}
     return notInFocus && elm.value !== checkVal
   }
   
   function isDirtyWithModifiers (elm, newVal) {
     var value = elm.value;
     var modifiers = elm._vModifiers; // injected by v-model runtime
     if (isDef(modifiers)) {
       if (modifiers.number) {
         return toNumber(value) !== toNumber(newVal)
       }
       if (modifiers.trim) {
         return value.trim() !== newVal.trim()
       }
     }
     return value !== newVal
   }
   
   var domProps = {
     create: updateDOMProps,
     update: updateDOMProps
   };
   
   /*  */
   
   var parseStyleText = cached(function (cssText) {
     var res = {};
     var listDelimiter = /;(?![^(]*\))/g;
     var propertyDelimiter = /:(.+)/;
     cssText.split(listDelimiter).forEach(function (item) {
       if (item) {
         var tmp = item.split(propertyDelimiter);
         tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
       }
     });
     return res
   });
   
   // merge static and dynamic style data on the same vnode
   function normalizeStyleData (data) {
     var style = normalizeStyleBinding(data.style);
     // static style is pre-processed into an object during compilation
     // and is always a fresh object, so it's safe to merge into it
     return data.staticStyle
       ? extend(data.staticStyle, style)
       : style
   }
   
   // normalize possible array / string values into Object
   function normalizeStyleBinding (bindingStyle) {
     if (Array.isArray(bindingStyle)) {
       return toObject(bindingStyle)
     }
     if (typeof bindingStyle === 'string') {
       return parseStyleText(bindingStyle)
     }
     return bindingStyle
   }
   
   /**
    * parent component style should be after child's
    * so that parent component's style could override it
    */
   function getStyle (vnode, checkChild) {
     var res = {};
     var styleData;
   
     if (checkChild) {
       var childNode = vnode;
       while (childNode.componentInstance) {
         childNode = childNode.componentInstance._vnode;
         if (
           childNode && childNode.data &&
           (styleData = normalizeStyleData(childNode.data))
         ) {
           extend(res, styleData);
         }
       }
     }
   
     if ((styleData = normalizeStyleData(vnode.data))) {
       extend(res, styleData);
     }
   
     var parentNode = vnode;
     while ((parentNode = parentNode.parent)) {
       if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
         extend(res, styleData);
       }
     }
     return res
   }
   
   /*  */
   
   var cssVarRE = /^--/;
   var importantRE = /\s*!important$/;
   var setProp = function (el, name, val) {
     /* istanbul ignore if */
     if (cssVarRE.test(name)) {
       el.style.setProperty(name, val);
     } else if (importantRE.test(val)) {
       el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
     } else {
       var normalizedName = normalize(name);
       if (Array.isArray(val)) {
         // Support values array created by autoprefixer, e.g.
         // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
         // Set them one by one, and the browser will only set those it can recognize
         for (var i = 0, len = val.length; i < len; i++) {
           el.style[normalizedName] = val[i];
         }
       } else {
         el.style[normalizedName] = val;
       }
     }
   };
   
   var vendorNames = ['Webkit', 'Moz', 'ms'];
   
   var emptyStyle;
   var normalize = cached(function (prop) {
     emptyStyle = emptyStyle || document.createElement('div').style;
     prop = camelize(prop);
     if (prop !== 'filter' && (prop in emptyStyle)) {
       return prop
     }
     var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
     for (var i = 0; i < vendorNames.length; i++) {
       var name = vendorNames[i] + capName;
       if (name in emptyStyle) {
         return name
       }
     }
   });
   
   function updateStyle (oldVnode, vnode) {
     var data = vnode.data;
     var oldData = oldVnode.data;
   
     if (isUndef(data.staticStyle) && isUndef(data.style) &&
       isUndef(oldData.staticStyle) && isUndef(oldData.style)
     ) {
       return
     }
   
     var cur, name;
     var el = vnode.elm;
     var oldStaticStyle = oldData.staticStyle;
     var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
   
     // if static style exists, stylebinding already merged into it when doing normalizeStyleData
     var oldStyle = oldStaticStyle || oldStyleBinding;
   
     var style = normalizeStyleBinding(vnode.data.style) || {};
   
     // store normalized style under a different key for next diff
     // make sure to clone it if it's reactive, since the user likely wants
     // to mutate it.
     vnode.data.normalizedStyle = isDef(style.__ob__)
       ? extend({}, style)
       : style;
   
     var newStyle = getStyle(vnode, true);
   
     for (name in oldStyle) {
       if (isUndef(newStyle[name])) {
         setProp(el, name, '');
       }
     }
     for (name in newStyle) {
       cur = newStyle[name];
       if (cur !== oldStyle[name]) {
         // ie9 setting to null has no effect, must use empty string
         setProp(el, name, cur == null ? '' : cur);
       }
     }
   }
   
   var style = {
     create: updateStyle,
     update: updateStyle
   };
   
   /*  */
   
   var whitespaceRE = /\s+/;
   
   /**
    * Add class with compatibility for SVG since classList is not supported on
    * SVG elements in IE
    */
   function addClass (el, cls) {
     /* istanbul ignore if */
     if (!cls || !(cls = cls.trim())) {
       return
     }
   
     /* istanbul ignore else */
     if (el.classList) {
       if (cls.indexOf(' ') > -1) {
         cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
       } else {
         el.classList.add(cls);
       }
     } else {
       var cur = " " + (el.getAttribute('class') || '') + " ";
       if (cur.indexOf(' ' + cls + ' ') < 0) {
         el.setAttribute('class', (cur + cls).trim());
       }
     }
   }
   
   /**
    * Remove class with compatibility for SVG since classList is not supported on
    * SVG elements in IE
    */
   function removeClass (el, cls) {
     /* istanbul ignore if */
     if (!cls || !(cls = cls.trim())) {
       return
     }
   
     /* istanbul ignore else */
     if (el.classList) {
       if (cls.indexOf(' ') > -1) {
         cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
       } else {
         el.classList.remove(cls);
       }
       if (!el.classList.length) {
         el.removeAttribute('class');
       }
     } else {
       var cur = " " + (el.getAttribute('class') || '') + " ";
       var tar = ' ' + cls + ' ';
       while (cur.indexOf(tar) >= 0) {
         cur = cur.replace(tar, ' ');
       }
       cur = cur.trim();
       if (cur) {
         el.setAttribute('class', cur);
       } else {
         el.removeAttribute('class');
       }
     }
   }
   
   /*  */
   
   function resolveTransition (def$$1) {
     if (!def$$1) {
       return
     }
     /* istanbul ignore else */
     if (typeof def$$1 === 'object') {
       var res = {};
       if (def$$1.css !== false) {
         extend(res, autoCssTransition(def$$1.name || 'v'));
       }
       extend(res, def$$1);
       return res
     } else if (typeof def$$1 === 'string') {
       return autoCssTransition(def$$1)
     }
   }
   
   var autoCssTransition = cached(function (name) {
     return {
       enterClass: (name + "-enter"),
       enterToClass: (name + "-enter-to"),
       enterActiveClass: (name + "-enter-active"),
       leaveClass: (name + "-leave"),
       leaveToClass: (name + "-leave-to"),
       leaveActiveClass: (name + "-leave-active")
     }
   });
   
   var hasTransition = inBrowser && !isIE9;
   var TRANSITION = 'transition';
   var ANIMATION = 'animation';
   
   // Transition property/event sniffing
   var transitionProp = 'transition';
   var transitionEndEvent = 'transitionend';
   var animationProp = 'animation';
   var animationEndEvent = 'animationend';
   if (hasTransition) {
     /* istanbul ignore if */
     if (window.ontransitionend === undefined &&
       window.onwebkittransitionend !== undefined
     ) {
       transitionProp = 'WebkitTransition';
       transitionEndEvent = 'webkitTransitionEnd';
     }
     if (window.onanimationend === undefined &&
       window.onwebkitanimationend !== undefined
     ) {
       animationProp = 'WebkitAnimation';
       animationEndEvent = 'webkitAnimationEnd';
     }
   }
   
   // binding to window is necessary to make hot reload work in IE in strict mode
   var raf = inBrowser
     ? window.requestAnimationFrame
       ? window.requestAnimationFrame.bind(window)
       : setTimeout
     : /* istanbul ignore next */ function (fn) { return fn(); };
   
   function nextFrame (fn) {
     raf(function () {
       raf(fn);
     });
   }
   
   function addTransitionClass (el, cls) {
     var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
     if (transitionClasses.indexOf(cls) < 0) {
       transitionClasses.push(cls);
       addClass(el, cls);
     }
   }
   
   function removeTransitionClass (el, cls) {
     if (el._transitionClasses) {
       remove(el._transitionClasses, cls);
     }
     removeClass(el, cls);
   }
   
   function whenTransitionEnds (
     el,
     expectedType,
     cb
   ) {
     var ref = getTransitionInfo(el, expectedType);
     var type = ref.type;
     var timeout = ref.timeout;
     var propCount = ref.propCount;
     if (!type) { return cb() }
     var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
     var ended = 0;
     var end = function () {
       el.removeEventListener(event, onEnd);
       cb();
     };
     var onEnd = function (e) {
       if (e.target === el) {
         if (++ended >= propCount) {
           end();
         }
       }
     };
     setTimeout(function () {
       if (ended < propCount) {
         end();
       }
     }, timeout + 1);
     el.addEventListener(event, onEnd);
   }
   
   var transformRE = /\b(transform|all)(,|$)/;
   
   function getTransitionInfo (el, expectedType) {
     var styles = window.getComputedStyle(el);
     // JSDOM may return undefined for transition properties
     var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
     var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
     var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
     var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
     var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
     var animationTimeout = getTimeout(animationDelays, animationDurations);
   
     var type;
     var timeout = 0;
     var propCount = 0;
     /* istanbul ignore if */
     if (expectedType === TRANSITION) {
       if (transitionTimeout > 0) {
         type = TRANSITION;
         timeout = transitionTimeout;
         propCount = transitionDurations.length;
       }
     } else if (expectedType === ANIMATION) {
       if (animationTimeout > 0) {
         type = ANIMATION;
         timeout = animationTimeout;
         propCount = animationDurations.length;
       }
     } else {
       timeout = Math.max(transitionTimeout, animationTimeout);
       type = timeout > 0
         ? transitionTimeout > animationTimeout
           ? TRANSITION
           : ANIMATION
         : null;
       propCount = type
         ? type === TRANSITION
           ? transitionDurations.length
           : animationDurations.length
         : 0;
     }
     var hasTransform =
       type === TRANSITION &&
       transformRE.test(styles[transitionProp + 'Property']);
     return {
       type: type,
       timeout: timeout,
       propCount: propCount,
       hasTransform: hasTransform
     }
   }
   
   function getTimeout (delays, durations) {
     /* istanbul ignore next */
     while (delays.length < durations.length) {
       delays = delays.concat(delays);
     }
   
     return Math.max.apply(null, durations.map(function (d, i) {
       return toMs(d) + toMs(delays[i])
     }))
   }
   
   // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
   // in a locale-dependent way, using a comma instead of a dot.
   // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
   // as a floor function) causing unexpected behaviors
   function toMs (s) {
     return Number(s.slice(0, -1).replace(',', '.')) * 1000
   }
   
   /*  */
   
   function enter (vnode, toggleDisplay) {
     var el = vnode.elm;
   
     // call leave callback now
     if (isDef(el._leaveCb)) {
       el._leaveCb.cancelled = true;
       el._leaveCb();
     }
   
     var data = resolveTransition(vnode.data.transition);
     if (isUndef(data)) {
       return
     }
   
     /* istanbul ignore if */
     if (isDef(el._enterCb) || el.nodeType !== 1) {
       return
     }
   
     var css = data.css;
     var type = data.type;
     var enterClass = data.enterClass;
     var enterToClass = data.enterToClass;
     var enterActiveClass = data.enterActiveClass;
     var appearClass = data.appearClass;
     var appearToClass = data.appearToClass;
     var appearActiveClass = data.appearActiveClass;
     var beforeEnter = data.beforeEnter;
     var enter = data.enter;
     var afterEnter = data.afterEnter;
     var enterCancelled = data.enterCancelled;
     var beforeAppear = data.beforeAppear;
     var appear = data.appear;
     var afterAppear = data.afterAppear;
     var appearCancelled = data.appearCancelled;
     var duration = data.duration;
   
     // activeInstance will always be the <transition> component managing this
     // transition. One edge case to check is when the <transition> is placed
     // as the root node of a child component. In that case we need to check
     // <transition>'s parent for appear check.
     var context = activeInstance;
     var transitionNode = activeInstance.$vnode;
     while (transitionNode && transitionNode.parent) {
       context = transitionNode.context;
       transitionNode = transitionNode.parent;
     }
   
     var isAppear = !context._isMounted || !vnode.isRootInsert;
   
     if (isAppear && !appear && appear !== '') {
       return
     }
   
     var startClass = isAppear && appearClass
       ? appearClass
       : enterClass;
     var activeClass = isAppear && appearActiveClass
       ? appearActiveClass
       : enterActiveClass;
     var toClass = isAppear && appearToClass
       ? appearToClass
       : enterToClass;
   
     var beforeEnterHook = isAppear
       ? (beforeAppear || beforeEnter)
       : beforeEnter;
     var enterHook = isAppear
       ? (typeof appear === 'function' ? appear : enter)
       : enter;
     var afterEnterHook = isAppear
       ? (afterAppear || afterEnter)
       : afterEnter;
     var enterCancelledHook = isAppear
       ? (appearCancelled || enterCancelled)
       : enterCancelled;
   
     var explicitEnterDuration = toNumber(
       isObject(duration)
         ? duration.enter
         : duration
     );
   
     if (false) {}
   
     var expectsCSS = css !== false && !isIE9;
     var userWantsControl = getHookArgumentsLength(enterHook);
   
     var cb = el._enterCb = once(function () {
       if (expectsCSS) {
         removeTransitionClass(el, toClass);
         removeTransitionClass(el, activeClass);
       }
       if (cb.cancelled) {
         if (expectsCSS) {
           removeTransitionClass(el, startClass);
         }
         enterCancelledHook && enterCancelledHook(el);
       } else {
         afterEnterHook && afterEnterHook(el);
       }
       el._enterCb = null;
     });
   
     if (!vnode.data.show) {
       // remove pending leave element on enter by injecting an insert hook
       mergeVNodeHook(vnode, 'insert', function () {
         var parent = el.parentNode;
         var pendingNode = parent && parent._pending && parent._pending[vnode.key];
         if (pendingNode &&
           pendingNode.tag === vnode.tag &&
           pendingNode.elm._leaveCb
         ) {
           pendingNode.elm._leaveCb();
         }
         enterHook && enterHook(el, cb);
       });
     }
   
     // start enter transition
     beforeEnterHook && beforeEnterHook(el);
     if (expectsCSS) {
       addTransitionClass(el, startClass);
       addTransitionClass(el, activeClass);
       nextFrame(function () {
         removeTransitionClass(el, startClass);
         if (!cb.cancelled) {
           addTransitionClass(el, toClass);
           if (!userWantsControl) {
             if (isValidDuration(explicitEnterDuration)) {
               setTimeout(cb, explicitEnterDuration);
             } else {
               whenTransitionEnds(el, type, cb);
             }
           }
         }
       });
     }
   
     if (vnode.data.show) {
       toggleDisplay && toggleDisplay();
       enterHook && enterHook(el, cb);
     }
   
     if (!expectsCSS && !userWantsControl) {
       cb();
     }
   }
   
   function leave (vnode, rm) {
     var el = vnode.elm;
   
     // call enter callback now
     if (isDef(el._enterCb)) {
       el._enterCb.cancelled = true;
       el._enterCb();
     }
   
     var data = resolveTransition(vnode.data.transition);
     if (isUndef(data) || el.nodeType !== 1) {
       return rm()
     }
   
     /* istanbul ignore if */
     if (isDef(el._leaveCb)) {
       return
     }
   
     var css = data.css;
     var type = data.type;
     var leaveClass = data.leaveClass;
     var leaveToClass = data.leaveToClass;
     var leaveActiveClass = data.leaveActiveClass;
     var beforeLeave = data.beforeLeave;
     var leave = data.leave;
     var afterLeave = data.afterLeave;
     var leaveCancelled = data.leaveCancelled;
     var delayLeave = data.delayLeave;
     var duration = data.duration;
   
     var expectsCSS = css !== false && !isIE9;
     var userWantsControl = getHookArgumentsLength(leave);
   
     var explicitLeaveDuration = toNumber(
       isObject(duration)
         ? duration.leave
         : duration
     );
   
     if (false) {}
   
     var cb = el._leaveCb = once(function () {
       if (el.parentNode && el.parentNode._pending) {
         el.parentNode._pending[vnode.key] = null;
       }
       if (expectsCSS) {
         removeTransitionClass(el, leaveToClass);
         removeTransitionClass(el, leaveActiveClass);
       }
       if (cb.cancelled) {
         if (expectsCSS) {
           removeTransitionClass(el, leaveClass);
         }
         leaveCancelled && leaveCancelled(el);
       } else {
         rm();
         afterLeave && afterLeave(el);
       }
       el._leaveCb = null;
     });
   
     if (delayLeave) {
       delayLeave(performLeave);
     } else {
       performLeave();
     }
   
     function performLeave () {
       // the delayed leave may have already been cancelled
       if (cb.cancelled) {
         return
       }
       // record leaving element
       if (!vnode.data.show && el.parentNode) {
         (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
       }
       beforeLeave && beforeLeave(el);
       if (expectsCSS) {
         addTransitionClass(el, leaveClass);
         addTransitionClass(el, leaveActiveClass);
         nextFrame(function () {
           removeTransitionClass(el, leaveClass);
           if (!cb.cancelled) {
             addTransitionClass(el, leaveToClass);
             if (!userWantsControl) {
               if (isValidDuration(explicitLeaveDuration)) {
                 setTimeout(cb, explicitLeaveDuration);
               } else {
                 whenTransitionEnds(el, type, cb);
               }
             }
           }
         });
       }
       leave && leave(el, cb);
       if (!expectsCSS && !userWantsControl) {
         cb();
       }
     }
   }
   
   // only used in dev mode
   function checkDuration (val, name, vnode) {
     if (typeof val !== 'number') {
       warn(
         "<transition> explicit " + name + " duration is not a valid number - " +
         "got " + (JSON.stringify(val)) + ".",
         vnode.context
       );
     } else if (isNaN(val)) {
       warn(
         "<transition> explicit " + name + " duration is NaN - " +
         'the duration expression might be incorrect.',
         vnode.context
       );
     }
   }
   
   function isValidDuration (val) {
     return typeof val === 'number' && !isNaN(val)
   }
   
   /**
    * Normalize a transition hook's argument length. The hook may be:
    * - a merged hook (invoker) with the original in .fns
    * - a wrapped component method (check ._length)
    * - a plain function (.length)
    */
   function getHookArgumentsLength (fn) {
     if (isUndef(fn)) {
       return false
     }
     var invokerFns = fn.fns;
     if (isDef(invokerFns)) {
       // invoker
       return getHookArgumentsLength(
         Array.isArray(invokerFns)
           ? invokerFns[0]
           : invokerFns
       )
     } else {
       return (fn._length || fn.length) > 1
     }
   }
   
   function _enter (_, vnode) {
     if (vnode.data.show !== true) {
       enter(vnode);
     }
   }
   
   var transition = inBrowser ? {
     create: _enter,
     activate: _enter,
     remove: function remove$$1 (vnode, rm) {
       /* istanbul ignore else */
       if (vnode.data.show !== true) {
         leave(vnode, rm);
       } else {
         rm();
       }
     }
   } : {};
   
   var platformModules = [
     attrs,
     klass,
     events,
     domProps,
     style,
     transition
   ];
   
   /*  */
   
   // the directive module should be applied last, after all
   // built-in modules have been applied.
   var modules = platformModules.concat(baseModules);
   
   var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });
   
   /**
    * Not type checking this file because flow doesn't like attaching
    * properties to Elements.
    */
   
   /* istanbul ignore if */
   if (isIE9) {
     // http://www.matts411.com/post/internet-explorer-9-oninput/
     document.addEventListener('selectionchange', function () {
       var el = document.activeElement;
       if (el && el.vmodel) {
         trigger(el, 'input');
       }
     });
   }
   
   var directive = {
     inserted: function inserted (el, binding, vnode, oldVnode) {
       if (vnode.tag === 'select') {
         // #6903
         if (oldVnode.elm && !oldVnode.elm._vOptions) {
           mergeVNodeHook(vnode, 'postpatch', function () {
             directive.componentUpdated(el, binding, vnode);
           });
         } else {
           setSelected(el, binding, vnode.context);
         }
         el._vOptions = [].map.call(el.options, getValue);
       } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
         el._vModifiers = binding.modifiers;
         if (!binding.modifiers.lazy) {
           el.addEventListener('compositionstart', onCompositionStart);
           el.addEventListener('compositionend', onCompositionEnd);
           // Safari < 10.2 & UIWebView doesn't fire compositionend when
           // switching focus before confirming composition choice
           // this also fixes the issue where some browsers e.g. iOS Chrome
           // fires "change" instead of "input" on autocomplete.
           el.addEventListener('change', onCompositionEnd);
           /* istanbul ignore if */
           if (isIE9) {
             el.vmodel = true;
           }
         }
       }
     },
   
     componentUpdated: function componentUpdated (el, binding, vnode) {
       if (vnode.tag === 'select') {
         setSelected(el, binding, vnode.context);
         // in case the options rendered by v-for have changed,
         // it's possible that the value is out-of-sync with the rendered options.
         // detect such cases and filter out values that no longer has a matching
         // option in the DOM.
         var prevOptions = el._vOptions;
         var curOptions = el._vOptions = [].map.call(el.options, getValue);
         if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
           // trigger change event if
           // no matching option found for at least one value
           var needReset = el.multiple
             ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
             : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
           if (needReset) {
             trigger(el, 'change');
           }
         }
       }
     }
   };
   
   function setSelected (el, binding, vm) {
     actuallySetSelected(el, binding, vm);
     /* istanbul ignore if */
     if (isIE || isEdge) {
       setTimeout(function () {
         actuallySetSelected(el, binding, vm);
       }, 0);
     }
   }
   
   function actuallySetSelected (el, binding, vm) {
     var value = binding.value;
     var isMultiple = el.multiple;
     if (isMultiple && !Array.isArray(value)) {
        false && 0;
       return
     }
     var selected, option;
     for (var i = 0, l = el.options.length; i < l; i++) {
       option = el.options[i];
       if (isMultiple) {
         selected = looseIndexOf(value, getValue(option)) > -1;
         if (option.selected !== selected) {
           option.selected = selected;
         }
       } else {
         if (looseEqual(getValue(option), value)) {
           if (el.selectedIndex !== i) {
             el.selectedIndex = i;
           }
           return
         }
       }
     }
     if (!isMultiple) {
       el.selectedIndex = -1;
     }
   }
   
   function hasNoMatchingOption (value, options) {
     return options.every(function (o) { return !looseEqual(o, value); })
   }
   
   function getValue (option) {
     return '_value' in option
       ? option._value
       : option.value
   }
   
   function onCompositionStart (e) {
     e.target.composing = true;
   }
   
   function onCompositionEnd (e) {
     // prevent triggering an input event for no reason
     if (!e.target.composing) { return }
     e.target.composing = false;
     trigger(e.target, 'input');
   }
   
   function trigger (el, type) {
     var e = document.createEvent('HTMLEvents');
     e.initEvent(type, true, true);
     el.dispatchEvent(e);
   }
   
   /*  */
   
   // recursively search for possible transition defined inside the component root
   function locateNode (vnode) {
     return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
       ? locateNode(vnode.componentInstance._vnode)
       : vnode
   }
   
   var show = {
     bind: function bind (el, ref, vnode) {
       var value = ref.value;
   
       vnode = locateNode(vnode);
       var transition$$1 = vnode.data && vnode.data.transition;
       var originalDisplay = el.__vOriginalDisplay =
         el.style.display === 'none' ? '' : el.style.display;
       if (value && transition$$1) {
         vnode.data.show = true;
         enter(vnode, function () {
           el.style.display = originalDisplay;
         });
       } else {
         el.style.display = value ? originalDisplay : 'none';
       }
     },
   
     update: function update (el, ref, vnode) {
       var value = ref.value;
       var oldValue = ref.oldValue;
   
       /* istanbul ignore if */
       if (!value === !oldValue) { return }
       vnode = locateNode(vnode);
       var transition$$1 = vnode.data && vnode.data.transition;
       if (transition$$1) {
         vnode.data.show = true;
         if (value) {
           enter(vnode, function () {
             el.style.display = el.__vOriginalDisplay;
           });
         } else {
           leave(vnode, function () {
             el.style.display = 'none';
           });
         }
       } else {
         el.style.display = value ? el.__vOriginalDisplay : 'none';
       }
     },
   
     unbind: function unbind (
       el,
       binding,
       vnode,
       oldVnode,
       isDestroy
     ) {
       if (!isDestroy) {
         el.style.display = el.__vOriginalDisplay;
       }
     }
   };
   
   var platformDirectives = {
     model: directive,
     show: show
   };
   
   /*  */
   
   var transitionProps = {
     name: String,
     appear: Boolean,
     css: Boolean,
     mode: String,
     type: String,
     enterClass: String,
     leaveClass: String,
     enterToClass: String,
     leaveToClass: String,
     enterActiveClass: String,
     leaveActiveClass: String,
     appearClass: String,
     appearActiveClass: String,
     appearToClass: String,
     duration: [Number, String, Object]
   };
   
   // in case the child is also an abstract component, e.g. <keep-alive>
   // we want to recursively retrieve the real component to be rendered
   function getRealChild (vnode) {
     var compOptions = vnode && vnode.componentOptions;
     if (compOptions && compOptions.Ctor.options.abstract) {
       return getRealChild(getFirstComponentChild(compOptions.children))
     } else {
       return vnode
     }
   }
   
   function extractTransitionData (comp) {
     var data = {};
     var options = comp.$options;
     // props
     for (var key in options.propsData) {
       data[key] = comp[key];
     }
     // events.
     // extract listeners and pass them directly to the transition methods
     var listeners = options._parentListeners;
     for (var key$1 in listeners) {
       data[camelize(key$1)] = listeners[key$1];
     }
     return data
   }
   
   function placeholder (h, rawChild) {
     if (/\d-keep-alive$/.test(rawChild.tag)) {
       return h('keep-alive', {
         props: rawChild.componentOptions.propsData
       })
     }
   }
   
   function hasParentTransition (vnode) {
     while ((vnode = vnode.parent)) {
       if (vnode.data.transition) {
         return true
       }
     }
   }
   
   function isSameChild (child, oldChild) {
     return oldChild.key === child.key && oldChild.tag === child.tag
   }
   
   var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
   
   var isVShowDirective = function (d) { return d.name === 'show'; };
   
   var Transition = {
     name: 'transition',
     props: transitionProps,
     abstract: true,
   
     render: function render (h) {
       var this$1 = this;
   
       var children = this.$slots.default;
       if (!children) {
         return
       }
   
       // filter out text nodes (possible whitespaces)
       children = children.filter(isNotTextNode);
       /* istanbul ignore if */
       if (!children.length) {
         return
       }
   
       // warn multiple elements
       if (false) {}
   
       var mode = this.mode;
   
       // warn invalid mode
       if (false
       ) {}
   
       var rawChild = children[0];
   
       // if this is a component root node and the component's
       // parent container node also has transition, skip.
       if (hasParentTransition(this.$vnode)) {
         return rawChild
       }
   
       // apply transition data to child
       // use getRealChild() to ignore abstract components e.g. keep-alive
       var child = getRealChild(rawChild);
       /* istanbul ignore if */
       if (!child) {
         return rawChild
       }
   
       if (this._leaving) {
         return placeholder(h, rawChild)
       }
   
       // ensure a key that is unique to the vnode type and to this transition
       // component instance. This key will be used to remove pending leaving nodes
       // during entering.
       var id = "__transition-" + (this._uid) + "-";
       child.key = child.key == null
         ? child.isComment
           ? id + 'comment'
           : id + child.tag
         : isPrimitive(child.key)
           ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
           : child.key;
   
       var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
       var oldRawChild = this._vnode;
       var oldChild = getRealChild(oldRawChild);
   
       // mark v-show
       // so that the transition module can hand over the control to the directive
       if (child.data.directives && child.data.directives.some(isVShowDirective)) {
         child.data.show = true;
       }
   
       if (
         oldChild &&
         oldChild.data &&
         !isSameChild(child, oldChild) &&
         !isAsyncPlaceholder(oldChild) &&
         // #6687 component root is a comment node
         !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
       ) {
         // replace old child transition data with fresh one
         // important for dynamic transitions!
         var oldData = oldChild.data.transition = extend({}, data);
         // handle transition mode
         if (mode === 'out-in') {
           // return placeholder node and queue update when leave finishes
           this._leaving = true;
           mergeVNodeHook(oldData, 'afterLeave', function () {
             this$1._leaving = false;
             this$1.$forceUpdate();
           });
           return placeholder(h, rawChild)
         } else if (mode === 'in-out') {
           if (isAsyncPlaceholder(child)) {
             return oldRawChild
           }
           var delayedLeave;
           var performLeave = function () { delayedLeave(); };
           mergeVNodeHook(data, 'afterEnter', performLeave);
           mergeVNodeHook(data, 'enterCancelled', performLeave);
           mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
         }
       }
   
       return rawChild
     }
   };
   
   /*  */
   
   var props = extend({
     tag: String,
     moveClass: String
   }, transitionProps);
   
   delete props.mode;
   
   var TransitionGroup = {
     props: props,
   
     beforeMount: function beforeMount () {
       var this$1 = this;
   
       var update = this._update;
       this._update = function (vnode, hydrating) {
         var restoreActiveInstance = setActiveInstance(this$1);
         // force removing pass
         this$1.__patch__(
           this$1._vnode,
           this$1.kept,
           false, // hydrating
           true // removeOnly (!important, avoids unnecessary moves)
         );
         this$1._vnode = this$1.kept;
         restoreActiveInstance();
         update.call(this$1, vnode, hydrating);
       };
     },
   
     render: function render (h) {
       var tag = this.tag || this.$vnode.data.tag || 'span';
       var map = Object.create(null);
       var prevChildren = this.prevChildren = this.children;
       var rawChildren = this.$slots.default || [];
       var children = this.children = [];
       var transitionData = extractTransitionData(this);
   
       for (var i = 0; i < rawChildren.length; i++) {
         var c = rawChildren[i];
         if (c.tag) {
           if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
             children.push(c);
             map[c.key] = c
             ;(c.data || (c.data = {})).transition = transitionData;
           } else if (false) { var name, opts; }
         }
       }
   
       if (prevChildren) {
         var kept = [];
         var removed = [];
         for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
           var c$1 = prevChildren[i$1];
           c$1.data.transition = transitionData;
           c$1.data.pos = c$1.elm.getBoundingClientRect();
           if (map[c$1.key]) {
             kept.push(c$1);
           } else {
             removed.push(c$1);
           }
         }
         this.kept = h(tag, null, kept);
         this.removed = removed;
       }
   
       return h(tag, null, children)
     },
   
     updated: function updated () {
       var children = this.prevChildren;
       var moveClass = this.moveClass || ((this.name || 'v') + '-move');
       if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
         return
       }
   
       // we divide the work into three loops to avoid mixing DOM reads and writes
       // in each iteration - which helps prevent layout thrashing.
       children.forEach(callPendingCbs);
       children.forEach(recordPosition);
       children.forEach(applyTranslation);
   
       // force reflow to put everything in position
       // assign to this to avoid being removed in tree-shaking
       // $flow-disable-line
       this._reflow = document.body.offsetHeight;
   
       children.forEach(function (c) {
         if (c.data.moved) {
           var el = c.elm;
           var s = el.style;
           addTransitionClass(el, moveClass);
           s.transform = s.WebkitTransform = s.transitionDuration = '';
           el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
             if (e && e.target !== el) {
               return
             }
             if (!e || /transform$/.test(e.propertyName)) {
               el.removeEventListener(transitionEndEvent, cb);
               el._moveCb = null;
               removeTransitionClass(el, moveClass);
             }
           });
         }
       });
     },
   
     methods: {
       hasMove: function hasMove (el, moveClass) {
         /* istanbul ignore if */
         if (!hasTransition) {
           return false
         }
         /* istanbul ignore if */
         if (this._hasMove) {
           return this._hasMove
         }
         // Detect whether an element with the move class applied has
         // CSS transitions. Since the element may be inside an entering
         // transition at this very moment, we make a clone of it and remove
         // all other transition classes applied to ensure only the move class
         // is applied.
         var clone = el.cloneNode();
         if (el._transitionClasses) {
           el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
         }
         addClass(clone, moveClass);
         clone.style.display = 'none';
         this.$el.appendChild(clone);
         var info = getTransitionInfo(clone);
         this.$el.removeChild(clone);
         return (this._hasMove = info.hasTransform)
       }
     }
   };
   
   function callPendingCbs (c) {
     /* istanbul ignore if */
     if (c.elm._moveCb) {
       c.elm._moveCb();
     }
     /* istanbul ignore if */
     if (c.elm._enterCb) {
       c.elm._enterCb();
     }
   }
   
   function recordPosition (c) {
     c.data.newPos = c.elm.getBoundingClientRect();
   }
   
   function applyTranslation (c) {
     var oldPos = c.data.pos;
     var newPos = c.data.newPos;
     var dx = oldPos.left - newPos.left;
     var dy = oldPos.top - newPos.top;
     if (dx || dy) {
       c.data.moved = true;
       var s = c.elm.style;
       s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
       s.transitionDuration = '0s';
     }
   }
   
   var platformComponents = {
     Transition: Transition,
     TransitionGroup: TransitionGroup
   };
   
   /*  */
   
   // install platform specific utils
   vue_esm_Vue.config.mustUseProp = mustUseProp;
   vue_esm_Vue.config.isReservedTag = isReservedTag;
   vue_esm_Vue.config.isReservedAttr = isReservedAttr;
   vue_esm_Vue.config.getTagNamespace = getTagNamespace;
   vue_esm_Vue.config.isUnknownElement = isUnknownElement;
   
   // install platform runtime directives & components
   extend(vue_esm_Vue.options.directives, platformDirectives);
   extend(vue_esm_Vue.options.components, platformComponents);
   
   // install platform patch function
   vue_esm_Vue.prototype.__patch__ = inBrowser ? patch : noop;
   
   // public mount method
   vue_esm_Vue.prototype.$mount = function (
     el,
     hydrating
   ) {
     el = el && inBrowser ? query(el) : undefined;
     return mountComponent(this, el, hydrating)
   };
   
   // devtools global hook
   /* istanbul ignore next */
   if (inBrowser) {
     setTimeout(function () {
       if (config.devtools) {
         if (devtools) {
           devtools.emit('init', vue_esm_Vue);
         } else if (
           false
         ) {}
       }
       if (false
       ) {}
     }, 0);
   }
   
   /*  */
   
   var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
   var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
   
   var buildRegex = cached(function (delimiters) {
     var open = delimiters[0].replace(regexEscapeRE, '\\$&');
     var close = delimiters[1].replace(regexEscapeRE, '\\$&');
     return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
   });
   
   
   
   function parseText (
     text,
     delimiters
   ) {
     var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
     if (!tagRE.test(text)) {
       return
     }
     var tokens = [];
     var rawTokens = [];
     var lastIndex = tagRE.lastIndex = 0;
     var match, index, tokenValue;
     while ((match = tagRE.exec(text))) {
       index = match.index;
       // push text token
       if (index > lastIndex) {
         rawTokens.push(tokenValue = text.slice(lastIndex, index));
         tokens.push(JSON.stringify(tokenValue));
       }
       // tag token
       var exp = parseFilters(match[1].trim());
       tokens.push(("_s(" + exp + ")"));
       rawTokens.push({ '@binding': exp });
       lastIndex = index + match[0].length;
     }
     if (lastIndex < text.length) {
       rawTokens.push(tokenValue = text.slice(lastIndex));
       tokens.push(JSON.stringify(tokenValue));
     }
     return {
       expression: tokens.join('+'),
       tokens: rawTokens
     }
   }
   
   /*  */
   
   function transformNode (el, options) {
     var warn = options.warn || baseWarn;
     var staticClass = getAndRemoveAttr(el, 'class');
     if (false) { var res; }
     if (staticClass) {
       el.staticClass = JSON.stringify(staticClass);
     }
     var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
     if (classBinding) {
       el.classBinding = classBinding;
     }
   }
   
   function genData (el) {
     var data = '';
     if (el.staticClass) {
       data += "staticClass:" + (el.staticClass) + ",";
     }
     if (el.classBinding) {
       data += "class:" + (el.classBinding) + ",";
     }
     return data
   }
   
   var klass$1 = {
     staticKeys: ['staticClass'],
     transformNode: transformNode,
     genData: genData
   };
   
   /*  */
   
   function transformNode$1 (el, options) {
     var warn = options.warn || baseWarn;
     var staticStyle = getAndRemoveAttr(el, 'style');
     if (staticStyle) {
       /* istanbul ignore if */
       if (false) { var res; }
       el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
     }
   
     var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
     if (styleBinding) {
       el.styleBinding = styleBinding;
     }
   }
   
   function genData$1 (el) {
     var data = '';
     if (el.staticStyle) {
       data += "staticStyle:" + (el.staticStyle) + ",";
     }
     if (el.styleBinding) {
       data += "style:(" + (el.styleBinding) + "),";
     }
     return data
   }
   
   var style$1 = {
     staticKeys: ['staticStyle'],
     transformNode: transformNode$1,
     genData: genData$1
   };
   
   /*  */
   
   var decoder;
   
   var he = {
     decode: function decode (html) {
       decoder = decoder || document.createElement('div');
       decoder.innerHTML = html;
       return decoder.textContent
     }
   };
   
   /*  */
   
   var isUnaryTag = makeMap(
     'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
     'link,meta,param,source,track,wbr'
   );
   
   // Elements that you can, intentionally, leave open
   // (and which close themselves)
   var canBeLeftOpenTag = makeMap(
     'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
   );
   
   // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
   // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
   var isNonPhrasingTag = makeMap(
     'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
     'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
     'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
     'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
     'title,tr,track'
   );
   
   /**
    * Not type-checking this file because it's mostly vendor code.
    */
   
   // Regular Expressions for parsing tags and attributes
   var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
   var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
   var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
   var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
   var startTagOpen = new RegExp(("^<" + qnameCapture));
   var startTagClose = /^\s*(\/?)>/;
   var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
   var doctype = /^<!DOCTYPE [^>]+>/i;
   // #7298: escape - to avoid being passed as HTML comment when inlined in page
   var comment = /^<!\--/;
   var conditionalComment = /^<!\[/;
   
   // Special Elements (can contain anything)
   var isPlainTextElement = makeMap('script,style,textarea', true);
   var reCache = {};
   
   var decodingMap = {
     '&lt;': '<',
     '&gt;': '>',
     '&quot;': '"',
     '&amp;': '&',
     '&#10;': '\n',
     '&#9;': '\t',
     '&#39;': "'"
   };
   var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
   var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
   
   // #5992
   var isIgnoreNewlineTag = makeMap('pre,textarea', true);
   var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };
   
   function decodeAttr (value, shouldDecodeNewlines) {
     var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
     return value.replace(re, function (match) { return decodingMap[match]; })
   }
   
   function parseHTML (html, options) {
     var stack = [];
     var expectHTML = options.expectHTML;
     var isUnaryTag$$1 = options.isUnaryTag || no;
     var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
     var index = 0;
     var last, lastTag;
     while (html) {
       last = html;
       // Make sure we're not in a plaintext content element like script/style
       if (!lastTag || !isPlainTextElement(lastTag)) {
         var textEnd = html.indexOf('<');
         if (textEnd === 0) {
           // Comment:
           if (comment.test(html)) {
             var commentEnd = html.indexOf('-->');
   
             if (commentEnd >= 0) {
               if (options.shouldKeepComment) {
                 options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
               }
               advance(commentEnd + 3);
               continue
             }
           }
   
           // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
           if (conditionalComment.test(html)) {
             var conditionalEnd = html.indexOf(']>');
   
             if (conditionalEnd >= 0) {
               advance(conditionalEnd + 2);
               continue
             }
           }
   
           // Doctype:
           var doctypeMatch = html.match(doctype);
           if (doctypeMatch) {
             advance(doctypeMatch[0].length);
             continue
           }
   
           // End tag:
           var endTagMatch = html.match(endTag);
           if (endTagMatch) {
             var curIndex = index;
             advance(endTagMatch[0].length);
             parseEndTag(endTagMatch[1], curIndex, index);
             continue
           }
   
           // Start tag:
           var startTagMatch = parseStartTag();
           if (startTagMatch) {
             handleStartTag(startTagMatch);
             if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
               advance(1);
             }
             continue
           }
         }
   
         var text = (void 0), rest = (void 0), next = (void 0);
         if (textEnd >= 0) {
           rest = html.slice(textEnd);
           while (
             !endTag.test(rest) &&
             !startTagOpen.test(rest) &&
             !comment.test(rest) &&
             !conditionalComment.test(rest)
           ) {
             // < in plain text, be forgiving and treat it as text
             next = rest.indexOf('<', 1);
             if (next < 0) { break }
             textEnd += next;
             rest = html.slice(textEnd);
           }
           text = html.substring(0, textEnd);
         }
   
         if (textEnd < 0) {
           text = html;
         }
   
         if (text) {
           advance(text.length);
         }
   
         if (options.chars && text) {
           options.chars(text, index - text.length, index);
         }
       } else {
         var endTagLength = 0;
         var stackedTag = lastTag.toLowerCase();
         var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
         var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
           endTagLength = endTag.length;
           if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
             text = text
               .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
               .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
           }
           if (shouldIgnoreFirstNewline(stackedTag, text)) {
             text = text.slice(1);
           }
           if (options.chars) {
             options.chars(text);
           }
           return ''
         });
         index += html.length - rest$1.length;
         html = rest$1;
         parseEndTag(stackedTag, index - endTagLength, index);
       }
   
       if (html === last) {
         options.chars && options.chars(html);
         if (false) {}
         break
       }
     }
   
     // Clean up any remaining tags
     parseEndTag();
   
     function advance (n) {
       index += n;
       html = html.substring(n);
     }
   
     function parseStartTag () {
       var start = html.match(startTagOpen);
       if (start) {
         var match = {
           tagName: start[1],
           attrs: [],
           start: index
         };
         advance(start[0].length);
         var end, attr;
         while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
           attr.start = index;
           advance(attr[0].length);
           attr.end = index;
           match.attrs.push(attr);
         }
         if (end) {
           match.unarySlash = end[1];
           advance(end[0].length);
           match.end = index;
           return match
         }
       }
     }
   
     function handleStartTag (match) {
       var tagName = match.tagName;
       var unarySlash = match.unarySlash;
   
       if (expectHTML) {
         if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
           parseEndTag(lastTag);
         }
         if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
           parseEndTag(tagName);
         }
       }
   
       var unary = isUnaryTag$$1(tagName) || !!unarySlash;
   
       var l = match.attrs.length;
       var attrs = new Array(l);
       for (var i = 0; i < l; i++) {
         var args = match.attrs[i];
         var value = args[3] || args[4] || args[5] || '';
         var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
           ? options.shouldDecodeNewlinesForHref
           : options.shouldDecodeNewlines;
         attrs[i] = {
           name: args[1],
           value: decodeAttr(value, shouldDecodeNewlines)
         };
         if (false) {}
       }
   
       if (!unary) {
         stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
         lastTag = tagName;
       }
   
       if (options.start) {
         options.start(tagName, attrs, unary, match.start, match.end);
       }
     }
   
     function parseEndTag (tagName, start, end) {
       var pos, lowerCasedTagName;
       if (start == null) { start = index; }
       if (end == null) { end = index; }
   
       // Find the closest opened tag of the same type
       if (tagName) {
         lowerCasedTagName = tagName.toLowerCase();
         for (pos = stack.length - 1; pos >= 0; pos--) {
           if (stack[pos].lowerCasedTag === lowerCasedTagName) {
             break
           }
         }
       } else {
         // If no tag name is provided, clean shop
         pos = 0;
       }
   
       if (pos >= 0) {
         // Close all the open elements, up the stack
         for (var i = stack.length - 1; i >= pos; i--) {
           if (false
           ) {}
           if (options.end) {
             options.end(stack[i].tag, start, end);
           }
         }
   
         // Remove the open elements from the stack
         stack.length = pos;
         lastTag = pos && stack[pos - 1].tag;
       } else if (lowerCasedTagName === 'br') {
         if (options.start) {
           options.start(tagName, [], true, start, end);
         }
       } else if (lowerCasedTagName === 'p') {
         if (options.start) {
           options.start(tagName, [], false, start, end);
         }
         if (options.end) {
           options.end(tagName, start, end);
         }
       }
     }
   }
   
   /*  */
   
   var onRE = /^@|^v-on:/;
   var dirRE = /^v-|^@|^:|^#/;
   var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
   var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
   var stripParensRE = /^\(|\)$/g;
   var dynamicArgRE = /^\[.*\]$/;
   
   var argRE = /:(.*)$/;
   var bindRE = /^:|^\.|^v-bind:/;
   var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
   
   var slotRE = /^v-slot(:|$)|^#/;
   
   var lineBreakRE = /[\r\n]/;
   var whitespaceRE$1 = /[ \f\t\r\n]+/g;
   
   var invalidAttributeRE = /[\s"'<>\/=]/;
   
   var decodeHTMLCached = cached(he.decode);
   
   var emptySlotScopeToken = "_empty_";
   
   // configurable state
   var warn$2;
   var delimiters;
   var transforms;
   var preTransforms;
   var postTransforms;
   var platformIsPreTag;
   var platformMustUseProp;
   var platformGetTagNamespace;
   var maybeComponent;
   
   function createASTElement (
     tag,
     attrs,
     parent
   ) {
     return {
       type: 1,
       tag: tag,
       attrsList: attrs,
       attrsMap: makeAttrsMap(attrs),
       rawAttrsMap: {},
       parent: parent,
       children: []
     }
   }
   
   /**
    * Convert HTML string to AST.
    */
   function parse (
     template,
     options
   ) {
     warn$2 = options.warn || baseWarn;
   
     platformIsPreTag = options.isPreTag || no;
     platformMustUseProp = options.mustUseProp || no;
     platformGetTagNamespace = options.getTagNamespace || no;
     var isReservedTag = options.isReservedTag || no;
     maybeComponent = function (el) { return !!(
       el.component ||
       el.attrsMap[':is'] ||
       el.attrsMap['v-bind:is'] ||
       !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
     ); };
     transforms = pluckModuleFunction(options.modules, 'transformNode');
     preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
     postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
   
     delimiters = options.delimiters;
   
     var stack = [];
     var preserveWhitespace = options.preserveWhitespace !== false;
     var whitespaceOption = options.whitespace;
     var root;
     var currentParent;
     var inVPre = false;
     var inPre = false;
     var warned = false;
   
     function warnOnce (msg, range) {
       if (!warned) {
         warned = true;
         warn$2(msg, range);
       }
     }
   
     function closeElement (element) {
       trimEndingWhitespace(element);
       if (!inVPre && !element.processed) {
         element = processElement(element, options);
       }
       // tree management
       if (!stack.length && element !== root) {
         // allow root elements with v-if, v-else-if and v-else
         if (root.if && (element.elseif || element.else)) {
           if (false) {}
           addIfCondition(root, {
             exp: element.elseif,
             block: element
           });
         } else if (false) {}
       }
       if (currentParent && !element.forbidden) {
         if (element.elseif || element.else) {
           processIfConditions(element, currentParent);
         } else {
           if (element.slotScope) {
             // scoped slot
             // keep it in the children list so that v-else(-if) conditions can
             // find it as the prev node.
             var name = element.slotTarget || '"default"'
             ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
           }
           currentParent.children.push(element);
           element.parent = currentParent;
         }
       }
   
       // final children cleanup
       // filter out scoped slots
       element.children = element.children.filter(function (c) { return !(c).slotScope; });
       // remove trailing whitespace node again
       trimEndingWhitespace(element);
   
       // check pre state
       if (element.pre) {
         inVPre = false;
       }
       if (platformIsPreTag(element.tag)) {
         inPre = false;
       }
       // apply post-transforms
       for (var i = 0; i < postTransforms.length; i++) {
         postTransforms[i](element, options);
       }
     }
   
     function trimEndingWhitespace (el) {
       // remove trailing whitespace node
       if (!inPre) {
         var lastNode;
         while (
           (lastNode = el.children[el.children.length - 1]) &&
           lastNode.type === 3 &&
           lastNode.text === ' '
         ) {
           el.children.pop();
         }
       }
     }
   
     function checkRootConstraints (el) {
       if (el.tag === 'slot' || el.tag === 'template') {
         warnOnce(
           "Cannot use <" + (el.tag) + "> as component root element because it may " +
           'contain multiple nodes.',
           { start: el.start }
         );
       }
       if (el.attrsMap.hasOwnProperty('v-for')) {
         warnOnce(
           'Cannot use v-for on stateful component root element because ' +
           'it renders multiple elements.',
           el.rawAttrsMap['v-for']
         );
       }
     }
   
     parseHTML(template, {
       warn: warn$2,
       expectHTML: options.expectHTML,
       isUnaryTag: options.isUnaryTag,
       canBeLeftOpenTag: options.canBeLeftOpenTag,
       shouldDecodeNewlines: options.shouldDecodeNewlines,
       shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
       shouldKeepComment: options.comments,
       outputSourceRange: options.outputSourceRange,
       start: function start (tag, attrs, unary, start$1, end) {
         // check namespace.
         // inherit parent ns if there is one
         var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
   
         // handle IE svg bug
         /* istanbul ignore if */
         if (isIE && ns === 'svg') {
           attrs = guardIESVGBug(attrs);
         }
   
         var element = createASTElement(tag, attrs, currentParent);
         if (ns) {
           element.ns = ns;
         }
   
         if (false) {}
   
         if (isForbiddenTag(element) && !isServerRendering()) {
           element.forbidden = true;
            false && 0;
         }
   
         // apply pre-transforms
         for (var i = 0; i < preTransforms.length; i++) {
           element = preTransforms[i](element, options) || element;
         }
   
         if (!inVPre) {
           processPre(element);
           if (element.pre) {
             inVPre = true;
           }
         }
         if (platformIsPreTag(element.tag)) {
           inPre = true;
         }
         if (inVPre) {
           processRawAttrs(element);
         } else if (!element.processed) {
           // structural directives
           processFor(element);
           processIf(element);
           processOnce(element);
         }
   
         if (!root) {
           root = element;
           if (false) {}
         }
   
         if (!unary) {
           currentParent = element;
           stack.push(element);
         } else {
           closeElement(element);
         }
       },
   
       end: function end (tag, start, end$1) {
         var element = stack[stack.length - 1];
         // pop stack
         stack.length -= 1;
         currentParent = stack[stack.length - 1];
         if (false) {}
         closeElement(element);
       },
   
       chars: function chars (text, start, end) {
         if (!currentParent) {
           if (false) {}
           return
         }
         // IE textarea placeholder bug
         /* istanbul ignore if */
         if (isIE &&
           currentParent.tag === 'textarea' &&
           currentParent.attrsMap.placeholder === text
         ) {
           return
         }
         var children = currentParent.children;
         if (inPre || text.trim()) {
           text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
         } else if (!children.length) {
           // remove the whitespace-only node right after an opening tag
           text = '';
         } else if (whitespaceOption) {
           if (whitespaceOption === 'condense') {
             // in condense mode, remove the whitespace node if it contains
             // line break, otherwise condense to a single space
             text = lineBreakRE.test(text) ? '' : ' ';
           } else {
             text = ' ';
           }
         } else {
           text = preserveWhitespace ? ' ' : '';
         }
         if (text) {
           if (!inPre && whitespaceOption === 'condense') {
             // condense consecutive whitespaces into single space
             text = text.replace(whitespaceRE$1, ' ');
           }
           var res;
           var child;
           if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
             child = {
               type: 2,
               expression: res.expression,
               tokens: res.tokens,
               text: text
             };
           } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
             child = {
               type: 3,
               text: text
             };
           }
           if (child) {
             if (false) {}
             children.push(child);
           }
         }
       },
       comment: function comment (text, start, end) {
         // adding anything as a sibling to the root node is forbidden
         // comments should still be allowed, but ignored
         if (currentParent) {
           var child = {
             type: 3,
             text: text,
             isComment: true
           };
           if (false) {}
           currentParent.children.push(child);
         }
       }
     });
     return root
   }
   
   function processPre (el) {
     if (getAndRemoveAttr(el, 'v-pre') != null) {
       el.pre = true;
     }
   }
   
   function processRawAttrs (el) {
     var list = el.attrsList;
     var len = list.length;
     if (len) {
       var attrs = el.attrs = new Array(len);
       for (var i = 0; i < len; i++) {
         attrs[i] = {
           name: list[i].name,
           value: JSON.stringify(list[i].value)
         };
         if (list[i].start != null) {
           attrs[i].start = list[i].start;
           attrs[i].end = list[i].end;
         }
       }
     } else if (!el.pre) {
       // non root node in pre blocks with no attributes
       el.plain = true;
     }
   }
   
   function processElement (
     element,
     options
   ) {
     processKey(element);
   
     // determine whether this is a plain element after
     // removing structural attributes
     element.plain = (
       !element.key &&
       !element.scopedSlots &&
       !element.attrsList.length
     );
   
     processRef(element);
     processSlotContent(element);
     processSlotOutlet(element);
     processComponent(element);
     for (var i = 0; i < transforms.length; i++) {
       element = transforms[i](element, options) || element;
     }
     processAttrs(element);
     return element
   }
   
   function processKey (el) {
     var exp = getBindingAttr(el, 'key');
     if (exp) {
       if (false) { var parent, iterator; }
       el.key = exp;
     }
   }
   
   function processRef (el) {
     var ref = getBindingAttr(el, 'ref');
     if (ref) {
       el.ref = ref;
       el.refInFor = checkInFor(el);
     }
   }
   
   function processFor (el) {
     var exp;
     if ((exp = getAndRemoveAttr(el, 'v-for'))) {
       var res = parseFor(exp);
       if (res) {
         extend(el, res);
       } else if (false) {}
     }
   }
   
   
   
   function parseFor (exp) {
     var inMatch = exp.match(forAliasRE);
     if (!inMatch) { return }
     var res = {};
     res.for = inMatch[2].trim();
     var alias = inMatch[1].trim().replace(stripParensRE, '');
     var iteratorMatch = alias.match(forIteratorRE);
     if (iteratorMatch) {
       res.alias = alias.replace(forIteratorRE, '').trim();
       res.iterator1 = iteratorMatch[1].trim();
       if (iteratorMatch[2]) {
         res.iterator2 = iteratorMatch[2].trim();
       }
     } else {
       res.alias = alias;
     }
     return res
   }
   
   function processIf (el) {
     var exp = getAndRemoveAttr(el, 'v-if');
     if (exp) {
       el.if = exp;
       addIfCondition(el, {
         exp: exp,
         block: el
       });
     } else {
       if (getAndRemoveAttr(el, 'v-else') != null) {
         el.else = true;
       }
       var elseif = getAndRemoveAttr(el, 'v-else-if');
       if (elseif) {
         el.elseif = elseif;
       }
     }
   }
   
   function processIfConditions (el, parent) {
     var prev = findPrevElement(parent.children);
     if (prev && prev.if) {
       addIfCondition(prev, {
         exp: el.elseif,
         block: el
       });
     } else if (false) {}
   }
   
   function findPrevElement (children) {
     var i = children.length;
     while (i--) {
       if (children[i].type === 1) {
         return children[i]
       } else {
         if (false) {}
         children.pop();
       }
     }
   }
   
   function addIfCondition (el, condition) {
     if (!el.ifConditions) {
       el.ifConditions = [];
     }
     el.ifConditions.push(condition);
   }
   
   function processOnce (el) {
     var once$$1 = getAndRemoveAttr(el, 'v-once');
     if (once$$1 != null) {
       el.once = true;
     }
   }
   
   // handle content being passed to a component as slot,
   // e.g. <template slot="xxx">, <div slot-scope="xxx">
   function processSlotContent (el) {
     var slotScope;
     if (el.tag === 'template') {
       slotScope = getAndRemoveAttr(el, 'scope');
       /* istanbul ignore if */
       if (false) {}
       el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
     } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
       /* istanbul ignore if */
       if (false) {}
       el.slotScope = slotScope;
     }
   
     // slot="xxx"
     var slotTarget = getBindingAttr(el, 'slot');
     if (slotTarget) {
       el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
       el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
       // preserve slot as an attribute for native shadow DOM compat
       // only for non-scoped slots.
       if (el.tag !== 'template' && !el.slotScope) {
         addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
       }
     }
   
     // 2.6 v-slot syntax
     {
       if (el.tag === 'template') {
         // v-slot on <template>
         var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
         if (slotBinding) {
           if (false) {}
           var ref = getSlotName(slotBinding);
           var name = ref.name;
           var dynamic = ref.dynamic;
           el.slotTarget = name;
           el.slotTargetDynamic = dynamic;
           el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
         }
       } else {
         // v-slot on component, denotes default slot
         var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
         if (slotBinding$1) {
           if (false) {}
           // add the component's children to its default slot
           var slots = el.scopedSlots || (el.scopedSlots = {});
           var ref$1 = getSlotName(slotBinding$1);
           var name$1 = ref$1.name;
           var dynamic$1 = ref$1.dynamic;
           var slotContainer = slots[name$1] = createASTElement('template', [], el);
           slotContainer.slotTarget = name$1;
           slotContainer.slotTargetDynamic = dynamic$1;
           slotContainer.children = el.children.filter(function (c) {
             if (!c.slotScope) {
               c.parent = slotContainer;
               return true
             }
           });
           slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
           // remove children as they are returned from scopedSlots now
           el.children = [];
           // mark el non-plain so data gets generated
           el.plain = false;
         }
       }
     }
   }
   
   function getSlotName (binding) {
     var name = binding.name.replace(slotRE, '');
     if (!name) {
       if (binding.name[0] !== '#') {
         name = 'default';
       } else if (false) {}
     }
     return dynamicArgRE.test(name)
       // dynamic [name]
       ? { name: name.slice(1, -1), dynamic: true }
       // static name
       : { name: ("\"" + name + "\""), dynamic: false }
   }
   
   // handle <slot/> outlets
   function processSlotOutlet (el) {
     if (el.tag === 'slot') {
       el.slotName = getBindingAttr(el, 'name');
       if (false) {}
     }
   }
   
   function processComponent (el) {
     var binding;
     if ((binding = getBindingAttr(el, 'is'))) {
       el.component = binding;
     }
     if (getAndRemoveAttr(el, 'inline-template') != null) {
       el.inlineTemplate = true;
     }
   }
   
   function processAttrs (el) {
     var list = el.attrsList;
     var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
     for (i = 0, l = list.length; i < l; i++) {
       name = rawName = list[i].name;
       value = list[i].value;
       if (dirRE.test(name)) {
         // mark element as dynamic
         el.hasBindings = true;
         // modifiers
         modifiers = parseModifiers(name.replace(dirRE, ''));
         // support .foo shorthand syntax for the .prop modifier
         if (modifiers) {
           name = name.replace(modifierRE, '');
         }
         if (bindRE.test(name)) { // v-bind
           name = name.replace(bindRE, '');
           value = parseFilters(value);
           isDynamic = dynamicArgRE.test(name);
           if (isDynamic) {
             name = name.slice(1, -1);
           }
           if (
             false
           ) {}
           if (modifiers) {
             if (modifiers.prop && !isDynamic) {
               name = camelize(name);
               if (name === 'innerHtml') { name = 'innerHTML'; }
             }
             if (modifiers.camel && !isDynamic) {
               name = camelize(name);
             }
             if (modifiers.sync) {
               syncGen = genAssignmentCode(value, "$event");
               if (!isDynamic) {
                 addHandler(
                   el,
                   ("update:" + (camelize(name))),
                   syncGen,
                   null,
                   false,
                   warn$2,
                   list[i]
                 );
                 if (hyphenate(name) !== camelize(name)) {
                   addHandler(
                     el,
                     ("update:" + (hyphenate(name))),
                     syncGen,
                     null,
                     false,
                     warn$2,
                     list[i]
                   );
                 }
               } else {
                 // handler w/ dynamic event name
                 addHandler(
                   el,
                   ("\"update:\"+(" + name + ")"),
                   syncGen,
                   null,
                   false,
                   warn$2,
                   list[i],
                   true // dynamic
                 );
               }
             }
           }
           if ((modifiers && modifiers.prop) || (
             !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
           )) {
             addProp(el, name, value, list[i], isDynamic);
           } else {
             addAttr(el, name, value, list[i], isDynamic);
           }
         } else if (onRE.test(name)) { // v-on
           name = name.replace(onRE, '');
           isDynamic = dynamicArgRE.test(name);
           if (isDynamic) {
             name = name.slice(1, -1);
           }
           addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
         } else { // normal directives
           name = name.replace(dirRE, '');
           // parse arg
           var argMatch = name.match(argRE);
           var arg = argMatch && argMatch[1];
           isDynamic = false;
           if (arg) {
             name = name.slice(0, -(arg.length + 1));
             if (dynamicArgRE.test(arg)) {
               arg = arg.slice(1, -1);
               isDynamic = true;
             }
           }
           addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
           if (false) {}
         }
       } else {
         // literal attribute
         if (false) { var res; }
         addAttr(el, name, JSON.stringify(value), list[i]);
         // #6887 firefox doesn't update muted state if set via attribute
         // even immediately after element creation
         if (!el.component &&
             name === 'muted' &&
             platformMustUseProp(el.tag, el.attrsMap.type, name)) {
           addProp(el, name, 'true', list[i]);
         }
       }
     }
   }
   
   function checkInFor (el) {
     var parent = el;
     while (parent) {
       if (parent.for !== undefined) {
         return true
       }
       parent = parent.parent;
     }
     return false
   }
   
   function parseModifiers (name) {
     var match = name.match(modifierRE);
     if (match) {
       var ret = {};
       match.forEach(function (m) { ret[m.slice(1)] = true; });
       return ret
     }
   }
   
   function makeAttrsMap (attrs) {
     var map = {};
     for (var i = 0, l = attrs.length; i < l; i++) {
       if (
         false
       ) {}
       map[attrs[i].name] = attrs[i].value;
     }
     return map
   }
   
   // for script (e.g. type="x/template") or style, do not decode content
   function isTextTag (el) {
     return el.tag === 'script' || el.tag === 'style'
   }
   
   function isForbiddenTag (el) {
     return (
       el.tag === 'style' ||
       (el.tag === 'script' && (
         !el.attrsMap.type ||
         el.attrsMap.type === 'text/javascript'
       ))
     )
   }
   
   var ieNSBug = /^xmlns:NS\d+/;
   var ieNSPrefix = /^NS\d+:/;
   
   /* istanbul ignore next */
   function guardIESVGBug (attrs) {
     var res = [];
     for (var i = 0; i < attrs.length; i++) {
       var attr = attrs[i];
       if (!ieNSBug.test(attr.name)) {
         attr.name = attr.name.replace(ieNSPrefix, '');
         res.push(attr);
       }
     }
     return res
   }
   
   function checkForAliasModel (el, value) {
     var _el = el;
     while (_el) {
       if (_el.for && _el.alias === value) {
         warn$2(
           "<" + (el.tag) + " v-model=\"" + value + "\">: " +
           "You are binding v-model directly to a v-for iteration alias. " +
           "This will not be able to modify the v-for source array because " +
           "writing to the alias is like modifying a function local variable. " +
           "Consider using an array of objects and use v-model on an object property instead.",
           el.rawAttrsMap['v-model']
         );
       }
       _el = _el.parent;
     }
   }
   
   /*  */
   
   function preTransformNode (el, options) {
     if (el.tag === 'input') {
       var map = el.attrsMap;
       if (!map['v-model']) {
         return
       }
   
       var typeBinding;
       if (map[':type'] || map['v-bind:type']) {
         typeBinding = getBindingAttr(el, 'type');
       }
       if (!map.type && !typeBinding && map['v-bind']) {
         typeBinding = "(" + (map['v-bind']) + ").type";
       }
   
       if (typeBinding) {
         var ifCondition = getAndRemoveAttr(el, 'v-if', true);
         var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
         var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
         var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
         // 1. checkbox
         var branch0 = cloneASTElement(el);
         // process for on the main node
         processFor(branch0);
         addRawAttr(branch0, 'type', 'checkbox');
         processElement(branch0, options);
         branch0.processed = true; // prevent it from double-processed
         branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
         addIfCondition(branch0, {
           exp: branch0.if,
           block: branch0
         });
         // 2. add radio else-if condition
         var branch1 = cloneASTElement(el);
         getAndRemoveAttr(branch1, 'v-for', true);
         addRawAttr(branch1, 'type', 'radio');
         processElement(branch1, options);
         addIfCondition(branch0, {
           exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
           block: branch1
         });
         // 3. other
         var branch2 = cloneASTElement(el);
         getAndRemoveAttr(branch2, 'v-for', true);
         addRawAttr(branch2, ':type', typeBinding);
         processElement(branch2, options);
         addIfCondition(branch0, {
           exp: ifCondition,
           block: branch2
         });
   
         if (hasElse) {
           branch0.else = true;
         } else if (elseIfCondition) {
           branch0.elseif = elseIfCondition;
         }
   
         return branch0
       }
     }
   }
   
   function cloneASTElement (el) {
     return createASTElement(el.tag, el.attrsList.slice(), el.parent)
   }
   
   var model$1 = {
     preTransformNode: preTransformNode
   };
   
   var modules$1 = [
     klass$1,
     style$1,
     model$1
   ];
   
   /*  */
   
   function vue_esm_text (el, dir) {
     if (dir.value) {
       addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
     }
   }
   
   /*  */
   
   function html (el, dir) {
     if (dir.value) {
       addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
     }
   }
   
   var directives$1 = {
     model: model,
     text: vue_esm_text,
     html: html
   };
   
   /*  */
   
   var baseOptions = {
     expectHTML: true,
     modules: modules$1,
     directives: directives$1,
     isPreTag: isPreTag,
     isUnaryTag: isUnaryTag,
     mustUseProp: mustUseProp,
     canBeLeftOpenTag: canBeLeftOpenTag,
     isReservedTag: isReservedTag,
     getTagNamespace: getTagNamespace,
     staticKeys: genStaticKeys(modules$1)
   };
   
   /*  */
   
   var isStaticKey;
   var isPlatformReservedTag;
   
   var genStaticKeysCached = cached(genStaticKeys$1);
   
   /**
    * Goal of the optimizer: walk the generated template AST tree
    * and detect sub-trees that are purely static, i.e. parts of
    * the DOM that never needs to change.
    *
    * Once we detect these sub-trees, we can:
    *
    * 1. Hoist them into constants, so that we no longer need to
    *    create fresh nodes for them on each re-render;
    * 2. Completely skip them in the patching process.
    */
   function optimize (root, options) {
     if (!root) { return }
     isStaticKey = genStaticKeysCached(options.staticKeys || '');
     isPlatformReservedTag = options.isReservedTag || no;
     // first pass: mark all non-static nodes.
     markStatic$1(root);
     // second pass: mark static roots.
     markStaticRoots(root, false);
   }
   
   function genStaticKeys$1 (keys) {
     return makeMap(
       'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
       (keys ? ',' + keys : '')
     )
   }
   
   function markStatic$1 (node) {
     node.static = isStatic(node);
     if (node.type === 1) {
       // do not make component slot content static. this avoids
       // 1. components not able to mutate slot nodes
       // 2. static slot content fails for hot-reloading
       if (
         !isPlatformReservedTag(node.tag) &&
         node.tag !== 'slot' &&
         node.attrsMap['inline-template'] == null
       ) {
         return
       }
       for (var i = 0, l = node.children.length; i < l; i++) {
         var child = node.children[i];
         markStatic$1(child);
         if (!child.static) {
           node.static = false;
         }
       }
       if (node.ifConditions) {
         for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
           var block = node.ifConditions[i$1].block;
           markStatic$1(block);
           if (!block.static) {
             node.static = false;
           }
         }
       }
     }
   }
   
   function markStaticRoots (node, isInFor) {
     if (node.type === 1) {
       if (node.static || node.once) {
         node.staticInFor = isInFor;
       }
       // For a node to qualify as a static root, it should have children that
       // are not just static text. Otherwise the cost of hoisting out will
       // outweigh the benefits and it's better off to just always render it fresh.
       if (node.static && node.children.length && !(
         node.children.length === 1 &&
         node.children[0].type === 3
       )) {
         node.staticRoot = true;
         return
       } else {
         node.staticRoot = false;
       }
       if (node.children) {
         for (var i = 0, l = node.children.length; i < l; i++) {
           markStaticRoots(node.children[i], isInFor || !!node.for);
         }
       }
       if (node.ifConditions) {
         for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
           markStaticRoots(node.ifConditions[i$1].block, isInFor);
         }
       }
     }
   }
   
   function isStatic (node) {
     if (node.type === 2) { // expression
       return false
     }
     if (node.type === 3) { // text
       return true
     }
     return !!(node.pre || (
       !node.hasBindings && // no dynamic bindings
       !node.if && !node.for && // not v-if or v-for or v-else
       !isBuiltInTag(node.tag) && // not a built-in
       isPlatformReservedTag(node.tag) && // not a component
       !isDirectChildOfTemplateFor(node) &&
       Object.keys(node).every(isStaticKey)
     ))
   }
   
   function isDirectChildOfTemplateFor (node) {
     while (node.parent) {
       node = node.parent;
       if (node.tag !== 'template') {
         return false
       }
       if (node.for) {
         return true
       }
     }
     return false
   }
   
   /*  */
   
   var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
   var fnInvokeRE = /\([^)]*?\);*$/;
   var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
   
   // KeyboardEvent.keyCode aliases
   var keyCodes = {
     esc: 27,
     tab: 9,
     enter: 13,
     space: 32,
     up: 38,
     left: 37,
     right: 39,
     down: 40,
     'delete': [8, 46]
   };
   
   // KeyboardEvent.key aliases
   var keyNames = {
     // #7880: IE11 and Edge use `Esc` for Escape key name.
     esc: ['Esc', 'Escape'],
     tab: 'Tab',
     enter: 'Enter',
     // #9112: IE11 uses `Spacebar` for Space key name.
     space: [' ', 'Spacebar'],
     // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
     up: ['Up', 'ArrowUp'],
     left: ['Left', 'ArrowLeft'],
     right: ['Right', 'ArrowRight'],
     down: ['Down', 'ArrowDown'],
     // #9112: IE11 uses `Del` for Delete key name.
     'delete': ['Backspace', 'Delete', 'Del']
   };
   
   // #4868: modifiers that prevent the execution of the listener
   // need to explicitly return null so that we can determine whether to remove
   // the listener for .once
   var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };
   
   var modifierCode = {
     stop: '$event.stopPropagation();',
     prevent: '$event.preventDefault();',
     self: genGuard("$event.target !== $event.currentTarget"),
     ctrl: genGuard("!$event.ctrlKey"),
     shift: genGuard("!$event.shiftKey"),
     alt: genGuard("!$event.altKey"),
     meta: genGuard("!$event.metaKey"),
     left: genGuard("'button' in $event && $event.button !== 0"),
     middle: genGuard("'button' in $event && $event.button !== 1"),
     right: genGuard("'button' in $event && $event.button !== 2")
   };
   
   function genHandlers (
     events,
     isNative
   ) {
     var prefix = isNative ? 'nativeOn:' : 'on:';
     var staticHandlers = "";
     var dynamicHandlers = "";
     for (var name in events) {
       var handlerCode = genHandler(events[name]);
       if (events[name] && events[name].dynamic) {
         dynamicHandlers += name + "," + handlerCode + ",";
       } else {
         staticHandlers += "\"" + name + "\":" + handlerCode + ",";
       }
     }
     staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
     if (dynamicHandlers) {
       return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
     } else {
       return prefix + staticHandlers
     }
   }
   
   function genHandler (handler) {
     if (!handler) {
       return 'function(){}'
     }
   
     if (Array.isArray(handler)) {
       return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
     }
   
     var isMethodPath = simplePathRE.test(handler.value);
     var isFunctionExpression = fnExpRE.test(handler.value);
     var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
   
     if (!handler.modifiers) {
       if (isMethodPath || isFunctionExpression) {
         return handler.value
       }
       return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
     } else {
       var code = '';
       var genModifierCode = '';
       var keys = [];
       for (var key in handler.modifiers) {
         if (modifierCode[key]) {
           genModifierCode += modifierCode[key];
           // left/right
           if (keyCodes[key]) {
             keys.push(key);
           }
         } else if (key === 'exact') {
           var modifiers = (handler.modifiers);
           genModifierCode += genGuard(
             ['ctrl', 'shift', 'alt', 'meta']
               .filter(function (keyModifier) { return !modifiers[keyModifier]; })
               .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
               .join('||')
           );
         } else {
           keys.push(key);
         }
       }
       if (keys.length) {
         code += genKeyFilter(keys);
       }
       // Make sure modifiers like prevent and stop get executed after key filtering
       if (genModifierCode) {
         code += genModifierCode;
       }
       var handlerCode = isMethodPath
         ? ("return " + (handler.value) + ".apply(null, arguments)")
         : isFunctionExpression
           ? ("return (" + (handler.value) + ").apply(null, arguments)")
           : isFunctionInvocation
             ? ("return " + (handler.value))
             : handler.value;
       return ("function($event){" + code + handlerCode + "}")
     }
   }
   
   function genKeyFilter (keys) {
     return (
       // make sure the key filters only apply to KeyboardEvents
       // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
       // key events that do not have keyCode property...
       "if(!$event.type.indexOf('key')&&" +
       (keys.map(genFilterCode).join('&&')) + ")return null;"
     )
   }
   
   function genFilterCode (key) {
     var keyVal = parseInt(key, 10);
     if (keyVal) {
       return ("$event.keyCode!==" + keyVal)
     }
     var keyCode = keyCodes[key];
     var keyName = keyNames[key];
     return (
       "_k($event.keyCode," +
       (JSON.stringify(key)) + "," +
       (JSON.stringify(keyCode)) + "," +
       "$event.key," +
       "" + (JSON.stringify(keyName)) +
       ")"
     )
   }
   
   /*  */
   
   function on (el, dir) {
     if (false) {}
     el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
   }
   
   /*  */
   
   function bind$1 (el, dir) {
     el.wrapData = function (code) {
       return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
     };
   }
   
   /*  */
   
   var baseDirectives = {
     on: on,
     bind: bind$1,
     cloak: noop
   };
   
   /*  */
   
   
   
   
   
   var CodegenState = function CodegenState (options) {
     this.options = options;
     this.warn = options.warn || baseWarn;
     this.transforms = pluckModuleFunction(options.modules, 'transformCode');
     this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
     this.directives = extend(extend({}, baseDirectives), options.directives);
     var isReservedTag = options.isReservedTag || no;
     this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
     this.onceId = 0;
     this.staticRenderFns = [];
     this.pre = false;
   };
   
   
   
   function generate (
     ast,
     options
   ) {
     var state = new CodegenState(options);
     // fix #11483, Root level <script> tags should not be rendered.
     var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
     return {
       render: ("with(this){return " + code + "}"),
       staticRenderFns: state.staticRenderFns
     }
   }
   
   function genElement (el, state) {
     if (el.parent) {
       el.pre = el.pre || el.parent.pre;
     }
   
     if (el.staticRoot && !el.staticProcessed) {
       return genStatic(el, state)
     } else if (el.once && !el.onceProcessed) {
       return genOnce(el, state)
     } else if (el.for && !el.forProcessed) {
       return genFor(el, state)
     } else if (el.if && !el.ifProcessed) {
       return genIf(el, state)
     } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
       return genChildren(el, state) || 'void 0'
     } else if (el.tag === 'slot') {
       return genSlot(el, state)
     } else {
       // component or element
       var code;
       if (el.component) {
         code = genComponent(el.component, el, state);
       } else {
         var data;
         if (!el.plain || (el.pre && state.maybeComponent(el))) {
           data = genData$2(el, state);
         }
   
         var children = el.inlineTemplate ? null : genChildren(el, state, true);
         code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
       }
       // module transforms
       for (var i = 0; i < state.transforms.length; i++) {
         code = state.transforms[i](el, code);
       }
       return code
     }
   }
   
   // hoist static sub-trees out
   function genStatic (el, state) {
     el.staticProcessed = true;
     // Some elements (templates) need to behave differently inside of a v-pre
     // node.  All pre nodes are static roots, so we can use this as a location to
     // wrap a state change and reset it upon exiting the pre node.
     var originalPreState = state.pre;
     if (el.pre) {
       state.pre = el.pre;
     }
     state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
     state.pre = originalPreState;
     return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
   }
   
   // v-once
   function genOnce (el, state) {
     el.onceProcessed = true;
     if (el.if && !el.ifProcessed) {
       return genIf(el, state)
     } else if (el.staticInFor) {
       var key = '';
       var parent = el.parent;
       while (parent) {
         if (parent.for) {
           key = parent.key;
           break
         }
         parent = parent.parent;
       }
       if (!key) {
          false && 0;
         return genElement(el, state)
       }
       return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
     } else {
       return genStatic(el, state)
     }
   }
   
   function genIf (
     el,
     state,
     altGen,
     altEmpty
   ) {
     el.ifProcessed = true; // avoid recursion
     return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
   }
   
   function genIfConditions (
     conditions,
     state,
     altGen,
     altEmpty
   ) {
     if (!conditions.length) {
       return altEmpty || '_e()'
     }
   
     var condition = conditions.shift();
     if (condition.exp) {
       return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
     } else {
       return ("" + (genTernaryExp(condition.block)))
     }
   
     // v-if with v-once should generate code like (a)?_m(0):_m(1)
     function genTernaryExp (el) {
       return altGen
         ? altGen(el, state)
         : el.once
           ? genOnce(el, state)
           : genElement(el, state)
     }
   }
   
   function genFor (
     el,
     state,
     altGen,
     altHelper
   ) {
     var exp = el.for;
     var alias = el.alias;
     var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
     var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
   
     if (false
     ) {}
   
     el.forProcessed = true; // avoid recursion
     return (altHelper || '_l') + "((" + exp + ")," +
       "function(" + alias + iterator1 + iterator2 + "){" +
         "return " + ((altGen || genElement)(el, state)) +
       '})'
   }
   
   function genData$2 (el, state) {
     var data = '{';
   
     // directives first.
     // directives may mutate the el's other properties before they are generated.
     var dirs = genDirectives(el, state);
     if (dirs) { data += dirs + ','; }
   
     // key
     if (el.key) {
       data += "key:" + (el.key) + ",";
     }
     // ref
     if (el.ref) {
       data += "ref:" + (el.ref) + ",";
     }
     if (el.refInFor) {
       data += "refInFor:true,";
     }
     // pre
     if (el.pre) {
       data += "pre:true,";
     }
     // record original tag name for components using "is" attribute
     if (el.component) {
       data += "tag:\"" + (el.tag) + "\",";
     }
     // module data generation functions
     for (var i = 0; i < state.dataGenFns.length; i++) {
       data += state.dataGenFns[i](el);
     }
     // attributes
     if (el.attrs) {
       data += "attrs:" + (genProps(el.attrs)) + ",";
     }
     // DOM props
     if (el.props) {
       data += "domProps:" + (genProps(el.props)) + ",";
     }
     // event handlers
     if (el.events) {
       data += (genHandlers(el.events, false)) + ",";
     }
     if (el.nativeEvents) {
       data += (genHandlers(el.nativeEvents, true)) + ",";
     }
     // slot target
     // only for non-scoped slots
     if (el.slotTarget && !el.slotScope) {
       data += "slot:" + (el.slotTarget) + ",";
     }
     // scoped slots
     if (el.scopedSlots) {
       data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
     }
     // component v-model
     if (el.model) {
       data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
     }
     // inline-template
     if (el.inlineTemplate) {
       var inlineTemplate = genInlineTemplate(el, state);
       if (inlineTemplate) {
         data += inlineTemplate + ",";
       }
     }
     data = data.replace(/,$/, '') + '}';
     // v-bind dynamic argument wrap
     // v-bind with dynamic arguments must be applied using the same v-bind object
     // merge helper so that class/style/mustUseProp attrs are handled correctly.
     if (el.dynamicAttrs) {
       data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
     }
     // v-bind data wrap
     if (el.wrapData) {
       data = el.wrapData(data);
     }
     // v-on data wrap
     if (el.wrapListeners) {
       data = el.wrapListeners(data);
     }
     return data
   }
   
   function genDirectives (el, state) {
     var dirs = el.directives;
     if (!dirs) { return }
     var res = 'directives:[';
     var hasRuntime = false;
     var i, l, dir, needRuntime;
     for (i = 0, l = dirs.length; i < l; i++) {
       dir = dirs[i];
       needRuntime = true;
       var gen = state.directives[dir.name];
       if (gen) {
         // compile-time directive that manipulates AST.
         // returns true if it also needs a runtime counterpart.
         needRuntime = !!gen(el, dir, state.warn);
       }
       if (needRuntime) {
         hasRuntime = true;
         res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
       }
     }
     if (hasRuntime) {
       return res.slice(0, -1) + ']'
     }
   }
   
   function genInlineTemplate (el, state) {
     var ast = el.children[0];
     if (false) {}
     if (ast && ast.type === 1) {
       var inlineRenderFns = generate(ast, state.options);
       return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
     }
   }
   
   function genScopedSlots (
     el,
     slots,
     state
   ) {
     // by default scoped slots are considered "stable", this allows child
     // components with only scoped slots to skip forced updates from parent.
     // but in some cases we have to bail-out of this optimization
     // for example if the slot contains dynamic names, has v-if or v-for on them...
     var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
       var slot = slots[key];
       return (
         slot.slotTargetDynamic ||
         slot.if ||
         slot.for ||
         containsSlotChild(slot) // is passing down slot from parent which may be dynamic
       )
     });
   
     // #9534: if a component with scoped slots is inside a conditional branch,
     // it's possible for the same component to be reused but with different
     // compiled slot content. To avoid that, we generate a unique key based on
     // the generated code of all the slot contents.
     var needsKey = !!el.if;
   
     // OR when it is inside another scoped slot or v-for (the reactivity may be
     // disconnected due to the intermediate scope variable)
     // #9438, #9506
     // TODO: this can be further optimized by properly analyzing in-scope bindings
     // and skip force updating ones that do not actually use scope variables.
     if (!needsForceUpdate) {
       var parent = el.parent;
       while (parent) {
         if (
           (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
           parent.for
         ) {
           needsForceUpdate = true;
           break
         }
         if (parent.if) {
           needsKey = true;
         }
         parent = parent.parent;
       }
     }
   
     var generatedSlots = Object.keys(slots)
       .map(function (key) { return genScopedSlot(slots[key], state); })
       .join(',');
   
     return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
   }
   
   function hash(str) {
     var hash = 5381;
     var i = str.length;
     while(i) {
       hash = (hash * 33) ^ str.charCodeAt(--i);
     }
     return hash >>> 0
   }
   
   function containsSlotChild (el) {
     if (el.type === 1) {
       if (el.tag === 'slot') {
         return true
       }
       return el.children.some(containsSlotChild)
     }
     return false
   }
   
   function genScopedSlot (
     el,
     state
   ) {
     var isLegacySyntax = el.attrsMap['slot-scope'];
     if (el.if && !el.ifProcessed && !isLegacySyntax) {
       return genIf(el, state, genScopedSlot, "null")
     }
     if (el.for && !el.forProcessed) {
       return genFor(el, state, genScopedSlot)
     }
     var slotScope = el.slotScope === emptySlotScopeToken
       ? ""
       : String(el.slotScope);
     var fn = "function(" + slotScope + "){" +
       "return " + (el.tag === 'template'
         ? el.if && isLegacySyntax
           ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
           : genChildren(el, state) || 'undefined'
         : genElement(el, state)) + "}";
     // reverse proxy v-slot without scope on this.$slots
     var reverseProxy = slotScope ? "" : ",proxy:true";
     return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
   }
   
   function genChildren (
     el,
     state,
     checkSkip,
     altGenElement,
     altGenNode
   ) {
     var children = el.children;
     if (children.length) {
       var el$1 = children[0];
       // optimize single v-for
       if (children.length === 1 &&
         el$1.for &&
         el$1.tag !== 'template' &&
         el$1.tag !== 'slot'
       ) {
         var normalizationType = checkSkip
           ? state.maybeComponent(el$1) ? ",1" : ",0"
           : "";
         return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
       }
       var normalizationType$1 = checkSkip
         ? getNormalizationType(children, state.maybeComponent)
         : 0;
       var gen = altGenNode || genNode;
       return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
     }
   }
   
   // determine the normalization needed for the children array.
   // 0: no normalization needed
   // 1: simple normalization needed (possible 1-level deep nested array)
   // 2: full normalization needed
   function getNormalizationType (
     children,
     maybeComponent
   ) {
     var res = 0;
     for (var i = 0; i < children.length; i++) {
       var el = children[i];
       if (el.type !== 1) {
         continue
       }
       if (needsNormalization(el) ||
           (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
         res = 2;
         break
       }
       if (maybeComponent(el) ||
           (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
         res = 1;
       }
     }
     return res
   }
   
   function needsNormalization (el) {
     return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
   }
   
   function genNode (node, state) {
     if (node.type === 1) {
       return genElement(node, state)
     } else if (node.type === 3 && node.isComment) {
       return genComment(node)
     } else {
       return genText(node)
     }
   }
   
   function genText (text) {
     return ("_v(" + (text.type === 2
       ? text.expression // no need for () because already wrapped in _s()
       : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
   }
   
   function genComment (comment) {
     return ("_e(" + (JSON.stringify(comment.text)) + ")")
   }
   
   function genSlot (el, state) {
     var slotName = el.slotName || '"default"';
     var children = genChildren(el, state);
     var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
     var attrs = el.attrs || el.dynamicAttrs
       ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
           // slot props are camelized
           name: camelize(attr.name),
           value: attr.value,
           dynamic: attr.dynamic
         }); }))
       : null;
     var bind$$1 = el.attrsMap['v-bind'];
     if ((attrs || bind$$1) && !children) {
       res += ",null";
     }
     if (attrs) {
       res += "," + attrs;
     }
     if (bind$$1) {
       res += (attrs ? '' : ',null') + "," + bind$$1;
     }
     return res + ')'
   }
   
   // componentName is el.component, take it as argument to shun flow's pessimistic refinement
   function genComponent (
     componentName,
     el,
     state
   ) {
     var children = el.inlineTemplate ? null : genChildren(el, state, true);
     return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
   }
   
   function genProps (props) {
     var staticProps = "";
     var dynamicProps = "";
     for (var i = 0; i < props.length; i++) {
       var prop = props[i];
       var value = transformSpecialNewlines(prop.value);
       if (prop.dynamic) {
         dynamicProps += (prop.name) + "," + value + ",";
       } else {
         staticProps += "\"" + (prop.name) + "\":" + value + ",";
       }
     }
     staticProps = "{" + (staticProps.slice(0, -1)) + "}";
     if (dynamicProps) {
       return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
     } else {
       return staticProps
     }
   }
   
   // #3895, #4268
   function transformSpecialNewlines (text) {
     return text
       .replace(/\u2028/g, '\\u2028')
       .replace(/\u2029/g, '\\u2029')
   }
   
   /*  */
   
   
   
   // these keywords should not appear inside expressions, but operators like
   // typeof, instanceof and in are allowed
   var prohibitedKeywordRE = new RegExp('\\b' + (
     'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
     'super,throw,while,yield,delete,export,import,return,switch,default,' +
     'extends,finally,continue,debugger,function,arguments'
   ).split(',').join('\\b|\\b') + '\\b');
   
   // these unary operators should not be used as property/method names
   var unaryOperatorsRE = new RegExp('\\b' + (
     'delete,typeof,void'
   ).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
   
   // strip strings in expressions
   var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
   
   // detect problematic expressions in a template
   function detectErrors (ast, warn) {
     if (ast) {
       checkNode(ast, warn);
     }
   }
   
   function checkNode (node, warn) {
     if (node.type === 1) {
       for (var name in node.attrsMap) {
         if (dirRE.test(name)) {
           var value = node.attrsMap[name];
           if (value) {
             var range = node.rawAttrsMap[name];
             if (name === 'v-for') {
               checkFor(node, ("v-for=\"" + value + "\""), warn, range);
             } else if (name === 'v-slot' || name[0] === '#') {
               checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
             } else if (onRE.test(name)) {
               checkEvent(value, (name + "=\"" + value + "\""), warn, range);
             } else {
               checkExpression(value, (name + "=\"" + value + "\""), warn, range);
             }
           }
         }
       }
       if (node.children) {
         for (var i = 0; i < node.children.length; i++) {
           checkNode(node.children[i], warn);
         }
       }
     } else if (node.type === 2) {
       checkExpression(node.expression, node.text, warn, node);
     }
   }
   
   function checkEvent (exp, text, warn, range) {
     var stripped = exp.replace(stripStringRE, '');
     var keywordMatch = stripped.match(unaryOperatorsRE);
     if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
       warn(
         "avoid using JavaScript unary operator as property name: " +
         "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
         range
       );
     }
     checkExpression(exp, text, warn, range);
   }
   
   function checkFor (node, text, warn, range) {
     checkExpression(node.for || '', text, warn, range);
     checkIdentifier(node.alias, 'v-for alias', text, warn, range);
     checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
     checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
   }
   
   function checkIdentifier (
     ident,
     type,
     text,
     warn,
     range
   ) {
     if (typeof ident === 'string') {
       try {
         new Function(("var " + ident + "=_"));
       } catch (e) {
         warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
       }
     }
   }
   
   function checkExpression (exp, text, warn, range) {
     try {
       new Function(("return " + exp));
     } catch (e) {
       var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
       if (keywordMatch) {
         warn(
           "avoid using JavaScript keyword as property name: " +
           "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
           range
         );
       } else {
         warn(
           "invalid expression: " + (e.message) + " in\n\n" +
           "    " + exp + "\n\n" +
           "  Raw expression: " + (text.trim()) + "\n",
           range
         );
       }
     }
   }
   
   function checkFunctionParameterExpression (exp, text, warn, range) {
     try {
       new Function(exp, '');
     } catch (e) {
       warn(
         "invalid function parameter expression: " + (e.message) + " in\n\n" +
         "    " + exp + "\n\n" +
         "  Raw expression: " + (text.trim()) + "\n",
         range
       );
     }
   }
   
   /*  */
   
   var range = 2;
   
   function generateCodeFrame (
     source,
     start,
     end
   ) {
     if ( start === void 0 ) start = 0;
     if ( end === void 0 ) end = source.length;
   
     var lines = source.split(/\r?\n/);
     var count = 0;
     var res = [];
     for (var i = 0; i < lines.length; i++) {
       count += lines[i].length + 1;
       if (count >= start) {
         for (var j = i - range; j <= i + range || end > count; j++) {
           if (j < 0 || j >= lines.length) { continue }
           res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
           var lineLength = lines[j].length;
           if (j === i) {
             // push underline
             var pad = start - (count - lineLength) + 1;
             var length = end > count ? lineLength - pad : end - start;
             res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
           } else if (j > i) {
             if (end > count) {
               var length$1 = Math.min(end - count, lineLength);
               res.push("   |  " + repeat$1("^", length$1));
             }
             count += lineLength + 1;
           }
         }
         break
       }
     }
     return res.join('\n')
   }
   
   function repeat$1 (str, n) {
     var result = '';
     if (n > 0) {
       while (true) { // eslint-disable-line
         if (n & 1) { result += str; }
         n >>>= 1;
         if (n <= 0) { break }
         str += str;
       }
     }
     return result
   }
   
   /*  */
   
   
   
   function createFunction (code, errors) {
     try {
       return new Function(code)
     } catch (err) {
       errors.push({ err: err, code: code });
       return noop
     }
   }
   
   function createCompileToFunctionFn (compile) {
     var cache = Object.create(null);
   
     return function compileToFunctions (
       template,
       options,
       vm
     ) {
       options = extend({}, options);
       var warn$$1 = options.warn || warn;
       delete options.warn;
   
       /* istanbul ignore if */
       if (false) {}
   
       // check cache
       var key = options.delimiters
         ? String(options.delimiters) + template
         : template;
       if (cache[key]) {
         return cache[key]
       }
   
       // compile
       var compiled = compile(template, options);
   
       // check compilation errors/tips
       if (false) {}
   
       // turn code into functions
       var res = {};
       var fnGenErrors = [];
       res.render = createFunction(compiled.render, fnGenErrors);
       res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
         return createFunction(code, fnGenErrors)
       });
   
       // check function generation errors.
       // this should only happen if there is a bug in the compiler itself.
       // mostly for codegen development use
       /* istanbul ignore if */
       if (false) {}
   
       return (cache[key] = res)
     }
   }
   
   /*  */
   
   function createCompilerCreator (baseCompile) {
     return function createCompiler (baseOptions) {
       function compile (
         template,
         options
       ) {
         var finalOptions = Object.create(baseOptions);
         var errors = [];
         var tips = [];
   
         var warn = function (msg, range, tip) {
           (tip ? tips : errors).push(msg);
         };
   
         if (options) {
           if (false) { var leadingSpaceLength; }
           // merge custom modules
           if (options.modules) {
             finalOptions.modules =
               (baseOptions.modules || []).concat(options.modules);
           }
           // merge custom directives
           if (options.directives) {
             finalOptions.directives = extend(
               Object.create(baseOptions.directives || null),
               options.directives
             );
           }
           // copy other options
           for (var key in options) {
             if (key !== 'modules' && key !== 'directives') {
               finalOptions[key] = options[key];
             }
           }
         }
   
         finalOptions.warn = warn;
   
         var compiled = baseCompile(template.trim(), finalOptions);
         if (false) {}
         compiled.errors = errors;
         compiled.tips = tips;
         return compiled
       }
   
       return {
         compile: compile,
         compileToFunctions: createCompileToFunctionFn(compile)
       }
     }
   }
   
   /*  */
   
   // `createCompilerCreator` allows creating compilers that use alternative
   // parser/optimizer/codegen, e.g the SSR optimizing compiler.
   // Here we just export a default compiler using the default parts.
   var createCompiler = createCompilerCreator(function baseCompile (
     template,
     options
   ) {
     var ast = parse(template.trim(), options);
     if (options.optimize !== false) {
       optimize(ast, options);
     }
     var code = generate(ast, options);
     return {
       ast: ast,
       render: code.render,
       staticRenderFns: code.staticRenderFns
     }
   });
   
   /*  */
   
   var ref$1 = createCompiler(baseOptions);
   var compile = ref$1.compile;
   var compileToFunctions = ref$1.compileToFunctions;
   
   /*  */
   
   // check whether current browser encodes a char inside attribute values
   var div;
   function getShouldDecode (href) {
     div = div || document.createElement('div');
     div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
     return div.innerHTML.indexOf('&#10;') > 0
   }
   
   // #3663: IE encodes newlines inside attribute values while other browsers don't
   var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
   // #6828: chrome encodes content in a[href]
   var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
   
   /*  */
   
   var idToTemplate = cached(function (id) {
     var el = query(id);
     return el && el.innerHTML
   });
   
   var mount = vue_esm_Vue.prototype.$mount;
   vue_esm_Vue.prototype.$mount = function (
     el,
     hydrating
   ) {
     el = el && query(el);
   
     /* istanbul ignore if */
     if (el === document.body || el === document.documentElement) {
        false && 0;
       return this
     }
   
     var options = this.$options;
     // resolve template/el and convert to render function
     if (!options.render) {
       var template = options.template;
       if (template) {
         if (typeof template === 'string') {
           if (template.charAt(0) === '#') {
             template = idToTemplate(template);
             /* istanbul ignore if */
             if (false) {}
           }
         } else if (template.nodeType) {
           template = template.innerHTML;
         } else {
           if (false) {}
           return this
         }
       } else if (el) {
         template = getOuterHTML(el);
       }
       if (template) {
         /* istanbul ignore if */
         if (false) {}
   
         var ref = compileToFunctions(template, {
           outputSourceRange: "production" !== 'production',
           shouldDecodeNewlines: shouldDecodeNewlines,
           shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
           delimiters: options.delimiters,
           comments: options.comments
         }, this);
         var render = ref.render;
         var staticRenderFns = ref.staticRenderFns;
         options.render = render;
         options.staticRenderFns = staticRenderFns;
   
         /* istanbul ignore if */
         if (false) {}
       }
     }
     return mount.call(this, el, hydrating)
   };
   
   /**
    * Get outerHTML of elements, taking care
    * of SVG elements in IE as well.
    */
   function getOuterHTML (el) {
     if (el.outerHTML) {
       return el.outerHTML
     } else {
       var container = document.createElement('div');
       container.appendChild(el.cloneNode(true));
       return container.innerHTML
     }
   }
   
   vue_esm_Vue.compile = compileToFunctions;
   
   /* harmony default export */ const vue_esm = (vue_esm_Vue);
   
   ;// CONCATENATED MODULE: ./src/javascripts/constants.js
   /**
     * @typedef {Object} Breakpoint
     * @param {number} min
     * @param {number} max
     * @param {string} name
     * @param {number} order
     */
   
   /** @enum {Breakpoint} */
   const Breakpoints = {
     xs: {
       min: 0,
       max: 480,
       name: 'xs',
       order: 1
     },
     // Extra small devices (portrait phones, less than 576px)
     sm: {
       min: 481,
       max: 767,
       name: 'sm',
       order: 2
     },
     // Small devices (landscape phones, 576px and up)
     md: {
       min: 768,
       max: 991,
       name: 'md',
       order: 3
     },
     // Medium devices (tablets, 768px and up)
     lg: {
       min: 992,
       max: 1199,
       name: 'lg',
       order: 4
     },
     // Large devices (desktops, 992px and up)
     xl: {
       min: 1200,
       max: Number.POSITIVE_INFINITY,
       name: 'xl',
       order: 5
     } // Extra large devices (large desktops, 1200px and up)
   };
   ;// CONCATENATED MODULE: ./src/javascripts/ThemeBase.js
   /* eslint-disable no-unused-vars */
   
   
   const TOGGLE_RIGHT_DRAWER_EVENT = 'wetheme-toggle-right-drawer';
   const TOGGLE_LEFT_DRAWER_EVENT = 'wetheme-toggle-left-drawer';
   const CART_UPDATE_EVENT = 'wetheme-cart-update';
   class ThemeBase {
     constructor() {
       this.$ = void 0;
       this.translations = void 0;
       this.moneyFormat = void 0;
       this.giftwrapProduct = void 0;
       this.giftwrapEnabled = void 0;
       this.breakpoint = void 0;
       this.formatMoney = (cents, format) => {
         var moneyFormat = this.moneyFormat;
         if (typeof cents === 'string') {
           cents = cents.replace('.', '');
         }
         var value = '';
         var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
         var formatString = format || moneyFormat;
         function formatWithDelimiters(number, precision, thousands, decimal) {
           if (precision === null || precision === undefined) {
             precision = 2;
           }
           thousands = thousands || ',';
           decimal = decimal || '.';
           if (isNaN(number) || number == null) {
             return 0;
           }
           number = (number / 100.0).toFixed(precision);
           var parts = number.split('.');
           var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
           var centsAmount = parts[1] ? decimal + parts[1] : '';
           return dollarsAmount + centsAmount;
         }
         switch (formatString.match(placeholderRegex)[1]) {
           case 'amount':
             value = formatWithDelimiters(cents, 2);
             break;
           case 'amount_no_decimals':
             value = formatWithDelimiters(cents, 0);
             break;
           case 'amount_with_comma_separator':
             value = formatWithDelimiters(cents, 2, '.', ',');
             break;
           case 'amount_no_decimals_with_comma_separator':
             value = formatWithDelimiters(cents, 0, '.', ',');
             break;
           case 'amount_no_decimals_with_space_separator':
             value = formatWithDelimiters(cents, 0, ' ');
             break;
         }
         return '<span class="money">' + formatString.replace(placeholderRegex, value) + '</span>';
       };
       this.getWindowWidth = () => {
         return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
       };
       this.getBreakpoint = (width = undefined) => {
         const w = width === null || width === undefined ? this.getWindowWidth() : width;
         let breakpoint;
         Object.values(Breakpoints).forEach(b => {
           if (w >= b.min && w <= b.max) {
             breakpoint = b;
           }
         });
         return breakpoint;
       };
       this.toggleRightDrawer = (type = 'cart', forceOpen = undefined, params = {}) => {};
       this.toggleLeftDrawer = (forceOpen = undefined) => {};
       this.updateCartDrawer = cart => {};
       this.loadYoutubeApi = () => {
         return;
       };
       this.loadVimeoApi = () => {
         return;
       };
       this.loadGoogleMapApi = apiKey => {
         return;
       };
       this.createScript = (id, src) => {
         return;
       };
       this.registerComponent = component => {};
       this.addBadges = (root, timeout) => {};
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/Component.js
   class Component {
     /**
      * Generic component, inherited class will be called to receive things like resize events.
      *
      * @param {import('./ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element) {
       this.onWindowResizeRaw = ({
         width
       }) => {};
       this.onWindowResize = ({
         width,
         oldWidth,
         breakpoint
       }) => {};
       this.onWindowResizeBreakpoint = ({
         width,
         breakpoint,
         oldBreakpoint
       }) => {};
       this.onWindowScroll = () => {};
       this.theme = theme;
       this.element = element;
       theme.registerComponent(this);
     }
   
     /**
      * This will be called immediatelly when window resizes.
      *
      * NOTE: prefer using onWindowResize as it's already debounced.
      *
      * @param {Object} params
      * @param {number} params.width Width of the window
      */
   }
   ;// CONCATENATED MODULE: ./src/javascripts/Section.js
   
   
   /**
    * Base class for all the section components
    *
    * All components should inherit this class and implement what method they need
    */
   class Section extends Component {
     /**
      *
      * @param {import("./ThemeBase").default} theme Global theme object
      * @param {HTMLElement} element Toplevel element for the section
      * @param {boolean} pageLoad True on initial page load, False when this section reloads
      */
     constructor(theme, element, pageLoad) {
       super(theme, element);
       this.onSectionSelect = ({
         element,
         sectionId,
         load
       }) => {};
       this.onSectionDeselect = ({
         element,
         sectionId
       }) => {};
       this.onSectionReorder = ({
         element,
         sectionId
       }) => {};
       this.onBlockSelect = ({
         element,
         sectionId,
         blockId,
         load
       }) => {};
       this.onBlockDeselect = ({
         element,
         sectionId,
         blockId
       }) => {};
       this.destroy = ({
         element
       }) => {};
       this.theme = theme;
       this.element = element;
     }
   
     /**
      * This will be called when section gets selected in Shopify Theme Editor
      *
      * @param {Object} params
      * @param {HTMLElement} params.element Toplevel element for the section
      * @param {string} params.sectionId Identification of the section
      * @param {boolean} params.load True if block was loaded, False if user just openeded previously selected block
      * */
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/MobileMenu.js
   
   
   class MobileMenu {
     constructor(theme, element) {
       this.handleToggle = e => {
         this.toggle(e.detail.forceOpen);
       };
       this.close = () => {
         document.body.classList.remove('js-drawer-open');
         document.body.classList.remove('js-drawer-open-left');
         this.isOpen = false;
       };
       this.open = () => {
         document.body.classList.add('js-drawer-open');
         document.body.classList.add('js-drawer-open-left');
         this.isOpen = true;
       };
       this.toggle = (forceOpen = undefined) => {
         if (forceOpen === true) {
           this.open();
         } else if (forceOpen === false) {
           this.close();
         } else if (this.isOpen) {
           this.close();
         } else {
           this.open();
         }
       };
       this.theme = theme;
       this.element = element;
       this.isOpen = false;
       document.documentElement.addEventListener(TOGGLE_LEFT_DRAWER_EVENT, this.handleToggle);
       jquery_default()('.mobile-nav__toggle').off('click').on('click', function (evt) {
         jquery_default()(this).parent().toggleClass('mobile-nav--expanded');
       });
       this.element.querySelector('.mobile-menu--close-btn').addEventListener('click', e => {
         e.preventDefault;
         this.close();
       });
     }
   }
   // EXTERNAL MODULE: ./node_modules/hoverintent/index.js
   var hoverintent = __webpack_require__(876);
   var hoverintent_default = /*#__PURE__*/__webpack_require__.n(hoverintent);
   ;// CONCATENATED MODULE: ./src/javascripts/global/fadeInUpAnimation.js
   // fadeInUpAnimation.js
   
   // Selects all children elements within a parent element and initiates a fade in up animation
   // Child elements have an opacity of 0 and a transform of translateY() applied to them initially
   // See _global-sections.scss for the animation
   
   function initiateFadeInUpAnimation(elements) {
     if (elements.length) {
       elements.forEach((child, index) => {
         child.style.animation = `fade-in-up 0.15s ease-in-out forwards, fade-in-up-opacity 0.35s ease-in-out forwards`;
         child.style.animationDelay = `${(index + 1) * 0.05}s`;
       });
     }
   }
   
   // Selects all children elements within a parent element and removes the fade in up animation
   
   function removeFadeInUpAnimation(elements) {
     if (elements.length) {
       elements.forEach(child => {
         child.style.animation = 'none';
       });
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Menu.js
   // @ts-nocheck
   
   
   
   class Menu {
     constructor(theme, element) {
       this.initScrollHandler = $el => {
         const $container = jquery_default()($el);
         let scrolling;
         $container.on('scroll', () => {
           clearTimeout(scrolling);
   
           // Add class to show scrollbar
           $container.addClass('scrolling');
           scrolling = setTimeout(() => {
             // Remove class to hide scrollbar
             $container.removeClass('scrolling');
           }, 800);
         });
       };
       this.closeSiblings = ($el, evt) => {
         if (!$el.hasClass(this.activeClass)) {
           evt.preventDefault();
           this.hideDropdown($el.siblings());
         }
       };
       this.setMegaMenuPosition = () => {
         // Position mega menu dropdowns to sit below their parent nav link
         this.$megaMenuDropdowns.forEach(dropdown => {
           const navLink = dropdown.parentElement;
           const navLinkRect = navLink.getBoundingClientRect();
   
           // Calculate the position relative to the viewport
           dropdown.style.top = `${navLinkRect.bottom}px`;
         });
       };
       this.showDropdown = $el => {
         $el.addClass(this.activeClass);
         const self2 = this;
   
         // Initiate mega menu animation
         const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
         initiateFadeInUpAnimation(megaMenuChildrenArray);
   
         // Remove iOS workaround because it breaks menu z-index
         jquery_default()('.sticky-header').removeClass('sticky-header-transformed');
         setTimeout(function () {
           jquery_default()(document.body).on('touchstart', evt => {
             if (jquery_default()(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0) {
               // Hide dropdown if the touchstart was not on nav link
               self2.hideDropdown($el);
             }
           });
         }, 250);
       };
       this.hideDropdown = $el => {
         if ($el !== undefined) {
           $el.removeClass(this.activeClass);
   
           // Remove mega menu animation 
           const megaMenuChildrenArray = Array.from($el.find('.mega-menu-block .dropdown-submenu'));
           if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
             removeFadeInUpAnimation(megaMenuChildrenArray);
           }
         } else {
           jquery_default()('.site-nav--has-dropdown').removeClass(this.activeClass);
   
           // Remove mega menu animation
           if (!this.$element.hasClass('section-selected') && !this.$parents.hasClass('nav-hover')) {
             removeFadeInUpAnimation(this.$megaMenuChildren);
           }
         }
         jquery_default()(document.body).off('touchstart');
   
         // Reenable iOS workaround
         if (jquery_default()('.nav-hover').length === 0) {
           jquery_default()('.sticky-header').addClass('sticky-header-transformed');
         }
       };
       this.setDropdownOffset = $el => {
         const dropdown = $el.find('.site-nav__dropdown.standard-dropdown');
         if (dropdown.length === 0) return;
         const nav_position = jquery_default()(dropdown).data('logoPlacement');
         const subDropdown = jquery_default()(dropdown).find('.site-nav__subdropdown');
   
         // Get dropdown's distance from the right side of the window
         const dropdownRight = jquery_default()(window).width() - (dropdown.offset().left + dropdown.outerWidth());
   
         // If it's less than 15px from the right edge of the window, it is too far right.
         if (dropdownRight < 15) {
           dropdown.css({
             right: '0',
             left: 'auto'
           });
         }
         if (subDropdown.length === 0) return;
   
         // Get the subdropdown's distance from the right side of the window
         const subDropdownRight = jquery_default()(window).width() - (subDropdown.offset().left + subDropdown.outerWidth());
         if (subDropdownRight < 15) {
           if (nav_position == 'left' || nav_position == 'above') {
             subDropdown.css({
               left: 'auto',
               right: '100%'
             });
           } else {
             subDropdown.css({
               left: '100%',
               right: 'auto'
             });
           }
         }
       };
       const self = this;
       this.theme = theme;
       this.element = element;
       this.$element = jquery_default()(element);
       this.$nav = jquery_default()('#AccessibleNav');
       this.$allLinks = this.$nav.find('a');
       this.$topLevel = this.$nav.children('li').find('a');
       this.$parents = this.$nav.find('.site-nav--has-dropdown');
       this.$mainLinks = this.$nav.find('.site-nav--has-dropdown.first-level-dropdown');
       this.$subMenus = this.$nav.find('.site-nav__dropdown');
       this.$subMenuLinks = this.$subMenus.find('a');
       this.activeClass = 'nav-hover';
       this.$sectionId = this.$element.attr('data-wetheme-section-id');
       this.$megaMenuDropdowns = document.querySelectorAll('.site-nav__dropdown.mega-menu-dropdown');
       this.$megaMenu = document.querySelector('.mega-menu-block');
       this.$megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');
       this.$resizeTimeout = null;
       this.$parents.each((i, el) => {
         this.setDropdownOffset(jquery_default()(el));
       });
       this.$subMenus.each((i, el) => {
         this.initScrollHandler(el);
       });
       this.setMegaMenuPosition();
       window.addEventListener('resize', () => {
         this.$parents.each((i, el) => {
           // If there's a scheduled resize, cancel it
           if (this.$resizeTimeout) {
             clearTimeout(this.$resizeTimeout);
           }
   
           // Schedule a new resize event to run 300ms from now
           this.$resizeTimeout = setTimeout(() => {
             this.$parents.each((i, el) => {
               this.setDropdownOffset(jquery_default()(el));
               this.setMegaMenuPosition();
             });
           }, 300);
         });
       });
       if (window.Shopify.designMode) {
         document.addEventListener('shopify:section:select', e => {
           if (e.detail.sectionId == this.$sectionId) {
             this.$element.addClass('section-selected');
             this.setMegaMenuPosition();
           } else {
             this.$element.removeClass('section-selected');
           }
         });
         document.addEventListener('shopify:section:deselect', e => {
           if (e.detail.sectionId == this.$sectionId) {
             this.$element.removeClass('section-selected');
             this.setMegaMenuPosition();
           }
         });
         document.addEventListener('shopify:section:load', e => {
           if (e.detail.sectionId == this.$sectionId) {
             this.setMegaMenuPosition();
           }
         });
       }
       document.addEventListener('headerSticked', e => {
         this.setMegaMenuPosition();
       });
       document.addEventListener('headerUnstuck', e => {
         setTimeout(() => {
           this.setMegaMenuPosition();
         }, 300);
       });
       this.$parents.on('mouseover touchstart focusin', function (evt) {
         var ret = true;
         var $el = jquery_default()(this);
         if (!$el.hasClass(self.activeClass)) {
           evt.preventDefault();
           self.hideDropdown($el.siblings());
           ret = false;
         }
         self.showDropdown($el);
         return ret;
       });
       this.$parents.each((i, el) => {
         hoverintent_default()(el, function (evt) {
           jquery_default()('.' + self.activeClass).each(function (el) {
             var $active = jquery_default()(this);
             if ($active.has(evt.target).length === 0) {
               $active.removeClass(self.activeClass);
             }
           });
         }, function () {
           // This is triggered when hovering over sub-menus /
           // child elements, so avoid using self.hideDropdown()
           // here.
         });
       });
   
       // Handle focus for submenus.
       this.$parents.each((i, el) => {
         jquery_default()(el).on('focusin', function (elem) {
           self.showDropdown(jquery_default()(el));
         });
       });
   
       // Hide dropdown when moving away from top level links.
       this.$mainLinks.each((i, el) => {
         jquery_default()(el).on('mouseleave', function (elem) {
           self.hideDropdown();
         });
       });
   
       // Mouseout / blur.
       jquery_default()('.site-header').on('mouseleave', () => {
         self.hideDropdown();
       });
       jquery_default()('.site-nav__dropdown').on('mouseleave focusout', evt => {
         self.hideDropdown(jquery_default()(this));
       });
       jquery_default()(this.$megaMenu).on('mouseleave', () => {
         self.hideDropdown();
       });
       this.$subMenuLinks.on('touchstart', function (evt) {
         // Prevent touchstart on body from firing instead of link
         evt.stopImmediatePropagation();
       });
       this.$allLinks.on('focusin', function (evt) {
         let $el = jquery_default()(this).parent();
         self.closeSiblings($el, evt);
       });
       jquery_default()('.site-header').find('a, button, select').on('focusin', function () {
         // If this is not a menu (e.g. icon, logo), close all menus.
         let thisElem = this;
         let closeAllMenus = true;
         self.$allLinks.each(function () {
           if (jquery_default()(this).is(thisElem)) {
             closeAllMenus = false;
           }
         });
         if (closeAllMenus) {
           self.$parents.each(function () {
             self.hideDropdown(jquery_default()(this));
           });
         }
       });
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Header.js
   
   
   
   
   
   
   class Header extends Section {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      * @param {boolean} pageLoad
      */
     constructor(theme, _element, pageLoad) {
       super(theme, _element, pageLoad);
       this.onCartUpdate = e => {
         Array.prototype.forEach.call(document.querySelectorAll('.cart-item-count-header--quantity'), el => {
           el.classList.add('hide');
           const cartHasItems = e.detail.cart.item_count > 0;
           el.textContent = e.detail.cart.item_count;
           if (cartHasItems) el.classList.remove('hide');
         });
       };
       this.onCartButtonClick = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('cart');
       };
       // ADDED FOR ACCOUNT DRAWER
         this.onAccountButtonClick = e => {
            e.preventDefault();
             this.theme.toggleRightDrawer('login');
         };
       // ADDED FOR ACCOUNT DRAWER
       this.onMobileMenuButtonClick = e => {
         e.preventDefault();
         this.mobileMenu.toggle();
       };
       this.loadSearchDrawer = () => {
         document.querySelectorAll('.search-button').forEach(item => {
           item.addEventListener('click', this.onSearch);
         });
       };
       this.onSearch = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('search', true);
       };
       this.loadAccessibleMenu = () => {
         this.$element.find('.site-nav').addClass('js');
         this.$element.find('.site-nav li a').focus(function () {
           // main nav anchor focus
           jquery_default()(this).parent().children('ul').fadeIn();
         });
         this.$element.find('.site-nav li li a').off(); // unbind hide drop downs from sub nav anchors
   
         const self = this;
         this.$element.find('.mobile-nav__link').on('click', function () {
           const a = /** @type {HTMLAnchorElement} */this;
           if (a.href && a.href.split('#')[0] === window.location.href.split('#')[0]) {
             // Anchor on same page - just close the drawer
             self.theme.toggleLeftDrawer(false);
           }
         });
         this.tabindexMobileNav();
       };
       this.tabindexMobileNav = () => {
         // Mobile menu should not be keyboard-navigable while viewing on desktop.
         if (window.innerWidth > 767) {
           this.$element.find('#NavDrawer a, #NavDrawer button').attr('tabindex', -1);
         } else {
           this.$element.find('#NavDrawer a:not(.promo-text), #NavDrawer button').removeAttr('tabindex');
         }
       };
       this.onWindowResize = ({
         width,
         oldWidth,
         breakpoint
       }) => {
         this.tabindexMobileNav();
       };
       this.loadStickyHeader = () => {
         if ('IntersectionObserver' in window) {
           // We need to apply sticky to child of element that is being scrolled, in
           // this case it's the whole `shopify-section`
           const headerWrapper = this.element.closest('.shopify-section.header-section');
           headerWrapper.classList.add('sticky-header');
           const observer = new IntersectionObserver(([e]) => {
             if (e.intersectionRatio < 1) {
               e.target.classList.add('sticked');
               // Dispatch a custom event when the header becomes 'sticked'
               const stickedEvent = new CustomEvent('headerSticked', {
                 detail: e.target
               });
               document.dispatchEvent(stickedEvent);
             } else {
               e.target.classList.remove('sticked');
               // Dispatch a custom event when the header becomes 'unstuck'
               const unstuckEvent = new CustomEvent('headerUnstuck', {
                 detail: e.target
               });
               document.dispatchEvent(unstuckEvent);
             }
           }, {
             threshold: [1]
           });
           observer.observe(headerWrapper);
         }
       };
       this.onBlockSelect = ({
         element
       }) => {
         // Open mega menu and make overlay force-hovered
         if (element.dataset.megaMenuBlockId) {
           this.$element.find('[data-mega-menu-block-id=' + element.dataset.megaMenuBlockId + ']').closest('li.mega-menu').addClass('force-open');
           this.$element.find('.overlay-header').addClass('force-hover');
           const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu.force-open .mega-menu-block .dropdown-submenu'));
           initiateFadeInUpAnimation(megaMenuChildrenArray); // Initiate mega menu animation
         }
       };
       this.onBlockDeselect = () => {
         // Close mega menu and make overlay non-hovered
         this.$element.find('li.mega-menu.force-open').removeClass('force-open');
         this.$element.find('.overlay-header').removeClass('force-hover');
         const megaMenuChildrenArray = Array.from(this.$element.find('li.mega-menu .mega-menu-block .dropdown-submenu'));
         removeFadeInUpAnimation(megaMenuChildrenArray); // Remove mega menu animation
       };
       this.handleExternalLinks = () => {
         var links = this.element.querySelectorAll('a');
         for (let i = 0, linksLength = links.length; i < linksLength; i++) {
           if (links[i].hostname !== window.location.hostname) {
             links[i].target = '_blank';
             links[i].rel = 'noreferrer noopener';
           }
         }
       };
       this.$element = jquery_default()(this.element);
        Array.prototype.forEach.call(this.element.querySelectorAll('.js-drawer-open-right-link'), el => el.addEventListener('click', this.onCartButtonClick));
         // ADDED FOR ACCOUNT DRAWER
        Array.prototype.forEach.call(this.element.querySelectorAll('.js-drawer-open-right-link-account'), el => el.addEventListener('click', this.onAccountButtonClick));
        // ADDED FOR ACCOUNT DRAWER
       this.element.querySelector('.js-drawer-open-left-link').addEventListener('click', this.onMobileMenuButtonClick);
       this.mobileMenu = new MobileMenu(theme, this.element.querySelector('.drawer--left'));
       document.documentElement.addEventListener(CART_UPDATE_EVENT, this.onCartUpdate);
       if (window.Shopify.designMode) {
         const headerEl = this.element.querySelector('header');
         const overlayHeader = this.element.dataset.headerOverlay;
         document.addEventListener('shopify:inspector:activate', () => {
           // Disable sticky header
           this.element.setAttribute('data-inspector-active', 'true');
           const headerWrapper = this.element.closest('.shopify-section');
           if (this.element.dataset.headerSticky === 'true') headerWrapper.classList.remove('sticky-header');
   
           // Disable overlay header
           if (overlayHeader == 'true') {
             this.element.classList.remove('overlay-header-wrapper');
             if (headerEl) headerEl.classList.remove('overlay-header');
           }
         });
         document.addEventListener('shopify:inspector:deactivate', () => {
           // Re-enable sticky header
           this.element.setAttribute('data-inspector-active', 'false');
           if (this.element.dataset.headerSticky === 'true') this.loadStickyHeader();
   
           // Re-enable overlay header
           if (overlayHeader == 'true') {
             this.element.classList.add('overlay-header-wrapper');
             if (headerEl) headerEl.classList.add('overlay-header');
           }
         });
       }
   
       // Close mobile menu on overlay click
       this.element.querySelector('#NavDrawerOverlay').addEventListener('click', () => this.theme.toggleLeftDrawer(false));
       this.loadAccessibleMenu();
       if (this.element.dataset.headerSticky === 'true' && (this.element.dataset.inspectorActive == 'false' || !this.element.dataset.inspectorActive)) {
         this.loadStickyHeader();
       }
       this.loadSearchDrawer();
       this.menu = new Menu(this, _element);
       this.handleExternalLinks();
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Footer.js
   
   class Footer extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.fixFooterToBottom = () => {
         let heightOfContent = this.pageContainer.offsetHeight + this.footerWrapper.offsetHeight;
         this.footerWrapper.classList.remove('fix-to-bottom');
   
         // If the viewport is higher than the content.
        //  if (window.innerHeight > heightOfContent) {
        //    this.footerWrapper.classList.add('fix-to-bottom');
        //  }
       };
       this.onBlockSelect = () => {
         this.fixFooterToBottom();
       };
       this.footerWrapper = /** @type {HTMLElement} */document.querySelector('.footer-wrapper');
       this.footer = /** @type {HTMLElement} */document.querySelector('footer');
       this.pageContainer = /** @type {HTMLElement} */document.querySelector('#PageContainer');
       this.fixFooterToBottom();
       let self = this;
       document.addEventListener('shopify:section:load', this.fixFooterToBottom);
       document.addEventListener('shopify:section:unload', this.fixFooterToBottom);
       document.addEventListener('shopify:section:select', this.fixFooterToBottom);
       document.addEventListener('shopify:section:deselect', this.fixFooterToBottom);
       document.addEventListener('shopify:section:reorder', this.fixFooterToBottom);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/AnnouncementBar.js
   
   class AnnouncementBar extends Section {}
   ;// CONCATENATED MODULE: ./src/javascripts/global/KenBurns.js
   class KenBurns {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element) {
       this.load = () => {
         if ('IntersectionObserver' in window) {
           this.observer = new IntersectionObserver(() => {
             this.apply();
           }, {
             threshold: [1]
           });
           this.observer.observe(this.element);
         }
       };
       this.apply = () => {
         Array.prototype.forEach.call(this.element.querySelectorAll('.kb-enabled'), (el, index) => {
           setTimeout(() => {
             el.classList.add('in-viewport');
           }, 150 * index);
         });
       };
       this.reapply = () => {
         Array.prototype.forEach.call(this.element.querySelectorAll('.kb-enabled'), el => {
           if (el.classList.contains('in-viewport')) {
             // Reapply ken burns with a slight delay.
             el.classList.add('no-anim');
             el.classList.remove('in-viewport');
             setTimeout(() => {
               el.classList.remove('no-anim');
               el.classList.add('in-viewport');
             }, 150);
           }
         });
       };
       this.theme = theme;
       this.element = element;
       this.load();
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/AnimatedText.js
   
   
   class AnimatedText extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.kenBurns = new KenBurns(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/CustomHtml.js
   
   class CustomHtml extends Section {}
   // EXTERNAL MODULE: ./node_modules/imagesloaded/imagesloaded.js
   var imagesloaded = __webpack_require__(564);
   var imagesloaded_default = /*#__PURE__*/__webpack_require__.n(imagesloaded);
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Hero.js
   
   
   
   
   class Hero extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.hoverEffect = $link => {
         const $overlay = jquery_default()('#' + $link.data('overlayId'));
         $link.hover(() => {
           $overlay.addClass("active");
         }, () => {
           $overlay.removeClass("active");
         });
   
         // Apply hover on page load
         if ($link.is(':hover')) {
           $overlay.addClass("active");
         }
       };
       imagesloaded_default()(this.element.querySelectorAll('.homepage-hero-content-overlay-menu-item'), {
         background: true
       }, () => {
         this.kenBurns = new KenBurns(theme, element);
         jquery_default()(".homepage-hero-text-advert-link").each((index, link) => {
           this.hoverEffect(jquery_default()(link));
         });
         jquery_default()('.homepage-hero-menu li').each((index, link) => {
           this.hoverEffect(jquery_default()(link));
         });
       });
     }
   }
   ;// CONCATENATED MODULE: ./node_modules/ssr-window/dist/ssr-window.esm.js
   /**
    * SSR Window 2.0.0
    * Better handling for window object in SSR environment
    * https://github.com/nolimits4web/ssr-window
    *
    * Copyright 2020, Vladimir Kharlampidi
    *
    * Licensed under MIT
    *
    * Released on: May 12, 2020
    */
   /* eslint-disable no-param-reassign */
   function ssr_window_esm_isObject(obj) {
       return (obj !== null &&
           typeof obj === 'object' &&
           'constructor' in obj &&
           obj.constructor === Object);
   }
   function ssr_window_esm_extend(target, src) {
       if (target === void 0) { target = {}; }
       if (src === void 0) { src = {}; }
       Object.keys(src).forEach(function (key) {
           if (typeof target[key] === 'undefined')
               target[key] = src[key];
           else if (ssr_window_esm_isObject(src[key]) &&
               ssr_window_esm_isObject(target[key]) &&
               Object.keys(src[key]).length > 0) {
               ssr_window_esm_extend(target[key], src[key]);
           }
       });
   }
   
   var doc = typeof document !== 'undefined' ? document : {};
   var ssrDocument = {
       body: {},
       addEventListener: function () { },
       removeEventListener: function () { },
       activeElement: {
           blur: function () { },
           nodeName: '',
       },
       querySelector: function () {
           return null;
       },
       querySelectorAll: function () {
           return [];
       },
       getElementById: function () {
           return null;
       },
       createEvent: function () {
           return {
               initEvent: function () { },
           };
       },
       createElement: function () {
           return {
               children: [],
               childNodes: [],
               style: {},
               setAttribute: function () { },
               getElementsByTagName: function () {
                   return [];
               },
           };
       },
       createElementNS: function () {
           return {};
       },
       importNode: function () {
           return null;
       },
       location: {
           hash: '',
           host: '',
           hostname: '',
           href: '',
           origin: '',
           pathname: '',
           protocol: '',
           search: '',
       },
   };
   ssr_window_esm_extend(doc, ssrDocument);
   
   var win = typeof window !== 'undefined' ? window : {};
   var ssrWindow = {
       document: ssrDocument,
       navigator: {
           userAgent: '',
       },
       location: {
           hash: '',
           host: '',
           hostname: '',
           href: '',
           origin: '',
           pathname: '',
           protocol: '',
           search: '',
       },
       history: {
           replaceState: function () { },
           pushState: function () { },
           go: function () { },
           back: function () { },
       },
       CustomEvent: function CustomEvent() {
           return this;
       },
       addEventListener: function () { },
       removeEventListener: function () { },
       getComputedStyle: function () {
           return {
               getPropertyValue: function () {
                   return '';
               },
           };
       },
       Image: function () { },
       Date: function () { },
       screen: {},
       setTimeout: function () { },
       clearTimeout: function () { },
       matchMedia: function () {
           return {};
       },
   };
   ssr_window_esm_extend(win, ssrWindow);
   
   
   
   ;// CONCATENATED MODULE: ./node_modules/dom7/dist/dom7.modular.js
   /**
    * Dom7 2.1.5
    * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
    * http://framework7.io/docs/dom.html
    *
    * Copyright 2020, Vladimir Kharlampidi
    * The iDangero.us
    * http://www.idangero.us/
    *
    * Licensed under MIT
    *
    * Released on: May 15, 2020
    */
   
   
   class Dom7 {
     constructor(arr) {
       const self = this;
       // Create array-like object
       for (let i = 0; i < arr.length; i += 1) {
         self[i] = arr[i];
       }
       self.length = arr.length;
       // Return collection with methods
       return this;
     }
   }
   
   function $(selector, context) {
     const arr = [];
     let i = 0;
     if (selector && !context) {
       if (selector instanceof Dom7) {
         return selector;
       }
     }
     if (selector) {
         // String
       if (typeof selector === 'string') {
         let els;
         let tempParent;
         const html = selector.trim();
         if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
           let toCreate = 'div';
           if (html.indexOf('<li') === 0) toCreate = 'ul';
           if (html.indexOf('<tr') === 0) toCreate = 'tbody';
           if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
           if (html.indexOf('<tbody') === 0) toCreate = 'table';
           if (html.indexOf('<option') === 0) toCreate = 'select';
           tempParent = doc.createElement(toCreate);
           tempParent.innerHTML = html;
           for (i = 0; i < tempParent.childNodes.length; i += 1) {
             arr.push(tempParent.childNodes[i]);
           }
         } else {
           if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
             // Pure ID selector
             els = [doc.getElementById(selector.trim().split('#')[1])];
           } else {
             // Other selectors
             els = (context || doc).querySelectorAll(selector.trim());
           }
           for (i = 0; i < els.length; i += 1) {
             if (els[i]) arr.push(els[i]);
           }
         }
       } else if (selector.nodeType || selector === win || selector === doc) {
         // Node/element
         arr.push(selector);
       } else if (selector.length > 0 && selector[0].nodeType) {
         // Array of elements or instance of Dom
         for (i = 0; i < selector.length; i += 1) {
           arr.push(selector[i]);
         }
       }
     }
     return new Dom7(arr);
   }
   
   $.fn = Dom7.prototype;
   $.Class = Dom7;
   $.Dom7 = Dom7;
   
   function unique(arr) {
     const uniqueArray = [];
     for (let i = 0; i < arr.length; i += 1) {
       if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
     }
     return uniqueArray;
   }
   function toCamelCase(string) {
     return string.toLowerCase().replace(/-(.)/g, (match, group1) => group1.toUpperCase());
   }
   
   function dom7_modular_requestAnimationFrame(callback) {
     if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
     else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
     return window.setTimeout(callback, 1000 / 60);
   }
   function dom7_modular_cancelAnimationFrame(id) {
     if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
     else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
     return window.clearTimeout(id);
   }
   
   // Classes and attributes
   function dom7_modular_addClass(className) {
     if (typeof className === 'undefined') {
       return this;
     }
     const classes = className.split(' ');
     for (let i = 0; i < classes.length; i += 1) {
       for (let j = 0; j < this.length; j += 1) {
         if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
       }
     }
     return this;
   }
   function dom7_modular_removeClass(className) {
     const classes = className.split(' ');
     for (let i = 0; i < classes.length; i += 1) {
       for (let j = 0; j < this.length; j += 1) {
         if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
       }
     }
     return this;
   }
   function hasClass(className) {
     if (!this[0]) return false;
     return this[0].classList.contains(className);
   }
   function toggleClass(className) {
     const classes = className.split(' ');
     for (let i = 0; i < classes.length; i += 1) {
       for (let j = 0; j < this.length; j += 1) {
         if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
       }
     }
     return this;
   }
   function attr(attrs, value) {
     if (arguments.length === 1 && typeof attrs === 'string') {
       // Get attr
       if (this[0]) return this[0].getAttribute(attrs);
       return undefined;
     }
   
     // Set attrs
     for (let i = 0; i < this.length; i += 1) {
       if (arguments.length === 2) {
         // String
         this[i].setAttribute(attrs, value);
       } else {
         // Object
         // eslint-disable-next-line
         for (const attrName in attrs) {
           this[i][attrName] = attrs[attrName];
           this[i].setAttribute(attrName, attrs[attrName]);
         }
       }
     }
     return this;
   }
   // eslint-disable-next-line
   function removeAttr(attr) {
     for (let i = 0; i < this.length; i += 1) {
       this[i].removeAttribute(attr);
     }
     return this;
   }
   // eslint-disable-next-line
   function prop(props, value) {
     if (arguments.length === 1 && typeof props === 'string') {
       // Get prop
       if (this[0]) return this[0][props];
     } else {
       // Set props
       for (let i = 0; i < this.length; i += 1) {
         if (arguments.length === 2) {
           // String
           this[i][props] = value;
         } else {
           // Object
           // eslint-disable-next-line
           for (const propName in props) {
             this[i][propName] = props[propName];
           }
         }
       }
       return this;
     }
   }
   function data(key, value) {
     let el;
     if (typeof value === 'undefined') {
       el = this[0];
       // Get value
       if (el) {
         if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
           return el.dom7ElementDataStorage[key];
         }
   
         const dataKey = el.getAttribute(`data-${key}`);
         if (dataKey) {
           return dataKey;
         }
         return undefined;
       }
       return undefined;
     }
   
     // Set value
     for (let i = 0; i < this.length; i += 1) {
       el = this[i];
       if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
       el.dom7ElementDataStorage[key] = value;
     }
     return this;
   }
   function removeData(key) {
     for (let i = 0; i < this.length; i += 1) {
       const el = this[i];
       if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
         el.dom7ElementDataStorage[key] = null;
         delete el.dom7ElementDataStorage[key];
       }
     }
   }
   function dataset() {
     const el = this[0];
     if (!el) return undefined;
     const dataset = {}; // eslint-disable-line
     if (el.dataset) {
       // eslint-disable-next-line
       for (const dataKey in el.dataset) {
         dataset[dataKey] = el.dataset[dataKey];
       }
     } else {
       for (let i = 0; i < el.attributes.length; i += 1) {
         // eslint-disable-next-line
         const attr = el.attributes[i];
         if (attr.name.indexOf('data-') >= 0) {
           dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
         }
       }
     }
     // eslint-disable-next-line
     for (const key in dataset) {
       if (dataset[key] === 'false') dataset[key] = false;
       else if (dataset[key] === 'true') dataset[key] = true;
       else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
     }
     return dataset;
   }
   function val(value) {
     const dom = this;
     if (typeof value === 'undefined') {
       if (dom[0]) {
         if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
           const values = [];
           for (let i = 0; i < dom[0].selectedOptions.length; i += 1) {
             values.push(dom[0].selectedOptions[i].value);
           }
           return values;
         }
         return dom[0].value;
       }
       return undefined;
     }
   
     for (let i = 0; i < dom.length; i += 1) {
       const el = dom[i];
       if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
         for (let j = 0; j < el.options.length; j += 1) {
           el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
         }
       } else {
         el.value = value;
       }
     }
     return dom;
   }
   // Transforms
   // eslint-disable-next-line
   function transform(transform) {
     for (let i = 0; i < this.length; i += 1) {
       const elStyle = this[i].style;
       elStyle.webkitTransform = transform;
       elStyle.transform = transform;
     }
     return this;
   }
   function dom7_modular_transition(duration) {
     if (typeof duration !== 'string') {
       duration = `${duration}ms`; // eslint-disable-line
     }
     for (let i = 0; i < this.length; i += 1) {
       const elStyle = this[i].style;
       elStyle.webkitTransitionDuration = duration;
       elStyle.transitionDuration = duration;
     }
     return this;
   }
   // Events
   function dom7_modular_on(...args) {
     let [eventType, targetSelector, listener, capture] = args;
     if (typeof args[1] === 'function') {
       [eventType, listener, capture] = args;
       targetSelector = undefined;
     }
     if (!capture) capture = false;
   
     function handleLiveEvent(e) {
       const target = e.target;
       if (!target) return;
       const eventData = e.target.dom7EventData || [];
       if (eventData.indexOf(e) < 0) {
         eventData.unshift(e);
       }
       if ($(target).is(targetSelector)) listener.apply(target, eventData);
       else {
         const parents = $(target).parents(); // eslint-disable-line
         for (let k = 0; k < parents.length; k += 1) {
           if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
         }
       }
     }
     function handleEvent(e) {
       const eventData = e && e.target ? e.target.dom7EventData || [] : [];
       if (eventData.indexOf(e) < 0) {
         eventData.unshift(e);
       }
       listener.apply(this, eventData);
     }
     const events = eventType.split(' ');
     let j;
     for (let i = 0; i < this.length; i += 1) {
       const el = this[i];
       if (!targetSelector) {
         for (j = 0; j < events.length; j += 1) {
           const event = events[j];
           if (!el.dom7Listeners) el.dom7Listeners = {};
           if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
           el.dom7Listeners[event].push({
             listener,
             proxyListener: handleEvent,
           });
           el.addEventListener(event, handleEvent, capture);
         }
       } else {
         // Live events
         for (j = 0; j < events.length; j += 1) {
           const event = events[j];
           if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
           if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
           el.dom7LiveListeners[event].push({
             listener,
             proxyListener: handleLiveEvent,
           });
           el.addEventListener(event, handleLiveEvent, capture);
         }
       }
     }
     return this;
   }
   function off(...args) {
     let [eventType, targetSelector, listener, capture] = args;
     if (typeof args[1] === 'function') {
       [eventType, listener, capture] = args;
       targetSelector = undefined;
     }
     if (!capture) capture = false;
   
     const events = eventType.split(' ');
     for (let i = 0; i < events.length; i += 1) {
       const event = events[i];
       for (let j = 0; j < this.length; j += 1) {
         const el = this[j];
         let handlers;
         if (!targetSelector && el.dom7Listeners) {
           handlers = el.dom7Listeners[event];
         } else if (targetSelector && el.dom7LiveListeners) {
           handlers = el.dom7LiveListeners[event];
         }
         if (handlers && handlers.length) {
           for (let k = handlers.length - 1; k >= 0; k -= 1) {
             const handler = handlers[k];
             if (listener && handler.listener === listener) {
               el.removeEventListener(event, handler.proxyListener, capture);
               handlers.splice(k, 1);
             } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
               el.removeEventListener(event, handler.proxyListener, capture);
               handlers.splice(k, 1);
             } else if (!listener) {
               el.removeEventListener(event, handler.proxyListener, capture);
               handlers.splice(k, 1);
             }
           }
         }
       }
     }
     return this;
   }
   function dom7_modular_once(...args) {
     const dom = this;
     let [eventName, targetSelector, listener, capture] = args;
     if (typeof args[1] === 'function') {
       [eventName, listener, capture] = args;
       targetSelector = undefined;
     }
     function onceHandler(...eventArgs) {
       listener.apply(this, eventArgs);
       dom.off(eventName, targetSelector, onceHandler, capture);
       if (onceHandler.dom7proxy) {
         delete onceHandler.dom7proxy;
       }
     }
     onceHandler.dom7proxy = listener;
     return dom.on(eventName, targetSelector, onceHandler, capture);
   }
   function dom7_modular_trigger(...args) {
     const events = args[0].split(' ');
     const eventData = args[1];
     for (let i = 0; i < events.length; i += 1) {
       const event = events[i];
       for (let j = 0; j < this.length; j += 1) {
         const el = this[j];
         let evt;
         try {
           evt = new win.CustomEvent(event, {
             detail: eventData,
             bubbles: true,
             cancelable: true,
           });
         } catch (e) {
           evt = doc.createEvent('Event');
           evt.initEvent(event, true, true);
           evt.detail = eventData;
         }
         // eslint-disable-next-line
         el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
         el.dispatchEvent(evt);
         el.dom7EventData = [];
         delete el.dom7EventData;
       }
     }
     return this;
   }
   function transitionEnd(callback) {
     const events = ['webkitTransitionEnd', 'transitionend'];
     const dom = this;
     let i;
     function fireCallBack(e) {
       /* jshint validthis:true */
       if (e.target !== this) return;
       callback.call(this, e);
       for (i = 0; i < events.length; i += 1) {
         dom.off(events[i], fireCallBack);
       }
     }
     if (callback) {
       for (i = 0; i < events.length; i += 1) {
         dom.on(events[i], fireCallBack);
       }
     }
     return this;
   }
   function animationEnd(callback) {
     const events = ['webkitAnimationEnd', 'animationend'];
     const dom = this;
     let i;
     function fireCallBack(e) {
       if (e.target !== this) return;
       callback.call(this, e);
       for (i = 0; i < events.length; i += 1) {
         dom.off(events[i], fireCallBack);
       }
     }
     if (callback) {
       for (i = 0; i < events.length; i += 1) {
         dom.on(events[i], fireCallBack);
       }
     }
     return this;
   }
   // Sizing/Styles
   function width() {
     if (this[0] === window) {
       return window.innerWidth;
     }
   
     if (this.length > 0) {
       return parseFloat(this.css('width'));
     }
   
     return null;
   }
   function dom7_modular_outerWidth(includeMargins) {
     if (this.length > 0) {
       if (includeMargins) {
         // eslint-disable-next-line
         const styles = this.styles();
         return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
       }
       return this[0].offsetWidth;
     }
     return null;
   }
   function height() {
     if (this[0] === window) {
       return window.innerHeight;
     }
   
     if (this.length > 0) {
       return parseFloat(this.css('height'));
     }
   
     return null;
   }
   function dom7_modular_outerHeight(includeMargins) {
     if (this.length > 0) {
       if (includeMargins) {
         // eslint-disable-next-line
         const styles = this.styles();
         return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
       }
       return this[0].offsetHeight;
     }
     return null;
   }
   function offset() {
     if (this.length > 0) {
       const el = this[0];
       const box = el.getBoundingClientRect();
       const body = doc.body;
       const clientTop = el.clientTop || body.clientTop || 0;
       const clientLeft = el.clientLeft || body.clientLeft || 0;
       const scrollTop = el === win ? win.scrollY : el.scrollTop;
       const scrollLeft = el === win ? win.scrollX : el.scrollLeft;
       return {
         top: (box.top + scrollTop) - clientTop,
         left: (box.left + scrollLeft) - clientLeft,
       };
     }
   
     return null;
   }
   function hide() {
     for (let i = 0; i < this.length; i += 1) {
       this[i].style.display = 'none';
     }
     return this;
   }
   function dom7_modular_show() {
     for (let i = 0; i < this.length; i += 1) {
       const el = this[i];
       if (el.style.display === 'none') {
         el.style.display = '';
       }
       if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
         // Still not visible
         el.style.display = 'block';
       }
     }
     return this;
   }
   function styles() {
     if (this[0]) return win.getComputedStyle(this[0], null);
     return {};
   }
   function css(props, value) {
     let i;
     if (arguments.length === 1) {
       if (typeof props === 'string') {
         if (this[0]) return win.getComputedStyle(this[0], null).getPropertyValue(props);
       } else {
         for (i = 0; i < this.length; i += 1) {
           // eslint-disable-next-line
           for (let prop in props) {
             this[i].style[prop] = props[prop];
           }
         }
         return this;
       }
     }
     if (arguments.length === 2 && typeof props === 'string') {
       for (i = 0; i < this.length; i += 1) {
         this[i].style[props] = value;
       }
       return this;
     }
     return this;
   }
   
   // Dom manipulation
   function dom7_modular_toArray() {
     const arr = [];
     for (let i = 0; i < this.length; i += 1) {
       arr.push(this[i]);
     }
     return arr;
   }
   // Iterate over the collection passing elements to `callback`
   function each(callback) {
     // Don't bother continuing without a callback
     if (!callback) return this;
     // Iterate over the current collection
     for (let i = 0; i < this.length; i += 1) {
       // If the callback returns false
       if (callback.call(this[i], i, this[i]) === false) {
         // End the loop early
         return this;
       }
     }
     // Return `this` to allow chained DOM operations
     return this;
   }
   function forEach(callback) {
     // Don't bother continuing without a callback
     if (!callback) return this;
     // Iterate over the current collection
     for (let i = 0; i < this.length; i += 1) {
       // If the callback returns false
       if (callback.call(this[i], this[i], i) === false) {
         // End the loop early
         return this;
       }
     }
     // Return `this` to allow chained DOM operations
     return this;
   }
   function filter(callback) {
     const matchedItems = [];
     const dom = this;
     for (let i = 0; i < dom.length; i += 1) {
       if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
     }
     return new Dom7(matchedItems);
   }
   function map(callback) {
     const modifiedItems = [];
     const dom = this;
     for (let i = 0; i < dom.length; i += 1) {
       modifiedItems.push(callback.call(dom[i], i, dom[i]));
     }
     return new Dom7(modifiedItems);
   }
   // eslint-disable-next-line
   function dom7_modular_html(html) {
     if (typeof html === 'undefined') {
       return this[0] ? this[0].innerHTML : undefined;
     }
   
     for (let i = 0; i < this.length; i += 1) {
       this[i].innerHTML = html;
     }
     return this;
   }
   // eslint-disable-next-line
   function dom7_modular_text(text) {
     if (typeof text === 'undefined') {
       if (this[0]) {
         return this[0].textContent.trim();
       }
       return null;
     }
   
     for (let i = 0; i < this.length; i += 1) {
       this[i].textContent = text;
     }
     return this;
   }
   function is(selector) {
     const el = this[0];
     let compareWith;
     let i;
     if (!el || typeof selector === 'undefined') return false;
     if (typeof selector === 'string') {
       if (el.matches) return el.matches(selector);
       else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
       else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
   
       compareWith = $(selector);
       for (i = 0; i < compareWith.length; i += 1) {
         if (compareWith[i] === el) return true;
       }
       return false;
     } else if (selector === doc) return el === doc;
     else if (selector === win) return el === win;
   
     if (selector.nodeType || selector instanceof Dom7) {
       compareWith = selector.nodeType ? [selector] : selector;
       for (i = 0; i < compareWith.length; i += 1) {
         if (compareWith[i] === el) return true;
       }
       return false;
     }
     return false;
   }
   function indexOf(el) {
     for (let i = 0; i < this.length; i += 1) {
       if (this[i] === el) return i;
     }
     return -1;
   }
   function dom7_modular_index() {
     let child = this[0];
     let i;
     if (child) {
       i = 0;
       // eslint-disable-next-line
       while ((child = child.previousSibling) !== null) {
         if (child.nodeType === 1) i += 1;
       }
       return i;
     }
     return undefined;
   }
   // eslint-disable-next-line
   function eq(index) {
     if (typeof index === 'undefined') return this;
     const length = this.length;
     let returnIndex;
     if (index > length - 1) {
       return new Dom7([]);
     }
     if (index < 0) {
       returnIndex = length + index;
       if (returnIndex < 0) return new Dom7([]);
       return new Dom7([this[returnIndex]]);
     }
     return new Dom7([this[index]]);
   }
   function append(...args) {
     let newChild;
   
     for (let k = 0; k < args.length; k += 1) {
       newChild = args[k];
       for (let i = 0; i < this.length; i += 1) {
         if (typeof newChild === 'string') {
           const tempDiv = doc.createElement('div');
           tempDiv.innerHTML = newChild;
           while (tempDiv.firstChild) {
             this[i].appendChild(tempDiv.firstChild);
           }
         } else if (newChild instanceof Dom7) {
           for (let j = 0; j < newChild.length; j += 1) {
             this[i].appendChild(newChild[j]);
           }
         } else {
           this[i].appendChild(newChild);
         }
       }
     }
   
     return this;
   }
   // eslint-disable-next-line
   function appendTo(parent) {
     $(parent).append(this);
     return this;
   }
   function prepend(newChild) {
     let i;
     let j;
     for (i = 0; i < this.length; i += 1) {
       if (typeof newChild === 'string') {
         const tempDiv = doc.createElement('div');
         tempDiv.innerHTML = newChild;
         for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
           this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
         }
       } else if (newChild instanceof Dom7) {
         for (j = 0; j < newChild.length; j += 1) {
           this[i].insertBefore(newChild[j], this[i].childNodes[0]);
         }
       } else {
         this[i].insertBefore(newChild, this[i].childNodes[0]);
       }
     }
     return this;
   }
   // eslint-disable-next-line
   function prependTo(parent) {
     $(parent).prepend(this);
     return this;
   }
   function dom7_modular_insertBefore(selector) {
     const before = $(selector);
     for (let i = 0; i < this.length; i += 1) {
       if (before.length === 1) {
         before[0].parentNode.insertBefore(this[i], before[0]);
       } else if (before.length > 1) {
         for (let j = 0; j < before.length; j += 1) {
           before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
         }
       }
     }
   }
   function insertAfter(selector) {
     const after = $(selector);
     for (let i = 0; i < this.length; i += 1) {
       if (after.length === 1) {
         after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
       } else if (after.length > 1) {
         for (let j = 0; j < after.length; j += 1) {
           after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
         }
       }
     }
   }
   function dom7_modular_next(selector) {
     if (this.length > 0) {
       if (selector) {
         if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
           return new Dom7([this[0].nextElementSibling]);
         }
         return new Dom7([]);
       }
   
       if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
       return new Dom7([]);
     }
     return new Dom7([]);
   }
   function nextAll(selector) {
     const nextEls = [];
     let el = this[0];
     if (!el) return new Dom7([]);
     while (el.nextElementSibling) {
       const next = el.nextElementSibling; // eslint-disable-line
       if (selector) {
         if ($(next).is(selector)) nextEls.push(next);
       } else nextEls.push(next);
       el = next;
     }
     return new Dom7(nextEls);
   }
   function prev(selector) {
     if (this.length > 0) {
       const el = this[0];
       if (selector) {
         if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
           return new Dom7([el.previousElementSibling]);
         }
         return new Dom7([]);
       }
   
       if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
       return new Dom7([]);
     }
     return new Dom7([]);
   }
   function prevAll(selector) {
     const prevEls = [];
     let el = this[0];
     if (!el) return new Dom7([]);
     while (el.previousElementSibling) {
       const prev = el.previousElementSibling; // eslint-disable-line
       if (selector) {
         if ($(prev).is(selector)) prevEls.push(prev);
       } else prevEls.push(prev);
       el = prev;
     }
     return new Dom7(prevEls);
   }
   function siblings(selector) {
     return this.nextAll(selector).add(this.prevAll(selector));
   }
   function dom7_modular_parent(selector) {
     const parents = []; // eslint-disable-line
     for (let i = 0; i < this.length; i += 1) {
       if (this[i].parentNode !== null) {
         if (selector) {
           if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
         } else {
           parents.push(this[i].parentNode);
         }
       }
     }
     return $(unique(parents));
   }
   function parents(selector) {
     const parents = []; // eslint-disable-line
     for (let i = 0; i < this.length; i += 1) {
       let parent = this[i].parentNode; // eslint-disable-line
       while (parent) {
         if (selector) {
           if ($(parent).is(selector)) parents.push(parent);
         } else {
           parents.push(parent);
         }
         parent = parent.parentNode;
       }
     }
     return $(unique(parents));
   }
   function closest(selector) {
     let closest = this; // eslint-disable-line
     if (typeof selector === 'undefined') {
       return new Dom7([]);
     }
     if (!closest.is(selector)) {
       closest = closest.parents(selector).eq(0);
     }
     return closest;
   }
   function find(selector) {
     const foundElements = [];
     for (let i = 0; i < this.length; i += 1) {
       const found = this[i].querySelectorAll(selector);
       for (let j = 0; j < found.length; j += 1) {
         foundElements.push(found[j]);
       }
     }
     return new Dom7(foundElements);
   }
   function children(selector) {
     const children = []; // eslint-disable-line
     for (let i = 0; i < this.length; i += 1) {
       const childNodes = this[i].childNodes;
   
       for (let j = 0; j < childNodes.length; j += 1) {
         if (!selector) {
           if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
         } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
           children.push(childNodes[j]);
         }
       }
     }
     return new Dom7(unique(children));
   }
   function dom7_modular_remove() {
     for (let i = 0; i < this.length; i += 1) {
       if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
     }
     return this;
   }
   function detach() {
     return this.remove();
   }
   function dom7_modular_add(...args) {
     const dom = this;
     let i;
     let j;
     for (i = 0; i < args.length; i += 1) {
       const toAdd = $(args[i]);
       for (j = 0; j < toAdd.length; j += 1) {
         dom[dom.length] = toAdd[j];
         dom.length += 1;
       }
     }
     return dom;
   }
   function empty() {
     for (let i = 0; i < this.length; i += 1) {
       const el = this[i];
       if (el.nodeType === 1) {
         for (let j = 0; j < el.childNodes.length; j += 1) {
           if (el.childNodes[j].parentNode) {
             el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
           }
         }
         el.textContent = '';
       }
     }
     return this;
   }
   
   function scrollTo(...args) {
     let [left, top, duration, easing, callback] = args;
     if (args.length === 4 && typeof easing === 'function') {
       callback = easing;
       [left, top, duration, callback, easing] = args;
     }
     if (typeof easing === 'undefined') easing = 'swing';
   
     return this.each(function animate() {
       const el = this;
       let currentTop;
       let currentLeft;
       let maxTop;
       let maxLeft;
       let newTop;
       let newLeft;
       let scrollTop; // eslint-disable-line
       let scrollLeft; // eslint-disable-line
       let animateTop = top > 0 || top === 0;
       let animateLeft = left > 0 || left === 0;
       if (typeof easing === 'undefined') {
         easing = 'swing';
       }
       if (animateTop) {
         currentTop = el.scrollTop;
         if (!duration) {
           el.scrollTop = top;
         }
       }
       if (animateLeft) {
         currentLeft = el.scrollLeft;
         if (!duration) {
           el.scrollLeft = left;
         }
       }
       if (!duration) return;
       if (animateTop) {
         maxTop = el.scrollHeight - el.offsetHeight;
         newTop = Math.max(Math.min(top, maxTop), 0);
       }
       if (animateLeft) {
         maxLeft = el.scrollWidth - el.offsetWidth;
         newLeft = Math.max(Math.min(left, maxLeft), 0);
       }
       let startTime = null;
       if (animateTop && newTop === currentTop) animateTop = false;
       if (animateLeft && newLeft === currentLeft) animateLeft = false;
       function render(time = new Date().getTime()) {
         if (startTime === null) {
           startTime = time;
         }
         const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
         const easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
         let done;
         if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
         if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
         if (animateTop && newTop > currentTop && scrollTop >= newTop) {
           el.scrollTop = newTop;
           done = true;
         }
         if (animateTop && newTop < currentTop && scrollTop <= newTop) {
           el.scrollTop = newTop;
           done = true;
         }
         if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
           el.scrollLeft = newLeft;
           done = true;
         }
         if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
           el.scrollLeft = newLeft;
           done = true;
         }
   
         if (done) {
           if (callback) callback();
           return;
         }
         if (animateTop) el.scrollTop = scrollTop;
         if (animateLeft) el.scrollLeft = scrollLeft;
         dom7_modular_requestAnimationFrame(render);
       }
       dom7_modular_requestAnimationFrame(render);
     });
   }
   // scrollTop(top, duration, easing, callback) {
   function scrollTop(...args) {
     let [top, duration, easing, callback] = args;
     if (args.length === 3 && typeof easing === 'function') {
       [top, duration, callback, easing] = args;
     }
     const dom = this;
     if (typeof top === 'undefined') {
       if (dom.length > 0) return dom[0].scrollTop;
       return null;
     }
     return dom.scrollTo(undefined, top, duration, easing, callback);
   }
   function scrollLeft(...args) {
     let [left, duration, easing, callback] = args;
     if (args.length === 3 && typeof easing === 'function') {
       [left, duration, callback, easing] = args;
     }
     const dom = this;
     if (typeof left === 'undefined') {
       if (dom.length > 0) return dom[0].scrollLeft;
       return null;
     }
     return dom.scrollTo(left, undefined, duration, easing, callback);
   }
   
   function animate(initialProps, initialParams) {
     const els = this;
     const a = {
       props: Object.assign({}, initialProps),
       params: Object.assign({
         duration: 300,
         easing: 'swing', // or 'linear'
         /* Callbacks
         begin(elements)
         complete(elements)
         progress(elements, complete, remaining, start, tweenValue)
         */
       }, initialParams),
   
       elements: els,
       animating: false,
       que: [],
   
       easingProgress(easing, progress) {
         if (easing === 'swing') {
           return 0.5 - (Math.cos(progress * Math.PI) / 2);
         }
         if (typeof easing === 'function') {
           return easing(progress);
         }
         return progress;
       },
       stop() {
         if (a.frameId) {
           dom7_modular_cancelAnimationFrame(a.frameId);
         }
         a.animating = false;
         a.elements.each((index, el) => {
           const element = el;
           delete element.dom7AnimateInstance;
         });
         a.que = [];
       },
       done(complete) {
         a.animating = false;
         a.elements.each((index, el) => {
           const element = el;
           delete element.dom7AnimateInstance;
         });
         if (complete) complete(els);
         if (a.que.length > 0) {
           const que = a.que.shift();
           a.animate(que[0], que[1]);
         }
       },
       animate(props, params) {
         if (a.animating) {
           a.que.push([props, params]);
           return a;
         }
         const elements = [];
   
         // Define & Cache Initials & Units
         a.elements.each((index, el) => {
           let initialFullValue;
           let initialValue;
           let unit;
           let finalValue;
           let finalFullValue;
   
           if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
   
           elements[index] = {
             container: el,
           };
           Object.keys(props).forEach((prop) => {
             initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
             initialValue = parseFloat(initialFullValue);
             unit = initialFullValue.replace(initialValue, '');
             finalValue = parseFloat(props[prop]);
             finalFullValue = props[prop] + unit;
             elements[index][prop] = {
               initialFullValue,
               initialValue,
               unit,
               finalValue,
               finalFullValue,
               currentValue: initialValue,
             };
           });
         });
   
         let startTime = null;
         let time;
         let elementsDone = 0;
         let propsDone = 0;
         let done;
         let began = false;
   
         a.animating = true;
   
         function render() {
           time = new Date().getTime();
           let progress;
           let easeProgress;
           // let el;
           if (!began) {
             began = true;
             if (params.begin) params.begin(els);
           }
           if (startTime === null) {
             startTime = time;
           }
           if (params.progress) {
             // eslint-disable-next-line
             params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
           }
   
           elements.forEach((element) => {
             const el = element;
             if (done || el.done) return;
             Object.keys(props).forEach((prop) => {
               if (done || el.done) return;
               progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
               easeProgress = a.easingProgress(params.easing, progress);
               const { initialValue, finalValue, unit } = el[prop];
               el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
               const currentValue = el[prop].currentValue;
   
               if (
                 (finalValue > initialValue && currentValue >= finalValue) ||
                 (finalValue < initialValue && currentValue <= finalValue)) {
                 el.container.style[prop] = finalValue + unit;
                 propsDone += 1;
                 if (propsDone === Object.keys(props).length) {
                   el.done = true;
                   elementsDone += 1;
                 }
                 if (elementsDone === elements.length) {
                   done = true;
                 }
               }
               if (done) {
                 a.done(params.complete);
                 return;
               }
               el.container.style[prop] = currentValue + unit;
             });
           });
           if (done) return;
           // Then call
           a.frameId = dom7_modular_requestAnimationFrame(render);
         }
         a.frameId = dom7_modular_requestAnimationFrame(render);
         return a;
       },
     };
   
     if (a.elements.length === 0) {
       return els;
     }
   
     let animateInstance;
     for (let i = 0; i < a.elements.length; i += 1) {
       if (a.elements[i].dom7AnimateInstance) {
         animateInstance = a.elements[i].dom7AnimateInstance;
       } else a.elements[i].dom7AnimateInstance = a;
     }
     if (!animateInstance) {
       animateInstance = a;
     }
   
     if (initialProps === 'stop') {
       animateInstance.stop();
     } else {
       animateInstance.animate(a.props, a.params);
     }
   
     return els;
   }
   
   function stop() {
     const els = this;
     for (let i = 0; i < els.length; i += 1) {
       if (els[i].dom7AnimateInstance) {
         els[i].dom7AnimateInstance.stop();
       }
     }
   }
   
   const noTrigger = ('resize scroll').split(' ');
   function eventShortcut(name, ...args) {
     if (typeof args[0] === 'undefined') {
       for (let i = 0; i < this.length; i += 1) {
         if (noTrigger.indexOf(name) < 0) {
           if (name in this[i]) this[i][name]();
           else {
             $(this[i]).trigger(name);
           }
         }
       }
       return this;
     }
     return this.on(name, ...args);
   }
   
   function click(...args) {
     return eventShortcut.bind(this)('click', ...args);
   }
   function dom7_modular_blur(...args) {
     return eventShortcut.bind(this)('blur', ...args);
   }
   function dom7_modular_focus(...args) {
     return eventShortcut.bind(this)('focus', ...args);
   }
   function focusin(...args) {
     return eventShortcut.bind(this)('focusin', ...args);
   }
   function focusout(...args) {
     return eventShortcut.bind(this)('focusout', ...args);
   }
   function keyup(...args) {
     return eventShortcut.bind(this)('keyup', ...args);
   }
   function keydown(...args) {
     return eventShortcut.bind(this)('keydown', ...args);
   }
   function keypress(...args) {
     return eventShortcut.bind(this)('keypress', ...args);
   }
   function dom7_modular_submit(...args) {
     return eventShortcut.bind(this)('submit', ...args);
   }
   function change(...args) {
     return eventShortcut.bind(this)('change', ...args);
   }
   function mousedown(...args) {
     return eventShortcut.bind(this)('mousedown', ...args);
   }
   function mousemove(...args) {
     return eventShortcut.bind(this)('mousemove', ...args);
   }
   function mouseup(...args) {
     return eventShortcut.bind(this)('mouseup', ...args);
   }
   function mouseenter(...args) {
     return eventShortcut.bind(this)('mouseenter', ...args);
   }
   function mouseleave(...args) {
     return eventShortcut.bind(this)('mouseleave', ...args);
   }
   function mouseout(...args) {
     return eventShortcut.bind(this)('mouseout', ...args);
   }
   function mouseover(...args) {
     return eventShortcut.bind(this)('mouseover', ...args);
   }
   function touchstart(...args) {
     return eventShortcut.bind(this)('touchstart', ...args);
   }
   function touchend(...args) {
     return eventShortcut.bind(this)('touchend', ...args);
   }
   function touchmove(...args) {
     return eventShortcut.bind(this)('touchmove', ...args);
   }
   function resize(...args) {
     return eventShortcut.bind(this)('resize', ...args);
   }
   function dom7_modular_scroll(...args) {
     return eventShortcut.bind(this)('scroll', ...args);
   }
   
   
   
   ;// CONCATENATED MODULE: ./node_modules/swiper/js/swiper.esm.bundle.js
   /**
    * Swiper 5.4.5
    * Most modern mobile touch slider and framework with hardware accelerated transitions
    * http://swiperjs.com
    *
    * Copyright 2014-2020 Vladimir Kharlampidi
    *
    * Released under the MIT License
    *
    * Released on: June 16, 2020
    */
   
   
   
   
   const Methods = {
     addClass: dom7_modular_addClass,
     removeClass: dom7_modular_removeClass,
     hasClass: hasClass,
     toggleClass: toggleClass,
     attr: attr,
     removeAttr: removeAttr,
     data: data,
     transform: transform,
     transition: dom7_modular_transition,
     on: dom7_modular_on,
     off: off,
     trigger: dom7_modular_trigger,
     transitionEnd: transitionEnd,
     outerWidth: dom7_modular_outerWidth,
     outerHeight: dom7_modular_outerHeight,
     offset: offset,
     css: css,
     each: each,
     html: dom7_modular_html,
     text: dom7_modular_text,
     is: is,
     index: dom7_modular_index,
     eq: eq,
     append: append,
     prepend: prepend,
     next: dom7_modular_next,
     nextAll: nextAll,
     prev: prev,
     prevAll: prevAll,
     parent: dom7_modular_parent,
     parents: parents,
     closest: closest,
     find: find,
     children: children,
     filter: filter,
     remove: dom7_modular_remove,
     add: dom7_modular_add,
     styles: styles,
   };
   
   Object.keys(Methods).forEach((methodName) => {
     $.fn[methodName] = $.fn[methodName] || Methods[methodName];
   });
   
   const Utils = {
     deleteProps(obj) {
       const object = obj;
       Object.keys(object).forEach((key) => {
         try {
           object[key] = null;
         } catch (e) {
           // no getter for object
         }
         try {
           delete object[key];
         } catch (e) {
           // something got wrong
         }
       });
     },
     nextTick(callback, delay = 0) {
       return setTimeout(callback, delay);
     },
     now() {
       return Date.now();
     },
     getTranslate(el, axis = 'x') {
       let matrix;
       let curTransform;
       let transformMatrix;
   
       const curStyle = win.getComputedStyle(el, null);
   
       if (win.WebKitCSSMatrix) {
         curTransform = curStyle.transform || curStyle.webkitTransform;
         if (curTransform.split(',').length > 6) {
           curTransform = curTransform.split(', ').map((a) => a.replace(',', '.')).join(', ');
         }
         // Some old versions of Webkit choke when 'none' is passed; pass
         // empty string instead in this case
         transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
       } else {
         transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
         matrix = transformMatrix.toString().split(',');
       }
   
       if (axis === 'x') {
         // Latest Chrome and webkits Fix
         if (win.WebKitCSSMatrix) curTransform = transformMatrix.m41;
         // Crazy IE10 Matrix
         else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
         // Normal Browsers
         else curTransform = parseFloat(matrix[4]);
       }
       if (axis === 'y') {
         // Latest Chrome and webkits Fix
         if (win.WebKitCSSMatrix) curTransform = transformMatrix.m42;
         // Crazy IE10 Matrix
         else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
         // Normal Browsers
         else curTransform = parseFloat(matrix[5]);
       }
       return curTransform || 0;
     },
     parseUrlQuery(url) {
       const query = {};
       let urlToParse = url || win.location.href;
       let i;
       let params;
       let param;
       let length;
       if (typeof urlToParse === 'string' && urlToParse.length) {
         urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
         params = urlToParse.split('&').filter((paramsPart) => paramsPart !== '');
         length = params.length;
   
         for (i = 0; i < length; i += 1) {
           param = params[i].replace(/#\S+/g, '').split('=');
           query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
         }
       }
       return query;
     },
     isObject(o) {
       return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
     },
     extend(...args) {
       const to = Object(args[0]);
       for (let i = 1; i < args.length; i += 1) {
         const nextSource = args[i];
         if (nextSource !== undefined && nextSource !== null) {
           const keysArray = Object.keys(Object(nextSource));
           for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
             const nextKey = keysArray[nextIndex];
             const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
             if (desc !== undefined && desc.enumerable) {
               if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                 Utils.extend(to[nextKey], nextSource[nextKey]);
               } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                 to[nextKey] = {};
                 Utils.extend(to[nextKey], nextSource[nextKey]);
               } else {
                 to[nextKey] = nextSource[nextKey];
               }
             }
           }
         }
       }
       return to;
     },
   };
   
   const Support = (function Support() {
     return {
       touch: !!(("ontouchstart" in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch)),
   
       pointerEvents: !!win.PointerEvent && ("maxTouchPoints" in win.navigator) && win.navigator.maxTouchPoints >= 0,
   
       observer: (function checkObserver() {
         return ("MutationObserver" in win || "WebkitMutationObserver" in win);
       }()),
   
       passiveListener: (function checkPassiveListener() {
         let supportsPassive = false;
         try {
           const opts = Object.defineProperty({}, 'passive', {
             // eslint-disable-next-line
             get() {
               supportsPassive = true;
             },
           });
           win.addEventListener('testPassiveListener', null, opts);
         } catch (e) {
           // No support
         }
         return supportsPassive;
       }()),
   
       gestures: (function checkGestures() {
         return "ongesturestart" in win;
       }()),
     };
   }());
   
   class SwiperClass {
     constructor(params = {}) {
       const self = this;
       self.params = params;
   
       // Events
       self.eventsListeners = {};
   
       if (self.params && self.params.on) {
         Object.keys(self.params.on).forEach((eventName) => {
           self.on(eventName, self.params.on[eventName]);
         });
       }
     }
   
     on(events, handler, priority) {
       const self = this;
       if (typeof handler !== 'function') return self;
       const method = priority ? 'unshift' : 'push';
       events.split(' ').forEach((event) => {
         if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
         self.eventsListeners[event][method](handler);
       });
       return self;
     }
   
     once(events, handler, priority) {
       const self = this;
       if (typeof handler !== 'function') return self;
       function onceHandler(...args) {
         self.off(events, onceHandler);
         if (onceHandler.f7proxy) {
           delete onceHandler.f7proxy;
         }
         handler.apply(self, args);
       }
       onceHandler.f7proxy = handler;
       return self.on(events, onceHandler, priority);
     }
   
     off(events, handler) {
       const self = this;
       if (!self.eventsListeners) return self;
       events.split(' ').forEach((event) => {
         if (typeof handler === 'undefined') {
           self.eventsListeners[event] = [];
         } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
           self.eventsListeners[event].forEach((eventHandler, index) => {
             if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
               self.eventsListeners[event].splice(index, 1);
             }
           });
         }
       });
       return self;
     }
   
     emit(...args) {
       const self = this;
       if (!self.eventsListeners) return self;
       let events;
       let data;
       let context;
       if (typeof args[0] === 'string' || Array.isArray(args[0])) {
         events = args[0];
         data = args.slice(1, args.length);
         context = self;
       } else {
         events = args[0].events;
         data = args[0].data;
         context = args[0].context || self;
       }
       const eventsArray = Array.isArray(events) ? events : events.split(' ');
       eventsArray.forEach((event) => {
         if (self.eventsListeners && self.eventsListeners[event]) {
           const handlers = [];
           self.eventsListeners[event].forEach((eventHandler) => {
             handlers.push(eventHandler);
           });
           handlers.forEach((eventHandler) => {
             eventHandler.apply(context, data);
           });
         }
       });
       return self;
     }
   
     useModulesParams(instanceParams) {
       const instance = this;
       if (!instance.modules) return;
       Object.keys(instance.modules).forEach((moduleName) => {
         const module = instance.modules[moduleName];
         // Extend params
         if (module.params) {
           Utils.extend(instanceParams, module.params);
         }
       });
     }
   
     useModules(modulesParams = {}) {
       const instance = this;
       if (!instance.modules) return;
       Object.keys(instance.modules).forEach((moduleName) => {
         const module = instance.modules[moduleName];
         const moduleParams = modulesParams[moduleName] || {};
         // Extend instance methods and props
         if (module.instance) {
           Object.keys(module.instance).forEach((modulePropName) => {
             const moduleProp = module.instance[modulePropName];
             if (typeof moduleProp === 'function') {
               instance[modulePropName] = moduleProp.bind(instance);
             } else {
               instance[modulePropName] = moduleProp;
             }
           });
         }
         // Add event listeners
         if (module.on && instance.on) {
           Object.keys(module.on).forEach((moduleEventName) => {
             instance.on(moduleEventName, module.on[moduleEventName]);
           });
         }
   
         // Module create callback
         if (module.create) {
           module.create.bind(instance)(moduleParams);
         }
       });
     }
   
     static set components(components) {
       const Class = this;
       if (!Class.use) return;
       Class.use(components);
     }
   
     static installModule(module, ...params) {
       const Class = this;
       if (!Class.prototype.modules) Class.prototype.modules = {};
       const name = module.name || (`${Object.keys(Class.prototype.modules).length}_${Utils.now()}`);
       Class.prototype.modules[name] = module;
       // Prototype
       if (module.proto) {
         Object.keys(module.proto).forEach((key) => {
           Class.prototype[key] = module.proto[key];
         });
       }
       // Class
       if (module.static) {
         Object.keys(module.static).forEach((key) => {
           Class[key] = module.static[key];
         });
       }
       // Callback
       if (module.install) {
         module.install.apply(Class, params);
       }
       return Class;
     }
   
     static use(module, ...params) {
       const Class = this;
       if (Array.isArray(module)) {
         module.forEach((m) => Class.installModule(m));
         return Class;
       }
       return Class.installModule(module, ...params);
     }
   }
   
   function updateSize () {
     const swiper = this;
     let width;
     let height;
     const $el = swiper.$el;
     if (typeof swiper.params.width !== 'undefined') {
       width = swiper.params.width;
     } else {
       width = $el[0].clientWidth;
     }
     if (typeof swiper.params.height !== 'undefined') {
       height = swiper.params.height;
     } else {
       height = $el[0].clientHeight;
     }
     if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
       return;
     }
   
     // Subtract paddings
     width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
     height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
   
     Utils.extend(swiper, {
       width,
       height,
       size: swiper.isHorizontal() ? width : height,
     });
   }
   
   function updateSlides () {
     const swiper = this;
     const params = swiper.params;
   
     const {
       $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL,
     } = swiper;
     const isVirtual = swiper.virtual && params.virtual.enabled;
     const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
     const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
     const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
     let snapGrid = [];
     const slidesGrid = [];
     const slidesSizesGrid = [];
   
     function slidesForMargin(slideIndex) {
       if (!params.cssMode) return true;
       if (slideIndex === slides.length - 1) {
         return false;
       }
       return true;
     }
   
     let offsetBefore = params.slidesOffsetBefore;
     if (typeof offsetBefore === 'function') {
       offsetBefore = params.slidesOffsetBefore.call(swiper);
     }
   
     let offsetAfter = params.slidesOffsetAfter;
     if (typeof offsetAfter === 'function') {
       offsetAfter = params.slidesOffsetAfter.call(swiper);
     }
   
     const previousSnapGridLength = swiper.snapGrid.length;
     const previousSlidesGridLength = swiper.snapGrid.length;
   
     let spaceBetween = params.spaceBetween;
     let slidePosition = -offsetBefore;
     let prevSlideSize = 0;
     let index = 0;
     if (typeof swiperSize === 'undefined') {
       return;
     }
     if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
       spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
     }
   
     swiper.virtualSize = -spaceBetween;
   
     // reset margins
     if (rtl) slides.css({ marginLeft: '', marginTop: '' });
     else slides.css({ marginRight: '', marginBottom: '' });
   
     let slidesNumberEvenToRows;
     if (params.slidesPerColumn > 1) {
       if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
         slidesNumberEvenToRows = slidesLength;
       } else {
         slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
       }
       if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
         slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
       }
     }
   
     // Calc slides
     let slideSize;
     const slidesPerColumn = params.slidesPerColumn;
     const slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
     const numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
     for (let i = 0; i < slidesLength; i += 1) {
       slideSize = 0;
       const slide = slides.eq(i);
       if (params.slidesPerColumn > 1) {
         // Set slides order
         let newSlideOrderIndex;
         let column;
         let row;
         if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
           const groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
           const slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
           const columnsInGroup = groupIndex === 0
             ? params.slidesPerGroup
             : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
           row = Math.floor(slideIndexInGroup / columnsInGroup);
           column = (slideIndexInGroup - row * columnsInGroup) + groupIndex * params.slidesPerGroup;
   
           newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
           slide
             .css({
               '-webkit-box-ordinal-group': newSlideOrderIndex,
               '-moz-box-ordinal-group': newSlideOrderIndex,
               '-ms-flex-order': newSlideOrderIndex,
               '-webkit-order': newSlideOrderIndex,
               order: newSlideOrderIndex,
             });
         } else if (params.slidesPerColumnFill === 'column') {
           column = Math.floor(i / slidesPerColumn);
           row = i - (column * slidesPerColumn);
           if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
             row += 1;
             if (row >= slidesPerColumn) {
               row = 0;
               column += 1;
             }
           }
         } else {
           row = Math.floor(i / slidesPerRow);
           column = i - (row * slidesPerRow);
         }
         slide.css(
           `margin-${swiper.isHorizontal() ? 'top' : 'left'}`,
           (row !== 0 && params.spaceBetween) && (`${params.spaceBetween}px`)
         );
       }
       if (slide.css('display') === 'none') continue; // eslint-disable-line
   
       if (params.slidesPerView === 'auto') {
         const slideStyles = win.getComputedStyle(slide[0], null);
         const currentTransform = slide[0].style.transform;
         const currentWebKitTransform = slide[0].style.webkitTransform;
         if (currentTransform) {
           slide[0].style.transform = 'none';
         }
         if (currentWebKitTransform) {
           slide[0].style.webkitTransform = 'none';
         }
         if (params.roundLengths) {
           slideSize = swiper.isHorizontal()
             ? slide.outerWidth(true)
             : slide.outerHeight(true);
         } else {
           // eslint-disable-next-line
           if (swiper.isHorizontal()) {
             const width = parseFloat(slideStyles.getPropertyValue('width'));
             const paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
             const paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
             const marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
             const marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
             const boxSizing = slideStyles.getPropertyValue('box-sizing');
             if (boxSizing && boxSizing === 'border-box') {
               slideSize = width + marginLeft + marginRight;
             } else {
               slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
             }
           } else {
             const height = parseFloat(slideStyles.getPropertyValue('height'));
             const paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
             const paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
             const marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
             const marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
             const boxSizing = slideStyles.getPropertyValue('box-sizing');
             if (boxSizing && boxSizing === 'border-box') {
               slideSize = height + marginTop + marginBottom;
             } else {
               slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
             }
           }
         }
         if (currentTransform) {
           slide[0].style.transform = currentTransform;
         }
         if (currentWebKitTransform) {
           slide[0].style.webkitTransform = currentWebKitTransform;
         }
         if (params.roundLengths) slideSize = Math.floor(slideSize);
       } else {
         slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
         if (params.roundLengths) slideSize = Math.floor(slideSize);
   
         if (slides[i]) {
           if (swiper.isHorizontal()) {
             slides[i].style.width = `${slideSize}px`;
           } else {
             slides[i].style.height = `${slideSize}px`;
           }
         }
       }
       if (slides[i]) {
         slides[i].swiperSlideSize = slideSize;
       }
       slidesSizesGrid.push(slideSize);
   
   
       if (params.centeredSlides) {
         slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
         if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
         if (i === 0) slidePosition = slidePosition - (swiperSize / 2) - spaceBetween;
         if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
         if (params.roundLengths) slidePosition = Math.floor(slidePosition);
         if ((index) % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
         slidesGrid.push(slidePosition);
       } else {
         if (params.roundLengths) slidePosition = Math.floor(slidePosition);
         if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
         slidesGrid.push(slidePosition);
         slidePosition = slidePosition + slideSize + spaceBetween;
       }
   
       swiper.virtualSize += slideSize + spaceBetween;
   
       prevSlideSize = slideSize;
   
       index += 1;
     }
     swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
     let newSlidesGrid;
   
     if (
       rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
       $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
     }
     if (params.setWrapperSize) {
       if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
       else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
     }
   
     if (params.slidesPerColumn > 1) {
       swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
       swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
       if (swiper.isHorizontal()) $wrapperEl.css({ width: `${swiper.virtualSize + params.spaceBetween}px` });
       else $wrapperEl.css({ height: `${swiper.virtualSize + params.spaceBetween}px` });
       if (params.centeredSlides) {
         newSlidesGrid = [];
         for (let i = 0; i < snapGrid.length; i += 1) {
           let slidesGridItem = snapGrid[i];
           if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
           if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
         }
         snapGrid = newSlidesGrid;
       }
     }
   
     // Remove last grid elements depending on width
     if (!params.centeredSlides) {
       newSlidesGrid = [];
       for (let i = 0; i < snapGrid.length; i += 1) {
         let slidesGridItem = snapGrid[i];
         if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
         if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
           newSlidesGrid.push(slidesGridItem);
         }
       }
       snapGrid = newSlidesGrid;
       if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
         snapGrid.push(swiper.virtualSize - swiperSize);
       }
     }
     if (snapGrid.length === 0) snapGrid = [0];
   
     if (params.spaceBetween !== 0) {
       if (swiper.isHorizontal()) {
         if (rtl) slides.filter(slidesForMargin).css({ marginLeft: `${spaceBetween}px` });
         else slides.filter(slidesForMargin).css({ marginRight: `${spaceBetween}px` });
       } else slides.filter(slidesForMargin).css({ marginBottom: `${spaceBetween}px` });
     }
   
     if (params.centeredSlides && params.centeredSlidesBounds) {
       let allSlidesSize = 0;
       slidesSizesGrid.forEach((slideSizeValue) => {
         allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
       });
       allSlidesSize -= params.spaceBetween;
       const maxSnap = allSlidesSize - swiperSize;
       snapGrid = snapGrid.map((snap) => {
         if (snap < 0) return -offsetBefore;
         if (snap > maxSnap) return maxSnap + offsetAfter;
         return snap;
       });
     }
   
     if (params.centerInsufficientSlides) {
       let allSlidesSize = 0;
       slidesSizesGrid.forEach((slideSizeValue) => {
         allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
       });
       allSlidesSize -= params.spaceBetween;
       if (allSlidesSize < swiperSize) {
         const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
         snapGrid.forEach((snap, snapIndex) => {
           snapGrid[snapIndex] = snap - allSlidesOffset;
         });
         slidesGrid.forEach((snap, snapIndex) => {
           slidesGrid[snapIndex] = snap + allSlidesOffset;
         });
       }
     }
   
     Utils.extend(swiper, {
       slides,
       snapGrid,
       slidesGrid,
       slidesSizesGrid,
     });
   
     if (slidesLength !== previousSlidesLength) {
       swiper.emit('slidesLengthChange');
     }
     if (snapGrid.length !== previousSnapGridLength) {
       if (swiper.params.watchOverflow) swiper.checkOverflow();
       swiper.emit('snapGridLengthChange');
     }
     if (slidesGrid.length !== previousSlidesGridLength) {
       swiper.emit('slidesGridLengthChange');
     }
   
     if (params.watchSlidesProgress || params.watchSlidesVisibility) {
       swiper.updateSlidesOffset();
     }
   }
   
   function updateAutoHeight (speed) {
     const swiper = this;
     const activeSlides = [];
     let newHeight = 0;
     let i;
     if (typeof speed === 'number') {
       swiper.setTransition(speed);
     } else if (speed === true) {
       swiper.setTransition(swiper.params.speed);
     }
     // Find slides currently in view
     if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
       if (swiper.params.centeredSlides) {
         swiper.visibleSlides.each((index, slide) => {
           activeSlides.push(slide);
         });
       } else {
         for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
           const index = swiper.activeIndex + i;
           if (index > swiper.slides.length) break;
           activeSlides.push(swiper.slides.eq(index)[0]);
         }
       }
     } else {
       activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
     }
   
     // Find new height from highest slide in view
     for (i = 0; i < activeSlides.length; i += 1) {
       if (typeof activeSlides[i] !== 'undefined') {
         const height = activeSlides[i].offsetHeight;
         newHeight = height > newHeight ? height : newHeight;
       }
     }
   
     // Update Height
     if (newHeight) swiper.$wrapperEl.css('height', `${newHeight}px`);
   }
   
   function updateSlidesOffset () {
     const swiper = this;
     const slides = swiper.slides;
     for (let i = 0; i < slides.length; i += 1) {
       slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
     }
   }
   
   function updateSlidesProgress (translate = (this && this.translate) || 0) {
     const swiper = this;
     const params = swiper.params;
   
     const { slides, rtlTranslate: rtl } = swiper;
   
     if (slides.length === 0) return;
     if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
   
     let offsetCenter = -translate;
     if (rtl) offsetCenter = translate;
   
     // Visible Slides
     slides.removeClass(params.slideVisibleClass);
   
     swiper.visibleSlidesIndexes = [];
     swiper.visibleSlides = [];
   
     for (let i = 0; i < slides.length; i += 1) {
       const slide = slides[i];
       const slideProgress = (
         (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
       ) / (slide.swiperSlideSize + params.spaceBetween);
       if (params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) {
         const slideBefore = -(offsetCenter - slide.swiperSlideOffset);
         const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
         const isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                   || (slideAfter > 1 && slideAfter <= swiper.size)
                   || (slideBefore <= 0 && slideAfter >= swiper.size);
         if (isVisible) {
           swiper.visibleSlides.push(slide);
           swiper.visibleSlidesIndexes.push(i);
           slides.eq(i).addClass(params.slideVisibleClass);
         }
       }
       slide.progress = rtl ? -slideProgress : slideProgress;
     }
     swiper.visibleSlides = $(swiper.visibleSlides);
   }
   
   function updateProgress (translate) {
     const swiper = this;
     if (typeof translate === 'undefined') {
       const multiplier = swiper.rtlTranslate ? -1 : 1;
       // eslint-disable-next-line
       translate = (swiper && swiper.translate && (swiper.translate * multiplier)) || 0;
     }
     const params = swiper.params;
     const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
     let { progress, isBeginning, isEnd } = swiper;
     const wasBeginning = isBeginning;
     const wasEnd = isEnd;
     if (translatesDiff === 0) {
       progress = 0;
       isBeginning = true;
       isEnd = true;
     } else {
       progress = (translate - swiper.minTranslate()) / (translatesDiff);
       isBeginning = progress <= 0;
       isEnd = progress >= 1;
     }
     Utils.extend(swiper, {
       progress,
       isBeginning,
       isEnd,
     });
   
     if (params.watchSlidesProgress || params.watchSlidesVisibility || (params.centeredSlides && params.autoHeight)) swiper.updateSlidesProgress(translate);
   
     if (isBeginning && !wasBeginning) {
       swiper.emit('reachBeginning toEdge');
     }
     if (isEnd && !wasEnd) {
       swiper.emit('reachEnd toEdge');
     }
     if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
       swiper.emit('fromEdge');
     }
   
     swiper.emit('progress', progress);
   }
   
   function updateSlidesClasses () {
     const swiper = this;
   
     const {
       slides, params, $wrapperEl, activeIndex, realIndex,
     } = swiper;
     const isVirtual = swiper.virtual && params.virtual.enabled;
   
     slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
   
     let activeSlide;
     if (isVirtual) {
       activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
     } else {
       activeSlide = slides.eq(activeIndex);
     }
   
     // Active classes
     activeSlide.addClass(params.slideActiveClass);
   
     if (params.loop) {
       // Duplicate to all looped slides
       if (activeSlide.hasClass(params.slideDuplicateClass)) {
         $wrapperEl
           .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`)
           .addClass(params.slideDuplicateActiveClass);
       } else {
         $wrapperEl
           .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`)
           .addClass(params.slideDuplicateActiveClass);
       }
     }
     // Next Slide
     let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
     if (params.loop && nextSlide.length === 0) {
       nextSlide = slides.eq(0);
       nextSlide.addClass(params.slideNextClass);
     }
     // Prev Slide
     let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
     if (params.loop && prevSlide.length === 0) {
       prevSlide = slides.eq(-1);
       prevSlide.addClass(params.slidePrevClass);
     }
     if (params.loop) {
       // Duplicate to all looped slides
       if (nextSlide.hasClass(params.slideDuplicateClass)) {
         $wrapperEl
           .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
           .addClass(params.slideDuplicateNextClass);
       } else {
         $wrapperEl
           .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`)
           .addClass(params.slideDuplicateNextClass);
       }
       if (prevSlide.hasClass(params.slideDuplicateClass)) {
         $wrapperEl
           .children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
           .addClass(params.slideDuplicatePrevClass);
       } else {
         $wrapperEl
           .children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`)
           .addClass(params.slideDuplicatePrevClass);
       }
     }
   }
   
   function updateActiveIndex (newActiveIndex) {
     const swiper = this;
     const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
     const {
       slidesGrid, snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex,
     } = swiper;
     let activeIndex = newActiveIndex;
     let snapIndex;
     if (typeof activeIndex === 'undefined') {
       for (let i = 0; i < slidesGrid.length; i += 1) {
         if (typeof slidesGrid[i + 1] !== 'undefined') {
           if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
             activeIndex = i;
           } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
             activeIndex = i + 1;
           }
         } else if (translate >= slidesGrid[i]) {
           activeIndex = i;
         }
       }
       // Normalize slideIndex
       if (params.normalizeSlideIndex) {
         if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
       }
     }
     if (snapGrid.indexOf(translate) >= 0) {
       snapIndex = snapGrid.indexOf(translate);
     } else {
       const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
       snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
     }
     if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
     if (activeIndex === previousIndex) {
       if (snapIndex !== previousSnapIndex) {
         swiper.snapIndex = snapIndex;
         swiper.emit('snapIndexChange');
       }
       return;
     }
   
     // Get real index
     const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
   
     Utils.extend(swiper, {
       snapIndex,
       realIndex,
       previousIndex,
       activeIndex,
     });
     swiper.emit('activeIndexChange');
     swiper.emit('snapIndexChange');
     if (previousRealIndex !== realIndex) {
       swiper.emit('realIndexChange');
     }
     if (swiper.initialized || swiper.params.runCallbacksOnInit) {
       swiper.emit('slideChange');
     }
   }
   
   function updateClickedSlide (e) {
     const swiper = this;
     const params = swiper.params;
     const slide = $(e.target).closest(`.${params.slideClass}`)[0];
     let slideFound = false;
     if (slide) {
       for (let i = 0; i < swiper.slides.length; i += 1) {
         if (swiper.slides[i] === slide) slideFound = true;
       }
     }
   
     if (slide && slideFound) {
       swiper.clickedSlide = slide;
       if (swiper.virtual && swiper.params.virtual.enabled) {
         swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
       } else {
         swiper.clickedIndex = $(slide).index();
       }
     } else {
       swiper.clickedSlide = undefined;
       swiper.clickedIndex = undefined;
       return;
     }
     if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
       swiper.slideToClickedSlide();
     }
   }
   
   var update = {
     updateSize,
     updateSlides,
     updateAutoHeight,
     updateSlidesOffset,
     updateSlidesProgress,
     updateProgress,
     updateSlidesClasses,
     updateActiveIndex,
     updateClickedSlide,
   };
   
   function getTranslate (axis = this.isHorizontal() ? 'x' : 'y') {
     const swiper = this;
   
     const {
       params, rtlTranslate: rtl, translate, $wrapperEl,
     } = swiper;
   
     if (params.virtualTranslate) {
       return rtl ? -translate : translate;
     }
     if (params.cssMode) {
       return translate;
     }
   
     let currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
     if (rtl) currentTranslate = -currentTranslate;
   
     return currentTranslate || 0;
   }
   
   function setTranslate (translate, byController) {
     const swiper = this;
     const {
       rtlTranslate: rtl, params, $wrapperEl, wrapperEl, progress,
     } = swiper;
     let x = 0;
     let y = 0;
     const z = 0;
   
     if (swiper.isHorizontal()) {
       x = rtl ? -translate : translate;
     } else {
       y = translate;
     }
   
     if (params.roundLengths) {
       x = Math.floor(x);
       y = Math.floor(y);
     }
   
     if (params.cssMode) {
       wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
     } else if (!params.virtualTranslate) {
       $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
     }
     swiper.previousTranslate = swiper.translate;
     swiper.translate = swiper.isHorizontal() ? x : y;
   
     // Check if we need to update progress
     let newProgress;
     const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
     if (translatesDiff === 0) {
       newProgress = 0;
     } else {
       newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
     }
     if (newProgress !== progress) {
       swiper.updateProgress(translate);
     }
   
     swiper.emit('setTranslate', swiper.translate, byController);
   }
   
   function minTranslate () {
     return (-this.snapGrid[0]);
   }
   
   function maxTranslate () {
     return (-this.snapGrid[this.snapGrid.length - 1]);
   }
   
   function translateTo (translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
     const swiper = this;
   
     const {
       params,
       wrapperEl,
     } = swiper;
   
     if (swiper.animating && params.preventInteractionOnTransition) {
       return false;
     }
   
     const minTranslate = swiper.minTranslate();
     const maxTranslate = swiper.maxTranslate();
     let newTranslate;
     if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
     else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
     else newTranslate = translate;
   
     // Update progress
     swiper.updateProgress(newTranslate);
   
     if (params.cssMode) {
       const isH = swiper.isHorizontal();
       if (speed === 0) {
         wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
       } else {
         // eslint-disable-next-line
         if (wrapperEl.scrollTo) {
           wrapperEl.scrollTo({
             [isH ? 'left' : 'top']: -newTranslate,
             behavior: 'smooth',
           });
         } else {
           wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
         }
       }
       return true;
     }
   
     if (speed === 0) {
       swiper.setTransition(0);
       swiper.setTranslate(newTranslate);
       if (runCallbacks) {
         swiper.emit('beforeTransitionStart', speed, internal);
         swiper.emit('transitionEnd');
       }
     } else {
       swiper.setTransition(speed);
       swiper.setTranslate(newTranslate);
       if (runCallbacks) {
         swiper.emit('beforeTransitionStart', speed, internal);
         swiper.emit('transitionStart');
       }
       if (!swiper.animating) {
         swiper.animating = true;
         if (!swiper.onTranslateToWrapperTransitionEnd) {
           swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
             if (!swiper || swiper.destroyed) return;
             if (e.target !== this) return;
             swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
             swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
             swiper.onTranslateToWrapperTransitionEnd = null;
             delete swiper.onTranslateToWrapperTransitionEnd;
             if (runCallbacks) {
               swiper.emit('transitionEnd');
             }
           };
         }
         swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
         swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
       }
     }
   
     return true;
   }
   
   var translate = {
     getTranslate,
     setTranslate,
     minTranslate,
     maxTranslate,
     translateTo,
   };
   
   function setTransition (duration, byController) {
     const swiper = this;
   
     if (!swiper.params.cssMode) {
       swiper.$wrapperEl.transition(duration);
     }
   
     swiper.emit('setTransition', duration, byController);
   }
   
   function transitionStart (runCallbacks = true, direction) {
     const swiper = this;
     const { activeIndex, params, previousIndex } = swiper;
     if (params.cssMode) return;
     if (params.autoHeight) {
       swiper.updateAutoHeight();
     }
   
     let dir = direction;
     if (!dir) {
       if (activeIndex > previousIndex) dir = 'next';
       else if (activeIndex < previousIndex) dir = 'prev';
       else dir = 'reset';
     }
   
     swiper.emit('transitionStart');
   
     if (runCallbacks && activeIndex !== previousIndex) {
       if (dir === 'reset') {
         swiper.emit('slideResetTransitionStart');
         return;
       }
       swiper.emit('slideChangeTransitionStart');
       if (dir === 'next') {
         swiper.emit('slideNextTransitionStart');
       } else {
         swiper.emit('slidePrevTransitionStart');
       }
     }
   }
   
   function swiper_esm_bundle_transitionEnd (runCallbacks = true, direction) {
     const swiper = this;
     const { activeIndex, previousIndex, params } = swiper;
     swiper.animating = false;
     if (params.cssMode) return;
     swiper.setTransition(0);
   
     let dir = direction;
     if (!dir) {
       if (activeIndex > previousIndex) dir = 'next';
       else if (activeIndex < previousIndex) dir = 'prev';
       else dir = 'reset';
     }
   
     swiper.emit('transitionEnd');
   
     if (runCallbacks && activeIndex !== previousIndex) {
       if (dir === 'reset') {
         swiper.emit('slideResetTransitionEnd');
         return;
       }
       swiper.emit('slideChangeTransitionEnd');
       if (dir === 'next') {
         swiper.emit('slideNextTransitionEnd');
       } else {
         swiper.emit('slidePrevTransitionEnd');
       }
     }
   }
   
   var swiper_esm_bundle_transition = {
     setTransition,
     transitionStart,
     transitionEnd: swiper_esm_bundle_transitionEnd,
   };
   
   function slideTo (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
     const swiper = this;
     let slideIndex = index;
     if (slideIndex < 0) slideIndex = 0;
   
     const {
       params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl,
     } = swiper;
     if (swiper.animating && params.preventInteractionOnTransition) {
       return false;
     }
   
     const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
     let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
     if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
   
     if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
       swiper.emit('beforeSlideChangeStart');
     }
   
     const translate = -snapGrid[snapIndex];
   
     // Update progress
     swiper.updateProgress(translate);
   
     // Normalize slideIndex
     if (params.normalizeSlideIndex) {
       for (let i = 0; i < slidesGrid.length; i += 1) {
         if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
           slideIndex = i;
         }
       }
     }
     // Directions locks
     if (swiper.initialized && slideIndex !== activeIndex) {
       if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
         return false;
       }
       if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
         if ((activeIndex || 0) !== slideIndex) return false;
       }
     }
   
     let direction;
     if (slideIndex > activeIndex) direction = 'next';
     else if (slideIndex < activeIndex) direction = 'prev';
     else direction = 'reset';
   
   
     // Update Index
     if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
       swiper.updateActiveIndex(slideIndex);
       // Update Height
       if (params.autoHeight) {
         swiper.updateAutoHeight();
       }
       swiper.updateSlidesClasses();
       if (params.effect !== 'slide') {
         swiper.setTranslate(translate);
       }
       if (direction !== 'reset') {
         swiper.transitionStart(runCallbacks, direction);
         swiper.transitionEnd(runCallbacks, direction);
       }
       return false;
     }
     if (params.cssMode) {
       const isH = swiper.isHorizontal();
       let t = -translate;
       if (rtl) {
         t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
       }
       if (speed === 0) {
         wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
       } else {
         // eslint-disable-next-line
         if (wrapperEl.scrollTo) {
           wrapperEl.scrollTo({
             [isH ? 'left' : 'top']: t,
             behavior: 'smooth',
           });
         } else {
           wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
         }
       }
       return true;
     }
   
     if (speed === 0) {
       swiper.setTransition(0);
       swiper.setTranslate(translate);
       swiper.updateActiveIndex(slideIndex);
       swiper.updateSlidesClasses();
       swiper.emit('beforeTransitionStart', speed, internal);
       swiper.transitionStart(runCallbacks, direction);
       swiper.transitionEnd(runCallbacks, direction);
     } else {
       swiper.setTransition(speed);
       swiper.setTranslate(translate);
       swiper.updateActiveIndex(slideIndex);
       swiper.updateSlidesClasses();
       swiper.emit('beforeTransitionStart', speed, internal);
       swiper.transitionStart(runCallbacks, direction);
       if (!swiper.animating) {
         swiper.animating = true;
         if (!swiper.onSlideToWrapperTransitionEnd) {
           swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
             if (!swiper || swiper.destroyed) return;
             if (e.target !== this) return;
             swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
             swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
             swiper.onSlideToWrapperTransitionEnd = null;
             delete swiper.onSlideToWrapperTransitionEnd;
             swiper.transitionEnd(runCallbacks, direction);
           };
         }
         swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
         swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
       }
     }
   
     return true;
   }
   
   function slideToLoop (index = 0, speed = this.params.speed, runCallbacks = true, internal) {
     const swiper = this;
     let newIndex = index;
     if (swiper.params.loop) {
       newIndex += swiper.loopedSlides;
     }
   
     return swiper.slideTo(newIndex, speed, runCallbacks, internal);
   }
   
   /* eslint no-unused-vars: "off" */
   function slideNext (speed = this.params.speed, runCallbacks = true, internal) {
     const swiper = this;
     const { params, animating } = swiper;
     const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
     if (params.loop) {
       if (animating) return false;
       swiper.loopFix();
       // eslint-disable-next-line
       swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
     }
     return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
   }
   
   /* eslint no-unused-vars: "off" */
   function slidePrev (speed = this.params.speed, runCallbacks = true, internal) {
     const swiper = this;
     const {
       params, animating, snapGrid, slidesGrid, rtlTranslate,
     } = swiper;
   
     if (params.loop) {
       if (animating) return false;
       swiper.loopFix();
       // eslint-disable-next-line
       swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
     }
     const translate = rtlTranslate ? swiper.translate : -swiper.translate;
     function normalize(val) {
       if (val < 0) return -Math.floor(Math.abs(val));
       return Math.floor(val);
     }
     const normalizedTranslate = normalize(translate);
     const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
     const normalizedSlidesGrid = slidesGrid.map((val) => normalize(val));
   
     const currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
     let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
     if (typeof prevSnap === 'undefined' && params.cssMode) {
       snapGrid.forEach((snap) => {
         if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
       });
     }
     let prevIndex;
     if (typeof prevSnap !== 'undefined') {
       prevIndex = slidesGrid.indexOf(prevSnap);
       if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
     }
     return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
   }
   
   /* eslint no-unused-vars: "off" */
   function slideReset (speed = this.params.speed, runCallbacks = true, internal) {
     const swiper = this;
     return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
   }
   
   /* eslint no-unused-vars: "off" */
   function slideToClosest (speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
     const swiper = this;
     let index = swiper.activeIndex;
     const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
     const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
   
     const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
   
     if (translate >= swiper.snapGrid[snapIndex]) {
       // The current translate is on or after the current snap index, so the choice
       // is between the current index and the one after it.
       const currentSnap = swiper.snapGrid[snapIndex];
       const nextSnap = swiper.snapGrid[snapIndex + 1];
       if ((translate - currentSnap) > (nextSnap - currentSnap) * threshold) {
         index += swiper.params.slidesPerGroup;
       }
     } else {
       // The current translate is before the current snap index, so the choice
       // is between the current index and the one before it.
       const prevSnap = swiper.snapGrid[snapIndex - 1];
       const currentSnap = swiper.snapGrid[snapIndex];
       if ((translate - prevSnap) <= (currentSnap - prevSnap) * threshold) {
         index -= swiper.params.slidesPerGroup;
       }
     }
     index = Math.max(index, 0);
     index = Math.min(index, swiper.slidesGrid.length - 1);
   
     return swiper.slideTo(index, speed, runCallbacks, internal);
   }
   
   function slideToClickedSlide () {
     const swiper = this;
     const { params, $wrapperEl } = swiper;
   
     const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
     let slideToIndex = swiper.clickedIndex;
     let realIndex;
     if (params.loop) {
       if (swiper.animating) return;
       realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
       if (params.centeredSlides) {
         if (
           (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
           || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
         ) {
           swiper.loopFix();
           slideToIndex = $wrapperEl
             .children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
             .eq(0)
             .index();
   
           Utils.nextTick(() => {
             swiper.slideTo(slideToIndex);
           });
         } else {
           swiper.slideTo(slideToIndex);
         }
       } else if (slideToIndex > swiper.slides.length - slidesPerView) {
         swiper.loopFix();
         slideToIndex = $wrapperEl
           .children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`)
           .eq(0)
           .index();
   
         Utils.nextTick(() => {
           swiper.slideTo(slideToIndex);
         });
       } else {
         swiper.slideTo(slideToIndex);
       }
     } else {
       swiper.slideTo(slideToIndex);
     }
   }
   
   var slide = {
     slideTo,
     slideToLoop,
     slideNext,
     slidePrev,
     slideReset,
     slideToClosest,
     slideToClickedSlide,
   };
   
   function loopCreate () {
     const swiper = this;
     const { params, $wrapperEl } = swiper;
     // Remove duplicated slides
     $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
   
     let slides = $wrapperEl.children(`.${params.slideClass}`);
   
     if (params.loopFillGroupWithBlank) {
       const blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
       if (blankSlidesNum !== params.slidesPerGroup) {
         for (let i = 0; i < blankSlidesNum; i += 1) {
           const blankNode = $(doc.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
           $wrapperEl.append(blankNode);
         }
         slides = $wrapperEl.children(`.${params.slideClass}`);
       }
     }
   
     if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
   
     swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
     swiper.loopedSlides += params.loopAdditionalSlides;
     if (swiper.loopedSlides > slides.length) {
       swiper.loopedSlides = slides.length;
     }
   
     const prependSlides = [];
     const appendSlides = [];
     slides.each((index, el) => {
       const slide = $(el);
       if (index < swiper.loopedSlides) appendSlides.push(el);
       if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
       slide.attr('data-swiper-slide-index', index);
     });
     for (let i = 0; i < appendSlides.length; i += 1) {
       $wrapperEl.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
     }
     for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
       $wrapperEl.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
     }
   }
   
   function loopFix () {
     const swiper = this;
   
     swiper.emit('beforeLoopFix');
   
     const {
       activeIndex, slides, loopedSlides, allowSlidePrev, allowSlideNext, snapGrid, rtlTranslate: rtl,
     } = swiper;
     let newIndex;
     swiper.allowSlidePrev = true;
     swiper.allowSlideNext = true;
   
     const snapTranslate = -snapGrid[activeIndex];
     const diff = snapTranslate - swiper.getTranslate();
   
     // Fix For Negative Oversliding
     if (activeIndex < loopedSlides) {
       newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
       newIndex += loopedSlides;
       const slideChanged = swiper.slideTo(newIndex, 0, false, true);
       if (slideChanged && diff !== 0) {
         swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
       }
     } else if (activeIndex >= slides.length - loopedSlides) {
       // Fix For Positive Oversliding
       newIndex = -slides.length + activeIndex + loopedSlides;
       newIndex += loopedSlides;
       const slideChanged = swiper.slideTo(newIndex, 0, false, true);
       if (slideChanged && diff !== 0) {
         swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
       }
     }
     swiper.allowSlidePrev = allowSlidePrev;
     swiper.allowSlideNext = allowSlideNext;
   
     swiper.emit('loopFix');
   }
   
   function loopDestroy () {
     const swiper = this;
     const { $wrapperEl, params, slides } = swiper;
     $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
     slides.removeAttr('data-swiper-slide-index');
   }
   
   var loop = {
     loopCreate,
     loopFix,
     loopDestroy,
   };
   
   function setGrabCursor (moving) {
     const swiper = this;
     if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
     const el = swiper.el;
     el.style.cursor = 'move';
     el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
     el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
     el.style.cursor = moving ? 'grabbing' : 'grab';
   }
   
   function unsetGrabCursor () {
     const swiper = this;
     if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
     swiper.el.style.cursor = '';
   }
   
   var grabCursor = {
     setGrabCursor,
     unsetGrabCursor,
   };
   
   function appendSlide (slides) {
     const swiper = this;
     const { $wrapperEl, params } = swiper;
     if (params.loop) {
       swiper.loopDestroy();
     }
     if (typeof slides === 'object' && 'length' in slides) {
       for (let i = 0; i < slides.length; i += 1) {
         if (slides[i]) $wrapperEl.append(slides[i]);
       }
     } else {
       $wrapperEl.append(slides);
     }
     if (params.loop) {
       swiper.loopCreate();
     }
     if (!(params.observer && Support.observer)) {
       swiper.update();
     }
   }
   
   function prependSlide (slides) {
     const swiper = this;
     const { params, $wrapperEl, activeIndex } = swiper;
   
     if (params.loop) {
       swiper.loopDestroy();
     }
     let newActiveIndex = activeIndex + 1;
     if (typeof slides === 'object' && 'length' in slides) {
       for (let i = 0; i < slides.length; i += 1) {
         if (slides[i]) $wrapperEl.prepend(slides[i]);
       }
       newActiveIndex = activeIndex + slides.length;
     } else {
       $wrapperEl.prepend(slides);
     }
     if (params.loop) {
       swiper.loopCreate();
     }
     if (!(params.observer && Support.observer)) {
       swiper.update();
     }
     swiper.slideTo(newActiveIndex, 0, false);
   }
   
   function addSlide (index, slides) {
     const swiper = this;
     const { $wrapperEl, params, activeIndex } = swiper;
     let activeIndexBuffer = activeIndex;
     if (params.loop) {
       activeIndexBuffer -= swiper.loopedSlides;
       swiper.loopDestroy();
       swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
     }
     const baseLength = swiper.slides.length;
     if (index <= 0) {
       swiper.prependSlide(slides);
       return;
     }
     if (index >= baseLength) {
       swiper.appendSlide(slides);
       return;
     }
     let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
   
     const slidesBuffer = [];
     for (let i = baseLength - 1; i >= index; i -= 1) {
       const currentSlide = swiper.slides.eq(i);
       currentSlide.remove();
       slidesBuffer.unshift(currentSlide);
     }
   
     if (typeof slides === 'object' && 'length' in slides) {
       for (let i = 0; i < slides.length; i += 1) {
         if (slides[i]) $wrapperEl.append(slides[i]);
       }
       newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
     } else {
       $wrapperEl.append(slides);
     }
   
     for (let i = 0; i < slidesBuffer.length; i += 1) {
       $wrapperEl.append(slidesBuffer[i]);
     }
   
     if (params.loop) {
       swiper.loopCreate();
     }
     if (!(params.observer && Support.observer)) {
       swiper.update();
     }
     if (params.loop) {
       swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
     } else {
       swiper.slideTo(newActiveIndex, 0, false);
     }
   }
   
   function removeSlide (slidesIndexes) {
     const swiper = this;
     const { params, $wrapperEl, activeIndex } = swiper;
   
     let activeIndexBuffer = activeIndex;
     if (params.loop) {
       activeIndexBuffer -= swiper.loopedSlides;
       swiper.loopDestroy();
       swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
     }
     let newActiveIndex = activeIndexBuffer;
     let indexToRemove;
   
     if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
       for (let i = 0; i < slidesIndexes.length; i += 1) {
         indexToRemove = slidesIndexes[i];
         if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
         if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
       }
       newActiveIndex = Math.max(newActiveIndex, 0);
     } else {
       indexToRemove = slidesIndexes;
       if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
       if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
       newActiveIndex = Math.max(newActiveIndex, 0);
     }
   
     if (params.loop) {
       swiper.loopCreate();
     }
   
     if (!(params.observer && Support.observer)) {
       swiper.update();
     }
     if (params.loop) {
       swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
     } else {
       swiper.slideTo(newActiveIndex, 0, false);
     }
   }
   
   function removeAllSlides () {
     const swiper = this;
   
     const slidesIndexes = [];
     for (let i = 0; i < swiper.slides.length; i += 1) {
       slidesIndexes.push(i);
     }
     swiper.removeSlide(slidesIndexes);
   }
   
   var manipulation = {
     appendSlide,
     prependSlide,
     addSlide,
     removeSlide,
     removeAllSlides,
   };
   
   const Device = (function Device() {
     const platform = win.navigator.platform;
     const ua = win.navigator.userAgent;
   
     const device = {
       ios: false,
       android: false,
       androidChrome: false,
       desktop: false,
       iphone: false,
       ipod: false,
       ipad: false,
       edge: false,
       ie: false,
       firefox: false,
       macos: false,
       windows: false,
       cordova: !!(win.cordova || win.phonegap),
       phonegap: !!(win.cordova || win.phonegap),
       electron: false,
     };
   
     const screenWidth = win.screen.width;
     const screenHeight = win.screen.height;
   
     const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
     let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
     const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
     const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
     const ie = ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
     const edge = ua.indexOf('Edge/') >= 0;
     const firefox = ua.indexOf('Gecko/') >= 0 && ua.indexOf('Firefox/') >= 0;
     const windows = platform === 'Win32';
     const electron = ua.toLowerCase().indexOf('electron') >= 0;
     let macos = platform === 'MacIntel';
   
     // iPadOs 13 fix
     if (!ipad
       && macos
       && Support.touch
       && (
         (screenWidth === 1024 && screenHeight === 1366) // Pro 12.9
         || (screenWidth === 834 && screenHeight === 1194) // Pro 11
         || (screenWidth === 834 && screenHeight === 1112) // Pro 10.5
         || (screenWidth === 768 && screenHeight === 1024) // other
       )
     ) {
       ipad = ua.match(/(Version)\/([\d.]+)/);
       macos = false;
     }
   
     device.ie = ie;
     device.edge = edge;
     device.firefox = firefox;
   
     // Android
     if (android && !windows) {
       device.os = 'android';
       device.osVersion = android[2];
       device.android = true;
       device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
     }
     if (ipad || iphone || ipod) {
       device.os = 'ios';
       device.ios = true;
     }
     // iOS
     if (iphone && !ipod) {
       device.osVersion = iphone[2].replace(/_/g, '.');
       device.iphone = true;
     }
     if (ipad) {
       device.osVersion = ipad[2].replace(/_/g, '.');
       device.ipad = true;
     }
     if (ipod) {
       device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
       device.ipod = true;
     }
     // iOS 8+ changed UA
     if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
       if (device.osVersion.split('.')[0] === '10') {
         device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
       }
     }
   
     // Webview
     device.webView = !!((iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone))
       || (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches);
     device.webview = device.webView;
     device.standalone = device.webView;
   
     // Desktop
     device.desktop = !(device.ios || device.android) || electron;
     if (device.desktop) {
       device.electron = electron;
       device.macos = macos;
       device.windows = windows;
       if (device.macos) {
         device.os = 'macos';
       }
       if (device.windows) {
         device.os = 'windows';
       }
     }
   
     // Pixel Ratio
     device.pixelRatio = win.devicePixelRatio || 1;
   
     // Export object
     return device;
   }());
   
   function onTouchStart (event) {
     const swiper = this;
     const data = swiper.touchEventsData;
     const { params, touches } = swiper;
   
     if (swiper.animating && params.preventInteractionOnTransition) {
       return;
     }
     let e = event;
     if (e.originalEvent) e = e.originalEvent;
     const $targetEl = $(e.target);
   
     if (params.touchEventsTarget === 'wrapper') {
       if (!$targetEl.closest(swiper.wrapperEl).length) return;
     }
     data.isTouchEvent = e.type === 'touchstart';
     if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
     if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
     if (data.isTouched && data.isMoved) return;
     if (params.noSwiping && $targetEl.closest(params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`)[0]) {
       swiper.allowClick = true;
       return;
     }
     if (params.swipeHandler) {
       if (!$targetEl.closest(params.swipeHandler)[0]) return;
     }
   
     touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
     touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
     const startX = touches.currentX;
     const startY = touches.currentY;
   
     // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
   
     const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
     const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
     if (
       edgeSwipeDetection
       && ((startX <= edgeSwipeThreshold)
       || (startX >= win.screen.width - edgeSwipeThreshold))
     ) {
       return;
     }
   
     Utils.extend(data, {
       isTouched: true,
       isMoved: false,
       allowTouchCallbacks: true,
       isScrolling: undefined,
       startMoving: undefined,
     });
   
     touches.startX = startX;
     touches.startY = startY;
     data.touchStartTime = Utils.now();
     swiper.allowClick = true;
     swiper.updateSize();
     swiper.swipeDirection = undefined;
     if (params.threshold > 0) data.allowThresholdMove = false;
     if (e.type !== 'touchstart') {
       let preventDefault = true;
       if ($targetEl.is(data.formElements)) preventDefault = false;
       if (
         doc.activeElement
         && $(doc.activeElement).is(data.formElements)
         && doc.activeElement !== $targetEl[0]
       ) {
         doc.activeElement.blur();
       }
   
       const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
       if (params.touchStartForcePreventDefault || shouldPreventDefault) {
         e.preventDefault();
       }
     }
     swiper.emit('touchStart', e);
   }
   
   function onTouchMove (event) {
     const swiper = this;
     const data = swiper.touchEventsData;
     const { params, touches, rtlTranslate: rtl } = swiper;
     let e = event;
     if (e.originalEvent) e = e.originalEvent;
     if (!data.isTouched) {
       if (data.startMoving && data.isScrolling) {
         swiper.emit('touchMoveOpposite', e);
       }
       return;
     }
     if (data.isTouchEvent && e.type !== 'touchmove') return;
     const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
     const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
     const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
     if (e.preventedByNestedSwiper) {
       touches.startX = pageX;
       touches.startY = pageY;
       return;
     }
     if (!swiper.allowTouchMove) {
       // isMoved = true;
       swiper.allowClick = false;
       if (data.isTouched) {
         Utils.extend(touches, {
           startX: pageX,
           startY: pageY,
           currentX: pageX,
           currentY: pageY,
         });
         data.touchStartTime = Utils.now();
       }
       return;
     }
     if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
       if (swiper.isVertical()) {
         // Vertical
         if (
           (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
           || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
         ) {
           data.isTouched = false;
           data.isMoved = false;
           return;
         }
       } else if (
         (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
         || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
       ) {
         return;
       }
     }
     if (data.isTouchEvent && doc.activeElement) {
       if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
         data.isMoved = true;
         swiper.allowClick = false;
         return;
       }
     }
     if (data.allowTouchCallbacks) {
       swiper.emit('touchMove', e);
     }
     if (e.targetTouches && e.targetTouches.length > 1) return;
   
     touches.currentX = pageX;
     touches.currentY = pageY;
   
     const diffX = touches.currentX - touches.startX;
     const diffY = touches.currentY - touches.startY;
     if (swiper.params.threshold && Math.sqrt((diffX ** 2) + (diffY ** 2)) < swiper.params.threshold) return;
   
     if (typeof data.isScrolling === 'undefined') {
       let touchAngle;
       if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
         data.isScrolling = false;
       } else {
         // eslint-disable-next-line
         if ((diffX * diffX) + (diffY * diffY) >= 25) {
           touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
           data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
         }
       }
     }
     if (data.isScrolling) {
       swiper.emit('touchMoveOpposite', e);
     }
     if (typeof data.startMoving === 'undefined') {
       if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
         data.startMoving = true;
       }
     }
     if (data.isScrolling) {
       data.isTouched = false;
       return;
     }
     if (!data.startMoving) {
       return;
     }
     swiper.allowClick = false;
     if (!params.cssMode && e.cancelable) {
       e.preventDefault();
     }
     if (params.touchMoveStopPropagation && !params.nested) {
       e.stopPropagation();
     }
   
     if (!data.isMoved) {
       if (params.loop) {
         swiper.loopFix();
       }
       data.startTranslate = swiper.getTranslate();
       swiper.setTransition(0);
       if (swiper.animating) {
         swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
       }
       data.allowMomentumBounce = false;
       // Grab Cursor
       if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
         swiper.setGrabCursor(true);
       }
       swiper.emit('sliderFirstMove', e);
     }
     swiper.emit('sliderMove', e);
     data.isMoved = true;
   
     let diff = swiper.isHorizontal() ? diffX : diffY;
     touches.diff = diff;
   
     diff *= params.touchRatio;
     if (rtl) diff = -diff;
   
     swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
     data.currentTranslate = diff + data.startTranslate;
   
     let disableParentSwiper = true;
     let resistanceRatio = params.resistanceRatio;
     if (params.touchReleaseOnEdges) {
       resistanceRatio = 0;
     }
     if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
       disableParentSwiper = false;
       if (params.resistance) data.currentTranslate = (swiper.minTranslate() - 1) + ((-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio);
     } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
       disableParentSwiper = false;
       if (params.resistance) data.currentTranslate = (swiper.maxTranslate() + 1) - ((swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio);
     }
   
     if (disableParentSwiper) {
       e.preventedByNestedSwiper = true;
     }
   
     // Directions locks
     if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
       data.currentTranslate = data.startTranslate;
     }
     if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
       data.currentTranslate = data.startTranslate;
     }
   
   
     // Threshold
     if (params.threshold > 0) {
       if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
         if (!data.allowThresholdMove) {
           data.allowThresholdMove = true;
           touches.startX = touches.currentX;
           touches.startY = touches.currentY;
           data.currentTranslate = data.startTranslate;
           touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
           return;
         }
       } else {
         data.currentTranslate = data.startTranslate;
         return;
       }
     }
   
     if (!params.followFinger || params.cssMode) return;
   
     // Update active index in free mode
     if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
       swiper.updateActiveIndex();
       swiper.updateSlidesClasses();
     }
     if (params.freeMode) {
       // Velocity
       if (data.velocities.length === 0) {
         data.velocities.push({
           position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
           time: data.touchStartTime,
         });
       }
       data.velocities.push({
         position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
         time: Utils.now(),
       });
     }
     // Update progress
     swiper.updateProgress(data.currentTranslate);
     // Update translate
     swiper.setTranslate(data.currentTranslate);
   }
   
   function onTouchEnd (event) {
     const swiper = this;
     const data = swiper.touchEventsData;
   
     const {
       params, touches, rtlTranslate: rtl, $wrapperEl, slidesGrid, snapGrid,
     } = swiper;
     let e = event;
     if (e.originalEvent) e = e.originalEvent;
     if (data.allowTouchCallbacks) {
       swiper.emit('touchEnd', e);
     }
     data.allowTouchCallbacks = false;
     if (!data.isTouched) {
       if (data.isMoved && params.grabCursor) {
         swiper.setGrabCursor(false);
       }
       data.isMoved = false;
       data.startMoving = false;
       return;
     }
     // Return Grab Cursor
     if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
       swiper.setGrabCursor(false);
     }
   
     // Time diff
     const touchEndTime = Utils.now();
     const timeDiff = touchEndTime - data.touchStartTime;
   
     // Tap, doubleTap, Click
     if (swiper.allowClick) {
       swiper.updateClickedSlide(e);
       swiper.emit('tap click', e);
       if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
         swiper.emit('doubleTap doubleClick', e);
       }
     }
   
     data.lastClickTime = Utils.now();
     Utils.nextTick(() => {
       if (!swiper.destroyed) swiper.allowClick = true;
     });
   
     if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
       data.isTouched = false;
       data.isMoved = false;
       data.startMoving = false;
       return;
     }
     data.isTouched = false;
     data.isMoved = false;
     data.startMoving = false;
   
     let currentPos;
     if (params.followFinger) {
       currentPos = rtl ? swiper.translate : -swiper.translate;
     } else {
       currentPos = -data.currentTranslate;
     }
   
     if (params.cssMode) {
       return;
     }
   
     if (params.freeMode) {
       if (currentPos < -swiper.minTranslate()) {
         swiper.slideTo(swiper.activeIndex);
         return;
       }
       if (currentPos > -swiper.maxTranslate()) {
         if (swiper.slides.length < snapGrid.length) {
           swiper.slideTo(snapGrid.length - 1);
         } else {
           swiper.slideTo(swiper.slides.length - 1);
         }
         return;
       }
   
       if (params.freeModeMomentum) {
         if (data.velocities.length > 1) {
           const lastMoveEvent = data.velocities.pop();
           const velocityEvent = data.velocities.pop();
   
           const distance = lastMoveEvent.position - velocityEvent.position;
           const time = lastMoveEvent.time - velocityEvent.time;
           swiper.velocity = distance / time;
           swiper.velocity /= 2;
           if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
             swiper.velocity = 0;
           }
           // this implies that the user stopped moving a finger then released.
           // There would be no events with distance zero, so the last event is stale.
           if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
             swiper.velocity = 0;
           }
         } else {
           swiper.velocity = 0;
         }
         swiper.velocity *= params.freeModeMomentumVelocityRatio;
   
         data.velocities.length = 0;
         let momentumDuration = 1000 * params.freeModeMomentumRatio;
         const momentumDistance = swiper.velocity * momentumDuration;
   
         let newPosition = swiper.translate + momentumDistance;
         if (rtl) newPosition = -newPosition;
   
         let doBounce = false;
         let afterBouncePosition;
         const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
         let needsLoopFix;
         if (newPosition < swiper.maxTranslate()) {
           if (params.freeModeMomentumBounce) {
             if (newPosition + swiper.maxTranslate() < -bounceAmount) {
               newPosition = swiper.maxTranslate() - bounceAmount;
             }
             afterBouncePosition = swiper.maxTranslate();
             doBounce = true;
             data.allowMomentumBounce = true;
           } else {
             newPosition = swiper.maxTranslate();
           }
           if (params.loop && params.centeredSlides) needsLoopFix = true;
         } else if (newPosition > swiper.minTranslate()) {
           if (params.freeModeMomentumBounce) {
             if (newPosition - swiper.minTranslate() > bounceAmount) {
               newPosition = swiper.minTranslate() + bounceAmount;
             }
             afterBouncePosition = swiper.minTranslate();
             doBounce = true;
             data.allowMomentumBounce = true;
           } else {
             newPosition = swiper.minTranslate();
           }
           if (params.loop && params.centeredSlides) needsLoopFix = true;
         } else if (params.freeModeSticky) {
           let nextSlide;
           for (let j = 0; j < snapGrid.length; j += 1) {
             if (snapGrid[j] > -newPosition) {
               nextSlide = j;
               break;
             }
           }
   
           if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
             newPosition = snapGrid[nextSlide];
           } else {
             newPosition = snapGrid[nextSlide - 1];
           }
           newPosition = -newPosition;
         }
         if (needsLoopFix) {
           swiper.once('transitionEnd', () => {
             swiper.loopFix();
           });
         }
         // Fix duration
         if (swiper.velocity !== 0) {
           if (rtl) {
             momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
           } else {
             momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
           }
           if (params.freeModeSticky) {
             // If freeModeSticky is active and the user ends a swipe with a slow-velocity
             // event, then durations can be 20+ seconds to slide one (or zero!) slides.
             // It's easy to see this when simulating touch with mouse events. To fix this,
             // limit single-slide swipes to the default slide duration. This also has the
             // nice side effect of matching slide speed if the user stopped moving before
             // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
             // For faster swipes, also apply limits (albeit higher ones).
             const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
             const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
             if (moveDistance < currentSlideSize) {
               momentumDuration = params.speed;
             } else if (moveDistance < 2 * currentSlideSize) {
               momentumDuration = params.speed * 1.5;
             } else {
               momentumDuration = params.speed * 2.5;
             }
           }
         } else if (params.freeModeSticky) {
           swiper.slideToClosest();
           return;
         }
   
         if (params.freeModeMomentumBounce && doBounce) {
           swiper.updateProgress(afterBouncePosition);
           swiper.setTransition(momentumDuration);
           swiper.setTranslate(newPosition);
           swiper.transitionStart(true, swiper.swipeDirection);
           swiper.animating = true;
           $wrapperEl.transitionEnd(() => {
             if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
             swiper.emit('momentumBounce');
             swiper.setTransition(params.speed);
             setTimeout(() => {
               swiper.setTranslate(afterBouncePosition);
               $wrapperEl.transitionEnd(() => {
                 if (!swiper || swiper.destroyed) return;
                 swiper.transitionEnd();
               });
             }, 0);
           });
         } else if (swiper.velocity) {
           swiper.updateProgress(newPosition);
           swiper.setTransition(momentumDuration);
           swiper.setTranslate(newPosition);
           swiper.transitionStart(true, swiper.swipeDirection);
           if (!swiper.animating) {
             swiper.animating = true;
             $wrapperEl.transitionEnd(() => {
               if (!swiper || swiper.destroyed) return;
               swiper.transitionEnd();
             });
           }
         } else {
           swiper.updateProgress(newPosition);
         }
   
         swiper.updateActiveIndex();
         swiper.updateSlidesClasses();
       } else if (params.freeModeSticky) {
         swiper.slideToClosest();
         return;
       }
   
       if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
         swiper.updateProgress();
         swiper.updateActiveIndex();
         swiper.updateSlidesClasses();
       }
       return;
     }
   
     // Find current slide
     let stopIndex = 0;
     let groupSize = swiper.slidesSizesGrid[0];
     for (let i = 0; i < slidesGrid.length; i += (i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup)) {
       const increment = (i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
       if (typeof slidesGrid[i + increment] !== 'undefined') {
         if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
           stopIndex = i;
           groupSize = slidesGrid[i + increment] - slidesGrid[i];
         }
       } else if (currentPos >= slidesGrid[i]) {
         stopIndex = i;
         groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
       }
     }
   
     // Find current slide size
     const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
     const increment = (stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup);
   
     if (timeDiff > params.longSwipesMs) {
       // Long touches
       if (!params.longSwipes) {
         swiper.slideTo(swiper.activeIndex);
         return;
       }
       if (swiper.swipeDirection === 'next') {
         if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
         else swiper.slideTo(stopIndex);
       }
       if (swiper.swipeDirection === 'prev') {
         if (ratio > (1 - params.longSwipesRatio)) swiper.slideTo(stopIndex + increment);
         else swiper.slideTo(stopIndex);
       }
     } else {
       // Short swipes
       if (!params.shortSwipes) {
         swiper.slideTo(swiper.activeIndex);
         return;
       }
       const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
       if (!isNavButtonTarget) {
         if (swiper.swipeDirection === 'next') {
           swiper.slideTo(stopIndex + increment);
         }
         if (swiper.swipeDirection === 'prev') {
           swiper.slideTo(stopIndex);
         }
       } else if (e.target === swiper.navigation.nextEl) {
         swiper.slideTo(stopIndex + increment);
       } else {
         swiper.slideTo(stopIndex);
       }
     }
   }
   
   function onResize () {
     const swiper = this;
   
     const { params, el } = swiper;
   
     if (el && el.offsetWidth === 0) return;
   
     // Breakpoints
     if (params.breakpoints) {
       swiper.setBreakpoint();
     }
   
     // Save locks
     const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;
   
     // Disable locks on resize
     swiper.allowSlideNext = true;
     swiper.allowSlidePrev = true;
   
     swiper.updateSize();
     swiper.updateSlides();
   
     swiper.updateSlidesClasses();
     if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
       swiper.slideTo(swiper.slides.length - 1, 0, false, true);
     } else {
       swiper.slideTo(swiper.activeIndex, 0, false, true);
     }
   
     if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
       swiper.autoplay.run();
     }
     // Return locks after resize
     swiper.allowSlidePrev = allowSlidePrev;
     swiper.allowSlideNext = allowSlideNext;
   
     if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
       swiper.checkOverflow();
     }
   }
   
   function onClick (e) {
     const swiper = this;
     if (!swiper.allowClick) {
       if (swiper.params.preventClicks) e.preventDefault();
       if (swiper.params.preventClicksPropagation && swiper.animating) {
         e.stopPropagation();
         e.stopImmediatePropagation();
       }
     }
   }
   
   function onScroll () {
     const swiper = this;
     const { wrapperEl, rtlTranslate } = swiper;
     swiper.previousTranslate = swiper.translate;
     if (swiper.isHorizontal()) {
       if (rtlTranslate) {
         swiper.translate = ((wrapperEl.scrollWidth - wrapperEl.offsetWidth) - wrapperEl.scrollLeft);
       } else {
         swiper.translate = -wrapperEl.scrollLeft;
       }
     } else {
       swiper.translate = -wrapperEl.scrollTop;
     }
     // eslint-disable-next-line
     if (swiper.translate === -0) swiper.translate = 0;
   
     swiper.updateActiveIndex();
     swiper.updateSlidesClasses();
   
     let newProgress;
     const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
     if (translatesDiff === 0) {
       newProgress = 0;
     } else {
       newProgress = (swiper.translate - swiper.minTranslate()) / (translatesDiff);
     }
     if (newProgress !== swiper.progress) {
       swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
     }
   
     swiper.emit('setTranslate', swiper.translate, false);
   }
   
   let dummyEventAttached = false;
   function dummyEventListener() {}
   
   function attachEvents() {
     const swiper = this;
     const {
       params, touchEvents, el, wrapperEl,
     } = swiper;
   
     swiper.onTouchStart = onTouchStart.bind(swiper);
     swiper.onTouchMove = onTouchMove.bind(swiper);
     swiper.onTouchEnd = onTouchEnd.bind(swiper);
     if (params.cssMode) {
       swiper.onScroll = onScroll.bind(swiper);
     }
   
     swiper.onClick = onClick.bind(swiper);
   
     const capture = !!params.nested;
   
     // Touch Events
     if (!Support.touch && Support.pointerEvents) {
       el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
       doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
       doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
     } else {
       if (Support.touch) {
         const passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
         el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
         el.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture } : capture);
         el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
         if (touchEvents.cancel) {
           el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
         }
         if (!dummyEventAttached) {
           doc.addEventListener('touchstart', dummyEventListener);
           dummyEventAttached = true;
         }
       }
       if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
         el.addEventListener('mousedown', swiper.onTouchStart, false);
         doc.addEventListener('mousemove', swiper.onTouchMove, capture);
         doc.addEventListener('mouseup', swiper.onTouchEnd, false);
       }
     }
     // Prevent Links Clicks
     if (params.preventClicks || params.preventClicksPropagation) {
       el.addEventListener('click', swiper.onClick, true);
     }
     if (params.cssMode) {
       wrapperEl.addEventListener('scroll', swiper.onScroll);
     }
   
     // Resize handler
     if (params.updateOnWindowResize) {
       swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
     } else {
       swiper.on('observerUpdate', onResize, true);
     }
   }
   
   function detachEvents() {
     const swiper = this;
   
     const {
       params, touchEvents, el, wrapperEl,
     } = swiper;
   
     const capture = !!params.nested;
   
     // Touch Events
     if (!Support.touch && Support.pointerEvents) {
       el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
       doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
       doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
     } else {
       if (Support.touch) {
         const passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
         el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
         el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
         el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
         if (touchEvents.cancel) {
           el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
         }
       }
       if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
         el.removeEventListener('mousedown', swiper.onTouchStart, false);
         doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
         doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
       }
     }
     // Prevent Links Clicks
     if (params.preventClicks || params.preventClicksPropagation) {
       el.removeEventListener('click', swiper.onClick, true);
     }
   
     if (params.cssMode) {
       wrapperEl.removeEventListener('scroll', swiper.onScroll);
     }
   
     // Resize handler
     swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
   }
   
   var swiper_esm_bundle_events = {
     attachEvents,
     detachEvents,
   };
   
   function setBreakpoint () {
     const swiper = this;
     const {
       activeIndex, initialized, loopedSlides = 0, params, $el,
     } = swiper;
     const breakpoints = params.breakpoints;
     if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) return;
   
     // Get breakpoint for window width and update parameters
     const breakpoint = swiper.getBreakpoint(breakpoints);
   
     if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
       const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
       if (breakpointOnlyParams) {
         ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach((param) => {
           const paramValue = breakpointOnlyParams[param];
           if (typeof paramValue === 'undefined') return;
           if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
             breakpointOnlyParams[param] = 'auto';
           } else if (param === 'slidesPerView') {
             breakpointOnlyParams[param] = parseFloat(paramValue);
           } else {
             breakpointOnlyParams[param] = parseInt(paramValue, 10);
           }
         });
       }
   
       const breakpointParams = breakpointOnlyParams || swiper.originalParams;
       const wasMultiRow = params.slidesPerColumn > 1;
       const isMultiRow = breakpointParams.slidesPerColumn > 1;
       if (wasMultiRow && !isMultiRow) {
         $el.removeClass(`${params.containerModifierClass}multirow ${params.containerModifierClass}multirow-column`);
       } else if (!wasMultiRow && isMultiRow) {
         $el.addClass(`${params.containerModifierClass}multirow`);
         if (breakpointParams.slidesPerColumnFill === 'column') {
           $el.addClass(`${params.containerModifierClass}multirow-column`);
         }
       }
   
       const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
       const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
   
       if (directionChanged && initialized) {
         swiper.changeDirection();
       }
   
       Utils.extend(swiper.params, breakpointParams);
   
       Utils.extend(swiper, {
         allowTouchMove: swiper.params.allowTouchMove,
         allowSlideNext: swiper.params.allowSlideNext,
         allowSlidePrev: swiper.params.allowSlidePrev,
       });
   
       swiper.currentBreakpoint = breakpoint;
   
       if (needsReLoop && initialized) {
         swiper.loopDestroy();
         swiper.loopCreate();
         swiper.updateSlides();
         swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
       }
   
       swiper.emit('breakpoint', breakpointParams);
     }
   }
   
   function getBreakpoint (breakpoints) {
     // Get breakpoint for window width
     if (!breakpoints) return undefined;
     let breakpoint = false;
   
     const points = Object.keys(breakpoints).map((point) => {
       if (typeof point === 'string' && point.indexOf('@') === 0) {
         const minRatio = parseFloat(point.substr(1));
         const value = win.innerHeight * minRatio;
         return { value, point };
       }
       return { value: point, point };
     });
   
     points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
     for (let i = 0; i < points.length; i += 1) {
       const { point, value } = points[i];
       if (value <= win.innerWidth) {
         breakpoint = point;
       }
     }
     return breakpoint || 'max';
   }
   
   var breakpoints = { setBreakpoint, getBreakpoint };
   
   function addClasses () {
     const swiper = this;
     const {
       classNames, params, rtl, $el,
     } = swiper;
     const suffixes = [];
   
     suffixes.push('initialized');
     suffixes.push(params.direction);
   
     if (params.freeMode) {
       suffixes.push('free-mode');
     }
     if (params.autoHeight) {
       suffixes.push('autoheight');
     }
     if (rtl) {
       suffixes.push('rtl');
     }
     if (params.slidesPerColumn > 1) {
       suffixes.push('multirow');
       if (params.slidesPerColumnFill === 'column') {
         suffixes.push('multirow-column');
       }
     }
     if (Device.android) {
       suffixes.push('android');
     }
     if (Device.ios) {
       suffixes.push('ios');
     }
   
     if (params.cssMode) {
       suffixes.push('css-mode');
     }
   
     suffixes.forEach((suffix) => {
       classNames.push(params.containerModifierClass + suffix);
     });
   
     $el.addClass(classNames.join(' '));
   }
   
   function removeClasses () {
     const swiper = this;
     const { $el, classNames } = swiper;
   
     $el.removeClass(classNames.join(' '));
   }
   
   var classes = { addClasses, removeClasses };
   
   function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
     let image;
     function onReady() {
       if (callback) callback();
     }
     const isPicture = $(imageEl).parent('picture')[0];
   
     if (!isPicture && (!imageEl.complete || !checkForComplete)) {
       if (src) {
         image = new win.Image();
         image.onload = onReady;
         image.onerror = onReady;
         if (sizes) {
           image.sizes = sizes;
         }
         if (srcset) {
           image.srcset = srcset;
         }
         if (src) {
           image.src = src;
         }
       } else {
         onReady();
       }
     } else {
       // image already loaded...
       onReady();
     }
   }
   
   function preloadImages () {
     const swiper = this;
     swiper.imagesToLoad = swiper.$el.find('img');
     function onReady() {
       if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
       if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
       if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
         if (swiper.params.updateOnImagesReady) swiper.update();
         swiper.emit('imagesReady');
       }
     }
     for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
       const imageEl = swiper.imagesToLoad[i];
       swiper.loadImage(
         imageEl,
         imageEl.currentSrc || imageEl.getAttribute('src'),
         imageEl.srcset || imageEl.getAttribute('srcset'),
         imageEl.sizes || imageEl.getAttribute('sizes'),
         true,
         onReady
       );
     }
   }
   
   var swiper_esm_bundle_images = {
     loadImage,
     preloadImages,
   };
   
   function checkOverflow() {
     const swiper = this;
     const params = swiper.params;
     const wasLocked = swiper.isLocked;
     const lastSlidePosition = swiper.slides.length > 0 && (params.slidesOffsetBefore + (params.spaceBetween * (swiper.slides.length - 1)) + ((swiper.slides[0]).offsetWidth) * swiper.slides.length);
   
     if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
       swiper.isLocked = lastSlidePosition <= swiper.size;
     } else {
       swiper.isLocked = swiper.snapGrid.length === 1;
     }
   
     swiper.allowSlideNext = !swiper.isLocked;
     swiper.allowSlidePrev = !swiper.isLocked;
   
     // events
     if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
   
     if (wasLocked && wasLocked !== swiper.isLocked) {
       swiper.isEnd = false;
       if (swiper.navigation) swiper.navigation.update();
     }
   }
   
   var checkOverflow$1 = { checkOverflow };
   
   var defaults = {
     init: true,
     direction: 'horizontal',
     touchEventsTarget: 'container',
     initialSlide: 0,
     speed: 300,
     cssMode: false,
     updateOnWindowResize: true,
     //
     preventInteractionOnTransition: false,
   
     // To support iOS's swipe-to-go-back gesture (when being used in-app).
     edgeSwipeDetection: false,
     edgeSwipeThreshold: 20,
   
     // Free mode
     freeMode: false,
     freeModeMomentum: true,
     freeModeMomentumRatio: 1,
     freeModeMomentumBounce: true,
     freeModeMomentumBounceRatio: 1,
     freeModeMomentumVelocityRatio: 1,
     freeModeSticky: false,
     freeModeMinimumVelocity: 0.02,
   
     // Autoheight
     autoHeight: false,
   
     // Set wrapper width
     setWrapperSize: false,
   
     // Virtual Translate
     virtualTranslate: false,
   
     // Effects
     effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
   
     // Breakpoints
     breakpoints: undefined,
   
     // Slides grid
     spaceBetween: 0,
     slidesPerView: 1,
     slidesPerColumn: 1,
     slidesPerColumnFill: 'column',
     slidesPerGroup: 1,
     slidesPerGroupSkip: 0,
     centeredSlides: false,
     centeredSlidesBounds: false,
     slidesOffsetBefore: 0, // in px
     slidesOffsetAfter: 0, // in px
     normalizeSlideIndex: true,
     centerInsufficientSlides: false,
   
     // Disable swiper and hide navigation when container not overflow
     watchOverflow: false,
   
     // Round length
     roundLengths: false,
   
     // Touches
     touchRatio: 1,
     touchAngle: 45,
     simulateTouch: true,
     shortSwipes: true,
     longSwipes: true,
     longSwipesRatio: 0.5,
     longSwipesMs: 300,
     followFinger: true,
     allowTouchMove: true,
     threshold: 0,
     touchMoveStopPropagation: false,
     touchStartPreventDefault: true,
     touchStartForcePreventDefault: false,
     touchReleaseOnEdges: false,
   
     // Unique Navigation Elements
     uniqueNavElements: true,
   
     // Resistance
     resistance: true,
     resistanceRatio: 0.85,
   
     // Progress
     watchSlidesProgress: false,
     watchSlidesVisibility: false,
   
     // Cursor
     grabCursor: false,
   
     // Clicks
     preventClicks: true,
     preventClicksPropagation: true,
     slideToClickedSlide: false,
   
     // Images
     preloadImages: true,
     updateOnImagesReady: true,
   
     // loop
     loop: false,
     loopAdditionalSlides: 0,
     loopedSlides: null,
     loopFillGroupWithBlank: false,
   
     // Swiping/no swiping
     allowSlidePrev: true,
     allowSlideNext: true,
     swipeHandler: null, // '.swipe-handler',
     noSwiping: true,
     noSwipingClass: 'swiper-no-swiping',
     noSwipingSelector: null,
   
     // Passive Listeners
     passiveListeners: true,
   
     // NS
     containerModifierClass: 'swiper-container-', // NEW
     slideClass: 'swiper-slide',
     slideBlankClass: 'swiper-slide-invisible-blank',
     slideActiveClass: 'swiper-slide-active',
     slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
     slideVisibleClass: 'swiper-slide-visible',
     slideDuplicateClass: 'swiper-slide-duplicate',
     slideNextClass: 'swiper-slide-next',
     slideDuplicateNextClass: 'swiper-slide-duplicate-next',
     slidePrevClass: 'swiper-slide-prev',
     slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
     wrapperClass: 'swiper-wrapper',
   
     // Callbacks
     runCallbacksOnInit: true,
   };
   
   /* eslint no-param-reassign: "off" */
   
   const prototypes = {
     update,
     translate,
     transition: swiper_esm_bundle_transition,
     slide,
     loop,
     grabCursor,
     manipulation,
     events: swiper_esm_bundle_events,
     breakpoints,
     checkOverflow: checkOverflow$1,
     classes,
     images: swiper_esm_bundle_images,
   };
   
   const extendedDefaults = {};
   
   class Swiper extends SwiperClass {
     constructor(...args) {
       let el;
       let params;
       if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
         params = args[0];
       } else {
         [el, params] = args;
       }
       if (!params) params = {};
   
       params = Utils.extend({}, params);
       if (el && !params.el) params.el = el;
   
       super(params);
   
       Object.keys(prototypes).forEach((prototypeGroup) => {
         Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
           if (!Swiper.prototype[protoMethod]) {
             Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
           }
         });
       });
   
       // Swiper Instance
       const swiper = this;
       if (typeof swiper.modules === 'undefined') {
         swiper.modules = {};
       }
       Object.keys(swiper.modules).forEach((moduleName) => {
         const module = swiper.modules[moduleName];
         if (module.params) {
           const moduleParamName = Object.keys(module.params)[0];
           const moduleParams = module.params[moduleParamName];
           if (typeof moduleParams !== 'object' || moduleParams === null) return;
           if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
           if (params[moduleParamName] === true) {
             params[moduleParamName] = { enabled: true };
           }
           if (
             typeof params[moduleParamName] === 'object'
             && !('enabled' in params[moduleParamName])
           ) {
             params[moduleParamName].enabled = true;
           }
           if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
         }
       });
   
       // Extend defaults with modules params
       const swiperParams = Utils.extend({}, defaults);
       swiper.useModulesParams(swiperParams);
   
       // Extend defaults with passed params
       swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
       swiper.originalParams = Utils.extend({}, swiper.params);
       swiper.passedParams = Utils.extend({}, params);
   
       // Save Dom lib
       swiper.$ = $;
   
       // Find el
       const $el = $(swiper.params.el);
       el = $el[0];
   
       if (!el) {
         return undefined;
       }
   
       if ($el.length > 1) {
         const swipers = [];
         $el.each((index, containerEl) => {
           const newParams = Utils.extend({}, params, { el: containerEl });
           swipers.push(new Swiper(newParams));
         });
         return swipers;
       }
   
       el.swiper = swiper;
       $el.data('swiper', swiper);
   
       // Find Wrapper
       let $wrapperEl;
       if (el && el.shadowRoot && el.shadowRoot.querySelector) {
         $wrapperEl = $(el.shadowRoot.querySelector(`.${swiper.params.wrapperClass}`));
         // Children needs to return slot items
         $wrapperEl.children = (options) => $el.children(options);
       } else {
         $wrapperEl = $el.children(`.${swiper.params.wrapperClass}`);
       }
       // Extend Swiper
       Utils.extend(swiper, {
         $el,
         el,
         $wrapperEl,
         wrapperEl: $wrapperEl[0],
   
         // Classes
         classNames: [],
   
         // Slides
         slides: $(),
         slidesGrid: [],
         snapGrid: [],
         slidesSizesGrid: [],
   
         // isDirection
         isHorizontal() {
           return swiper.params.direction === 'horizontal';
         },
         isVertical() {
           return swiper.params.direction === 'vertical';
         },
         // RTL
         rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
         rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
         wrongRTL: $wrapperEl.css('display') === '-webkit-box',
   
         // Indexes
         activeIndex: 0,
         realIndex: 0,
   
         //
         isBeginning: true,
         isEnd: false,
   
         // Props
         translate: 0,
         previousTranslate: 0,
         progress: 0,
         velocity: 0,
         animating: false,
   
         // Locks
         allowSlideNext: swiper.params.allowSlideNext,
         allowSlidePrev: swiper.params.allowSlidePrev,
   
         // Touch Events
         touchEvents: (function touchEvents() {
           const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
           let desktop = ['mousedown', 'mousemove', 'mouseup'];
           if (Support.pointerEvents) {
             desktop = ['pointerdown', 'pointermove', 'pointerup'];
           }
           swiper.touchEventsTouch = {
             start: touch[0],
             move: touch[1],
             end: touch[2],
             cancel: touch[3],
           };
           swiper.touchEventsDesktop = {
             start: desktop[0],
             move: desktop[1],
             end: desktop[2],
           };
           return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
         }()),
         touchEventsData: {
           isTouched: undefined,
           isMoved: undefined,
           allowTouchCallbacks: undefined,
           touchStartTime: undefined,
           isScrolling: undefined,
           currentTranslate: undefined,
           startTranslate: undefined,
           allowThresholdMove: undefined,
           // Form elements to match
           formElements: 'input, select, option, textarea, button, video, label',
           // Last click time
           lastClickTime: Utils.now(),
           clickTimeout: undefined,
           // Velocities
           velocities: [],
           allowMomentumBounce: undefined,
           isTouchEvent: undefined,
           startMoving: undefined,
         },
   
         // Clicks
         allowClick: true,
   
         // Touches
         allowTouchMove: swiper.params.allowTouchMove,
   
         touches: {
           startX: 0,
           startY: 0,
           currentX: 0,
           currentY: 0,
           diff: 0,
         },
   
         // Images
         imagesToLoad: [],
         imagesLoaded: 0,
   
       });
   
       // Install Modules
       swiper.useModules();
   
       // Init
       if (swiper.params.init) {
         swiper.init();
       }
   
       // Return app instance
       return swiper;
     }
   
     slidesPerViewDynamic() {
       const swiper = this;
       const {
         params, slides, slidesGrid, size: swiperSize, activeIndex,
       } = swiper;
       let spv = 1;
       if (params.centeredSlides) {
         let slideSize = slides[activeIndex].swiperSlideSize;
         let breakLoop;
         for (let i = activeIndex + 1; i < slides.length; i += 1) {
           if (slides[i] && !breakLoop) {
             slideSize += slides[i].swiperSlideSize;
             spv += 1;
             if (slideSize > swiperSize) breakLoop = true;
           }
         }
         for (let i = activeIndex - 1; i >= 0; i -= 1) {
           if (slides[i] && !breakLoop) {
             slideSize += slides[i].swiperSlideSize;
             spv += 1;
             if (slideSize > swiperSize) breakLoop = true;
           }
         }
       } else {
         for (let i = activeIndex + 1; i < slides.length; i += 1) {
           if (slidesGrid[i] - slidesGrid[activeIndex] < swiperSize) {
             spv += 1;
           }
         }
       }
       return spv;
     }
   
     update() {
       const swiper = this;
       if (!swiper || swiper.destroyed) return;
       const { snapGrid, params } = swiper;
       // Breakpoints
       if (params.breakpoints) {
         swiper.setBreakpoint();
       }
       swiper.updateSize();
       swiper.updateSlides();
       swiper.updateProgress();
       swiper.updateSlidesClasses();
   
       function setTranslate() {
         const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
         const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
         swiper.setTranslate(newTranslate);
         swiper.updateActiveIndex();
         swiper.updateSlidesClasses();
       }
       let translated;
       if (swiper.params.freeMode) {
         setTranslate();
         if (swiper.params.autoHeight) {
           swiper.updateAutoHeight();
         }
       } else {
         if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
           translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
         } else {
           translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
         }
         if (!translated) {
           setTranslate();
         }
       }
       if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
         swiper.checkOverflow();
       }
       swiper.emit('update');
     }
   
     changeDirection(newDirection, needUpdate = true) {
       const swiper = this;
       const currentDirection = swiper.params.direction;
       if (!newDirection) {
         // eslint-disable-next-line
         newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
       }
       if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
         return swiper;
       }
   
       swiper.$el
         .removeClass(`${swiper.params.containerModifierClass}${currentDirection}`)
         .addClass(`${swiper.params.containerModifierClass}${newDirection}`);
   
       swiper.params.direction = newDirection;
   
       swiper.slides.each((slideIndex, slideEl) => {
         if (newDirection === 'vertical') {
           slideEl.style.width = '';
         } else {
           slideEl.style.height = '';
         }
       });
   
       swiper.emit('changeDirection');
       if (needUpdate) swiper.update();
   
       return swiper;
     }
   
     init() {
       const swiper = this;
       if (swiper.initialized) return;
   
       swiper.emit('beforeInit');
   
       // Set breakpoint
       if (swiper.params.breakpoints) {
         swiper.setBreakpoint();
       }
   
       // Add Classes
       swiper.addClasses();
   
       // Create loop
       if (swiper.params.loop) {
         swiper.loopCreate();
       }
   
       // Update size
       swiper.updateSize();
   
       // Update slides
       swiper.updateSlides();
   
       if (swiper.params.watchOverflow) {
         swiper.checkOverflow();
       }
   
       // Set Grab Cursor
       if (swiper.params.grabCursor) {
         swiper.setGrabCursor();
       }
   
       if (swiper.params.preloadImages) {
         swiper.preloadImages();
       }
   
       // Slide To Initial Slide
       if (swiper.params.loop) {
         swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
       } else {
         swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
       }
   
       // Attach events
       swiper.attachEvents();
   
       // Init Flag
       swiper.initialized = true;
   
       // Emit
       swiper.emit('init');
     }
   
     destroy(deleteInstance = true, cleanStyles = true) {
       const swiper = this;
       const {
         params, $el, $wrapperEl, slides,
       } = swiper;
   
       if (typeof swiper.params === 'undefined' || swiper.destroyed) {
         return null;
       }
   
       swiper.emit('beforeDestroy');
   
       // Init Flag
       swiper.initialized = false;
   
       // Detach events
       swiper.detachEvents();
   
       // Destroy loop
       if (params.loop) {
         swiper.loopDestroy();
       }
   
       // Cleanup styles
       if (cleanStyles) {
         swiper.removeClasses();
         $el.removeAttr('style');
         $wrapperEl.removeAttr('style');
         if (slides && slides.length) {
           slides
             .removeClass([
               params.slideVisibleClass,
               params.slideActiveClass,
               params.slideNextClass,
               params.slidePrevClass,
             ].join(' '))
             .removeAttr('style')
             .removeAttr('data-swiper-slide-index');
         }
       }
   
       swiper.emit('destroy');
   
       // Detach emitter events
       Object.keys(swiper.eventsListeners).forEach((eventName) => {
         swiper.off(eventName);
       });
   
       if (deleteInstance !== false) {
         swiper.$el[0].swiper = null;
         swiper.$el.data('swiper', null);
         Utils.deleteProps(swiper);
       }
       swiper.destroyed = true;
   
       return null;
     }
   
     static extendDefaults(newDefaults) {
       Utils.extend(extendedDefaults, newDefaults);
     }
   
     static get extendedDefaults() {
       return extendedDefaults;
     }
   
     static get defaults() {
       return defaults;
     }
   
     static get Class() {
       return SwiperClass;
     }
   
     static get $() {
       return $;
     }
   }
   
   var Device$1 = {
     name: 'device',
     proto: {
       device: Device,
     },
     static: {
       device: Device,
     },
   };
   
   var Support$1 = {
     name: 'support',
     proto: {
       support: Support,
     },
     static: {
       support: Support,
     },
   };
   
   const Browser = (function Browser() {
     function isSafari() {
       const ua = win.navigator.userAgent.toLowerCase();
       return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
     }
     return {
       isEdge: !!win.navigator.userAgent.match(/Edge/g),
       isSafari: isSafari(),
       isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
     };
   }());
   
   var Browser$1 = {
     name: 'browser',
     proto: {
       browser: Browser,
     },
     static: {
       browser: Browser,
     },
   };
   
   var Resize = {
     name: 'resize',
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         resize: {
           resizeHandler() {
             if (!swiper || swiper.destroyed || !swiper.initialized) return;
             swiper.emit('beforeResize');
             swiper.emit('resize');
           },
           orientationChangeHandler() {
             if (!swiper || swiper.destroyed || !swiper.initialized) return;
             swiper.emit('orientationchange');
           },
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         // Emit resize
         win.addEventListener('resize', swiper.resize.resizeHandler);
   
         // Emit orientationchange
         win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
       },
       destroy() {
         const swiper = this;
         win.removeEventListener('resize', swiper.resize.resizeHandler);
         win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
       },
     },
   };
   
   const swiper_esm_bundle_Observer = {
     func: win.MutationObserver || win.WebkitMutationObserver,
     attach(target, options = {}) {
       const swiper = this;
   
       const ObserverFunc = swiper_esm_bundle_Observer.func;
       const observer = new ObserverFunc((mutations) => {
         // The observerUpdate event should only be triggered
         // once despite the number of mutations.  Additional
         // triggers are redundant and are very costly
         if (mutations.length === 1) {
           swiper.emit('observerUpdate', mutations[0]);
           return;
         }
         const observerUpdate = function observerUpdate() {
           swiper.emit('observerUpdate', mutations[0]);
         };
   
         if (win.requestAnimationFrame) {
           win.requestAnimationFrame(observerUpdate);
         } else {
           win.setTimeout(observerUpdate, 0);
         }
       });
   
       observer.observe(target, {
         attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
         childList: typeof options.childList === 'undefined' ? true : options.childList,
         characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
       });
   
       swiper.observer.observers.push(observer);
     },
     init() {
       const swiper = this;
       if (!Support.observer || !swiper.params.observer) return;
       if (swiper.params.observeParents) {
         const containerParents = swiper.$el.parents();
         for (let i = 0; i < containerParents.length; i += 1) {
           swiper.observer.attach(containerParents[i]);
         }
       }
       // Observe container
       swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });
   
       // Observe wrapper
       swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
     },
     destroy() {
       const swiper = this;
       swiper.observer.observers.forEach((observer) => {
         observer.disconnect();
       });
       swiper.observer.observers = [];
     },
   };
   
   var Observer$1 = {
     name: 'observer',
     params: {
       observer: false,
       observeParents: false,
       observeSlideChildren: false,
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         observer: {
           init: swiper_esm_bundle_Observer.init.bind(swiper),
           attach: swiper_esm_bundle_Observer.attach.bind(swiper),
           destroy: swiper_esm_bundle_Observer.destroy.bind(swiper),
           observers: [],
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         swiper.observer.init();
       },
       destroy() {
         const swiper = this;
         swiper.observer.destroy();
       },
     },
   };
   
   const Virtual = {
     update(force) {
       const swiper = this;
       const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
       const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
       const {
         from: previousFrom,
         to: previousTo,
         slides,
         slidesGrid: previousSlidesGrid,
         renderSlide,
         offset: previousOffset,
       } = swiper.virtual;
       swiper.updateActiveIndex();
       const activeIndex = swiper.activeIndex || 0;
   
       let offsetProp;
       if (swiper.rtlTranslate) offsetProp = 'right';
       else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
   
       let slidesAfter;
       let slidesBefore;
       if (centeredSlides) {
         slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
         slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
       } else {
         slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
         slidesBefore = slidesPerGroup + addSlidesAfter;
       }
       const from = Math.max((activeIndex || 0) - slidesBefore, 0);
       const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
       const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
   
       Utils.extend(swiper.virtual, {
         from,
         to,
         offset,
         slidesGrid: swiper.slidesGrid,
       });
   
       function onRendered() {
         swiper.updateSlides();
         swiper.updateProgress();
         swiper.updateSlidesClasses();
         if (swiper.lazy && swiper.params.lazy.enabled) {
           swiper.lazy.load();
         }
       }
   
       if (previousFrom === from && previousTo === to && !force) {
         if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
           swiper.slides.css(offsetProp, `${offset}px`);
         }
         swiper.updateProgress();
         return;
       }
       if (swiper.params.virtual.renderExternal) {
         swiper.params.virtual.renderExternal.call(swiper, {
           offset,
           from,
           to,
           slides: (function getSlides() {
             const slidesToRender = [];
             for (let i = from; i <= to; i += 1) {
               slidesToRender.push(slides[i]);
             }
             return slidesToRender;
           }()),
         });
         onRendered();
         return;
       }
       const prependIndexes = [];
       const appendIndexes = [];
       if (force) {
         swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
       } else {
         for (let i = previousFrom; i <= previousTo; i += 1) {
           if (i < from || i > to) {
             swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
           }
         }
       }
       for (let i = 0; i < slides.length; i += 1) {
         if (i >= from && i <= to) {
           if (typeof previousTo === 'undefined' || force) {
             appendIndexes.push(i);
           } else {
             if (i > previousTo) appendIndexes.push(i);
             if (i < previousFrom) prependIndexes.push(i);
           }
         }
       }
       appendIndexes.forEach((index) => {
         swiper.$wrapperEl.append(renderSlide(slides[index], index));
       });
       prependIndexes.sort((a, b) => b - a).forEach((index) => {
         swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
       });
       swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
       onRendered();
     },
     renderSlide(slide, index) {
       const swiper = this;
       const params = swiper.params.virtual;
       if (params.cache && swiper.virtual.cache[index]) {
         return swiper.virtual.cache[index];
       }
       const $slideEl = params.renderSlide
         ? $(params.renderSlide.call(swiper, slide, index))
         : $(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
       if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
       if (params.cache) swiper.virtual.cache[index] = $slideEl;
       return $slideEl;
     },
     appendSlide(slides) {
       const swiper = this;
       if (typeof slides === 'object' && 'length' in slides) {
         for (let i = 0; i < slides.length; i += 1) {
           if (slides[i]) swiper.virtual.slides.push(slides[i]);
         }
       } else {
         swiper.virtual.slides.push(slides);
       }
       swiper.virtual.update(true);
     },
     prependSlide(slides) {
       const swiper = this;
       const activeIndex = swiper.activeIndex;
       let newActiveIndex = activeIndex + 1;
       let numberOfNewSlides = 1;
   
       if (Array.isArray(slides)) {
         for (let i = 0; i < slides.length; i += 1) {
           if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
         }
         newActiveIndex = activeIndex + slides.length;
         numberOfNewSlides = slides.length;
       } else {
         swiper.virtual.slides.unshift(slides);
       }
       if (swiper.params.virtual.cache) {
         const cache = swiper.virtual.cache;
         const newCache = {};
         Object.keys(cache).forEach((cachedIndex) => {
           const $cachedEl = cache[cachedIndex];
           const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
           if (cachedElIndex) {
             $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
           }
           newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
         });
         swiper.virtual.cache = newCache;
       }
       swiper.virtual.update(true);
       swiper.slideTo(newActiveIndex, 0);
     },
     removeSlide(slidesIndexes) {
       const swiper = this;
       if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
       let activeIndex = swiper.activeIndex;
       if (Array.isArray(slidesIndexes)) {
         for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
           swiper.virtual.slides.splice(slidesIndexes[i], 1);
           if (swiper.params.virtual.cache) {
             delete swiper.virtual.cache[slidesIndexes[i]];
           }
           if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
           activeIndex = Math.max(activeIndex, 0);
         }
       } else {
         swiper.virtual.slides.splice(slidesIndexes, 1);
         if (swiper.params.virtual.cache) {
           delete swiper.virtual.cache[slidesIndexes];
         }
         if (slidesIndexes < activeIndex) activeIndex -= 1;
         activeIndex = Math.max(activeIndex, 0);
       }
       swiper.virtual.update(true);
       swiper.slideTo(activeIndex, 0);
     },
     removeAllSlides() {
       const swiper = this;
       swiper.virtual.slides = [];
       if (swiper.params.virtual.cache) {
         swiper.virtual.cache = {};
       }
       swiper.virtual.update(true);
       swiper.slideTo(0, 0);
     },
   };
   
   var Virtual$1 = {
     name: 'virtual',
     params: {
       virtual: {
         enabled: false,
         slides: [],
         cache: true,
         renderSlide: null,
         renderExternal: null,
         addSlidesBefore: 0,
         addSlidesAfter: 0,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         virtual: {
           update: Virtual.update.bind(swiper),
           appendSlide: Virtual.appendSlide.bind(swiper),
           prependSlide: Virtual.prependSlide.bind(swiper),
           removeSlide: Virtual.removeSlide.bind(swiper),
           removeAllSlides: Virtual.removeAllSlides.bind(swiper),
           renderSlide: Virtual.renderSlide.bind(swiper),
           slides: swiper.params.virtual.slides,
           cache: {},
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (!swiper.params.virtual.enabled) return;
         swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
         const overwriteParams = {
           watchSlidesProgress: true,
         };
         Utils.extend(swiper.params, overwriteParams);
         Utils.extend(swiper.originalParams, overwriteParams);
   
         if (!swiper.params.initialSlide) {
           swiper.virtual.update();
         }
       },
       setTranslate() {
         const swiper = this;
         if (!swiper.params.virtual.enabled) return;
         swiper.virtual.update();
       },
     },
   };
   
   const Keyboard = {
     handle(event) {
       const swiper = this;
       const { rtlTranslate: rtl } = swiper;
       let e = event;
       if (e.originalEvent) e = e.originalEvent; // jquery fix
       const kc = e.keyCode || e.charCode;
       const pageUpDown = swiper.params.keyboard.pageUpDown;
       const isPageUp = pageUpDown && kc === 33;
       const isPageDown = pageUpDown && kc === 34;
       const isArrowLeft = kc === 37;
       const isArrowRight = kc === 39;
       const isArrowUp = kc === 38;
       const isArrowDown = kc === 40;
       // Directions locks
       if (!swiper.allowSlideNext && ((swiper.isHorizontal() && isArrowRight) || (swiper.isVertical() && isArrowDown) || isPageDown)) {
         return false;
       }
       if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && isArrowLeft) || (swiper.isVertical() && isArrowUp) || isPageUp)) {
         return false;
       }
       if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
         return undefined;
       }
       if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
         return undefined;
       }
       if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
         let inView = false;
         // Check that swiper should be inside of visible area of window
         if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
           return undefined;
         }
         const windowWidth = win.innerWidth;
         const windowHeight = win.innerHeight;
         const swiperOffset = swiper.$el.offset();
         if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
         const swiperCoord = [
           [swiperOffset.left, swiperOffset.top],
           [swiperOffset.left + swiper.width, swiperOffset.top],
           [swiperOffset.left, swiperOffset.top + swiper.height],
           [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height],
         ];
         for (let i = 0; i < swiperCoord.length; i += 1) {
           const point = swiperCoord[i];
           if (
             point[0] >= 0 && point[0] <= windowWidth
             && point[1] >= 0 && point[1] <= windowHeight
           ) {
             inView = true;
           }
         }
         if (!inView) return undefined;
       }
       if (swiper.isHorizontal()) {
         if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
           if (e.preventDefault) e.preventDefault();
           else e.returnValue = false;
         }
         if (((isPageDown || isArrowRight) && !rtl) || ((isPageUp || isArrowLeft) && rtl)) swiper.slideNext();
         if (((isPageUp || isArrowLeft) && !rtl) || ((isPageDown || isArrowRight) && rtl)) swiper.slidePrev();
       } else {
         if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
           if (e.preventDefault) e.preventDefault();
           else e.returnValue = false;
         }
         if (isPageDown || isArrowDown) swiper.slideNext();
         if (isPageUp || isArrowUp) swiper.slidePrev();
       }
       swiper.emit('keyPress', kc);
       return undefined;
     },
     enable() {
       const swiper = this;
       if (swiper.keyboard.enabled) return;
       $(doc).on('keydown', swiper.keyboard.handle);
       swiper.keyboard.enabled = true;
     },
     disable() {
       const swiper = this;
       if (!swiper.keyboard.enabled) return;
       $(doc).off('keydown', swiper.keyboard.handle);
       swiper.keyboard.enabled = false;
     },
   };
   
   var Keyboard$1 = {
     name: 'keyboard',
     params: {
       keyboard: {
         enabled: false,
         onlyInViewport: true,
         pageUpDown: true,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         keyboard: {
           enabled: false,
           enable: Keyboard.enable.bind(swiper),
           disable: Keyboard.disable.bind(swiper),
           handle: Keyboard.handle.bind(swiper),
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (swiper.params.keyboard.enabled) {
           swiper.keyboard.enable();
         }
       },
       destroy() {
         const swiper = this;
         if (swiper.keyboard.enabled) {
           swiper.keyboard.disable();
         }
       },
     },
   };
   
   function isEventSupported() {
     const eventName = 'onwheel';
     let isSupported = eventName in doc;
   
     if (!isSupported) {
       const element = doc.createElement('div');
       element.setAttribute(eventName, 'return;');
       isSupported = typeof element[eventName] === 'function';
     }
   
     if (!isSupported
       && doc.implementation
       && doc.implementation.hasFeature
       // always returns true in newer browsers as per the standard.
       // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
       && doc.implementation.hasFeature('', '') !== true
     ) {
       // This is the only way to test support for the `wheel` event in IE9+.
       isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
     }
   
     return isSupported;
   }
   const Mousewheel = {
     lastScrollTime: Utils.now(),
     lastEventBeforeSnap: undefined,
     recentWheelEvents: [],
     event() {
       if (win.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
       return isEventSupported() ? 'wheel' : 'mousewheel';
     },
     normalize(e) {
       // Reasonable defaults
       const PIXEL_STEP = 10;
       const LINE_HEIGHT = 40;
       const PAGE_HEIGHT = 800;
   
       let sX = 0;
       let sY = 0; // spinX, spinY
       let pX = 0;
       let pY = 0; // pixelX, pixelY
   
       // Legacy
       if ('detail' in e) {
         sY = e.detail;
       }
       if ('wheelDelta' in e) {
         sY = -e.wheelDelta / 120;
       }
       if ('wheelDeltaY' in e) {
         sY = -e.wheelDeltaY / 120;
       }
       if ('wheelDeltaX' in e) {
         sX = -e.wheelDeltaX / 120;
       }
   
       // side scrolling on FF with DOMMouseScroll
       if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
         sX = sY;
         sY = 0;
       }
   
       pX = sX * PIXEL_STEP;
       pY = sY * PIXEL_STEP;
   
       if ('deltaY' in e) {
         pY = e.deltaY;
       }
       if ('deltaX' in e) {
         pX = e.deltaX;
       }
   
       if (e.shiftKey && !pX) { // if user scrolls with shift he wants horizontal scroll
         pX = pY;
         pY = 0;
       }
   
       if ((pX || pY) && e.deltaMode) {
         if (e.deltaMode === 1) { // delta in LINE units
           pX *= LINE_HEIGHT;
           pY *= LINE_HEIGHT;
         } else { // delta in PAGE units
           pX *= PAGE_HEIGHT;
           pY *= PAGE_HEIGHT;
         }
       }
   
       // Fall-back if spin cannot be determined
       if (pX && !sX) {
         sX = (pX < 1) ? -1 : 1;
       }
       if (pY && !sY) {
         sY = (pY < 1) ? -1 : 1;
       }
   
       return {
         spinX: sX,
         spinY: sY,
         pixelX: pX,
         pixelY: pY,
       };
     },
     handleMouseEnter() {
       const swiper = this;
       swiper.mouseEntered = true;
     },
     handleMouseLeave() {
       const swiper = this;
       swiper.mouseEntered = false;
     },
     handle(event) {
       let e = event;
       const swiper = this;
       const params = swiper.params.mousewheel;
   
       if (swiper.params.cssMode) {
         e.preventDefault();
       }
   
       let target = swiper.$el;
       if (swiper.params.mousewheel.eventsTarged !== 'container') {
         target = $(swiper.params.mousewheel.eventsTarged);
       }
       if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
   
       if (e.originalEvent) e = e.originalEvent; // jquery fix
       let delta = 0;
       const rtlFactor = swiper.rtlTranslate ? -1 : 1;
   
       const data = Mousewheel.normalize(e);
   
       if (params.forceToAxis) {
         if (swiper.isHorizontal()) {
           if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
           else return true;
         } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
         else return true;
       } else {
         delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
       }
   
       if (delta === 0) return true;
   
       if (params.invert) delta = -delta;
   
       if (!swiper.params.freeMode) {
         // Register the new event in a variable which stores the relevant data
         const newEvent = {
           time: Utils.now(),
           delta: Math.abs(delta),
           direction: Math.sign(delta),
           raw: event,
         };
   
         // Keep the most recent events
         const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
         if (recentWheelEvents.length >= 2) {
           recentWheelEvents.shift(); // only store the last N events
         }
         const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
         recentWheelEvents.push(newEvent);
   
         // If there is at least one previous recorded event:
         //   If direction has changed or
         //   if the scroll is quicker than the previous one:
         //     Animate the slider.
         // Else (this is the first time the wheel is moved):
         //     Animate the slider.
         if (prevEvent) {
           if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
             swiper.mousewheel.animateSlider(newEvent);
           }
         } else {
           swiper.mousewheel.animateSlider(newEvent);
         }
   
         // If it's time to release the scroll:
         //   Return now so you don't hit the preventDefault.
         if (swiper.mousewheel.releaseScroll(newEvent)) {
           return true;
         }
       } else {
         // Freemode or scrollContainer:
   
         // If we recently snapped after a momentum scroll, then ignore wheel events
         // to give time for the deceleration to finish. Stop ignoring after 500 msecs
         // or if it's a new scroll (larger delta or inverse sign as last event before
         // an end-of-momentum snap).
         const newEvent = { time: Utils.now(), delta: Math.abs(delta), direction: Math.sign(delta) };
         const { lastEventBeforeSnap } = swiper.mousewheel;
         const ignoreWheelEvents = lastEventBeforeSnap
           && newEvent.time < lastEventBeforeSnap.time + 500
           && newEvent.delta <= lastEventBeforeSnap.delta
           && newEvent.direction === lastEventBeforeSnap.direction;
         if (!ignoreWheelEvents) {
           swiper.mousewheel.lastEventBeforeSnap = undefined;
   
           if (swiper.params.loop) {
             swiper.loopFix();
           }
           let position = swiper.getTranslate() + (delta * params.sensitivity);
           const wasBeginning = swiper.isBeginning;
           const wasEnd = swiper.isEnd;
   
           if (position >= swiper.minTranslate()) position = swiper.minTranslate();
           if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
   
           swiper.setTransition(0);
           swiper.setTranslate(position);
           swiper.updateProgress();
           swiper.updateActiveIndex();
           swiper.updateSlidesClasses();
   
           if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
             swiper.updateSlidesClasses();
           }
   
           if (swiper.params.freeModeSticky) {
             // When wheel scrolling starts with sticky (aka snap) enabled, then detect
             // the end of a momentum scroll by storing recent (N=15?) wheel events.
             // 1. do all N events have decreasing or same (absolute value) delta?
             // 2. did all N events arrive in the last M (M=500?) msecs?
             // 3. does the earliest event have an (absolute value) delta that's
             //    at least P (P=1?) larger than the most recent event's delta?
             // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
             // If 1-4 are "yes" then we're near the end of a momuntum scroll deceleration.
             // Snap immediately and ignore remaining wheel events in this scroll.
             // See comment above for "remaining wheel events in this scroll" determination.
             // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
             clearTimeout(swiper.mousewheel.timeout);
             swiper.mousewheel.timeout = undefined;
             const recentWheelEvents = swiper.mousewheel.recentWheelEvents;
             if (recentWheelEvents.length >= 15) {
               recentWheelEvents.shift(); // only store the last N events
             }
             const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
             const firstEvent = recentWheelEvents[0];
             recentWheelEvents.push(newEvent);
             if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
               // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
               recentWheelEvents.splice(0);
             } else if (recentWheelEvents.length >= 15
                 && newEvent.time - firstEvent.time < 500
                 && firstEvent.delta - newEvent.delta >= 1
                 && newEvent.delta <= 6
             ) {
               // We're at the end of the deceleration of a momentum scroll, so there's no need
               // to wait for more events. Snap ASAP on the next tick.
               // Also, because there's some remaining momentum we'll bias the snap in the
               // direction of the ongoing scroll because it's better UX for the scroll to snap
               // in the same direction as the scroll instead of reversing to snap.  Therefore,
               // if it's already scrolled more than 20% in the current direction, keep going.
               const snapToThreshold = delta > 0 ? 0.8 : 0.2;
               swiper.mousewheel.lastEventBeforeSnap = newEvent;
               recentWheelEvents.splice(0);
               swiper.mousewheel.timeout = Utils.nextTick(() => {
                 swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
               }, 0); // no delay; move on next tick
             }
             if (!swiper.mousewheel.timeout) {
               // if we get here, then we haven't detected the end of a momentum scroll, so
               // we'll consider a scroll "complete" when there haven't been any wheel events
               // for 500ms.
               swiper.mousewheel.timeout = Utils.nextTick(() => {
                 const snapToThreshold = 0.5;
                 swiper.mousewheel.lastEventBeforeSnap = newEvent;
                 recentWheelEvents.splice(0);
                 swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
               }, 500);
             }
           }
   
           // Emit event
           if (!ignoreWheelEvents) swiper.emit('scroll', e);
   
           // Stop autoplay
           if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
           // Return page scroll on edge positions
           if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
         }
       }
   
       if (e.preventDefault) e.preventDefault();
       else e.returnValue = false;
       return false;
     },
     animateSlider(newEvent) {
       const swiper = this;
       // If the movement is NOT big enough and
       // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
       //   Don't go any further (avoid insignificant scroll movement).
       if (newEvent.delta >= 6 && Utils.now() - swiper.mousewheel.lastScrollTime < 60) {
         // Return false as a default
         return true;
       }
       // If user is scrolling towards the end:
       //   If the slider hasn't hit the latest slide or
       //   if the slider is a loop and
       //   if the slider isn't moving right now:
       //     Go to next slide and
       //     emit a scroll event.
       // Else (the user is scrolling towards the beginning) and
       // if the slider hasn't hit the first slide or
       // if the slider is a loop and
       // if the slider isn't moving right now:
       //   Go to prev slide and
       //   emit a scroll event.
       if (newEvent.direction < 0) {
         if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
           swiper.slideNext();
           swiper.emit('scroll', newEvent.raw);
         }
       } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
         swiper.slidePrev();
         swiper.emit('scroll', newEvent.raw);
       }
       // If you got here is because an animation has been triggered so store the current time
       swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
       // Return false as a default
       return false;
     },
     releaseScroll(newEvent) {
       const swiper = this;
       const params = swiper.params.mousewheel;
       if (newEvent.direction < 0) {
         if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
           // Return true to animate scroll on edges
           return true;
         }
       } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
         // Return true to animate scroll on edges
         return true;
       }
       return false;
     },
     enable() {
       const swiper = this;
       const event = Mousewheel.event();
       if (swiper.params.cssMode) {
         swiper.wrapperEl.removeEventListener(event, swiper.mousewheel.handle);
         return true;
       }
       if (!event) return false;
       if (swiper.mousewheel.enabled) return false;
       let target = swiper.$el;
       if (swiper.params.mousewheel.eventsTarged !== 'container') {
         target = $(swiper.params.mousewheel.eventsTarged);
       }
       target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
       target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
       target.on(event, swiper.mousewheel.handle);
       swiper.mousewheel.enabled = true;
       return true;
     },
     disable() {
       const swiper = this;
       const event = Mousewheel.event();
       if (swiper.params.cssMode) {
         swiper.wrapperEl.addEventListener(event, swiper.mousewheel.handle);
         return true;
       }
       if (!event) return false;
       if (!swiper.mousewheel.enabled) return false;
       let target = swiper.$el;
       if (swiper.params.mousewheel.eventsTarged !== 'container') {
         target = $(swiper.params.mousewheel.eventsTarged);
       }
       target.off(event, swiper.mousewheel.handle);
       swiper.mousewheel.enabled = false;
       return true;
     },
   };
   
   var Mousewheel$1 = {
     name: 'mousewheel',
     params: {
       mousewheel: {
         enabled: false,
         releaseOnEdges: false,
         invert: false,
         forceToAxis: false,
         sensitivity: 1,
         eventsTarged: 'container',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         mousewheel: {
           enabled: false,
           enable: Mousewheel.enable.bind(swiper),
           disable: Mousewheel.disable.bind(swiper),
           handle: Mousewheel.handle.bind(swiper),
           handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
           handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
           animateSlider: Mousewheel.animateSlider.bind(swiper),
           releaseScroll: Mousewheel.releaseScroll.bind(swiper),
           lastScrollTime: Utils.now(),
           lastEventBeforeSnap: undefined,
           recentWheelEvents: [],
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
           swiper.mousewheel.disable();
         }
         if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
       },
       destroy() {
         const swiper = this;
         if (swiper.params.cssMode) {
           swiper.mousewheel.enable();
         }
         if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
       },
     },
   };
   
   const Navigation = {
     update() {
       // Update Navigation Buttons
       const swiper = this;
       const params = swiper.params.navigation;
   
       if (swiper.params.loop) return;
       const { $nextEl, $prevEl } = swiper.navigation;
   
       if ($prevEl && $prevEl.length > 0) {
         if (swiper.isBeginning) {
           $prevEl.addClass(params.disabledClass);
         } else {
           $prevEl.removeClass(params.disabledClass);
         }
         $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
       }
       if ($nextEl && $nextEl.length > 0) {
         if (swiper.isEnd) {
           $nextEl.addClass(params.disabledClass);
         } else {
           $nextEl.removeClass(params.disabledClass);
         }
         $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
       }
     },
     onPrevClick(e) {
       const swiper = this;
       e.preventDefault();
       if (swiper.isBeginning && !swiper.params.loop) return;
       swiper.slidePrev();
     },
     onNextClick(e) {
       const swiper = this;
       e.preventDefault();
       if (swiper.isEnd && !swiper.params.loop) return;
       swiper.slideNext();
     },
     init() {
       const swiper = this;
       const params = swiper.params.navigation;
       if (!(params.nextEl || params.prevEl)) return;
   
       let $nextEl;
       let $prevEl;
       if (params.nextEl) {
         $nextEl = $(params.nextEl);
         if (
           swiper.params.uniqueNavElements
           && typeof params.nextEl === 'string'
           && $nextEl.length > 1
           && swiper.$el.find(params.nextEl).length === 1
         ) {
           $nextEl = swiper.$el.find(params.nextEl);
         }
       }
       if (params.prevEl) {
         $prevEl = $(params.prevEl);
         if (
           swiper.params.uniqueNavElements
           && typeof params.prevEl === 'string'
           && $prevEl.length > 1
           && swiper.$el.find(params.prevEl).length === 1
         ) {
           $prevEl = swiper.$el.find(params.prevEl);
         }
       }
   
       if ($nextEl && $nextEl.length > 0) {
         $nextEl.on('click', swiper.navigation.onNextClick);
       }
       if ($prevEl && $prevEl.length > 0) {
         $prevEl.on('click', swiper.navigation.onPrevClick);
       }
   
       Utils.extend(swiper.navigation, {
         $nextEl,
         nextEl: $nextEl && $nextEl[0],
         $prevEl,
         prevEl: $prevEl && $prevEl[0],
       });
     },
     destroy() {
       const swiper = this;
       const { $nextEl, $prevEl } = swiper.navigation;
       if ($nextEl && $nextEl.length) {
         $nextEl.off('click', swiper.navigation.onNextClick);
         $nextEl.removeClass(swiper.params.navigation.disabledClass);
       }
       if ($prevEl && $prevEl.length) {
         $prevEl.off('click', swiper.navigation.onPrevClick);
         $prevEl.removeClass(swiper.params.navigation.disabledClass);
       }
     },
   };
   
   var Navigation$1 = {
     name: 'navigation',
     params: {
       navigation: {
         nextEl: null,
         prevEl: null,
   
         hideOnClick: false,
         disabledClass: 'swiper-button-disabled',
         hiddenClass: 'swiper-button-hidden',
         lockClass: 'swiper-button-lock',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         navigation: {
           init: Navigation.init.bind(swiper),
           update: Navigation.update.bind(swiper),
           destroy: Navigation.destroy.bind(swiper),
           onNextClick: Navigation.onNextClick.bind(swiper),
           onPrevClick: Navigation.onPrevClick.bind(swiper),
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         swiper.navigation.init();
         swiper.navigation.update();
       },
       toEdge() {
         const swiper = this;
         swiper.navigation.update();
       },
       fromEdge() {
         const swiper = this;
         swiper.navigation.update();
       },
       destroy() {
         const swiper = this;
         swiper.navigation.destroy();
       },
       click(e) {
         const swiper = this;
         const { $nextEl, $prevEl } = swiper.navigation;
         if (
           swiper.params.navigation.hideOnClick
           && !$(e.target).is($prevEl)
           && !$(e.target).is($nextEl)
         ) {
           let isHidden;
           if ($nextEl) {
             isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
           } else if ($prevEl) {
             isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
           }
           if (isHidden === true) {
             swiper.emit('navigationShow', swiper);
           } else {
             swiper.emit('navigationHide', swiper);
           }
           if ($nextEl) {
             $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
           }
           if ($prevEl) {
             $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
           }
         }
       },
     },
   };
   
   const Pagination = {
     update() {
       // Render || Update Pagination bullets/items
       const swiper = this;
       const rtl = swiper.rtl;
       const params = swiper.params.pagination;
       if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
       const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
       const $el = swiper.pagination.$el;
       // Current/Total
       let current;
       const total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
       if (swiper.params.loop) {
         current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
         if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
           current -= (slidesLength - (swiper.loopedSlides * 2));
         }
         if (current > total - 1) current -= total;
         if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
       } else if (typeof swiper.snapIndex !== 'undefined') {
         current = swiper.snapIndex;
       } else {
         current = swiper.activeIndex || 0;
       }
       // Types
       if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
         const bullets = swiper.pagination.bullets;
         let firstIndex;
         let lastIndex;
         let midIndex;
         if (params.dynamicBullets) {
           swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
           $el.css(swiper.isHorizontal() ? 'width' : 'height', `${swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)}px`);
           if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
             swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
             if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
               swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
             } else if (swiper.pagination.dynamicBulletIndex < 0) {
               swiper.pagination.dynamicBulletIndex = 0;
             }
           }
           firstIndex = current - swiper.pagination.dynamicBulletIndex;
           lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
           midIndex = (lastIndex + firstIndex) / 2;
         }
         bullets.removeClass(`${params.bulletActiveClass} ${params.bulletActiveClass}-next ${params.bulletActiveClass}-next-next ${params.bulletActiveClass}-prev ${params.bulletActiveClass}-prev-prev ${params.bulletActiveClass}-main`);
         if ($el.length > 1) {
           bullets.each((index, bullet) => {
             const $bullet = $(bullet);
             const bulletIndex = $bullet.index();
             if (bulletIndex === current) {
               $bullet.addClass(params.bulletActiveClass);
             }
             if (params.dynamicBullets) {
               if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                 $bullet.addClass(`${params.bulletActiveClass}-main`);
               }
               if (bulletIndex === firstIndex) {
                 $bullet
                   .prev()
                   .addClass(`${params.bulletActiveClass}-prev`)
                   .prev()
                   .addClass(`${params.bulletActiveClass}-prev-prev`);
               }
               if (bulletIndex === lastIndex) {
                 $bullet
                   .next()
                   .addClass(`${params.bulletActiveClass}-next`)
                   .next()
                   .addClass(`${params.bulletActiveClass}-next-next`);
               }
             }
           });
         } else {
           const $bullet = bullets.eq(current);
           const bulletIndex = $bullet.index();
           $bullet.addClass(params.bulletActiveClass);
           if (params.dynamicBullets) {
             const $firstDisplayedBullet = bullets.eq(firstIndex);
             const $lastDisplayedBullet = bullets.eq(lastIndex);
             for (let i = firstIndex; i <= lastIndex; i += 1) {
               bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
             }
             if (swiper.params.loop) {
               if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                 for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                   bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                 }
                 bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
               } else {
                 $firstDisplayedBullet
                   .prev()
                   .addClass(`${params.bulletActiveClass}-prev`)
                   .prev()
                   .addClass(`${params.bulletActiveClass}-prev-prev`);
                 $lastDisplayedBullet
                   .next()
                   .addClass(`${params.bulletActiveClass}-next`)
                   .next()
                   .addClass(`${params.bulletActiveClass}-next-next`);
               }
             } else {
               $firstDisplayedBullet
                 .prev()
                 .addClass(`${params.bulletActiveClass}-prev`)
                 .prev()
                 .addClass(`${params.bulletActiveClass}-prev-prev`);
               $lastDisplayedBullet
                 .next()
                 .addClass(`${params.bulletActiveClass}-next`)
                 .next()
                 .addClass(`${params.bulletActiveClass}-next-next`);
             }
           }
         }
         if (params.dynamicBullets) {
           const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
           const bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
           const offsetProp = rtl ? 'right' : 'left';
           bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
         }
       }
       if (params.type === 'fraction') {
         $el.find(`.${params.currentClass}`).text(params.formatFractionCurrent(current + 1));
         $el.find(`.${params.totalClass}`).text(params.formatFractionTotal(total));
       }
       if (params.type === 'progressbar') {
         let progressbarDirection;
         if (params.progressbarOpposite) {
           progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
         } else {
           progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
         }
         const scale = (current + 1) / total;
         let scaleX = 1;
         let scaleY = 1;
         if (progressbarDirection === 'horizontal') {
           scaleX = scale;
         } else {
           scaleY = scale;
         }
         $el.find(`.${params.progressbarFillClass}`).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
       }
       if (params.type === 'custom' && params.renderCustom) {
         $el.html(params.renderCustom(swiper, current + 1, total));
         swiper.emit('paginationRender', swiper, $el[0]);
       } else {
         swiper.emit('paginationUpdate', swiper, $el[0]);
       }
       $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
     },
     render() {
       // Render Container
       const swiper = this;
       const params = swiper.params.pagination;
       if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
       const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
   
       const $el = swiper.pagination.$el;
       let paginationHTML = '';
       if (params.type === 'bullets') {
         const numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
         for (let i = 0; i < numberOfBullets; i += 1) {
           if (params.renderBullet) {
             paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
           } else {
             paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
           }
         }
         $el.html(paginationHTML);
         swiper.pagination.bullets = $el.find(`.${params.bulletClass}`);
       }
       if (params.type === 'fraction') {
         if (params.renderFraction) {
           paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
         } else {
           paginationHTML = `<span class="${params.currentClass}"></span>`
           + ' / '
           + `<span class="${params.totalClass}"></span>`;
         }
         $el.html(paginationHTML);
       }
       if (params.type === 'progressbar') {
         if (params.renderProgressbar) {
           paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
         } else {
           paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
         }
         $el.html(paginationHTML);
       }
       if (params.type !== 'custom') {
         swiper.emit('paginationRender', swiper.pagination.$el[0]);
       }
     },
     init() {
       const swiper = this;
       const params = swiper.params.pagination;
       if (!params.el) return;
   
       let $el = $(params.el);
       if ($el.length === 0) return;
   
       if (
         swiper.params.uniqueNavElements
         && typeof params.el === 'string'
         && $el.length > 1
       ) {
         $el = swiper.$el.find(params.el);
       }
   
       if (params.type === 'bullets' && params.clickable) {
         $el.addClass(params.clickableClass);
       }
   
       $el.addClass(params.modifierClass + params.type);
   
       if (params.type === 'bullets' && params.dynamicBullets) {
         $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
         swiper.pagination.dynamicBulletIndex = 0;
         if (params.dynamicMainBullets < 1) {
           params.dynamicMainBullets = 1;
         }
       }
       if (params.type === 'progressbar' && params.progressbarOpposite) {
         $el.addClass(params.progressbarOppositeClass);
       }
   
       if (params.clickable) {
         $el.on('click', `.${params.bulletClass}`, function onClick(e) {
           e.preventDefault();
           let index = $(this).index() * swiper.params.slidesPerGroup;
           if (swiper.params.loop) index += swiper.loopedSlides;
           swiper.slideTo(index);
         });
       }
   
       Utils.extend(swiper.pagination, {
         $el,
         el: $el[0],
       });
     },
     destroy() {
       const swiper = this;
       const params = swiper.params.pagination;
       if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
       const $el = swiper.pagination.$el;
   
       $el.removeClass(params.hiddenClass);
       $el.removeClass(params.modifierClass + params.type);
       if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
       if (params.clickable) {
         $el.off('click', `.${params.bulletClass}`);
       }
     },
   };
   
   var Pagination$1 = {
     name: 'pagination',
     params: {
       pagination: {
         el: null,
         bulletElement: 'span',
         clickable: false,
         hideOnClick: false,
         renderBullet: null,
         renderProgressbar: null,
         renderFraction: null,
         renderCustom: null,
         progressbarOpposite: false,
         type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
         dynamicBullets: false,
         dynamicMainBullets: 1,
         formatFractionCurrent: (number) => number,
         formatFractionTotal: (number) => number,
         bulletClass: 'swiper-pagination-bullet',
         bulletActiveClass: 'swiper-pagination-bullet-active',
         modifierClass: 'swiper-pagination-', // NEW
         currentClass: 'swiper-pagination-current',
         totalClass: 'swiper-pagination-total',
         hiddenClass: 'swiper-pagination-hidden',
         progressbarFillClass: 'swiper-pagination-progressbar-fill',
         progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
         clickableClass: 'swiper-pagination-clickable', // NEW
         lockClass: 'swiper-pagination-lock',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         pagination: {
           init: Pagination.init.bind(swiper),
           render: Pagination.render.bind(swiper),
           update: Pagination.update.bind(swiper),
           destroy: Pagination.destroy.bind(swiper),
           dynamicBulletIndex: 0,
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         swiper.pagination.init();
         swiper.pagination.render();
         swiper.pagination.update();
       },
       activeIndexChange() {
         const swiper = this;
         if (swiper.params.loop) {
           swiper.pagination.update();
         } else if (typeof swiper.snapIndex === 'undefined') {
           swiper.pagination.update();
         }
       },
       snapIndexChange() {
         const swiper = this;
         if (!swiper.params.loop) {
           swiper.pagination.update();
         }
       },
       slidesLengthChange() {
         const swiper = this;
         if (swiper.params.loop) {
           swiper.pagination.render();
           swiper.pagination.update();
         }
       },
       snapGridLengthChange() {
         const swiper = this;
         if (!swiper.params.loop) {
           swiper.pagination.render();
           swiper.pagination.update();
         }
       },
       destroy() {
         const swiper = this;
         swiper.pagination.destroy();
       },
       click(e) {
         const swiper = this;
         if (
           swiper.params.pagination.el
           && swiper.params.pagination.hideOnClick
           && swiper.pagination.$el.length > 0
           && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
         ) {
           const isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
           if (isHidden === true) {
             swiper.emit('paginationShow', swiper);
           } else {
             swiper.emit('paginationHide', swiper);
           }
           swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
         }
       },
     },
   };
   
   const Scrollbar = {
     setTranslate() {
       const swiper = this;
       if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
       const { scrollbar, rtlTranslate: rtl, progress } = swiper;
       const {
         dragSize, trackSize, $dragEl, $el,
       } = scrollbar;
       const params = swiper.params.scrollbar;
   
       let newSize = dragSize;
       let newPos = (trackSize - dragSize) * progress;
       if (rtl) {
         newPos = -newPos;
         if (newPos > 0) {
           newSize = dragSize - newPos;
           newPos = 0;
         } else if (-newPos + dragSize > trackSize) {
           newSize = trackSize + newPos;
         }
       } else if (newPos < 0) {
         newSize = dragSize + newPos;
         newPos = 0;
       } else if (newPos + dragSize > trackSize) {
         newSize = trackSize - newPos;
       }
       if (swiper.isHorizontal()) {
         $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
         $dragEl[0].style.width = `${newSize}px`;
       } else {
         $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
         $dragEl[0].style.height = `${newSize}px`;
       }
       if (params.hide) {
         clearTimeout(swiper.scrollbar.timeout);
         $el[0].style.opacity = 1;
         swiper.scrollbar.timeout = setTimeout(() => {
           $el[0].style.opacity = 0;
           $el.transition(400);
         }, 1000);
       }
     },
     setTransition(duration) {
       const swiper = this;
       if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
       swiper.scrollbar.$dragEl.transition(duration);
     },
     updateSize() {
       const swiper = this;
       if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
   
       const { scrollbar } = swiper;
       const { $dragEl, $el } = scrollbar;
   
       $dragEl[0].style.width = '';
       $dragEl[0].style.height = '';
       const trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
   
       const divider = swiper.size / swiper.virtualSize;
       const moveDivider = divider * (trackSize / swiper.size);
       let dragSize;
       if (swiper.params.scrollbar.dragSize === 'auto') {
         dragSize = trackSize * divider;
       } else {
         dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
       }
   
       if (swiper.isHorizontal()) {
         $dragEl[0].style.width = `${dragSize}px`;
       } else {
         $dragEl[0].style.height = `${dragSize}px`;
       }
   
       if (divider >= 1) {
         $el[0].style.display = 'none';
       } else {
         $el[0].style.display = '';
       }
       if (swiper.params.scrollbar.hide) {
         $el[0].style.opacity = 0;
       }
       Utils.extend(scrollbar, {
         trackSize,
         divider,
         moveDivider,
         dragSize,
       });
       scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
     },
     getPointerPosition(e) {
       const swiper = this;
       if (swiper.isHorizontal()) {
         return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientX : e.clientX);
       }
       return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].clientY : e.clientY);
     },
     setDragPosition(e) {
       const swiper = this;
       const { scrollbar, rtlTranslate: rtl } = swiper;
       const {
         $el,
         dragSize,
         trackSize,
         dragStartPos,
       } = scrollbar;
   
       let positionRatio;
       positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
         - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
       positionRatio = Math.max(Math.min(positionRatio, 1), 0);
       if (rtl) {
         positionRatio = 1 - positionRatio;
       }
   
       const position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
   
       swiper.updateProgress(position);
       swiper.setTranslate(position);
       swiper.updateActiveIndex();
       swiper.updateSlidesClasses();
     },
     onDragStart(e) {
       const swiper = this;
       const params = swiper.params.scrollbar;
       const { scrollbar, $wrapperEl } = swiper;
       const { $el, $dragEl } = scrollbar;
       swiper.scrollbar.isTouched = true;
       swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
         ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
       e.preventDefault();
       e.stopPropagation();
   
       $wrapperEl.transition(100);
       $dragEl.transition(100);
       scrollbar.setDragPosition(e);
   
       clearTimeout(swiper.scrollbar.dragTimeout);
   
       $el.transition(0);
       if (params.hide) {
         $el.css('opacity', 1);
       }
       if (swiper.params.cssMode) {
         swiper.$wrapperEl.css('scroll-snap-type', 'none');
       }
       swiper.emit('scrollbarDragStart', e);
     },
     onDragMove(e) {
       const swiper = this;
       const { scrollbar, $wrapperEl } = swiper;
       const { $el, $dragEl } = scrollbar;
   
       if (!swiper.scrollbar.isTouched) return;
       if (e.preventDefault) e.preventDefault();
       else e.returnValue = false;
       scrollbar.setDragPosition(e);
       $wrapperEl.transition(0);
       $el.transition(0);
       $dragEl.transition(0);
       swiper.emit('scrollbarDragMove', e);
     },
     onDragEnd(e) {
       const swiper = this;
   
       const params = swiper.params.scrollbar;
       const { scrollbar, $wrapperEl } = swiper;
       const { $el } = scrollbar;
   
       if (!swiper.scrollbar.isTouched) return;
       swiper.scrollbar.isTouched = false;
       if (swiper.params.cssMode) {
         swiper.$wrapperEl.css('scroll-snap-type', '');
         $wrapperEl.transition('');
       }
       if (params.hide) {
         clearTimeout(swiper.scrollbar.dragTimeout);
         swiper.scrollbar.dragTimeout = Utils.nextTick(() => {
           $el.css('opacity', 0);
           $el.transition(400);
         }, 1000);
       }
       swiper.emit('scrollbarDragEnd', e);
       if (params.snapOnRelease) {
         swiper.slideToClosest();
       }
     },
     enableDraggable() {
       const swiper = this;
       if (!swiper.params.scrollbar.el) return;
       const {
         scrollbar, touchEventsTouch, touchEventsDesktop, params,
       } = swiper;
       const $el = scrollbar.$el;
       const target = $el[0];
       const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
       const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
       if (!Support.touch) {
         target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
         doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
         doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
       } else {
         target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
         target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
         target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
       }
     },
     disableDraggable() {
       const swiper = this;
       if (!swiper.params.scrollbar.el) return;
       const {
         scrollbar, touchEventsTouch, touchEventsDesktop, params,
       } = swiper;
       const $el = scrollbar.$el;
       const target = $el[0];
       const activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
       const passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
       if (!Support.touch) {
         target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
         doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
         doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
       } else {
         target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
         target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
         target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
       }
     },
     init() {
       const swiper = this;
       if (!swiper.params.scrollbar.el) return;
       const { scrollbar, $el: $swiperEl } = swiper;
       const params = swiper.params.scrollbar;
   
       let $el = $(params.el);
       if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
         $el = $swiperEl.find(params.el);
       }
   
       let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
       if ($dragEl.length === 0) {
         $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
         $el.append($dragEl);
       }
   
       Utils.extend(scrollbar, {
         $el,
         el: $el[0],
         $dragEl,
         dragEl: $dragEl[0],
       });
   
       if (params.draggable) {
         scrollbar.enableDraggable();
       }
     },
     destroy() {
       const swiper = this;
       swiper.scrollbar.disableDraggable();
     },
   };
   
   var Scrollbar$1 = {
     name: 'scrollbar',
     params: {
       scrollbar: {
         el: null,
         dragSize: 'auto',
         hide: false,
         draggable: false,
         snapOnRelease: true,
         lockClass: 'swiper-scrollbar-lock',
         dragClass: 'swiper-scrollbar-drag',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         scrollbar: {
           init: Scrollbar.init.bind(swiper),
           destroy: Scrollbar.destroy.bind(swiper),
           updateSize: Scrollbar.updateSize.bind(swiper),
           setTranslate: Scrollbar.setTranslate.bind(swiper),
           setTransition: Scrollbar.setTransition.bind(swiper),
           enableDraggable: Scrollbar.enableDraggable.bind(swiper),
           disableDraggable: Scrollbar.disableDraggable.bind(swiper),
           setDragPosition: Scrollbar.setDragPosition.bind(swiper),
           getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
           onDragStart: Scrollbar.onDragStart.bind(swiper),
           onDragMove: Scrollbar.onDragMove.bind(swiper),
           onDragEnd: Scrollbar.onDragEnd.bind(swiper),
           isTouched: false,
           timeout: null,
           dragTimeout: null,
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         swiper.scrollbar.init();
         swiper.scrollbar.updateSize();
         swiper.scrollbar.setTranslate();
       },
       update() {
         const swiper = this;
         swiper.scrollbar.updateSize();
       },
       resize() {
         const swiper = this;
         swiper.scrollbar.updateSize();
       },
       observerUpdate() {
         const swiper = this;
         swiper.scrollbar.updateSize();
       },
       setTranslate() {
         const swiper = this;
         swiper.scrollbar.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         swiper.scrollbar.setTransition(duration);
       },
       destroy() {
         const swiper = this;
         swiper.scrollbar.destroy();
       },
     },
   };
   
   const Parallax = {
     setTransform(el, progress) {
       const swiper = this;
       const { rtl } = swiper;
   
       const $el = $(el);
       const rtlFactor = rtl ? -1 : 1;
   
       const p = $el.attr('data-swiper-parallax') || '0';
       let x = $el.attr('data-swiper-parallax-x');
       let y = $el.attr('data-swiper-parallax-y');
       const scale = $el.attr('data-swiper-parallax-scale');
       const opacity = $el.attr('data-swiper-parallax-opacity');
   
       if (x || y) {
         x = x || '0';
         y = y || '0';
       } else if (swiper.isHorizontal()) {
         x = p;
         y = '0';
       } else {
         y = p;
         x = '0';
       }
   
       if ((x).indexOf('%') >= 0) {
         x = `${parseInt(x, 10) * progress * rtlFactor}%`;
       } else {
         x = `${x * progress * rtlFactor}px`;
       }
       if ((y).indexOf('%') >= 0) {
         y = `${parseInt(y, 10) * progress}%`;
       } else {
         y = `${y * progress}px`;
       }
   
       if (typeof opacity !== 'undefined' && opacity !== null) {
         const currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
         $el[0].style.opacity = currentOpacity;
       }
       if (typeof scale === 'undefined' || scale === null) {
         $el.transform(`translate3d(${x}, ${y}, 0px)`);
       } else {
         const currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
         $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
       }
     },
     setTranslate() {
       const swiper = this;
       const {
         $el, slides, progress, snapGrid,
       } = swiper;
       $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
         .each((index, el) => {
           swiper.parallax.setTransform(el, progress);
         });
       slides.each((slideIndex, slideEl) => {
         let slideProgress = slideEl.progress;
         if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
           slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
         }
         slideProgress = Math.min(Math.max(slideProgress, -1), 1);
         $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
           .each((index, el) => {
             swiper.parallax.setTransform(el, slideProgress);
           });
       });
     },
     setTransition(duration = this.params.speed) {
       const swiper = this;
       const { $el } = swiper;
       $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
         .each((index, parallaxEl) => {
           const $parallaxEl = $(parallaxEl);
           let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
           if (duration === 0) parallaxDuration = 0;
           $parallaxEl.transition(parallaxDuration);
         });
     },
   };
   
   var Parallax$1 = {
     name: 'parallax',
     params: {
       parallax: {
         enabled: false,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         parallax: {
           setTransform: Parallax.setTransform.bind(swiper),
           setTranslate: Parallax.setTranslate.bind(swiper),
           setTransition: Parallax.setTransition.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (!swiper.params.parallax.enabled) return;
         swiper.params.watchSlidesProgress = true;
         swiper.originalParams.watchSlidesProgress = true;
       },
       init() {
         const swiper = this;
         if (!swiper.params.parallax.enabled) return;
         swiper.parallax.setTranslate();
       },
       setTranslate() {
         const swiper = this;
         if (!swiper.params.parallax.enabled) return;
         swiper.parallax.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         if (!swiper.params.parallax.enabled) return;
         swiper.parallax.setTransition(duration);
       },
     },
   };
   
   const Zoom = {
     // Calc Scale From Multi-touches
     getDistanceBetweenTouches(e) {
       if (e.targetTouches.length < 2) return 1;
       const x1 = e.targetTouches[0].pageX;
       const y1 = e.targetTouches[0].pageY;
       const x2 = e.targetTouches[1].pageX;
       const y2 = e.targetTouches[1].pageY;
       const distance = Math.sqrt(((x2 - x1) ** 2) + ((y2 - y1) ** 2));
       return distance;
     },
     // Events
     onGestureStart(e) {
       const swiper = this;
       const params = swiper.params.zoom;
       const zoom = swiper.zoom;
       const { gesture } = zoom;
       zoom.fakeGestureTouched = false;
       zoom.fakeGestureMoved = false;
       if (!Support.gestures) {
         if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
           return;
         }
         zoom.fakeGestureTouched = true;
         gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
       }
       if (!gesture.$slideEl || !gesture.$slideEl.length) {
         gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`);
         if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
         gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
         gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
         gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
         if (gesture.$imageWrapEl.length === 0) {
           gesture.$imageEl = undefined;
           return;
         }
       }
       if (gesture.$imageEl) {
         gesture.$imageEl.transition(0);
       }
       swiper.zoom.isScaling = true;
     },
     onGestureChange(e) {
       const swiper = this;
       const params = swiper.params.zoom;
       const zoom = swiper.zoom;
       const { gesture } = zoom;
       if (!Support.gestures) {
         if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
           return;
         }
         zoom.fakeGestureMoved = true;
         gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
       }
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
       if (Support.gestures) {
         zoom.scale = e.scale * zoom.currentScale;
       } else {
         zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
       }
       if (zoom.scale > gesture.maxRatio) {
         zoom.scale = (gesture.maxRatio - 1) + (((zoom.scale - gesture.maxRatio) + 1) ** 0.5);
       }
       if (zoom.scale < params.minRatio) {
         zoom.scale = (params.minRatio + 1) - (((params.minRatio - zoom.scale) + 1) ** 0.5);
       }
       gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
     },
     onGestureEnd(e) {
       const swiper = this;
       const params = swiper.params.zoom;
       const zoom = swiper.zoom;
       const { gesture } = zoom;
       if (!Support.gestures) {
         if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
           return;
         }
         if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
           return;
         }
         zoom.fakeGestureTouched = false;
         zoom.fakeGestureMoved = false;
       }
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
       zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
       gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
       zoom.currentScale = zoom.scale;
       zoom.isScaling = false;
       if (zoom.scale === 1) gesture.$slideEl = undefined;
     },
     onTouchStart(e) {
       const swiper = this;
       const zoom = swiper.zoom;
       const { gesture, image } = zoom;
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
       if (image.isTouched) return;
       if (Device.android && e.cancelable) e.preventDefault();
       image.isTouched = true;
       image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
       image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
     },
     onTouchMove(e) {
       const swiper = this;
       const zoom = swiper.zoom;
       const { gesture, image, velocity } = zoom;
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
       swiper.allowClick = false;
       if (!image.isTouched || !gesture.$slideEl) return;
   
       if (!image.isMoved) {
         image.width = gesture.$imageEl[0].offsetWidth;
         image.height = gesture.$imageEl[0].offsetHeight;
         image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
         image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
         gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
         gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
         gesture.$imageWrapEl.transition(0);
         if (swiper.rtl) {
           image.startX = -image.startX;
           image.startY = -image.startY;
         }
       }
       // Define if we need image drag
       const scaledWidth = image.width * zoom.scale;
       const scaledHeight = image.height * zoom.scale;
   
       if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
   
       image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
       image.maxX = -image.minX;
       image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
       image.maxY = -image.minY;
   
       image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
       image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
   
       if (!image.isMoved && !zoom.isScaling) {
         if (
           swiper.isHorizontal()
           && (
             (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
             || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
           )
         ) {
           image.isTouched = false;
           return;
         } if (
           !swiper.isHorizontal()
           && (
             (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
             || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
           )
         ) {
           image.isTouched = false;
           return;
         }
       }
       if (e.cancelable) {
         e.preventDefault();
       }
       e.stopPropagation();
   
       image.isMoved = true;
       image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
       image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
   
       if (image.currentX < image.minX) {
         image.currentX = (image.minX + 1) - (((image.minX - image.currentX) + 1) ** 0.8);
       }
       if (image.currentX > image.maxX) {
         image.currentX = (image.maxX - 1) + (((image.currentX - image.maxX) + 1) ** 0.8);
       }
   
       if (image.currentY < image.minY) {
         image.currentY = (image.minY + 1) - (((image.minY - image.currentY) + 1) ** 0.8);
       }
       if (image.currentY > image.maxY) {
         image.currentY = (image.maxY - 1) + (((image.currentY - image.maxY) + 1) ** 0.8);
       }
   
       // Velocity
       if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
       if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
       if (!velocity.prevTime) velocity.prevTime = Date.now();
       velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
       velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
       if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
       if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
       velocity.prevPositionX = image.touchesCurrent.x;
       velocity.prevPositionY = image.touchesCurrent.y;
       velocity.prevTime = Date.now();
   
       gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
     },
     onTouchEnd() {
       const swiper = this;
       const zoom = swiper.zoom;
       const { gesture, image, velocity } = zoom;
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
       if (!image.isTouched || !image.isMoved) {
         image.isTouched = false;
         image.isMoved = false;
         return;
       }
       image.isTouched = false;
       image.isMoved = false;
       let momentumDurationX = 300;
       let momentumDurationY = 300;
       const momentumDistanceX = velocity.x * momentumDurationX;
       const newPositionX = image.currentX + momentumDistanceX;
       const momentumDistanceY = velocity.y * momentumDurationY;
       const newPositionY = image.currentY + momentumDistanceY;
   
       // Fix duration
       if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
       if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
       const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
   
       image.currentX = newPositionX;
       image.currentY = newPositionY;
   
       // Define if we need image drag
       const scaledWidth = image.width * zoom.scale;
       const scaledHeight = image.height * zoom.scale;
       image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
       image.maxX = -image.minX;
       image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
       image.maxY = -image.minY;
       image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
       image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
   
       gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
     },
     onTransitionEnd() {
       const swiper = this;
       const zoom = swiper.zoom;
       const { gesture } = zoom;
       if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
         if (gesture.$imageEl) {
           gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
         }
         if (gesture.$imageWrapEl) {
           gesture.$imageWrapEl.transform('translate3d(0,0,0)');
         }
   
         zoom.scale = 1;
         zoom.currentScale = 1;
   
         gesture.$slideEl = undefined;
         gesture.$imageEl = undefined;
         gesture.$imageWrapEl = undefined;
       }
     },
     // Toggle Zoom
     toggle(e) {
       const swiper = this;
       const zoom = swiper.zoom;
   
       if (zoom.scale && zoom.scale !== 1) {
         // Zoom Out
         zoom.out();
       } else {
         // Zoom In
         zoom.in(e);
       }
     },
     in(e) {
       const swiper = this;
   
       const zoom = swiper.zoom;
       const params = swiper.params.zoom;
       const { gesture, image } = zoom;
   
       if (!gesture.$slideEl) {
         if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
           gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
         } else {
           gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
         }
         gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
         gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
       }
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
   
       gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
   
       let touchX;
       let touchY;
       let offsetX;
       let offsetY;
       let diffX;
       let diffY;
       let translateX;
       let translateY;
       let imageWidth;
       let imageHeight;
       let scaledWidth;
       let scaledHeight;
       let translateMinX;
       let translateMinY;
       let translateMaxX;
       let translateMaxY;
       let slideWidth;
       let slideHeight;
   
       if (typeof image.touchesStart.x === 'undefined' && e) {
         touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
         touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
       } else {
         touchX = image.touchesStart.x;
         touchY = image.touchesStart.y;
       }
   
       zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
       zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
       if (e) {
         slideWidth = gesture.$slideEl[0].offsetWidth;
         slideHeight = gesture.$slideEl[0].offsetHeight;
         offsetX = gesture.$slideEl.offset().left;
         offsetY = gesture.$slideEl.offset().top;
         diffX = (offsetX + (slideWidth / 2)) - touchX;
         diffY = (offsetY + (slideHeight / 2)) - touchY;
   
         imageWidth = gesture.$imageEl[0].offsetWidth;
         imageHeight = gesture.$imageEl[0].offsetHeight;
         scaledWidth = imageWidth * zoom.scale;
         scaledHeight = imageHeight * zoom.scale;
   
         translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
         translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
         translateMaxX = -translateMinX;
         translateMaxY = -translateMinY;
   
         translateX = diffX * zoom.scale;
         translateY = diffY * zoom.scale;
   
         if (translateX < translateMinX) {
           translateX = translateMinX;
         }
         if (translateX > translateMaxX) {
           translateX = translateMaxX;
         }
   
         if (translateY < translateMinY) {
           translateY = translateMinY;
         }
         if (translateY > translateMaxY) {
           translateY = translateMaxY;
         }
       } else {
         translateX = 0;
         translateY = 0;
       }
       gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
       gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
     },
     out() {
       const swiper = this;
   
       const zoom = swiper.zoom;
       const params = swiper.params.zoom;
       const { gesture } = zoom;
   
       if (!gesture.$slideEl) {
         if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
           gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
         } else {
           gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
         }
         gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target');
         gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
       }
       if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
   
       zoom.scale = 1;
       zoom.currentScale = 1;
       gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
       gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
       gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
       gesture.$slideEl = undefined;
     },
     // Attach/Detach Events
     enable() {
       const swiper = this;
       const zoom = swiper.zoom;
       if (zoom.enabled) return;
       zoom.enabled = true;
   
       const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
       const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;
   
       const slideSelector = `.${swiper.params.slideClass}`;
   
       // Scale image
       if (Support.gestures) {
         swiper.$wrapperEl.on('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
         swiper.$wrapperEl.on('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
         swiper.$wrapperEl.on('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
       } else if (swiper.touchEvents.start === 'touchstart') {
         swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
         swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
         swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
         if (swiper.touchEvents.cancel) {
           swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
         }
       }
   
       // Move image
       swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
     },
     disable() {
       const swiper = this;
       const zoom = swiper.zoom;
       if (!zoom.enabled) return;
   
       swiper.zoom.enabled = false;
   
       const passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
       const activeListenerWithCapture = Support.passiveListener ? { passive: false, capture: true } : true;
   
       const slideSelector = `.${swiper.params.slideClass}`;
   
       // Scale image
       if (Support.gestures) {
         swiper.$wrapperEl.off('gesturestart', slideSelector, zoom.onGestureStart, passiveListener);
         swiper.$wrapperEl.off('gesturechange', slideSelector, zoom.onGestureChange, passiveListener);
         swiper.$wrapperEl.off('gestureend', slideSelector, zoom.onGestureEnd, passiveListener);
       } else if (swiper.touchEvents.start === 'touchstart') {
         swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, zoom.onGestureStart, passiveListener);
         swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, zoom.onGestureChange, activeListenerWithCapture);
         swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, zoom.onGestureEnd, passiveListener);
         if (swiper.touchEvents.cancel) {
           swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, zoom.onGestureEnd, passiveListener);
         }
       }
   
       // Move image
       swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, zoom.onTouchMove, activeListenerWithCapture);
     },
   };
   
   var Zoom$1 = {
     name: 'zoom',
     params: {
       zoom: {
         enabled: false,
         maxRatio: 3,
         minRatio: 1,
         toggle: true,
         containerClass: 'swiper-zoom-container',
         zoomedSlideClass: 'swiper-slide-zoomed',
       },
     },
     create() {
       const swiper = this;
       const zoom = {
         enabled: false,
         scale: 1,
         currentScale: 1,
         isScaling: false,
         gesture: {
           $slideEl: undefined,
           slideWidth: undefined,
           slideHeight: undefined,
           $imageEl: undefined,
           $imageWrapEl: undefined,
           maxRatio: 3,
         },
         image: {
           isTouched: undefined,
           isMoved: undefined,
           currentX: undefined,
           currentY: undefined,
           minX: undefined,
           minY: undefined,
           maxX: undefined,
           maxY: undefined,
           width: undefined,
           height: undefined,
           startX: undefined,
           startY: undefined,
           touchesStart: {},
           touchesCurrent: {},
         },
         velocity: {
           x: undefined,
           y: undefined,
           prevPositionX: undefined,
           prevPositionY: undefined,
           prevTime: undefined,
         },
       };
   
       ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach((methodName) => {
         zoom[methodName] = Zoom[methodName].bind(swiper);
       });
       Utils.extend(swiper, {
         zoom,
       });
   
       let scale = 1;
       Object.defineProperty(swiper.zoom, 'scale', {
         get() {
           return scale;
         },
         set(value) {
           if (scale !== value) {
             const imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
             const slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
             swiper.emit('zoomChange', value, imageEl, slideEl);
           }
           scale = value;
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (swiper.params.zoom.enabled) {
           swiper.zoom.enable();
         }
       },
       destroy() {
         const swiper = this;
         swiper.zoom.disable();
       },
       touchStart(e) {
         const swiper = this;
         if (!swiper.zoom.enabled) return;
         swiper.zoom.onTouchStart(e);
       },
       touchEnd(e) {
         const swiper = this;
         if (!swiper.zoom.enabled) return;
         swiper.zoom.onTouchEnd(e);
       },
       doubleTap(e) {
         const swiper = this;
         if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
           swiper.zoom.toggle(e);
         }
       },
       transitionEnd() {
         const swiper = this;
         if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
           swiper.zoom.onTransitionEnd();
         }
       },
       slideChange() {
         const swiper = this;
         if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
           swiper.zoom.onTransitionEnd();
         }
       },
     },
   };
   
   const Lazy = {
     loadInSlide(index, loadInDuplicate = true) {
       const swiper = this;
       const params = swiper.params.lazy;
       if (typeof index === 'undefined') return;
       if (swiper.slides.length === 0) return;
       const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
   
       const $slideEl = isVirtual
         ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`)
         : swiper.slides.eq(index);
   
       let $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
       if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
         $images = $images.add($slideEl[0]);
       }
       if ($images.length === 0) return;
   
       $images.each((imageIndex, imageEl) => {
         const $imageEl = $(imageEl);
         $imageEl.addClass(params.loadingClass);
   
         const background = $imageEl.attr('data-background');
         const src = $imageEl.attr('data-src');
         const srcset = $imageEl.attr('data-srcset');
         const sizes = $imageEl.attr('data-sizes');
         const $pictureEl = $imageEl.parent('picture');
   
         swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, () => {
           if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) return;
           if (background) {
             $imageEl.css('background-image', `url("${background}")`);
             $imageEl.removeAttr('data-background');
           } else {
             if (srcset) {
               $imageEl.attr('srcset', srcset);
               $imageEl.removeAttr('data-srcset');
             }
             if (sizes) {
               $imageEl.attr('sizes', sizes);
               $imageEl.removeAttr('data-sizes');
             }
             if ($pictureEl.length) {
               $pictureEl.children('source').each((sourceIndex, sourceEl) => {
                 const $source = $(sourceEl);
   
                 if ($source.attr('data-srcset')) {
                   $source.attr('srcset', $source.attr('data-srcset'));
                   $source.removeAttr('data-srcset');
                 }
               });
             }
             if (src) {
               $imageEl.attr('src', src);
               $imageEl.removeAttr('data-src');
             }
           }
   
           $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
           $slideEl.find(`.${params.preloaderClass}`).remove();
           if (swiper.params.loop && loadInDuplicate) {
             const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
             if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
               const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
               swiper.lazy.loadInSlide(originalSlide.index(), false);
             } else {
               const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
               swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
             }
           }
           swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
           if (swiper.params.autoHeight) {
             swiper.updateAutoHeight();
           }
         });
   
         swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
       });
     },
     load() {
       const swiper = this;
       const {
         $wrapperEl, params: swiperParams, slides, activeIndex,
       } = swiper;
       const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
       const params = swiperParams.lazy;
   
       let slidesPerView = swiperParams.slidesPerView;
       if (slidesPerView === 'auto') {
         slidesPerView = 0;
       }
   
       function slideExist(index) {
         if (isVirtual) {
           if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
             return true;
           }
         } else if (slides[index]) return true;
         return false;
       }
   
       function slideIndex(slideEl) {
         if (isVirtual) {
           return $(slideEl).attr('data-swiper-slide-index');
         }
         return $(slideEl).index();
       }
   
       if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
       if (swiper.params.watchSlidesVisibility) {
         $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((elIndex, slideEl) => {
           const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
           swiper.lazy.loadInSlide(index);
         });
       } else if (slidesPerView > 1) {
         for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
           if (slideExist(i)) swiper.lazy.loadInSlide(i);
         }
       } else {
         swiper.lazy.loadInSlide(activeIndex);
       }
       if (params.loadPrevNext) {
         if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
           const amount = params.loadPrevNextAmount;
           const spv = slidesPerView;
           const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
           const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
           // Next Slides
           for (let i = activeIndex + slidesPerView; i < maxIndex; i += 1) {
             if (slideExist(i)) swiper.lazy.loadInSlide(i);
           }
           // Prev Slides
           for (let i = minIndex; i < activeIndex; i += 1) {
             if (slideExist(i)) swiper.lazy.loadInSlide(i);
           }
         } else {
           const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
           if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));
   
           const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
           if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
         }
       }
     },
   };
   
   var Lazy$1 = {
     name: 'lazy',
     params: {
       lazy: {
         enabled: false,
         loadPrevNext: false,
         loadPrevNextAmount: 1,
         loadOnTransitionStart: false,
   
         elementClass: 'swiper-lazy',
         loadingClass: 'swiper-lazy-loading',
         loadedClass: 'swiper-lazy-loaded',
         preloaderClass: 'swiper-lazy-preloader',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         lazy: {
           initialImageLoaded: false,
           load: Lazy.load.bind(swiper),
           loadInSlide: Lazy.loadInSlide.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
           swiper.params.preloadImages = false;
         }
       },
       init() {
         const swiper = this;
         if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
           swiper.lazy.load();
         }
       },
       scroll() {
         const swiper = this;
         if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
           swiper.lazy.load();
         }
       },
       resize() {
         const swiper = this;
         if (swiper.params.lazy.enabled) {
           swiper.lazy.load();
         }
       },
       scrollbarDragMove() {
         const swiper = this;
         if (swiper.params.lazy.enabled) {
           swiper.lazy.load();
         }
       },
       transitionStart() {
         const swiper = this;
         if (swiper.params.lazy.enabled) {
           if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
             swiper.lazy.load();
           }
         }
       },
       transitionEnd() {
         const swiper = this;
         if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
           swiper.lazy.load();
         }
       },
       slideChange() {
         const swiper = this;
         if (swiper.params.lazy.enabled && swiper.params.cssMode) {
           swiper.lazy.load();
         }
       },
     },
   };
   
   /* eslint no-bitwise: ["error", { "allow": [">>"] }] */
   
   const Controller = {
     LinearSpline: function LinearSpline(x, y) {
       const binarySearch = (function search() {
         let maxIndex;
         let minIndex;
         let guess;
         return (array, val) => {
           minIndex = -1;
           maxIndex = array.length;
           while (maxIndex - minIndex > 1) {
             guess = maxIndex + minIndex >> 1;
             if (array[guess] <= val) {
               minIndex = guess;
             } else {
               maxIndex = guess;
             }
           }
           return maxIndex;
         };
       }());
       this.x = x;
       this.y = y;
       this.lastIndex = x.length - 1;
       // Given an x value (x2), return the expected y2 value:
       // (x1,y1) is the known point before given value,
       // (x3,y3) is the known point after given value.
       let i1;
       let i3;
   
       this.interpolate = function interpolate(x2) {
         if (!x2) return 0;
   
         // Get the indexes of x1 and x3 (the array indexes before and after given x2):
         i3 = binarySearch(this.x, x2);
         i1 = i3 - 1;
   
         // We have our indexes i1 & i3, so we can calculate already:
         // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
         return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
       };
       return this;
     },
     // xxx: for now i will just save one spline function to to
     getInterpolateFunction(c) {
       const swiper = this;
       if (!swiper.controller.spline) {
         swiper.controller.spline = swiper.params.loop
           ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
           : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
       }
     },
     setTranslate(setTranslate, byController) {
       const swiper = this;
       const controlled = swiper.controller.control;
       let multiplier;
       let controlledTranslate;
       function setControlledTranslate(c) {
         // this will create an Interpolate function based on the snapGrids
         // x is the Grid of the scrolled scroller and y will be the controlled scroller
         // it makes sense to create this only once and recall it for the interpolation
         // the function does a lot of value caching for performance
         const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
         if (swiper.params.controller.by === 'slide') {
           swiper.controller.getInterpolateFunction(c);
           // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
           // but it did not work out
           controlledTranslate = -swiper.controller.spline.interpolate(-translate);
         }
   
         if (!controlledTranslate || swiper.params.controller.by === 'container') {
           multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
           controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
         }
   
         if (swiper.params.controller.inverse) {
           controlledTranslate = c.maxTranslate() - controlledTranslate;
         }
         c.updateProgress(controlledTranslate);
         c.setTranslate(controlledTranslate, swiper);
         c.updateActiveIndex();
         c.updateSlidesClasses();
       }
       if (Array.isArray(controlled)) {
         for (let i = 0; i < controlled.length; i += 1) {
           if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
             setControlledTranslate(controlled[i]);
           }
         }
       } else if (controlled instanceof Swiper && byController !== controlled) {
         setControlledTranslate(controlled);
       }
     },
     setTransition(duration, byController) {
       const swiper = this;
       const controlled = swiper.controller.control;
       let i;
       function setControlledTransition(c) {
         c.setTransition(duration, swiper);
         if (duration !== 0) {
           c.transitionStart();
           if (c.params.autoHeight) {
             Utils.nextTick(() => {
               c.updateAutoHeight();
             });
           }
           c.$wrapperEl.transitionEnd(() => {
             if (!controlled) return;
             if (c.params.loop && swiper.params.controller.by === 'slide') {
               c.loopFix();
             }
             c.transitionEnd();
           });
         }
       }
       if (Array.isArray(controlled)) {
         for (i = 0; i < controlled.length; i += 1) {
           if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
             setControlledTransition(controlled[i]);
           }
         }
       } else if (controlled instanceof Swiper && byController !== controlled) {
         setControlledTransition(controlled);
       }
     },
   };
   var Controller$1 = {
     name: 'controller',
     params: {
       controller: {
         control: undefined,
         inverse: false,
         by: 'slide', // or 'container'
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         controller: {
           control: swiper.params.controller.control,
           getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
           setTranslate: Controller.setTranslate.bind(swiper),
           setTransition: Controller.setTransition.bind(swiper),
         },
       });
     },
     on: {
       update() {
         const swiper = this;
         if (!swiper.controller.control) return;
         if (swiper.controller.spline) {
           swiper.controller.spline = undefined;
           delete swiper.controller.spline;
         }
       },
       resize() {
         const swiper = this;
         if (!swiper.controller.control) return;
         if (swiper.controller.spline) {
           swiper.controller.spline = undefined;
           delete swiper.controller.spline;
         }
       },
       observerUpdate() {
         const swiper = this;
         if (!swiper.controller.control) return;
         if (swiper.controller.spline) {
           swiper.controller.spline = undefined;
           delete swiper.controller.spline;
         }
       },
       setTranslate(translate, byController) {
         const swiper = this;
         if (!swiper.controller.control) return;
         swiper.controller.setTranslate(translate, byController);
       },
       setTransition(duration, byController) {
         const swiper = this;
         if (!swiper.controller.control) return;
         swiper.controller.setTransition(duration, byController);
       },
     },
   };
   
   const a11y = {
     makeElFocusable($el) {
       $el.attr('tabIndex', '0');
       return $el;
     },
     makeElNotFocusable($el) {
       $el.attr('tabIndex', '-1');
       return $el;
     },
     addElRole($el, role) {
       $el.attr('role', role);
       return $el;
     },
     addElLabel($el, label) {
       $el.attr('aria-label', label);
       return $el;
     },
     disableEl($el) {
       $el.attr('aria-disabled', true);
       return $el;
     },
     enableEl($el) {
       $el.attr('aria-disabled', false);
       return $el;
     },
     onEnterKey(e) {
       const swiper = this;
       const params = swiper.params.a11y;
       if (e.keyCode !== 13) return;
       const $targetEl = $(e.target);
       if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
         if (!(swiper.isEnd && !swiper.params.loop)) {
           swiper.slideNext();
         }
         if (swiper.isEnd) {
           swiper.a11y.notify(params.lastSlideMessage);
         } else {
           swiper.a11y.notify(params.nextSlideMessage);
         }
       }
       if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
         if (!(swiper.isBeginning && !swiper.params.loop)) {
           swiper.slidePrev();
         }
         if (swiper.isBeginning) {
           swiper.a11y.notify(params.firstSlideMessage);
         } else {
           swiper.a11y.notify(params.prevSlideMessage);
         }
       }
       if (swiper.pagination && $targetEl.is(`.${swiper.params.pagination.bulletClass}`)) {
         $targetEl[0].click();
       }
     },
     notify(message) {
       const swiper = this;
       const notification = swiper.a11y.liveRegion;
       if (notification.length === 0) return;
       notification.html('');
       notification.html(message);
     },
     updateNavigation() {
       const swiper = this;
   
       if (swiper.params.loop || !swiper.navigation) return;
       const { $nextEl, $prevEl } = swiper.navigation;
   
       if ($prevEl && $prevEl.length > 0) {
         if (swiper.isBeginning) {
           swiper.a11y.disableEl($prevEl);
           swiper.a11y.makeElNotFocusable($prevEl);
         } else {
           swiper.a11y.enableEl($prevEl);
           swiper.a11y.makeElFocusable($prevEl);
         }
       }
       if ($nextEl && $nextEl.length > 0) {
         if (swiper.isEnd) {
           swiper.a11y.disableEl($nextEl);
           swiper.a11y.makeElNotFocusable($nextEl);
         } else {
           swiper.a11y.enableEl($nextEl);
           swiper.a11y.makeElFocusable($nextEl);
         }
       }
     },
     updatePagination() {
       const swiper = this;
       const params = swiper.params.a11y;
       if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
         swiper.pagination.bullets.each((bulletIndex, bulletEl) => {
           const $bulletEl = $(bulletEl);
           swiper.a11y.makeElFocusable($bulletEl);
           swiper.a11y.addElRole($bulletEl, 'button');
           swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
         });
       }
     },
     init() {
       const swiper = this;
   
       swiper.$el.append(swiper.a11y.liveRegion);
   
       // Navigation
       const params = swiper.params.a11y;
       let $nextEl;
       let $prevEl;
       if (swiper.navigation && swiper.navigation.$nextEl) {
         $nextEl = swiper.navigation.$nextEl;
       }
       if (swiper.navigation && swiper.navigation.$prevEl) {
         $prevEl = swiper.navigation.$prevEl;
       }
       if ($nextEl) {
         swiper.a11y.makeElFocusable($nextEl);
         swiper.a11y.addElRole($nextEl, 'button');
         swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
         $nextEl.on('keydown', swiper.a11y.onEnterKey);
       }
       if ($prevEl) {
         swiper.a11y.makeElFocusable($prevEl);
         swiper.a11y.addElRole($prevEl, 'button');
         swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
         $prevEl.on('keydown', swiper.a11y.onEnterKey);
       }
   
       // Pagination
       if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
         swiper.pagination.$el.on('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
       }
     },
     destroy() {
       const swiper = this;
       if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
   
       let $nextEl;
       let $prevEl;
       if (swiper.navigation && swiper.navigation.$nextEl) {
         $nextEl = swiper.navigation.$nextEl;
       }
       if (swiper.navigation && swiper.navigation.$prevEl) {
         $prevEl = swiper.navigation.$prevEl;
       }
       if ($nextEl) {
         $nextEl.off('keydown', swiper.a11y.onEnterKey);
       }
       if ($prevEl) {
         $prevEl.off('keydown', swiper.a11y.onEnterKey);
       }
   
       // Pagination
       if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
         swiper.pagination.$el.off('keydown', `.${swiper.params.pagination.bulletClass}`, swiper.a11y.onEnterKey);
       }
     },
   };
   var A11y = {
     name: 'a11y',
     params: {
       a11y: {
         enabled: true,
         notificationClass: 'swiper-notification',
         prevSlideMessage: 'Previous slide',
         nextSlideMessage: 'Next slide',
         firstSlideMessage: 'This is the first slide',
         lastSlideMessage: 'This is the last slide',
         paginationBulletMessage: 'Go to slide {{index}}',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         a11y: {
           liveRegion: $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`),
         },
       });
       Object.keys(a11y).forEach((methodName) => {
         swiper.a11y[methodName] = a11y[methodName].bind(swiper);
       });
     },
     on: {
       init() {
         const swiper = this;
         if (!swiper.params.a11y.enabled) return;
         swiper.a11y.init();
         swiper.a11y.updateNavigation();
       },
       toEdge() {
         const swiper = this;
         if (!swiper.params.a11y.enabled) return;
         swiper.a11y.updateNavigation();
       },
       fromEdge() {
         const swiper = this;
         if (!swiper.params.a11y.enabled) return;
         swiper.a11y.updateNavigation();
       },
       paginationUpdate() {
         const swiper = this;
         if (!swiper.params.a11y.enabled) return;
         swiper.a11y.updatePagination();
       },
       destroy() {
         const swiper = this;
         if (!swiper.params.a11y.enabled) return;
         swiper.a11y.destroy();
       },
     },
   };
   
   const History = {
     init() {
       const swiper = this;
       if (!swiper.params.history) return;
       if (!win.history || !win.history.pushState) {
         swiper.params.history.enabled = false;
         swiper.params.hashNavigation.enabled = true;
         return;
       }
       const history = swiper.history;
       history.initialized = true;
       history.paths = History.getPathValues();
       if (!history.paths.key && !history.paths.value) return;
       history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
       if (!swiper.params.history.replaceState) {
         win.addEventListener('popstate', swiper.history.setHistoryPopState);
       }
     },
     destroy() {
       const swiper = this;
       if (!swiper.params.history.replaceState) {
         win.removeEventListener('popstate', swiper.history.setHistoryPopState);
       }
     },
     setHistoryPopState() {
       const swiper = this;
       swiper.history.paths = History.getPathValues();
       swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
     },
     getPathValues() {
       const pathArray = win.location.pathname.slice(1).split('/').filter((part) => part !== '');
       const total = pathArray.length;
       const key = pathArray[total - 2];
       const value = pathArray[total - 1];
       return { key, value };
     },
     setHistory(key, index) {
       const swiper = this;
       if (!swiper.history.initialized || !swiper.params.history.enabled) return;
       const slide = swiper.slides.eq(index);
       let value = History.slugify(slide.attr('data-history'));
       if (!win.location.pathname.includes(key)) {
         value = `${key}/${value}`;
       }
       const currentState = win.history.state;
       if (currentState && currentState.value === value) {
         return;
       }
       if (swiper.params.history.replaceState) {
         win.history.replaceState({ value }, null, value);
       } else {
         win.history.pushState({ value }, null, value);
       }
     },
     slugify(text) {
       return text.toString()
         .replace(/\s+/g, '-')
         .replace(/[^\w-]+/g, '')
         .replace(/--+/g, '-')
         .replace(/^-+/, '')
         .replace(/-+$/, '');
     },
     scrollToSlide(speed, value, runCallbacks) {
       const swiper = this;
       if (value) {
         for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
           const slide = swiper.slides.eq(i);
           const slideHistory = History.slugify(slide.attr('data-history'));
           if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
             const index = slide.index();
             swiper.slideTo(index, speed, runCallbacks);
           }
         }
       } else {
         swiper.slideTo(0, speed, runCallbacks);
       }
     },
   };
   
   var History$1 = {
     name: 'history',
     params: {
       history: {
         enabled: false,
         replaceState: false,
         key: 'slides',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         history: {
           init: History.init.bind(swiper),
           setHistory: History.setHistory.bind(swiper),
           setHistoryPopState: History.setHistoryPopState.bind(swiper),
           scrollToSlide: History.scrollToSlide.bind(swiper),
           destroy: History.destroy.bind(swiper),
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (swiper.params.history.enabled) {
           swiper.history.init();
         }
       },
       destroy() {
         const swiper = this;
         if (swiper.params.history.enabled) {
           swiper.history.destroy();
         }
       },
       transitionEnd() {
         const swiper = this;
         if (swiper.history.initialized) {
           swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
         }
       },
       slideChange() {
         const swiper = this;
         if (swiper.history.initialized && swiper.params.cssMode) {
           swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
         }
       },
     },
   };
   
   const HashNavigation = {
     onHashCange() {
       const swiper = this;
       swiper.emit('hashChange');
       const newHash = doc.location.hash.replace('#', '');
       const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
       if (newHash !== activeSlideHash) {
         const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
         if (typeof newIndex === 'undefined') return;
         swiper.slideTo(newIndex);
       }
     },
     setHash() {
       const swiper = this;
       if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
       if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
         win.history.replaceState(null, null, (`#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || ''));
         swiper.emit('hashSet');
       } else {
         const slide = swiper.slides.eq(swiper.activeIndex);
         const hash = slide.attr('data-hash') || slide.attr('data-history');
         doc.location.hash = hash || '';
         swiper.emit('hashSet');
       }
     },
     init() {
       const swiper = this;
       if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) return;
       swiper.hashNavigation.initialized = true;
       const hash = doc.location.hash.replace('#', '');
       if (hash) {
         const speed = 0;
         for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
           const slide = swiper.slides.eq(i);
           const slideHash = slide.attr('data-hash') || slide.attr('data-history');
           if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
             const index = slide.index();
             swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
           }
         }
       }
       if (swiper.params.hashNavigation.watchState) {
         $(win).on('hashchange', swiper.hashNavigation.onHashCange);
       }
     },
     destroy() {
       const swiper = this;
       if (swiper.params.hashNavigation.watchState) {
         $(win).off('hashchange', swiper.hashNavigation.onHashCange);
       }
     },
   };
   var HashNavigation$1 = {
     name: 'hash-navigation',
     params: {
       hashNavigation: {
         enabled: false,
         replaceState: false,
         watchState: false,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         hashNavigation: {
           initialized: false,
           init: HashNavigation.init.bind(swiper),
           destroy: HashNavigation.destroy.bind(swiper),
           setHash: HashNavigation.setHash.bind(swiper),
           onHashCange: HashNavigation.onHashCange.bind(swiper),
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (swiper.params.hashNavigation.enabled) {
           swiper.hashNavigation.init();
         }
       },
       destroy() {
         const swiper = this;
         if (swiper.params.hashNavigation.enabled) {
           swiper.hashNavigation.destroy();
         }
       },
       transitionEnd() {
         const swiper = this;
         if (swiper.hashNavigation.initialized) {
           swiper.hashNavigation.setHash();
         }
       },
       slideChange() {
         const swiper = this;
         if (swiper.hashNavigation.initialized && swiper.params.cssMode) {
           swiper.hashNavigation.setHash();
         }
       },
     },
   };
   
   /* eslint no-underscore-dangle: "off" */
   
   const Autoplay = {
     run() {
       const swiper = this;
       const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
       let delay = swiper.params.autoplay.delay;
       if ($activeSlideEl.attr('data-swiper-autoplay')) {
         delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
       }
       clearTimeout(swiper.autoplay.timeout);
       swiper.autoplay.timeout = Utils.nextTick(() => {
         if (swiper.params.autoplay.reverseDirection) {
           if (swiper.params.loop) {
             swiper.loopFix();
             swiper.slidePrev(swiper.params.speed, true, true);
             swiper.emit('autoplay');
           } else if (!swiper.isBeginning) {
             swiper.slidePrev(swiper.params.speed, true, true);
             swiper.emit('autoplay');
           } else if (!swiper.params.autoplay.stopOnLastSlide) {
             swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
             swiper.emit('autoplay');
           } else {
             swiper.autoplay.stop();
           }
         } else if (swiper.params.loop) {
           swiper.loopFix();
           swiper.slideNext(swiper.params.speed, true, true);
           swiper.emit('autoplay');
         } else if (!swiper.isEnd) {
           swiper.slideNext(swiper.params.speed, true, true);
           swiper.emit('autoplay');
         } else if (!swiper.params.autoplay.stopOnLastSlide) {
           swiper.slideTo(0, swiper.params.speed, true, true);
           swiper.emit('autoplay');
         } else {
           swiper.autoplay.stop();
         }
         if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
       }, delay);
     },
     start() {
       const swiper = this;
       if (typeof swiper.autoplay.timeout !== 'undefined') return false;
       if (swiper.autoplay.running) return false;
       swiper.autoplay.running = true;
       swiper.emit('autoplayStart');
       swiper.autoplay.run();
       return true;
     },
     stop() {
       const swiper = this;
       if (!swiper.autoplay.running) return false;
       if (typeof swiper.autoplay.timeout === 'undefined') return false;
   
       if (swiper.autoplay.timeout) {
         clearTimeout(swiper.autoplay.timeout);
         swiper.autoplay.timeout = undefined;
       }
       swiper.autoplay.running = false;
       swiper.emit('autoplayStop');
       return true;
     },
     pause(speed) {
       const swiper = this;
       if (!swiper.autoplay.running) return;
       if (swiper.autoplay.paused) return;
       if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
       swiper.autoplay.paused = true;
       if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
         swiper.autoplay.paused = false;
         swiper.autoplay.run();
       } else {
         swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
         swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
       }
     },
   };
   
   var Autoplay$1 = {
     name: 'autoplay',
     params: {
       autoplay: {
         enabled: false,
         delay: 3000,
         waitForTransition: true,
         disableOnInteraction: true,
         stopOnLastSlide: false,
         reverseDirection: false,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         autoplay: {
           running: false,
           paused: false,
           run: Autoplay.run.bind(swiper),
           start: Autoplay.start.bind(swiper),
           stop: Autoplay.stop.bind(swiper),
           pause: Autoplay.pause.bind(swiper),
           onVisibilityChange() {
             if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
               swiper.autoplay.pause();
             }
             if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
               swiper.autoplay.run();
               swiper.autoplay.paused = false;
             }
           },
           onTransitionEnd(e) {
             if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
             if (e.target !== this) return;
             swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
             swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
             swiper.autoplay.paused = false;
             if (!swiper.autoplay.running) {
               swiper.autoplay.stop();
             } else {
               swiper.autoplay.run();
             }
           },
         },
       });
     },
     on: {
       init() {
         const swiper = this;
         if (swiper.params.autoplay.enabled) {
           swiper.autoplay.start();
           document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
         }
       },
       beforeTransitionStart(speed, internal) {
         const swiper = this;
         if (swiper.autoplay.running) {
           if (internal || !swiper.params.autoplay.disableOnInteraction) {
             swiper.autoplay.pause(speed);
           } else {
             swiper.autoplay.stop();
           }
         }
       },
       sliderFirstMove() {
         const swiper = this;
         if (swiper.autoplay.running) {
           if (swiper.params.autoplay.disableOnInteraction) {
             swiper.autoplay.stop();
           } else {
             swiper.autoplay.pause();
           }
         }
       },
       touchEnd() {
         const swiper = this;
         if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
           swiper.autoplay.run();
         }
       },
       destroy() {
         const swiper = this;
         if (swiper.autoplay.running) {
           swiper.autoplay.stop();
         }
         document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
       },
     },
   };
   
   const Fade = {
     setTranslate() {
       const swiper = this;
       const { slides } = swiper;
       for (let i = 0; i < slides.length; i += 1) {
         const $slideEl = swiper.slides.eq(i);
         const offset = $slideEl[0].swiperSlideOffset;
         let tx = -offset;
         if (!swiper.params.virtualTranslate) tx -= swiper.translate;
         let ty = 0;
         if (!swiper.isHorizontal()) {
           ty = tx;
           tx = 0;
         }
         const slideOpacity = swiper.params.fadeEffect.crossFade
           ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
           : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
         $slideEl
           .css({
             opacity: slideOpacity,
           })
           .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
       }
     },
     setTransition(duration) {
       const swiper = this;
       const { slides, $wrapperEl } = swiper;
       slides.transition(duration);
       if (swiper.params.virtualTranslate && duration !== 0) {
         let eventTriggered = false;
         slides.transitionEnd(() => {
           if (eventTriggered) return;
           if (!swiper || swiper.destroyed) return;
           eventTriggered = true;
           swiper.animating = false;
           const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
           for (let i = 0; i < triggerEvents.length; i += 1) {
             $wrapperEl.trigger(triggerEvents[i]);
           }
         });
       }
     },
   };
   
   var EffectFade = {
     name: 'effect-fade',
     params: {
       fadeEffect: {
         crossFade: false,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         fadeEffect: {
           setTranslate: Fade.setTranslate.bind(swiper),
           setTransition: Fade.setTransition.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (swiper.params.effect !== 'fade') return;
         swiper.classNames.push(`${swiper.params.containerModifierClass}fade`);
         const overwriteParams = {
           slidesPerView: 1,
           slidesPerColumn: 1,
           slidesPerGroup: 1,
           watchSlidesProgress: true,
           spaceBetween: 0,
           virtualTranslate: true,
         };
         Utils.extend(swiper.params, overwriteParams);
         Utils.extend(swiper.originalParams, overwriteParams);
       },
       setTranslate() {
         const swiper = this;
         if (swiper.params.effect !== 'fade') return;
         swiper.fadeEffect.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         if (swiper.params.effect !== 'fade') return;
         swiper.fadeEffect.setTransition(duration);
       },
     },
   };
   
   const Cube = {
     setTranslate() {
       const swiper = this;
       const {
         $el, $wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize,
       } = swiper;
       const params = swiper.params.cubeEffect;
       const isHorizontal = swiper.isHorizontal();
       const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
       let wrapperRotate = 0;
       let $cubeShadowEl;
       if (params.shadow) {
         if (isHorizontal) {
           $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
           if ($cubeShadowEl.length === 0) {
             $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
             $wrapperEl.append($cubeShadowEl);
           }
           $cubeShadowEl.css({ height: `${swiperWidth}px` });
         } else {
           $cubeShadowEl = $el.find('.swiper-cube-shadow');
           if ($cubeShadowEl.length === 0) {
             $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
             $el.append($cubeShadowEl);
           }
         }
       }
       for (let i = 0; i < slides.length; i += 1) {
         const $slideEl = slides.eq(i);
         let slideIndex = i;
         if (isVirtual) {
           slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
         }
         let slideAngle = slideIndex * 90;
         let round = Math.floor(slideAngle / 360);
         if (rtl) {
           slideAngle = -slideAngle;
           round = Math.floor(-slideAngle / 360);
         }
         const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
         let tx = 0;
         let ty = 0;
         let tz = 0;
         if (slideIndex % 4 === 0) {
           tx = -round * 4 * swiperSize;
           tz = 0;
         } else if ((slideIndex - 1) % 4 === 0) {
           tx = 0;
           tz = -round * 4 * swiperSize;
         } else if ((slideIndex - 2) % 4 === 0) {
           tx = swiperSize + (round * 4 * swiperSize);
           tz = swiperSize;
         } else if ((slideIndex - 3) % 4 === 0) {
           tx = -swiperSize;
           tz = (3 * swiperSize) + (swiperSize * 4 * round);
         }
         if (rtl) {
           tx = -tx;
         }
   
         if (!isHorizontal) {
           ty = tx;
           tx = 0;
         }
   
         const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
         if (progress <= 1 && progress > -1) {
           wrapperRotate = (slideIndex * 90) + (progress * 90);
           if (rtl) wrapperRotate = (-slideIndex * 90) - (progress * 90);
         }
         $slideEl.transform(transform);
         if (params.slideShadows) {
           // Set shadows
           let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
           let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
           if (shadowBefore.length === 0) {
             shadowBefore = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
             $slideEl.append(shadowBefore);
           }
           if (shadowAfter.length === 0) {
             shadowAfter = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
             $slideEl.append(shadowAfter);
           }
           if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
           if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
         }
       }
       $wrapperEl.css({
         '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
         '-moz-transform-origin': `50% 50% -${swiperSize / 2}px`,
         '-ms-transform-origin': `50% 50% -${swiperSize / 2}px`,
         'transform-origin': `50% 50% -${swiperSize / 2}px`,
       });
   
       if (params.shadow) {
         if (isHorizontal) {
           $cubeShadowEl.transform(`translate3d(0px, ${(swiperWidth / 2) + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
         } else {
           const shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
           const multiplier = 1.5 - (
             (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
             + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
           );
           const scale1 = params.shadowScale;
           const scale2 = params.shadowScale / multiplier;
           const offset = params.shadowOffset;
           $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${(swiperHeight / 2) + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
         }
       }
       const zFactor = (Browser.isSafari || Browser.isWebView) ? (-swiperSize / 2) : 0;
       $wrapperEl
         .transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
     },
     setTransition(duration) {
       const swiper = this;
       const { $el, slides } = swiper;
       slides
         .transition(duration)
         .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
         .transition(duration);
       if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
         $el.find('.swiper-cube-shadow').transition(duration);
       }
     },
   };
   
   var EffectCube = {
     name: 'effect-cube',
     params: {
       cubeEffect: {
         slideShadows: true,
         shadow: true,
         shadowOffset: 20,
         shadowScale: 0.94,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         cubeEffect: {
           setTranslate: Cube.setTranslate.bind(swiper),
           setTransition: Cube.setTransition.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (swiper.params.effect !== 'cube') return;
         swiper.classNames.push(`${swiper.params.containerModifierClass}cube`);
         swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
         const overwriteParams = {
           slidesPerView: 1,
           slidesPerColumn: 1,
           slidesPerGroup: 1,
           watchSlidesProgress: true,
           resistanceRatio: 0,
           spaceBetween: 0,
           centeredSlides: false,
           virtualTranslate: true,
         };
         Utils.extend(swiper.params, overwriteParams);
         Utils.extend(swiper.originalParams, overwriteParams);
       },
       setTranslate() {
         const swiper = this;
         if (swiper.params.effect !== 'cube') return;
         swiper.cubeEffect.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         if (swiper.params.effect !== 'cube') return;
         swiper.cubeEffect.setTransition(duration);
       },
     },
   };
   
   const Flip = {
     setTranslate() {
       const swiper = this;
       const { slides, rtlTranslate: rtl } = swiper;
       for (let i = 0; i < slides.length; i += 1) {
         const $slideEl = slides.eq(i);
         let progress = $slideEl[0].progress;
         if (swiper.params.flipEffect.limitRotation) {
           progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
         }
         const offset = $slideEl[0].swiperSlideOffset;
         const rotate = -180 * progress;
         let rotateY = rotate;
         let rotateX = 0;
         let tx = -offset;
         let ty = 0;
         if (!swiper.isHorizontal()) {
           ty = tx;
           tx = 0;
           rotateX = -rotateY;
           rotateY = 0;
         } else if (rtl) {
           rotateY = -rotateY;
         }
   
         $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
   
         if (swiper.params.flipEffect.slideShadows) {
           // Set shadows
           let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
           let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
           if (shadowBefore.length === 0) {
             shadowBefore = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'left' : 'top'}"></div>`);
             $slideEl.append(shadowBefore);
           }
           if (shadowAfter.length === 0) {
             shadowAfter = $(`<div class="swiper-slide-shadow-${swiper.isHorizontal() ? 'right' : 'bottom'}"></div>`);
             $slideEl.append(shadowAfter);
           }
           if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
           if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
         }
         $slideEl
           .transform(`translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`);
       }
     },
     setTransition(duration) {
       const swiper = this;
       const { slides, activeIndex, $wrapperEl } = swiper;
       slides
         .transition(duration)
         .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
         .transition(duration);
       if (swiper.params.virtualTranslate && duration !== 0) {
         let eventTriggered = false;
         // eslint-disable-next-line
         slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
           if (eventTriggered) return;
           if (!swiper || swiper.destroyed) return;
           // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
           eventTriggered = true;
           swiper.animating = false;
           const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
           for (let i = 0; i < triggerEvents.length; i += 1) {
             $wrapperEl.trigger(triggerEvents[i]);
           }
         });
       }
     },
   };
   
   var EffectFlip = {
     name: 'effect-flip',
     params: {
       flipEffect: {
         slideShadows: true,
         limitRotation: true,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         flipEffect: {
           setTranslate: Flip.setTranslate.bind(swiper),
           setTransition: Flip.setTransition.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (swiper.params.effect !== 'flip') return;
         swiper.classNames.push(`${swiper.params.containerModifierClass}flip`);
         swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
         const overwriteParams = {
           slidesPerView: 1,
           slidesPerColumn: 1,
           slidesPerGroup: 1,
           watchSlidesProgress: true,
           spaceBetween: 0,
           virtualTranslate: true,
         };
         Utils.extend(swiper.params, overwriteParams);
         Utils.extend(swiper.originalParams, overwriteParams);
       },
       setTranslate() {
         const swiper = this;
         if (swiper.params.effect !== 'flip') return;
         swiper.flipEffect.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         if (swiper.params.effect !== 'flip') return;
         swiper.flipEffect.setTransition(duration);
       },
     },
   };
   
   const Coverflow = {
     setTranslate() {
       const swiper = this;
       const {
         width: swiperWidth, height: swiperHeight, slides, $wrapperEl, slidesSizesGrid,
       } = swiper;
       const params = swiper.params.coverflowEffect;
       const isHorizontal = swiper.isHorizontal();
       const transform = swiper.translate;
       const center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
       const rotate = isHorizontal ? params.rotate : -params.rotate;
       const translate = params.depth;
       // Each slide offset from center
       for (let i = 0, length = slides.length; i < length; i += 1) {
         const $slideEl = slides.eq(i);
         const slideSize = slidesSizesGrid[i];
         const slideOffset = $slideEl[0].swiperSlideOffset;
         const offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
   
         let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
         let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
         // var rotateZ = 0
         let translateZ = -translate * Math.abs(offsetMultiplier);
   
         let stretch = params.stretch;
         // Allow percentage to make a relative stretch for responsive sliders
         if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
           stretch = ((parseFloat(params.stretch) / 100) * slideSize);
         }
         let translateY = isHorizontal ? 0 : stretch * (offsetMultiplier);
         let translateX = isHorizontal ? stretch * (offsetMultiplier) : 0;
   
         let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
   
         // Fix for ultra small values
         if (Math.abs(translateX) < 0.001) translateX = 0;
         if (Math.abs(translateY) < 0.001) translateY = 0;
         if (Math.abs(translateZ) < 0.001) translateZ = 0;
         if (Math.abs(rotateY) < 0.001) rotateY = 0;
         if (Math.abs(rotateX) < 0.001) rotateX = 0;
         if (Math.abs(scale) < 0.001) scale = 0;
   
         const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
   
         $slideEl.transform(slideTransform);
         $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
         if (params.slideShadows) {
           // Set shadows
           let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
           let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
           if ($shadowBeforeEl.length === 0) {
             $shadowBeforeEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
             $slideEl.append($shadowBeforeEl);
           }
           if ($shadowAfterEl.length === 0) {
             $shadowAfterEl = $(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
             $slideEl.append($shadowAfterEl);
           }
           if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
           if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
         }
       }
   
       // Set correct perspective for IE10
       if (Support.pointerEvents || Support.prefixedPointerEvents) {
         const ws = $wrapperEl[0].style;
         ws.perspectiveOrigin = `${center}px 50%`;
       }
     },
     setTransition(duration) {
       const swiper = this;
       swiper.slides
         .transition(duration)
         .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
         .transition(duration);
     },
   };
   
   var EffectCoverflow = {
     name: 'effect-coverflow',
     params: {
       coverflowEffect: {
         rotate: 50,
         stretch: 0,
         depth: 100,
         scale: 1,
         modifier: 1,
         slideShadows: true,
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         coverflowEffect: {
           setTranslate: Coverflow.setTranslate.bind(swiper),
           setTransition: Coverflow.setTransition.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         if (swiper.params.effect !== 'coverflow') return;
   
         swiper.classNames.push(`${swiper.params.containerModifierClass}coverflow`);
         swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
   
         swiper.params.watchSlidesProgress = true;
         swiper.originalParams.watchSlidesProgress = true;
       },
       setTranslate() {
         const swiper = this;
         if (swiper.params.effect !== 'coverflow') return;
         swiper.coverflowEffect.setTranslate();
       },
       setTransition(duration) {
         const swiper = this;
         if (swiper.params.effect !== 'coverflow') return;
         swiper.coverflowEffect.setTransition(duration);
       },
     },
   };
   
   const Thumbs = {
     init() {
       const swiper = this;
       const { thumbs: thumbsParams } = swiper.params;
       const SwiperClass = swiper.constructor;
       if (thumbsParams.swiper instanceof SwiperClass) {
         swiper.thumbs.swiper = thumbsParams.swiper;
         Utils.extend(swiper.thumbs.swiper.originalParams, {
           watchSlidesProgress: true,
           slideToClickedSlide: false,
         });
         Utils.extend(swiper.thumbs.swiper.params, {
           watchSlidesProgress: true,
           slideToClickedSlide: false,
         });
       } else if (Utils.isObject(thumbsParams.swiper)) {
         swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
           watchSlidesVisibility: true,
           watchSlidesProgress: true,
           slideToClickedSlide: false,
         }));
         swiper.thumbs.swiperCreated = true;
       }
       swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
       swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
     },
     onThumbClick() {
       const swiper = this;
       const thumbsSwiper = swiper.thumbs.swiper;
       if (!thumbsSwiper) return;
       const clickedIndex = thumbsSwiper.clickedIndex;
       const clickedSlide = thumbsSwiper.clickedSlide;
       if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
       if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
       let slideToIndex;
       if (thumbsSwiper.params.loop) {
         slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
       } else {
         slideToIndex = clickedIndex;
       }
       if (swiper.params.loop) {
         let currentIndex = swiper.activeIndex;
         if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
           swiper.loopFix();
           // eslint-disable-next-line
           swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
           currentIndex = swiper.activeIndex;
         }
         const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
         const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
         if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
         else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
         else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
         else slideToIndex = prevIndex;
       }
       swiper.slideTo(slideToIndex);
     },
     update(initial) {
       const swiper = this;
       const thumbsSwiper = swiper.thumbs.swiper;
       if (!thumbsSwiper) return;
   
       const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
         ? thumbsSwiper.slidesPerViewDynamic()
         : thumbsSwiper.params.slidesPerView;
   
       const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
       const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
       if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
         let currentThumbsIndex = thumbsSwiper.activeIndex;
         let newThumbsIndex;
         let direction;
         if (thumbsSwiper.params.loop) {
           if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
             thumbsSwiper.loopFix();
             // eslint-disable-next-line
             thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
             currentThumbsIndex = thumbsSwiper.activeIndex;
           }
           // Find actual thumbs index to slide to
           const prevThumbsIndex = thumbsSwiper.slides
             .eq(currentThumbsIndex)
             .prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
             .index();
           const nextThumbsIndex = thumbsSwiper.slides
             .eq(currentThumbsIndex)
             .nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0)
             .index();
           if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
           else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
           else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;
           else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
           else newThumbsIndex = prevThumbsIndex;
           direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
         } else {
           newThumbsIndex = swiper.realIndex;
           direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
         }
         if (useOffset) {
           newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
         }
   
         if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
           if (thumbsSwiper.params.centeredSlides) {
             if (newThumbsIndex > currentThumbsIndex) {
               newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
             } else {
               newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
             }
           } else if (newThumbsIndex > currentThumbsIndex) {
             newThumbsIndex = newThumbsIndex - slidesPerView + 1;
           }
           thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
         }
       }
   
       // Activate thumbs
       let thumbsToActivate = 1;
       const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
   
       if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
         thumbsToActivate = swiper.params.slidesPerView;
       }
   
       if (!swiper.params.thumbs.multipleActiveThumbs) {
         thumbsToActivate = 1;
       }
   
       thumbsToActivate = Math.floor(thumbsToActivate);
   
       thumbsSwiper.slides.removeClass(thumbActiveClass);
       if (thumbsSwiper.params.loop || (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)) {
         for (let i = 0; i < thumbsToActivate; i += 1) {
           thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
         }
       } else {
         for (let i = 0; i < thumbsToActivate; i += 1) {
           thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
         }
       }
     },
   };
   var Thumbs$1 = {
     name: 'thumbs',
     params: {
       thumbs: {
         swiper: null,
         multipleActiveThumbs: true,
         autoScrollOffset: 0,
         slideThumbActiveClass: 'swiper-slide-thumb-active',
         thumbsContainerClass: 'swiper-container-thumbs',
       },
     },
     create() {
       const swiper = this;
       Utils.extend(swiper, {
         thumbs: {
           swiper: null,
           init: Thumbs.init.bind(swiper),
           update: Thumbs.update.bind(swiper),
           onThumbClick: Thumbs.onThumbClick.bind(swiper),
         },
       });
     },
     on: {
       beforeInit() {
         const swiper = this;
         const { thumbs } = swiper.params;
         if (!thumbs || !thumbs.swiper) return;
         swiper.thumbs.init();
         swiper.thumbs.update(true);
       },
       slideChange() {
         const swiper = this;
         if (!swiper.thumbs.swiper) return;
         swiper.thumbs.update();
       },
       update() {
         const swiper = this;
         if (!swiper.thumbs.swiper) return;
         swiper.thumbs.update();
       },
       resize() {
         const swiper = this;
         if (!swiper.thumbs.swiper) return;
         swiper.thumbs.update();
       },
       observerUpdate() {
         const swiper = this;
         if (!swiper.thumbs.swiper) return;
         swiper.thumbs.update();
       },
       setTransition(duration) {
         const swiper = this;
         const thumbsSwiper = swiper.thumbs.swiper;
         if (!thumbsSwiper) return;
         thumbsSwiper.setTransition(duration);
       },
       beforeDestroy() {
         const swiper = this;
         const thumbsSwiper = swiper.thumbs.swiper;
         if (!thumbsSwiper) return;
         if (swiper.thumbs.swiperCreated && thumbsSwiper) {
           thumbsSwiper.destroy();
         }
       },
     },
   };
   
   // Swiper Class
   
   const components = [
     Device$1,
     Support$1,
     Browser$1,
     Resize,
     Observer$1,
     Virtual$1,
     Keyboard$1,
     Mousewheel$1,
     Navigation$1,
     Pagination$1,
     Scrollbar$1,
     Parallax$1,
     Zoom$1,
     Lazy$1,
     Controller$1,
     A11y,
     History$1,
     HashNavigation$1,
     Autoplay$1,
     EffectFade,
     EffectCube,
     EffectFlip,
     EffectCoverflow,
     Thumbs$1
   ];
   
   if (typeof Swiper.use === 'undefined') {
     Swiper.use = Swiper.Class.use;
     Swiper.installModule = Swiper.Class.installModule;
   }
   
   Swiper.use(components);
   
   /* harmony default export */ const swiper_esm_bundle = (Swiper);
   //# sourceMappingURL=swiper.esm.bundle.js.map
   
   ;// CONCATENATED MODULE: ./src/javascripts/sections/BlogPosts.js
   
   
   
   class BlogPosts extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.kenBurns = new KenBurns(theme, element);
       const swiperContainer = this.element.querySelector('.swiper-container');
       this.swiper = new swiper_esm_bundle(swiperContainer, {
         slidesPerView: 1,
         watchOverflow: true,
         autoHeight: true,
         pagination: {
           el: swiperContainer.querySelectorAll('.swiper-pagination'),
           clickable: true
         }
       });
     }
   }
   // EXTERNAL MODULE: ./node_modules/rellax/rellax.js
   var rellax = __webpack_require__(926);
   var rellax_default = /*#__PURE__*/__webpack_require__.n(rellax);
   ;// CONCATENATED MODULE: ./src/javascripts/global/Parallax.js
   
   
   
   class Parallax_Parallax extends Component {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
     */
     constructor(theme, element) {
       super(theme, element);
   
       /** @type {Rellax[]} */
       this.init = () => {
         if (this.element.querySelector('.rellax')) {
           this.rellaxes = Array.prototype.map.call(this.element.querySelectorAll('.rellax'), el => {
             return new (rellax_default())(el, {
               center: true
             });
           });
         }
       };
       this.destroy = () => {
         this.rellaxes.forEach(rellax => rellax.destroy());
         this.rellaxes = [];
       };
       this.isMobile = (breakpoint = null) => {
         return (breakpoint || this.theme.getBreakpoint()).order < Breakpoints.md.order;
       };
       this.onWindowResizeBreakpoint = ({
         breakpoint
       }) => {
         const isMobile = this.isMobile(breakpoint);
         if (!isMobile && this.rellaxes.length === 0) {
           // We're on desktop and parallax is not active => activate it
           this.init();
         } else if (isMobile && this.rellaxes.length > 0) {
           // We're on mobile and parallax is active => deactivate it
           this.destroy();
         }
       };
       this.rellaxes = [];
       this.element = element;
       if (!this.isMobile()) {
         this.init();
       }
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionList.js
   
   
   class CollectionList extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.parallax = new Parallax_Parallax(theme, element.parentNode);
       this.theme.addBadges(this.element, 1000);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/EventsCalendar.js
   
   
   class EventsCalendar extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.kenBurns = new KenBurns(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/QuickAdd.js
   
   
   class QuickAdd extends Component {
     constructor(theme, element) {
       super(theme, element);
       this.theme = theme;
       this.element = element;
       this.onSubmit = this.onSubmit.bind(this);
       this.currentButton = null;
       this.cartAction = document.getElementById('PageContainer').dataset.cartAction;
       this.languageUrl = document.getElementById('PageContainer').dataset.languageUrl;
       this.formWrapper = /** @type {HTMLElement} */this.element.querySelectorAll('.quick-add-wrapper.is-singular');
       this.wethemeGlobal = document.querySelector('script#wetheme-global');
       this.translationsObject = JSON.parse(this.wethemeGlobal.textContent);
       if (!this.formWrapper) {
         return;
       }
       Array.prototype.forEach.call(this.element.querySelectorAll('.quick-add-wrapper.is-singular .shopify-product-form'), el => {
         el.addEventListener('submit', this.onSubmit);
       });
     }
     async onSubmit(e) {
       // Go straight to cart page, use html form submit event.
       if (this.cartAction == 'page') {
         return;
       }
       e.preventDefault();
       this.currentButton = e.currentTarget.querySelector('.quick-add-button');
   
       // Loading spinner.
       this.currentButton.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="spin flex m-0-auto"><g clip-path="url(#clip0_7323_531303)"><path d="M10.5 19C5.52944 19 1.5 14.9706 1.5 10C1.5 5.02944 5.52944 1 10.5 1C15.4706 1 19.5 5.02944 19.5 10C19.5 12.5991 18.3983 14.9408 16.6364 16.5837" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></g><defs><clipPath id="clip0_7323_531303"><rect width="20" height="20" fill="white" transform="translate(0.5)"/></clipPath></defs>${this.translationsObject.translations.loading}</svg>`;
       try {
         const data = jquery_default()(e.currentTarget).serialize();
         const response = await window.fetch('/cart/add.js', {
           method: 'POST',
           credentials: 'same-origin',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded'
           },
           body: data
         });
         if (!response.ok) {
           // FIXME: error handling
           return false;
         }
         const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
         const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
         if (!response2.ok) {
           // FIXME: error handling
           return false;
         }
         const cart = await response2.json();
         if (this.cartAction == 'drawer') {
           this.theme.toggleRightDrawer('cart', true, {
             cart: cart
           });
         } else {
           this.currentButton.innerHTML = this.translationsObject.translations.productAdded;
           this.theme.updateCartDrawer(cart);
         }
         setTimeout(() => {
           this.currentButton.innerHTML = this.translationsObject.translations.addToCart;
         }, 2000);
       } catch (e) {
         console.error('Unable to add to cart: ', e);
         // FIXME error handling
       }
   
       return false;
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedCollection.js
   
   
   class FeaturedCollection extends Section {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      * @param {boolean} pageLoad
      */
   
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.handleShopNow = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('shop-now', true, {
           url: e.currentTarget.href
         });
       };
       this.isMobile = () => {
         return window.matchMedia('(max-width: 1023px)').matches;
       };
       Array.prototype.forEach.call(element.querySelectorAll('.shop-now-button, .quick-add-button-variants'), shopNow => {
         if (shopNow) {
           shopNow.addEventListener('click', this.handleShopNow);
         }
       });
       this.quickAddButtons = new QuickAdd(theme, element);
       this.theme.addBadges(this.element, 1000);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedMenu.js
   
   class FeaturedMenu extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/ImageGallery.js
   
   
   class ImageGallery extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.kenBurns = new KenBurns(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/ImageWithText.js
   
   
   class ImageWithText extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.onSectionSelect = () => {
         this.kenBurns.reapply();
       };
       this.kenBurns = new KenBurns(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/modules/sectionLink.js
   function createClickableSection(element) {
     const mainLink = element.querySelector('[data-section-main-link]');
     if (!mainLink) return;
     const buttonHidden = mainLink.ariaHidden == 'true';
     const handleSectionClick = () => {
       const isTextSelected = window.getSelection().toString();
       if (!isTextSelected) mainLink.click();
     };
     if (buttonHidden && mainLink) element.addEventListener('click', handleSectionClick);
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/ImageWithTextOverlay.js
   
   
   
   class ImageWithTextOverlay extends ImageWithText {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      * @param {boolean} pageLoad
      */
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.onWindowResize = () => {
         if (this.sectionHeightSetToOriginal) {
           this.setToOriginalHeight();
         }
       };
       this.setToOriginalHeight = () => {
         this.setImageWrapperHeight('auto');
         if (this.contentIsTallerThanImage()) {
           this.toggleCoverClass('true');
           this.setImageWrapperHeight('100%');
         } else {
           this.toggleCoverClass();
           this.setSectionMinHeight();
         }
       };
       this.toggleCoverClass = contentIsTaller => {
         if (!this.imageElement) return;
         this.imageElement.classList.remove('image-cover');
         if (contentIsTaller) this.imageElement.classList.add('image-cover');
       };
       this.setImageWrapperHeight = value => {
         this.imageWrapper.style.height = value;
       };
       this.setSectionMinHeight = () => {
         this.sectionWrapper.style.minHeight = `${this.getImageHeight()}px`;
       };
       this.getContentHeight = () => {
         return this.contentWrapper.offsetHeight;
       };
       this.getImageHeight = () => {
         return this.imageWrapper.offsetHeight;
       };
       this.contentIsTallerThanImage = () => {
         return this.getContentHeight() > this.getImageHeight();
       };
       this.theme = theme;
       this.element = element;
       this.sectionWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-featured-content-wrapper');
       this.imageWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-content--image');
       this.contentWrapper = /** @type {HTMLElement} */this.element.querySelector('.homepage-featured-content-box-inner');
       this.imageElement = this.imageWrapper.getElementsByTagName('img').item(0);
       this.sectionHeightSetToOriginal = this.element.classList.contains('size-original');
       if (this.sectionHeightSetToOriginal) {
         this.setToOriginalHeight();
       }
       this.parallax = new Parallax_Parallax(this.theme, this.element);
       createClickableSection(this.element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/LogoList.js
   
   class LogoList extends Section {}
   ;// CONCATENATED MODULE: ./src/javascripts/global/Slider.js
   
   class Slider {
     constructor(theme, element, options) {
       this.stop = () => {
         if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
           return;
         }
         this.swiper.autoplay.stop();
       };
       this.start = () => {
         if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
           return;
         }
         this.swiper.autoplay.start();
       };
       this.isRunning = () => {
         return this.swiper.autoplay.running;
       };
       this.slideTo = (index, skipAnimation = false) => {
         this.swiper.slideTo(index, skipAnimation ? 0 : 200);
       };
       this.slideToLoop = (index, skipAnimation = false) => {
         this.swiper.slideToLoop(index, skipAnimation ? 0 : 200);
       };
       this.onSlideChange = () => {
         if (this.slideChangeCallback) {
           this.slideChangeCallback();
         }
       };
       this.setAutoHeight = () => {
         this.autoHeightEnabled = false;
         if (this.desktopHeight && this.mobileHeight) {
           if (!this.isMobile() && this.desktopHeight == 'original') {
             this.autoHeightEnabled = true;
           } else if (this.isMobile() && this.mobileHeight == 'original') {
             this.autoHeightEnabled = true;
           }
         }
         return this.autoHeightEnabled;
       };
       this.configure = () => {
         let paginationStyle = this.paginationType;
         let paginationElement = this.element.querySelector('.swiper-pagination');
         if (this.element.querySelectorAll('.swiper-slide').length <= 1) {
           return;
         }
         const swiper = new swiper_esm_bundle(this.element, {
           allowTouchMove: this.isDraggable == 'true' ? true : false,
           autoHeight: this.autoHeightEnabled,
           loop: true,
           loopedSlides: this.effect === 'fade' ? 0 : 2,
           autoplay: this.speed > 0 ? {
             delay: this.speed,
             disableOnInteraction: false
           } : false,
           effect: this.effect,
           slidesPerView: 1,
           speed: this.transitionSpeed,
           watchOverflow: true,
           keyboard: {
             enabled: true,
             onlyInViewport: false
           },
           fadeEffect: {
             crossFade: true
           },
           navigation: {
             nextEl: this.element.querySelector('.flex-next'),
             prevEl: this.element.querySelector('.flex-prev')
           },
           pagination: {
             el: this.element.querySelector('.swiper-pagination'),
             type: paginationStyle,
             renderBullet: function (index, className) {
               const paginationOption = paginationElement.dataset.paginationStyle;
               if (paginationOption == 'bars') {
                 return '<span class="' + className + ' progress-bar">' + '<i></i>' + '<b></b>' + '</span>';
               } else if (paginationOption == 'dots') {
                 return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
               }
             },
             clickable: true
           }
         });
         swiper.on('slideChange', () => {
           const event = new CustomEvent('slider:slide:change');
           document.dispatchEvent(event);
           this.onSlideChange();
         });
         return swiper;
       };
       this.isMobile = () => {
         return window.matchMedia('(max-width: 1023px)').matches;
       };
       this.theme = theme;
       this.element = element;
       this.restartTimer = null;
       this.running = true;
       this.speed = options.speed !== undefined ? options.speed : 200;
       this.transitionSpeed = options.transitionSpeed !== undefined ? options.transitionSpeed : 300;
       this.paginationType = options.paginationType;
       this.effect = options.animation || 'slide';
       this.slideChangeCallback = options.onSlideChange;
       this.desktopHeight = options.desktopHeight;
       this.mobileHeight = options.mobileHeight;
       this.isDraggable = options.isDraggable;
       this.blockIsActive = false;
       if (window.Shopify.designMode) {
         document.addEventListener('shopify:block:select', () => {
           this.blockIsActive = true;
         });
         document.addEventListener('shopify:block:deselect', () => {
           this.blockIsActive = false;
         });
       }
   
       // Determine if we should use autoHeight
       this.setAutoHeight();
       this.swiper = this.configure();
   
       // Handle window resize
       window.addEventListener('resize', () => {
         const index_currentSlide = this.swiper.activeIndex;
         this.setAutoHeight();
         this.swiper.destroy();
         this.swiper = this.configure();
         if (window.Shopify.designMode) {
           this.swiper.slideTo(index_currentSlide, 0);
   
           // stop autoplay when in editor
           if (this.blockIsActive) this.stop();
         }
       });
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Slideshow.js
   
   
   
   class Slideshow extends Section {
     // ms
   
     constructor(theme, _element, pageLoad) {
       super(theme, _element, pageLoad);
       this.SLIDER_SELECTOR = '.swiper-container';
       this.SLIDER_REENABLE_INTERVAL = 6000;
       this.initPaginationColor = () => {
         if (this.slideCount == 1) return;
         const paginationEl = this.paginationType == 'fraction' ? this.sliderElement.querySelector('.image--slideshow__navigation') : this.sliderElement.querySelector('.swiper-pagination');
         const activeSlide = this.sliderElement.querySelector('.swiper-slide-active');
         if (!paginationEl || !activeSlide) return;
         const captionColor = activeSlide.dataset.captionColor;
         if (captionColor) {
           paginationEl.style.color = captionColor;
         }
       };
       this.changePaginationColor = () => {
         if (this.slideCount == 1) return;
         const paginationElement = this.paginationType == 'fraction' ? this.sliderElement.querySelector('.image--slideshow__navigation') : this.slider.element.querySelector('.swiper-pagination');
         if (!paginationElement) return;
         const index_currentSlide = this.slider.swiper.activeIndex;
         const currentSlide = this.slider.swiper.slides[index_currentSlide];
         if (!currentSlide) return;
         const color = currentSlide.dataset.captionColor;
         if (color) {
           paginationElement.style.color = color;
         }
       };
       this.setTabIndex = () => {
         // Return if there's only one slide
         if (this.slideCount == 1) return;
         const slideshowBtns = this.slider.element.querySelectorAll('.homepage-section-btn');
         const slideshowLinks = this.slider.element.querySelectorAll('.slideshow__link');
         const index_currentSlide = this.slider.swiper.activeIndex;
         const currentSlide = this.slider.swiper.slides[index_currentSlide];
         if (!currentSlide) return;
         const currentSlideBtns = currentSlide.querySelectorAll('.homepage-section-btn');
         const currentSlideLinks = currentSlide.querySelectorAll('.slideshow__link');
   
         // Links
         if (slideshowLinks.length > 0) {
           slideshowLinks.forEach(link => {
             link.setAttribute('tabindex', '-1');
           });
         }
         if (currentSlideLinks.length > 0) {
           currentSlideLinks.forEach(link => {
             link.removeAttribute('tabindex');
           });
         }
   
         // Buttons
         if (slideshowBtns.length > 0) {
           slideshowBtns.forEach(btn => {
             btn.setAttribute('tabindex', '-1');
           });
         }
         if (currentSlideBtns.length > 0) {
           currentSlideBtns.forEach(btn => {
             btn.removeAttribute('tabindex');
           });
         }
       };
       this.slideTransitionHandler = transitionTimeout => {
         // Handle slide transition
         const swiper = this.slider.swiper;
         const currentSlide = swiper.slides[swiper.activeIndex];
         const currentSlideInner = currentSlide.querySelector('.swiper-slide--inner');
         if (currentSlideInner) {
           // Clear any existing timeouts and animations
           clearTimeout(transitionTimeout);
           currentSlideInner.style.animation = 'none';
   
           // Use setTimeout to allow the browser to render the initial state and then start the transition
           transitionTimeout = setTimeout(() => {
             // Apply the keyframes animation
             currentSlideInner.style.animation = 'fadeInMove 600ms forwards';
   
             // Listen for the animationend event
             currentSlideInner.addEventListener('animationend', () => {
               // Reset or clear any styles if needed after the animation completes
               currentSlideInner.style.animation = 'none';
             }, {
               once: true
             }); // The event listener will be removed after it's called once
           }, 50);
         }
       };
       this.autoplayHandler = () => {
         if (window.Shopify.designMode) return; // Otherwise the slider won't remain paused on block select
         const handleIntersection = (entries, observer) => {
           if (!entries[0].isIntersecting) {
             this.slider.stop();
           } else {
             this.slider.start();
           }
         };
         new IntersectionObserver(handleIntersection.bind(this), {
           rootMargin: '0px 0px 0px 0px'
         }).observe(this.slider.element);
       };
       this.onSlideChange = () => {
         // Handle slide transition
         this.slideTransitionHandler(this.slideTransitionTimeout);
         if (this.slider && this.slider.isRunning && this.speed > 0) {
           if (window.Shopify.designMode) return; // Otherwise the slider won't remain paused on block select
           // restart autoscroll after given interval since last interaction
           clearTimeout(this.restartTimer);
           this.restartTimer = setTimeout(() => {
             this.slider.start();
           }, Math.max(0, this.SLIDER_REENABLE_INTERVAL - this.speed));
         }
       };
       this.onBlockSelect = ({
         element
       }) => {
         const index = parseInt(element.dataset.swiperSlideIndex, 10);
         this.slider.slideToLoop(index);
         this.slider.stop();
       };
       this.onBlockDeselect = () => {
         this.slider.start();
       };
       this.restartTimer = null;
       this.sliderElement = _element.querySelector(this.SLIDER_SELECTOR);
       this.speed = parseInt(this.sliderElement.dataset.sliderSlideTime, 10);
       this.slideTransitionSpeed = parseInt(this.sliderElement.dataset.sliderTransitionSpeed, 10);
       this.paginationType = this.sliderElement.dataset.sliderPaginationType;
       this.desktopHeight = this.sliderElement.dataset.desktopHeight;
       this.mobileHeight = this.sliderElement.dataset.mobileHeight;
       this.isDraggable = this.sliderElement.dataset.draggable;
       this.slideTransitionTimeout = null;
       if (this.paginationType == 'arrows') {
         this.paginationType = 'fraction';
       } else if (this.paginationType == 'bars') {
         this.paginationType = 'bullets';
       } else if (this.paginationType == 'dots') {
         this.paginationType = 'bullets';
       }
       this.slider = new Slider(theme, this.sliderElement, {
         speed: this.speed,
         transitionSpeed: this.slideTransitionSpeed,
         paginationType: this.paginationType,
         animation: this.sliderElement.dataset.sliderAnimation,
         onSlideChange: this.onSlideChange,
         desktopHeight: this.desktopHeight,
         mobileHeight: this.mobileHeight,
         isDraggable: this.isDraggable
       });
       const slides = this.slider.element.querySelectorAll('.slideshow__link');
       slides.forEach(slide => createClickableSection(slide));
   
       // Get slide count
       this.slideCount = this.slider.element.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
   
       // Play when in viewport/stop when out of viewport
       this.autoplayHandler();
   
       // The slider breaks when tabbing through the slide buttons
       this.setTabIndex();
   
       // Pagination colors to match caption color
       this.initPaginationColor();
       window.addEventListener('resize', () => {
         this.initPaginationColor();
       });
       document.addEventListener('slider:slide:change', () => {
         // The slider breaks when tabbing through the slide buttons
         this.setTabIndex();
   
         // Pagination colors
         this.changePaginationColor();
       });
       if (window.Shopify.designMode) {
         document.addEventListener('shopify:block:select', e => {
           const index_currentSlide = this.slider.swiper.activeIndex;
           const currentSlide = this.slider.swiper.slides[index_currentSlide];
   
           // @ts-ignore
           const blockId = e.detail.blockId;
           if (currentSlide && blockId == currentSlide.dataset.blockId) {
             this.onBlockSelect({
               element: currentSlide
             });
           }
         });
         document.addEventListener('shopify:block:deselect', e => {
           const index_currentSlide = this.slider.swiper.activeIndex;
           const currentSlide = this.slider.swiper.slides[index_currentSlide];
   
           // @ts-ignore
           const blockId = e.detail.blockId;
           if (currentSlide && blockId == currentSlide.dataset.blockId) {
             this.onBlockDeselect();
           }
         });
       }
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Newsletter.js
   
   class Newsletter extends Section {}
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Password.js
   
   
   class Password extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.load = () => {
         var self = this;
         jquery_default()('.password-show').click(function () {
           self.$head.slideToggle('slow').addClass('open');
           jquery_default()('.password--container').addClass('password-modal--open');
           self.$password.focus();
         });
         jquery_default()('.password--close').click(function () {
           self.$head.slideToggle('slow').removeClass('open');
           jquery_default()('.password--container').removeClass('password-modal--open');
           self.$password.blur();
         });
         jquery_default()(function () {
           if (jquery_default()('.storefront-password-form .errors').length) {
             self.$head.slideDown('slow').addClass('open');
             self.$password.focus();
           }
         });
   
         // Detect click outside of popup to close it.
         jquery_default()('.password--wrapper').click(e => {
           if (self.$head.hasClass('open')) {
             if (!self.$head.is(e.target) && self.$head.has(e.target).length === 0 && !jquery_default()('.password-show').is(e.target)) {
               self.$head.slideUp('slow');
             }
           }
         });
   
         // Keep tabbing within the modal while it is open.
         jquery_default()(document).on('keydown', function (e) {
           // @ts-ignore
           e = e || window.event;
           if (e.keyCode == 9) {
             // Keep tab within the open modal.
             if (e.shiftKey) {
               if (document.activeElement === self.firstFocusableEl) {
                 e.preventDefault();
                 self.lastFocusableEl.focus();
               }
             } else {
               if (document.activeElement === self.lastFocusableEl) {
                 e.preventDefault();
                 self.firstFocusableEl.focus();
               }
             }
           } else if (e.keyCode == 27) {
             // Escape to close popup.
             if (self.$head.hasClass('open')) {
               self.$head.slideToggle('slow').removeClass('open');
               self.$password.blur();
             }
           }
         });
       };
       this.$head = jquery_default()('.site-header');
       this.$focusableEls = this.$head.find('a[href], input:not([disabled]):not([type="hidden"]), button:not([disabled]), [tabindex="0"]');
       this.$password = this.$head.find('input#password');
       this.firstFocusableEl = /** @type {HTMLElement} */this.$focusableEls[0];
       this.lastFocusableEl = /** @type {HTMLElement} */this.$focusableEls[this.$focusableEls.length - 1];
       this.load();
     }
   }
   // EXTERNAL MODULE: ./node_modules/vue-template-compiler/browser.js
   var browser = __webpack_require__(725);
   ;// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
   /**
     * vue-class-component v7.2.6
     * (c) 2015-present Evan You
     * @license MIT
     */
   
   
   function _typeof(obj) {
     if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
       _typeof = function (obj) {
         return typeof obj;
       };
     } else {
       _typeof = function (obj) {
         return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
       };
     }
   
     return _typeof(obj);
   }
   
   function _defineProperty(obj, key, value) {
     if (key in obj) {
       Object.defineProperty(obj, key, {
         value: value,
         enumerable: true,
         configurable: true,
         writable: true
       });
     } else {
       obj[key] = value;
     }
   
     return obj;
   }
   
   function _toConsumableArray(arr) {
     return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
   }
   
   function _arrayWithoutHoles(arr) {
     if (Array.isArray(arr)) {
       for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
   
       return arr2;
     }
   }
   
   function _iterableToArray(iter) {
     if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
   }
   
   function _nonIterableSpread() {
     throw new TypeError("Invalid attempt to spread non-iterable instance");
   }
   
   // The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
   // which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
   // Without this check consumers will encounter hard to track down runtime errors.
   function reflectionIsSupported() {
     return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
   }
   function copyReflectionMetadata(to, from) {
     forwardMetadata(to, from);
     Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
       forwardMetadata(to.prototype, from.prototype, key);
     });
     Object.getOwnPropertyNames(from).forEach(function (key) {
       forwardMetadata(to, from, key);
     });
   }
   
   function forwardMetadata(to, from, propertyKey) {
     var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
     metaKeys.forEach(function (metaKey) {
       var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);
   
       if (propertyKey) {
         Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
       } else {
         Reflect.defineMetadata(metaKey, metadata, to);
       }
     });
   }
   
   var fakeArray = {
     __proto__: []
   };
   var vue_class_component_esm_hasProto = fakeArray instanceof Array;
   function vue_class_component_esm_createDecorator(factory) {
     return function (target, key, index) {
       var Ctor = typeof target === 'function' ? target : target.constructor;
   
       if (!Ctor.__decorators__) {
         Ctor.__decorators__ = [];
       }
   
       if (typeof index !== 'number') {
         index = undefined;
       }
   
       Ctor.__decorators__.push(function (options) {
         return factory(options, key, index);
       });
     };
   }
   function mixins() {
     for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
       Ctors[_key] = arguments[_key];
     }
   
     return Vue.extend({
       mixins: Ctors
     });
   }
   function vue_class_component_esm_isPrimitive(value) {
     var type = _typeof(value);
   
     return value == null || type !== 'object' && type !== 'function';
   }
   function vue_class_component_esm_warn(message) {
     if (typeof console !== 'undefined') {
       console.warn('[vue-class-component] ' + message);
     }
   }
   
   function collectDataFromConstructor(vm, Component) {
     // override _init to prevent to init as Vue instance
     var originalInit = Component.prototype._init;
   
     Component.prototype._init = function () {
       var _this = this;
   
       // proxy to actual vm
       var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)
   
       if (vm.$options.props) {
         for (var key in vm.$options.props) {
           if (!vm.hasOwnProperty(key)) {
             keys.push(key);
           }
         }
       }
   
       keys.forEach(function (key) {
         Object.defineProperty(_this, key, {
           get: function get() {
             return vm[key];
           },
           set: function set(value) {
             vm[key] = value;
           },
           configurable: true
         });
       });
     }; // should be acquired class property values
   
   
     var data = new Component(); // restore original _init to avoid memory leak (#209)
   
     Component.prototype._init = originalInit; // create plain data object
   
     var plainData = {};
     Object.keys(data).forEach(function (key) {
       if (data[key] !== undefined) {
         plainData[key] = data[key];
       }
     });
   
     if (false) {}
   
     return plainData;
   }
   
   var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
   ];
   function componentFactory(Component) {
     var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
     options.name = options.name || Component._componentTag || Component.name; // prototype props.
   
     var proto = Component.prototype;
     Object.getOwnPropertyNames(proto).forEach(function (key) {
       if (key === 'constructor') {
         return;
       } // hooks
   
   
       if ($internalHooks.indexOf(key) > -1) {
         options[key] = proto[key];
         return;
       }
   
       var descriptor = Object.getOwnPropertyDescriptor(proto, key);
   
       if (descriptor.value !== void 0) {
         // methods
         if (typeof descriptor.value === 'function') {
           (options.methods || (options.methods = {}))[key] = descriptor.value;
         } else {
           // typescript decorated data
           (options.mixins || (options.mixins = [])).push({
             data: function data() {
               return _defineProperty({}, key, descriptor.value);
             }
           });
         }
       } else if (descriptor.get || descriptor.set) {
         // computed properties
         (options.computed || (options.computed = {}))[key] = {
           get: descriptor.get,
           set: descriptor.set
         };
       }
     });
     (options.mixins || (options.mixins = [])).push({
       data: function data() {
         return collectDataFromConstructor(this, Component);
       }
     }); // decorate options
   
     var decorators = Component.__decorators__;
   
     if (decorators) {
       decorators.forEach(function (fn) {
         return fn(options);
       });
       delete Component.__decorators__;
     } // find super
   
   
     var superProto = Object.getPrototypeOf(Component.prototype);
     var Super = superProto instanceof vue_esm ? superProto.constructor : vue_esm;
     var Extended = Super.extend(options);
     forwardStaticMembers(Extended, Component, Super);
   
     if (reflectionIsSupported()) {
       copyReflectionMetadata(Extended, Component);
     }
   
     return Extended;
   }
   var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
   'cid', // Super Vue constructor
   'super', // Component options that will be used by the component
   'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
   'component', 'directive', 'filter']));
   var shouldIgnore = {
     prototype: true,
     arguments: true,
     callee: true,
     caller: true
   };
   
   function forwardStaticMembers(Extended, Original, Super) {
     // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
     Object.getOwnPropertyNames(Original).forEach(function (key) {
       // Skip the properties that should not be overwritten
       if (shouldIgnore[key]) {
         return;
       } // Some browsers does not allow reconfigure built-in properties
   
   
       var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
   
       if (extendedDescriptor && !extendedDescriptor.configurable) {
         return;
       }
   
       var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
       // the sub class properties may be inherited properties from the super class in TypeScript.
       // We need to exclude such properties to prevent to overwrite
       // the component options object which stored on the extended constructor (See #192).
       // If the value is a referenced value (object or function),
       // we can check equality of them and exclude it if they have the same reference.
       // If it is a primitive value, it will be forwarded for safety.
   
       if (!vue_class_component_esm_hasProto) {
         // Only `cid` is explicitly exluded from property forwarding
         // because we cannot detect whether it is a inherited property or not
         // on the no `__proto__` environment even though the property is reserved.
         if (key === 'cid') {
           return;
         }
   
         var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
   
         if (!vue_class_component_esm_isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
           return;
         }
       } // Warn if the users manually declare reserved properties
   
   
       if (false) {}
   
       Object.defineProperty(Extended, key, descriptor);
     });
   }
   
   function vue_class_component_esm_Component(options) {
     if (typeof options === 'function') {
       return componentFactory(options);
     }
   
     return function (Component) {
       return componentFactory(Component, options);
     };
   }
   
   vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
     $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
   };
   
   /* harmony default export */ const vue_class_component_esm = (vue_class_component_esm_Component);
   
   
   ;// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
   /** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
   /// <reference types='reflect-metadata'/>
   
   
   
   
   /** Used for keying reactive provide/inject properties */
   var reactiveInjectKey = '__reactiveInject__';
   /**
    * decorator of an inject
    * @param from key
    * @return PropertyDecorator
    */
   function Inject(options) {
       return createDecorator(function (componentOptions, key) {
           if (typeof componentOptions.inject === 'undefined') {
               componentOptions.inject = {};
           }
           if (!Array.isArray(componentOptions.inject)) {
               componentOptions.inject[key] = options || key;
           }
       });
   }
   /**
    * decorator of a reactive inject
    * @param from key
    * @return PropertyDecorator
    */
   function InjectReactive(options) {
       return createDecorator(function (componentOptions, key) {
           if (typeof componentOptions.inject === 'undefined') {
               componentOptions.inject = {};
           }
           if (!Array.isArray(componentOptions.inject)) {
               var fromKey_1 = !!options ? options.from || options : key;
               var defaultVal_1 = (!!options && options.default) || undefined;
               if (!componentOptions.computed)
                   componentOptions.computed = {};
               componentOptions.computed[key] = function () {
                   var obj = this[reactiveInjectKey];
                   return obj ? obj[fromKey_1] : defaultVal_1;
               };
               componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
           }
       });
   }
   function produceProvide(original) {
       var provide = function () {
           var _this = this;
           var rv = typeof original === 'function' ? original.call(this) : original;
           rv = Object.create(rv || null);
           // set reactive services (propagates previous services if necessary)
           rv[reactiveInjectKey] = this[reactiveInjectKey] || {};
           for (var i in provide.managed) {
               rv[provide.managed[i]] = this[i];
           }
           var _loop_1 = function (i) {
               rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
               Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                   enumerable: true,
                   get: function () { return _this[i]; },
               });
           };
           var this_1 = this;
           for (var i in provide.managedReactive) {
               _loop_1(i);
           }
           return rv;
       };
       provide.managed = {};
       provide.managedReactive = {};
       return provide;
   }
   function needToProduceProvide(original) {
       return (typeof original !== 'function' ||
           (!original.managed && !original.managedReactive));
   }
   /**
    * decorator of a provide
    * @param key key
    * @return PropertyDecorator | void
    */
   function Provide(key) {
       return createDecorator(function (componentOptions, k) {
           var provide = componentOptions.provide;
           if (needToProduceProvide(provide)) {
               provide = componentOptions.provide = produceProvide(provide);
           }
           provide.managed[k] = key || k;
       });
   }
   /**
    * decorator of a reactive provide
    * @param key key
    * @return PropertyDecorator | void
    */
   function ProvideReactive(key) {
       return createDecorator(function (componentOptions, k) {
           var provide = componentOptions.provide;
           // inject parent reactive services (if any)
           if (!Array.isArray(componentOptions.inject)) {
               componentOptions.inject = componentOptions.inject || {};
               componentOptions.inject[reactiveInjectKey] = {
                   from: reactiveInjectKey,
                   default: {},
               };
           }
           if (needToProduceProvide(provide)) {
               provide = componentOptions.provide = produceProvide(provide);
           }
           provide.managedReactive[k] = key || k;
       });
   }
   /** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
   var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
   function applyMetadata(options, target, key) {
       if (reflectMetadataIsSupported) {
           if (!Array.isArray(options) &&
               typeof options !== 'function' &&
               typeof options.type === 'undefined') {
               var type = Reflect.getMetadata('design:type', target, key);
               if (type !== Object) {
                   options.type = type;
               }
           }
       }
   }
   /**
    * decorator of model
    * @param  event event name
    * @param options options
    * @return PropertyDecorator
    */
   function Model(event, options) {
       if (options === void 0) { options = {}; }
       return function (target, key) {
           applyMetadata(options, target, key);
           createDecorator(function (componentOptions, k) {
               ;
               (componentOptions.props || (componentOptions.props = {}))[k] = options;
               componentOptions.model = { prop: k, event: event || k };
           })(target, key);
       };
   }
   /**
    * decorator of a prop
    * @param  options the options for the prop
    * @return PropertyDecorator | void
    */
   function Prop(options) {
       if (options === void 0) { options = {}; }
       return function (target, key) {
           applyMetadata(options, target, key);
           vue_class_component_esm_createDecorator(function (componentOptions, k) {
               ;
               (componentOptions.props || (componentOptions.props = {}))[k] = options;
           })(target, key);
       };
   }
   /**
    * decorator of a synced prop
    * @param propName the name to interface with from outside, must be different from decorated property
    * @param options the options for the synced prop
    * @return PropertyDecorator | void
    */
   function PropSync(propName, options) {
       if (options === void 0) { options = {}; }
       // @ts-ignore
       return function (target, key) {
           applyMetadata(options, target, key);
           createDecorator(function (componentOptions, k) {
               ;
               (componentOptions.props || (componentOptions.props = {}))[propName] = options;
               (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                   get: function () {
                       return this[propName];
                   },
                   set: function (value) {
                       // @ts-ignore
                       this.$emit("update:" + propName, value);
                   },
               };
           })(target, key);
       };
   }
   /**
    * decorator of a watch function
    * @param  path the path or the expression to observe
    * @param  WatchOption
    * @return MethodDecorator
    */
   function Watch(path, options) {
       if (options === void 0) { options = {}; }
       var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
       return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
           if (typeof componentOptions.watch !== 'object') {
               componentOptions.watch = Object.create(null);
           }
           var watch = componentOptions.watch;
           if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
               watch[path] = [watch[path]];
           }
           else if (typeof watch[path] === 'undefined') {
               watch[path] = [];
           }
           watch[path].push({ handler: handler, deep: deep, immediate: immediate });
       });
   }
   // Code copied from Vue/src/shared/util.js
   var vue_property_decorator_hyphenateRE = /\B([A-Z])/g;
   var vue_property_decorator_hyphenate = function (str) { return str.replace(vue_property_decorator_hyphenateRE, '-$1').toLowerCase(); };
   /**
    * decorator of an event-emitter function
    * @param  event The name of the event
    * @return MethodDecorator
    */
   function Emit(event) {
       return function (_target, propertyKey, descriptor) {
           var key = vue_property_decorator_hyphenate(propertyKey);
           var original = descriptor.value;
           descriptor.value = function emitter() {
               var _this = this;
               var args = [];
               for (var _i = 0; _i < arguments.length; _i++) {
                   args[_i] = arguments[_i];
               }
               var emit = function (returnValue) {
                   var emitName = event || key;
                   if (returnValue === undefined) {
                       if (args.length === 0) {
                           _this.$emit(emitName);
                       }
                       else if (args.length === 1) {
                           _this.$emit(emitName, args[0]);
                       }
                       else {
                           _this.$emit.apply(_this, [emitName].concat(args));
                       }
                   }
                   else {
                       if (args.length === 0) {
                           _this.$emit(emitName, returnValue);
                       }
                       else if (args.length === 1) {
                           _this.$emit(emitName, returnValue, args[0]);
                       }
                       else {
                           _this.$emit.apply(_this, [emitName, returnValue].concat(args));
                       }
                   }
               };
               var returnValue = original.apply(this, args);
               if (vue_property_decorator_isPromise(returnValue)) {
                   returnValue.then(emit);
               }
               else {
                   emit(returnValue);
               }
               return returnValue;
           };
       };
   }
   /**
    * decorator of a ref prop
    * @param refKey the ref key defined in template
    */
   function Ref(refKey) {
       return createDecorator(function (options, key) {
           options.computed = options.computed || {};
           options.computed[key] = {
               cache: false,
               get: function () {
                   return this.$refs[refKey || key];
               },
           };
       });
   }
   function vue_property_decorator_isPromise(obj) {
       return obj instanceof Promise || (obj && typeof obj.then === 'function');
   }
   
   ;// CONCATENATED MODULE: ./node_modules/photoswipe/dist/photoswipe-lightbox.esm.js
   /*!
     * PhotoSwipe Lightbox 5.3.7 - https://photoswipe.com
     * (c) 2023 Dmytro Semenov
     */
   /** @typedef {import('../photoswipe.js').Point} Point */
   
   /**
    * @template {keyof HTMLElementTagNameMap} T
    * @param {string} className
    * @param {T} tagName
    * @param {Node} [appendToEl]
    * @returns {HTMLElementTagNameMap[T]}
    */
   function photoswipe_lightbox_esm_createElement(className, tagName, appendToEl) {
     const el = document.createElement(tagName);
     if (className) {
       el.className = className;
     }
     if (appendToEl) {
       appendToEl.appendChild(el);
     }
     return el;
   }
   
   /**
    * Get transform string
    *
    * @param {number} x
    * @param {number} [y]
    * @param {number} [scale]
    * @returns {string}
    */
   function toTransformString(x, y, scale) {
     let propValue = `translate3d(${x}px,${y || 0}px,0)`;
   
     if (scale !== undefined) {
       propValue += ` scale3d(${scale},${scale},1)`;
     }
   
     return propValue;
   }
   
   /**
    * Apply width and height CSS properties to element
    *
    * @param {HTMLElement} el
    * @param {string | number} w
    * @param {string | number} h
    */
   function setWidthHeight(el, w, h) {
     el.style.width = (typeof w === 'number') ? `${w}px` : w;
     el.style.height = (typeof h === 'number') ? `${h}px` : h;
   }
   
   /** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */
   /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */
   const LOAD_STATE = {
     IDLE: 'idle',
     LOADING: 'loading',
     LOADED: 'loaded',
     ERROR: 'error',
   };
   
   
   /**
    * Check if click or keydown event was dispatched
    * with a special key or via mouse wheel.
    *
    * @param {MouseEvent | KeyboardEvent} e
    * @returns {boolean}
    */
   function specialKeyUsed(e) {
     return ('button' in e && e.button === 1) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
   }
   
   /**
    * Parse `gallery` or `children` options.
    *
    * @param {import('../photoswipe.js').ElementProvider} [option]
    * @param {string} [legacySelector]
    * @param {HTMLElement | Document} [parent]
    * @returns HTMLElement[]
    */
   function getElementsFromOption(option, legacySelector, parent = document) {
     /** @type {HTMLElement[]} */
     let elements = [];
   
     if (option instanceof Element) {
       elements = [option];
     } else if (option instanceof NodeList || Array.isArray(option)) {
       elements = Array.from(option);
     } else {
       const selector = typeof option === 'string' ? option : legacySelector;
       if (selector) {
         elements = Array.from(parent.querySelectorAll(selector));
       }
     }
   
     return elements;
   }
   
   /**
    * Check if variable is PhotoSwipe class
    *
    * @param {any} fn
    * @returns {boolean}
    */
   function isPswpClass(fn) {
     return typeof fn === 'function'
       && fn.prototype
       && fn.prototype.goTo;
   }
   
   /**
    * Check if browser is Safari
    *
    * @returns {boolean}
    */
   function isSafari() {
     return !!(navigator.vendor && navigator.vendor.match(/apple/i));
   }
   
   /** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../photoswipe.js').DataSource} DataSource */
   /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */
   /** @typedef {import('../slide/content.js').default} ContentDefault */
   /** @typedef {import('../slide/slide.js').default} Slide */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */
   /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */
   
   /**
    * Allow adding an arbitrary props to the Content
    * https://photoswipe.com/custom-content/#using-webp-image-format
    * @typedef {ContentDefault & Record<string, any>} Content
    */
   /** @typedef {{ x?: number; y?: number }} Point */
   
   /**
    * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
    *
    *
    * https://photoswipe.com/adding-ui-elements/
    *
    * @prop {undefined} uiRegister
    * @prop {{ data: UIElementData }} uiElementCreate
    *
    *
    * https://photoswipe.com/events/#initialization-events
    *
    * @prop {undefined} beforeOpen
    * @prop {undefined} firstUpdate
    * @prop {undefined} initialLayout
    * @prop {undefined} change
    * @prop {undefined} afterInit
    * @prop {undefined} bindEvents
    *
    *
    * https://photoswipe.com/events/#opening-or-closing-transition-events
    *
    * @prop {undefined} openingAnimationStart
    * @prop {undefined} openingAnimationEnd
    * @prop {undefined} closingAnimationStart
    * @prop {undefined} closingAnimationEnd
    *
    *
    * https://photoswipe.com/events/#closing-events
    *
    * @prop {undefined} close
    * @prop {undefined} destroy
    *
    *
    * https://photoswipe.com/events/#pointer-and-gesture-events
    *
    * @prop {{ originalEvent: PointerEvent }} pointerDown
    * @prop {{ originalEvent: PointerEvent }} pointerMove
    * @prop {{ originalEvent: PointerEvent }} pointerUp
    * @prop {{ bgOpacity: number }} pinchClose can be default prevented
    * @prop {{ panY: number }} verticalDrag can be default prevented
    *
    *
    * https://photoswipe.com/events/#slide-content-events
    *
    * @prop {{ content: Content }} contentInit
    * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
    * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
    * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
    * @prop {{ content: Content; slide: Slide }} loadError
    * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
    * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
    * @prop {{ content: Content }} contentLazyLoad can be default prevented
    * @prop {{ content: Content }} contentAppend can be default prevented
    * @prop {{ content: Content }} contentActivate can be default prevented
    * @prop {{ content: Content }} contentDeactivate can be default prevented
    * @prop {{ content: Content }} contentRemove can be default prevented
    * @prop {{ content: Content }} contentDestroy can be default prevented
    *
    *
    * undocumented
    *
    * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
    *
    * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
    * @prop {{ x: number; dragging: boolean }} moveMainScroll
    * @prop {{ slide: Slide }} firstZoomPan
    * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
    * @prop {undefined} beforeResize
    * @prop {undefined} resize
    * @prop {undefined} viewportSize
    * @prop {undefined} updateScrollOffset
    * @prop {{ slide: Slide }} slideInit
    * @prop {{ slide: Slide }} afterSetContent
    * @prop {{ slide: Slide }} slideLoad
    * @prop {{ slide: Slide }} appendHeavy can be default prevented
    * @prop {{ slide: Slide }} appendHeavyContent
    * @prop {{ slide: Slide }} slideActivate
    * @prop {{ slide: Slide }} slideDeactivate
    * @prop {{ slide: Slide }} slideDestroy
    * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
    * @prop {{ slide: Slide }} zoomPanUpdate
    * @prop {{ slide: Slide }} initialZoomPan
    * @prop {{ slide: Slide }} calcSlideSize
    * @prop {undefined} resolutionChanged
    * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
    * @prop {{ content: Content }} contentAppendImage can be default prevented
    * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
    * @prop {undefined} lazyLoad
    * @prop {{ slide: Slide }} calcBounds
    * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
    *
    *
    * legacy
    *
    * @prop {undefined} init
    * @prop {undefined} initialZoomIn
    * @prop {undefined} initialZoomOut
    * @prop {undefined} initialZoomInEnd
    * @prop {undefined} initialZoomOutEnd
    * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
    * @prop {{ itemData: SlideData; index: number }} itemData
    * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
    */
   
   /**
    * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
    *
    * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
    * Modify the total amount of slides. Example on Data sources page.
    * https://photoswipe.com/filters/#numitems
    *
    * @prop {(itemData: SlideData, index: number) => SlideData} itemData
    * Modify slide item data. Example on Data sources page.
    * https://photoswipe.com/filters/#itemdata
    *
    * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
    * Modify item data when it's parsed from DOM element. Example on Data sources page.
    * https://photoswipe.com/filters/#domitemdata
    *
    * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
    * Modify clicked gallery item index.
    * https://photoswipe.com/filters/#clickedindex
    *
    * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
    * Modify placeholder image source.
    * https://photoswipe.com/filters/#placeholdersrc
    *
    * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
    * Modify if the content is currently loading.
    * https://photoswipe.com/filters/#iscontentloading
    *
    * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
    * Modify if the content can be zoomed.
    * https://photoswipe.com/filters/#iscontentzoomable
    *
    * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
    * Modify if the placeholder should be used for the content.
    * https://photoswipe.com/filters/#usecontentplaceholder
    *
    * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
    * Modify if the placeholder should be kept after the content is loaded.
    * https://photoswipe.com/filters/#iskeepingplaceholder
    *
    *
    * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
    * Modify an element when the content has error state (for example, if image cannot be loaded).
    * https://photoswipe.com/filters/#contenterrorelement
    *
    * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
    * Modify a UI element that's being created.
    * https://photoswipe.com/filters/#uielement
    *
    * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
    * Modify the thubmnail element from which opening zoom animation starts or ends.
    * https://photoswipe.com/filters/#thumbel
    *
    * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
    * Modify the thubmnail bounds from which opening zoom animation starts or ends.
    * https://photoswipe.com/filters/#thumbbounds
    *
    * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
    *
    */
   
   /**
    * @template {keyof PhotoSwipeFiltersMap} T
    * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
    */
   
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
    */
   
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
    */
   
   /**
    * Base PhotoSwipe event object
    *
    * @template {keyof PhotoSwipeEventsMap} T
    */
   class PhotoSwipeEvent {
     /**
      * @param {T} type
      * @param {PhotoSwipeEventsMap[T]} [details]
      */
     constructor(type, details) {
       this.type = type;
       this.defaultPrevented = false;
       if (details) {
         Object.assign(this, details);
       }
     }
   
     preventDefault() {
       this.defaultPrevented = true;
     }
   }
   
   /**
    * PhotoSwipe base class that can listen and dispatch for events.
    * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
    */
   class Eventable {
     constructor() {
       /**
        * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
        */
       this._listeners = {};
   
       /**
        * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
        */
       this._filters = {};
   
       /** @type {PhotoSwipe | undefined} */
       this.pswp = undefined;
   
       /** @type {PhotoSwipeOptions | undefined} */
       this.options = undefined;
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {PhotoSwipeFiltersMap[T]} fn
      * @param {number} priority
      */
     addFilter(name, fn, priority = 100) {
       if (!this._filters[name]) {
         this._filters[name] = [];
       }
   
       this._filters[name]?.push({ fn, priority });
       this._filters[name]?.sort((f1, f2) => f1.priority - f2.priority);
   
       this.pswp?.addFilter(name, fn, priority);
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {PhotoSwipeFiltersMap[T]} fn
      */
     removeFilter(name, fn) {
       if (this._filters[name]) {
         // @ts-expect-error
         this._filters[name] = this._filters[name].filter(filter => (filter.fn !== fn));
       }
   
       if (this.pswp) {
         this.pswp.removeFilter(name, fn);
       }
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
      * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
      */
     applyFilters(name, ...args) {
       this._filters[name]?.forEach((filter) => {
         // @ts-expect-error
         args[0] = filter.fn.apply(this, args);
       });
       return args[0];
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {EventCallback<T>} fn
      */
     on(name, fn) {
       if (!this._listeners[name]) {
         this._listeners[name] = [];
       }
       this._listeners[name]?.push(fn);
   
       // When binding events to lightbox,
       // also bind events to PhotoSwipe Core,
       // if it's open.
       this.pswp?.on(name, fn);
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {EventCallback<T>} fn
      */
     off(name, fn) {
       if (this._listeners[name]) {
         // @ts-expect-error
         this._listeners[name] = this._listeners[name].filter(listener => (fn !== listener));
       }
   
       this.pswp?.off(name, fn);
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {PhotoSwipeEventsMap[T]} [details]
      * @returns {AugmentedEvent<T>}
      */
     dispatch(name, details) {
       if (this.pswp) {
         return this.pswp.dispatch(name, details);
       }
   
       const event = /** @type {AugmentedEvent<T>} */ (new PhotoSwipeEvent(name, details));
   
       this._listeners[name]?.forEach((listener) => {
         listener.call(this, event);
       });
   
       return event;
     }
   }
   
   class Placeholder {
     /**
      * @param {string | false} imageSrc
      * @param {HTMLElement} container
      */
     constructor(imageSrc, container) {
       // Create placeholder
       // (stretched thumbnail or simple div behind the main image)
       /** @type {HTMLImageElement | HTMLDivElement | null} */
       this.element = photoswipe_lightbox_esm_createElement(
         'pswp__img pswp__img--placeholder',
         imageSrc ? 'img' : 'div',
         container
       );
   
       if (imageSrc) {
         const imgEl = /** @type {HTMLImageElement} */ (this.element);
         imgEl.decoding = 'async';
         imgEl.alt = '';
         imgEl.src = imageSrc;
         imgEl.setAttribute('role', 'presentation');
       }
   
       this.element.setAttribute('aria-hidden', 'true');
     }
   
     /**
      * @param {number} width
      * @param {number} height
      */
     setDisplayedSize(width, height) {
       if (!this.element) {
         return;
       }
   
       if (this.element.tagName === 'IMG') {
         // Use transform scale() to modify img placeholder size
         // (instead of changing width/height directly).
         // This helps with performance, specifically in iOS15 Safari.
         setWidthHeight(this.element, 250, 'auto');
         this.element.style.transformOrigin = '0 0';
         this.element.style.transform = toTransformString(0, 0, width / 250);
       } else {
         setWidthHeight(this.element, width, height);
       }
     }
   
     destroy() {
       if (this.element?.parentNode) {
         this.element.remove();
       }
       this.element = null;
     }
   }
   
   /** @typedef {import('./slide.js').default} Slide */
   /** @typedef {import('./slide.js').SlideData} SlideData */
   /** @typedef {import('../core/base.js').default} PhotoSwipeBase */
   /** @typedef {import('../util/util.js').LoadState} LoadState */
   
   class Content {
     /**
      * @param {SlideData} itemData Slide data
      * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
      * @param {number} index
      */
     constructor(itemData, instance, index) {
       this.instance = instance;
       this.data = itemData;
       this.index = index;
   
       /** @type {HTMLImageElement | HTMLDivElement | undefined} */
       this.element = undefined;
       /** @type {Placeholder | undefined} */
       this.placeholder = undefined;
       /** @type {Slide | undefined} */
       this.slide = undefined;
   
       this.displayedImageWidth = 0;
       this.displayedImageHeight = 0;
   
       this.width = Number(this.data.w) || Number(this.data.width) || 0;
       this.height = Number(this.data.h) || Number(this.data.height) || 0;
   
       this.isAttached = false;
       this.hasSlide = false;
       this.isDecoding = false;
       /** @type {LoadState} */
       this.state = LOAD_STATE.IDLE;
   
       if (this.data.type) {
         this.type = this.data.type;
       } else if (this.data.src) {
         this.type = 'image';
       } else {
         this.type = 'html';
       }
   
       this.instance.dispatch('contentInit', { content: this });
     }
   
     removePlaceholder() {
       if (this.placeholder && !this.keepPlaceholder()) {
         // With delay, as image might be loaded, but not rendered
         setTimeout(() => {
           if (this.placeholder) {
             this.placeholder.destroy();
             this.placeholder = undefined;
           }
         }, 1000);
       }
     }
   
     /**
      * Preload content
      *
      * @param {boolean} isLazy
      * @param {boolean} [reload]
      */
     load(isLazy, reload) {
       if (this.slide && this.usePlaceholder()) {
         if (!this.placeholder) {
           const placeholderSrc = this.instance.applyFilters(
             'placeholderSrc',
             // use  image-based placeholder only for the first slide,
             // as rendering (even small stretched thumbnail) is an expensive operation
             (this.data.msrc && this.slide.isFirstSlide) ? this.data.msrc : false,
             this
           );
           this.placeholder = new Placeholder(
             placeholderSrc,
             this.slide.container
           );
         } else {
           const placeholderEl = this.placeholder.element;
           // Add placeholder to DOM if it was already created
           if (placeholderEl && !placeholderEl.parentElement) {
             this.slide.container.prepend(placeholderEl);
           }
         }
       }
   
       if (this.element && !reload) {
         return;
       }
   
       if (this.instance.dispatch('contentLoad', { content: this, isLazy }).defaultPrevented) {
         return;
       }
   
       if (this.isImageContent()) {
         this.element = photoswipe_lightbox_esm_createElement('pswp__img', 'img');
         // Start loading only after width is defined, as sizes might depend on it.
         // Due to Safari feature, we must define sizes before srcset.
         if (this.displayedImageWidth) {
           this.loadImage(isLazy);
         }
       } else {
         this.element = photoswipe_lightbox_esm_createElement('pswp__content', 'div');
         this.element.innerHTML = this.data.html || '';
       }
   
       if (reload && this.slide) {
         this.slide.updateContentSize(true);
       }
     }
   
     /**
      * Preload image
      *
      * @param {boolean} isLazy
      */
     loadImage(isLazy) {
       if (!this.isImageContent()
         || !this.element
         || this.instance.dispatch('contentLoadImage', { content: this, isLazy }).defaultPrevented) {
         return;
       }
   
       const imageElement = /** @type HTMLImageElement */ (this.element);
   
       this.updateSrcsetSizes();
   
       if (this.data.srcset) {
         imageElement.srcset = this.data.srcset;
       }
   
       imageElement.src = this.data.src ?? '';
       imageElement.alt = this.data.alt ?? '';
   
       this.state = LOAD_STATE.LOADING;
   
       if (imageElement.complete) {
         this.onLoaded();
       } else {
         imageElement.onload = () => {
           this.onLoaded();
         };
   
         imageElement.onerror = () => {
           this.onError();
         };
       }
     }
   
     /**
      * Assign slide to content
      *
      * @param {Slide} slide
      */
     setSlide(slide) {
       this.slide = slide;
       this.hasSlide = true;
       this.instance = slide.pswp;
   
       // todo: do we need to unset slide?
     }
   
     /**
      * Content load success handler
      */
     onLoaded() {
       this.state = LOAD_STATE.LOADED;
   
       if (this.slide && this.element) {
         this.instance.dispatch('loadComplete', { slide: this.slide, content: this });
   
         // if content is reloaded
         if (this.slide.isActive
             && this.slide.heavyAppended
             && !this.element.parentNode) {
           this.append();
           this.slide.updateContentSize(true);
         }
   
         if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
           this.removePlaceholder();
         }
       }
     }
   
     /**
      * Content load error handler
      */
     onError() {
       this.state = LOAD_STATE.ERROR;
   
       if (this.slide) {
         this.displayError();
         this.instance.dispatch('loadComplete', { slide: this.slide, isError: true, content: this });
         this.instance.dispatch('loadError', { slide: this.slide, content: this });
       }
     }
   
     /**
      * @returns {Boolean} If the content is currently loading
      */
     isLoading() {
       return this.instance.applyFilters(
         'isContentLoading',
         this.state === LOAD_STATE.LOADING,
         this
       );
     }
   
     /**
      * @returns {Boolean} If the content is in error state
      */
     isError() {
       return this.state === LOAD_STATE.ERROR;
     }
   
     /**
      * @returns {boolean} If the content is image
      */
     isImageContent() {
       return this.type === 'image';
     }
   
     /**
      * Update content size
      *
      * @param {Number} width
      * @param {Number} height
      */
     setDisplayedSize(width, height) {
       if (!this.element) {
         return;
       }
   
       if (this.placeholder) {
         this.placeholder.setDisplayedSize(width, height);
       }
   
       if (this.instance.dispatch(
         'contentResize',
         { content: this, width, height }).defaultPrevented
       ) {
         return;
       }
   
       setWidthHeight(this.element, width, height);
   
       if (this.isImageContent() && !this.isError()) {
         const isInitialSizeUpdate = (!this.displayedImageWidth && width);
   
         this.displayedImageWidth = width;
         this.displayedImageHeight = height;
   
         if (isInitialSizeUpdate) {
           this.loadImage(false);
         } else {
           this.updateSrcsetSizes();
         }
   
         if (this.slide) {
           this.instance.dispatch(
             'imageSizeChange',
             { slide: this.slide, width, height, content: this }
           );
         }
       }
     }
   
     /**
      * @returns {boolean} If the content can be zoomed
      */
     isZoomable() {
       return this.instance.applyFilters(
         'isContentZoomable',
         this.isImageContent() && (this.state !== LOAD_STATE.ERROR),
         this
       );
     }
   
     /**
      * Update image srcset sizes attribute based on width and height
      */
     updateSrcsetSizes() {
       // Handle srcset sizes attribute.
       //
       // Never lower quality, if it was increased previously.
       // Chrome does this automatically, Firefox and Safari do not,
       // so we store largest used size in dataset.
       if (!this.isImageContent() || !this.element || !this.data.srcset) {
         return;
       }
   
       const image = /** @type HTMLImageElement */ (this.element);
       const sizesWidth = this.instance.applyFilters(
         'srcsetSizesWidth',
         this.displayedImageWidth,
         this
       );
   
       if (
         !image.dataset.largestUsedSize
         || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)
       ) {
         image.sizes = sizesWidth + 'px';
         image.dataset.largestUsedSize = String(sizesWidth);
       }
     }
   
     /**
      * @returns {boolean} If content should use a placeholder (from msrc by default)
      */
     usePlaceholder() {
       return this.instance.applyFilters(
         'useContentPlaceholder',
         this.isImageContent(),
         this
       );
     }
   
     /**
      * Preload content with lazy-loading param
      */
     lazyLoad() {
       if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) {
         return;
       }
   
       this.load(true);
     }
   
     /**
      * @returns {boolean} If placeholder should be kept after content is loaded
      */
     keepPlaceholder() {
       return this.instance.applyFilters(
         'isKeepingPlaceholder',
         this.isLoading(),
         this
       );
     }
   
     /**
      * Destroy the content
      */
     destroy() {
       this.hasSlide = false;
       this.slide = undefined;
   
       if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) {
         return;
       }
   
       this.remove();
   
       if (this.placeholder) {
         this.placeholder.destroy();
         this.placeholder = undefined;
       }
   
       if (this.isImageContent() && this.element) {
         this.element.onload = null;
         this.element.onerror = null;
         this.element = undefined;
       }
     }
   
     /**
      * Display error message
      */
     displayError() {
       if (this.slide) {
         let errorMsgEl = photoswipe_lightbox_esm_createElement('pswp__error-msg', 'div');
         errorMsgEl.innerText = this.instance.options?.errorMsg ?? '';
         errorMsgEl = /** @type {HTMLDivElement} */ (this.instance.applyFilters(
           'contentErrorElement',
           errorMsgEl,
           this
         ));
         this.element = photoswipe_lightbox_esm_createElement('pswp__content pswp__error-msg-container', 'div');
         this.element.appendChild(errorMsgEl);
         this.slide.container.innerText = '';
         this.slide.container.appendChild(this.element);
         this.slide.updateContentSize(true);
         this.removePlaceholder();
       }
     }
   
     /**
      * Append the content
      */
     append() {
       if (this.isAttached || !this.element) {
         return;
       }
   
       this.isAttached = true;
   
       if (this.state === LOAD_STATE.ERROR) {
         this.displayError();
         return;
       }
   
       if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) {
         return;
       }
   
       const supportsDecode = ('decode' in this.element);
   
       if (this.isImageContent()) {
         // Use decode() on nearby slides
         //
         // Nearby slide images are in DOM and not hidden via display:none.
         // However, they are placed offscreen (to the left and right side).
         //
         // Some browsers do not composite the image until it's actually visible,
         // using decode() helps.
         //
         // You might ask "why dont you just decode() and then append all images",
         // that's because I want to show image before it's fully loaded,
         // as browser can render parts of image while it is loading.
         // We do not do this in Safari due to partial loading bug.
         if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
           this.isDecoding = true;
           // purposefully using finally instead of then,
           // as if srcset sizes changes dynamically - it may cause decode error
           /** @type {HTMLImageElement} */
           (this.element).decode().catch(() => {}).finally(() => {
             this.isDecoding = false;
             this.appendImage();
           });
         } else {
           this.appendImage();
         }
       } else if (this.slide && !this.element.parentNode) {
         this.slide.container.appendChild(this.element);
       }
     }
   
     /**
      * Activate the slide,
      * active slide is generally the current one,
      * meaning the user can see it.
      */
     activate() {
       if (this.instance.dispatch('contentActivate', { content: this }).defaultPrevented
         || !this.slide) {
         return;
       }
   
       if (this.isImageContent() && this.isDecoding && !isSafari()) {
         // add image to slide when it becomes active,
         // even if it's not finished decoding
         this.appendImage();
       } else if (this.isError()) {
         this.load(false, true); // try to reload
       }
   
       if (this.slide.holderElement) {
         this.slide.holderElement.setAttribute('aria-hidden', 'false');
       }
     }
   
     /**
      * Deactivate the content
      */
     deactivate() {
       this.instance.dispatch('contentDeactivate', { content: this });
       if (this.slide && this.slide.holderElement) {
         this.slide.holderElement.setAttribute('aria-hidden', 'true');
       }
     }
   
   
     /**
      * Remove the content from DOM
      */
     remove() {
       this.isAttached = false;
   
       if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) {
         return;
       }
   
       if (this.element && this.element.parentNode) {
         this.element.remove();
       }
   
       if (this.placeholder && this.placeholder.element) {
         this.placeholder.element.remove();
       }
     }
   
     /**
      * Append the image content to slide container
      */
     appendImage() {
       if (!this.isAttached) {
         return;
       }
   
       if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented) {
         return;
       }
   
       // ensure that element exists and is not already appended
       if (this.slide && this.element && !this.element.parentNode) {
         this.slide.container.appendChild(this.element);
       }
   
       if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
         this.removePlaceholder();
       }
     }
   }
   
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../core/base.js').default} PhotoSwipeBase */
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   
   /**
    * @param {PhotoSwipeOptions} options
    * @param {PhotoSwipeBase} pswp
    * @returns {Point}
    */
   function getViewportSize(options, pswp) {
     if (options.getViewportSizeFn) {
       const newViewportSize = options.getViewportSizeFn(options, pswp);
       if (newViewportSize) {
         return newViewportSize;
       }
     }
   
     return {
       x: document.documentElement.clientWidth,
   
       // TODO: height on mobile is very incosistent due to toolbar
       // find a way to improve this
       //
       // document.documentElement.clientHeight - doesn't seem to work well
       y: window.innerHeight
     };
   }
   
   /**
    * Parses padding option.
    * Supported formats:
    *
    * // Object
    * padding: {
    *  top: 0,
    *  bottom: 0,
    *  left: 0,
    *  right: 0
    * }
    *
    * // A function that returns the object
    * paddingFn: (viewportSize, itemData, index) => {
    *  return {
    *    top: 0,
    *    bottom: 0,
    *    left: 0,
    *    right: 0
    *  };
    * }
    *
    * // Legacy variant
    * paddingLeft: 0,
    * paddingRight: 0,
    * paddingTop: 0,
    * paddingBottom: 0,
    *
    * @param {'left' | 'top' | 'bottom' | 'right'} prop
    * @param {PhotoSwipeOptions} options PhotoSwipe options
    * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
    * @param {SlideData} itemData Data about the slide
    * @param {number} index Slide index
    * @returns {number}
    */
   function parsePaddingOption(prop, options, viewportSize, itemData, index) {
     let paddingValue = 0;
   
     if (options.paddingFn) {
       paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
     } else if (options.padding) {
       paddingValue = options.padding[prop];
     } else {
       const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1);
       // @ts-expect-error
       if (options[legacyPropName]) {
         // @ts-expect-error
         paddingValue = options[legacyPropName];
       }
     }
   
     return Number(paddingValue) || 0;
   }
   
   /**
    * @param {PhotoSwipeOptions} options
    * @param {Point} viewportSize
    * @param {SlideData} itemData
    * @param {number} index
    * @returns {Point}
    */
   function getPanAreaSize(options, viewportSize, itemData, index) {
     return {
       x: viewportSize.x
         - parsePaddingOption('left', options, viewportSize, itemData, index)
         - parsePaddingOption('right', options, viewportSize, itemData, index),
       y: viewportSize.y
         - parsePaddingOption('top', options, viewportSize, itemData, index)
         - parsePaddingOption('bottom', options, viewportSize, itemData, index)
     };
   }
   
   const MAX_IMAGE_WIDTH = 4000;
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   
   /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */
   
   /**
    * Calculates zoom levels for specific slide.
    * Depends on viewport size and image size.
    */
   class ZoomLevel {
     /**
      * @param {PhotoSwipeOptions} options PhotoSwipe options
      * @param {SlideData} itemData Slide data
      * @param {number} index Slide index
      * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
      */
     constructor(options, itemData, index, pswp) {
       this.pswp = pswp;
       this.options = options;
       this.itemData = itemData;
       this.index = index;
       /** @type { Point | null } */
       this.panAreaSize = null;
       /** @type { Point | null } */
       this.elementSize = null;
       this.fit = 1;
       this.fill = 1;
       this.vFill = 1;
       this.initial = 1;
       this.secondary = 1;
       this.max = 1;
       this.min = 1;
     }
   
     /**
      * Calculate initial, secondary and maximum zoom level for the specified slide.
      *
      * It should be called when either image or viewport size changes.
      *
      * @param {number} maxWidth
      * @param {number} maxHeight
      * @param {Point} panAreaSize
      */
     update(maxWidth, maxHeight, panAreaSize) {
       /** @type {Point} */
       const elementSize = { x: maxWidth, y: maxHeight };
       this.elementSize = elementSize;
       this.panAreaSize = panAreaSize;
   
       const hRatio = panAreaSize.x / elementSize.x;
       const vRatio = panAreaSize.y / elementSize.y;
   
       this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
       this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
   
       // zoom.vFill defines zoom level of the image
       // when it has 100% of viewport vertical space (height)
       this.vFill = Math.min(1, vRatio);
   
       this.initial = this._getInitial();
       this.secondary = this._getSecondary();
       this.max = Math.max(
         this.initial,
         this.secondary,
         this._getMax()
       );
   
       this.min = Math.min(
         this.fit,
         this.initial,
         this.secondary
       );
   
       if (this.pswp) {
         this.pswp.dispatch('zoomLevelsUpdate', { zoomLevels: this, slideData: this.itemData });
       }
     }
   
     /**
      * Parses user-defined zoom option.
      *
      * @private
      * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
      * @returns { number | undefined }
      */
     _parseZoomLevelOption(optionPrefix) {
       const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ (
         optionPrefix + 'ZoomLevel'
       );
       const optionValue = this.options[optionName];
   
       if (!optionValue) {
         return;
       }
   
       if (typeof optionValue === 'function') {
         return optionValue(this);
       }
   
       if (optionValue === 'fill') {
         return this.fill;
       }
   
       if (optionValue === 'fit') {
         return this.fit;
       }
   
       return Number(optionValue);
     }
   
     /**
      * Get zoom level to which image will be zoomed after double-tap gesture,
      * or when user clicks on zoom icon,
      * or mouse-click on image itself.
      * If you return 1 image will be zoomed to its original size.
      *
      * @private
      * @return {number}
      */
     _getSecondary() {
       let currZoomLevel = this._parseZoomLevelOption('secondary');
   
       if (currZoomLevel) {
         return currZoomLevel;
       }
   
       // 3x of "fit" state, but not larger than original
       currZoomLevel = Math.min(1, this.fit * 3);
   
       if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
         currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
       }
   
       return currZoomLevel;
     }
   
     /**
      * Get initial image zoom level.
      *
      * @private
      * @return {number}
      */
     _getInitial() {
       return this._parseZoomLevelOption('initial') || this.fit;
     }
   
     /**
      * Maximum zoom level when user zooms
      * via zoom/pinch gesture,
      * via cmd/ctrl-wheel or via trackpad.
      *
      * @private
      * @return {number}
      */
     _getMax() {
       // max zoom level is x4 from "fit state",
       // used for zoom gesture and ctrl/trackpad zoom
       return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
     }
   }
   
   /**
    * Lazy-load an image
    * This function is used both by Lightbox and PhotoSwipe core,
    * thus it can be called before dialog is opened.
    *
    * @param {SlideData} itemData Data about the slide
    * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
    * @param {number} index
    * @returns {Content} Image that is being decoded or false.
    */
   function lazyLoadData(itemData, instance, index) {
     const content = instance.createContentFromData(itemData, index);
     /** @type {ZoomLevel | undefined} */
     let zoomLevel;
   
     const { options } = instance;
   
     // We need to know dimensions of the image to preload it,
     // as it might use srcset, and we need to define sizes
     if (options) {
       zoomLevel = new ZoomLevel(options, itemData, -1);
   
       let viewportSize;
       if (instance.pswp) {
         viewportSize = instance.pswp.viewportSize;
       } else {
         viewportSize = getViewportSize(options, instance);
       }
   
       const panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
       zoomLevel.update(content.width, content.height, panAreaSize);
     }
   
     content.lazyLoad();
   
     if (zoomLevel) {
       content.setDisplayedSize(
         Math.ceil(content.width * zoomLevel.initial),
         Math.ceil(content.height * zoomLevel.initial)
       );
     }
   
     return content;
   }
   
   
   /**
    * Lazy-loads specific slide.
    * This function is used both by Lightbox and PhotoSwipe core,
    * thus it can be called before dialog is opened.
    *
    * By default, it loads image based on viewport size and initial zoom level.
    *
    * @param {number} index Slide index
    * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
    * @returns {Content | undefined}
    */
   function lazyLoadSlide(index, instance) {
     const itemData = instance.getItemData(index);
   
     if (instance.dispatch('lazyLoadSlide', { index, itemData }).defaultPrevented) {
       return;
     }
   
     return lazyLoadData(itemData, instance, index);
   }
   
   /** @typedef {import("../photoswipe.js").default} PhotoSwipe */
   /** @typedef {import("../slide/slide.js").SlideData} SlideData */
   
   /**
    * PhotoSwipe base class that can retrieve data about every slide.
    * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
    */
   class PhotoSwipeBase extends Eventable {
     /**
      * Get total number of slides
      *
      * @returns {number}
      */
     getNumItems() {
       let numItems = 0;
       const dataSource = this.options?.dataSource;
   
       if (dataSource && 'length' in dataSource) {
         // may be an array or just object with length property
         numItems = dataSource.length;
       } else if (dataSource && 'gallery' in dataSource) {
         // query DOM elements
         if (!dataSource.items) {
           dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
         }
   
         if (dataSource.items) {
           numItems = dataSource.items.length;
         }
       }
   
       // legacy event, before filters were introduced
       const event = this.dispatch('numItems', {
         dataSource,
         numItems
       });
       return this.applyFilters('numItems', event.numItems, dataSource);
     }
   
     /**
      * @param {SlideData} slideData
      * @param {number} index
      * @returns {Content}
      */
     createContentFromData(slideData, index) {
       return new Content(slideData, this, index);
     }
   
     /**
      * Get item data by index.
      *
      * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
      * For example, it may contain properties like
      * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
      *
      * @param {number} index
      * @returns {SlideData}
      */
     getItemData(index) {
       const dataSource = this.options?.dataSource;
       /** @type {SlideData | HTMLElement} */
       let dataSourceItem = {};
       if (Array.isArray(dataSource)) {
         // Datasource is an array of elements
         dataSourceItem = dataSource[index];
       } else if (dataSource && 'gallery' in dataSource) {
         // dataSource has gallery property,
         // thus it was created by Lightbox, based on
         // gallery and children options
   
         // query DOM elements
         if (!dataSource.items) {
           dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
         }
   
         dataSourceItem = dataSource.items[index];
       }
   
       let itemData = dataSourceItem;
   
       if (itemData instanceof Element) {
         itemData = this._domElementToItemData(itemData);
       }
   
       // Dispatching the itemData event,
       // it's a legacy verion before filters were introduced
       const event = this.dispatch('itemData', {
         itemData: itemData || {},
         index
       });
   
       return this.applyFilters('itemData', event.itemData, index);
     }
   
     /**
      * Get array of gallery DOM elements,
      * based on childSelector and gallery element.
      *
      * @param {HTMLElement} galleryElement
      * @returns {HTMLElement[]}
      */
     _getGalleryDOMElements(galleryElement) {
       if (this.options?.children || this.options?.childSelector) {
         return getElementsFromOption(
           this.options.children,
           this.options.childSelector,
           galleryElement
         ) || [];
       }
   
       return [galleryElement];
     }
   
     /**
      * Converts DOM element to item data object.
      *
      * @param {HTMLElement} element DOM element
      * @returns {SlideData}
      */
     _domElementToItemData(element) {
       /** @type {SlideData} */
       const itemData = {
         element
       };
   
       const linkEl = /** @type {HTMLAnchorElement} */ (
         element.tagName === 'A'
           ? element
           : element.querySelector('a')
       );
   
       if (linkEl) {
         // src comes from data-pswp-src attribute,
         // if it's empty link href is used
         itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
   
         if (linkEl.dataset.pswpSrcset) {
           itemData.srcset = linkEl.dataset.pswpSrcset;
         }
   
         itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
         itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
   
         // support legacy w & h properties
         itemData.w = itemData.width;
         itemData.h = itemData.height;
   
         if (linkEl.dataset.pswpType) {
           itemData.type = linkEl.dataset.pswpType;
         }
   
         const thumbnailEl = element.querySelector('img');
   
         if (thumbnailEl) {
           // msrc is URL to placeholder image that's displayed before large image is loaded
           // by default it's displayed only for the first slide
           itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
           itemData.alt = thumbnailEl.getAttribute('alt') ?? '';
         }
   
         if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
           itemData.thumbCropped = true;
         }
       }
   
       return this.applyFilters('domItemData', itemData, element, linkEl);
     }
   
     /**
      * Lazy-load by slide data
      *
      * @param {SlideData} itemData Data about the slide
      * @param {number} index
      * @returns {Content} Image that is being decoded or false.
      */
     lazyLoadData(itemData, index) {
       return lazyLoadData(itemData, this, index);
     }
   }
   
   /**
    * @template T
    * @typedef {import('../types.js').Type<T>} Type<T>
    */
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../photoswipe.js').DataSource} DataSource */
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('../slide/content.js').default} Content */
   /** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */
   /** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */
   
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
    */
   
   /**
    * PhotoSwipe Lightbox
    *
    * - If user has unsupported browser it falls back to default browser action (just opens URL)
    * - Binds click event to links that should open PhotoSwipe
    * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
    * - Initializes PhotoSwipe
    *
    *
    * Loader options use the same object as PhotoSwipe, and supports such options:
    *
    * gallery - Element | Element[] | NodeList | string selector for the gallery element
    * children - Element | Element[] | NodeList | string selector for the gallery children
    *
    */
   class PhotoSwipeLightbox extends PhotoSwipeBase {
     /**
      * @param {PhotoSwipeOptions} [options]
      */
     constructor(options) {
       super();
       /** @type {PhotoSwipeOptions} */
       this.options = options || {};
       this._uid = 0;
       this.shouldOpen = false;
       /**
        * @private
        * @type {Content | undefined}
        */
       this._preloadedContent = undefined;
   
       this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
     }
   
     /**
      * Initialize lightbox, should be called only once.
      * It's not included in the main constructor, so you may bind events before it.
      */
     init() {
       // Bind click events to each gallery
       getElementsFromOption(this.options.gallery, this.options.gallerySelector)
         .forEach((galleryElement) => {
           galleryElement.addEventListener('click', this.onThumbnailsClick, false);
         });
     }
   
     /**
      * @param {MouseEvent} e
      */
     onThumbnailsClick(e) {
       // Exit and allow default browser action if:
       if (specialKeyUsed(e) // ... if clicked with a special key (ctrl/cmd...)
           || window.pswp // ... if PhotoSwipe is already open
           || window.navigator.onLine === false) { // ... if offline
         return;
       }
   
       // If both clientX and clientY are 0 or not defined,
       // the event is likely triggered by keyboard,
       // so we do not pass the initialPoint
       //
       // Note that some screen readers emulate the mouse position,
       // so it's not the ideal way to detect them.
       //
       /** @type {Point | null} */
       let initialPoint = { x: e.clientX, y: e.clientY };
   
       if (!initialPoint.x && !initialPoint.y) {
         initialPoint = null;
       }
   
       let clickedIndex = this.getClickedIndex(e);
       clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
       /** @type {DataSource} */
       const dataSource = {
         gallery: /** @type {HTMLElement} */ (e.currentTarget)
       };
   
       if (clickedIndex >= 0) {
         e.preventDefault();
         this.loadAndOpen(clickedIndex, dataSource, initialPoint);
       }
     }
   
     /**
      * Get index of gallery item that was clicked.
      *
      * @param {MouseEvent} e click event
      * @returns {number}
      */
     getClickedIndex(e) {
       // legacy option
       if (this.options.getClickedIndexFn) {
         return this.options.getClickedIndexFn.call(this, e);
       }
   
       const clickedTarget = /** @type {HTMLElement} */ (e.target);
       const childElements = getElementsFromOption(
         this.options.children,
         this.options.childSelector,
         /** @type {HTMLElement} */ (e.currentTarget)
       );
       const clickedChildIndex = childElements.findIndex(
         child => child === clickedTarget || child.contains(clickedTarget)
       );
   
       if (clickedChildIndex !== -1) {
         return clickedChildIndex;
       } else if (this.options.children || this.options.childSelector) {
         // click wasn't on a child element
         return -1;
       }
   
       // There is only one item (which is the gallery)
       return 0;
     }
   
     /**
      * Load and open PhotoSwipe
      *
      * @param {number} index
      * @param {DataSource} dataSource
      * @param {Point | null} [initialPoint]
      * @returns {boolean}
      */
     loadAndOpen(index, dataSource, initialPoint) {
       // Check if the gallery is already open
       if (window.pswp) {
         return false;
       }
   
       // set initial index
       this.options.index = index;
   
       // define options for PhotoSwipe constructor
       this.options.initialPointerPos = initialPoint;
   
       this.shouldOpen = true;
       this.preload(index, dataSource);
       return true;
     }
   
     /**
      * Load the main module and the slide content by index
      *
      * @param {number} index
      * @param {DataSource} [dataSource]
      */
     preload(index, dataSource) {
       const { options } = this;
   
       if (dataSource) {
         options.dataSource = dataSource;
       }
   
       // Add the main module
       /** @type {Promise<Type<PhotoSwipe>>[]} */
       const promiseArray = [];
   
       const pswpModuleType = typeof options.pswpModule;
       if (isPswpClass(options.pswpModule)) {
         promiseArray.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */ (options.pswpModule)));
       } else if (pswpModuleType === 'string') {
         throw new Error('pswpModule as string is no longer supported');
       } else if (pswpModuleType === 'function') {
         promiseArray.push(/** @type {() => Promise<Type<PhotoSwipe>>} */ (options.pswpModule)());
       } else {
         throw new Error('pswpModule is not valid');
       }
   
       // Add custom-defined promise, if any
       if (typeof options.openPromise === 'function') {
         // allow developers to perform some task before opening
         promiseArray.push(options.openPromise());
       }
   
       if (options.preloadFirstSlide !== false && index >= 0) {
         this._preloadedContent = lazyLoadSlide(index, this);
       }
   
       // Wait till all promises resolve and open PhotoSwipe
       const uid = ++this._uid;
       Promise.all(promiseArray).then((iterableModules) => {
         if (this.shouldOpen) {
           const mainModule = iterableModules[0];
           this._openPhotoswipe(mainModule, uid);
         }
       });
     }
   
     /**
      * @private
      * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
      * @param {number} uid
      */
     _openPhotoswipe(module, uid) {
       // Cancel opening if UID doesn't match the current one
       // (if user clicked on another gallery item before current was loaded).
       //
       // Or if shouldOpen flag is set to false
       // (developer may modify it via public API)
       if (uid !== this._uid && this.shouldOpen) {
         return;
       }
   
       this.shouldOpen = false;
   
       // PhotoSwipe is already open
       if (window.pswp) {
         return;
       }
   
       /**
        * Pass data to PhotoSwipe and open init
        *
        * @type {PhotoSwipe}
        */
       const pswp = typeof module === 'object'
           ? new module.default(this.options) // eslint-disable-line
           : new module(this.options); // eslint-disable-line
   
       this.pswp = pswp;
       window.pswp = pswp;
   
       // map listeners from Lightbox to PhotoSwipe Core
       /** @type {(keyof PhotoSwipeEventsMap)[]} */
       (Object.keys(this._listeners)).forEach((name) => {
         this._listeners[name]?.forEach((fn) => {
           pswp.on(name, /** @type {EventCallback<typeof name>} */(fn));
         });
       });
   
       // same with filters
       /** @type {(keyof PhotoSwipeFiltersMap)[]} */
       (Object.keys(this._filters)).forEach((name) => {
         this._filters[name]?.forEach((filter) => {
           pswp.addFilter(name, filter.fn, filter.priority);
         });
       });
   
       if (this._preloadedContent) {
         pswp.contentLoader.addToCache(this._preloadedContent);
         this._preloadedContent = undefined;
       }
   
       pswp.on('destroy', () => {
         // clean up public variables
         this.pswp = undefined;
         delete window.pswp;
       });
   
       pswp.init();
     }
   
     /**
      * Unbinds all events, closes PhotoSwipe if it's open.
      */
     destroy() {
       this.pswp?.destroy();
   
       this.shouldOpen = false;
       this._listeners = {};
   
       getElementsFromOption(this.options.gallery, this.options.gallerySelector)
         .forEach((galleryElement) => {
           galleryElement.removeEventListener('click', this.onThumbnailsClick, false);
         });
     }
   }
   
   
   //# sourceMappingURL=photoswipe-lightbox.esm.js.map
   
   ;// CONCATENATED MODULE: ./node_modules/photoswipe/dist/photoswipe.esm.js
   /*!
     * PhotoSwipe 5.3.7 - https://photoswipe.com
     * (c) 2023 Dmytro Semenov
     */
   /** @typedef {import('../photoswipe.js').Point} Point */
   
   /**
    * @template {keyof HTMLElementTagNameMap} T
    * @param {string} className
    * @param {T} tagName
    * @param {Node} [appendToEl]
    * @returns {HTMLElementTagNameMap[T]}
    */
   function photoswipe_esm_createElement(className, tagName, appendToEl) {
     const el = document.createElement(tagName);
     if (className) {
       el.className = className;
     }
     if (appendToEl) {
       appendToEl.appendChild(el);
     }
     return el;
   }
   
   /**
    * @param {Point} p1
    * @param {Point} p2
    * @returns {Point}
    */
   function equalizePoints(p1, p2) {
     p1.x = p2.x;
     p1.y = p2.y;
     if (p2.id !== undefined) {
       p1.id = p2.id;
     }
     return p1;
   }
   
   /**
    * @param {Point} p
    */
   function roundPoint(p) {
     p.x = Math.round(p.x);
     p.y = Math.round(p.y);
   }
   
   /**
    * Returns distance between two points.
    *
    * @param {Point} p1
    * @param {Point} p2
    * @returns {number}
    */
   function getDistanceBetween(p1, p2) {
     const x = Math.abs(p1.x - p2.x);
     const y = Math.abs(p1.y - p2.y);
     return Math.sqrt((x * x) + (y * y));
   }
   
   /**
    * Whether X and Y positions of points are equal
    *
    * @param {Point} p1
    * @param {Point} p2
    * @returns {boolean}
    */
   function pointsEqual(p1, p2) {
     return p1.x === p2.x && p1.y === p2.y;
   }
   
   /**
    * The float result between the min and max values.
    *
    * @param {number} val
    * @param {number} min
    * @param {number} max
    * @returns {number}
    */
   function clamp(val, min, max) {
     return Math.min(Math.max(val, min), max);
   }
   
   /**
    * Get transform string
    *
    * @param {number} x
    * @param {number} [y]
    * @param {number} [scale]
    * @returns {string}
    */
   function photoswipe_esm_toTransformString(x, y, scale) {
     let propValue = `translate3d(${x}px,${y || 0}px,0)`;
   
     if (scale !== undefined) {
       propValue += ` scale3d(${scale},${scale},1)`;
     }
   
     return propValue;
   }
   
   /**
    * Apply transform:translate(x, y) scale(scale) to element
    *
    * @param {HTMLElement} el
    * @param {number} x
    * @param {number} [y]
    * @param {number} [scale]
    */
   function setTransform(el, x, y, scale) {
     el.style.transform = photoswipe_esm_toTransformString(x, y, scale);
   }
   
   const defaultCSSEasing = 'cubic-bezier(.4,0,.22,1)';
   
   /**
    * Apply CSS transition to element
    *
    * @param {HTMLElement} el
    * @param {string} [prop] CSS property to animate
    * @param {number} [duration] in ms
    * @param {string} [ease] CSS easing function
    */
   function setTransitionStyle(el, prop, duration, ease) {
     // inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
     // out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
     // in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
     el.style.transition = prop
       ? `${prop} ${duration}ms ${ease || defaultCSSEasing}`
       : 'none';
   }
   
   /**
    * Apply width and height CSS properties to element
    *
    * @param {HTMLElement} el
    * @param {string | number} w
    * @param {string | number} h
    */
   function photoswipe_esm_setWidthHeight(el, w, h) {
     el.style.width = (typeof w === 'number') ? `${w}px` : w;
     el.style.height = (typeof h === 'number') ? `${h}px` : h;
   }
   
   /**
    * @param {HTMLElement} el
    */
   function removeTransitionStyle(el) {
     setTransitionStyle(el);
   }
   
   /**
    * @param {HTMLImageElement} img
    * @returns {Promise<HTMLImageElement | void>}
    */
   function decodeImage(img) {
     if ('decode' in img) {
       return img.decode().catch(() => {});
     }
   
     if (img.complete) {
       return Promise.resolve(img);
     }
   
     return new Promise((resolve, reject) => {
       img.onload = () => resolve(img);
       img.onerror = reject;
     });
   }
   
   /** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */
   /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */
   const photoswipe_esm_LOAD_STATE = {
     IDLE: 'idle',
     LOADING: 'loading',
     LOADED: 'loaded',
     ERROR: 'error',
   };
   
   
   /**
    * Check if click or keydown event was dispatched
    * with a special key or via mouse wheel.
    *
    * @param {MouseEvent | KeyboardEvent} e
    * @returns {boolean}
    */
   function photoswipe_esm_specialKeyUsed(e) {
     return ('button' in e && e.button === 1) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
   }
   
   /**
    * Parse `gallery` or `children` options.
    *
    * @param {import('../photoswipe.js').ElementProvider} [option]
    * @param {string} [legacySelector]
    * @param {HTMLElement | Document} [parent]
    * @returns HTMLElement[]
    */
   function photoswipe_esm_getElementsFromOption(option, legacySelector, parent = document) {
     /** @type {HTMLElement[]} */
     let elements = [];
   
     if (option instanceof Element) {
       elements = [option];
     } else if (option instanceof NodeList || Array.isArray(option)) {
       elements = Array.from(option);
     } else {
       const selector = typeof option === 'string' ? option : legacySelector;
       if (selector) {
         elements = Array.from(parent.querySelectorAll(selector));
       }
     }
   
     return elements;
   }
   
   /**
    * Check if browser is Safari
    *
    * @returns {boolean}
    */
   function photoswipe_esm_isSafari() {
     return !!(navigator.vendor && navigator.vendor.match(/apple/i));
   }
   
   // Detect passive event listener support
   let photoswipe_esm_supportsPassive = false;
   /* eslint-disable */
   try {
     /* @ts-ignore */
     window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
       get: () => {
         photoswipe_esm_supportsPassive = true;
       }
     }));
   } catch (e) {}
   /* eslint-enable */
   
   /**
    * @typedef {Object} PoolItem
    * @prop {HTMLElement | Window | Document | undefined | null} target
    * @prop {string} type
    * @prop {EventListenerOrEventListenerObject} listener
    * @prop {boolean} [passive]
    */
   
   class DOMEvents {
     constructor() {
       /**
        * @type {PoolItem[]}
        * @private
        */
       this._pool = [];
     }
   
     /**
      * Adds event listeners
      *
      * @param {PoolItem['target']} target
      * @param {PoolItem['type']} type Can be multiple, separated by space.
      * @param {PoolItem['listener']} listener
      * @param {PoolItem['passive']} [passive]
      */
     add(target, type, listener, passive) {
       this._toggleListener(target, type, listener, passive);
     }
   
     /**
      * Removes event listeners
      *
      * @param {PoolItem['target']} target
      * @param {PoolItem['type']} type
      * @param {PoolItem['listener']} listener
      * @param {PoolItem['passive']} [passive]
      */
     remove(target, type, listener, passive) {
       this._toggleListener(target, type, listener, passive, true);
     }
   
     /**
      * Removes all bound events
      */
     removeAll() {
       this._pool.forEach((poolItem) => {
         this._toggleListener(
           poolItem.target,
           poolItem.type,
           poolItem.listener,
           poolItem.passive,
           true,
           true
         );
       });
       this._pool = [];
     }
   
     /**
      * Adds or removes event
      *
      * @private
      * @param {PoolItem['target']} target
      * @param {PoolItem['type']} type
      * @param {PoolItem['listener']} listener
      * @param {PoolItem['passive']} [passive]
      * @param {boolean} [unbind] Whether the event should be added or removed
      * @param {boolean} [skipPool] Whether events pool should be skipped
      */
     _toggleListener(target, type, listener, passive, unbind, skipPool) {
       if (!target) {
         return;
       }
   
       const methodName = unbind ? 'removeEventListener' : 'addEventListener';
       const types = type.split(' ');
       types.forEach((eType) => {
         if (eType) {
           // Events pool is used to easily unbind all events when PhotoSwipe is closed,
           // so developer doesn't need to do this manually
           if (!skipPool) {
             if (unbind) {
               // Remove from the events pool
               this._pool = this._pool.filter((poolItem) => {
                 return poolItem.type !== eType
                   || poolItem.listener !== listener
                   || poolItem.target !== target;
               });
             } else {
               // Add to the events pool
               this._pool.push({
                 target,
                 type: eType,
                 listener,
                 passive
               });
             }
           }
   
           // most PhotoSwipe events call preventDefault,
           // and we do not need browser to scroll the page
           const eventOptions = photoswipe_esm_supportsPassive ? { passive: (passive || false) } : false;
   
           target[methodName](
             eType,
             listener,
             eventOptions
           );
         }
       });
     }
   }
   
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../core/base.js').default} PhotoSwipeBase */
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   
   /**
    * @param {PhotoSwipeOptions} options
    * @param {PhotoSwipeBase} pswp
    * @returns {Point}
    */
   function photoswipe_esm_getViewportSize(options, pswp) {
     if (options.getViewportSizeFn) {
       const newViewportSize = options.getViewportSizeFn(options, pswp);
       if (newViewportSize) {
         return newViewportSize;
       }
     }
   
     return {
       x: document.documentElement.clientWidth,
   
       // TODO: height on mobile is very incosistent due to toolbar
       // find a way to improve this
       //
       // document.documentElement.clientHeight - doesn't seem to work well
       y: window.innerHeight
     };
   }
   
   /**
    * Parses padding option.
    * Supported formats:
    *
    * // Object
    * padding: {
    *  top: 0,
    *  bottom: 0,
    *  left: 0,
    *  right: 0
    * }
    *
    * // A function that returns the object
    * paddingFn: (viewportSize, itemData, index) => {
    *  return {
    *    top: 0,
    *    bottom: 0,
    *    left: 0,
    *    right: 0
    *  };
    * }
    *
    * // Legacy variant
    * paddingLeft: 0,
    * paddingRight: 0,
    * paddingTop: 0,
    * paddingBottom: 0,
    *
    * @param {'left' | 'top' | 'bottom' | 'right'} prop
    * @param {PhotoSwipeOptions} options PhotoSwipe options
    * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
    * @param {SlideData} itemData Data about the slide
    * @param {number} index Slide index
    * @returns {number}
    */
   function photoswipe_esm_parsePaddingOption(prop, options, viewportSize, itemData, index) {
     let paddingValue = 0;
   
     if (options.paddingFn) {
       paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
     } else if (options.padding) {
       paddingValue = options.padding[prop];
     } else {
       const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1);
       // @ts-expect-error
       if (options[legacyPropName]) {
         // @ts-expect-error
         paddingValue = options[legacyPropName];
       }
     }
   
     return Number(paddingValue) || 0;
   }
   
   /**
    * @param {PhotoSwipeOptions} options
    * @param {Point} viewportSize
    * @param {SlideData} itemData
    * @param {number} index
    * @returns {Point}
    */
   function photoswipe_esm_getPanAreaSize(options, viewportSize, itemData, index) {
     return {
       x: viewportSize.x
         - photoswipe_esm_parsePaddingOption('left', options, viewportSize, itemData, index)
         - photoswipe_esm_parsePaddingOption('right', options, viewportSize, itemData, index),
       y: viewportSize.y
         - photoswipe_esm_parsePaddingOption('top', options, viewportSize, itemData, index)
         - photoswipe_esm_parsePaddingOption('bottom', options, viewportSize, itemData, index)
     };
   }
   
   /** @typedef {import('./slide.js').default} Slide */
   /** @typedef {Record<Axis, number>} Point */
   /** @typedef {'x' | 'y'} Axis */
   
   /**
    * Calculates minimum, maximum and initial (center) bounds of a slide
    */
   class PanBounds {
     /**
      * @param {Slide} slide
      */
     constructor(slide) {
       this.slide = slide;
       this.currZoomLevel = 1;
       this.center = /** @type {Point} */ { x: 0, y: 0 };
       this.max = /** @type {Point} */ { x: 0, y: 0 };
       this.min = /** @type {Point} */ { x: 0, y: 0 };
     }
   
     /**
      * _getItemBounds
      *
      * @param {number} currZoomLevel
      */
     update(currZoomLevel) {
       this.currZoomLevel = currZoomLevel;
   
       if (!this.slide.width) {
         this.reset();
       } else {
         this._updateAxis('x');
         this._updateAxis('y');
         this.slide.pswp.dispatch('calcBounds', { slide: this.slide });
       }
     }
   
     /**
      * _calculateItemBoundsForAxis
      *
      * @param {Axis} axis
      */
     _updateAxis(axis) {
       const { pswp } = this.slide;
       const elSize = this.slide[axis === 'x' ? 'width' : 'height'] * this.currZoomLevel;
       const paddingProp = axis === 'x' ? 'left' : 'top';
       const padding = photoswipe_esm_parsePaddingOption(
         paddingProp,
         pswp.options,
         pswp.viewportSize,
         this.slide.data,
         this.slide.index
       );
   
       const panAreaSize = this.slide.panAreaSize[axis];
   
       // Default position of element.
       // By default, it is center of viewport:
       this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding;
   
       // maximum pan position
       this.max[axis] = (elSize > panAreaSize)
         ? Math.round(panAreaSize - elSize) + padding
         : this.center[axis];
   
       // minimum pan position
       this.min[axis] = (elSize > panAreaSize)
         ? padding
         : this.center[axis];
     }
   
     // _getZeroBounds
     reset() {
       this.center.x = 0;
       this.center.y = 0;
       this.max.x = 0;
       this.max.y = 0;
       this.min.x = 0;
       this.min.y = 0;
     }
   
     /**
      * Correct pan position if it's beyond the bounds
      *
      * @param {Axis} axis x or y
      * @param {number} panOffset
      * @returns {number}
      */
     correctPan(axis, panOffset) { // checkPanBounds
       return clamp(panOffset, this.max[axis], this.min[axis]);
     }
   }
   
   const photoswipe_esm_MAX_IMAGE_WIDTH = 4000;
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   
   /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */
   
   /**
    * Calculates zoom levels for specific slide.
    * Depends on viewport size and image size.
    */
   class photoswipe_esm_ZoomLevel {
     /**
      * @param {PhotoSwipeOptions} options PhotoSwipe options
      * @param {SlideData} itemData Slide data
      * @param {number} index Slide index
      * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
      */
     constructor(options, itemData, index, pswp) {
       this.pswp = pswp;
       this.options = options;
       this.itemData = itemData;
       this.index = index;
       /** @type { Point | null } */
       this.panAreaSize = null;
       /** @type { Point | null } */
       this.elementSize = null;
       this.fit = 1;
       this.fill = 1;
       this.vFill = 1;
       this.initial = 1;
       this.secondary = 1;
       this.max = 1;
       this.min = 1;
     }
   
     /**
      * Calculate initial, secondary and maximum zoom level for the specified slide.
      *
      * It should be called when either image or viewport size changes.
      *
      * @param {number} maxWidth
      * @param {number} maxHeight
      * @param {Point} panAreaSize
      */
     update(maxWidth, maxHeight, panAreaSize) {
       /** @type {Point} */
       const elementSize = { x: maxWidth, y: maxHeight };
       this.elementSize = elementSize;
       this.panAreaSize = panAreaSize;
   
       const hRatio = panAreaSize.x / elementSize.x;
       const vRatio = panAreaSize.y / elementSize.y;
   
       this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
       this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio);
   
       // zoom.vFill defines zoom level of the image
       // when it has 100% of viewport vertical space (height)
       this.vFill = Math.min(1, vRatio);
   
       this.initial = this._getInitial();
       this.secondary = this._getSecondary();
       this.max = Math.max(
         this.initial,
         this.secondary,
         this._getMax()
       );
   
       this.min = Math.min(
         this.fit,
         this.initial,
         this.secondary
       );
   
       if (this.pswp) {
         this.pswp.dispatch('zoomLevelsUpdate', { zoomLevels: this, slideData: this.itemData });
       }
     }
   
     /**
      * Parses user-defined zoom option.
      *
      * @private
      * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
      * @returns { number | undefined }
      */
     _parseZoomLevelOption(optionPrefix) {
       const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ (
         optionPrefix + 'ZoomLevel'
       );
       const optionValue = this.options[optionName];
   
       if (!optionValue) {
         return;
       }
   
       if (typeof optionValue === 'function') {
         return optionValue(this);
       }
   
       if (optionValue === 'fill') {
         return this.fill;
       }
   
       if (optionValue === 'fit') {
         return this.fit;
       }
   
       return Number(optionValue);
     }
   
     /**
      * Get zoom level to which image will be zoomed after double-tap gesture,
      * or when user clicks on zoom icon,
      * or mouse-click on image itself.
      * If you return 1 image will be zoomed to its original size.
      *
      * @private
      * @return {number}
      */
     _getSecondary() {
       let currZoomLevel = this._parseZoomLevelOption('secondary');
   
       if (currZoomLevel) {
         return currZoomLevel;
       }
   
       // 3x of "fit" state, but not larger than original
       currZoomLevel = Math.min(1, this.fit * 3);
   
       if (this.elementSize && currZoomLevel * this.elementSize.x > photoswipe_esm_MAX_IMAGE_WIDTH) {
         currZoomLevel = photoswipe_esm_MAX_IMAGE_WIDTH / this.elementSize.x;
       }
   
       return currZoomLevel;
     }
   
     /**
      * Get initial image zoom level.
      *
      * @private
      * @return {number}
      */
     _getInitial() {
       return this._parseZoomLevelOption('initial') || this.fit;
     }
   
     /**
      * Maximum zoom level when user zooms
      * via zoom/pinch gesture,
      * via cmd/ctrl-wheel or via trackpad.
      *
      * @private
      * @return {number}
      */
     _getMax() {
       // max zoom level is x4 from "fit state",
       // used for zoom gesture and ctrl/trackpad zoom
       return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
     }
   }
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   
   /**
    * Renders and allows to control a single slide
    */
   class Slide {
     /**
      * @param {SlideData} data
      * @param {number} index
      * @param {PhotoSwipe} pswp
      */
     constructor(data, index, pswp) {
       this.data = data;
       this.index = index;
       this.pswp = pswp;
       this.isActive = (index === pswp.currIndex);
       this.currentResolution = 0;
       /** @type {Point} */
       this.panAreaSize = { x: 0, y: 0 };
       /** @type {Point} */
       this.pan = { x: 0, y: 0 };
   
       this.isFirstSlide = (this.isActive && !pswp.opener.isOpen);
   
       this.zoomLevels = new photoswipe_esm_ZoomLevel(pswp.options, data, index, pswp);
   
       this.pswp.dispatch('gettingData', {
         slide: this,
         data: this.data,
         index
       });
   
       this.content = this.pswp.contentLoader.getContentBySlide(this);
       this.container = photoswipe_esm_createElement('pswp__zoom-wrap', 'div');
       /** @type {HTMLElement | null} */
       this.holderElement = null;
   
       this.currZoomLevel = 1;
       /** @type {number} */
       this.width = this.content.width;
       /** @type {number} */
       this.height = this.content.height;
       this.heavyAppended = false;
       this.bounds = new PanBounds(this);
   
       this.prevDisplayedWidth = -1;
       this.prevDisplayedHeight = -1;
   
       this.pswp.dispatch('slideInit', { slide: this });
     }
   
     /**
      * If this slide is active/current/visible
      *
      * @param {boolean} isActive
      */
     setIsActive(isActive) {
       if (isActive && !this.isActive) {
         // slide just became active
         this.activate();
       } else if (!isActive && this.isActive) {
         // slide just became non-active
         this.deactivate();
       }
     }
   
     /**
      * Appends slide content to DOM
      *
      * @param {HTMLElement} holderElement
      */
     append(holderElement) {
       this.holderElement = holderElement;
   
       this.container.style.transformOrigin = '0 0';
   
       // Slide appended to DOM
       if (!this.data) {
         return;
       }
   
       this.calculateSize();
   
       this.load();
       this.updateContentSize();
       this.appendHeavy();
   
       this.holderElement.appendChild(this.container);
   
       this.zoomAndPanToInitial();
   
       this.pswp.dispatch('firstZoomPan', { slide: this });
   
       this.applyCurrentZoomPan();
   
       this.pswp.dispatch('afterSetContent', { slide: this });
   
       if (this.isActive) {
         this.activate();
       }
     }
   
     load() {
       this.content.load(false);
       this.pswp.dispatch('slideLoad', { slide: this });
     }
   
     /**
      * Append "heavy" DOM elements
      *
      * This may depend on a type of slide,
      * but generally these are large images.
      */
     appendHeavy() {
       const { pswp } = this;
       const appendHeavyNearby = true; // todo
   
       // Avoid appending heavy elements during animations
       if (this.heavyAppended
           || !pswp.opener.isOpen
           || pswp.mainScroll.isShifted()
           || (!this.isActive && !appendHeavyNearby)) {
         return;
       }
   
       if (this.pswp.dispatch('appendHeavy', { slide: this }).defaultPrevented) {
         return;
       }
   
       this.heavyAppended = true;
   
       this.content.append();
   
       this.pswp.dispatch('appendHeavyContent', { slide: this });
     }
   
     /**
      * Triggered when this slide is active (selected).
      *
      * If it's part of opening/closing transition -
      * activate() will trigger after the transition is ended.
      */
     activate() {
       this.isActive = true;
       this.appendHeavy();
       this.content.activate();
       this.pswp.dispatch('slideActivate', { slide: this });
     }
   
     /**
      * Triggered when this slide becomes inactive.
      *
      * Slide can become inactive only after it was active.
      */
     deactivate() {
       this.isActive = false;
       this.content.deactivate();
   
       if (this.currZoomLevel !== this.zoomLevels.initial) {
         // allow filtering
         this.calculateSize();
       }
   
       // reset zoom level
       this.currentResolution = 0;
       this.zoomAndPanToInitial();
       this.applyCurrentZoomPan();
       this.updateContentSize();
   
       this.pswp.dispatch('slideDeactivate', { slide: this });
     }
   
     /**
      * The slide should destroy itself, it will never be used again.
      * (unbind all events and destroy internal components)
      */
     destroy() {
       this.content.hasSlide = false;
       this.content.remove();
       this.container.remove();
       this.pswp.dispatch('slideDestroy', { slide: this });
     }
   
     resize() {
       if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
         // Keep initial zoom level if it was before the resize,
         // as well as when this slide is not active
   
         // Reset position and scale to original state
         this.calculateSize();
         this.currentResolution = 0;
         this.zoomAndPanToInitial();
         this.applyCurrentZoomPan();
         this.updateContentSize();
       } else {
         // readjust pan position if it's beyond the bounds
         this.calculateSize();
         this.bounds.update(this.currZoomLevel);
         this.panTo(this.pan.x, this.pan.y);
       }
     }
   
   
     /**
      * Apply size to current slide content,
      * based on the current resolution and scale.
      *
      * @param {boolean} [force] if size should be updated even if dimensions weren't changed
      */
     updateContentSize(force) {
       // Use initial zoom level
       // if resolution is not defined (user didn't zoom yet)
       const scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
   
       if (!scaleMultiplier) {
         return;
       }
   
       const width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
       const height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
   
       if (!this.sizeChanged(width, height) && !force) {
         return;
       }
       this.content.setDisplayedSize(width, height);
     }
   
     /**
      * @param {number} width
      * @param {number} height
      */
     sizeChanged(width, height) {
       if (width !== this.prevDisplayedWidth
           || height !== this.prevDisplayedHeight) {
         this.prevDisplayedWidth = width;
         this.prevDisplayedHeight = height;
         return true;
       }
   
       return false;
     }
   
     /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */
     getPlaceholderElement() {
       return this.content.placeholder?.element;
     }
   
     /**
      * Zoom current slide image to...
      *
      * @param {number} destZoomLevel Destination zoom level.
      * @param {Point} [centerPoint]
      * Transform origin center point, or false if viewport center should be used.
      * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
      * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
      */
     zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
       const { pswp } = this;
       if (!this.isZoomable()
           || pswp.mainScroll.isShifted()) {
         return;
       }
   
       pswp.dispatch('beforeZoomTo', {
         destZoomLevel, centerPoint, transitionDuration
       });
   
       // stop all pan and zoom transitions
       pswp.animations.stopAllPan();
   
       // if (!centerPoint) {
       //   centerPoint = pswp.getViewportCenterPoint();
       // }
   
       const prevZoomLevel = this.currZoomLevel;
   
       if (!ignoreBounds) {
         destZoomLevel = clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
       }
   
       // if (transitionDuration === undefined) {
       //   transitionDuration = this.pswp.options.zoomAnimationDuration;
       // }
   
       this.setZoomLevel(destZoomLevel);
       this.pan.x = this.calculateZoomToPanOffset('x', centerPoint, prevZoomLevel);
       this.pan.y = this.calculateZoomToPanOffset('y', centerPoint, prevZoomLevel);
       roundPoint(this.pan);
   
       const finishTransition = () => {
         this._setResolution(destZoomLevel);
         this.applyCurrentZoomPan();
       };
   
       if (!transitionDuration) {
         finishTransition();
       } else {
         pswp.animations.startTransition({
           isPan: true,
           name: 'zoomTo',
           target: this.container,
           transform: this.getCurrentTransform(),
           onComplete: finishTransition,
           duration: transitionDuration,
           easing: pswp.options.easing
         });
       }
     }
   
     /**
      * @param {Point} [centerPoint]
      */
     toggleZoom(centerPoint) {
       this.zoomTo(
         this.currZoomLevel === this.zoomLevels.initial
           ? this.zoomLevels.secondary : this.zoomLevels.initial,
         centerPoint,
         this.pswp.options.zoomAnimationDuration
       );
     }
   
     /**
      * Updates zoom level property and recalculates new pan bounds,
      * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
      *
      * @param {number} currZoomLevel
      */
     setZoomLevel(currZoomLevel) {
       this.currZoomLevel = currZoomLevel;
       this.bounds.update(this.currZoomLevel);
     }
   
     /**
      * Get pan position after zoom at a given `point`.
      *
      * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
      * pan bounds according to the new zoom level.
      *
      * @param {'x' | 'y'} axis
      * @param {Point} [point]
      * point based on which zoom is performed, usually refers to the current mouse position,
      * if false - viewport center will be used.
      * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
      * @returns {number}
      */
     calculateZoomToPanOffset(axis, point, prevZoomLevel) {
       const totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
       if (totalPanDistance === 0) {
         return this.bounds.center[axis];
       }
   
       if (!point) {
         point = this.pswp.getViewportCenterPoint();
       }
   
       if (!prevZoomLevel) {
         prevZoomLevel = this.zoomLevels.initial;
       }
   
       const zoomFactor = this.currZoomLevel / prevZoomLevel;
       return this.bounds.correctPan(
         axis,
         (this.pan[axis] - point[axis]) * zoomFactor + point[axis]
       );
     }
   
     /**
      * Apply pan and keep it within bounds.
      *
      * @param {number} panX
      * @param {number} panY
      */
     panTo(panX, panY) {
       this.pan.x = this.bounds.correctPan('x', panX);
       this.pan.y = this.bounds.correctPan('y', panY);
       this.applyCurrentZoomPan();
     }
   
     /**
      * If the slide in the current state can be panned by the user
      * @returns {boolean}
      */
     isPannable() {
       return Boolean(this.width) && (this.currZoomLevel > this.zoomLevels.fit);
     }
   
     /**
      * If the slide can be zoomed
      * @returns {boolean}
      */
     isZoomable() {
       return Boolean(this.width) && this.content.isZoomable();
     }
   
     /**
      * Apply transform and scale based on
      * the current pan position (this.pan) and zoom level (this.currZoomLevel)
      */
     applyCurrentZoomPan() {
       this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
       if (this === this.pswp.currSlide) {
         this.pswp.dispatch('zoomPanUpdate', { slide: this });
       }
     }
   
     zoomAndPanToInitial() {
       this.currZoomLevel = this.zoomLevels.initial;
   
       // pan according to the zoom level
       this.bounds.update(this.currZoomLevel);
       equalizePoints(this.pan, this.bounds.center);
       this.pswp.dispatch('initialZoomPan', { slide: this });
     }
   
     /**
      * Set translate and scale based on current resolution
      *
      * @param {number} x
      * @param {number} y
      * @param {number} zoom
      * @private
      */
     _applyZoomTransform(x, y, zoom) {
       zoom /= this.currentResolution || this.zoomLevels.initial;
       setTransform(this.container, x, y, zoom);
     }
   
     calculateSize() {
       const { pswp } = this;
   
       equalizePoints(
         this.panAreaSize,
         photoswipe_esm_getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index)
       );
   
       this.zoomLevels.update(this.width, this.height, this.panAreaSize);
   
       pswp.dispatch('calcSlideSize', {
         slide: this
       });
     }
   
     /** @returns {string} */
     getCurrentTransform() {
       const scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
       return photoswipe_esm_toTransformString(this.pan.x, this.pan.y, scale);
     }
   
     /**
      * Set resolution and re-render the image.
      *
      * For example, if the real image size is 2000x1500,
      * and resolution is 0.5 - it will be rendered as 1000x750.
      *
      * Image with zoom level 2 and resolution 0.5 is
      * the same as image with zoom level 1 and resolution 1.
      *
      * Used to optimize animations and make
      * sure that browser renders image in the highest quality.
      * Also used by responsive images to load the correct one.
      *
      * @param {number} newResolution
      */
     _setResolution(newResolution) {
       if (newResolution === this.currentResolution) {
         return;
       }
   
       this.currentResolution = newResolution;
       this.updateContentSize();
   
       this.pswp.dispatch('resolutionChanged');
     }
   }
   
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('./gestures.js').default} Gestures */
   
   const PAN_END_FRICTION = 0.35;
   const VERTICAL_DRAG_FRICTION = 0.6;
   
   // 1 corresponds to the third of viewport height
   const MIN_RATIO_TO_CLOSE = 0.4;
   
   // Minimum speed required to navigate
   // to next or previous slide
   const MIN_NEXT_SLIDE_SPEED = 0.5;
   
   /**
    * @param {number} initialVelocity
    * @param {number} decelerationRate
    * @returns {number}
    */
   function project(initialVelocity, decelerationRate) {
     return initialVelocity * decelerationRate / (1 - decelerationRate);
   }
   
   /**
    * Handles single pointer dragging
    */
   class DragHandler {
     /**
      * @param {Gestures} gestures
      */
     constructor(gestures) {
       this.gestures = gestures;
       this.pswp = gestures.pswp;
       /** @type {Point} */
       this.startPan = { x: 0, y: 0 };
     }
   
     start() {
       if (this.pswp.currSlide) {
         equalizePoints(this.startPan, this.pswp.currSlide.pan);
       }
       this.pswp.animations.stopAll();
     }
   
     change() {
       const { p1, prevP1, dragAxis } = this.gestures;
       const { currSlide } = this.pswp;
   
       if (dragAxis === 'y'
           && this.pswp.options.closeOnVerticalDrag
           && (currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit)
           && !this.gestures.isMultitouch) {
         // Handle vertical drag to close
         const panY = currSlide.pan.y + (p1.y - prevP1.y);
         if (!this.pswp.dispatch('verticalDrag', { panY }).defaultPrevented) {
           this._setPanWithFriction('y', panY, VERTICAL_DRAG_FRICTION);
           const bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
           this.pswp.applyBgOpacity(bgOpacity);
           currSlide.applyCurrentZoomPan();
         }
       } else {
         const mainScrollChanged = this._panOrMoveMainScroll('x');
         if (!mainScrollChanged) {
           this._panOrMoveMainScroll('y');
   
           if (currSlide) {
             roundPoint(currSlide.pan);
             currSlide.applyCurrentZoomPan();
           }
         }
       }
     }
   
     end() {
       const { velocity } = this.gestures;
       const { mainScroll, currSlide } = this.pswp;
       let indexDiff = 0;
   
       this.pswp.animations.stopAll();
   
       // Handle main scroll if it's shifted
       if (mainScroll.isShifted()) {
         // Position of the main scroll relative to the viewport
         const mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX();
   
         // Ratio between 0 and 1:
         // 0 - slide is not visible at all,
         // 0.5 - half of the slide is visible
         // 1 - slide is fully visible
         const currentSlideVisibilityRatio = (mainScrollShiftDiff / this.pswp.viewportSize.x);
   
         // Go next slide.
         //
         // - if velocity and its direction is matched,
         //   and we see at least tiny part of the next slide
         //
         // - or if we see less than 50% of the current slide
         //   and velocity is close to 0
         //
         if ((velocity.x < -MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0)
             || (velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5)) {
           // Go to next slide
           indexDiff = 1;
           velocity.x = Math.min(velocity.x, 0);
         } else if ((velocity.x > MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0)
             || (velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5)) {
           // Go to prev slide
           indexDiff = -1;
           velocity.x = Math.max(velocity.x, 0);
         }
   
         mainScroll.moveIndexBy(indexDiff, true, velocity.x);
       }
   
       // Restore zoom level
       if ((currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max)
           || this.gestures.isMultitouch) {
         this.gestures.zoomLevels.correctZoomPan(true);
       } else {
         // we run two animations instead of one,
         // as each axis has own pan boundaries and thus different spring function
         // (correctZoomPan does not have this functionality,
         //  it animates all properties with single timing function)
         this._finishPanGestureForAxis('x');
         this._finishPanGestureForAxis('y');
       }
     }
   
     /**
      * @private
      * @param {'x' | 'y'} axis
      */
     _finishPanGestureForAxis(axis) {
       const { velocity } = this.gestures;
       const { currSlide } = this.pswp;
   
       if (!currSlide) {
         return;
       }
   
       const { pan, bounds } = currSlide;
       const panPos = pan[axis];
       const restoreBgOpacity = (this.pswp.bgOpacity < 1 && axis === 'y');
   
       // 0.995 means - scroll view loses 0.5% of its velocity per millisecond
       // Increasing this number will reduce travel distance
       const decelerationRate = 0.995; // 0.99
   
       // Pan position if there is no bounds
       const projectedPosition = panPos + project(velocity[axis], decelerationRate);
   
       if (restoreBgOpacity) {
         const vDragRatio = this._getVerticalDragRatio(panPos);
         const projectedVDragRatio = this._getVerticalDragRatio(projectedPosition);
   
         // If we are above and moving upwards,
         // or if we are below and moving downwards
         if ((vDragRatio < 0 && projectedVDragRatio < -MIN_RATIO_TO_CLOSE)
             || (vDragRatio > 0 && projectedVDragRatio > MIN_RATIO_TO_CLOSE)) {
           this.pswp.close();
           return;
         }
       }
   
       // Pan position with corrected bounds
       const correctedPanPosition = bounds.correctPan(axis, projectedPosition);
   
       // Exit if pan position should not be changed
       // or if speed it too low
       if (panPos === correctedPanPosition) {
         return;
       }
   
       // Overshoot if the final position is out of pan bounds
       const dampingRatio = (correctedPanPosition === projectedPosition) ? 1 : 0.82;
   
       const initialBgOpacity = this.pswp.bgOpacity;
       const totalPanDist = correctedPanPosition - panPos;
   
       this.pswp.animations.startSpring({
         name: 'panGesture' + axis,
         isPan: true,
         start: panPos,
         end: correctedPanPosition,
         velocity: velocity[axis],
         dampingRatio,
         onUpdate: (pos) => {
           // Animate opacity of background relative to Y pan position of an image
           if (restoreBgOpacity && this.pswp.bgOpacity < 1) {
             // 0 - start of animation, 1 - end of animation
             const animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist;
   
             // We clamp opacity to keep it between 0 and 1.
             // As progress ratio can be larger than 1 due to overshoot,
             // and we do not want to bounce opacity.
             this.pswp.applyBgOpacity(clamp(
               initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio,
               0,
               1
             ));
           }
   
           pan[axis] = Math.floor(pos);
           currSlide.applyCurrentZoomPan();
         },
       });
     }
   
     /**
      * Update position of the main scroll,
      * or/and update pan position of the current slide.
      *
      * Should return true if it changes (or can change) main scroll.
      *
      * @private
      * @param {'x' | 'y'} axis
      * @returns {boolean}
      */
     _panOrMoveMainScroll(axis) {
       const { p1, dragAxis, prevP1, isMultitouch } = this.gestures;
       const { currSlide, mainScroll } = this.pswp;
       const delta = (p1[axis] - prevP1[axis]);
       const newMainScrollX = mainScroll.x + delta;
   
       if (!delta || !currSlide) {
         return false;
       }
   
       // Always move main scroll if image can not be panned
       if (axis === 'x' && !currSlide.isPannable() && !isMultitouch) {
         mainScroll.moveTo(newMainScrollX, true);
         return true; // changed main scroll
       }
   
       const { bounds } = currSlide;
       const newPan = currSlide.pan[axis] + delta;
   
       if (this.pswp.options.allowPanToNext
           && dragAxis === 'x'
           && axis === 'x'
           && !isMultitouch) {
         const currSlideMainScrollX = mainScroll.getCurrSlideX();
   
         // Position of the main scroll relative to the viewport
         const mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
   
         const isLeftToRight = delta > 0;
         const isRightToLeft = !isLeftToRight;
   
         if (newPan > bounds.min[axis] && isLeftToRight) {
           // Panning from left to right, beyond the left edge
   
           // Wether the image was at minimum pan position (or less)
           // when this drag gesture started.
           // Minimum pan position refers to the left edge of the image.
           const wasAtMinPanPosition = (bounds.min[axis] <= this.startPan[axis]);
   
           if (wasAtMinPanPosition) {
             mainScroll.moveTo(newMainScrollX, true);
             return true;
           } else {
             this._setPanWithFriction(axis, newPan);
             //currSlide.pan[axis] = newPan;
           }
         } else if (newPan < bounds.max[axis] && isRightToLeft) {
           // Paning from right to left, beyond the right edge
   
           // Maximum pan position refers to the right edge of the image.
           const wasAtMaxPanPosition = (this.startPan[axis] <= bounds.max[axis]);
   
           if (wasAtMaxPanPosition) {
             mainScroll.moveTo(newMainScrollX, true);
             return true;
           } else {
             this._setPanWithFriction(axis, newPan);
             //currSlide.pan[axis] = newPan;
           }
         } else {
           // If main scroll is shifted
           if (mainScrollShiftDiff !== 0) {
             // If main scroll is shifted right
             if (mainScrollShiftDiff > 0 /*&& isRightToLeft*/) {
               mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
               return true;
             } else if (mainScrollShiftDiff < 0 /*&& isLeftToRight*/) {
               // Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
               mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
               return true;
             }
           } else {
             // We are within pan bounds, so just pan
             this._setPanWithFriction(axis, newPan);
           }
         }
       } else {
         if (axis === 'y') {
           // Do not pan vertically if main scroll is shifted o
           if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) {
             this._setPanWithFriction(axis, newPan);
           }
         } else {
           this._setPanWithFriction(axis, newPan);
         }
       }
   
       return false;
     }
   
     // If we move above - the ratio is negative
     // If we move below the ratio is positive
   
     /**
      * Relation between pan Y position and third of viewport height.
      *
      * When we are at initial position (center bounds) - the ratio is 0,
      * if position is shifted upwards - the ratio is negative,
      * if position is shifted downwards - the ratio is positive.
      *
      * @private
      * @param {number} panY The current pan Y position.
      * @returns {number}
      */
     _getVerticalDragRatio(panY) {
       return (panY - (this.pswp.currSlide?.bounds.center.y ?? 0)) / (this.pswp.viewportSize.y / 3);
     }
   
     /**
      * Set pan position of the current slide.
      * Apply friction if the position is beyond the pan bounds,
      * or if custom friction is defined.
      *
      * @private
      * @param {'x' | 'y'} axis
      * @param {number} potentialPan
      * @param {number} [customFriction] (0.1 - 1)
      */
     _setPanWithFriction(axis, potentialPan, customFriction) {
       const { currSlide } = this.pswp;
   
       if (!currSlide) {
         return;
       }
   
       const { pan, bounds } = currSlide;
       const correctedPan = bounds.correctPan(axis, potentialPan);
       // If we are out of pan bounds
       if (correctedPan !== potentialPan || customFriction) {
         const delta = Math.round(potentialPan - pan[axis]);
         pan[axis] += delta * (customFriction || PAN_END_FRICTION);
       } else {
         pan[axis] = potentialPan;
       }
     }
   }
   
   /** @typedef {import('../photoswipe.js').Point} Point */
   /** @typedef {import('./gestures.js').default} Gestures */
   
   const UPPER_ZOOM_FRICTION = 0.05;
   const LOWER_ZOOM_FRICTION = 0.15;
   
   
   /**
    * Get center point between two points
    *
    * @param {Point} p
    * @param {Point} p1
    * @param {Point} p2
    * @returns {Point}
    */
   function getZoomPointsCenter(p, p1, p2) {
     p.x = (p1.x + p2.x) / 2;
     p.y = (p1.y + p2.y) / 2;
     return p;
   }
   
   class ZoomHandler {
     /**
      * @param {Gestures} gestures
      */
     constructor(gestures) {
       this.gestures = gestures;
       /**
        * @private
        * @type {Point}
        */
       this._startPan = { x: 0, y: 0 };
       /**
        * @private
        * @type {Point}
        */
       this._startZoomPoint = { x: 0, y: 0 };
       /**
        * @private
        * @type {Point}
        */
       this._zoomPoint = { x: 0, y: 0 };
       /** @private */
       this._wasOverFitZoomLevel = false;
       /** @private */
       this._startZoomLevel = 1;
     }
   
     start() {
       const { currSlide } = this.gestures.pswp;
       if (currSlide) {
         this._startZoomLevel = currSlide.currZoomLevel;
         equalizePoints(this._startPan, currSlide.pan);
       }
   
       this.gestures.pswp.animations.stopAllPan();
       this._wasOverFitZoomLevel = false;
     }
   
     change() {
       const { p1, startP1, p2, startP2, pswp } = this.gestures;
       const { currSlide } = pswp;
   
       if (!currSlide) {
         return;
       }
   
       const minZoomLevel = currSlide.zoomLevels.min;
       const maxZoomLevel = currSlide.zoomLevels.max;
   
       if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) {
         return;
       }
   
       getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
       getZoomPointsCenter(this._zoomPoint, p1, p2);
   
       let currZoomLevel = (1 / getDistanceBetween(startP1, startP2))
                         * getDistanceBetween(p1, p2)
                         * this._startZoomLevel;
   
       // slightly over the zoom.fit
       if (currZoomLevel > currSlide.zoomLevels.initial + (currSlide.zoomLevels.initial / 15)) {
         this._wasOverFitZoomLevel = true;
       }
   
       if (currZoomLevel < minZoomLevel) {
         if (pswp.options.pinchToClose
             && !this._wasOverFitZoomLevel
             && this._startZoomLevel <= currSlide.zoomLevels.initial) {
           // fade out background if zooming out
           const bgOpacity = 1 - ((minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2));
           if (!pswp.dispatch('pinchClose', { bgOpacity }).defaultPrevented) {
             pswp.applyBgOpacity(bgOpacity);
           }
         } else {
           // Apply the friction if zoom level is below the min
           currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * LOWER_ZOOM_FRICTION;
         }
       } else if (currZoomLevel > maxZoomLevel) {
         // Apply the friction if zoom level is above the max
         currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * UPPER_ZOOM_FRICTION;
       }
   
       currSlide.pan.x = this._calculatePanForZoomLevel('x', currZoomLevel);
       currSlide.pan.y = this._calculatePanForZoomLevel('y', currZoomLevel);
   
       currSlide.setZoomLevel(currZoomLevel);
       currSlide.applyCurrentZoomPan();
     }
   
     end() {
       const { pswp } = this.gestures;
       const { currSlide } = pswp;
       if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial)
           && !this._wasOverFitZoomLevel
           && pswp.options.pinchToClose) {
         pswp.close();
       } else {
         this.correctZoomPan();
       }
     }
   
     /**
      * @private
      * @param {'x' | 'y'} axis
      * @param {number} currZoomLevel
      * @returns {number}
      */
     _calculatePanForZoomLevel(axis, currZoomLevel) {
       const zoomFactor = currZoomLevel / this._startZoomLevel;
       return this._zoomPoint[axis]
               - ((this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor);
     }
   
     /**
      * Correct currZoomLevel and pan if they are
      * beyond minimum or maximum values.
      * With animation.
      *
      * @param {boolean} [ignoreGesture]
      * Wether gesture coordinates should be ignored when calculating destination pan position.
      */
     correctZoomPan(ignoreGesture) {
       const { pswp } = this.gestures;
       const { currSlide } = pswp;
   
       if (!currSlide?.isZoomable()) {
         return;
       }
   
       if (this._zoomPoint.x === 0) {
         ignoreGesture = true;
       }
   
       const prevZoomLevel = currSlide.currZoomLevel;
   
       /** @type {number} */
       let destinationZoomLevel;
       let currZoomLevelNeedsChange = true;
   
       if (prevZoomLevel < currSlide.zoomLevels.initial) {
         destinationZoomLevel = currSlide.zoomLevels.initial;
         // zoom to min
       } else if (prevZoomLevel > currSlide.zoomLevels.max) {
         destinationZoomLevel = currSlide.zoomLevels.max;
         // zoom to max
       } else {
         currZoomLevelNeedsChange = false;
         destinationZoomLevel = prevZoomLevel;
       }
   
       const initialBgOpacity = pswp.bgOpacity;
       const restoreBgOpacity = pswp.bgOpacity < 1;
   
       const initialPan = equalizePoints({ x: 0, y: 0 }, currSlide.pan);
       let destinationPan = equalizePoints({ x: 0, y: 0 }, initialPan);
   
       if (ignoreGesture) {
         this._zoomPoint.x = 0;
         this._zoomPoint.y = 0;
         this._startZoomPoint.x = 0;
         this._startZoomPoint.y = 0;
         this._startZoomLevel = prevZoomLevel;
         equalizePoints(this._startPan, initialPan);
       }
   
       if (currZoomLevelNeedsChange) {
         destinationPan = {
           x: this._calculatePanForZoomLevel('x', destinationZoomLevel),
           y: this._calculatePanForZoomLevel('y', destinationZoomLevel)
         };
       }
   
       // set zoom level, so pan bounds are updated according to it
       currSlide.setZoomLevel(destinationZoomLevel);
   
       destinationPan = {
         x: currSlide.bounds.correctPan('x', destinationPan.x),
         y: currSlide.bounds.correctPan('y', destinationPan.y)
       };
   
       // return zoom level and its bounds to initial
       currSlide.setZoomLevel(prevZoomLevel);
   
       const panNeedsChange = !pointsEqual(destinationPan, initialPan);
   
       if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
         // update resolution after gesture
         currSlide._setResolution(destinationZoomLevel);
         currSlide.applyCurrentZoomPan();
   
         // nothing to animate
         return;
       }
   
       pswp.animations.stopAllPan();
   
       pswp.animations.startSpring({
         isPan: true,
         start: 0,
         end: 1000,
         velocity: 0,
         dampingRatio: 1,
         naturalFrequency: 40,
         onUpdate: (now) => {
           now /= 1000; // 0 - start, 1 - end
   
           if (panNeedsChange || currZoomLevelNeedsChange) {
             if (panNeedsChange) {
               currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
               currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
             }
   
             if (currZoomLevelNeedsChange) {
               const newZoomLevel = prevZoomLevel
                           + (destinationZoomLevel - prevZoomLevel) * now;
               currSlide.setZoomLevel(newZoomLevel);
             }
   
             currSlide.applyCurrentZoomPan();
           }
   
           // Restore background opacity
           if (restoreBgOpacity && pswp.bgOpacity < 1) {
             // We clamp opacity to keep it between 0 and 1.
             // As progress ratio can be larger than 1 due to overshoot,
             // and we do not want to bounce opacity.
             pswp.applyBgOpacity(clamp(
               initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1
             ));
           }
         },
         onComplete: () => {
           // update resolution after transition ends
           currSlide._setResolution(destinationZoomLevel);
           currSlide.applyCurrentZoomPan();
         }
       });
     }
   }
   
   /**
    * @template {string} T
    * @template {string} P
    * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
    */
   
   /** @typedef {import('./gestures.js').default} Gestures */
   /** @typedef {import('../photoswipe.js').Point} Point */
   
   /** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions */
   
   /**
    * Whether the tap was performed on the main slide
    * (rather than controls or caption).
    *
    * @param {PointerEvent} event
    * @returns {boolean}
    */
   function didTapOnMainContent(event) {
     return !!(/** @type {HTMLElement} */ (event.target).closest('.pswp__container'));
   }
   
   /**
    * Tap, double-tap handler.
    */
   class TapHandler {
     /**
      * @param {Gestures} gestures
      */
     constructor(gestures) {
       this.gestures = gestures;
     }
   
     /**
      * @param {Point} point
      * @param {PointerEvent} originalEvent
      */
     click(point, originalEvent) {
       const targetClassList = /** @type {HTMLElement} */ (originalEvent.target).classList;
       const isImageClick = targetClassList.contains('pswp__img');
       const isBackgroundClick = targetClassList.contains('pswp__item')
                                 || targetClassList.contains('pswp__zoom-wrap');
   
       if (isImageClick) {
         this._doClickOrTapAction('imageClick', point, originalEvent);
       } else if (isBackgroundClick) {
         this._doClickOrTapAction('bgClick', point, originalEvent);
       }
     }
   
     /**
      * @param {Point} point
      * @param {PointerEvent} originalEvent
      */
     tap(point, originalEvent) {
       if (didTapOnMainContent(originalEvent)) {
         this._doClickOrTapAction('tap', point, originalEvent);
       }
     }
   
     /**
      * @param {Point} point
      * @param {PointerEvent} originalEvent
      */
     doubleTap(point, originalEvent) {
       if (didTapOnMainContent(originalEvent)) {
         this._doClickOrTapAction('doubleTap', point, originalEvent);
       }
     }
   
     /**
      * @private
      * @param {Actions} actionName
      * @param {Point} point
      * @param {PointerEvent} originalEvent
      */
     _doClickOrTapAction(actionName, point, originalEvent) {
       const { pswp } = this.gestures;
       const { currSlide } = pswp;
       const actionFullName = /** @type {AddPostfix<Actions, 'Action'>} */ (actionName + 'Action');
       const optionValue = pswp.options[actionFullName];
   
       if (pswp.dispatch(actionFullName, { point, originalEvent }).defaultPrevented) {
         return;
       }
   
       if (typeof optionValue === 'function') {
         optionValue.call(pswp, point, originalEvent);
         return;
       }
   
       switch (optionValue) {
         case 'close':
         case 'next':
           pswp[optionValue]();
           break;
         case 'zoom':
           currSlide?.toggleZoom(point);
           break;
         case 'zoom-or-close':
           // by default click zooms current image,
           // if it can not be zoomed - gallery will be closed
           if (currSlide?.isZoomable()
               && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) {
             currSlide.toggleZoom(point);
           } else if (pswp.options.clickToCloseNonZoomable) {
             pswp.close();
           }
           break;
         case 'toggle-controls':
           this.gestures.pswp.element?.classList.toggle('pswp--ui-visible');
           // if (_controlsVisible) {
           //   _ui.hideControls();
           // } else {
           //   _ui.showControls();
           // }
           break;
       }
     }
   }
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').Point} Point */
   
   // How far should user should drag
   // until we can determine that the gesture is swipe and its direction
   const AXIS_SWIPE_HYSTERISIS = 10;
   //const PAN_END_FRICTION = 0.35;
   
   const DOUBLE_TAP_DELAY = 300; // ms
   const MIN_TAP_DISTANCE = 25; // px
   
   /**
    * Gestures class bind touch, pointer or mouse events
    * and emits drag to drag-handler and zoom events zoom-handler.
    *
    * Drag and zoom events are emited in requestAnimationFrame,
    * and only when one of pointers was actually changed.
    */
   class Gestures {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
   
       /** @type {'x' | 'y' | null} */
       this.dragAxis = null;
   
       // point objects are defined once and reused
       // PhotoSwipe keeps track only of two pointers, others are ignored
       /** @type {Point} */
       this.p1 = { x: 0, y: 0 }; // the first pressed pointer
       /** @type {Point} */
       this.p2 = { x: 0, y: 0 }; // the second pressed pointer
       /** @type {Point} */
       this.prevP1 = { x: 0, y: 0 };
       /** @type {Point} */
       this.prevP2 = { x: 0, y: 0 };
       /** @type {Point} */
       this.startP1 = { x: 0, y: 0 };
       /** @type {Point} */
       this.startP2 = { x: 0, y: 0 };
       /** @type {Point} */
       this.velocity = { x: 0, y: 0 };
   
       /** @type {Point}
        * @private
        */
       this._lastStartP1 = { x: 0, y: 0 };
       /** @type {Point}
        * @private
        */
       this._intervalP1 = { x: 0, y: 0 };
       /** @private */
       this._numActivePoints = 0;
       /** @type {Point[]}
        * @private
        */
       this._ongoingPointers = [];
       /** @private */
       this._touchEventEnabled = 'ontouchstart' in window;
       /** @private */
       this._pointerEventEnabled = !!(window.PointerEvent);
       this.supportsTouch = this._touchEventEnabled
                             || (this._pointerEventEnabled && navigator.maxTouchPoints > 1);
       /** @private */
       this._numActivePoints = 0;
       /** @private */
       this._intervalTime = 0;
       /** @private */
       this._velocityCalculated = false;
       this.isMultitouch = false;
       this.isDragging = false;
       this.isZooming = false;
       /** @type {number | null} */
       this.raf = null;
       /** @type {NodeJS.Timeout | null}
        * @private
        */
       this._tapTimer = null;
   
       if (!this.supportsTouch) {
         // disable pan to next slide for non-touch devices
         pswp.options.allowPanToNext = false;
       }
   
       this.drag = new DragHandler(this);
       this.zoomLevels = new ZoomHandler(this);
       this.tapHandler = new TapHandler(this);
   
       pswp.on('bindEvents', () => {
         pswp.events.add(
           pswp.scrollWrap,
           'click',
           /** @type EventListener */(this._onClick.bind(this))
         );
   
         if (this._pointerEventEnabled) {
           this._bindEvents('pointer', 'down', 'up', 'cancel');
         } else if (this._touchEventEnabled) {
           this._bindEvents('touch', 'start', 'end', 'cancel');
   
           // In previous versions we also bound mouse event here,
           // in case device supports both touch and mouse events,
           // but newer versions of browsers now support PointerEvent.
   
           // on iOS10 if you bind touchmove/end after touchstart,
           // and you don't preventDefault touchstart (which PhotoSwipe does),
           // preventDefault will have no effect on touchmove and touchend.
           // Unless you bind it previously.
           if (pswp.scrollWrap) {
             pswp.scrollWrap.ontouchmove = () => {};
             pswp.scrollWrap.ontouchend = () => {};
           }
         } else {
           this._bindEvents('mouse', 'down', 'up');
         }
       });
     }
   
     /**
      * @private
      * @param {'mouse' | 'touch' | 'pointer'} pref
      * @param {'down' | 'start'} down
      * @param {'up' | 'end'} up
      * @param {'cancel'} [cancel]
      */
     _bindEvents(pref, down, up, cancel) {
       const { pswp } = this;
       const { events } = pswp;
   
       const cancelEvent = cancel ? pref + cancel : '';
   
       events.add(
         pswp.scrollWrap,
         pref + down,
         /** @type EventListener */(this.onPointerDown.bind(this))
       );
       events.add(window, pref + 'move', /** @type EventListener */(this.onPointerMove.bind(this)));
       events.add(window, pref + up, /** @type EventListener */(this.onPointerUp.bind(this)));
       if (cancelEvent) {
         events.add(
           pswp.scrollWrap,
           cancelEvent,
           /** @type EventListener */(this.onPointerUp.bind(this))
         );
       }
     }
   
     /**
      * @param {PointerEvent} e
      */
     onPointerDown(e) {
       // We do not call preventDefault for touch events
       // to allow browser to show native dialog on longpress
       // (the one that allows to save image or open it in new tab).
       //
       // Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
       // even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
       const isMousePointer = e.type === 'mousedown' || e.pointerType === 'mouse';
   
       // Allow dragging only via left mouse button.
       // http://www.quirksmode.org/js/events_properties.html
       // https://developer.mozilla.org/en-US/docs/Web/API/event.button
       if (isMousePointer && e.button > 0) {
         return;
       }
   
       const { pswp } = this;
   
       // if PhotoSwipe is opening or closing
       if (!pswp.opener.isOpen) {
         e.preventDefault();
         return;
       }
   
       if (pswp.dispatch('pointerDown', { originalEvent: e }).defaultPrevented) {
         return;
       }
   
       if (isMousePointer) {
         pswp.mouseDetected();
   
         // preventDefault mouse event to prevent
         // browser image drag feature
         this._preventPointerEventBehaviour(e);
       }
   
       pswp.animations.stopAll();
   
       this._updatePoints(e, 'down');
   
       if (this._numActivePoints === 1) {
         this.dragAxis = null;
         // we need to store initial point to determine the main axis,
         // drag is activated only after the axis is determined
         equalizePoints(this.startP1, this.p1);
       }
   
       if (this._numActivePoints > 1) {
         // Tap or double tap should not trigger if more than one pointer
         this._clearTapTimer();
         this.isMultitouch = true;
       } else {
         this.isMultitouch = false;
       }
     }
   
     /**
      * @param {PointerEvent} e
      */
     onPointerMove(e) {
       e.preventDefault(); // always preventDefault move event
   
       if (!this._numActivePoints) {
         return;
       }
   
       this._updatePoints(e, 'move');
   
       if (this.pswp.dispatch('pointerMove', { originalEvent: e }).defaultPrevented) {
         return;
       }
   
       if (this._numActivePoints === 1 && !this.isDragging) {
         if (!this.dragAxis) {
           this._calculateDragDirection();
         }
   
         // Drag axis was detected, emit drag.start
         if (this.dragAxis && !this.isDragging) {
           if (this.isZooming) {
             this.isZooming = false;
             this.zoomLevels.end();
           }
   
           this.isDragging = true;
           this._clearTapTimer(); // Tap can not trigger after drag
   
           // Adjust starting point
           this._updateStartPoints();
           this._intervalTime = Date.now();
           //this._startTime = this._intervalTime;
           this._velocityCalculated = false;
           equalizePoints(this._intervalP1, this.p1);
           this.velocity.x = 0;
           this.velocity.y = 0;
           this.drag.start();
   
           this._rafStopLoop();
           this._rafRenderLoop();
         }
       } else if (this._numActivePoints > 1 && !this.isZooming) {
         this._finishDrag();
   
         this.isZooming = true;
   
         // Adjust starting points
         this._updateStartPoints();
   
         this.zoomLevels.start();
   
         this._rafStopLoop();
         this._rafRenderLoop();
       }
     }
   
     /**
      * @private
      */
     _finishDrag() {
       if (this.isDragging) {
         this.isDragging = false;
   
         // Try to calculate velocity,
         // if it wasn't calculated yet in drag.change
         if (!this._velocityCalculated) {
           this._updateVelocity(true);
         }
   
         this.drag.end();
         this.dragAxis = null;
       }
     }
   
     /**
      * @param {PointerEvent} e
      */
     onPointerUp(e) {
       if (!this._numActivePoints) {
         return;
       }
   
       this._updatePoints(e, 'up');
   
       if (this.pswp.dispatch('pointerUp', { originalEvent: e }).defaultPrevented) {
         return;
       }
   
       if (this._numActivePoints === 0) {
         this._rafStopLoop();
   
         if (this.isDragging) {
           this._finishDrag();
         } else if (!this.isZooming && !this.isMultitouch) {
           //this.zoomLevels.correctZoomPan();
           this._finishTap(e);
         }
       }
   
       if (this._numActivePoints < 2 && this.isZooming) {
         this.isZooming = false;
         this.zoomLevels.end();
   
         if (this._numActivePoints === 1) {
           // Since we have 1 point left, we need to reinitiate drag
           this.dragAxis = null;
           this._updateStartPoints();
         }
       }
     }
   
     /**
      * @private
      */
     _rafRenderLoop() {
       if (this.isDragging || this.isZooming) {
         this._updateVelocity();
   
         if (this.isDragging) {
           // make sure that pointer moved since the last update
           if (!pointsEqual(this.p1, this.prevP1)) {
             this.drag.change();
           }
         } else /* if (this.isZooming) */ {
           if (!pointsEqual(this.p1, this.prevP1)
               || !pointsEqual(this.p2, this.prevP2)) {
             this.zoomLevels.change();
           }
         }
   
         this._updatePrevPoints();
         this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
       }
     }
   
     /**
      * Update velocity at 50ms interval
      *
      * @private
      * @param {boolean} [force]
      */
     _updateVelocity(force) {
       const time = Date.now();
       const duration = time - this._intervalTime;
   
       if (duration < 50 && !force) {
         return;
       }
   
   
       this.velocity.x = this._getVelocity('x', duration);
       this.velocity.y = this._getVelocity('y', duration);
   
       this._intervalTime = time;
       equalizePoints(this._intervalP1, this.p1);
       this._velocityCalculated = true;
     }
   
     /**
      * @private
      * @param {PointerEvent} e
      */
     _finishTap(e) {
       const { mainScroll } = this.pswp;
   
       // Do not trigger tap events if main scroll is shifted
       if (mainScroll.isShifted()) {
         // restore main scroll position
         // (usually happens if stopped in the middle of animation)
         mainScroll.moveIndexBy(0, true);
         return;
       }
   
       // Do not trigger tap for touchcancel or pointercancel
       if (e.type.indexOf('cancel') > 0) {
         return;
       }
   
       // Trigger click instead of tap for mouse events
       if (e.type === 'mouseup' || e.pointerType === 'mouse') {
         this.tapHandler.click(this.startP1, e);
         return;
       }
   
       // Disable delay if there is no doubleTapAction
       const tapDelay = this.pswp.options.doubleTapAction ? DOUBLE_TAP_DELAY : 0;
   
       // If tapTimer is defined - we tapped recently,
       // check if the current tap is close to the previous one,
       // if yes - trigger double tap
       if (this._tapTimer) {
         this._clearTapTimer();
         // Check if two taps were more or less on the same place
         if (getDistanceBetween(this._lastStartP1, this.startP1) < MIN_TAP_DISTANCE) {
           this.tapHandler.doubleTap(this.startP1, e);
         }
       } else {
         equalizePoints(this._lastStartP1, this.startP1);
         this._tapTimer = setTimeout(() => {
           this.tapHandler.tap(this.startP1, e);
           this._clearTapTimer();
         }, tapDelay);
       }
     }
   
     /**
      * @private
      */
     _clearTapTimer() {
       if (this._tapTimer) {
         clearTimeout(this._tapTimer);
         this._tapTimer = null;
       }
     }
   
     /**
      * Get velocity for axis
      *
      * @private
      * @param {'x' | 'y'} axis
      * @param {number} duration
      * @returns {number}
      */
     _getVelocity(axis, duration) {
       // displacement is like distance, but can be negative.
       const displacement = this.p1[axis] - this._intervalP1[axis];
   
       if (Math.abs(displacement) > 1 && duration > 5) {
         return displacement / duration;
       }
   
       return 0;
     }
   
     /**
      * @private
      */
     _rafStopLoop() {
       if (this.raf) {
         cancelAnimationFrame(this.raf);
         this.raf = null;
       }
     }
   
     /**
      * @private
      * @param {PointerEvent} e
      */
     _preventPointerEventBehaviour(e) {
       // TODO find a way to disable e.preventDefault on some elements
       //      via event or some class or something
       e.preventDefault();
     }
   
     /**
      * Parses and normalizes points from the touch, mouse or pointer event.
      * Updates p1 and p2.
      *
      * @private
      * @param {PointerEvent | TouchEvent} e
      * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
      */
     _updatePoints(e, pointerType) {
       if (this._pointerEventEnabled) {
         const pointerEvent = /** @type {PointerEvent} */ (e);
         // Try to find the current pointer in ongoing pointers by its ID
         const pointerIndex = this._ongoingPointers.findIndex((ongoingPointer) => {
           return ongoingPointer.id === pointerEvent.pointerId;
         });
   
         if (pointerType === 'up' && pointerIndex > -1) {
           // release the pointer - remove it from ongoing
           this._ongoingPointers.splice(pointerIndex, 1);
         } else if (pointerType === 'down' && pointerIndex === -1) {
           // add new pointer
           this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, { x: 0, y: 0 }));
         } else if (pointerIndex > -1) {
           // update existing pointer
           this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
         }
   
         this._numActivePoints = this._ongoingPointers.length;
   
         // update points that PhotoSwipe uses
         // to calculate position and scale
         if (this._numActivePoints > 0) {
           equalizePoints(this.p1, this._ongoingPointers[0]);
         }
   
         if (this._numActivePoints > 1) {
           equalizePoints(this.p2, this._ongoingPointers[1]);
         }
       } else {
         const touchEvent = /** @type {TouchEvent} */ (e);
   
         this._numActivePoints = 0;
         if (touchEvent.type.indexOf('touch') > -1) {
           // Touch Event
           // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
           if (touchEvent.touches && touchEvent.touches.length > 0) {
             this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
             this._numActivePoints++;
             if (touchEvent.touches.length > 1) {
               this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
               this._numActivePoints++;
             }
           }
         } else {
           // Mouse Event
           this._convertEventPosToPoint(/** @type {PointerEvent} */ (e), this.p1);
           if (pointerType === 'up') {
             // clear all points on mouseup
             this._numActivePoints = 0;
           } else {
             this._numActivePoints++;
           }
         }
       }
     }
   
     /** update points that were used during previous rAF tick
      * @private
      */
     _updatePrevPoints() {
       equalizePoints(this.prevP1, this.p1);
       equalizePoints(this.prevP2, this.p2);
     }
   
     /** update points at the start of gesture
      * @private
      */
     _updateStartPoints() {
       equalizePoints(this.startP1, this.p1);
       equalizePoints(this.startP2, this.p2);
       this._updatePrevPoints();
     }
   
     /** @private */
     _calculateDragDirection() {
       if (this.pswp.mainScroll.isShifted()) {
         // if main scroll position is shifted – direction is always horizontal
         this.dragAxis = 'x';
       } else {
         // calculate delta of the last touchmove tick
         const diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
   
         if (diff !== 0) {
           // check if pointer was shifted horizontally or vertically
           const axisToCheck = diff > 0 ? 'x' : 'y';
   
           if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= AXIS_SWIPE_HYSTERISIS) {
             this.dragAxis = axisToCheck;
           }
         }
       }
     }
   
     /**
      * Converts touch, pointer or mouse event
      * to PhotoSwipe point.
      *
      * @private
      * @param {Touch | PointerEvent} e
      * @param {Point} p
      * @returns {Point}
      */
     _convertEventPosToPoint(e, p) {
       p.x = e.pageX - this.pswp.offset.x;
       p.y = e.pageY - this.pswp.offset.y;
   
       if ('pointerId' in e) {
         p.id = e.pointerId;
       } else if (e.identifier !== undefined) {
         p.id = e.identifier;
       }
   
       return p;
     }
   
     /**
      * @private
      * @param {PointerEvent} e
      */
     _onClick(e) {
       // Do not allow click event to pass through after drag
       if (this.pswp.mainScroll.isShifted()) {
         e.preventDefault();
         e.stopPropagation();
       }
     }
   }
   
   /** @typedef {import('./photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('./slide/slide.js').default} Slide */
   
   /** @typedef {{ el: HTMLDivElement; slide?: Slide }} ItemHolder */
   
   const MAIN_SCROLL_END_FRICTION = 0.35;
   
   
   // const MIN_SWIPE_TRANSITION_DURATION = 250;
   // const MAX_SWIPE_TRABSITION_DURATION = 500;
   // const DEFAULT_SWIPE_TRANSITION_DURATION = 333;
   
   /**
    * Handles movement of the main scrolling container
    * (for example, it repositions when user swipes left or right).
    *
    * Also stores its state.
    */
   class MainScroll {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       this.x = 0;
       this.slideWidth = 0;
       /** @private */
       this._currPositionIndex = 0;
       /** @private */
       this._prevPositionIndex = 0;
       /** @private */
       this._containerShiftIndex = -1;
   
       /** @type {ItemHolder[]} */
       this.itemHolders = [];
     }
   
     /**
      * Position the scroller and slide containers
      * according to viewport size.
      *
      * @param {boolean} [resizeSlides] Whether slides content should resized
      */
     resize(resizeSlides) {
       const { pswp } = this;
       const newSlideWidth = Math.round(
         pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing
       );
       // Mobile browsers might trigger a resize event during a gesture.
       // (due to toolbar appearing or hiding).
       // Avoid re-adjusting main scroll position if width wasn't changed
       const slideWidthChanged = (newSlideWidth !== this.slideWidth);
   
       if (slideWidthChanged) {
         this.slideWidth = newSlideWidth;
         this.moveTo(this.getCurrSlideX());
       }
   
       this.itemHolders.forEach((itemHolder, index) => {
         if (slideWidthChanged) {
           setTransform(itemHolder.el, (index + this._containerShiftIndex)
                                       * this.slideWidth);
         }
   
         if (resizeSlides && itemHolder.slide) {
           itemHolder.slide.resize();
         }
       });
     }
   
     /**
      * Reset X position of the main scroller to zero
      */
     resetPosition() {
       // Position on the main scroller (offset)
       // it is independent from slide index
       this._currPositionIndex = 0;
       this._prevPositionIndex = 0;
   
       // This will force recalculation of size on next resize()
       this.slideWidth = 0;
   
       // _containerShiftIndex*viewportSize will give you amount of transform of the current slide
       this._containerShiftIndex = -1;
     }
   
     /**
      * Create and append array of three items
      * that hold data about slides in DOM
      */
     appendHolders() {
       this.itemHolders = [];
   
       // append our three slide holders -
       // previous, current, and next
       for (let i = 0; i < 3; i++) {
         const el = photoswipe_esm_createElement('pswp__item', 'div', this.pswp.container);
         el.setAttribute('role', 'group');
         el.setAttribute('aria-roledescription', 'slide');
         el.setAttribute('aria-hidden', 'true');
   
         // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
         el.style.display = (i === 1) ? 'block' : 'none';
   
         this.itemHolders.push({
           el,
           //index: -1
         });
       }
     }
   
     /**
      * Whether the main scroll can be horizontally swiped to the next or previous slide.
      * @returns {boolean}
      */
     canBeSwiped() {
       return this.pswp.getNumItems() > 1;
     }
   
     /**
      * Move main scroll by X amount of slides.
      * For example:
      *   `-1` will move to the previous slide,
      *    `0` will reset the scroll position of the current slide,
      *    `3` will move three slides forward
      *
      * If loop option is enabled - index will be automatically looped too,
      * (for example `-1` will move to the last slide of the gallery).
      *
      * @param {number} diff
      * @param {boolean} [animate]
      * @param {number} [velocityX]
      * @returns {boolean} whether index was changed or not
      */
     moveIndexBy(diff, animate, velocityX) {
       const { pswp } = this;
       let newIndex = pswp.potentialIndex + diff;
       const numSlides = pswp.getNumItems();
   
       if (pswp.canLoop()) {
         newIndex = pswp.getLoopedIndex(newIndex);
         const distance = (diff + numSlides) % numSlides;
         if (distance <= numSlides / 2) {
           // go forward
           diff = distance;
         } else {
           // go backwards
           diff = distance - numSlides;
         }
       } else {
         if (newIndex < 0) {
           newIndex = 0;
         } else if (newIndex >= numSlides) {
           newIndex = numSlides - 1;
         }
         diff = newIndex - pswp.potentialIndex;
       }
   
       pswp.potentialIndex = newIndex;
       this._currPositionIndex -= diff;
   
       pswp.animations.stopMainScroll();
   
       const destinationX = this.getCurrSlideX();
       if (!animate) {
         this.moveTo(destinationX);
         this.updateCurrItem();
       } else {
         pswp.animations.startSpring({
           isMainScroll: true,
           start: this.x,
           end: destinationX,
           velocity: velocityX || 0,
           naturalFrequency: 30,
           dampingRatio: 1, //0.7,
           onUpdate: (x) => {
             this.moveTo(x);
           },
           onComplete: () => {
             this.updateCurrItem();
             pswp.appendHeavy();
           }
         });
   
         let currDiff = pswp.potentialIndex - pswp.currIndex;
         if (pswp.canLoop()) {
           const currDistance = (currDiff + numSlides) % numSlides;
           if (currDistance <= numSlides / 2) {
             // go forward
             currDiff = currDistance;
           } else {
             // go backwards
             currDiff = currDistance - numSlides;
           }
         }
   
         // Force-append new slides during transition
         // if difference between slides is more than 1
         if (Math.abs(currDiff) > 1) {
           this.updateCurrItem();
         }
       }
   
       return Boolean(diff);
     }
   
     /**
      * X position of the main scroll for the current slide
      * (ignores position during dragging)
      * @returns {number}
      */
     getCurrSlideX() {
       return this.slideWidth * this._currPositionIndex;
     }
   
     /**
      * Whether scroll position is shifted.
      * For example, it will return true if the scroll is being dragged or animated.
      * @returns {boolean}
      */
     isShifted() {
       return this.x !== this.getCurrSlideX();
     }
   
     /**
      * Update slides X positions and set their content
      */
     updateCurrItem() {
       const { pswp } = this;
       const positionDifference = this._prevPositionIndex - this._currPositionIndex;
   
       if (!positionDifference) {
         return;
       }
   
       this._prevPositionIndex = this._currPositionIndex;
   
       pswp.currIndex = pswp.potentialIndex;
   
       let diffAbs = Math.abs(positionDifference);
       /** @type {ItemHolder | undefined} */
       let tempHolder;
   
       if (diffAbs >= 3) {
         this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
         diffAbs = 3;
       }
   
       for (let i = 0; i < diffAbs; i++) {
         if (positionDifference > 0) {
           tempHolder = this.itemHolders.shift();
           if (tempHolder) {
             this.itemHolders[2] = tempHolder; // move first to last
   
             this._containerShiftIndex++;
   
             setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
   
             pswp.setContent(tempHolder, (pswp.currIndex - diffAbs) + i + 2);
           }
         } else {
           tempHolder = this.itemHolders.pop();
           if (tempHolder) {
             this.itemHolders.unshift(tempHolder); // move last to first
   
             this._containerShiftIndex--;
   
             setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
   
             pswp.setContent(tempHolder, (pswp.currIndex + diffAbs) - i - 2);
           }
         }
       }
   
       // Reset transfrom every 50ish navigations in one direction.
       //
       // Otherwise transform will keep growing indefinitely,
       // which might cause issues as browsers have a maximum transform limit.
       // I wasn't able to reach it, but just to be safe.
       // This should not cause noticable lag.
       if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
         this.resetPosition();
         this.resize();
       }
   
       // Pan transition might be running (and consntantly updating pan position)
       pswp.animations.stopAllPan();
   
       this.itemHolders.forEach((itemHolder, i) => {
         if (itemHolder.slide) {
           // Slide in the 2nd holder is always active
           itemHolder.slide.setIsActive(i === 1);
         }
       });
   
       pswp.currSlide = this.itemHolders[1]?.slide;
       pswp.contentLoader.updateLazy(positionDifference);
   
       if (pswp.currSlide) {
         pswp.currSlide.applyCurrentZoomPan();
       }
   
       pswp.dispatch('change');
     }
   
     /**
      * Move the X position of the main scroll container
      *
      * @param {number} x
      * @param {boolean} [dragging]
      */
     moveTo(x, dragging) {
       if (!this.pswp.canLoop() && dragging) {
         // Apply friction
         let newSlideIndexOffset = ((this.slideWidth * this._currPositionIndex) - x) / this.slideWidth;
         newSlideIndexOffset += this.pswp.currIndex;
         const delta = Math.round(x - this.x);
   
         if ((newSlideIndexOffset < 0 && delta > 0)
             || (newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0)) {
           x = this.x + (delta * MAIN_SCROLL_END_FRICTION);
         }
       }
   
       this.x = x;
   
       if (this.pswp.container) {
         setTransform(this.pswp.container, x);
       }
   
       this.pswp.dispatch('moveMainScroll', { x, dragging: dragging ?? false });
     }
   }
   
   /** @typedef {import('./photoswipe.js').default} PhotoSwipe */
   
   /**
    * @template T
    * @typedef {import('./types.js').Methods<T>} Methods<T>
    */
   
   const KeyboardKeyCodesMap = {
     Escape: 27,
     z: 90,
     ArrowLeft: 37,
     ArrowUp: 38,
     ArrowRight: 39,
     ArrowDown: 40,
     Tab: 9,
   };
   
   /**
    * @template {keyof KeyboardKeyCodesMap} T
    * @param {T} key
    * @param {boolean} isKeySupported
    * @returns {T | number | undefined}
    */
   const getKeyboardEventKey = (key, isKeySupported) => {
     return isKeySupported ? key : KeyboardKeyCodesMap[key];
   };
   
   /**
    * - Manages keyboard shortcuts.
    * - Helps trap focus within photoswipe.
    */
   class photoswipe_esm_Keyboard {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       /** @private */
       this._wasFocused = false;
   
       pswp.on('bindEvents', () => {
         // Dialog was likely opened by keyboard if initial point is not defined
         if (!pswp.options.initialPointerPos) {
           // focus causes layout,
           // which causes lag during the animation,
           // that's why we delay it until the opener transition ends
           this._focusRoot();
         }
   
         pswp.events.add(document, 'focusin', /** @type EventListener */(this._onFocusIn.bind(this)));
         pswp.events.add(document, 'keydown', /** @type EventListener */(this._onKeyDown.bind(this)));
       });
   
       const lastActiveElement = /** @type {HTMLElement} */ (document.activeElement);
       pswp.on('destroy', () => {
         if (pswp.options.returnFocus
             && lastActiveElement
             && this._wasFocused) {
           lastActiveElement.focus();
         }
       });
     }
   
     /** @private */
     _focusRoot() {
       if (!this._wasFocused && this.pswp.element) {
         this.pswp.element.focus();
         this._wasFocused = true;
       }
     }
   
     /**
      * @private
      * @param {KeyboardEvent} e
      */
     _onKeyDown(e) {
       const { pswp } = this;
   
       if (pswp.dispatch('keydown', { originalEvent: e }).defaultPrevented) {
         return;
       }
   
       if (photoswipe_esm_specialKeyUsed(e)) {
         // don't do anything if special key pressed
         // to prevent from overriding default browser actions
         // for example, in Chrome on Mac cmd+arrow-left returns to previous page
         return;
       }
   
       /** @type {Methods<PhotoSwipe> | undefined} */
       let keydownAction;
       /** @type {'x' | 'y' | undefined} */
       let axis;
       let isForward = false;
       const isKeySupported = 'key' in e;
   
       switch (isKeySupported ? e.key : e.keyCode) {
         case getKeyboardEventKey('Escape', isKeySupported):
           if (pswp.options.escKey) {
             keydownAction = 'close';
           }
           break;
         case getKeyboardEventKey('z', isKeySupported):
           keydownAction = 'toggleZoom';
           break;
         case getKeyboardEventKey('ArrowLeft', isKeySupported):
           axis = 'x';
           break;
         case getKeyboardEventKey('ArrowUp', isKeySupported):
           axis = 'y';
           break;
         case getKeyboardEventKey('ArrowRight', isKeySupported):
           axis = 'x';
           isForward = true;
           break;
         case getKeyboardEventKey('ArrowDown', isKeySupported):
           isForward = true;
           axis = 'y';
           break;
         case getKeyboardEventKey('Tab', isKeySupported):
           this._focusRoot();
           break;
       }
   
       // if left/right/top/bottom key
       if (axis) {
         // prevent page scroll
         e.preventDefault();
   
         const { currSlide } = pswp;
   
         if (pswp.options.arrowKeys
             && axis === 'x'
             && pswp.getNumItems() > 1) {
           keydownAction = isForward ? 'next' : 'prev';
         } else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
           // up/down arrow keys pan the image vertically
           // left/right arrow keys pan horizontally.
           // Unless there is only one image,
           // or arrowKeys option is disabled
           currSlide.pan[axis] += isForward ? -80 : 80;
           currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
         }
       }
   
       if (keydownAction) {
         e.preventDefault();
         // @ts-ignore
         pswp[keydownAction]();
       }
     }
   
     /**
      * Trap focus inside photoswipe
      *
      * @private
      * @param {FocusEvent} e
      */
     _onFocusIn(e) {
       const { template } = this.pswp;
       if (template
           && document !== e.target
           && template !== e.target
           && !template.contains(/** @type {Node} */ (e.target))) {
         // focus root element
         template.focus();
       }
     }
   }
   
   const DEFAULT_EASING = 'cubic-bezier(.4,0,.22,1)';
   
   /** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */
   
   /** @typedef {Object} DefaultCssAnimationProps
    *
    * @prop {HTMLElement} target
    * @prop {number} [duration]
    * @prop {string} [easing]
    * @prop {string} [transform]
    * @prop {string} [opacity]
    * */
   
   /** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps */
   
   /**
    * Runs CSS transition.
    */
   class CSSAnimation {
     /**
      * onComplete can be unpredictable, be careful about current state
      *
      * @param {CssAnimationProps} props
      */
     constructor(props) {
       this.props = props;
       const {
         target,
         onComplete,
         transform,
         onFinish = () => {},
         duration = 333,
         easing = DEFAULT_EASING,
       } = props;
   
       this.onFinish = onFinish;
   
       // support only transform and opacity
       const prop = transform ? 'transform' : 'opacity';
       const propValue = props[prop] ?? '';
   
       /** @private */
       this._target = target;
       /** @private */
       this._onComplete = onComplete;
       /** @private */
       this._finished = false;
   
       /** @private */
       this._onTransitionEnd = this._onTransitionEnd.bind(this);
   
       // Using timeout hack to make sure that animation
       // starts even if the animated property was changed recently,
       // otherwise transitionend might not fire or transition won't start.
       // https://drafts.csswg.org/css-transitions/#starting
       //
       // ¯\_(ツ)_/¯
       /** @private */
       this._helperTimeout = setTimeout(() => {
         setTransitionStyle(target, prop, duration, easing);
         this._helperTimeout = setTimeout(() => {
           target.addEventListener('transitionend', this._onTransitionEnd, false);
           target.addEventListener('transitioncancel', this._onTransitionEnd, false);
   
           // Safari occasionally does not emit transitionend event
           // if element property was modified during the transition,
           // which may be caused by resize or third party component,
           // using timeout as a safety fallback
           this._helperTimeout = setTimeout(() => {
             this._finalizeAnimation();
           }, duration + 500);
           target.style[prop] = propValue;
         }, 30); // Do not reduce this number
       }, 0);
     }
   
     /**
      * @private
      * @param {TransitionEvent} e
      */
     _onTransitionEnd(e) {
       if (e.target === this._target) {
         this._finalizeAnimation();
       }
     }
   
     /**
      * @private
      */
     _finalizeAnimation() {
       if (!this._finished) {
         this._finished = true;
         this.onFinish();
         if (this._onComplete) {
           this._onComplete();
         }
       }
     }
   
     // Destroy is called automatically onFinish
     destroy() {
       if (this._helperTimeout) {
         clearTimeout(this._helperTimeout);
       }
       removeTransitionStyle(this._target);
       this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
       this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
       if (!this._finished) {
         this._finalizeAnimation();
       }
     }
   }
   
   const DEFAULT_NATURAL_FREQUENCY = 12;
   const DEFAULT_DAMPING_RATIO = 0.75;
   
   /**
    * Spring easing helper
    */
   class SpringEaser {
     /**
      * @param {number} initialVelocity Initial velocity, px per ms.
      *
      * @param {number} [dampingRatio]
      * Determines how bouncy animation will be.
      * From 0 to 1, 0 - always overshoot, 1 - do not overshoot.
      * "overshoot" refers to part of animation that
      * goes beyond the final value.
      *
      * @param {number} [naturalFrequency]
      * Determines how fast animation will slow down.
      * The higher value - the stiffer the transition will be,
      * and the faster it will slow down.
      * Recommended value from 10 to 50
      */
     constructor(initialVelocity, dampingRatio, naturalFrequency) {
       this.velocity = initialVelocity * 1000; // convert to "pixels per second"
   
       // https://en.wikipedia.org/wiki/Damping_ratio
       this._dampingRatio = dampingRatio || DEFAULT_DAMPING_RATIO;
   
       // https://en.wikipedia.org/wiki/Natural_frequency
       this._naturalFrequency = naturalFrequency || DEFAULT_NATURAL_FREQUENCY;
   
       this._dampedFrequency = this._naturalFrequency;
   
       if (this._dampingRatio < 1) {
         this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
       }
     }
   
     /**
      * @param {number} deltaPosition Difference between current and end position of the animation
      * @param {number} deltaTime Frame duration in milliseconds
      *
      * @returns {number} Displacement, relative to the end position.
      */
     easeFrame(deltaPosition, deltaTime) {
       // Inspired by Apple Webkit and Android spring function implementation
       // https://en.wikipedia.org/wiki/Oscillation
       // https://en.wikipedia.org/wiki/Damping_ratio
       // we ignore mass (assume that it's 1kg)
   
       let displacement = 0;
       let coeff;
   
       deltaTime /= 1000;
   
       const naturalDumpingPow = Math.E ** (-this._dampingRatio * this._naturalFrequency * deltaTime);
   
       if (this._dampingRatio === 1) {
         coeff = this.velocity + this._naturalFrequency * deltaPosition;
   
         displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
   
         this.velocity = displacement
                           * (-this._naturalFrequency) + coeff
                           * naturalDumpingPow;
       } else if (this._dampingRatio < 1) {
         coeff = (1 / this._dampedFrequency)
                   * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
   
         const dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
         const dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
   
         displacement = naturalDumpingPow
                          * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
   
         this.velocity = displacement
                           * (-this._naturalFrequency)
                           * this._dampingRatio
                           + naturalDumpingPow
                           * (-this._dampedFrequency * deltaPosition * dumpedFSin
                           + this._dampedFrequency * coeff * dumpedFCos);
       }
   
       // Overdamped (>1) damping ratio is not supported
   
       return displacement;
     }
   }
   
   /** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */
   
   /**
    * @typedef {Object} DefaultSpringAnimationProps
    *
    * @prop {number} start
    * @prop {number} end
    * @prop {number} velocity
    * @prop {number} [dampingRatio]
    * @prop {number} [naturalFrequency]
    * @prop {(end: number) => void} onUpdate
    */
   
   /** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */
   
   class SpringAnimation {
     /**
      * @param {SpringAnimationProps} props
      */
     constructor(props) {
       this.props = props;
       this._raf = 0;
   
       const {
         start,
         end,
         velocity,
         onUpdate,
         onComplete,
         onFinish = () => {},
         dampingRatio,
         naturalFrequency
       } = props;
   
       this.onFinish = onFinish;
   
       const easer = new SpringEaser(velocity, dampingRatio, naturalFrequency);
       let prevTime = Date.now();
       let deltaPosition = start - end;
   
       const animationLoop = () => {
         if (this._raf) {
           deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime);
   
           // Stop the animation if velocity is low and position is close to end
           if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
             // Finalize the animation
             onUpdate(end);
             if (onComplete) {
               onComplete();
             }
             this.onFinish();
           } else {
             prevTime = Date.now();
             onUpdate(deltaPosition + end);
             this._raf = requestAnimationFrame(animationLoop);
           }
         }
       };
   
       this._raf = requestAnimationFrame(animationLoop);
     }
   
     // Destroy is called automatically onFinish
     destroy() {
       if (this._raf >= 0) {
         cancelAnimationFrame(this._raf);
       }
       this._raf = 0;
     }
   }
   
   /** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps */
   /** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps */
   
   /** @typedef {Object} SharedAnimationProps
    * @prop {string} [name]
    * @prop {boolean} [isPan]
    * @prop {boolean} [isMainScroll]
    * @prop {VoidFunction} [onComplete]
    * @prop {VoidFunction} [onFinish]
    */
   
   /** @typedef {SpringAnimation | CSSAnimation} Animation */
   /** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps */
   
   /**
    * Manages animations
    */
   class Animations {
     constructor() {
       /** @type {Animation[]} */
       this.activeAnimations = [];
     }
   
     /**
      * @param {SpringAnimationProps} props
      */
     startSpring(props) {
       this._start(props, true);
     }
   
     /**
      * @param {CssAnimationProps} props
      */
     startTransition(props) {
       this._start(props);
     }
   
     /**
      * @private
      * @param {AnimationProps} props
      * @param {boolean} [isSpring]
      * @returns {Animation}
      */
     _start(props, isSpring) {
       const animation = isSpring
         ? new SpringAnimation(/** @type SpringAnimationProps */ (props))
         : new CSSAnimation(/** @type CssAnimationProps */ (props));
   
       this.activeAnimations.push(animation);
       animation.onFinish = () => this.stop(animation);
   
       return animation;
     }
   
     /**
      * @param {Animation} animation
      */
     stop(animation) {
       animation.destroy();
       const index = this.activeAnimations.indexOf(animation);
       if (index > -1) {
         this.activeAnimations.splice(index, 1);
       }
     }
   
     stopAll() { // _stopAllAnimations
       this.activeAnimations.forEach((animation) => {
         animation.destroy();
       });
       this.activeAnimations = [];
     }
   
     /**
      * Stop all pan or zoom transitions
      */
     stopAllPan() {
       this.activeAnimations = this.activeAnimations.filter((animation) => {
         if (animation.props.isPan) {
           animation.destroy();
           return false;
         }
   
         return true;
       });
     }
   
     stopMainScroll() {
       this.activeAnimations = this.activeAnimations.filter((animation) => {
         if (animation.props.isMainScroll) {
           animation.destroy();
           return false;
         }
   
         return true;
       });
     }
   
     /**
      * Returns true if main scroll transition is running
      */
     // isMainScrollRunning() {
     //   return this.activeAnimations.some((animation) => {
     //     return animation.props.isMainScroll;
     //   });
     // }
   
     /**
      * Returns true if any pan or zoom transition is running
      */
     isPanRunning() {
       return this.activeAnimations.some((animation) => {
         return animation.props.isPan;
       });
     }
   }
   
   /** @typedef {import('./photoswipe.js').default} PhotoSwipe */
   
   /**
    * Handles scroll wheel.
    * Can pan and zoom current slide image.
    */
   class ScrollWheel {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       pswp.events.add(pswp.element, 'wheel', /** @type EventListener */(this._onWheel.bind(this)));
     }
   
     /**
      * @private
      * @param {WheelEvent} e
      */
     _onWheel(e) {
       e.preventDefault();
       const { currSlide } = this.pswp;
       let { deltaX, deltaY } = e;
   
       if (!currSlide) {
         return;
       }
   
       if (this.pswp.dispatch('wheel', { originalEvent: e }).defaultPrevented) {
         return;
       }
   
       if (e.ctrlKey || this.pswp.options.wheelToZoom) {
         // zoom
         if (currSlide.isZoomable()) {
           let zoomFactor = -deltaY;
           if (e.deltaMode === 1 /* DOM_DELTA_LINE */) {
             zoomFactor *= 0.05;
           } else {
             zoomFactor *= e.deltaMode ? 1 : 0.002;
           }
           zoomFactor = 2 ** zoomFactor;
   
           const destZoomLevel = currSlide.currZoomLevel * zoomFactor;
           currSlide.zoomTo(destZoomLevel, {
             x: e.clientX,
             y: e.clientY
           });
         }
       } else {
         // pan
         if (currSlide.isPannable()) {
           if (e.deltaMode === 1 /* DOM_DELTA_LINE */) {
             // 18 - average line height
             deltaX *= 18;
             deltaY *= 18;
           }
   
           currSlide.panTo(
             currSlide.pan.x - deltaX,
             currSlide.pan.y - deltaY
           );
         }
       }
     }
   }
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   
   /**
    * @template T
    * @typedef {import('../types.js').Methods<T>} Methods<T>
    */
   
   /**
    * @typedef {Object} UIElementMarkupProps
    * @prop {boolean} [isCustomSVG]
    * @prop {string} inner
    * @prop {string} [outlineID]
    * @prop {number | string} [size]
    */
   
   /**
    * @typedef {Object} UIElementData
    * @prop {DefaultUIElements | string} [name]
    * @prop {string} [className]
    * @prop {UIElementMarkup} [html]
    * @prop {boolean} [isButton]
    * @prop {keyof HTMLElementTagNameMap} [tagName]
    * @prop {string} [title]
    * @prop {string} [ariaLabel]
    * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
    * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
    * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
    * @prop {number} [order]
    */
   
   /** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements */
   
   /** @typedef {string | UIElementMarkupProps} UIElementMarkup */
   
   /**
    * @param {UIElementMarkup} [htmlData]
    * @returns {string}
    */
   function addElementHTML(htmlData) {
     if (typeof htmlData === 'string') {
       // Allow developers to provide full svg,
       // For example:
       // <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
       //   <path d="..." />
       //   <circle ... />
       // </svg>
       // Can also be any HTML string.
       return htmlData;
     }
   
     if (!htmlData || !htmlData.isCustomSVG) {
       return '';
     }
   
     const svgData = htmlData;
     let out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
     // replace all %d with size
     out = out.split('%d').join(/** @type {string} */ (svgData.size || 32));
   
     // Icons may contain outline/shadow,
     // to make it we "clone" base icon shape and add border to it.
     // Icon itself and border are styled via CSS.
     //
     // Property shadowID defines ID of element that should be cloned.
     if (svgData.outlineID) {
       out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
     }
   
     out += svgData.inner;
   
     out += '</svg>';
   
     return out;
   }
   
   class UIElement {
     /**
      * @param {PhotoSwipe} pswp
      * @param {UIElementData} data
      */
     constructor(pswp, data) {
       const name = data.name || data.className;
       let elementHTML = data.html;
   
       // @ts-expect-error lookup only by `data.name` maybe?
       if (pswp.options[name] === false) {
         // exit if element is disabled from options
         return;
       }
   
       // Allow to override SVG icons from options
       // @ts-expect-error lookup only by `data.name` maybe?
       if (typeof pswp.options[name + 'SVG'] === 'string') {
         // arrowPrevSVG
         // arrowNextSVG
         // closeSVG
         // zoomSVG
         // @ts-expect-error lookup only by `data.name` maybe?
         elementHTML = pswp.options[name + 'SVG'];
       }
   
       pswp.dispatch('uiElementCreate', { data });
   
       let className = '';
       if (data.isButton) {
         className += 'pswp__button ';
         className += (data.className || `pswp__button--${data.name}`);
       } else {
         className += (data.className || `pswp__${data.name}`);
       }
   
       let tagName = data.isButton ? (data.tagName || 'button') : (data.tagName || 'div');
       tagName = /** @type {keyof HTMLElementTagNameMap} */ (tagName.toLowerCase());
       /** @type {HTMLElement} */
       const element = photoswipe_esm_createElement(className, tagName);
   
       if (data.isButton) {
         if (tagName === 'button') {
           /** @type {HTMLButtonElement} */ (element).type = 'button';
         }
   
         let { title } = data;
         const { ariaLabel } = data;
   
         // @ts-expect-error lookup only by `data.name` maybe?
         if (typeof pswp.options[name + 'Title'] === 'string') {
           // @ts-expect-error lookup only by `data.name` maybe?
           title = pswp.options[name + 'Title'];
         }
   
         if (title) {
           element.title = title;
         }
   
         const ariaText = ariaLabel || title;
         if (ariaText) {
           element.setAttribute('aria-label', ariaText);
         }
       }
   
       element.innerHTML = addElementHTML(elementHTML);
   
       if (data.onInit) {
         data.onInit(element, pswp);
       }
   
       if (data.onClick) {
         element.onclick = (e) => {
           if (typeof data.onClick === 'string') {
             // @ts-ignore
             pswp[data.onClick]();
           } else if (typeof data.onClick === 'function') {
             data.onClick(e, element, pswp);
           }
         };
       }
   
       // Top bar is default position
       const appendTo = data.appendTo || 'bar';
       /** @type {HTMLElement | undefined} root element by default */
       let container = pswp.element;
       if (appendTo === 'bar') {
         if (!pswp.topBar) {
           pswp.topBar = photoswipe_esm_createElement('pswp__top-bar pswp__hide-on-close', 'div', pswp.scrollWrap);
         }
         container = pswp.topBar;
       } else {
         // element outside of top bar gets a secondary class
         // that makes element fade out on close
         element.classList.add('pswp__hide-on-close');
   
         if (appendTo === 'wrapper') {
           container = pswp.scrollWrap;
         }
       }
   
       container?.appendChild(pswp.applyFilters('uiElement', element, data));
     }
   }
   
   /*
     Backward and forward arrow buttons
    */
   
   /** @typedef {import('./ui-element.js').UIElementData} UIElementData */
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   
   /**
    *
    * @param {HTMLElement} element
    * @param {PhotoSwipe} pswp
    * @param {boolean} [isNextButton]
    */
   function initArrowButton(element, pswp, isNextButton) {
     element.classList.add('pswp__button--arrow');
     // TODO: this should point to a unique id for this instance
     element.setAttribute('aria-controls', 'pswp__items');
     pswp.on('change', () => {
       if (!pswp.options.loop) {
         if (isNextButton) {
           /** @type {HTMLButtonElement} */
           (element).disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
         } else {
           /** @type {HTMLButtonElement} */
           (element).disabled = !(pswp.currIndex > 0);
         }
       }
     });
   }
   
   /** @type {UIElementData} */
   const arrowPrev = {
     name: 'arrowPrev',
     className: 'pswp__button--arrow--prev',
     title: 'Previous',
     order: 10,
     isButton: true,
     appendTo: 'wrapper',
     html: {
       isCustomSVG: true,
       size: 60,
       inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
       outlineID: 'pswp__icn-arrow'
     },
     onClick: 'prev',
     onInit: initArrowButton
   };
   
   /** @type {UIElementData} */
   const arrowNext = {
     name: 'arrowNext',
     className: 'pswp__button--arrow--next',
     title: 'Next',
     order: 11,
     isButton: true,
     appendTo: 'wrapper',
     html: {
       isCustomSVG: true,
       size: 60,
       inner: '<use xlink:href="#pswp__icn-arrow"/>',
       outlineID: 'pswp__icn-arrow'
     },
     onClick: 'next',
     onInit: (el, pswp) => {
       initArrowButton(el, pswp, true);
     }
   };
   
   /** @type {import('./ui-element.js').UIElementData} UIElementData */
   const closeButton = {
     name: 'close',
     title: 'Close',
     order: 20,
     isButton: true,
     html: {
       isCustomSVG: true,
       inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
       outlineID: 'pswp__icn-close'
     },
     onClick: 'close'
   };
   
   /** @type {import('./ui-element.js').UIElementData} UIElementData */
   const zoomButton = {
     name: 'zoom',
     title: 'Zoom',
     order: 10,
     isButton: true,
     html: {
       isCustomSVG: true,
       // eslint-disable-next-line max-len
       inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>'
             + '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>'
             + '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
       outlineID: 'pswp__icn-zoom'
     },
     onClick: 'toggleZoom'
   };
   
   /** @type {import('./ui-element.js').UIElementData} UIElementData */
   const loadingIndicator = {
     name: 'preloader',
     appendTo: 'bar',
     order: 7,
     html: {
       isCustomSVG: true,
       // eslint-disable-next-line max-len
       inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
       outlineID: 'pswp__icn-loading'
     },
     onInit: (indicatorElement, pswp) => {
       /** @type {boolean | undefined} */
       let isVisible;
       /** @type {NodeJS.Timeout | null} */
       let delayTimeout = null;
   
       /**
        * @param {string} className
        * @param {boolean} add
        */
       const toggleIndicatorClass = (className, add) => {
         indicatorElement.classList.toggle('pswp__preloader--' + className, add);
       };
   
       /**
        * @param {boolean} visible
        */
       const setIndicatorVisibility = (visible) => {
         if (isVisible !== visible) {
           isVisible = visible;
           toggleIndicatorClass('active', visible);
         }
       };
   
       const updatePreloaderVisibility = () => {
         if (!pswp.currSlide?.content.isLoading()) {
           setIndicatorVisibility(false);
           if (delayTimeout) {
             clearTimeout(delayTimeout);
             delayTimeout = null;
           }
           return;
         }
   
         if (!delayTimeout) {
           // display loading indicator with delay
           delayTimeout = setTimeout(() => {
             setIndicatorVisibility(Boolean(pswp.currSlide?.content.isLoading()));
             delayTimeout = null;
           }, pswp.options.preloaderDelay);
         }
       };
   
       pswp.on('change', updatePreloaderVisibility);
   
       pswp.on('loadComplete', (e) => {
         if (pswp.currSlide === e.slide) {
           updatePreloaderVisibility();
         }
       });
   
       // expose the method
       if (pswp.ui) {
         pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
       }
     }
   };
   
   /** @type {import('./ui-element.js').UIElementData} UIElementData */
   const counterIndicator = {
     name: 'counter',
     order: 5,
     onInit: (counterElement, pswp) => {
       pswp.on('change', () => {
         counterElement.innerText = (pswp.currIndex + 1)
                                     + pswp.options.indexIndicatorSep
                                     + pswp.getNumItems();
       });
     }
   };
   
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('./ui-element.js').UIElementData} UIElementData */
   
   /**
    * Set special class on element when image is zoomed.
    *
    * By default, it is used to adjust
    * zoom icon and zoom cursor via CSS.
    *
    * @param {HTMLElement} el
    * @param {boolean} isZoomedIn
    */
   function setZoomedIn(el, isZoomedIn) {
     el.classList.toggle('pswp--zoomed-in', isZoomedIn);
   }
   
   class UI {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       this.isRegistered = false;
       /** @type {UIElementData[]} */
       this.uiElementsData = [];
       /** @type {(UIElement | UIElementData)[]} */
       this.items = [];
       /** @type {() => void} */
       this.updatePreloaderVisibility = () => {};
   
       /**
        * @private
        * @type {number | undefined}
        */
       this._lastUpdatedZoomLevel = undefined;
     }
   
     init() {
       const { pswp } = this;
       this.isRegistered = false;
       this.uiElementsData = [
         closeButton,
         arrowPrev,
         arrowNext,
         zoomButton,
         loadingIndicator,
         counterIndicator
       ];
   
       pswp.dispatch('uiRegister');
   
       // sort by order
       this.uiElementsData.sort((a, b) => {
         // default order is 0
         return (a.order || 0) - (b.order || 0);
       });
   
       this.items = [];
   
       this.isRegistered = true;
       this.uiElementsData.forEach((uiElementData) => {
         this.registerElement(uiElementData);
       });
   
       pswp.on('change', () => {
         pswp.element?.classList.toggle('pswp--one-slide', pswp.getNumItems() === 1);
       });
   
       pswp.on('zoomPanUpdate', () => this._onZoomPanUpdate());
     }
   
     /**
      * @param {UIElementData} elementData
      */
     registerElement(elementData) {
       if (this.isRegistered) {
         this.items.push(
           new UIElement(this.pswp, elementData)
         );
       } else {
         this.uiElementsData.push(elementData);
       }
     }
   
     /**
      * Fired each time zoom or pan position is changed.
      * Update classes that control visibility of zoom button and cursor icon.
      *
      * @private
      */
     _onZoomPanUpdate() {
       const { template, currSlide, options } = this.pswp;
   
       if (this.pswp.opener.isClosing || !template || !currSlide) {
         return;
       }
   
       let { currZoomLevel } = currSlide;
   
       // if not open yet - check against initial zoom level
       if (!this.pswp.opener.isOpen) {
         currZoomLevel = currSlide.zoomLevels.initial;
       }
   
       if (currZoomLevel === this._lastUpdatedZoomLevel) {
         return;
       }
       this._lastUpdatedZoomLevel = currZoomLevel;
   
       const currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary;
   
       // Initial and secondary zoom levels are almost equal
       if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
         // disable zoom
         setZoomedIn(template, false);
         template.classList.remove('pswp--zoom-allowed');
         return;
       }
   
       template.classList.add('pswp--zoom-allowed');
   
       const potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial
         ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
   
       setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
   
       if (options.imageClickAction === 'zoom'
           || options.imageClickAction === 'zoom-or-close') {
         template.classList.add('pswp--click-to-zoom');
       }
     }
   }
   
   /** @typedef {import('./slide.js').SlideData} SlideData */
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   
   /** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds */
   
   /**
    * @param {HTMLElement} el
    * @returns Bounds
    */
   function getBoundsByElement(el) {
     const thumbAreaRect = el.getBoundingClientRect();
     return {
       x: thumbAreaRect.left,
       y: thumbAreaRect.top,
       w: thumbAreaRect.width
     };
   }
   
   /**
    * @param {HTMLElement} el
    * @param {number} imageWidth
    * @param {number} imageHeight
    * @returns Bounds
    */
   function getCroppedBoundsByElement(el, imageWidth, imageHeight) {
     const thumbAreaRect = el.getBoundingClientRect();
   
     // fill image into the area
     // (do they same as object-fit:cover does to retrieve coordinates)
     const hRatio = thumbAreaRect.width / imageWidth;
     const vRatio = thumbAreaRect.height / imageHeight;
     const fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
   
     const offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
     const offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
   
     /**
      * Coordinates of the image,
      * as if it was not cropped,
      * height is calculated automatically
      *
      * @type {Bounds}
      */
     const bounds = {
       x: thumbAreaRect.left + offsetX,
       y: thumbAreaRect.top + offsetY,
       w: imageWidth * fillZoomLevel
     };
   
     // Coordinates of inner crop area
     // relative to the image
     bounds.innerRect = {
       w: thumbAreaRect.width,
       h: thumbAreaRect.height,
       x: offsetX,
       y: offsetY
     };
   
     return bounds;
   }
   
   /**
    * Get dimensions of thumbnail image
    * (click on which opens photoswipe or closes photoswipe to)
    *
    * @param {number} index
    * @param {SlideData} itemData
    * @param {PhotoSwipe} instance PhotoSwipe instance
    * @returns {Bounds | undefined}
    */
   function getThumbBounds(index, itemData, instance) {
     // legacy event, before filters were introduced
     const event = instance.dispatch('thumbBounds', {
       index,
       itemData,
       instance
     });
     // @ts-expect-error
     if (event.thumbBounds) {
       // @ts-expect-error
       return event.thumbBounds;
     }
   
     const { element } = itemData;
     /** @type {Bounds | undefined} */
     let thumbBounds;
     /** @type {HTMLElement | null | undefined} */
     let thumbnail;
   
     if (element && instance.options.thumbSelector !== false) {
       const thumbSelector = instance.options.thumbSelector || 'img';
       thumbnail = element.matches(thumbSelector)
         ? element : /** @type {HTMLElement | null} */ (element.querySelector(thumbSelector));
     }
   
     thumbnail = instance.applyFilters('thumbEl', thumbnail, itemData, index);
   
     if (thumbnail) {
       if (!itemData.thumbCropped) {
         thumbBounds = getBoundsByElement(thumbnail);
       } else {
         thumbBounds = getCroppedBoundsByElement(
           thumbnail,
           itemData.width || itemData.w || 0,
           itemData.height || itemData.h || 0
         );
       }
     }
   
     return instance.applyFilters('thumbBounds', thumbBounds, itemData, index);
   }
   
   /** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
   /** @typedef {import('../photoswipe.js').DataSource} DataSource */
   /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */
   /** @typedef {import('../slide/content.js').default} ContentDefault */
   /** @typedef {import('../slide/slide.js').default} Slide */
   /** @typedef {import('../slide/slide.js').SlideData} SlideData */
   /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */
   /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */
   
   /**
    * Allow adding an arbitrary props to the Content
    * https://photoswipe.com/custom-content/#using-webp-image-format
    * @typedef {ContentDefault & Record<string, any>} Content
    */
   /** @typedef {{ x?: number; y?: number }} Point */
   
   /**
    * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
    *
    *
    * https://photoswipe.com/adding-ui-elements/
    *
    * @prop {undefined} uiRegister
    * @prop {{ data: UIElementData }} uiElementCreate
    *
    *
    * https://photoswipe.com/events/#initialization-events
    *
    * @prop {undefined} beforeOpen
    * @prop {undefined} firstUpdate
    * @prop {undefined} initialLayout
    * @prop {undefined} change
    * @prop {undefined} afterInit
    * @prop {undefined} bindEvents
    *
    *
    * https://photoswipe.com/events/#opening-or-closing-transition-events
    *
    * @prop {undefined} openingAnimationStart
    * @prop {undefined} openingAnimationEnd
    * @prop {undefined} closingAnimationStart
    * @prop {undefined} closingAnimationEnd
    *
    *
    * https://photoswipe.com/events/#closing-events
    *
    * @prop {undefined} close
    * @prop {undefined} destroy
    *
    *
    * https://photoswipe.com/events/#pointer-and-gesture-events
    *
    * @prop {{ originalEvent: PointerEvent }} pointerDown
    * @prop {{ originalEvent: PointerEvent }} pointerMove
    * @prop {{ originalEvent: PointerEvent }} pointerUp
    * @prop {{ bgOpacity: number }} pinchClose can be default prevented
    * @prop {{ panY: number }} verticalDrag can be default prevented
    *
    *
    * https://photoswipe.com/events/#slide-content-events
    *
    * @prop {{ content: Content }} contentInit
    * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
    * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
    * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
    * @prop {{ content: Content; slide: Slide }} loadError
    * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
    * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
    * @prop {{ content: Content }} contentLazyLoad can be default prevented
    * @prop {{ content: Content }} contentAppend can be default prevented
    * @prop {{ content: Content }} contentActivate can be default prevented
    * @prop {{ content: Content }} contentDeactivate can be default prevented
    * @prop {{ content: Content }} contentRemove can be default prevented
    * @prop {{ content: Content }} contentDestroy can be default prevented
    *
    *
    * undocumented
    *
    * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
    * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
    *
    * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
    * @prop {{ x: number; dragging: boolean }} moveMainScroll
    * @prop {{ slide: Slide }} firstZoomPan
    * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
    * @prop {undefined} beforeResize
    * @prop {undefined} resize
    * @prop {undefined} viewportSize
    * @prop {undefined} updateScrollOffset
    * @prop {{ slide: Slide }} slideInit
    * @prop {{ slide: Slide }} afterSetContent
    * @prop {{ slide: Slide }} slideLoad
    * @prop {{ slide: Slide }} appendHeavy can be default prevented
    * @prop {{ slide: Slide }} appendHeavyContent
    * @prop {{ slide: Slide }} slideActivate
    * @prop {{ slide: Slide }} slideDeactivate
    * @prop {{ slide: Slide }} slideDestroy
    * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
    * @prop {{ slide: Slide }} zoomPanUpdate
    * @prop {{ slide: Slide }} initialZoomPan
    * @prop {{ slide: Slide }} calcSlideSize
    * @prop {undefined} resolutionChanged
    * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
    * @prop {{ content: Content }} contentAppendImage can be default prevented
    * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
    * @prop {undefined} lazyLoad
    * @prop {{ slide: Slide }} calcBounds
    * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
    *
    *
    * legacy
    *
    * @prop {undefined} init
    * @prop {undefined} initialZoomIn
    * @prop {undefined} initialZoomOut
    * @prop {undefined} initialZoomInEnd
    * @prop {undefined} initialZoomOutEnd
    * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
    * @prop {{ itemData: SlideData; index: number }} itemData
    * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
    */
   
   /**
    * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
    *
    * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
    * Modify the total amount of slides. Example on Data sources page.
    * https://photoswipe.com/filters/#numitems
    *
    * @prop {(itemData: SlideData, index: number) => SlideData} itemData
    * Modify slide item data. Example on Data sources page.
    * https://photoswipe.com/filters/#itemdata
    *
    * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
    * Modify item data when it's parsed from DOM element. Example on Data sources page.
    * https://photoswipe.com/filters/#domitemdata
    *
    * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
    * Modify clicked gallery item index.
    * https://photoswipe.com/filters/#clickedindex
    *
    * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
    * Modify placeholder image source.
    * https://photoswipe.com/filters/#placeholdersrc
    *
    * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
    * Modify if the content is currently loading.
    * https://photoswipe.com/filters/#iscontentloading
    *
    * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
    * Modify if the content can be zoomed.
    * https://photoswipe.com/filters/#iscontentzoomable
    *
    * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
    * Modify if the placeholder should be used for the content.
    * https://photoswipe.com/filters/#usecontentplaceholder
    *
    * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
    * Modify if the placeholder should be kept after the content is loaded.
    * https://photoswipe.com/filters/#iskeepingplaceholder
    *
    *
    * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
    * Modify an element when the content has error state (for example, if image cannot be loaded).
    * https://photoswipe.com/filters/#contenterrorelement
    *
    * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
    * Modify a UI element that's being created.
    * https://photoswipe.com/filters/#uielement
    *
    * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
    * Modify the thubmnail element from which opening zoom animation starts or ends.
    * https://photoswipe.com/filters/#thumbel
    *
    * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
    * Modify the thubmnail bounds from which opening zoom animation starts or ends.
    * https://photoswipe.com/filters/#thumbbounds
    *
    * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
    *
    */
   
   /**
    * @template {keyof PhotoSwipeFiltersMap} T
    * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
    */
   
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
    */
   
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
    */
   
   /**
    * Base PhotoSwipe event object
    *
    * @template {keyof PhotoSwipeEventsMap} T
    */
   class photoswipe_esm_PhotoSwipeEvent {
     /**
      * @param {T} type
      * @param {PhotoSwipeEventsMap[T]} [details]
      */
     constructor(type, details) {
       this.type = type;
       this.defaultPrevented = false;
       if (details) {
         Object.assign(this, details);
       }
     }
   
     preventDefault() {
       this.defaultPrevented = true;
     }
   }
   
   /**
    * PhotoSwipe base class that can listen and dispatch for events.
    * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
    */
   class photoswipe_esm_Eventable {
     constructor() {
       /**
        * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
        */
       this._listeners = {};
   
       /**
        * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
        */
       this._filters = {};
   
       /** @type {PhotoSwipe | undefined} */
       this.pswp = undefined;
   
       /** @type {PhotoSwipeOptions | undefined} */
       this.options = undefined;
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {PhotoSwipeFiltersMap[T]} fn
      * @param {number} priority
      */
     addFilter(name, fn, priority = 100) {
       if (!this._filters[name]) {
         this._filters[name] = [];
       }
   
       this._filters[name]?.push({ fn, priority });
       this._filters[name]?.sort((f1, f2) => f1.priority - f2.priority);
   
       this.pswp?.addFilter(name, fn, priority);
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {PhotoSwipeFiltersMap[T]} fn
      */
     removeFilter(name, fn) {
       if (this._filters[name]) {
         // @ts-expect-error
         this._filters[name] = this._filters[name].filter(filter => (filter.fn !== fn));
       }
   
       if (this.pswp) {
         this.pswp.removeFilter(name, fn);
       }
     }
   
     /**
      * @template {keyof PhotoSwipeFiltersMap} T
      * @param {T} name
      * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
      * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
      */
     applyFilters(name, ...args) {
       this._filters[name]?.forEach((filter) => {
         // @ts-expect-error
         args[0] = filter.fn.apply(this, args);
       });
       return args[0];
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {EventCallback<T>} fn
      */
     on(name, fn) {
       if (!this._listeners[name]) {
         this._listeners[name] = [];
       }
       this._listeners[name]?.push(fn);
   
       // When binding events to lightbox,
       // also bind events to PhotoSwipe Core,
       // if it's open.
       this.pswp?.on(name, fn);
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {EventCallback<T>} fn
      */
     off(name, fn) {
       if (this._listeners[name]) {
         // @ts-expect-error
         this._listeners[name] = this._listeners[name].filter(listener => (fn !== listener));
       }
   
       this.pswp?.off(name, fn);
     }
   
     /**
      * @template {keyof PhotoSwipeEventsMap} T
      * @param {T} name
      * @param {PhotoSwipeEventsMap[T]} [details]
      * @returns {AugmentedEvent<T>}
      */
     dispatch(name, details) {
       if (this.pswp) {
         return this.pswp.dispatch(name, details);
       }
   
       const event = /** @type {AugmentedEvent<T>} */ (new photoswipe_esm_PhotoSwipeEvent(name, details));
   
       this._listeners[name]?.forEach((listener) => {
         listener.call(this, event);
       });
   
       return event;
     }
   }
   
   class photoswipe_esm_Placeholder {
     /**
      * @param {string | false} imageSrc
      * @param {HTMLElement} container
      */
     constructor(imageSrc, container) {
       // Create placeholder
       // (stretched thumbnail or simple div behind the main image)
       /** @type {HTMLImageElement | HTMLDivElement | null} */
       this.element = photoswipe_esm_createElement(
         'pswp__img pswp__img--placeholder',
         imageSrc ? 'img' : 'div',
         container
       );
   
       if (imageSrc) {
         const imgEl = /** @type {HTMLImageElement} */ (this.element);
         imgEl.decoding = 'async';
         imgEl.alt = '';
         imgEl.src = imageSrc;
         imgEl.setAttribute('role', 'presentation');
       }
   
       this.element.setAttribute('aria-hidden', 'true');
     }
   
     /**
      * @param {number} width
      * @param {number} height
      */
     setDisplayedSize(width, height) {
       if (!this.element) {
         return;
       }
   
       if (this.element.tagName === 'IMG') {
         // Use transform scale() to modify img placeholder size
         // (instead of changing width/height directly).
         // This helps with performance, specifically in iOS15 Safari.
         photoswipe_esm_setWidthHeight(this.element, 250, 'auto');
         this.element.style.transformOrigin = '0 0';
         this.element.style.transform = photoswipe_esm_toTransformString(0, 0, width / 250);
       } else {
         photoswipe_esm_setWidthHeight(this.element, width, height);
       }
     }
   
     destroy() {
       if (this.element?.parentNode) {
         this.element.remove();
       }
       this.element = null;
     }
   }
   
   /** @typedef {import('./slide.js').default} Slide */
   /** @typedef {import('./slide.js').SlideData} SlideData */
   /** @typedef {import('../core/base.js').default} PhotoSwipeBase */
   /** @typedef {import('../util/util.js').LoadState} LoadState */
   
   class photoswipe_esm_Content {
     /**
      * @param {SlideData} itemData Slide data
      * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
      * @param {number} index
      */
     constructor(itemData, instance, index) {
       this.instance = instance;
       this.data = itemData;
       this.index = index;
   
       /** @type {HTMLImageElement | HTMLDivElement | undefined} */
       this.element = undefined;
       /** @type {Placeholder | undefined} */
       this.placeholder = undefined;
       /** @type {Slide | undefined} */
       this.slide = undefined;
   
       this.displayedImageWidth = 0;
       this.displayedImageHeight = 0;
   
       this.width = Number(this.data.w) || Number(this.data.width) || 0;
       this.height = Number(this.data.h) || Number(this.data.height) || 0;
   
       this.isAttached = false;
       this.hasSlide = false;
       this.isDecoding = false;
       /** @type {LoadState} */
       this.state = photoswipe_esm_LOAD_STATE.IDLE;
   
       if (this.data.type) {
         this.type = this.data.type;
       } else if (this.data.src) {
         this.type = 'image';
       } else {
         this.type = 'html';
       }
   
       this.instance.dispatch('contentInit', { content: this });
     }
   
     removePlaceholder() {
       if (this.placeholder && !this.keepPlaceholder()) {
         // With delay, as image might be loaded, but not rendered
         setTimeout(() => {
           if (this.placeholder) {
             this.placeholder.destroy();
             this.placeholder = undefined;
           }
         }, 1000);
       }
     }
   
     /**
      * Preload content
      *
      * @param {boolean} isLazy
      * @param {boolean} [reload]
      */
     load(isLazy, reload) {
       if (this.slide && this.usePlaceholder()) {
         if (!this.placeholder) {
           const placeholderSrc = this.instance.applyFilters(
             'placeholderSrc',
             // use  image-based placeholder only for the first slide,
             // as rendering (even small stretched thumbnail) is an expensive operation
             (this.data.msrc && this.slide.isFirstSlide) ? this.data.msrc : false,
             this
           );
           this.placeholder = new photoswipe_esm_Placeholder(
             placeholderSrc,
             this.slide.container
           );
         } else {
           const placeholderEl = this.placeholder.element;
           // Add placeholder to DOM if it was already created
           if (placeholderEl && !placeholderEl.parentElement) {
             this.slide.container.prepend(placeholderEl);
           }
         }
       }
   
       if (this.element && !reload) {
         return;
       }
   
       if (this.instance.dispatch('contentLoad', { content: this, isLazy }).defaultPrevented) {
         return;
       }
   
       if (this.isImageContent()) {
         this.element = photoswipe_esm_createElement('pswp__img', 'img');
         // Start loading only after width is defined, as sizes might depend on it.
         // Due to Safari feature, we must define sizes before srcset.
         if (this.displayedImageWidth) {
           this.loadImage(isLazy);
         }
       } else {
         this.element = photoswipe_esm_createElement('pswp__content', 'div');
         this.element.innerHTML = this.data.html || '';
       }
   
       if (reload && this.slide) {
         this.slide.updateContentSize(true);
       }
     }
   
     /**
      * Preload image
      *
      * @param {boolean} isLazy
      */
     loadImage(isLazy) {
       if (!this.isImageContent()
         || !this.element
         || this.instance.dispatch('contentLoadImage', { content: this, isLazy }).defaultPrevented) {
         return;
       }
   
       const imageElement = /** @type HTMLImageElement */ (this.element);
   
       this.updateSrcsetSizes();
   
       if (this.data.srcset) {
         imageElement.srcset = this.data.srcset;
       }
   
       imageElement.src = this.data.src ?? '';
       imageElement.alt = this.data.alt ?? '';
   
       this.state = photoswipe_esm_LOAD_STATE.LOADING;
   
       if (imageElement.complete) {
         this.onLoaded();
       } else {
         imageElement.onload = () => {
           this.onLoaded();
         };
   
         imageElement.onerror = () => {
           this.onError();
         };
       }
     }
   
     /**
      * Assign slide to content
      *
      * @param {Slide} slide
      */
     setSlide(slide) {
       this.slide = slide;
       this.hasSlide = true;
       this.instance = slide.pswp;
   
       // todo: do we need to unset slide?
     }
   
     /**
      * Content load success handler
      */
     onLoaded() {
       this.state = photoswipe_esm_LOAD_STATE.LOADED;
   
       if (this.slide && this.element) {
         this.instance.dispatch('loadComplete', { slide: this.slide, content: this });
   
         // if content is reloaded
         if (this.slide.isActive
             && this.slide.heavyAppended
             && !this.element.parentNode) {
           this.append();
           this.slide.updateContentSize(true);
         }
   
         if (this.state === photoswipe_esm_LOAD_STATE.LOADED || this.state === photoswipe_esm_LOAD_STATE.ERROR) {
           this.removePlaceholder();
         }
       }
     }
   
     /**
      * Content load error handler
      */
     onError() {
       this.state = photoswipe_esm_LOAD_STATE.ERROR;
   
       if (this.slide) {
         this.displayError();
         this.instance.dispatch('loadComplete', { slide: this.slide, isError: true, content: this });
         this.instance.dispatch('loadError', { slide: this.slide, content: this });
       }
     }
   
     /**
      * @returns {Boolean} If the content is currently loading
      */
     isLoading() {
       return this.instance.applyFilters(
         'isContentLoading',
         this.state === photoswipe_esm_LOAD_STATE.LOADING,
         this
       );
     }
   
     /**
      * @returns {Boolean} If the content is in error state
      */
     isError() {
       return this.state === photoswipe_esm_LOAD_STATE.ERROR;
     }
   
     /**
      * @returns {boolean} If the content is image
      */
     isImageContent() {
       return this.type === 'image';
     }
   
     /**
      * Update content size
      *
      * @param {Number} width
      * @param {Number} height
      */
     setDisplayedSize(width, height) {
       if (!this.element) {
         return;
       }
   
       if (this.placeholder) {
         this.placeholder.setDisplayedSize(width, height);
       }
   
       if (this.instance.dispatch(
         'contentResize',
         { content: this, width, height }).defaultPrevented
       ) {
         return;
       }
   
       photoswipe_esm_setWidthHeight(this.element, width, height);
   
       if (this.isImageContent() && !this.isError()) {
         const isInitialSizeUpdate = (!this.displayedImageWidth && width);
   
         this.displayedImageWidth = width;
         this.displayedImageHeight = height;
   
         if (isInitialSizeUpdate) {
           this.loadImage(false);
         } else {
           this.updateSrcsetSizes();
         }
   
         if (this.slide) {
           this.instance.dispatch(
             'imageSizeChange',
             { slide: this.slide, width, height, content: this }
           );
         }
       }
     }
   
     /**
      * @returns {boolean} If the content can be zoomed
      */
     isZoomable() {
       return this.instance.applyFilters(
         'isContentZoomable',
         this.isImageContent() && (this.state !== photoswipe_esm_LOAD_STATE.ERROR),
         this
       );
     }
   
     /**
      * Update image srcset sizes attribute based on width and height
      */
     updateSrcsetSizes() {
       // Handle srcset sizes attribute.
       //
       // Never lower quality, if it was increased previously.
       // Chrome does this automatically, Firefox and Safari do not,
       // so we store largest used size in dataset.
       if (!this.isImageContent() || !this.element || !this.data.srcset) {
         return;
       }
   
       const image = /** @type HTMLImageElement */ (this.element);
       const sizesWidth = this.instance.applyFilters(
         'srcsetSizesWidth',
         this.displayedImageWidth,
         this
       );
   
       if (
         !image.dataset.largestUsedSize
         || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)
       ) {
         image.sizes = sizesWidth + 'px';
         image.dataset.largestUsedSize = String(sizesWidth);
       }
     }
   
     /**
      * @returns {boolean} If content should use a placeholder (from msrc by default)
      */
     usePlaceholder() {
       return this.instance.applyFilters(
         'useContentPlaceholder',
         this.isImageContent(),
         this
       );
     }
   
     /**
      * Preload content with lazy-loading param
      */
     lazyLoad() {
       if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) {
         return;
       }
   
       this.load(true);
     }
   
     /**
      * @returns {boolean} If placeholder should be kept after content is loaded
      */
     keepPlaceholder() {
       return this.instance.applyFilters(
         'isKeepingPlaceholder',
         this.isLoading(),
         this
       );
     }
   
     /**
      * Destroy the content
      */
     destroy() {
       this.hasSlide = false;
       this.slide = undefined;
   
       if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) {
         return;
       }
   
       this.remove();
   
       if (this.placeholder) {
         this.placeholder.destroy();
         this.placeholder = undefined;
       }
   
       if (this.isImageContent() && this.element) {
         this.element.onload = null;
         this.element.onerror = null;
         this.element = undefined;
       }
     }
   
     /**
      * Display error message
      */
     displayError() {
       if (this.slide) {
         let errorMsgEl = photoswipe_esm_createElement('pswp__error-msg', 'div');
         errorMsgEl.innerText = this.instance.options?.errorMsg ?? '';
         errorMsgEl = /** @type {HTMLDivElement} */ (this.instance.applyFilters(
           'contentErrorElement',
           errorMsgEl,
           this
         ));
         this.element = photoswipe_esm_createElement('pswp__content pswp__error-msg-container', 'div');
         this.element.appendChild(errorMsgEl);
         this.slide.container.innerText = '';
         this.slide.container.appendChild(this.element);
         this.slide.updateContentSize(true);
         this.removePlaceholder();
       }
     }
   
     /**
      * Append the content
      */
     append() {
       if (this.isAttached || !this.element) {
         return;
       }
   
       this.isAttached = true;
   
       if (this.state === photoswipe_esm_LOAD_STATE.ERROR) {
         this.displayError();
         return;
       }
   
       if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) {
         return;
       }
   
       const supportsDecode = ('decode' in this.element);
   
       if (this.isImageContent()) {
         // Use decode() on nearby slides
         //
         // Nearby slide images are in DOM and not hidden via display:none.
         // However, they are placed offscreen (to the left and right side).
         //
         // Some browsers do not composite the image until it's actually visible,
         // using decode() helps.
         //
         // You might ask "why dont you just decode() and then append all images",
         // that's because I want to show image before it's fully loaded,
         // as browser can render parts of image while it is loading.
         // We do not do this in Safari due to partial loading bug.
         if (supportsDecode && this.slide && (!this.slide.isActive || photoswipe_esm_isSafari())) {
           this.isDecoding = true;
           // purposefully using finally instead of then,
           // as if srcset sizes changes dynamically - it may cause decode error
           /** @type {HTMLImageElement} */
           (this.element).decode().catch(() => {}).finally(() => {
             this.isDecoding = false;
             this.appendImage();
           });
         } else {
           this.appendImage();
         }
       } else if (this.slide && !this.element.parentNode) {
         this.slide.container.appendChild(this.element);
       }
     }
   
     /**
      * Activate the slide,
      * active slide is generally the current one,
      * meaning the user can see it.
      */
     activate() {
       if (this.instance.dispatch('contentActivate', { content: this }).defaultPrevented
         || !this.slide) {
         return;
       }
   
       if (this.isImageContent() && this.isDecoding && !photoswipe_esm_isSafari()) {
         // add image to slide when it becomes active,
         // even if it's not finished decoding
         this.appendImage();
       } else if (this.isError()) {
         this.load(false, true); // try to reload
       }
   
       if (this.slide.holderElement) {
         this.slide.holderElement.setAttribute('aria-hidden', 'false');
       }
     }
   
     /**
      * Deactivate the content
      */
     deactivate() {
       this.instance.dispatch('contentDeactivate', { content: this });
       if (this.slide && this.slide.holderElement) {
         this.slide.holderElement.setAttribute('aria-hidden', 'true');
       }
     }
   
   
     /**
      * Remove the content from DOM
      */
     remove() {
       this.isAttached = false;
   
       if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) {
         return;
       }
   
       if (this.element && this.element.parentNode) {
         this.element.remove();
       }
   
       if (this.placeholder && this.placeholder.element) {
         this.placeholder.element.remove();
       }
     }
   
     /**
      * Append the image content to slide container
      */
     appendImage() {
       if (!this.isAttached) {
         return;
       }
   
       if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented) {
         return;
       }
   
       // ensure that element exists and is not already appended
       if (this.slide && this.element && !this.element.parentNode) {
         this.slide.container.appendChild(this.element);
       }
   
       if (this.state === photoswipe_esm_LOAD_STATE.LOADED || this.state === photoswipe_esm_LOAD_STATE.ERROR) {
         this.removePlaceholder();
       }
     }
   }
   
   /** @typedef {import('./content.js').default} Content */
   /** @typedef {import('./slide.js').default} Slide */
   /** @typedef {import('./slide.js').SlideData} SlideData */
   /** @typedef {import('../core/base.js').default} PhotoSwipeBase */
   /** @typedef {import('../photoswipe.js').default} PhotoSwipe */
   
   const MIN_SLIDES_TO_CACHE = 5;
   
   /**
    * Lazy-load an image
    * This function is used both by Lightbox and PhotoSwipe core,
    * thus it can be called before dialog is opened.
    *
    * @param {SlideData} itemData Data about the slide
    * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
    * @param {number} index
    * @returns {Content} Image that is being decoded or false.
    */
   function photoswipe_esm_lazyLoadData(itemData, instance, index) {
     const content = instance.createContentFromData(itemData, index);
     /** @type {ZoomLevel | undefined} */
     let zoomLevel;
   
     const { options } = instance;
   
     // We need to know dimensions of the image to preload it,
     // as it might use srcset, and we need to define sizes
     if (options) {
       zoomLevel = new photoswipe_esm_ZoomLevel(options, itemData, -1);
   
       let viewportSize;
       if (instance.pswp) {
         viewportSize = instance.pswp.viewportSize;
       } else {
         viewportSize = photoswipe_esm_getViewportSize(options, instance);
       }
   
       const panAreaSize = photoswipe_esm_getPanAreaSize(options, viewportSize, itemData, index);
       zoomLevel.update(content.width, content.height, panAreaSize);
     }
   
     content.lazyLoad();
   
     if (zoomLevel) {
       content.setDisplayedSize(
         Math.ceil(content.width * zoomLevel.initial),
         Math.ceil(content.height * zoomLevel.initial)
       );
     }
   
     return content;
   }
   
   
   /**
    * Lazy-loads specific slide.
    * This function is used both by Lightbox and PhotoSwipe core,
    * thus it can be called before dialog is opened.
    *
    * By default, it loads image based on viewport size and initial zoom level.
    *
    * @param {number} index Slide index
    * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
    * @returns {Content | undefined}
    */
   function photoswipe_esm_lazyLoadSlide(index, instance) {
     const itemData = instance.getItemData(index);
   
     if (instance.dispatch('lazyLoadSlide', { index, itemData }).defaultPrevented) {
       return;
     }
   
     return photoswipe_esm_lazyLoadData(itemData, instance, index);
   }
   
   class ContentLoader {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       // Total amount of cached images
       this.limit = Math.max(
         pswp.options.preload[0] + pswp.options.preload[1] + 1,
         MIN_SLIDES_TO_CACHE
       );
       /** @type {Content[]} */
       this._cachedItems = [];
     }
   
     /**
      * Lazy load nearby slides based on `preload` option.
      *
      * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
      */
     updateLazy(diff) {
       const { pswp } = this;
   
       if (pswp.dispatch('lazyLoad').defaultPrevented) {
         return;
       }
   
       const { preload } = pswp.options;
       const isForward = diff === undefined ? true : (diff >= 0);
       let i;
   
       // preload[1] - num items to preload in forward direction
       for (i = 0; i <= preload[1]; i++) {
         this.loadSlideByIndex(pswp.currIndex + (isForward ? i : (-i)));
       }
   
       // preload[0] - num items to preload in backward direction
       for (i = 1; i <= preload[0]; i++) {
         this.loadSlideByIndex(pswp.currIndex + (isForward ? (-i) : i));
       }
     }
   
     /**
      * @param {number} initialIndex
      */
     loadSlideByIndex(initialIndex) {
       const index = this.pswp.getLoopedIndex(initialIndex);
       // try to get cached content
       let content = this.getContentByIndex(index);
       if (!content) {
         // no cached content, so try to load from scratch:
         content = photoswipe_esm_lazyLoadSlide(index, this.pswp);
         // if content can be loaded, add it to cache:
         if (content) {
           this.addToCache(content);
         }
       }
     }
   
     /**
      * @param {Slide} slide
      * @returns {Content}
      */
     getContentBySlide(slide) {
       let content = this.getContentByIndex(slide.index);
       if (!content) {
         // create content if not found in cache
         content = this.pswp.createContentFromData(slide.data, slide.index);
         this.addToCache(content);
       }
   
       // assign slide to content
       content.setSlide(slide);
   
       return content;
     }
   
     /**
      * @param {Content} content
      */
     addToCache(content) {
       // move to the end of array
       this.removeByIndex(content.index);
       this._cachedItems.push(content);
   
       if (this._cachedItems.length > this.limit) {
         // Destroy the first content that's not attached
         const indexToRemove = this._cachedItems.findIndex((item) => {
           return !item.isAttached && !item.hasSlide;
         });
         if (indexToRemove !== -1) {
           const removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
           removedItem.destroy();
         }
       }
     }
   
     /**
      * Removes an image from cache, does not destroy() it, just removes.
      *
      * @param {number} index
      */
     removeByIndex(index) {
       const indexToRemove = this._cachedItems.findIndex(item => item.index === index);
       if (indexToRemove !== -1) {
         this._cachedItems.splice(indexToRemove, 1);
       }
     }
   
     /**
      * @param {number} index
      * @returns {Content | undefined}
      */
     getContentByIndex(index) {
       return this._cachedItems.find(content => content.index === index);
     }
   
     destroy() {
       this._cachedItems.forEach(content => content.destroy());
       this._cachedItems = [];
     }
   }
   
   /** @typedef {import("../photoswipe.js").default} PhotoSwipe */
   /** @typedef {import("../slide/slide.js").SlideData} SlideData */
   
   /**
    * PhotoSwipe base class that can retrieve data about every slide.
    * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
    */
   class photoswipe_esm_PhotoSwipeBase extends photoswipe_esm_Eventable {
     /**
      * Get total number of slides
      *
      * @returns {number}
      */
     getNumItems() {
       let numItems = 0;
       const dataSource = this.options?.dataSource;
   
       if (dataSource && 'length' in dataSource) {
         // may be an array or just object with length property
         numItems = dataSource.length;
       } else if (dataSource && 'gallery' in dataSource) {
         // query DOM elements
         if (!dataSource.items) {
           dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
         }
   
         if (dataSource.items) {
           numItems = dataSource.items.length;
         }
       }
   
       // legacy event, before filters were introduced
       const event = this.dispatch('numItems', {
         dataSource,
         numItems
       });
       return this.applyFilters('numItems', event.numItems, dataSource);
     }
   
     /**
      * @param {SlideData} slideData
      * @param {number} index
      * @returns {Content}
      */
     createContentFromData(slideData, index) {
       return new photoswipe_esm_Content(slideData, this, index);
     }
   
     /**
      * Get item data by index.
      *
      * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
      * For example, it may contain properties like
      * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
      *
      * @param {number} index
      * @returns {SlideData}
      */
     getItemData(index) {
       const dataSource = this.options?.dataSource;
       /** @type {SlideData | HTMLElement} */
       let dataSourceItem = {};
       if (Array.isArray(dataSource)) {
         // Datasource is an array of elements
         dataSourceItem = dataSource[index];
       } else if (dataSource && 'gallery' in dataSource) {
         // dataSource has gallery property,
         // thus it was created by Lightbox, based on
         // gallery and children options
   
         // query DOM elements
         if (!dataSource.items) {
           dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
         }
   
         dataSourceItem = dataSource.items[index];
       }
   
       let itemData = dataSourceItem;
   
       if (itemData instanceof Element) {
         itemData = this._domElementToItemData(itemData);
       }
   
       // Dispatching the itemData event,
       // it's a legacy verion before filters were introduced
       const event = this.dispatch('itemData', {
         itemData: itemData || {},
         index
       });
   
       return this.applyFilters('itemData', event.itemData, index);
     }
   
     /**
      * Get array of gallery DOM elements,
      * based on childSelector and gallery element.
      *
      * @param {HTMLElement} galleryElement
      * @returns {HTMLElement[]}
      */
     _getGalleryDOMElements(galleryElement) {
       if (this.options?.children || this.options?.childSelector) {
         return photoswipe_esm_getElementsFromOption(
           this.options.children,
           this.options.childSelector,
           galleryElement
         ) || [];
       }
   
       return [galleryElement];
     }
   
     /**
      * Converts DOM element to item data object.
      *
      * @param {HTMLElement} element DOM element
      * @returns {SlideData}
      */
     _domElementToItemData(element) {
       /** @type {SlideData} */
       const itemData = {
         element
       };
   
       const linkEl = /** @type {HTMLAnchorElement} */ (
         element.tagName === 'A'
           ? element
           : element.querySelector('a')
       );
   
       if (linkEl) {
         // src comes from data-pswp-src attribute,
         // if it's empty link href is used
         itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
   
         if (linkEl.dataset.pswpSrcset) {
           itemData.srcset = linkEl.dataset.pswpSrcset;
         }
   
         itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
         itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0;
   
         // support legacy w & h properties
         itemData.w = itemData.width;
         itemData.h = itemData.height;
   
         if (linkEl.dataset.pswpType) {
           itemData.type = linkEl.dataset.pswpType;
         }
   
         const thumbnailEl = element.querySelector('img');
   
         if (thumbnailEl) {
           // msrc is URL to placeholder image that's displayed before large image is loaded
           // by default it's displayed only for the first slide
           itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
           itemData.alt = thumbnailEl.getAttribute('alt') ?? '';
         }
   
         if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
           itemData.thumbCropped = true;
         }
       }
   
       return this.applyFilters('domItemData', itemData, element, linkEl);
     }
   
     /**
      * Lazy-load by slide data
      *
      * @param {SlideData} itemData Data about the slide
      * @param {number} index
      * @returns {Content} Image that is being decoded or false.
      */
     lazyLoadData(itemData, index) {
       return photoswipe_esm_lazyLoadData(itemData, this, index);
     }
   }
   
   /** @typedef {import('./photoswipe.js').default} PhotoSwipe */
   /** @typedef {import('./slide/get-thumb-bounds.js').Bounds} Bounds */
   /** @typedef {import('./util/animations.js').AnimationProps} AnimationProps */
   
   // some browsers do not paint
   // elements which opacity is set to 0,
   // since we need to pre-render elements for the animation -
   // we set it to the minimum amount
   const MIN_OPACITY = 0.003;
   
   /**
    * Manages opening and closing transitions of the PhotoSwipe.
    *
    * It can perform zoom, fade or no transition.
    */
   class Opener {
     /**
      * @param {PhotoSwipe} pswp
      */
     constructor(pswp) {
       this.pswp = pswp;
       this.isClosed = true;
       this.isOpen = false;
       this.isClosing = false;
       this.isOpening = false;
       /**
        * @private
        * @type {number | false | undefined}
        */
       this._duration = undefined;
       /** @private */
       this._useAnimation = false;
       /** @private */
       this._croppedZoom = false;
       /** @private */
       this._animateRootOpacity = false;
       /** @private */
       this._animateBgOpacity = false;
       /**
        * @private
        * @type { HTMLDivElement | HTMLImageElement | null | undefined }
        */
       this._placeholder = undefined;
       /**
        * @private
        * @type { HTMLDivElement | undefined }
        */
       this._opacityElement = undefined;
       /**
        * @private
        * @type { HTMLDivElement | undefined }
        */
       this._cropContainer1 = undefined;
       /**
        * @private
        * @type { HTMLElement | null | undefined }
        */
       this._cropContainer2 = undefined;
   
       /**
        * @private
        * @type {Bounds | undefined}
        */
       this._thumbBounds = undefined;
   
   
       this._prepareOpen = this._prepareOpen.bind(this);
   
       // Override initial zoom and pan position
       pswp.on('firstZoomPan', this._prepareOpen);
     }
   
     open() {
       this._prepareOpen();
       this._start();
     }
   
     close() {
       if (this.isClosed || this.isClosing || this.isOpening) {
         // if we close during opening animation
         // for now do nothing,
         // browsers aren't good at changing the direction of the CSS transition
         return;
       }
   
       const slide = this.pswp.currSlide;
   
       this.isOpen = false;
       this.isOpening = false;
       this.isClosing = true;
       this._duration = this.pswp.options.hideAnimationDuration;
   
       if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) {
         this._duration = 0;
       }
   
       this._applyStartProps();
       setTimeout(() => {
         this._start();
       }, this._croppedZoom ? 30 : 0);
     }
   
     /** @private */
     _prepareOpen() {
       this.pswp.off('firstZoomPan', this._prepareOpen);
       if (!this.isOpening) {
         const slide = this.pswp.currSlide;
         this.isOpening = true;
         this.isClosing = false;
         this._duration = this.pswp.options.showAnimationDuration;
         if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) {
           this._duration = 0;
         }
         this._applyStartProps();
       }
     }
   
     /** @private */
     _applyStartProps() {
       const { pswp } = this;
       const slide = this.pswp.currSlide;
       const { options } = pswp;
   
       if (options.showHideAnimationType === 'fade') {
         options.showHideOpacity = true;
         this._thumbBounds = undefined;
       } else if (options.showHideAnimationType === 'none') {
         options.showHideOpacity = false;
         this._duration = 0;
         this._thumbBounds = undefined;
       } else if (this.isOpening && pswp._initialThumbBounds) {
         // Use initial bounds if defined
         this._thumbBounds = pswp._initialThumbBounds;
       } else {
         this._thumbBounds = this.pswp.getThumbBounds();
       }
   
       this._placeholder = slide?.getPlaceholderElement();
   
       pswp.animations.stopAll();
   
       // Discard animations when duration is less than 50ms
       this._useAnimation = Boolean(this._duration && this._duration > 50);
       this._animateZoom = Boolean(this._thumbBounds)
                           && slide?.content.usePlaceholder()
                           && (!this.isClosing || !pswp.mainScroll.isShifted());
       if (!this._animateZoom) {
         this._animateRootOpacity = true;
   
         if (this.isOpening && slide) {
           slide.zoomAndPanToInitial();
           slide.applyCurrentZoomPan();
         }
       } else {
         this._animateRootOpacity = options.showHideOpacity ?? false;
       }
       this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > MIN_OPACITY;
       this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
   
       if (!this._useAnimation) {
         this._duration = 0;
         this._animateZoom = false;
         this._animateBgOpacity = false;
         this._animateRootOpacity = true;
         if (this.isOpening) {
           if (pswp.element) {
             pswp.element.style.opacity = String(MIN_OPACITY);
           }
           pswp.applyBgOpacity(1);
         }
         return;
       }
   
       if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
         // Properties are used when animation from cropped thumbnail
         this._croppedZoom = true;
         this._cropContainer1 = this.pswp.container;
         this._cropContainer2 = this.pswp.currSlide?.holderElement;
   
         if (pswp.container) {
           pswp.container.style.overflow = 'hidden';
           pswp.container.style.width = pswp.viewportSize.x + 'px';
         }
       } else {
         this._croppedZoom = false;
       }
   
       if (this.isOpening) {
         // Apply styles before opening transition
         if (this._animateRootOpacity) {
           if (pswp.element) {
             pswp.element.style.opacity = String(MIN_OPACITY);
           }
           pswp.applyBgOpacity(1);
         } else {
           if (this._animateBgOpacity && pswp.bg) {
             pswp.bg.style.opacity = String(MIN_OPACITY);
           }
           if (pswp.element) {
             pswp.element.style.opacity = '1';
           }
         }
   
         if (this._animateZoom) {
           this._setClosedStateZoomPan();
           if (this._placeholder) {
             // tell browser that we plan to animate the placeholder
             this._placeholder.style.willChange = 'transform';
   
             // hide placeholder to allow hiding of
             // elements that overlap it (such as icons over the thumbnail)
             this._placeholder.style.opacity = String(MIN_OPACITY);
           }
         }
       } else if (this.isClosing) {
         // hide nearby slides to make sure that
         // they are not painted during the transition
         if (pswp.mainScroll.itemHolders[0]) {
           pswp.mainScroll.itemHolders[0].el.style.display = 'none';
         }
         if (pswp.mainScroll.itemHolders[2]) {
           pswp.mainScroll.itemHolders[2].el.style.display = 'none';
         }
   
         if (this._croppedZoom) {
           if (pswp.mainScroll.x !== 0) {
             // shift the main scroller to zero position
             pswp.mainScroll.resetPosition();
             pswp.mainScroll.resize();
           }
         }
       }
     }
   
     /** @private */
     _start() {
       if (this.isOpening
           && this._useAnimation
           && this._placeholder
           && this._placeholder.tagName === 'IMG') {
         // To ensure smooth animation
         // we wait till the current slide image placeholder is decoded,
         // but no longer than 250ms,
         // and no shorter than 50ms
         // (just using requestanimationframe is not enough in Firefox,
         // for some reason)
         new Promise((resolve) => {
           let decoded = false;
           let isDelaying = true;
           decodeImage(/** @type {HTMLImageElement} */ (this._placeholder)).finally(() => {
             decoded = true;
             if (!isDelaying) {
               resolve(true);
             }
           });
           setTimeout(() => {
             isDelaying = false;
             if (decoded) {
               resolve(true);
             }
           }, 50);
           setTimeout(resolve, 250);
         }).finally(() => this._initiate());
       } else {
         this._initiate();
       }
     }
   
     /** @private */
     _initiate() {
       this.pswp.element?.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
   
       this.pswp.dispatch(
         this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart'
       );
   
       // legacy event
       this.pswp.dispatch(
         /** @type {'initialZoomIn' | 'initialZoomOut'} */
         ('initialZoom' + (this.isOpening ? 'In' : 'Out'))
       );
   
       this.pswp.element?.classList.toggle('pswp--ui-visible', this.isOpening);
   
       if (this.isOpening) {
         if (this._placeholder) {
           // unhide the placeholder
           this._placeholder.style.opacity = '1';
         }
         this._animateToOpenState();
       } else if (this.isClosing) {
         this._animateToClosedState();
       }
   
       if (!this._useAnimation) {
         this._onAnimationComplete();
       }
     }
   
     /** @private */
     _onAnimationComplete() {
       const { pswp } = this;
       this.isOpen = this.isOpening;
       this.isClosed = this.isClosing;
       this.isOpening = false;
       this.isClosing = false;
   
       pswp.dispatch(
         this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd'
       );
   
       // legacy event
       pswp.dispatch(
         /** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */
         ('initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'))
       );
   
       if (this.isClosed) {
         pswp.destroy();
       } else if (this.isOpen) {
         if (this._animateZoom && pswp.container) {
           pswp.container.style.overflow = 'visible';
           pswp.container.style.width = '100%';
         }
         pswp.currSlide?.applyCurrentZoomPan();
       }
     }
   
     /** @private */
     _animateToOpenState() {
       const { pswp } = this;
       if (this._animateZoom) {
         if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
           this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
           this._animateTo(this._cropContainer2, 'transform', 'none');
         }
   
         if (pswp.currSlide) {
           pswp.currSlide.zoomAndPanToInitial();
           this._animateTo(
             pswp.currSlide.container,
             'transform',
             pswp.currSlide.getCurrentTransform()
           );
         }
       }
   
       if (this._animateBgOpacity && pswp.bg) {
         this._animateTo(pswp.bg, 'opacity', String(pswp.options.bgOpacity));
       }
   
       if (this._animateRootOpacity && pswp.element) {
         this._animateTo(pswp.element, 'opacity', '1');
       }
     }
   
     /** @private */
     _animateToClosedState() {
       const { pswp } = this;
   
       if (this._animateZoom) {
         this._setClosedStateZoomPan(true);
       }
   
       // do not animate opacity if it's already at 0
       if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) {
         this._animateTo(pswp.bg, 'opacity', '0');
       }
   
       if (this._animateRootOpacity && pswp.element) {
         this._animateTo(pswp.element, 'opacity', '0');
       }
     }
   
     /**
      * @private
      * @param {boolean} [animate]
      */
     _setClosedStateZoomPan(animate) {
       if (!this._thumbBounds) return;
   
       const { pswp } = this;
       const { innerRect } = this._thumbBounds;
       const { currSlide, viewportSize } = pswp;
   
       if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
         const containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
         const containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
         const containerTwoPanX = viewportSize.x - innerRect.w;
         const containerTwoPanY = viewportSize.y - innerRect.h;
   
   
         if (animate) {
           this._animateTo(
             this._cropContainer1,
             'transform',
             photoswipe_esm_toTransformString(containerOnePanX, containerOnePanY)
           );
   
           this._animateTo(
             this._cropContainer2,
             'transform',
             photoswipe_esm_toTransformString(containerTwoPanX, containerTwoPanY)
           );
         } else {
           setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
           setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
         }
       }
   
       if (currSlide) {
         equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
         currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
         if (animate) {
           this._animateTo(currSlide.container, 'transform', currSlide.getCurrentTransform());
         } else {
           currSlide.applyCurrentZoomPan();
         }
       }
     }
   
     /**
      * @private
      * @param {HTMLElement} target
      * @param {'transform' | 'opacity'} prop
      * @param {string} propValue
      */
     _animateTo(target, prop, propValue) {
       if (!this._duration) {
         target.style[prop] = propValue;
         return;
       }
   
       const { animations } = this.pswp;
       /** @type {AnimationProps} */
       const animProps = {
         duration: this._duration,
         easing: this.pswp.options.easing,
         onComplete: () => {
           if (!animations.activeAnimations.length) {
             this._onAnimationComplete();
           }
         },
         target,
       };
       animProps[prop] = propValue;
       animations.startTransition(animProps);
     }
   }
   
   /**
    * @template T
    * @typedef {import('./types.js').Type<T>} Type<T>
    */
   
   /** @typedef {import('./slide/slide.js').SlideData} SlideData */
   /** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption */
   /** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData */
   /** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder */
   /** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */
   /** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */
   /** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds */
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
    */
   /**
    * @template {keyof PhotoSwipeEventsMap} T
    * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
    */
   
   /** @typedef {{ x: number; y: number; id?: string | number }} Point */
   /** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding */
   /** @typedef {SlideData[]} DataSourceArray */
   /** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject */
   /** @typedef {DataSourceArray | DataSourceObject} DataSource */
   /** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn */
   /** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType */
   /** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule */
   /** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption */
   
   /**
    * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
    */
   
   /** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ */
   /**
    * @typedef {Object} PreparedPhotoSwipeOptions
    *
    * @prop {DataSource} [dataSource]
    * Pass an array of any items via dataSource option. Its length will determine amount of slides
    * (which may be modified further from numItems event).
    *
    * Each item should contain data that you need to generate slide
    * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
    *
    * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
    *
    * @prop {number} bgOpacity
    * Background backdrop opacity, always define it via this option and not via CSS rgba color.
    *
    * @prop {number} spacing
    * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
    *
    * @prop {boolean} allowPanToNext
    * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
    *
    * @prop {boolean} loop
    * If set to true you'll be able to swipe from the last to the first image.
    * Option is always false when there are less than 3 slides.
    *
    * @prop {boolean} [wheelToZoom]
    * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
    *
    * @prop {boolean} pinchToClose
    * Pinch touch gesture to close the gallery.
    *
    * @prop {boolean} closeOnVerticalDrag
    * Vertical drag gesture to close the PhotoSwipe.
    *
    * @prop {Padding} [padding]
    * Slide area padding (in pixels).
    *
    * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
    * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
    *
    * @prop {number | false} hideAnimationDuration
    * Transition duration in milliseconds, can be 0.
    *
    * @prop {number | false} showAnimationDuration
    * Transition duration in milliseconds, can be 0.
    *
    * @prop {number | false} zoomAnimationDuration
    * Transition duration in milliseconds, can be 0.
    *
    * @prop {string} easing
    * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
    *
    * @prop {boolean} escKey
    * Esc key to close.
    *
    * @prop {boolean} arrowKeys
    * Left/right arrow keys for navigation.
    *
    * @prop {boolean} returnFocus
    * Restore focus the last active element after PhotoSwipe is closed.
    *
    * @prop {boolean} clickToCloseNonZoomable
    * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
    *
    * @prop {ActionType | ActionFn | false} imageClickAction
    * Refer to click and tap actions page.
    *
    * @prop {ActionType | ActionFn | false} bgClickAction
    * Refer to click and tap actions page.
    *
    * @prop {ActionType | ActionFn | false} tapAction
    * Refer to click and tap actions page.
    *
    * @prop {ActionType | ActionFn | false} doubleTapAction
    * Refer to click and tap actions page.
    *
    * @prop {number} preloaderDelay
    * Delay before the loading indicator will be displayed,
    * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
    *
    * @prop {string} indexIndicatorSep
    * Used for slide count indicator ("1 of 10 ").
    *
    * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
    * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
    *
    * @prop {string} errorMsg
    * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
    *
    * @prop {[number, number]} preload
    * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
    * first one - number of items to preload before the current image, second one - after the current image.
    * Two nearby images are always loaded.
    *
    * @prop {string} [mainClass]
    * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
    * Example on Styling page.
    *
    * @prop {HTMLElement} [appendToEl]
    * Element to which PhotoSwipe dialog will be appended when it opens.
    *
    * @prop {number} maxWidthToAnimate
    * Maximum width of image to animate, if initial rendered image width
    * is larger than this value - the opening/closing transition will be automatically disabled.
    *
    * @prop {string} [closeTitle]
    * Translating
    *
    * @prop {string} [zoomTitle]
    * Translating
    *
    * @prop {string} [arrowPrevTitle]
    * Translating
    *
    * @prop {string} [arrowNextTitle]
    * Translating
    *
    * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
    * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
    * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
    *
    * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
    *
    * @prop {number} index
    * Defines start slide index.
    *
    * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
    *
    * @prop {boolean} [arrowPrev]
    * @prop {boolean} [arrowNext]
    * @prop {boolean} [zoom]
    * @prop {boolean} [close]
    * @prop {boolean} [counter]
    *
    * @prop {string} [arrowPrevSVG]
    * @prop {string} [arrowNextSVG]
    * @prop {string} [zoomSVG]
    * @prop {string} [closeSVG]
    * @prop {string} [counterSVG]
    *
    * @prop {string} [arrowPrevTitle]
    * @prop {string} [arrowNextTitle]
    * @prop {string} [zoomTitle]
    * @prop {string} [closeTitle]
    * @prop {string} [counterTitle]
    *
    * @prop {ZoomLevelOption} [initialZoomLevel]
    * @prop {ZoomLevelOption} [secondaryZoomLevel]
    * @prop {ZoomLevelOption} [maxZoomLevel]
    *
    * @prop {boolean} [mouseMovePan]
    * @prop {Point | null} [initialPointerPos]
    * @prop {boolean} [showHideOpacity]
    *
    * @prop {PhotoSwipeModuleOption} [pswpModule]
    * @prop {() => Promise<any>} [openPromise]
    * @prop {boolean} [preloadFirstSlide]
    * @prop {ElementProvider} [gallery]
    * @prop {string} [gallerySelector]
    * @prop {ElementProvider} [children]
    * @prop {string} [childSelector]
    * @prop {string | false} [thumbSelector]
    */
   
   /** @type {PreparedPhotoSwipeOptions} */
   const defaultOptions = {
     allowPanToNext: true,
     spacing: 0.1,
     loop: true,
     pinchToClose: true,
     closeOnVerticalDrag: true,
     hideAnimationDuration: 333,
     showAnimationDuration: 333,
     zoomAnimationDuration: 333,
     escKey: true,
     arrowKeys: true,
     returnFocus: true,
     maxWidthToAnimate: 4000,
     clickToCloseNonZoomable: true,
     imageClickAction: 'zoom-or-close',
     bgClickAction: 'close',
     tapAction: 'toggle-controls',
     doubleTapAction: 'zoom',
     indexIndicatorSep: ' / ',
     preloaderDelay: 2000,
     bgOpacity: 0.8,
   
     index: 0,
     errorMsg: 'The image cannot be loaded',
     preload: [1, 2],
     easing: 'cubic-bezier(.4,0,.22,1)'
   };
   
   /**
    * PhotoSwipe Core
    */
   class PhotoSwipe extends photoswipe_esm_PhotoSwipeBase {
     /**
      * @param {PhotoSwipeOptions} [options]
      */
     constructor(options) {
       super();
   
       this.options = this._prepareOptions(options || {});
   
       /**
        * offset of viewport relative to document
        *
        * @type {Point}
        */
       this.offset = { x: 0, y: 0 };
   
       /**
        * @type {Point}
        * @private
        */
       this._prevViewportSize = { x: 0, y: 0 };
   
       /**
        * Size of scrollable PhotoSwipe viewport
        *
        * @type {Point}
        */
       this.viewportSize = { x: 0, y: 0 };
   
       /**
        * background (backdrop) opacity
        */
       this.bgOpacity = 1;
       this.currIndex = 0;
       this.potentialIndex = 0;
       this.isOpen = false;
       this.isDestroying = false;
       this.hasMouse = false;
   
       /**
        * @private
        * @type {SlideData}
        */
       this._initialItemData = {};
       /** @type {Bounds | undefined} */
       this._initialThumbBounds = undefined;
   
       /** @type {HTMLDivElement | undefined} */
       this.topBar = undefined;
       /** @type {HTMLDivElement | undefined} */
       this.element = undefined;
       /** @type {HTMLDivElement | undefined} */
       this.template = undefined;
       /** @type {HTMLDivElement | undefined} */
       this.container = undefined;
       /** @type {HTMLElement | undefined} */
       this.scrollWrap = undefined;
       /** @type {Slide | undefined} */
       this.currSlide = undefined;
   
       this.events = new DOMEvents();
       this.animations = new Animations();
       this.mainScroll = new MainScroll(this);
       this.gestures = new Gestures(this);
       this.opener = new Opener(this);
       this.keyboard = new photoswipe_esm_Keyboard(this);
       this.contentLoader = new ContentLoader(this);
     }
   
     /** @returns {boolean} */
     init() {
       if (this.isOpen || this.isDestroying) {
         return false;
       }
   
       this.isOpen = true;
       this.dispatch('init'); // legacy
       this.dispatch('beforeOpen');
   
       this._createMainStructure();
   
       // add classes to the root element of PhotoSwipe
       let rootClasses = 'pswp--open';
       if (this.gestures.supportsTouch) {
         rootClasses += ' pswp--touch';
       }
       if (this.options.mainClass) {
         rootClasses += ' ' + this.options.mainClass;
       }
       if (this.element) {
         this.element.className += ' ' + rootClasses;
       }
   
       this.currIndex = this.options.index || 0;
       this.potentialIndex = this.currIndex;
       this.dispatch('firstUpdate'); // starting index can be modified here
   
       // initialize scroll wheel handler to block the scroll
       this.scrollWheel = new ScrollWheel(this);
   
       // sanitize index
       if (Number.isNaN(this.currIndex)
           || this.currIndex < 0
           || this.currIndex >= this.getNumItems()) {
         this.currIndex = 0;
       }
   
       if (!this.gestures.supportsTouch) {
         // enable mouse features if no touch support detected
         this.mouseDetected();
       }
   
       // causes forced synchronous layout
       this.updateSize();
   
       this.offset.y = window.pageYOffset;
   
       this._initialItemData = this.getItemData(this.currIndex);
       this.dispatch('gettingData', {
         index: this.currIndex,
         data: this._initialItemData,
         slide: undefined
       });
   
       // *Layout* - calculate size and position of elements here
       this._initialThumbBounds = this.getThumbBounds();
       this.dispatch('initialLayout');
   
       this.on('openingAnimationEnd', () => {
         const { itemHolders } = this.mainScroll;
   
         // Add content to the previous and next slide
         if (itemHolders[0]) {
           itemHolders[0].el.style.display = 'block';
           this.setContent(itemHolders[0], this.currIndex - 1);
         }
         if (itemHolders[2]) {
           itemHolders[2].el.style.display = 'block';
           this.setContent(itemHolders[2], this.currIndex + 1);
         }
   
         this.appendHeavy();
   
         this.contentLoader.updateLazy();
   
         this.events.add(window, 'resize', this._handlePageResize.bind(this));
         this.events.add(window, 'scroll', this._updatePageScrollOffset.bind(this));
         this.dispatch('bindEvents');
       });
   
       // set content for center slide (first time)
       if (this.mainScroll.itemHolders[1]) {
         this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
       }
       this.dispatch('change');
   
       this.opener.open();
   
       this.dispatch('afterInit');
   
       return true;
     }
   
     /**
      * Get looped slide index
      * (for example, -1 will return the last slide)
      *
      * @param {number} index
      * @returns {number}
      */
     getLoopedIndex(index) {
       const numSlides = this.getNumItems();
   
       if (this.options.loop) {
         if (index > numSlides - 1) {
           index -= numSlides;
         }
   
         if (index < 0) {
           index += numSlides;
         }
       }
   
       return clamp(index, 0, numSlides - 1);
     }
   
     appendHeavy() {
       this.mainScroll.itemHolders.forEach((itemHolder) => {
         itemHolder.slide?.appendHeavy();
       });
     }
   
     /**
      * Change the slide
      * @param {number} index New index
      */
     goTo(index) {
       this.mainScroll.moveIndexBy(
         this.getLoopedIndex(index) - this.potentialIndex
       );
     }
   
     /**
      * Go to the next slide.
      */
     next() {
       this.goTo(this.potentialIndex + 1);
     }
   
     /**
      * Go to the previous slide.
      */
     prev() {
       this.goTo(this.potentialIndex - 1);
     }
   
     /**
      * @see slide/slide.js zoomTo
      *
      * @param {Parameters<Slide['zoomTo']>} args
      */
     zoomTo(...args) {
       this.currSlide?.zoomTo(...args);
     }
   
     /**
      * @see slide/slide.js toggleZoom
      */
     toggleZoom() {
       this.currSlide?.toggleZoom();
     }
   
     /**
      * Close the gallery.
      * After closing transition ends - destroy it
      */
     close() {
       if (!this.opener.isOpen || this.isDestroying) {
         return;
       }
   
       this.isDestroying = true;
   
       this.dispatch('close');
   
       this.events.removeAll();
       this.opener.close();
     }
   
     /**
      * Destroys the gallery:
      * - instantly closes the gallery
      * - unbinds events,
      * - cleans intervals and timeouts
      * - removes elements from DOM
      */
     destroy() {
       if (!this.isDestroying) {
         this.options.showHideAnimationType = 'none';
         this.close();
         return;
       }
   
       this.dispatch('destroy');
   
       this._listeners = {};
   
       if (this.scrollWrap) {
         this.scrollWrap.ontouchmove = null;
         this.scrollWrap.ontouchend = null;
       }
   
       this.element?.remove();
   
       this.mainScroll.itemHolders.forEach((itemHolder) => {
         itemHolder.slide?.destroy();
       });
   
       this.contentLoader.destroy();
       this.events.removeAll();
     }
   
     /**
      * Refresh/reload content of a slide by its index
      *
      * @param {number} slideIndex
      */
     refreshSlideContent(slideIndex) {
       this.contentLoader.removeByIndex(slideIndex);
       this.mainScroll.itemHolders.forEach((itemHolder, i) => {
         let potentialHolderIndex = (this.currSlide?.index ?? 0) - 1 + i;
         if (this.canLoop()) {
           potentialHolderIndex = this.getLoopedIndex(potentialHolderIndex);
         }
         if (potentialHolderIndex === slideIndex) {
           // set the new slide content
           this.setContent(itemHolder, slideIndex, true);
   
           // activate the new slide if it's current
           if (i === 1) {
             this.currSlide = itemHolder.slide;
             itemHolder.slide?.setIsActive(true);
           }
         }
       });
   
       this.dispatch('change');
     }
   
   
     /**
      * Set slide content
      *
      * @param {ItemHolder} holder mainScroll.itemHolders array item
      * @param {number} index Slide index
      * @param {boolean} [force] If content should be set even if index wasn't changed
      */
     setContent(holder, index, force) {
       if (this.canLoop()) {
         index = this.getLoopedIndex(index);
       }
   
       if (holder.slide) {
         if (holder.slide.index === index && !force) {
           // exit if holder already contains this slide
           // this could be common when just three slides are used
           return;
         }
   
         // destroy previous slide
         holder.slide.destroy();
         holder.slide = undefined;
       }
   
       // exit if no loop and index is out of bounds
       if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) {
         return;
       }
   
       const itemData = this.getItemData(index);
       holder.slide = new Slide(itemData, index, this);
   
       // set current slide
       if (index === this.currIndex) {
         this.currSlide = holder.slide;
       }
   
       holder.slide.append(holder.el);
     }
   
     /** @returns {Point} */
     getViewportCenterPoint() {
       return {
         x: this.viewportSize.x / 2,
         y: this.viewportSize.y / 2
       };
     }
   
     /**
      * Update size of all elements.
      * Executed on init and on page resize.
      *
      * @param {boolean} [force] Update size even if size of viewport was not changed.
      */
     updateSize(force) {
       // let item;
       // let itemIndex;
   
       if (this.isDestroying) {
         // exit if PhotoSwipe is closed or closing
         // (to avoid errors, as resize event might be delayed)
         return;
       }
   
       //const newWidth = this.scrollWrap.clientWidth;
       //const newHeight = this.scrollWrap.clientHeight;
   
       const newViewportSize = photoswipe_esm_getViewportSize(this.options, this);
   
       if (!force && pointsEqual(newViewportSize, this._prevViewportSize)) {
         // Exit if dimensions were not changed
         return;
       }
   
       //this._prevViewportSize.x = newWidth;
       //this._prevViewportSize.y = newHeight;
       equalizePoints(this._prevViewportSize, newViewportSize);
   
       this.dispatch('beforeResize');
   
       equalizePoints(this.viewportSize, this._prevViewportSize);
   
       this._updatePageScrollOffset();
   
       this.dispatch('viewportSize');
   
       // Resize slides only after opener animation is finished
       // and don't re-calculate size on inital size update
       this.mainScroll.resize(this.opener.isOpen);
   
       if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) {
         this.mouseDetected();
       }
   
       this.dispatch('resize');
     }
   
     /**
      * @param {number} opacity
      */
     applyBgOpacity(opacity) {
       this.bgOpacity = Math.max(opacity, 0);
       if (this.bg) {
         this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
       }
     }
   
     /**
      * Whether mouse is detected
      */
     mouseDetected() {
       if (!this.hasMouse) {
         this.hasMouse = true;
         this.element?.classList.add('pswp--has_mouse');
       }
     }
   
     /**
      * Page resize event handler
      *
      * @private
      */
     _handlePageResize() {
       this.updateSize();
   
       // In iOS webview, if element size depends on document size,
       // it'll be measured incorrectly in resize event
       //
       // https://bugs.webkit.org/show_bug.cgi?id=170595
       // https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
       if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
         setTimeout(() => {
           this.updateSize();
         }, 500);
       }
     }
   
     /**
      * Page scroll offset is used
      * to get correct coordinates
      * relative to PhotoSwipe viewport.
      *
      * @private
      */
     _updatePageScrollOffset() {
       this.setScrollOffset(0, window.pageYOffset);
     }
   
     /**
      * @param {number} x
      * @param {number} y
      */
     setScrollOffset(x, y) {
       this.offset.x = x;
       this.offset.y = y;
       this.dispatch('updateScrollOffset');
     }
   
     /**
      * Create main HTML structure of PhotoSwipe,
      * and add it to DOM
      *
      * @private
      */
     _createMainStructure() {
       // root DOM element of PhotoSwipe (.pswp)
       this.element = photoswipe_esm_createElement('pswp', 'div');
       this.element.setAttribute('tabindex', '-1');
       this.element.setAttribute('role', 'dialog');
   
       // template is legacy prop
       this.template = this.element;
   
       // Background is added as a separate element,
       // as animating opacity is faster than animating rgba()
       this.bg = photoswipe_esm_createElement('pswp__bg', 'div', this.element);
       this.scrollWrap = photoswipe_esm_createElement('pswp__scroll-wrap', 'section', this.element);
       this.container = photoswipe_esm_createElement('pswp__container', 'div', this.scrollWrap);
   
       // aria pattern: carousel
       this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
       this.container.setAttribute('aria-live', 'off');
       this.container.setAttribute('id', 'pswp__items');
   
       this.mainScroll.appendHolders();
   
       this.ui = new UI(this);
       this.ui.init();
   
       // append to DOM
       (this.options.appendToEl || document.body).appendChild(this.element);
     }
   
   
     /**
      * Get position and dimensions of small thumbnail
      *   {x:,y:,w:}
      *
      * Height is optional (calculated based on the large image)
      *
      * @returns {Bounds | undefined}
      */
     getThumbBounds() {
       return getThumbBounds(
         this.currIndex,
         this.currSlide ? this.currSlide.data : this._initialItemData,
         this
       );
     }
   
     /**
      * If the PhotoSwipe can have continuous loop
      * @returns Boolean
      */
     canLoop() {
       return (this.options.loop && this.getNumItems() > 2);
     }
   
     /**
      * @private
      * @param {PhotoSwipeOptions} options
      * @returns {PreparedPhotoSwipeOptions}
      */
     _prepareOptions(options) {
       if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
         options.showHideAnimationType = 'none';
         options.zoomAnimationDuration = 0;
       }
   
       /** @type {PreparedPhotoSwipeOptions} */
       return {
         ...defaultOptions,
         ...options
       };
     }
   }
   
   
   //# sourceMappingURL=photoswipe.esm.js.map
   
   ;// CONCATENATED MODULE: ./node_modules/readmore-js/dist/readmore.es6.js
   /*!
    * @preserve
    * 
    * Readmore.js plugin
    * Author: @jed_foster
    * Project home: jedfoster.com/Readmore.js
    * Version: 3.0.0-beta-1
    * Licensed under the MIT license
    * 
    * Debounce function from davidwalsh.name/javascript-debounce-function
    */
   let uniqueIdCounter = 0;
   
   const isCssEmbeddedFor = [];
   
   // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
   ((function removePolyfill(arr) {
     arr.forEach((item) => {
       if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
         return;
       }
       Object.defineProperty(item, 'remove', {
         configurable: true,
         enumerable: true,
         writable: true,
         value: function remove() {
           if (this.parentNode !== null) {
             this.parentNode.removeChild(this);
           }
         }
       });
     });
   })([Element.prototype, CharacterData.prototype, DocumentType.prototype]));
   
   function readmore_es6_forEach(arr, callback, scope) {
     for (let i = 0; i < arr.length; i += 1) {
       callback.call(scope, arr[i], i);
     }
   }
   
   function readmore_es6_extend(...objects) {
     const hasProp = {}.hasOwnProperty;
     let child = objects[0];
     let parent = objects[1];
   
     if (objects.length > 2) {
       const args = [];
   
       Object.keys(objects).forEach((key) => {
         args.push(objects[key]);
       });
   
       while (args.length > 2) {
         const c1 = args.shift();
         const p1 = args.shift();
         args.unshift(readmore_es6_extend(c1, p1));
       }
   
       child = args.shift();
       parent = args.shift();
     }
   
     if (parent) {
       Object.keys(parent).forEach((key) => {
         if (hasProp.call(parent, key)) {
           if (typeof parent[key] === 'object') {
             child[key] = child[key] || {};
             child[key] = readmore_es6_extend(child[key], parent[key]);
           } else {
             child[key] = parent[key];
           }
         }
       });
     }
   
     return child;
   }
   
   function debounce(func, wait, immediate) {
     let timeout;
   
     return function debouncedFunc(...args) {
       const callNow = immediate && !timeout;
       const later = () => {
         timeout = null;
         if (!immediate) func.apply(this, args);
       };
   
       clearTimeout(timeout);
       timeout = setTimeout(later, wait);
   
       if (callNow) func.apply(this, args);
     };
   }
   
   function uniqueId() {
     uniqueIdCounter += 1;
   
     return `rmjs-${uniqueIdCounter}`;
   }
   
   function setBoxHeights(element) {
     element.style.height = 'auto';
   
     const expandedHeight = parseInt(element.getBoundingClientRect().height, 10);
     const cssMaxHeight = parseInt(window.getComputedStyle(element).maxHeight, 10);
     const defaultHeight = parseInt(element.readmore.defaultHeight, 10);
   
     // Store our measurements.
     element.readmore.expandedHeight = expandedHeight;
     element.readmore.maxHeight = cssMaxHeight;
     element.readmore.collapsedHeight = cssMaxHeight || element.readmore.collapsedHeight || defaultHeight;
   
     element.style.maxHeight = 'none';
   }
   
   function createElementFromString(htmlString) {
     const div = document.createElement('div');
     div.innerHTML = htmlString;
   
     return div.firstChild;
   }
   
   function embedCSS(selector, options) {
     if (!isCssEmbeddedFor[selector]) {
       let styles = '';
   
       if (options.embedCSS && options.blockCSS !== '') {
         styles += `${selector} + [data-readmore-toggle], ${selector}[data-readmore] {
           ${options.blockCSS}
         }`;
       }
   
       // Include the transition CSS even if embedCSS is false
       styles += `${selector}[data-readmore] {
         transition: height ${options.speed}ms;
         overflow: hidden;
       }`;
   
       (((d, u) => {
         const css = d.createElement('style');
         css.type = 'text/css';
   
         if (css.styleSheet) {
           css.styleSheet.cssText = u;
         } else {
           css.appendChild(d.createTextNode(u));
         }
   
         d.getElementsByTagName('head')[0].appendChild(css);
       })(document, styles));
   
       isCssEmbeddedFor[selector] = true;
     }
   }
   
   function buildToggle(link, element, scope) {
     function clickHandler(event) {
       this.toggle(element, event);
     }
   
     let text = link;
     if (typeof link === 'function') {
       text = link(element);
     }
   
     const toggleLink = createElementFromString(text);
     toggleLink.setAttribute('data-readmore-toggle', element.id);
     toggleLink.setAttribute('aria-controls', element.id);
     toggleLink.addEventListener('click', clickHandler.bind(scope));
   
     return toggleLink;
   }
   
   function isEnvironmentSupported() {
     return (typeof window !== 'undefined' && typeof document !== 'undefined')
       && !!document.querySelectorAll && !!window.addEventListener;
   }
   
   const resizeBoxes = debounce(() => {
     const elements = document.querySelectorAll('[data-readmore]');
   
     readmore_es6_forEach(elements, (element) => {
       const expanded = element.getAttribute('aria-expanded') === 'true';
   
       setBoxHeights(element);
   
       element.style.height = `${expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight}px`;
     });
   }, 100);
   
   const readmore_es6_defaults = {
     speed: 100,
     collapsedHeight: 200,
     heightMargin: 16,
     moreLink: '<a href="#">Read More</a>',
     lessLink: '<a href="#">Close</a>',
     embedCSS: true,
     blockCSS: 'display: block; width: 100%;',
     startOpen: false,
     sourceOrder: 'after',
   
     // callbacks
     blockProcessed: () => {},
     beforeToggle: () => {},
     afterToggle: () => {}
   };
   
   class Readmore {
     constructor(...args) {
       if (!isEnvironmentSupported()) return;
   
       const [selector, options] = args;
       let elements;
   
       if (typeof selector === 'string') {
         elements = document.querySelectorAll(selector);
       } else if (selector.nodeName) {
         elements = [selector]; // emulate a NodeList by casting a single Node as an array
       } else {
         elements = selector;
       }
   
       // After all that, if we _still_ don't have iteratable NodeList, bail out.
       if (!elements.length) return;
   
       this.options = readmore_es6_extend({}, readmore_es6_defaults, options);
   
       if (typeof selector === 'string') {
         embedCSS(selector, this.options);
       } else {
         // Instances need distinct selectors so they don't stomp on each other.
         this.instanceSelector = `.${uniqueId()}`;
         embedCSS(this.instanceSelector, this.options);
       }
   
       // Need to resize boxes when the page has fully loaded.
       window.addEventListener('load', resizeBoxes);
       window.addEventListener('resize', resizeBoxes);
   
       this.elements = [];
   
       readmore_es6_forEach(elements, (element) => {
         if (this.instanceSelector) {
           element.classList.add(this.instanceSelector.substr(1));
         }
   
         const expanded = this.options.startOpen;
   
         element.readmore = {
           defaultHeight: this.options.collapsedHeight,
           heightMargin: this.options.heightMargin
         };
   
         setBoxHeights(element);
   
         const { heightMargin } = element.readmore;
   
         if (element.getBoundingClientRect().height <= element.readmore.collapsedHeight + heightMargin) {
           if (typeof this.options.blockProcessed === 'function') {
             this.options.blockProcessed(element, false);
           }
           return;
         }
   
         element.setAttribute('data-readmore', '');
         element.setAttribute('aria-expanded', expanded);
         element.id = element.id || uniqueId();
   
         const toggleLink = expanded ? this.options.lessLink : this.options.moreLink;
         const toggleElement = buildToggle(toggleLink, element, this);
   
         element.parentNode.insertBefore(toggleElement, (this.options.sourceOrder === 'before') ? element : element.nextSibling);
   
         element.style.height = `${expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight}px`;
   
         if (typeof this.options.blockProcessed === 'function') {
           this.options.blockProcessed(element, true);
         }
   
         this.elements.push(element);
       });
     }
   
     // Signature when called internally by the toggleLink click handler:
     //   toggle(element, event)
     //
     // When called externally by an instance,
     // e.g. readmoreDemo.toggle(document.querySelector('article:nth-of-type(1)')):
     //   toggle(elementOrQuerySelector)
     toggle(...args) {
       let el = args[0];
   
       const toggleElement = (element) => {
         const trigger = document.querySelector(`[aria-controls="${element.id}"]`);
         const expanded = element.getBoundingClientRect().height <= element.readmore.collapsedHeight;
         const newHeight = expanded ? element.readmore.expandedHeight : element.readmore.collapsedHeight;
   
         // Fire beforeToggle callback
         // Since we determined the new "expanded" state above we're now out of sync
         // with our true current state, so we need to flip the value of `expanded`
         if (typeof this.options.beforeToggle === 'function') {
           const shouldContinueToggle = this.options.beforeToggle(trigger, element, !expanded);
   
           // if the beforeToggle callback returns false, stop toggling
           if (shouldContinueToggle === false) {
             return;
           }
         }
   
         element.style.height = `${newHeight}px`;
   
         const transitionendHandler = (transitionEvent) => {
           // Fire afterToggle callback
           if (typeof this.options.afterToggle === 'function') {
             this.options.afterToggle(trigger, element, expanded);
           }
   
           transitionEvent.stopPropagation();
   
           element.setAttribute('aria-expanded', expanded);
           element.removeEventListener('transitionend', transitionendHandler, false);
         };
   
         element.addEventListener('transitionend', transitionendHandler, false);
   
         if (this.options.speed < 1) {
           transitionendHandler.call(this, { target: element });
         }
   
         const toggleLink = expanded ? this.options.lessLink : this.options.moreLink;
   
         if (!toggleLink) {
           trigger.remove();
         } else if (trigger && trigger.parentNode) {
           trigger.parentNode.replaceChild(buildToggle(toggleLink, element, this), trigger);
         }
       };
   
       if (typeof el === 'string') {
         el = document.querySelectorAll(el);
       }
   
       if (!el) {
         throw new Error('Element MUST be either an HTML node or querySelector string');
       }
   
       const event = args[1];
   
       if (event) {
         event.preventDefault();
         event.stopPropagation();
       }
   
       if (typeof el === 'object' && !el.nodeName) { // element is likely a NodeList
         readmore_es6_forEach(el, toggleElement);
       } else {
         toggleElement(el);
       }
     }
   
     destroy(selector) {
       let elements;
   
       if (!selector) {
         elements = this.elements; // eslint-disable-line
       } else if (typeof selector === 'string') {
         elements = document.querySelectorAll(selector);
       } else if (selector.nodeName) {
         elements = [selector]; // emulate a NodeList by casting a single Node as an array
       } else {
         elements = selector;
       }
   
       readmore_es6_forEach(elements, (element) => {
         if (this.elements.indexOf(element) === -1) {
           return;
         }
   
         this.elements = this.elements.filter((el) => el !== element);
   
         if (this.instanceSelector) {
           element.classList.remove(this.instanceSelector.substr(1));
         }
   
         delete element.readmore;
   
         element.style.height = 'initial';
         element.style.maxHeight = 'initial';
   
         element.removeAttribute('data-readmore');
         element.removeAttribute('aria-expanded');
   
         const trigger = document.querySelector(`[aria-controls="${element.id}"]`);
         if (trigger) {
           trigger.remove();
         }
   
         if (element.id.indexOf('rmjs-') !== -1) {
           element.removeAttribute('id');
         }
       });
   
       delete this;
     }
   }
   
   Readmore.VERSION = '3.0.0-beta-1';
   
   /* harmony default export */ const readmore_es6 = (Readmore);
   
   ;// CONCATENATED MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
   function bodyScrollLock_esm_toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
   
   // Older browsers don't support event options, feature detect it.
   
   // Adopted and modified solution from Bohdan Didukh (2017)
   // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
   
   var hasPassiveEvents = false;
   if (typeof window !== 'undefined') {
     var passiveTestOptions = {
       get passive() {
         hasPassiveEvents = true;
         return undefined;
       }
     };
     window.addEventListener('testPassive', null, passiveTestOptions);
     window.removeEventListener('testPassive', null, passiveTestOptions);
   }
   
   var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
   
   
   var locks = [];
   var documentListenerAdded = false;
   var initialClientY = -1;
   var previousBodyOverflowSetting = void 0;
   var previousBodyPaddingRight = void 0;
   
   // returns true if `el` should be allowed to receive touchmove events.
   var allowTouchMove = function allowTouchMove(el) {
     return locks.some(function (lock) {
       if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
         return true;
       }
   
       return false;
     });
   };
   
   var preventDefault = function preventDefault(rawEvent) {
     var e = rawEvent || window.event;
   
     // For the case whereby consumers adds a touchmove event listener to document.
     // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
     // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
     // the touchmove event on document will break.
     if (allowTouchMove(e.target)) {
       return true;
     }
   
     // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
     if (e.touches.length > 1) return true;
   
     if (e.preventDefault) e.preventDefault();
   
     return false;
   };
   
   var setOverflowHidden = function setOverflowHidden(options) {
     // If previousBodyPaddingRight is already set, don't set it again.
     if (previousBodyPaddingRight === undefined) {
       var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
       var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
   
       if (_reserveScrollBarGap && scrollBarGap > 0) {
         previousBodyPaddingRight = document.body.style.paddingRight;
         document.body.style.paddingRight = scrollBarGap + 'px';
       }
     }
   
     // If previousBodyOverflowSetting is already set, don't set it again.
     if (previousBodyOverflowSetting === undefined) {
       previousBodyOverflowSetting = document.body.style.overflow;
       document.body.style.overflow = 'hidden';
     }
   };
   
   var restoreOverflowSetting = function restoreOverflowSetting() {
     if (previousBodyPaddingRight !== undefined) {
       document.body.style.paddingRight = previousBodyPaddingRight;
   
       // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
       // can be set again.
       previousBodyPaddingRight = undefined;
     }
   
     if (previousBodyOverflowSetting !== undefined) {
       document.body.style.overflow = previousBodyOverflowSetting;
   
       // Restore previousBodyOverflowSetting to undefined
       // so setOverflowHidden knows it can be set again.
       previousBodyOverflowSetting = undefined;
     }
   };
   
   // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
   var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
     return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
   };
   
   var handleScroll = function handleScroll(event, targetElement) {
     var clientY = event.targetTouches[0].clientY - initialClientY;
   
     if (allowTouchMove(event.target)) {
       return false;
     }
   
     if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
       // element is at the top of its scroll.
       return preventDefault(event);
     }
   
     if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
       // element is at the bottom of its scroll.
       return preventDefault(event);
     }
   
     event.stopPropagation();
     return true;
   };
   
   var disableBodyScroll = function disableBodyScroll(targetElement, options) {
     // targetElement must be provided
     if (!targetElement) {
       // eslint-disable-next-line no-console
       console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
       return;
     }
   
     // disableBodyScroll must not have been called on this targetElement before
     if (locks.some(function (lock) {
       return lock.targetElement === targetElement;
     })) {
       return;
     }
   
     var lock = {
       targetElement: targetElement,
       options: options || {}
     };
   
     locks = [].concat(bodyScrollLock_esm_toConsumableArray(locks), [lock]);
   
     if (isIosDevice) {
       targetElement.ontouchstart = function (event) {
         if (event.targetTouches.length === 1) {
           // detect single touch.
           initialClientY = event.targetTouches[0].clientY;
         }
       };
       targetElement.ontouchmove = function (event) {
         if (event.targetTouches.length === 1) {
           // detect single touch.
           handleScroll(event, targetElement);
         }
       };
   
       if (!documentListenerAdded) {
         document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
         documentListenerAdded = true;
       }
     } else {
       setOverflowHidden(options);
     }
   };
   
   var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
     if (isIosDevice) {
       // Clear all locks ontouchstart/ontouchmove handlers, and the references.
       locks.forEach(function (lock) {
         lock.targetElement.ontouchstart = null;
         lock.targetElement.ontouchmove = null;
       });
   
       if (documentListenerAdded) {
         document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
         documentListenerAdded = false;
       }
   
       // Reset initial clientY.
       initialClientY = -1;
     } else {
       restoreOverflowSetting();
     }
   
     locks = [];
   };
   
   var enableBodyScroll = function enableBodyScroll(targetElement) {
     if (!targetElement) {
       // eslint-disable-next-line no-console
       console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
       return;
     }
   
     locks = locks.filter(function (lock) {
       return lock.targetElement !== targetElement;
     });
   
     if (isIosDevice) {
       targetElement.ontouchstart = null;
       targetElement.ontouchmove = null;
   
       if (documentListenerAdded && locks.length === 0) {
         document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
         documentListenerAdded = false;
       }
     } else if (!locks.length) {
       restoreOverflowSetting();
     }
   };
   
   
   ;// CONCATENATED MODULE: ./src/javascripts/global/MediaWrapper.js
   
   
   class MediaWrapper {
     /**
      *
      * @param {import('../ThemeBase').default} theme
      * @param {string} sectionId
      * @param {import('theme-checker/dist/shopify').Media} media
      * @param {HTMLElement} target
      */
     constructor(theme, sectionId, media, target) {
       this.load = () => {
         return new Promise(resolve => {
           if (this.loaded) {
             resolve();
             return;
           }
           if (this.media.media_type === 'image') {
             this.on_load();
             resolve();
             return;
           }
           var template = /** @type {HTMLTemplateElement} */document.querySelector(`#media-template-${this.sectionId}-${this.media.id}`);
           if (!template) {
             this.on_load();
             resolve();
             return;
           }
           const fragment = document.importNode(template.content, true);
           while (this.target.firstChild) {
             this.target.removeChild(this.target.lastChild);
           }
           this.target.appendChild(fragment);
           this.renderedElement = this.target.lastElementChild;
           switch (this.media.media_type) {
             case 'model':
               window.Shopify.loadFeatures([{
                 name: 'model-viewer-ui',
                 version: '1.0'
               }], () => {
                 this.modelController = new window.Shopify.ModelViewerUI(this.renderedElement.querySelector('model-viewer'));
   
                 // Don't interact with the rest of the page when model is not disabled
                 this.modelController.viewer.parentElement.addEventListener('mouseup', e => {
                   e.stopPropagation = function () {};
                 }, {
                   capture: true
                 });
   
                 // Prevent activating the viewer right after it was paused when clicked in position of the button
                 this.modelController.elements.controlButton.addEventListener('click', e => {
                   e.stopImmediatePropagation();
                 }, {
                   capture: true
                 });
                 this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_pause', this.on_pause.bind(this));
                 this.modelController.viewer.addEventListener('shopify_model_viewer_ui_toggle_play', this.on_play.bind(this));
                 this.on_load();
                 resolve();
               });
               break;
             case 'video':
               window.Shopify.loadFeatures([{
                 name: 'video-ui',
                 version: '1.0',
                 onLoad: function () {
                   var video = this.renderedElement.querySelector('video');
                   var loop = video.parentNode.dataset.videoLoop === 'true';
                   this.plyrController = new window.Shopify.Plyr(video, {
                     loop: {
                       active: loop
                     },
                     focusOnPlay: false
                   });
                   video.addEventListener('play', this.on_play.bind(this));
                   video.addEventListener('pause', this.on_pause.bind(this));
                   video.addEventListener('ended', this.on_pause.bind(this));
                   this.on_load();
                   resolve();
                 }.bind(this)
               }]);
               break;
             case 'external_video':
               var iframe = /** @type {HTMLIFrameElement} */this.renderedElement.querySelector('iframe');
               var loop = /** @type {HTMLElement} */iframe.parentNode.dataset.videoLoop === 'true';
               if (iframe.src.indexOf('youtube.com') !== -1) {
                 this.externalVideoHost = 'youtube';
                 this.theme.loadYoutubeApi().then(() => {
                   new window.YT.Player(iframe, {
                     events: {
                       onReady: event => {
                         this.youtubeController = /** @type {import('../window').YoutubePlayer} */event.target;
                         this.on_load();
                         resolve();
                       },
                       onStateChange: event => {
                         if (event.data === window.YT.PlayerState.PLAYING) {
                           this.on_play();
                         } else if (event.data === window.YT.PlayerState.PAUSED) {
                           this.on_pause();
                         } else if (event.data === window.YT.PlayerState.ENDED) {
                           if (loop) {
                             this.youtubeController.playVideo();
                           } else {
                             this.on_pause();
                           }
                         }
                       },
                       onError: event => {
                         console.warn('Youtube video error', event, event.data);
                         this.on_pause();
                       }
                     }
                   });
                 });
               } else if (iframe.src.indexOf('vimeo.com') !== -1) {
                 this.externalVideoHost = 'vimeo';
                 let self = this;
                 this.theme.loadVimeoApi().then(() => {
                   // @ts-ignore
                   let player = new window.Vimeo.Player(iframe);
                   player.ready().then(function () {
                     self.vimeoController = player;
                     self.on_load();
                     resolve();
                   });
                   player.on('play', function () {
                     self.vimeoController.setLoop(loop);
                     self.on_play();
                   });
                   player.on('pause', function () {
                     self.on_pause();
                   });
                 });
               }
               break;
             default:
               this.on_load();
               resolve();
           }
         });
       };
       this.isMobile = () => {
         return window.matchMedia('only screen and (max-width: 767px)').matches;
       };
       this.on_load = () => {
         this.loaded = true;
         this.target.querySelector('.product-medias__media').classList.add('product-medias__media--loaded');
         var e = new CustomEvent('media-load', {
           detail: {
             parent: this.target,
             media: this
           }
         });
         this.target.dispatchEvent(e);
         if (window.ShopifyXR && window.ShopifyXR.setupXRElements) {
           window.ShopifyXR.setupXRElements();
         }
       };
       this.play = () => {
         if (!this.loaded) {
           this.load().then(this._play.bind(this));
         } else {
           this._play();
         }
       };
       this._play = () => {
         switch (this.media.media_type) {
           case 'model':
             this.modelController.play();
             this.on_play();
             break;
           case 'video':
             this.plyrController.play().then(this.on_play.bind(this)).catch(console.warn);
             break;
           case 'external_video':
             if (this.externalVideoHost == 'youtube') {
               this.youtubeController.playVideo();
             } else if (this.externalVideoHost == 'vimeo') {
               this.vimeoController.play();
             }
             this.on_play();
             break;
         }
       };
       this.on_play = () => {
         this.active = true;
         this.target.querySelector('.product-medias__media').classList.add('product-medias__media--active');
         if (!this.loaded) {
           this.loaded = true;
           this.target.querySelector('.product-medias__media').classList.add('product-medias__media--loaded');
         }
         var e = new CustomEvent('media-play', {
           detail: {
             parent: this.target,
             media: this
           }
         });
         this.target.dispatchEvent(e);
         if (document.activeElement === document.body) {
           // No element has focus, focus this media
           this.focus();
         }
       };
       this.autoplay = () => {
         if (jquery_default()(window).width() > 767 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
           this.play();
         }
       };
       this.pause = () => {
         if (!this.active) {
           return;
         }
         switch (this.media.media_type) {
           case 'model':
             break;
           case 'video':
             this.plyrController.pause();
             break;
           case 'external_video':
             if (this.externalVideoHost == 'youtube') {
               this.youtubeController.pauseVideo();
             } else if (this.externalVideoHost == 'vimeo') {
               this.vimeoController.pause();
             }
             break;
         }
         this.on_pause();
       };
       this.togglePlay = () => {
         if (this.active) {
           this.pause();
         } else {
           this.play();
         }
       };
       this.on_pause = () => {
         this.active = false;
         this.target.querySelector('.product-medias__media').classList.remove('product-medias__media--active');
         var e = new CustomEvent('media-pause', {
           detail: {
             parent: this.target,
             media: this
           }
         });
         this.target.dispatchEvent(e);
       };
       this.focus = () => {
         switch (this.media.media_type) {
           case 'video':
             /** @type {HTMLElement} */this.target.querySelector('.plyr').focus();
             break;
           case 'model':
             var viewer = this.target.querySelector('model-viewer');
             if (viewer && viewer.shadowRoot) {
               /** @type {HTMLElement} */viewer.focus();
             } else {
               // Not yet loaded, try later
               setTimeout(this.focus.bind(this), 1000);
             }
             break;
           case 'external_video':
             this.target.querySelector('iframe').contentWindow.focus();
             break;
           default:
             this.target.focus();
         }
       };
       this.destroy = () => {};
       this.theme = theme;
       this.sectionId = sectionId;
       this.mediaId = media.id;
       this.media = media;
       this.target = target;
       this.renderedElement = null;
       this.loaded = false;
       this.active = false;
       this.plyrController = null;
       this.modelController = null;
       this.youtubeController = null;
       this.vimeoController = null;
       this.externalVideoHost = null;
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Accessibility.js
   class Accessibility {
     constructor() {
       this.state = {
         firstFocusable: null,
         lastFocusable: null
       };
     }
   
     /**
      * Traps the focus in a particular container
      *
      * @param {object} options - Options to be used
      * @param {HTMLElement} options.container - Container to trap focus within
      * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
      */
     trapFocus(options) {
       var focusableElements = /** @type {HTMLElement[]} */Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (element) {
         var width = element.offsetWidth;
         var height = element.offsetHeight;
         return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue('display') !== 'none';
       });
       this.state.firstFocusable = focusableElements[0];
       this.state.lastFocusable = focusableElements[focusableElements.length - 1];
       if (!options.elementToFocus) {
         options.elementToFocus = options.container;
       }
       options.container.setAttribute('tabindex', '-1');
       options.elementToFocus.focus();
       this._setupHandlers();
       document.addEventListener('focusin', this._onFocusInHandler);
       document.addEventListener('focusout', this._onFocusOutHandler);
     }
     _setupHandlers() {
       if (!this._onFocusInHandler) {
         this._onFocusInHandler = this._onFocusIn.bind(this);
       }
       if (!this._onFocusOutHandler) {
         this._onFocusOutHandler = this._onFocusIn.bind(this);
       }
       if (!this._manageFocusHandler) {
         this._manageFocusHandler = this._manageFocus.bind(this);
       }
     }
     _onFocusOut() {
       document.removeEventListener('keydown', this._manageFocusHandler);
     }
     _onFocusIn(evt) {
       if (evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable) return;
       document.addEventListener('keydown', this._manageFocusHandler);
     }
     _manageFocus(evt) {
       if (evt.keyCode !== 9) return;
   
       /**
        * On the last focusable element and tab forward,
        * focus the first element.
        */
       if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
         evt.preventDefault();
         this.state.firstFocusable.focus();
       }
       /**
        * On the first focusable element and tab backward,
        * focus the last element.
        */
       if (evt.target === this.state.firstFocusable && evt.shiftKey) {
         evt.preventDefault();
         this.state.lastFocusable.focus();
       }
     }
   
     /**
      * Removes the trap of focus in a particular container
      *
      * @param {object} options - Options to be used
      * @param {HTMLElement} options.container - Container to trap focus within
      * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
      */
     removeTrapFocus(options) {
       if (options.container) {
         options.container.removeAttribute('tabindex');
       }
       if (options.elementToFocus) {
         options.elementToFocus.focus();
       }
       document.removeEventListener('focusin', this._onFocusInHandler);
     }
   }
   ;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=template&id=5e6c97d0&
   var render = function () {
     var _vm = this
     var _h = _vm.$createElement
     var _c = _vm._self._c || _h
     return _c(
       "div",
       {
         ref: "component",
         staticClass: "wetheme-dropdown",
         class: [
           "fit-" + _vm.fit,
           _vm.open ? "wetheme-dropdown--open" : "wetheme-dropdown--closed",
           "wetheme-dropdown--" + _vm.direction,
         ],
       },
       [
         _vm.title
           ? _c("div", { staticClass: "option-label-wrapper" }, [
               _c("label", {
                 staticClass: "label-font",
                 attrs: { for: _vm.id },
                 domProps: { textContent: _vm._s(_vm.title) },
               }),
               _vm._v(" "),
               _c(
                 "div",
                 {
                   staticClass: "text-link-animated",
                   attrs: { id: "size-guide" },
                 },
                 [
                   _vm.sizeGuideLink
                     ? _c("a", {
                         attrs: {
                           href: _vm.sizeGuideLink,
                           id: "wetheme-dropdown__size-guide",
                         },
                         domProps: { textContent: _vm._s(_vm.sizeGuideText) },
                       })
                     : _vm._e(),
                 ]
               ),
             ])
           : _vm._e(),
         _vm._v(" "),
         _c(
           "div",
           { staticClass: "wetheme-dropdown__wrapper" },
           [
             _c(
               "button",
               {
                 ref: "button",
                 attrs: {
                   id: _vm.id,
                   type: "button",
                   autocomplete: "off",
                   readonly: "true",
                   tabindex: "0",
                   "aria-controls": _vm.dropdownId,
                   "aria-expanded": _vm.open,
                 },
                 on: {
                   click: _vm.toggleOpen,
                   blur: function ($event) {
                     $event.preventDefault()
                     return _vm.close.apply(null, arguments)
                   },
                   keydown: [
                     function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "up", 38, $event.key, [
                           "Up",
                           "ArrowUp",
                         ])
                       ) {
                         return null
                       }
                       $event.preventDefault()
                       return _vm.moveFocusedIndex(-1)
                     },
                     function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "down", 40, $event.key, [
                           "Down",
                           "ArrowDown",
                         ])
                       ) {
                         return null
                       }
                       $event.preventDefault()
                       return _vm.moveFocusedIndex(1)
                     },
                     function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                       ) {
                         return null
                       }
                       $event.preventDefault()
                       return _vm.applyFocused(false)
                     },
                     function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "space", 32, $event.key, [
                           " ",
                           "Spacebar",
                         ])
                       ) {
                         return null
                       }
                       $event.preventDefault()
                       return _vm.applyFocused(false)
                     },
                     function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "esc", 27, $event.key, [
                           "Esc",
                           "Escape",
                         ])
                       ) {
                         return null
                       }
                       $event.preventDefault()
                       return _vm.close.apply(null, arguments)
                     },
                   ],
                 },
               },
               [
                 _c("span", {
                   staticClass: "header--supporting-text",
                   domProps: {
                     textContent: _vm._s(_vm.selectedOption.label || "\xa0"),
                   },
                 }),
                 _vm._v(" "),
                 _c("span", { staticClass: "icon-dropdown" }, [
                   _c(
                     "svg",
                     {
                       attrs: {
                         viewBox: "0 0 20 20",
                         fill: "none",
                         xmlns: "http://www.w3.org/2000/svg",
                         width: "16",
                         height: "16",
                       },
                     },
                     [
                       _c("path", {
                         attrs: {
                           d: "M5.5 7.5L10.5 12.5L15.5 7.5",
                           stroke: "currentColor",
                           "stroke-width": "1.5",
                           "stroke-linecap": "round",
                           "stroke-linejoin": "round",
                         },
                       }),
                     ]
                   ),
                 ]),
               ]
             ),
             _vm._v(" "),
             _c("transition", { attrs: { name: "wetheme-dropdown-fade" } }, [
               _c(
                 "ul",
                 {
                   directives: [
                     {
                       name: "show",
                       rawName: "v-show",
                       value: _vm.open,
                       expression: "open",
                     },
                   ],
                   ref: "ul",
                   staticClass: "dropdown-list",
                   attrs: { id: _vm.dropdownId },
                 },
                 _vm._l(_vm.options, function (option) {
                   return _c(
                     "li",
                     {
                       key: option.value,
                       class: [
                         "dropdown-list--item",
                         {
                           selected:
                             option.value === _vm.options[_vm.focusedIndex].value,
                           "sold-out": option.soldOutText,
                         },
                       ],
                       attrs: { value: option.value },
                       on: {
                         mousedown: function ($event) {
                           return _vm.optionClicked(option)
                         },
                       },
                     },
                     [
                       _c("span", { staticClass: "option-label" }, [
                         _vm._v(_vm._s(option.label)),
                       ]),
                       _vm._v(" "),
                       option.soldOutText
                         ? _c("span", { staticClass: "status-text" }, [
                             _vm._v(_vm._s(option.soldOutText)),
                           ])
                         : _vm._e(),
                     ]
                   )
                 }),
                 0
               ),
             ]),
           ],
           1
         ),
       ]
     )
   }
   var staticRenderFns = []
   render._withStripped = true
   
   
   ;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue?vue&type=template&id=5e6c97d0&
   
   ;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-2.use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   
   
   function getElementWidth(el) {
     const clone = el.cloneNode(true);
     clone.style.cssText = "position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset";
     document.body.appendChild(clone);
     const width = clone.getBoundingClientRect().width;
     document.body.removeChild(clone);
     return width;
   }
   let dropdown_last_id = 0;
   /* harmony default export */ const Dropdownvue_type_script_lang_js_ = (vue_esm.extend({
     props: {
       fit: {
         type: String,
         default: "parent",
         validator: function (value) {
           return ["parent", "current", "longest"].indexOf(value) !== -1;
         }
       },
       direction: {
         type: String,
         default: "down",
         validator: function (value) {
           return ["down", "up"].indexOf(value) !== -1;
         }
       },
       isVariantDropdown: {
         type: Boolean,
         default: false
       },
       soldOutString: {
         type: String,
         default: ''
       },
       name: {
         type: String,
         default: ""
       },
       value: {
         type: String,
         default: null
       }
     },
     data: function () {
       return {
         id: "",
         title: "",
         open: false,
         options: [],
         selectedOption: undefined,
         // focusedIndex is index of option that user navigated to using keyboard,
         // it's equal to index of selected option when keyboard was not used
         focusedIndex: 0,
         selectComponent: undefined
       };
     },
     computed: {
       dropdownId: function () {
         return this.id + "-dropdown";
       }
     },
     watch: {
       value: function (newVal) {
         this.options.forEach((option, index) => {
           if (option.value === newVal) {
             this.selectedOption = option;
             this.focusedIndex = index;
           }
         });
       }
     },
     beforeMount: function () {
       // Convert a <select> and <label> into options and other properties
       const el = this.$root.$el.tagName === "WETHEME-DROPDOWN" ? this.$root.$el : this.$root.$el.querySelector("wetheme-dropdown");
       var select = el.querySelector("select");
       if (select.id) {
         this.id = select.id;
       } else {
         dropdown_last_id += 1;
         this.id = "wetheme-dropdown-" + dropdown_last_id;
       }
       var labelEl = el.querySelector("label");
       this.title = labelEl?.textContent;
       var sizeGuideEl = el.querySelector("#size-guide-link");
       this.sizeGuideLink = sizeGuideEl?.href;
       this.sizeGuideText = sizeGuideEl?.textContent;
       var options = [];
       Array.prototype.forEach.call(select.querySelectorAll("option"), (option, index) => {
         options.push({
           value: option.value,
           label: option.textContent,
           soldOutText: option.getAttribute('data-status-text') || null
         });
         if (option.defaultSelected) {
           this.selectedOption = option;
           this.focusedIndex = index;
         }
       });
       this.options = options;
       if (!this.selectedOption) {
         this.selectedOption = options[0];
         this.focusedIndex = 0;
       }
       this.selectWidth = getElementWidth(select);
       this.selectComponent = select;
       this.selectComponent.style.display = "none";
       this.selectComponent.addEventListener("input", console.log);
       el.parentNode.removeChild(el);
     },
     mounted: function () {
       if (this.fit === "longest") {
         var w = this.selectWidth + 20; // 20px for caret
         this.$el.style.width = w + "px";
         this.$refs.ul.style.width = w + "px";
       }
       this.$el.appendChild(this.selectComponent);
       this.productForm = this.$el.closest('.product-single-wrapper') || this.$el.closest('#product-box');
   
       // Check if this.productForm is available and isVariantDropdown is true
       if (this.isVariantDropdown && this.productForm) {
         this.productForm.addEventListener('variant:changed', this.handleVariantChange);
       }
     },
     methods: {
       findOptionIndex: function (option) {
         var index;
         this.options.forEach(function (o, i) {
           if (o.value === option.value) {
             index = i;
           }
         });
         return index;
       },
       optionClicked: function (option) {
         this.selectedOption = option;
         this.focusedIndex = this.findOptionIndex(option);
         this.selectComponent.value = option.value;
         this.open = false;
         this.$nextTick(function () {
           // Emit the event when input value is already changed
           var e = new CustomEvent("change");
           this.selectComponent.dispatchEvent(e);
         });
         this.$emit("change", option.value, this.name);
       },
       moveFocusedIndex: function (offset) {
         var focusedIndex = this.focusedIndex + offset;
         if (focusedIndex >= 0 && focusedIndex < this.options.length) {
           this.focusedIndex = focusedIndex;
         }
         if (!this.open) {
           this.applyFocused(true);
         }
       },
       toggleOpen: function () {
         this.$nextTick(function () {
           if (!this.open) {
             this.open = true;
             this.$refs.button.focus();
           } else {
             this.open = false;
             this.$refs.button.blur();
           }
         });
       },
       applyFocused: function (force) {
         if (!this.open && !force) {
           this.open = true;
           return;
         }
         this.optionClicked(this.options[this.focusedIndex]);
         this.open = false;
       },
       handleVariantChange(event) {
         const product = event.detail.product;
         if (!product || product.options.length === 1) return;
         const variant = event.detail.variant;
         if (!variant) return;
         this.$nextTick(() => {
           product.options.forEach((option, index) => {
             const optionValues = product.variants.map(variant => variant[`option${index + 1}`]);
             optionValues.forEach(value => {
               this.UpdateDropdownState(product, value, index + 1, variant, option);
             });
           });
         });
       },
       UpdateDropdownState(product, value, optionIndex, currentVariant) {
         const availability = product.variants.map(variant => variant.available);
         const optionValues = [product.variants.map(variant => variant.option1), product.variants.map(variant => variant.option2), product.variants.map(variant => variant.option3)];
         const isOptionAvailable = optionValues[optionIndex - 1].some((optionValue, i) => {
           switch (optionIndex) {
             case 1:
               return optionValue === value && availability[i];
             case 2:
               return optionValue === value && optionValues[0][i] === currentVariant.option1 && availability[i];
             case 3:
               return optionValue === value && optionValues[0][i] === currentVariant.option1 && optionValues[1][i] === currentVariant.option2 && availability[i];
             default:
               return false;
           }
         });
         const dropdowns = this.productForm.querySelectorAll(`.dropdown-list--item[value="${value}"]`);
         dropdowns.forEach(dropdown => {
           if (isOptionAvailable) {
             dropdown.classList.remove('sold-out');
             // Remove sold-out text if it exists
             const statusText = dropdown.querySelector('.status-text');
             if (statusText) {
               statusText.remove();
             }
           } else {
             dropdown.classList.add('sold-out');
             // Add sold-out text if it doesn't exist
             if (!dropdown.querySelector('.status-text')) {
               const soldOutText = document.createElement('span');
               soldOutText.className = 'status-text';
               soldOutText.textContent = this.soldOutString;
               dropdown.appendChild(soldOutText);
             }
           }
         });
       },
       close: function () {
         this.open = false;
       }
     },
     beforeDestroy: function () {
       if (this.isVariantDropdown && this.productForm) {
         this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
       }
     }
   }));
   ;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue?vue&type=script&lang=js&
    /* harmony default export */ const components_Dropdownvue_type_script_lang_js_ = (Dropdownvue_type_script_lang_js_); 
   ;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
   /* globals __VUE_SSR_CONTEXT__ */
   
   // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
   // This module is a runtime utility for cleaner component module output and will
   // be included in the final webpack user bundle.
   
   function normalizeComponent(
     scriptExports,
     render,
     staticRenderFns,
     functionalTemplate,
     injectStyles,
     scopeId,
     moduleIdentifier /* server only */,
     shadowMode /* vue-cli only */
   ) {
     // Vue.extend constructor export interop
     var options =
       typeof scriptExports === 'function' ? scriptExports.options : scriptExports
   
     // render functions
     if (render) {
       options.render = render
       options.staticRenderFns = staticRenderFns
       options._compiled = true
     }
   
     // functional template
     if (functionalTemplate) {
       options.functional = true
     }
   
     // scopedId
     if (scopeId) {
       options._scopeId = 'data-v-' + scopeId
     }
   
     var hook
     if (moduleIdentifier) {
       // server build
       hook = function (context) {
         // 2.3 injection
         context =
           context || // cached call
           (this.$vnode && this.$vnode.ssrContext) || // stateful
           (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
         // 2.2 with runInNewContext: true
         if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
           context = __VUE_SSR_CONTEXT__
         }
         // inject component styles
         if (injectStyles) {
           injectStyles.call(this, context)
         }
         // register component module identifier for async chunk inferrence
         if (context && context._registeredComponents) {
           context._registeredComponents.add(moduleIdentifier)
         }
       }
       // used by ssr in case component is cached and beforeCreate
       // never gets called
       options._ssrRegister = hook
     } else if (injectStyles) {
       hook = shadowMode
         ? function () {
             injectStyles.call(
               this,
               (options.functional ? this.parent : this).$root.$options.shadowRoot
             )
           }
         : injectStyles
     }
   
     if (hook) {
       if (options.functional) {
         // for template-only hot-reload because in that case the render fn doesn't
         // go through the normalizer
         options._injectStyles = hook
         // register for functional component in vue file
         var originalRender = options.render
         options.render = function renderWithStyleInjection(h, context) {
           hook.call(context)
           return originalRender(h, context)
         }
       } else {
         // inject component registration as beforeCreate hook
         var existing = options.beforeCreate
         options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
       }
     }
   
     return {
       exports: scriptExports,
       options: options
     }
   }
   
   ;// CONCATENATED MODULE: ./src/javascripts/components/Dropdown.vue
   
   
   
   
   
   /* normalize component */
   ;
   var component = normalizeComponent(
     components_Dropdownvue_type_script_lang_js_,
     render,
     staticRenderFns,
     false,
     null,
     null,
     null
     
   )
   
   /* harmony default export */ const Dropdown = (component.exports);
   ;// CONCATENATED MODULE: ./src/javascripts/sections/ProductSection.js
   var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
   function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
   function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
   function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   /** @typedef {import('theme-checker/dist/shopify').Variant} Variant */
   /** @typedef {import('theme-checker/dist/shopify').Product} Product */
   /** @typedef {import('theme-checker/dist/shopify').Media} Media */
   
   const State = {
     ready: 'ready',
     soldOut: 'soldOut',
     added: 'added',
     unavailable: 'unavailable',
     adding: 'adding'
   };
   const MOBILE_BREAKPOINT = Breakpoints.xs;
   let ProductForm = (_dec = vue_class_component_esm({
     components: {
       'wetheme-dropdown': Dropdown
     }
   }), _dec2 = Prop({
     required: true
   }), _dec3 = Prop({
     required: true
   }), _dec4 = Prop({
     required: true
   }), _dec5 = Prop({
     required: true
   }), _dec6 = Prop({
     required: true
   }), _dec7 = Prop({
     required: true
   }), _dec8 = Prop({
     required: true
   }), _dec9 = Prop({
     required: true
   }), _dec10 = Prop({
     required: true
   }), _dec11 = Prop({
     required: true
   }), _dec12 = Prop({
     required: true
   }), _dec13 = Prop({
     required: true
   }), _dec14 = Prop({
     required: true
   }), _dec15 = Prop({
     required: false
   }), _dec16 = Watch('variant'), _dec17 = Watch('sendAsGift', {
     deep: true
   }), _dec(_class = (_class2 = class ProductForm extends vue_esm {
     constructor(...args) {
       super(...args);
       _initializerDefineProperty(this, "initialVariantId", _descriptor, this);
       _initializerDefineProperty(this, "product", _descriptor2, this);
       _initializerDefineProperty(this, "theme", _descriptor3, this);
       _initializerDefineProperty(this, "productSection", _descriptor4, this);
       _initializerDefineProperty(this, "isFeaturedProduct", _descriptor5, this);
       _initializerDefineProperty(this, "thumbnailChangesVariant", _descriptor6, this);
       _initializerDefineProperty(this, "hasThumbnails", _descriptor7, this);
       _initializerDefineProperty(this, "videoLoopEnabled", _descriptor8, this);
       _initializerDefineProperty(this, "sectionId", _descriptor9, this);
       _initializerDefineProperty(this, "cartMethod", _descriptor10, this);
       _initializerDefineProperty(this, "slidesPerView", _descriptor11, this);
       _initializerDefineProperty(this, "giftwrapProductVariantId", _descriptor12, this);
       _initializerDefineProperty(this, "locationsEnabled", _descriptor13, this);
       _initializerDefineProperty(this, "languageUrl", _descriptor14, this);
       this.option1 = '';
       this.option2 = null;
       this.option3 = null;
       this.addingToCart = void 0;
       this.afterAddToCart = void 0;
       this.mediaWrapperSpacing = void 0;
       this.activeMediaId = void 0;
       this.mediaWrapperById = void 0;
       this.showOutOfStockForm = void 0;
       this.isMobile = void 0;
       this.quantity = 1;
       this.hasErrors = void 0;
       this.giftwrapProduct = void 0;
       this.sendAsGift = void 0;
       this.mediaSlider = null;
       this.locationsModal = null;
       this.modalLink = null;
       this.Accessibility = void 0;
       this.hidePaymentButtons = () => {
         jquery_default()('.shopify-payment-button').hide();
       };
       this.showPaymentButtons = () => {
         jquery_default()('.shopify-payment-button').show();
       };
     }
     data() {
       const variant = this.product.variants.find(v => v.id === this.initialVariantId);
       let media;
       if (variant.featured_media) {
         media = variant.featured_media;
       } else if (this.product.media && this.product.media.length > 0) {
         media = this.product.media[0];
       }
       return {
         option1: variant.option1,
         option2: variant.option2,
         option3: variant.option3,
         addingToCart: false,
         afterAddToCart: false,
         mediaWrapperSpacing: '',
         activeMediaId: media ? media.id : undefined,
         mediaWrapperById: new Map(),
         showOutOfStockForm: false,
         isMobile: window.matchMedia(`only screen and (max-width: ${MOBILE_BREAKPOINT.max}px)`).matches,
         quantity: 1,
         hasErrors: '',
         giftwrapProduct: false,
         sendAsGift: false,
         hasLocalPickup: '',
         locationsModal: null,
         modalLink: null,
         Accessibility: null
       };
     }
   
     /** @returns {Variant | null} */
     get variant() {
       return this.product.variants.find(v => v.option1 === this.option1 && v.option2 == this.option2 && v.option3 === this.option3);
     }
   
     /** @returns {boolean} */
     get isSale() {
       return this.variant && this.variant.compare_at_price && this.variant.compare_at_price > this.variant.price;
     }
   
     /** @return {State[keyof State]} */
     get state() {
       if (this.addingToCart) {
         return State.adding;
       }
       if (this.afterAddToCart) {
         return State.added;
       }
       if (this.variant) {
         if (this.variant.available) {
           return State.ready;
         } else {
           return State.soldOut;
         }
       } else {
         return State.unavailable;
       }
     }
   
     /** @returns {boolean} */
     get addToCartDisabled() {
       return !this.variant || !this.variant.available;
     }
   
     /** @returns {Media | undefined} */
     get activeMedia() {
       return (this.product.media || []).find(m => m.id === this.activeMediaId);
     }
   
     /** @returns {Media | undefined} */
     get firstOrActiveModel() {
       if (this.activeMedia && this.activeMedia.media_type === 'model') {
         return this.activeMedia;
       }
       return (this.product.media || []).find(m => m.media_type === 'model');
     }
     increaseQuantity() {
       this.quantity = +this.quantity + 1;
     }
     decreaseQuantity() {
       this.quantity = Math.max(1, +this.quantity - 1);
     }
   
     /** @param {number} mediaId */
     getMedia(mediaId) {
       let media = this.mediaWrapperById.get(mediaId);
       if (!media) {
         const m = (this.product.media || []).find(m => m.id === mediaId);
         const target = this.$refs.mediaTargets[m.position - 1];
         media = new MediaWrapper(this.theme, this.sectionId, m, target);
         target.addEventListener('media-play', this.onMediaPlay.bind(this));
         target.addEventListener('media-pause', this.onMediaPause.bind(this));
         target.addEventListener('media-load', this.onMediaLoaded.bind(this));
         this.mediaWrapperById.set(mediaId, media);
       }
       return media;
     }
     async updateStoreAvailabilityContent(variantId, productTitle) {
       if (!this.locationsEnabled) return;
       const initialContent = this.$el.querySelector('#initialPickupInfo');
       const variantSectionUrl = '/variants/' + variantId + '/?section_id=store-availability';
       const response = await window.fetch(variantSectionUrl);
       const responseText = await response.text();
       let tempDomNode = document.createElement('div');
       tempDomNode.innerHTML = responseText;
       const hasPickupContent = tempDomNode.querySelector('.store-availability-information');
       const pickupHTML = tempDomNode.firstElementChild.innerHTML;
       if (hasPickupContent && initialContent.innerHTML != pickupHTML) {
         // @ts-ignore
         initialContent.style.display = 'none';
         this.hasLocalPickup = pickupHTML;
       } else if (!hasPickupContent) {
         this.hasLocalPickup = '';
       }
       this.$nextTick(() => {
         // Write product full title.
         let productTitleElem = this.$el.querySelector('.store-availabilities-modal__product-title');
         if (!productTitleElem) return;
         productTitleElem.textContent = productTitle;
   
         // Modal.
         this.locationsModal = this.$el.querySelector('.store-availabilities-modal');
         if (!this.locationsModal) return;
   
         // Event listeners.
         this.modalLink = this.$el.querySelector('.store-availability-information__link');
         if (this.modalLink) this.modalLink.addEventListener('click', this.openLocationsModal);
         this.modalClose = this.$el.querySelector('.store-availabilities-modal__close');
         if (this.modalClose) this.modalClose.addEventListener('click', this.closeLocationsModal);
   
         // Move modal html out of product info as that can be sticky, causing z-index problems.
         var parentNode = document.querySelector('#PageContainer');
         parentNode.insertBefore(this.locationsModal, parentNode.firstChild);
       });
     }
     handleLocationsClickOutside(e) {
       if (!e.target.classList.contains('store-availability-information__link') && !this.locationsModal.contains(e.target)) {
         e.preventDefault();
         this.closeLocationsModal();
       }
     }
     openLocationsModal() {
       document.body.classList.add('js-drawer-location-modal-open');
       this.locationsModal.classList.add('locations-modal--is-active');
       disableBodyScroll(this.locationsModal);
       document.addEventListener('click', this.handleLocationsClickOutside);
       this.Accessibility.trapFocus({
         container: this.locationsModal,
         elementToFocus: this.$el.querySelector('.store-availability-information__link')
       });
     }
     closeLocationsModal() {
       document.body.classList.remove('js-drawer-location-modal-open');
       this.locationsModal.classList.remove('locations-modal--is-active');
       enableBodyScroll(this.locationsModal);
       document.removeEventListener('click', this.handleLocationsClickOutside);
       this.Accessibility.removeTrapFocus({
         container: this.locationsModal,
         elementToFocus: this.$el.querySelector('.store-availability-information__link')
       });
     }
     loadSlider() {
       this.mediaSlider = new swiper_esm_bundle(this.$el.querySelector('.swiper-container'), {
         direction: 'horizontal',
         slidesPerView: this.slidesPerView,
         centeredSlides: this.slidesPerView > 1,
         updateOnImagesReady: true,
         spaceBetween: 20,
         threshold: 10,
         autoHeight: true,
         pagination: {
           el: '.swiper-pagination',
           clickable: true
         }
       });
       this.mediaSlider.on('slideChange', () => {
         if (this.thumbnailChangesVariant) {
           const media = this.product.media[this.mediaSlider.activeIndex];
           this.changeDropdownsToMedia(media);
         }
         this.mediaWrapperById.forEach(m => m.pause());
       });
       this.mediaSlider.allowTouchMove = this.isFeaturedProduct || this.isMobile;
       if (this.variant.featured_media) {
         this.slideTo(this.getMedia(this.variant.featured_media.id), true);
       }
     }
     unloadSlider() {
       this.mediaSlider.destroy();
       this.mediaSlider = undefined;
     }
     loadPhotoSwipe() {
       const leftArrowSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn"><path d="M13 5L8 10L13 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
       const zoomInSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn" id="pswp__icn--zoom-in"><path d="M6.66667 9.16667H9.16667M9.16667 9.16667H11.6667M9.16667 9.16667V6.66667M9.16667 9.16667V11.6667M14.1667 14.1667L17.5 17.5M2.5 9.16667C2.5 10.9348 3.20238 12.6305 4.45262 13.8807C5.70286 15.131 7.39856 15.8333 9.16667 15.8333C10.9348 15.8333 12.6305 15.131 13.8807 13.8807C15.131 12.6305 15.8333 10.9348 15.8333 9.16667C15.8333 7.39856 15.131 5.70286 13.8807 4.45262C12.6305 3.20238 10.9348 2.5 9.16667 2.5C7.39856 2.5 5.70286 3.20238 4.45262 4.45262C3.20238 5.70286 2.5 7.39856 2.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
       const zoomOutSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn" id="pswp__icn--zoom-out"><path d="M14.1667 14.1667L17.5 17.5M6.66667 9.16667H11.6667M2.5 9.16667C2.5 10.9348 3.20238 12.6305 4.45262 13.8807C5.70286 15.131 7.39856 15.8333 9.16667 15.8333C10.9348 15.8333 12.6305 15.131 13.8807 13.8807C15.131 12.6305 15.8333 10.9348 15.8333 9.16667C15.8333 7.39856 15.131 5.70286 13.8807 4.45262C12.6305 3.20238 10.9348 2.5 9.16667 2.5C7.39856 2.5 5.70286 3.20238 4.45262 4.45262C3.20238 5.70286 2.5 7.39856 2.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
       const zoomSVGs = zoomInSVG + zoomOutSVG;
       const closeSVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="pswp__icn"><path d="M5.63086 14.3692L10 10L14.3692 14.3692M14.3692 5.63086L9.99919 10L5.63086 5.63086" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
       const lightbox = new PhotoSwipeLightbox({
         mainClass: 'pswp--custom-colors',
         gallery: '.product-images-container .swiper-container',
         children: 'a',
         bgOpacity: 1,
         howAnimationDuration: 200,
         hideAnimationDuration: 200,
         arrowPrevSVG: leftArrowSVG,
         arrowNextSVG: leftArrowSVG,
         // right arrow is a flipped left arrow
         zoomSVG: zoomSVGs,
         // the switch between zoom-in and zoom-out icon happens with .pswp--zoomed-in class
         closeSVG: closeSVG,
         pswpModule: PhotoSwipe
       });
       lightbox.on('uiRegister', function () {
         lightbox.pswp.ui.registerElement({
           name: 'bulletsIndicator',
           className: 'pswp__bullets-indicator',
           appendTo: 'wrapper',
           onInit: (el, pswp) => {
             const bullets = [];
             let bullet;
             let prevIndex = -1;
             for (let i = 0; i < pswp.getNumItems(); i++) {
               bullet = document.createElement('div');
               bullet.className = 'pswp__bullet';
               bullet.onclick = e => {
                 pswp.goTo(bullets.indexOf(e.target));
               };
               el.appendChild(bullet);
               bullets.push(bullet);
             }
             pswp.on('change', a => {
               if (prevIndex >= 0) {
                 bullets[prevIndex].classList.remove('pswp__bullet--active');
               }
               bullets[pswp.currIndex].classList.add('pswp__bullet--active');
               prevIndex = pswp.currIndex;
             });
           }
         });
       });
   
       // forcing slidechange with animation
       lightbox.on('beforeChange', function () {
         // Add the class 'pswp--animated' to enable the animation
         lightbox.template.classList.add('pswp--animated');
       });
       lightbox.on('change', () => {
         if (!this.mediaSlider) return;
         const {
           pswp
         } = lightbox;
         this.mediaSlider.slideTo(pswp.currIndex, 0);
       });
       lightbox.init();
     }
     get hasSlider() {
       return this.isFeaturedProduct || this.isMobile;
     }
     get showThumbails() {
       return !this.isFeaturedProduct && this.hasThumbnails && !this.isMobile;
     }
     initApps() {
       let appBlocks = document.querySelectorAll('.shopify-app-block');
       if (appBlocks.length > 0) {
         appBlocks.forEach((element, index) => {
           let blockId = document.querySelector(`form #${element.id}`);
           if (blockId) {
             let appContent = document.querySelector(`.shopify-app-block#${blockId.id}`);
             let getContent = appContent.parentElement.removeChild(appContent);
             blockId.append(getContent);
           }
         });
       }
     }
     initSizeGuide() {
       const handleSizeGuideClick = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('page', true, {
           url: e.currentTarget.href
         });
       };
       let sizeGuideEl = document.querySelector('#size-guide-link');
       sizeGuideEl?.addEventListener('click', handleSizeGuideClick);
     }
     initReviewsRatingLink() {
       const ratingLink = /** @type {HTMLElement} */this.$el.querySelector('[data-reviews-link]');
       const reviewsSection = document.querySelector('#shopify-product-reviews');
       if (!ratingLink || !reviewsSection) return;
       ratingLink.setAttribute('role', 'link');
       ratingLink.setAttribute('tabindex', '0');
       ratingLink.style.cursor = 'pointer';
       ratingLink.addEventListener('click', () => {
         reviewsSection.scrollIntoView({
           behavior: 'smooth'
         });
       });
       ratingLink.addEventListener('keydown', e => {
         if (e.key === 'Enter') {
           reviewsSection.scrollIntoView({
             behavior: 'smooth'
           });
         }
       });
     }
     mounted() {
       this.initApps();
       this.initSizeGuide();
       this.initReviewsRatingLink();
       let qtyNoscript = this.$el.querySelector('.quantity-noscript');
       let jsQtyNum = this.$el.querySelector('.js-qty__num');
       if (qtyNoscript) {
         qtyNoscript.setAttribute('name', 'no-js-quantity');
       }
       if (jsQtyNum) {
         jsQtyNum.setAttribute('name', 'quantity');
       }
       this.$el.querySelector('#AddToCartForm').addEventListener('submit', this.onAddToCart);
       this.mediaWrapperById = new Map();
       this.Accessibility = new Accessibility();
       if (this.showThumbails || this.hasSlider) {
         this.loadSlider();
       }
       this.loadPhotoSwipe();
       this.updateStoreAvailabilityContent(this.variant.id, this.product.title);
       this.$el.addEventListener('product-media-select', this.onMediaSelect.bind(this));
       if (this.firstOrActiveModel) {
         // We have at least one model => load XR library so
         // it can show/hide the button based on browser/device support
         window.Shopify.loadFeatures([{
           name: 'shopify-xr',
           version: '1.0'
         }]);
         document.addEventListener('shopify_xr_launch', () => {
           // The launch of XR viewer triggers beforeload event, we need to reappear page content
           setTimeout(() => {
             document.body.classList.remove('unloading');
           }, 100);
         });
       }
       window.ShopifyXR = window.ShopifyXR || function () {
         (window.ShopifyXR.q = window.ShopifyXR.q || []).push(arguments);
       };
       const models = (this.product.media || []).filter(m => m.media_type === 'model');
       if (window.ShopifyXR.addModels) {
         window.ShopifyXR.addModels(models);
       } else {
         window.ShopifyXR('addModels', models);
       }
       this.giftCardRecipientsFieldsForm = /** @type {HTMLElement} */this.$el.querySelector('.gift-card--recipient-form-wrapper');
       this.giftCardRecipientsFields = /** @type {NodeListOf<HTMLInputElement>} */this.giftCardRecipientsFieldsForm ? this.giftCardRecipientsFieldsForm.querySelectorAll('[name*="properties"]') : [];
     }
     onVariantChange() {
       if (this.variant) {
         if (!this.variant.available) {
           this.showOutOfStockForm = false;
           this.hidePaymentButtons();
         } else {
           this.showPaymentButtons();
         }
         this.setVariantUrl(this.variant);
         this.updateStoreAvailabilityContent(this.variant.id, this.product.title);
         const stockLevelIndicatorEl = this.$el.querySelector('stock-level-indicator');
         if (stockLevelIndicatorEl) this.updateStockLevelIndicator(stockLevelIndicatorEl, this.variant.id);
         if (this.variant.featured_media) {
           const mediaElement = this.$el.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);
           this.onMediaElementSelect(mediaElement, {
             load: true
           });
         }
   
         // Ensure the change event is fired on the form when variants changed (for Shop Pay Installments)
         const self = this;
         this.addToCartForm = this.$el.querySelector('#AddToCartForm');
         this.$nextTick(() => {
           const event = new Event('change');
           self.addToCartForm.dispatchEvent(event);
         });
       } else {
         this.hidePaymentButtons();
       }
   
       // Dispatch variant:changed event for other components to listen to
       const variantChangedEvent = new CustomEvent('variant:changed', {
         detail: {
           variant: this.variant,
           product: this.product
         }
       });
       this.$el.dispatchEvent(variantChangedEvent);
     }
     onShowOutOfStockForm(e) {
       e.preventDefault();
       // When the HERE button is clicked, the target is whole text
       if (e.currentTarget.contains(e.target.closest('a'))) {
         this.showOutOfStockForm = true;
       }
     }
     onMediaPlay(e) {
       if (this.mediaSlider) {
         // Stop swiper swipe gestures, video is playing.
         this.mediaSlider.allowTouchMove = false;
   
         // There may be a difference between the poster image
         // and the video aspect ratio. Update height.
         this.mediaSlider.updateAutoHeight();
       }
     }
     onMediaPause(e) {
       if (this.mediaSlider) {
         // Restarts swiper swipe gestures, video isn't playing.
         this.mediaSlider.allowTouchMove = true;
       }
     }
     onMediaLoaded(e) {
       e.detail.parent.querySelector('.product-medias__media').addEventListener('click', this.onMediaActivate.bind(this));
     }
     onMediaSelect(e) {
       const element = /** @type {HTMLElement} */jquery_default()(this.$el).find('.product-single__media')[e.detail.index];
       const mediaWrapper = this.mediaWrapperById.get(parseInt(element.dataset.mediaId, 10));
       const isVideo = mediaWrapper.media.media_type === 'video' || mediaWrapper.media.media_type === 'external_video';
       const isQuickShop = this.$el.closest('#ShopNowContainer');
       this.onMediaElementSelect(element, {
         load: e.detail.forceLoad,
         forcePlay: e.detail.forcePlay || !this.isMobile && !isQuickShop && isVideo,
         // Autoplay video on non-mobile and not in quick shop
         focus: e.detail.focus
       });
     }
   
     /** @param {KeyboardEvent} e */
     onMediaActivate(e) {
       const target = /** @type {HTMLElement} */e.target;
       const currentTarget = /** @type {HTMLElement} */e.currentTarget;
       if (e.type === 'keydown') {
         if (e.keyCode !== 13 && e.keyCode !== 27) {
           return;
         }
         if (target.classList.contains('shopify-model-viewer-ui__button') || target.classList.contains('plyr__controls__item')) {
           return;
         }
       }
       e.preventDefault();
       if (target.classList.contains('product-medias__view-in-space')) {
         // Don't do anything on "view in your space" click, it's handled by Shopify XR library.
         return;
       }
       if (target.tagName === 'MODEL-VIEWER' || target.classList.contains('shopify-model-viewer-ui__controls-overlay')) {
         // Don't do anything on 3d model overlay click, it will trigger an event itself.
         return;
       }
       const isLoaded = currentTarget.classList.contains('product-single__media--loaded');
       const isActive = currentTarget.classList.contains('product-single__media--active');
       if (this.hasThumbnails) {
         this.onThumbnailClick(currentTarget);
       }
       if (isLoaded && isActive) {
         // Loaded and active media will handle click internally in the component itself.
         return;
       }
       this.onMediaElementSelect(currentTarget, {
         load: true,
         togglePlay: true
       });
     }
     onMediaElementSelect(element, options) {
       if (!element) {
         return;
       }
       const mediaWrapper = this.getMedia(parseInt(element.dataset.mediaId, 10));
       this.activeMediaId = mediaWrapper.media.id;
       this.slideTo(mediaWrapper);
   
       // Pause all others
       this.mediaWrapperById.forEach(otherMediaWrapper => {
         if (otherMediaWrapper.mediaId !== mediaWrapper.mediaId) {
           otherMediaWrapper.pause();
         }
       });
       jquery_default()(this.$el).find('.product-single__media--selected').not(element).removeClass('product-single__media--selected');
       element.classList.add('product-single__media--selected');
       if (options.togglePlay) {
         mediaWrapper.togglePlay();
       } else if (options.forcePlay) {
         mediaWrapper.play();
       } else if (options.load) {
         mediaWrapper.load();
       }
       if (options.focus) {
         mediaWrapper.focus();
       }
     }
     async onAddToCart(e) {
       e.preventDefault();
       this.addingToCart = true;
       this.hasErrors = '';
       try {
         const data = jquery_default()(this.$el.querySelector('#AddToCartForm')).serialize();
         const $formContainer = jquery_default()(this.$el.querySelector('#AddToCartForm'));
         let giftwrapProperty = '';
         if (this.giftwrapProduct && this.giftwrapProductVariantId) {
           giftwrapProperty = '&properties[' + this.theme.translations.giftwrap_label + ']=' + this.theme.translations.yes;
         }
   
         // Gift wrap add to cart.
         if (this.giftwrapProduct && this.giftwrapProductVariantId) {
           const giftData = {
             items: [{
               id: this.giftwrapProductVariantId,
               quantity: this.quantity
             }]
           };
           const giftResponse = await window.fetch('/cart/add.js', {
             method: 'POST',
             credentials: 'same-origin',
             headers: {
               'Content-Type': 'application/json',
               'X-Requested-With': 'XMLHttpRequest'
             },
             body: JSON.stringify(giftData)
           });
           const giftResponse1 = await giftResponse.json();
           if (!giftResponse.ok) {
             if (giftResponse1.status == 422) {
               this.hasErrors = giftResponse1.description;
             }
             this.addingToCart = false;
             return;
           }
         }
   
         // 'Actual' product add to cart.
         const response = await window.fetch('/cart/add.js', {
           method: 'POST',
           credentials: 'same-origin',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded',
             'X-Requested-With': 'XMLHttpRequest'
           },
           body: data + giftwrapProperty
         });
         const response1 = await response.json();
         if (!response.ok) {
           // Handle various errors, quantity etc.
           // See: https://shopify.dev/docs/themes/ajax-api/reference/cart
           if (response1.status == 422) {
             this.hasErrors = response1.description;
           }
           this.addingToCart = false;
           return;
         }
         const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
         const response2 = await window.fetch(`${languageParam}/cart?view=compare`);
         if (!response2.ok) {
           // FIXME: error handling
           this.addingToCart = false;
           return;
         }
         const cart = await response2.json();
         const featuredProductSubmit = this.$el.querySelector('[data-submit-type]');
         this.addingToCart = false;
         var cartBtn = /** @type {HTMLElement} */document.querySelector('#AddToCart');
         var cartURL = cartBtn.dataset.cartUrl;
         if (this.cartMethod === 'drawer' && !featuredProductSubmit) {
           this.theme.toggleRightDrawer('cart', true, {
             cart: cart
           });
           if (this.giftCardRecipientsFieldsForm) this.giftProductFormOnAddToCart();
         } else if (this.cartMethod === 'added' && !featuredProductSubmit) {
           this.afterAddToCart = true;
           setTimeout(() => {
             this.afterAddToCart = false;
           }, 2000);
           this.theme.updateCartDrawer(cart);
           if (this.giftCardRecipientsFieldsForm) this.giftProductFormOnAddToCart();
         } else if (this.cartMethod === 'page' || featuredProductSubmit) {
           window.location.href = cartURL;
         }
       } catch (e) {
         console.error('Unable to add to cart: ', e);
         // FIXME error handling
       }
     }
   
     giftProductFormOnAddToCart() {
       if (!this.sendAsGift) return;
       if (!this.giftCardRecipientsFieldsForm) return;
       this.emptyGiftPropductFormFields();
       this.toggleGiftCardRecipientFormVisibility(true);
       this.sendAsGift = false;
     }
     emptyGiftPropductFormFields() {
       this.giftCardRecipientsFields.forEach(input => input.value = '');
     }
     toggleGiftCardRecipientFormVisibility(visible) {
       this.giftCardRecipientsFields.forEach(input => visible ? input.disabled = true : input.disabled = false);
       this.giftCardRecipientsFieldsForm.style.display = visible ? 'none' : 'flex';
     }
     onSendAsGiftChange(newVal, oldVal) {
       if (!this.giftCardRecipientsFieldsForm) return;
       this.toggleGiftCardRecipientFormVisibility(oldVal);
       this.sendAsGift = newVal;
     }
     onThumbnailClick(target) {
       const mediaWrapper = this.getMedia(parseInt(target.dataset.mediaId, 10));
       this.slideTo(mediaWrapper);
       this.changeDropdownsToMedia(mediaWrapper.media);
     }
     slideTo(mediaWrapper, skipAnimation = false) {
       if (this.mediaSlider) {
         this.mediaSlider.slideTo(mediaWrapper.media.position - 1, this.hasSlider && !skipAnimation ? 200 : 0);
       }
     }
     changeDropdownsToMedia(media) {
       // select variant
       if (this.thumbnailChangesVariant) {
         const variant = this.product.variants.find(v => v.featured_media && v.featured_media.id === media.id);
         if (variant) {
           this.option1 = variant.option1;
           this.option2 = variant.option2;
           this.option3 = variant.option3;
           const variantChangedEvent = new CustomEvent('variant:changed', {
             detail: {
               variant: variant,
               product: this.product
             }
           });
           this.$el.dispatchEvent(variantChangedEvent);
         }
       }
     }
     setVariantOption(value, name) {
       this[`option${name}`] = value;
     }
   
     /** @param {Variant} variant */
     setVariantUrl(variant) {
       const hasMoreVariants = this.product.variants.length > 1;
       if (history.replaceState && !this.isFeaturedProduct && hasMoreVariants) {
         // Change url to include variant if we're not on homepage
         let search = [];
         if (window.location.search.length > 1) {
           // select non-variant query params
           search = window.location.search.slice(1).split('&').filter(q => {
             return q.indexOf('variant=') !== 0;
           });
         }
         // add current variant
         search.push('variant=' + variant.id);
   
         // set the url to include the variant
         const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + search.join('&');
         window.history.replaceState({
           path: newurl
         }, '', newurl);
       }
     }
     updateStockLevelIndicator(stockLevelIndicator, variantId) {
       stockLevelIndicator.setAttribute('data-flow-variant-id', variantId);
     }
     /** @returns {string} */
     money(price) {
       return this.theme.formatMoney(price);
     }
     onWindowResizeBreakpoint({
       breakpoint,
       oldBreakpoint
     }) {
       const newIsMobile = breakpoint.order <= MOBILE_BREAKPOINT.order;
       const oldWasMobile = oldBreakpoint.order <= MOBILE_BREAKPOINT.order;
       if (newIsMobile !== oldWasMobile) {
         this.isMobile = newIsMobile;
         if (this.mediaSlider) {
           this.mediaSlider.allowTouchMove = this.hasSlider;
         }
         if (!this.hasThumbnails) {
           if (this.hasSlider && !this.mediaSlider) {
             this.loadSlider();
           } else if (!this.hasSlider && this.mediaSlider) {
             this.unloadSlider();
           }
         }
       }
     }
   }, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "initialVariantId", [_dec2], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "product", [_dec3], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "theme", [_dec4], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "productSection", [_dec5], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isFeaturedProduct", [_dec6], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "thumbnailChangesVariant", [_dec7], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "hasThumbnails", [_dec8], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "videoLoopEnabled", [_dec9], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "sectionId", [_dec10], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "cartMethod", [_dec11], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "slidesPerView", [_dec12], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "giftwrapProductVariantId", [_dec13], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "locationsEnabled", [_dec14], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "languageUrl", [_dec15], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), _applyDecoratedDescriptor(_class2.prototype, "onVariantChange", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "onVariantChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSendAsGiftChange", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "onSendAsGiftChange"), _class2.prototype)), _class2)) || _class);
   class ProductSection extends Section {
     constructor(theme, _element, pageLoad, options = {}) {
       super(theme, _element, pageLoad);
       this.fixSticky = () => {
         const productStickyElements = /** @type {NodeListOf<HTMLElement>} */this.element.querySelectorAll('.product-sticky');
         const headerSticky = document.querySelector('.sticky-header');
         if (productStickyElements && headerSticky) {
           productStickyElements.forEach(element => {
             element.style.top = `${headerSticky.clientHeight}px`;
           });
         }
       };
       this.onWindowResize = () => {
         this.fixSticky();
         this.loadReadmore();
       };
       this.onWindowResizeBreakpoint = ({
         breakpoint,
         oldBreakpoint
       }) => {
         if (!this.vue) {
           // Product was not selected => no vue
           return;
         }
         /** @type {ProductForm} */this.vue.$children[0].onWindowResizeBreakpoint({
           breakpoint,
           oldBreakpoint
         });
       };
       this.loadReadmore = () => {
         const readMoreEls = document.querySelectorAll('.product-description.readmore');
         if (!readMoreEls) return;
         let thisHeight = 100;
         if (this.element.querySelector('.product-description_full-width')) {
           thisHeight = 150;
           if (this.theme.getWindowWidth() <= 768) {
             thisHeight = 100;
           }
         }
         readMoreEls.forEach(readMoreEl => {
           if (!readMoreEl.classList.contains('rmjs-1')) {
             this.readMore = new readmore_es6(readMoreEl, {
               speed: 100,
               collapsedHeight: thisHeight,
               moreLink: `<div class="read-more-link">
                         <div class="read-more-less--content nav-link-animated--custom">
                           <a href="#" class="animated-link--item">${this.theme.translations.read_more_html}</a>
                           <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                         </div>
                       </div>`,
               lessLink: `<div class="read-less-link nav-link-animated--custom">
                         <div class="read-more-less--content nav-link-animated--custom">
                           <a href="#" class="animated-link--item">${this.theme.translations.read_less_html}</a>
                           <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M5.5 12.5L10.5 7.5L15.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                         </div>
                       </div>`,
               beforeToggle: function (trigger, element, expanded) {
                 if (expanded) {
                   const headerEl = document.querySelector('.sticky-header');
                   const stickyHeaderHeight = headerEl ? headerEl.clientHeight : 0;
                   jquery_default()('html, body').animate({
                     scrollTop: jquery_default()(element).offset().top - stickyHeaderHeight
                   }, 100);
                 }
                 jquery_default()(element).toggleClass('closed');
               }
             });
           }
         });
       };
       this.loadTabs = () => {
         jquery_default()(this.element).find('ul.tabs').each(function () {
           var active,
             content,
             links = jquery_default()(this).find('a');
           active = links.first().addClass('active');
           content = jquery_default()(active.attr('href'));
           links.not(':first').each(function () {
             jquery_default()(jquery_default()(this).attr('href')).hide();
           });
           jquery_default()(this).find('a').click(function (e) {
             active.removeClass('active');
             content.hide();
             active = jquery_default()(this);
             content = jquery_default()(jquery_default()(this).attr('href'));
             active.addClass('active');
             content.fadeIn();
             return false;
           });
         });
       };
       this.scrollToPostedForm = () => {
         if (jquery_default()('.out-of-stock-form .posted-successfully').length) {
           jquery_default()('html, body').animate({
             scrollTop: jquery_default()('.form-vertical').offset().top
           }, 100);
         }
       };
       var product_json_el = this.element.querySelector('.product-json');
       if (!product_json_el) {
         // No product on the page - maybe just product placeholder
         return;
       }
       this.product = JSON.parse(product_json_el.textContent);
       this.vue = new vue_esm({
         el: this.element.querySelector('.product-form-vue'),
         components: {
           'wetheme-product-form': ProductForm
         },
         data: () => ({
           productSection: this,
           product: this.product,
           theme: this.theme,
           isFeaturedProduct: this.isFeaturedProduct,
           slidesPerView: options ? options.slidesPerView || 1 : 1
         })
       });
       this.fixSticky();
       this.loadReadmore();
       this.loadTabs();
       this.scrollToPostedForm();
       document.addEventListener('shopify:block:select', this.loadReadmore);
       document.addEventListener('shopify:section:select', this.loadReadmore);
     }
     get isFeaturedProduct() {
       return false;
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/FeaturedProduct.js
   
   class FeaturedProduct extends ProductSection {
     get isFeaturedProduct() {
       return true;
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/MapSection.js
   
   
   
   
   class MapSection extends Section {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      * @param {boolean} pageLoad
      */
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.onAuthError = e => {
         this.showError(e.detail.reason);
       };
       this.showError = message => {
         const container = this.element.querySelector('.map-section__container');
         container.classList.add('hide');
         if (window.Shopify.designMode) {
           jquery_default()('<div class="map-container-error"></div>').text(message).appendTo(container.parentElement.querySelector('.map-section__overlay'));
         }
         container.parentElement.querySelector('.homepage-map--fallback').classList.remove('hide');
       };
       this.onLoad = maps => {
         this.mapsApi = maps;
         const config = {
           zoom: 14
         };
         let style = [];
         try {
           const mapThemeElem = this.element.querySelector('.map-theme');
           if (mapThemeElem) {
             style = JSON.parse(mapThemeElem.textContent);
           }
         } catch (e) {
           console.error('Unable to parse theme style:', e);
         }
         const container = /** @type {HTMLElement} */this.element.querySelector('.map-section__container');
         if (!container) {
           return;
         }
         this.geocoder = new maps.Geocoder();
         this.geocoder.geocode({
           'address': this.address
         }, (results, status) => {
           if (status === 'OK') {
             /**
              * @typedef {import('../window').GoogleMap} GoogleMap
              *
              */
             this.map = /** @type {GoogleMap} */new maps.Map(container, {
               zoom: config.zoom,
               styles: style,
               disableDefaultUI: true,
               draggable: false,
               clickableIcons: false,
               scrollwheel: false,
               disableDoubleClickZoom: true,
               draggableCursor: 'default'
             });
             this.mapsApi.event.addListener(this.map, "projection_changed", () => {
               this.centerMap();
               if (this.contentBox) {
                 // Center map when content box is resized
                 // works as windiw resize observer as well since the content box has relative width
   
                 // @ts-ignore
                 new ResizeObserver(this.centerMap).observe(this.contentBox);
               } else {
                 // Center map when screensize is changed
                 // redundant if content box resize observer is active
                 window.addEventListener('resize', this.centerMap);
               }
             });
   
             /**
              *
              * @typedef {import('../window').GoogleMapsMarker} GoogleMapsMarkerType
              */
             this.marker = /** @type {GoogleMapsMarkerType} */new maps.Marker({
               map: this.map,
               position: results[0].geometry.location
             });
           } else {
             this.showError('Error looking up that address');
           }
         });
       };
       this.offsetCenter = (offsetX, offsetY) => {
         // offsetX is the distance you want that point to move to the right, in pixels
         // offsetY is the distance you want that point to move upwards, in pixels
         // offset values can be negative
   
         const markerPosition = this.marker.getPosition();
         const scale = Math.pow(2, this.map.getZoom());
         const mapProjection = this.map.getProjection();
         const worldCoordinateCenter = mapProjection.fromLatLngToPoint(markerPosition);
         const pixelOffset = new this.mapsApi.Point(offsetX / scale || 0, offsetY / scale || 0);
         const worldCoordinateNewCenter = new this.mapsApi.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
         const newCenter = mapProjection.fromPointToLatLng(worldCoordinateNewCenter);
         this.map.setCenter(newCenter);
       };
       this.centerMap = () => {
         if (!this.map) return;
         if (this.contentBox) {
           const totalContentBoxWidth = this.contentBox.offsetWidth + this.contentBoxMargin;
           const totalContentBoxHeight = this.contentBox.offsetHeight + this.contentBoxMargin;
           if (window.innerWidth > 767) {
             if (this.contentBoxAllignment === 'left') {
               this.offsetCenter(totalContentBoxWidth / 2, 0);
             } else {
               this.offsetCenter(-(totalContentBoxWidth / 2), 0);
             }
           } else {
             this.offsetCenter(0, -(totalContentBoxHeight / 2));
           }
         } else {
           this.map.setCenter(this.marker.getPosition());
         }
       };
       this.mapsApi = null;
       this.mapElement = /** @type {HTMLElement} */element.querySelector('.map-wrapper');
       this.contentBox = /** @type {HTMLElement} */element.querySelector('.homepage-map-content-box');
       if (this.contentBox) {
         this.contentBoxAllignment = this.element.dataset.mapsAlignment === 'right' ? 'left' : 'right';
         this.contentBoxMargin = parseInt(window.getComputedStyle(this.contentBox).getPropertyValue(`margin-${this.contentBoxAllignment}`));
       }
       this.apiKey = this.element.dataset.mapsApikey;
       this.address = this.element.dataset.mapsAddress;
       if (!this.apiKey || !this.address) return;
       theme.loadGoogleMapApi(this.apiKey).then(this.onLoad).catch(this.showError);
       document.body.addEventListener('google-maps-auth-failure', this.onAuthError);
       this.kenBurns = new KenBurns(theme, element);
       this.parallax = new Parallax_Parallax(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Pagination.js
   
   
   
   /** Pagination logic (Infinite scrolling and Load more button) */
   class Pagination_Pagination extends Component {
     // how many pixels from bottom should next page start loading
   
     // how often should the scroll position should be checked (in milliseconds)
   
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element, loadedCallback1, loadedCallback2) {
       super(theme, element);
       this.PAGINATION_LOAD_OFFSET = 1200;
       this.SCROLL_DELAY = 200;
       this.PAGINATION_SELECTOR = '.pagination';
       this.COLLECTION_WRAPPER_SELECTOR = '#CollectionProductGrid';
       this.COLLECTION_MAIN_SELECTOR = '.collection-main-body-inner';
       this.COLLECTION_HEADER_SELECTOR = '.collection-main-central-header';
       this.COLLECTION_ITEM_SELECTOR = '.grid__item';
       this.COLLECTION_ITEM_EXCLUDE_SELECTOR = '.collection-central-description-block';
       this.initialize = () => {
         if (jquery_default()('.pagination').hasClass('pagination-infinite')) {
           this.pagination_type = 'infinite-scroll';
         } else if (jquery_default()('.pagination').hasClass('pagination--load-more')) {
           this.pagination_type = 'load-more';
           this.load_more_button();
         }
         this.execCallbacks();
       };
       this.execCallbacks = () => {
         if (this.loadedCallback1) {
           this.loadedCallback1();
         }
         if (this.loadedCallback2) {
           this.loadedCallback2();
         }
       };
       this.onWindowScroll = () => {
         this.$wrapper = jquery_default()(this.COLLECTION_WRAPPER_SELECTOR);
         if (this.pagination_type !== 'infinite-scroll') {
           return;
         }
         var height = this.$wrapper.position().top + this.$wrapper.height();
         if (height - this.PAGINATION_LOAD_OFFSET < this.$doc.scrollTop() + this.$w.height()) {
           this.load_next_page();
         }
       };
       this.check_pagination_progress = () => {
         var next_url = jquery_default()(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
         this.fully_loaded = !next_url || next_url === '#';
       };
       this.build_load_more_html = function () {
         var totalItems = parseInt(jquery_default()('.pagination').attr('data-paginate-items'), 10);
         var currentOffset = parseInt(jquery_default()('.pagination').attr('data-paginate-offset'), 10);
         var pageSize = parseInt(jquery_default()('.pagination').attr('data-paginate-size'), 10);
         var totalViewed = currentOffset + pageSize;
         var progressPercentage = 100 * totalViewed / totalItems;
         if (this.theme.translations.youve_viewed !== undefined) {
           var youViewed = this.theme.translations.youve_viewed.replace('{{ x }}', totalViewed).replace('{{ y }}', totalItems);
         } else {
           youViewed = "";
         }
         var buttonHtml = '<div class="pagination__load-more">' + `<p class="pagination__progress-text">${youViewed}</p>` + '<div class="progress-bar"><div class="progress-bar__inner" style="width:' + progressPercentage + '%;"></div></div>' + `<button class="btn btn--large btn--load-more">${this.theme.translations.load_more}</button>` + '</div>';
         return buttonHtml;
       };
       this.load_more_button = function () {
         this.check_pagination_progress();
   
         // Check if Load More button already on page
         var buttonAppended = jquery_default()('.pagination .btn--load-more').length !== 0;
   
         // Build Button html
         var buttonHtml = this.build_load_more_html();
   
         // If button not on page and more results are available, display button
         if (!buttonAppended && !this.fully_loaded) {
           jquery_default()('.pagination').append(buttonHtml);
         }
   
         // If button clicked, load next page
         jquery_default()('.btn--load-more').off('click').on('click', this.load_next_page.bind(this.$self));
       };
       this.set_loading = loading => {
         if (loading) {
           this.loading = true;
           this.$loading_indicator.show();
           jquery_default()(this.PAGINATION_SELECTOR).hide();
         } else {
           this.loading = false;
           this.$loading_indicator.hide();
           jquery_default()(this.PAGINATION_SELECTOR).show();
         }
       };
       this.load_next_page = () => {
         if (this.loading) {
           return false;
         }
         var next_url = jquery_default()(this.PAGINATION_SELECTOR).find('.pagination-next a').attr('href');
         if (!next_url || next_url === '#') {
           return;
         }
         this.set_loading(true);
         jquery_default().ajax({
           type: 'GET',
           url: next_url,
           dataType: "html"
         }).then(this.page_loaded.bind(this)).always(this.set_loading.bind(this, false));
   
         // let newUrlIS =  window.location.origin + next_url;
         // history.pushState({}, null, newUrlIS);
       };
       this.scroll_position_history = () => {
         var pathName = document.location.pathname;
         window.onbeforeunload = function () {
           var htmlContent = document.querySelector('.collection-main-body-inner').innerHTML;
           var paginationContent = document.querySelector('.pagination').innerHTML;
           sessionStorage.setItem('pagePosition_' + pathName, htmlContent.toString());
           sessionStorage.setItem('pagePagination_' + pathName, paginationContent.toString());
         };
         if (performance.navigation.type == 2 && sessionStorage['pagePosition_' + pathName]) {
           var htmlContentContainer = document.querySelector('.collection-main-body-inner');
           htmlContentContainer.innerHTML = sessionStorage.getItem('pagePosition_' + pathName);
         }
         if (performance.navigation.type == 2 && sessionStorage['pagePagination_' + pathName]) {
           var paginationContainer = document.querySelector('.pagination');
           paginationContainer.innerHTML = sessionStorage.getItem('pagePagination_' + pathName);
         }
       };
       this.page_loaded = data => {
         var data_dom = jquery_default()(data);
         var classes = /** @type {string} */jquery_default()('#grid_item_width_classes').val();
         if (classes) {
           data_dom.find('.grid__item').removeClass('large--one-quarter medium--one-quarter small--one-whole large--one-half medium--one-half').addClass(classes);
         }
         this.$collection.append(data_dom.find(this.COLLECTION_HEADER_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR).not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR), data_dom.find(this.COLLECTION_MAIN_SELECTOR + ' > ' + this.COLLECTION_ITEM_SELECTOR));
         jquery_default()(this.PAGINATION_SELECTOR).replaceWith(data_dom.find(this.PAGINATION_SELECTOR));
   
         // If "load more" enabled, run function to conditionally render button on newly-loaded page
         if (this.pagination_type === 'load-more') {
           this.load_more_button();
         }
         this.execCallbacks();
       };
       this.loadedCallback1 = loadedCallback1;
       this.loadedCallback2 = loadedCallback2;
       this.$w = jquery_default()(window);
       this.$doc = jquery_default()(document);
       this.$self = this;
       this.$collection = jquery_default()(this.COLLECTION_MAIN_SELECTOR);
       this.$wrapper = jquery_default()(this.COLLECTION_WRAPPER_SELECTOR);
       this.$loading_indicator = jquery_default()('.pagination-loading');
       this.loading = false;
       this.fully_loaded = false;
       this.scroll_timeout = null;
       this.pagination_type = null;
   
       // If neither "infinite scrolling" nor "load more" are enabled, end function here
       const $pagination_infinite = jquery_default()('.pagination-infinite');
       const $pagination_load_more = jquery_default()('.pagination--load-more');
       this.initialize();
       if ($pagination_infinite.length > 0 || $pagination_load_more.length > 0) {
         this.scroll_position_history();
       }
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionSection.js
   
   
   
   
   
   class CollectionSection extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.initParallax = () => {
         // collection image is outside of main div, need to call it on parent
         this.parallax = new Parallax_Parallax(this.theme, this.element.parentNode);
       };
       this.initPagination = () => {
         this.pagination = new Pagination_Pagination(this.theme, this.element, this.loadShopNow, this.loadQuickAdd);
       };
       this.loadShopNow = () => {
         Array.prototype.forEach.call(this.element.querySelectorAll('.shop-now-button, .quick-add-button-variants'), el => {
           el.removeEventListener('click', this.handleShopNow);
           el.addEventListener('click', this.handleShopNow);
         });
         this.theme.addBadges(this.element, 1000);
       };
       this.loadQuickAdd = () => {
         this.quickAddButtons = new QuickAdd(this.theme, this.element);
       };
       this.loadTagFilter = () => {
         /* Product Tag Filters - Good for any number of filters on any type of collection pages */
         var collFilters = jquery_default()('.coll-filter');
         collFilters.on('change', function () {
           var newTags = [];
           var val = jquery_default()(this).val();
           if (val) {
             newTags.push(val);
           }
           if (newTags.length) {
             var query = newTags.join('+');
             var link = jquery_default()('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
             window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + query + '$2');
           } else {
             window.location.href = jquery_default()('#link-to-collection').val().toString();
           }
         });
         jquery_default()('.collection-filter-tag-checkbox').on('change', function () {
           var filter = Array.prototype.map.call(document.querySelectorAll('input.collection-filter-tag-checkbox:checked'), function (el) {
             return el.value;
           }).join('+');
           var link = jquery_default()('#link-to-tag-generic a').attr('href').replace(/\+/g, '%20');
           window.location.href = link.replace(/(\/|=)tag($|\?|&)/, '$1' + filter + '$2');
         });
       };
       this.loadSortBy = () => {
         const queryParams = {};
         if (location.search.length) {
           for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
             aKeyValue = aCouples[i].split('=');
             if (aKeyValue.length > 1) {
               queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
             }
           }
         }
         jquery_default()('.coll-sort-by').val('{{ collection.sort_by | default: collection.default_sort_by | escape }}');
         jquery_default()('.coll-sort-by,.collection-sort-by-radio').on('change', function () {
           queryParams.sort_by = jquery_default()(this).val();
           location.search = jquery_default().param(queryParams).replace(/\+/g, '%20');
         });
       };
       this.handleShopNow = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('shop-now', true, {
           url: e.currentTarget.href
         });
       };
       this.isMobile = () => {
         return window.matchMedia('(max-width: 1023px)').matches;
       };
       this.element = element;
       this.theme = theme;
       this.loadTagFilter();
       this.loadSortBy();
       this.initPagination();
       this.loadShopNow();
       this.loadQuickAdd();
       this.initParallax();
       this.theme.addBadges(this.element, 1000);
       document.addEventListener('shopify:section:load', () => {
         this.initParallax();
       });
       document.addEventListener('paginate', this.initPagination);
       document.addEventListener('shopify:section:select', this.initParallax);
       document.addEventListener('shopify:section:deselect', this.initParallax);
       document.addEventListener('shopify:section:reorder', this.initParallax);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/CollectionListSection.js
   
   
   
   class CollectionListSection extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.parallax = new Parallax_Parallax(theme, element.parentNode);
       this.quickAddButtons = new QuickAdd(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/RichText.js
   
   class RichText extends Section {}
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Testimonials.js
   
   class Testimonails extends Section {}
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Blog.js
   
   
   class Blog extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.kenBurns = new KenBurns(theme, element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/TextAdverts.js
   
   
   class TextAdverts extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       const swiperContainer = this.element.querySelector('.swiper-container');
       this.swiper = new swiper_esm_bundle(swiperContainer, {
         slidesPerView: 1,
         watchOverflow: true,
         autoHeight: true,
         loop: true,
         autoplay: {
           delay: 5000
         },
         speed: 1000
       });
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/VideoHero.js
   
   
   class VideoHero extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       createClickableSection(this.element);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/sections/Cart.js
   
   class Cart extends Section {
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.changeQuantity = e => {
         e.preventDefault();
         const input = e.currentTarget.closest('.js-qty').querySelector('input');
         if (e.currentTarget.classList.contains('js-qty__adjust--minus')) {
           input.value = Math.max(1, parseInt(input.value, 10) - 1);
         } else {
           input.value = parseInt(input.value, 10) + 1;
         }
       };
       Array.prototype.forEach.call(this.element.querySelectorAll('.js-qty__adjust'), el => el.addEventListener('click', this.changeQuantity));
     }
   }
   ;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=template&id=6f2f9e95&
   var Videovue_type_template_id_6f2f9e95_render = function () {
     var _vm = this
     var _h = _vm.$createElement
     var _c = _vm._self._c || _h
     return _c("div", [
       _c(
         "div",
         {
           class: _vm.overlay
             ? "homepage-hero-content-overlay-wrapper homepage-video-content-overlay-wrapper-" +
               _vm.sectionId +
               " " +
               (!_vm.showOverlay ? "overlay-hidden" : "")
             : "",
         },
         [
           _vm.showOverlay && !_vm.hero && !_vm.autoplay
             ? _c("div", { staticClass: "video--video__static-image" })
             : _vm._e(),
           _vm._v(" "),
           _vm.showOverlay && !_vm.hero && !_vm.autoplay
             ? _c(
                 "div",
                 {
                   staticClass: "video--video__text-block",
                   on: {
                     click: _vm.play,
                     keyup: function ($event) {
                       if (
                         !$event.type.indexOf("key") &&
                         _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                       ) {
                         return null
                       }
                       return _vm.play.apply(null, arguments)
                     },
                   },
                 },
                 [_vm._m(0)]
               )
             : _vm._e(),
           _vm._v(" "),
           _c(
             "div",
             {
               class: {
                 "embed-container": !_vm.hero,
                 "type-youtube": _vm.videoType === "youtube" && !_vm.hero,
               },
             },
             [
               _c("div", { ref: "video", staticClass: "video" }, [
                 _vm.videoType === "mp4"
                   ? _c(
                       "video",
                       {
                         ref: "videoMP4",
                         staticClass: "hero-video-mp4",
                         attrs: { playsinline: "", controls: "" },
                       },
                       [
                         _c("source", {
                           attrs: { src: _vm.url, type: "video/mp4" },
                         }),
                       ]
                     )
                   : _vm._e(),
               ]),
             ]
           ),
         ]
       ),
     ])
   }
   var Videovue_type_template_id_6f2f9e95_staticRenderFns = [
     function () {
       var _vm = this
       var _h = _vm.$createElement
       var _c = _vm._self._c || _h
       return _c(
         "div",
         { staticClass: "homepage-video-play-button", attrs: { tabindex: "0" } },
         [_c("div", { staticClass: "homepage-video-play-button-inner" })]
       )
     },
   ]
   Videovue_type_template_id_6f2f9e95_render._withStripped = true
   
   
   ;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue?vue&type=template&id=6f2f9e95&
   
   ;// CONCATENATED MODULE: ./src/javascripts/global/VideoBase.js
   /**
   * @typedef {Object} VideoParams
   * @param {boolean} autoplay
   * @param {boolean} mute
   * @param {boolean} loop
   * @param {boolean} hideControls
   * @param {string} url
   */
   
   class VideoBase {
     constructor(theme, element) {
       this.getAutoplay = autoplay => {
         // Autoplay if Save-Data is not set
         if ("connection" in navigator) {
           if (navigator.connection.saveData) {
             return false;
           }
         }
         // Autoplay if reduced motion is not set
         if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
           return false;
         }
         return autoplay;
       };
       this._load = async function () {};
       this.init = params => {};
       this.play = () => {};
       this.pause = () => {};
       this.theme = theme;
       this.element = element;
     }
   
     /**
     * Get autoplay with overrides
     *
     * @param {boolean} autoplay User autoplay preference
     * @return {boolean}
     */
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Youtube.js
   
   
   /** Get ID of a youtube video from URL
   * @param {string} url
   * @return {string} youtube video ID
   */
   const youtubeGetId = url => {
     const parts = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
     if (parts[2] !== undefined) {
       return parts[2].split(/[^0-9a-z_-]/i)[0];
     }
     return url;
   };
   class Youtube extends VideoBase {
     constructor(...args) {
       super(...args);
       this._load = () => {
         return this.theme.loadYoutubeApi();
       };
       this.init = ({
         autoplay,
         hideControls,
         url,
         mute,
         loop,
         onPlay,
         onEnd
       }) => {
         autoplay = this.getAutoplay(autoplay);
         const videoId = youtubeGetId(url);
         return new Promise(resolve => {
           this._load().then(YT => {
             this.player = new YT.Player(this.element, {
               videoId: videoId,
               playerVars: {
                 showinfo: 0,
                 modestbranding: 1,
                 rel: 0,
                 autoplay: autoplay ? 1 : 0,
                 controls: hideControls ? 0 : 1,
                 mute: mute || autoplay ? 1 : 0,
                 videoId: videoId,
                 cc_load_policy: 0,
                 fs: 0,
                 iv_load_policy: 3,
                 playsinline: 1,
                 branding: 0,
                 origin: window.location.origin
               },
               events: {
                 onReady: event => {
                   this.player = event.target;
                   if (mute || autoplay) {
                     this.player.mute();
                   }
                   if (autoplay) {
                     // Force play just in case that the option didn't work
                     this.player.playVideo();
                   }
                   resolve(this.player);
                 },
                 onStateChange: event => {
                   if (event.data === YT.PlayerState.PLAYING) {
                     onPlay();
                   }
                   if (event.data === YT.PlayerState.ENDED && loop) {
                     this.player.playVideo();
                     onEnd();
                   }
                 }
               }
             });
           });
         });
       };
       this.play = () => {
         this.player.playVideo();
       };
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Vimeo.js
   
   
   /** Get ID of a vimeo video from URL
   * @param {string} url
   * @return {string} vimeo video ID
   */
   function vimeoGetId(url) {
     const regex = /(videos|video|channels|\.com)\/([\d]+)/;
     const parts = url.match(regex);
     const partsNum = url.split('/');
   
     // Handle URLs like https://vimeo.com/413064250/6b8fd8d053
     if (partsNum.length > 4) {
       return url;
     } else if (parts && parts[2] !== undefined) {
       return parts[2];
     }
     return url;
   }
   class Vimeo extends VideoBase {
     constructor(...args) {
       super(...args);
       this._load = () => {
         return this.theme.loadVimeoApi();
       };
       this.init = ({
         autoplay,
         hideControls,
         url,
         mute,
         loop,
         onPlay,
         onEnd
       }) => {
         autoplay = this.getAutoplay(autoplay);
         const videoId = vimeoGetId(url);
         return new Promise((resolve, reject) => {
           this._load().then(Vimeo => {
             this.player = new Vimeo.Player(this.element, {
               id: videoId,
               autoplay: autoplay,
               controls: !hideControls,
               byline: false,
               portrait: false,
               title: false
             });
             this.player.ready().then(() => {
               if (mute || autoplay) {
                 this.player.setVolume(0);
               }
               if (loop) {
                 this.player.setLoop(true);
               }
               if (autoplay) {
                 this.player.play();
               }
               resolve(this.player);
             });
             this.player.on('play', () => {
               onPlay();
             });
             this.player.on('ended', () => {
               onEnd();
             });
           });
         });
       };
       this.play = () => {
         this.player.play();
       };
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/MP4Video.js
   
   
   /// <reference path="../window.d.ts" />
   
   class MP4Video extends VideoBase {
     constructor(...args) {
       super(...args);
       this._load = () => {
         return new Promise(resolve => {
           window.Shopify.loadFeatures([{
             name: 'video-ui',
             version: '1.0',
             onLoad: function () {
               resolve(window.Shopify.Plyr);
             }
           }]);
         });
       };
       this.init = ({
         autoplay,
         hideControls,
         url,
         mute,
         loop,
         onPlay,
         onPause,
         onEnd
       }) => {
         autoplay = this.getAutoplay(autoplay);
         return new Promise((resolve, reject) => {
           this._load().then(Plyr => {
             this.player = new Plyr(this.element, {
               loop: {
                 active: loop
               },
               autoplay: autoplay,
               muted: mute || autoplay ? 1 : 0,
               fullscreen: {
                 enabled: false
               },
               focusOnPlay: false
             });
             this.player.on('ready', event => {
               this.player = event.detail.plyr;
               if (autoplay) {
                 this.player.play();
               }
               if (hideControls) {
                 this.player.toggleControls(false);
               }
               resolve();
             });
             this.player.on('playing', () => {
               onPlay();
             });
             this.player.on('pause', () => {
               onPause();
             });
             this.player.on('ended', () => {
               onEnd();
             });
           });
         });
       };
       this.play = () => {
         this.player.play();
       };
     }
   }
   ;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-2.use!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/javascripts/components/Video.vue?vue&type=script&lang=js&
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   //
   
   
   
   
   
   
   /* harmony default export */ const Videovue_type_script_lang_js_ = (vue_esm.extend({
     props: {
       theme: ThemeBase,
       hero: Boolean,
       videoType: {
         type: String,
         required: true,
         validator: function (value) {
           return ['youtube', 'vimeo', 'mp4'].indexOf(value) !== -1;
         }
       },
       url: {
         type: String,
         required: true
       },
       autoplay: {
         type: Boolean,
         required: true
       },
       loop: Boolean,
       mute: Boolean,
       hideControls: {
         type: Boolean,
         default: false
       },
       overlayOpacity: {
         type: Number,
         default: 1
       },
       sectionId: {
         type: String,
         default: ''
       },
       overlay: Boolean
     },
     data() {
       return {
         /** @type {import('../global/VideoBase').default} */
         player: null,
         isPlaying: false,
         showOverlay: true
       };
     },
     mounted() {
       if (this.videoType === 'youtube') {
         this.player = new Youtube(this.$root.theme, this.$refs.video);
       } else if (this.videoType === 'vimeo') {
         this.player = new Vimeo(this.$root.theme, this.$refs.video);
       } else if (this.videoType === 'mp4') {
         this.player = new MP4Video(this.$root.theme, this.$refs.videoMP4);
       }
       this.player.init({
         autoplay: this.autoplay,
         hideControls: this.hideControls,
         url: this.url,
         mute: this.mute,
         loop: this.loop,
         onPlay: this.onPlay,
         onPause: this.onPause,
         onEnd: this.onEnd
       });
     },
     methods: {
       onPlay() {
         this.isPlaying = true;
       },
       onPause() {
         this.isPlaying = false;
       },
       onEnd() {
         this.isPlaying = false;
       },
       play() {
         this.player.play();
         this.showOverlay = false;
       }
     }
   }));
   ;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue?vue&type=script&lang=js&
    /* harmony default export */ const components_Videovue_type_script_lang_js_ = (Videovue_type_script_lang_js_); 
   ;// CONCATENATED MODULE: ./src/javascripts/components/Video.vue
   
   
   
   
   
   /* normalize component */
   ;
   var Video_component = normalizeComponent(
     components_Videovue_type_script_lang_js_,
     Videovue_type_template_id_6f2f9e95_render,
     Videovue_type_template_id_6f2f9e95_staticRenderFns,
     false,
     null,
     null,
     null
     
   )
   
   /* harmony default export */ const Video = (Video_component.exports);
   ;// CONCATENATED MODULE: ./src/javascripts/global/Login.js
   
   class Login {
     constructor(theme, element) {
       this.showRecoverPasswordForm = () => {
         this.$recoverPasswordForm.show();
         this.$customerLoginForm.hide();
   
         // Now + 10 minutes (in milliseconds).
         var expiry = new Date(Date.now() + 10 * 60 * 1000);
         localStorage.setItem('resettingPassword', JSON.stringify({
           expiry: expiry.toISOString()
         }));
       };
       this.hideRecoverPasswordForm = () => {
         this.$recoverPasswordForm.hide();
         this.$customerLoginForm.show();
       };
       this._isLocalStorageSupported = () => {
         try {
           return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
         } catch (e) {
           return false;
         }
       };
       this.theme = theme;
       this.element = element;
       this.$element = jquery_default()(element);
       this.$recoverPasswordForm = this.$element.find('#RecoverPasswordForm');
       this.$customerLoginForm = this.$element.find('#CustomerLoginForm');
       this.$recoverPasswordLink = this.$element.find('#RecoverPassword');
       this.$hideRecoverPasswordLink = this.$element.find('#HideRecoverPasswordLink');
       this.hasLocalStorage = this._isLocalStorageSupported();
       this.$recoverPasswordLink.on('click', evt => {
         evt.preventDefault();
         this.showRecoverPasswordForm();
       });
       this.$hideRecoverPasswordLink.on('click', evt => {
         evt.preventDefault();
         this.hideRecoverPasswordForm();
         if (this.hasLocalStorage) {
           window.localStorage.removeItem('resettingPassword');
         }
       });
   
       // Allow deep linking to recover password form
       if (window.location.hash === '#recover') {
         this.showRecoverPasswordForm();
       }
       var isResettingPassword = null;
       if (this.hasLocalStorage) {
         isResettingPassword = window.localStorage.getItem('resettingPassword');
       }
       if (isResettingPassword) {
         var isError = document.querySelector('#RecoverPasswordForm .errors');
         if (isError) {
           jquery_default()('#ResetSuccess').hide();
         } else {
           // The password reset email has been sent. Display information.
           jquery_default()('#ResetSuccess').show();
           if (this.hasLocalStorage) {
             window.localStorage.removeItem('resettingPassword');
           }
         }
       }
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/RightDrawer.js
   var RightDrawer_dec, RightDrawer_dec2, RightDrawer_dec3, RightDrawer_dec4, RightDrawer_dec5, RightDrawer_dec6, RightDrawer_class, RightDrawer_class2, RightDrawer_descriptor, RightDrawer_descriptor2, RightDrawer_descriptor3;
   function RightDrawer_initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
   function RightDrawer_applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
   function RightDrawer_initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
   
   
   
   
   /**
     * @typedef {Object} SearchGroup
     * @param {string} name
     * @param {any[]} results
     */
   let RightDrawer = (RightDrawer_dec = vue_class_component_esm({
     template: '#wetheme-right-drawer-template'
   }), RightDrawer_dec2 = Prop({
     required: true
   }), RightDrawer_dec3 = Prop({
     required: false
   }), RightDrawer_dec4 = Prop({
     required: false
   }), RightDrawer_dec5 = Watch('giftNote'), RightDrawer_dec6 = Watch('searchQuery'), RightDrawer_dec(RightDrawer_class = (RightDrawer_class2 = class RightDrawer extends vue_esm {
     constructor(...args) {
       super(...args);
       this.isOpen = false;
       this.type = 'cart';
       this.cart = null;
       this.lineQuantityUpdating = null;
       this.quickShopProductUrl = null;
       this.quickShopContent = '';
       this.searching = false;
       this.searchQuery = '';
       this.searchGroups = [];
       this.searchChangeTimer = null;
       this.searchSummary = '';
       this.searchHasResults = false;
       this.searchResultsNum = 0;
       this.giftNote = '';
       this.updatingGiftNote = false;
       RightDrawer_initializerDefineProperty(this, "searchUrl", RightDrawer_descriptor, this);
       RightDrawer_initializerDefineProperty(this, "isPredictive", RightDrawer_descriptor2, this);
       RightDrawer_initializerDefineProperty(this, "languageUrl", RightDrawer_descriptor3, this);
     }
     data() {
       return {
         isOpen: false,
         type: 'cart',
         cart: null,
         lineQuantityUpdating: null,
         quickShopProductUrl: null,
         quickShopContent: '',
         searchQuery: '',
         searchResults: [],
         giftNote: ''
       };
     }
     onGiftNoteChange() {
       if (this.giftNoteChangeTimer) {
         window.clearTimeout(this.giftNoteChangeTimer);
       }
       this.giftNoteChangeTimer = window.setTimeout(() => {
         this.updatingGiftNote = true;
         this.updateGiftNote();
         this.giftNoteChangeTimer = null;
       }, 1000);
     }
     onSearchChange() {
       if (this.isSearchPredictive) {
         if (this.searchQuery > '') {
           if (this.searchChangeTimer) {
             window.clearTimeout(this.searchChangeTimer);
           }
           this.searchChangeTimer = window.setTimeout(() => {
             this.performSearch();
             this.searchChangeTimer = null;
           }, 250);
         } else {
           this.searchResultsNum = 0;
           this.searchHasResults = false;
           this.searchGroups = [];
           this.searching = false;
           this.searchSummary = '';
         }
       }
     }
   
     /** @returns {import('../ThemeBase').default} */
     get theme() {
       // @ts-ignore
       return this.$root.theme;
     }
     mounted() {
       document.documentElement.addEventListener(TOGGLE_RIGHT_DRAWER_EVENT, this.handleToggle);
     }
     beforeDestroy() {
       document.documentElement.removeEventListener(TOGGLE_RIGHT_DRAWER_EVENT, this.handleToggle);
     }
     handleToggle(event) {
       const {
         type,
         forceOpen,
         params
       } = event.detail;
       if (params) {
         if (params.url) {
           const url = params.url;
           if (type === 'shop-now') {
             if (this.quickShopProductUrl !== url) {
               this.getProductPage(url);
               this.quickShopProductId = url;
             }
           } else if (type === 'page') {
             this.getGenericPage(url);
           }
         }
         if (params.cart) {
           this.cart = params.cart;
           // Populate gift note if it exists
           if (params.cart.attributes.gift_note) {
             this.giftNote = params.cart.attributes.gift_note;
           }
           this.theme.updateCartDrawer(params.cart);
         }
       }
       this.toggle(type, forceOpen);
     }
     close() {
       document.body.classList.remove('js-drawer-open');
       document.body.classList.remove('js-drawer-open-right');
       this.isOpen = false;
     }
     open() {
       this.setSubtotal();
       document.body.classList.add('js-drawer-open');
       document.body.classList.add('js-drawer-open-right');
       this.isOpen = true;
       if (this.type === 'cart' && this.cart === null) {
         this.fetchCart();
         this.$nextTick(() => /** @type {HTMLElement} */this.$refs.drawerClose.focus());
       } else if (this.type === 'search') {
         this.$nextTick(() => /** @type {HTMLElement} */this.$refs.searchText.focus());
       }
     }
     toggle(type, forceOpen = undefined) {
       if (forceOpen === true) {
         this.type = type;
         this.open();
       } else if (forceOpen === false) {
         this.close();
       } else if (this.isOpen) {
         this.close();
       } else {
         this.type = type;
         this.open();
       }
     }
     async fetchCart() {
       try {
         const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
         const response = await window.fetch(`${languageParam}/cart?view=compare`);
         if (!response.ok) {
           // FIXME error handling
         }
         const cart = await response.json();
         this.cart = cart;
         // Populate gift note if it exists
         if (cart.attributes.gift_note) {
           this.giftNote = cart.attributes.gift_note;
         }
         this.theme.updateCartDrawer(cart);
       } catch (e) {
         console.error('Unable to fetch cart: ', e);
         // FIXME error handling
       }
     }
   
     setSubtotal() {
       setTimeout(function () {
         //Show the sum of all the line item compare at prices before the subtotal in the drawer
         let priceNoDiscount = document.querySelectorAll('.price-no--discount');
         let lineItemPrices = document.querySelectorAll('.has--discount');
         let lineItemComparePrices = document.querySelectorAll('.line-item__compare-at-price');
         let copmarePriceDiv = /** @type {HTMLElement} */document.querySelector('.line__compare_price');
         let cartTotal = /** @type {HTMLElement} */document.querySelector('.cart__total');
         let cartTotalAmt = 0;
         if (cartTotal) cartTotalAmt = parseFloat(cartTotal.innerHTML);
         let totalWithDiscount;
         if (!lineItemComparePrices || !lineItemPrices) return;
         if (lineItemComparePrices.length > 0 && lineItemPrices.length > 0) {
           //Get the sum of all compare at prices
           let total = 0;
           let compareSubtotal;
           for (let num = 0; num < lineItemComparePrices.length; num++) {
             const currentPrice = /** @type {HTMLElement} */lineItemComparePrices[num];
             total += parseFloat(currentPrice.innerText);
             compareSubtotal = total;
           }
   
           //Get the sum of discount prices
           let count = 0;
           let finalPriceTotal;
           for (let amount = 0; amount < lineItemPrices.length; amount++) {
             const currentTotalPrice = /** @type {HTMLElement} */lineItemPrices[amount];
             count += parseFloat(currentTotalPrice.innerText);
             finalPriceTotal = count;
           }
   
           //Get the sum of all line items that don't have discounts
           let price = 0;
           let totalPrice;
           for (let amt = 0; amt < priceNoDiscount.length; amt++) {
             const currFinalPrice = /** @type {HTMLElement} */priceNoDiscount[amt];
             price += parseFloat(currFinalPrice.innerText);
             totalPrice = price;
           }
           if (totalPrice > 0) {
             totalWithDiscount = compareSubtotal + totalPrice;
           } else {
             totalWithDiscount = compareSubtotal;
           }
           if (copmarePriceDiv) {
             copmarePriceDiv.innerHTML = this.wetheme.formatMoney(totalWithDiscount);
           }
         }
       }, 1500);
     }
   
     /**
      * Fetch page
      *
      * @param {string} url
      */
     async fetchPage(url) {
       const response = await window.fetch(url);
       const parser = new DOMParser();
       const doc = parser.parseFromString(await response.text(), 'text/html');
       const pageContent = doc.querySelector('.page-main--wrapper');
       return pageContent;
     }
   
     /**
      * Product page url
      *
      * @param {string} url
      */
     async getProductPage(url) {
       const pageContent = await this.fetchPage(url);
       const productDiv = pageContent.querySelector('[data-wetheme-section-type="template--product"]');
       const target = /** @type {HTMLElement} */this.$refs.shopNowContent;
       target.appendChild(productDiv);
       new FeaturedProduct(this.theme, target.querySelector('[data-wetheme-section-type="template--product"]'), {
         slidesPerView: 2
       });
   
       // window.Shopify.PaymentButton does not exist until the fetched
       // product page is fully loaded
       setTimeout(() => {
         if (window.Shopify && window.Shopify.PaymentButton) {
           window.Shopify.PaymentButton.init();
         }
       }, 1250);
     }
   
     /**
      * Page url
      *
      * @param {string} url
      */
     async getGenericPage(url) {
       const pageContent = await this.fetchPage(url);
       const target = /** @type {HTMLElement} */this.$refs.pageContent;
       target.appendChild(pageContent);
     }
     numDifference(a, b) {
       if (a > b) {
         return a - b;
       } else {
         return b - a;
       }
     }
     get isGiftwrapEnabled() {
       return this.theme.giftwrapProduct && this.theme.giftwrapEnabled;
     }
   
     /**
      * Is a given Product object the selected giftwrap product?
      *
      * @param {object} item
      */
     isGiftwrapProduct(item) {
       if (!this.isGiftwrapEnabled) return false;
       return item.handle == this.theme.giftwrapProduct;
     }
   
     /**
      * Remove giftwrap product when another product is removed
      *
      * @param {number} line 1-based index of a line
      * @param {number} quantity new quantity
      */
     async updateGiftwrap(line, quantity) {
       const thisProduct = this.cart.items[line - 1];
       if (!this.isGiftwrapEnabled) return line;
       if (thisProduct.properties) {
         if (this.theme.translations.giftwrap_label in thisProduct.properties) {
           // Find position of gift wrap item in the cart. Note this will break
           // if you ever add additional properties to the gift wrap product
           // such that it splits that product into > 1 cart line items.
           const giftwrapIndex = this.cart.items.map(e => e.handle).indexOf(this.theme.giftwrapProduct);
   
           // Continue only if gift wrap product is in the cart
           if (giftwrapIndex > -1) {
             let difference = this.numDifference(thisProduct.quantity, quantity);
   
             // Quantity = quantity of current gift wrap product minus the quantity
             // of the product being removed. There could be gift wrap for other
             // items.
             let newGiftwrapQuantity = 0;
             if (quantity > thisProduct.quantity) {
               newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity + difference;
             } else if (quantity == 0) {
               // If new quantity is zero, the associated product is being removed.
               newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity - thisProduct.quantity;
             } else {
               newGiftwrapQuantity = this.cart.items[giftwrapIndex].quantity - difference;
             }
             const response = await window.fetch('/cart/change.js', {
               method: 'POST',
               credentials: 'same-origin',
               headers: {
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify({
                 'line': giftwrapIndex + 1,
                 'quantity': newGiftwrapQuantity
               })
             });
   
             // Line is always 1-based so do not go below 1.
             if (newGiftwrapQuantity == 0 && line > 1) return line - 1;
             return line;
           }
           return line;
         }
       }
       return line;
     }
   
     /**
      * Update quantity of an item in cart
      *
      * @param {number} line 1-based index of a line
      * @param {number} quantity new quantity
      */
     async setQuantity(line, quantity) {
       this.lineQuantityUpdating = line;
       try {
         // If item has gift wrap, change gift wrap quantity too.
         line = await this.updateGiftwrap(line, quantity);
         this.lineQuantityUpdating = line;
         const response = await window.fetch('/cart/change.js', {
           method: 'POST',
           credentials: 'same-origin',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify({
             line,
             quantity
           })
         });
         const cart = await response.json();
         this.cart = cart;
         this.lineQuantityUpdating = null;
       } catch (e) {
         console.error('Unable to fetch cart: ', e);
         // FIXME error handling
       }
   
       this.fetchCart();
     }
     onSearchSubmit() {
       window.location.href = this.searchPageUrlWithQuery;
       return;
     }
     clearSearchInput() {
       this.searchQuery = '';
       /** @type {HTMLElement} */this.$refs.searchText.focus();
     }
     get isSearchPredictive() {
       return this.isPredictive == 'true';
     }
     get searchUrlWithQuery() {
       if (this.isSearchPredictive) {
         return `${this.searchUrl}?q=${encodeURIComponent(this.searchQuery)}&resources[limit]=3&resources[limit_scope]=each`;
       } else {
         return `/search?q=${encodeURIComponent(this.searchQuery)}`;
       }
     }
     get searchPageUrlWithQuery() {
       const languageParam = !this.languageUrl || this.languageUrl == '/' ? '' : this.languageUrl;
       return `${languageParam}/search?q=${encodeURIComponent(this.searchQuery)}*`;
     }
     async performSearch() {
       this.searching = true;
       this.searchHasResults = false;
       this.searchResultsNum = 0;
       this.searchSummary = '';
       let data;
       try {
         const response = await fetch(`${this.searchUrlWithQuery}`);
         if (!response.ok) {
           // FIXME handle error
         }
         data = await response.json();
       } catch (e) {
         console.error("Search failed", e);
         // We'll redirect the user to /search page when search fails (for whatever reason)
         window.location.href = this.searchPageUrlWithQuery;
       }
       const resultGroups = new Map();
   
       // Loop over groups e.g. Products / Pages / Articles / Collections
       Object.keys(data.resources.results).forEach(resultType => {
         let group = resultGroups.get(resultType);
         let result = data.resources.results[resultType];
         if (!group) {
           group = {
             name: {
               'queries': this.theme.translations.suggestions,
               'articles': this.theme.translations.articles,
               'pages': this.theme.translations.pages,
               'products': this.theme.translations.products,
               'collections': this.theme.translations.collections
             }[resultType],
             results: []
           };
           resultGroups.set(resultType, group);
         }
   
         // Format price.
         let resultWithPrice = result.map(item => {
           var temp = Object.assign({}, item);
           if (temp.price) {
             temp.price = this.theme.formatMoney(temp.price);
           }
           return temp;
         });
         group.results = resultWithPrice;
         if (group.results && group.results.length > 0) {
           this.searchResultsNum += result.length;
           this.searchHasResults = true;
         }
       });
       if (!this.searchHasResults && this.searchQuery > '') {
         this.searchSummary = this.theme.translations.no_results_html.replace('{{ terms }}', this.searchQuery);
       }
       this.searching = false;
       this.searchGroups = Array.from(resultGroups.values());
     }
     async updateGiftNote() {
       const response = await window.fetch('/cart/update.js', {
         method: 'POST',
         credentials: 'same-origin',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify({
           attributes: {
             'gift_note': this.giftNote
           }
         })
       });
       if (!response.ok) {
         // FIXME error handling
         console.log('Could not update gift note in cart drawer', response);
       }
       this.updatingGiftNote = false;
     }
   }, (RightDrawer_descriptor = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "searchUrl", [RightDrawer_dec2], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), RightDrawer_descriptor2 = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "isPredictive", [RightDrawer_dec3], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), RightDrawer_descriptor3 = RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "languageUrl", [RightDrawer_dec4], {
     configurable: true,
     enumerable: true,
     writable: true,
     initializer: null
   }), RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "onGiftNoteChange", [RightDrawer_dec5], Object.getOwnPropertyDescriptor(RightDrawer_class2.prototype, "onGiftNoteChange"), RightDrawer_class2.prototype), RightDrawer_applyDecoratedDescriptor(RightDrawer_class2.prototype, "onSearchChange", [RightDrawer_dec6], Object.getOwnPropertyDescriptor(RightDrawer_class2.prototype, "onSearchChange"), RightDrawer_class2.prototype)), RightDrawer_class2)) || RightDrawer_class);
   /* harmony default export */ const global_RightDrawer = (RightDrawer);
   // EXTERNAL MODULE: ./node_modules/fancybox/dist/js/jquery.fancybox.js
   var jquery_fancybox = __webpack_require__(506);
   ;// CONCATENATED MODULE: ./src/javascripts/global/Popup.js
   
   
   
   class Popup extends Component {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element) {
       super(theme, element);
       this.isExpiredOrNotSet = () => {
         var expired = true;
         if (!this.hasLocalStorage) return expired;
         var popupInfo = window.localStorage.getItem(this.STORAGE_KEY);
         if (popupInfo) {
           try {
             var expiry = Date.parse(JSON.parse(popupInfo).expiry);
             if (expiry > Date.now()) {
               expired = false;
             }
           } catch (e) {
             console.warn('Unable to read popup expiry date', e);
           }
         }
         return expired;
       };
       this.setExpiry = days => {
         var expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
         try {
           if (this.hasLocalStorage) {
             localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
               expiry: expiry.toISOString()
             }));
           }
         } catch (e) {
           console.warn('Unable to set popup expiry:', e);
         }
       };
       this.onWindowResize = ({
         width
       }) => {
         // @ts-ignore
         var isFullscreenOpen = (jquery_default()).fancybox.isOpen;
         if (width < 769) {
           if (isFullscreenOpen) {
             // switch from fullscreen to slide-up
             jquery_default().fancybox.close();
             this.showSlideUp();
           }
         } else {
           if (this.element.classList.contains('visible') && this.isFullscreen) {
             this.element.classList.remove('visible');
             this.showFullscreen();
           }
           if (isFullscreenOpen) {
             jquery_default().fancybox.reposition();
           }
         }
       };
       this.show = () => {
         if (this.theme.getWindowWidth() < 769) {
           jquery_default().fancybox.close();
           this.showSlideUp();
         } else {
           if (this.isFullscreen) {
             this.element.classList.remove('visible');
             this.showFullscreen();
           } else {
             this.showSlideUp();
           }
         }
       };
       this.showSlideUp = () => {
         document.querySelector('#slide-up').removeAttribute("style");
         document.querySelector('#popup').classList.add('slide-up');
         document.querySelector('#popup').classList.add('visible');
       };
       this.showFullscreen = () => {
         document.querySelector('#popup').classList.add('fullscreen');
         document.querySelector('#fullscreen').removeAttribute("style");
         jquery_default().fancybox({
           // @ts-ignore
           'autoScale': true,
           'transitionIn': 'elastic',
           'transitionOut': 'elastic',
           'speedIn': 500,
           'speedOut': 300,
           'autoDimensions': true,
           'centerOnScroll': true,
           'href': '#popup #fullscreen',
           'wrapCSS': 'fullscreen-popup-fancybox',
           tpl: {
             closeBtn: '<div class="popup--close fancybox-close" tabindex="0"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M5.63086 14.3692L10 10L14.3692 14.3692M14.3692 5.63086L9.99919 10L5.63086 5.63086" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
           }
         });
       };
       this._isLocalStorageSupported = () => {
         try {
           return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
         } catch (e) {
           return false;
         }
       };
       this.STORAGE_KEY = 'wetheme-popup';
       this.isFullscreen = this.element.dataset.desktopType === "fullscreen";
       this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10);
       this.popupDelay = parseInt(this.element.dataset.popupDelay, 10);
       this.testMode = this.element.dataset.popupTestMode === 'true';
       this.hasLocalStorage = this._isLocalStorageSupported();
       if (this.testMode) {
         // popup is in test mode - will show immediately in editor and on live site
         this.show();
       } else if (this.isExpiredOrNotSet()) {
         // popup item in localStorage is expired or was not set, show popup this time
         setTimeout(() => {
           this.setExpiry(this.popupSkipDays);
           this.show();
         }, 1000 * this.popupDelay);
       }
       this.element.querySelector('.popup--close-btn').addEventListener('click', () => {
         this.element.classList.remove('visible');
       });
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/VerificationPopup.js
   
   
   
   class VerificationPopup extends Component {
     constructor(theme, element) {
       super(theme, element);
       this.load = () => {
         // Age checker is in test mode - will show immediately in editor and on live site
         if (this.ageTestMode) this.showModal();
         if (this.modalLinks) {
           this.modalLinks.setAttribute('tabindex', '1');
         }
         var isAnAdult = this.readCookie('isAnAdult');
         if (!isAnAdult) {
           if (window.Shopify.designMode && !this.ageTestMode) return;
           this.showModal();
         }
         if (this.enterButton) {
           this.enterButton.addEventListener('click', this.writeCookie);
         }
         if (this.exitButton) {
           this.exitButton.addEventListener('click', this.comeBackModal);
         }
         if (this.returnButton) {
           this.returnButton.addEventListener('click', this.confirmAgeModal);
         }
         if (this.closeButton) {
           this.closeButton.addEventListener('click', this.confirmAgeModal);
         }
       };
       this.writeCookie = () => {
         // document.write("<style> #prompt__background { display: none; }</style>");
         document.cookie = "isAnAdult=true; expires=0; path=/";
         this.hideModal();
       };
       this.getModalContent = () => {
         this.changeContent = document.querySelector('.modal-deny-content');
         this.hideInitial = document.querySelector('.modal-initial-content');
       };
       this.trapFocus = () => {
         setTimeout(() => {
           if (document.querySelector('.verification-popup-container')) {
             var inputs = jquery_default()('.verification-popup-container').find('button, a').filter(':visible');
             var firstInput = inputs.first();
             var lastInput = inputs.last();
   
             // Set focus on first input
             jquery_default()('.verification-popup-container').focus();
   
             // Redirect last tab to first input
             lastInput.on('keydown', function (e) {
               if (e.which === 9 && !e.shiftKey) {
                 e.preventDefault();
                 firstInput.focus();
               }
             });
   
             // Redirect first shift+tab to last input
             firstInput.on('keydown', function (e) {
               if (e.which === 9 && e.shiftKey) {
                 e.preventDefault();
                 lastInput.focus();
               }
             });
           }
         }, 250);
       };
       this.readCookie = name => {
         var nameEQ = name + "=";
         var ca = document.cookie.split(';');
         for (var i = 0; i < ca.length; i++) {
           var c = ca[i];
           while (c.charAt(0) == ' ') c = c.substring(1, c.length);
           if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
         }
         return null;
       };
       this.showModal = () => {
         jquery_default()('.verification-popup-container').css('display', 'block');
         this.trapFocus();
         disableBodyScroll(document.querySelector('.verification-popup-container'));
       };
       this.hideModal = () => {
         enableBodyScroll(document.querySelector('.verification-popup-container'));
         jquery_default()('.verification-popup-container').css('display', 'none');
       };
       this.confirmAgeModal = () => {
         jquery_default()('#verification__prompt').scrollTop(0);
         jquery_default()('.verification-popup__close-button').css('display', 'none');
         this.getModalContent();
         this.changeContent.classList.add('hidden');
         this.hideInitial.classList.remove('hidden');
         this.trapFocus();
       };
       this.comeBackModal = () => {
         jquery_default()('#verification__prompt').scrollTop(0);
         jquery_default()('.verification-popup__close-button').css('display', 'flex');
         this.getModalContent();
         this.changeContent.classList.remove('hidden');
         this.hideInitial.classList.add('hidden');
         this.trapFocus();
       };
       this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
       this.ageDelay = 0;
       this.ageTestMode = this.element.dataset.ageTestMode === 'true';
       this.enterButton = element.querySelector('#button__enter');
       this.exitButton = element.querySelector('#button__exit');
       this.returnButton = element.querySelector('#button__return');
       this.closeButton = element.querySelector('.verification-popup__close-button');
       this.modalLinks = element.querySelector('.modal-content__wrapper a');
       this.load();
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/utils.js
   /**
    * Throttle execution of function
    *
    * @param {Function} callback function to be throttled
    * @param {number} interval milliseconds
    * @returns {Function}
    */
   function throttle(callback, interval) {
     let enableCall = true;
     let calledWhenDisabled = false;
     return (...args) => {
       const onTimeout = () => {
         if (calledWhenDisabled) {
           callback.apply(this, args);
           setTimeout(onTimeout, interval);
         } else {
           enableCall = true;
         }
         calledWhenDisabled = false;
       };
       if (!enableCall) {
         calledWhenDisabled = true;
         return;
       }
       enableCall = false;
       callback.apply(this, args);
       setTimeout(onTimeout, interval);
     };
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/Badge.js
   
   
   
   
   
   /* Place the sale or sold out badge at the top left of preview thumbnail
   * image/s, rather than the top left of the containing <div>.
   */
   class Badge extends Component {
     constructor(theme, _element) {
       super(theme, _element);
       this.add = (element, timeout) => {
         this.roots.push(element);
         this.load(element, timeout);
       };
       this.onWindowResize = () => {
         const $containers = jquery_default()(this.roots).find('.grid-view-item .grid-view-item-image');
         const $badges = $containers.find('.badge');
         $badges.css('opacity', 0);
         this.calculateBadgePositions($containers);
         $badges.css('opacity', 1);
       };
       this.load = (element, timeout = undefined) => {
         const badge = this;
         if (timeout === undefined) {
           timeout = 0;
         }
         const $containers = jquery_default()(element).find('.grid-view-item .grid-view-item-image');
         this.calculateBadgePositions($containers);
         if (timeout > 0) {
           setTimeout(() => {
             this.calculateBadgePositions($containers);
           }, timeout);
         }
   
         // On hover, if the 'Enable hover effect' setting is ON we'll need to move
         // the badge on hover as a different image will be shown.
         if ($containers.find('.hidden').length > 0 && this.theme.getWindowWidth() >= Breakpoints.md.min) {
           $containers.each((index, el) => {
             hoverintent_default()(el, function () {
               if (!jquery_default()(this).parent('.grid-view-item').hasClass('hovering')) {
                 // Fade in second image.
                 var self = jquery_default()(this);
                 self.parent('.grid-view-item').addClass('hovering');
                 self.find('.hidden').fadeTo(200, 1, function () {
                   badge.calculateHoverBadgePositions(jquery_default()(self));
                 });
               }
             }, function () {
               var self = jquery_default()(this);
               // Fade out second image.
               jquery_default()(this).find('.hidden').fadeTo(200, 0, function () {
                 badge.calculateBadgePositions($containers);
               });
               self.parent('.grid-view-item').removeClass('hovering');
             }).options({
               sensitivity: 10,
               interval: 25
             });
           });
         }
       };
       this.calculateHoverBadgePositions = item => {
         // If the 'Enable hover effect' setting is ON, also calculate the position
         // of the badge on the second thumbnail.
         if (item.find('.reveal .hidden').length) {
           item.find('.reveal .hidden').css('z-index', 4);
         }
       };
       this.calculateBadgePositions = container => {
         container.each((i, el) => {
           jquery_default()(el).find('*').stop(true, true);
         });
       };
       this.roots = [];
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/RecentlyViewed.js
   
   
   
   
   function get_unique_array(array) {
     var newArray = new Array();
     var handleArray = new Array();
     for (var i = 0; i < array.length; i++) {
       var handle = array[i]['handle'];
       if (handleArray.indexOf(handle) === -1) {
         newArray.push(array[i]);
         handleArray.push(handle);
       }
     }
     return newArray;
   }
   class RecentlyViewed extends Section {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.RECENTLY_VIEWED_COUNT = 10;
       this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
       this.PLACEHOLDER = 'PLACEHOLDER';
       this.loadProducts = recentlyViewed => {
         let str = this.paramStr(this.blocksArray);
         var promises = recentlyViewed.map(function (rv) {
           return jquery_default().get(this.productUrl.replace(this.PLACEHOLDER, rv.handle), {
             blocks: str
           });
         }.bind(this));
         jquery_default().when.apply((jquery_default()), promises).then(() => {
           let allOK = true;
           promises.forEach(promise => {
             if (promise.status === 200) {
               var container = document.createElement('div');
               container.innerHTML = promise.responseText;
               this.$content.append(container.querySelector('.main-content .grid__item').outerHTML);
               this.$content.find('.grid__item').addClass('swiper-slide');
               this.orderBlocks(container.querySelector('.grid-view-item'));
             } else {
               console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
               allOK = false;
             }
           });
           if (allOK) {
             this.show();
           } else {
             this.hideButtons();
           }
         });
       };
       this.orderBlocks = parent => {
         if (!this.blocksArray) return;
         const clone = parent.cloneNode(true);
         parent.innerHTML = '';
         this.blocksArray.forEach(block => {
           if (!block) return;
           const blockElement = clone.querySelector(`[data-block-type=${block}]`);
           if (blockElement) {
             parent.appendChild(blockElement);
           }
         });
       };
       this.hideButtons = () => {
         this.$element.find('.swiper-button--next').hide();
         this.$element.find('.swiper-button--prev').hide();
       };
       this.show = () => {
         const nextEl = this.element.querySelector('.swiper-button--next');
         const prevEl = this.element.querySelector('.swiper-button--prev');
         this.$element.fadeIn();
         this.swiper = new swiper_esm_bundle(this.element.querySelector('.swiper-container'), {
           slidesPerView: 2,
           navigation: {
             nextEl,
             prevEl
           },
           breakpoints: {
             768: {
               slidesPerView: 4
             }
           },
           watchOverflow: true,
           autoHeight: true
         });
         this.loadShopNow();
         this.quickAddButtons = new QuickAdd(this.theme, this.element);
         this.badge = this.theme.addBadges(this.element, 1000);
         const sectionLoadedEvent = new CustomEvent('theme:section:load');
         document.dispatchEvent(sectionLoadedEvent);
       };
       this.loadShopNow = () => {
         if (this.quickShopDesktopEnabled === 'true') {
           Array.prototype.forEach.call(this.element.querySelectorAll('.grid-view-item'), el => {
             const productId = Number(el.dataset.productId);
             const productAvailable = el.dataset.productAvailable == 'true';
             const productVarSize = Number(el.dataset.productVariantsSize);
             const product_url = el.dataset.productUrl;
             const cardImageBottomWrapper = el.querySelector('.product-card-image--bottom-wrapper');
   
             // Construct button for this product.
             const a_desktop = document.createElement('a');
             const a_mobile = document.createElement('a');
             const wrapper = document.createElement('div');
             wrapper.classList.add('quick-add-wrapper');
             if (productVarSize == 1) wrapper.classList.add('is-singular');
             if (productVarSize > 1 && productAvailable) {
               // Desktop button.
               a_desktop.classList.add('quick-add-button-variants', 'quick-add-button-variants-desktop');
               a_desktop.tabIndex = 0;
               a_desktop.href = product_url;
               a_desktop.textContent = this.theme.translations.view_options;
   
               // Mobile button.
               a_mobile.classList.add('quick-add-button-variants', 'quick-add-button-variants-mobile');
               if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');
               a_mobile.tabIndex = 0;
               a_mobile.href = product_url;
               const icon_span = document.createElement('span');
               icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
               a_mobile.appendChild(icon_span);
               [a_desktop, a_mobile].forEach(a => {
                 wrapper.appendChild(a);
               });
             } else if (productAvailable) {
               // HTML Form. Used for the 'Add to cart' button functionality.
               const form = document.createElement('form');
               form.method = 'post';
               form.action = '/cart/add';
               form.id = 'CollectionAddToCartForm';
               form.acceptCharset = 'UTF-8';
               form.classList.add('shopify-product-form');
               form.enctype = 'multipart/form-data';
               // Hidden form inputs.
               const form_type = document.createElement('input');
               form_type.type = 'hidden';
               form_type.name = 'form_type';
               form_type.value = 'product';
               form.appendChild(form_type);
               const utf_input = document.createElement('input');
               utf_input.type = 'hidden';
               utf_input.name = 'utf8';
               utf_input.value = '✓';
               form.appendChild(utf_input);
               const prod_id = document.createElement('input');
               prod_id.type = 'hidden';
               prod_id.name = 'id';
               prod_id.value = productId.toString();
               form.appendChild(prod_id);
   
               // Submit button desktop.
               const btn_desktop = document.createElement('button');
               btn_desktop.classList.add('quick-add-button', 'quick-add-button-desktop');
               btn_desktop.type = 'submit';
               btn_desktop.tabIndex = 0;
               btn_desktop.textContent = this.theme.translations.addToCart;
   
               // Submit button mobile.
               const btn_mobile = document.createElement('button');
               btn_mobile.classList.add('quick-add-button', 'quick-add-button-mobile');
               if (this.quickShopMobileDisabled == 'true') btn_mobile.classList.add('quick-shop-hidden');
               btn_mobile.type = 'submit';
               btn_mobile.tabIndex = 0;
               const icon_span = document.createElement('span');
               icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
               btn_mobile.appendChild(icon_span);
               [btn_desktop, btn_mobile].forEach(btn => {
                 form.appendChild(btn);
               });
               wrapper.appendChild(form);
             } else {
               // Desktop button.
               a_desktop.classList.add('sold-out-button', 'sold-out-button-desktop');
               a_desktop.href = product_url;
               a_desktop.textContent = this.theme.translations.soldOut;
   
               // Mobile button.
               a_mobile.classList.add('sold-out-button', 'sold-out-button-mobile');
               if (this.quickShopMobileDisabled == 'true') a_mobile.classList.add('quick-shop-hidden');
               a_mobile.href = product_url;
               const icon_span = document.createElement('span');
               icon_span.innerHTML = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="quick-view-mobile-icon"><path d="M11.6673 4.16667C11.6673 3.72464 11.4917 3.30072 11.1791 2.98816C10.8665 2.67559 10.4426 2.5 10.0006 2.5C9.55856 2.5 9.13464 2.67559 8.82208 2.98816C8.50952 3.30072 8.33392 3.72464 8.33392 4.16667M16.0506 8.08L17.2048 15.58C17.2413 15.8174 17.226 16.0598 17.1601 16.2908C17.0942 16.5217 16.9791 16.7357 16.8228 16.918C16.6665 17.1004 16.4727 17.2468 16.2545 17.3472C16.0364 17.4477 15.7991 17.4998 15.5589 17.5H4.44226C4.20195 17.5 3.96448 17.4481 3.74613 17.3477C3.52777 17.2474 3.3337 17.101 3.17721 16.9187C3.02072 16.7363 2.90552 16.5222 2.83951 16.2912C2.7735 16.0601 2.75823 15.8175 2.79476 15.58L3.94892 8.08C4.00947 7.68633 4.20899 7.32735 4.51136 7.06809C4.81373 6.80882 5.19895 6.66642 5.59726 6.66667H14.4039C14.8021 6.66662 15.1871 6.80911 15.4893 7.06836C15.7915 7.3276 15.9901 7.68647 16.0506 8.08Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
               a_mobile.appendChild(icon_span);
               [a_desktop, a_mobile].forEach(a => {
                 wrapper.appendChild(a);
               });
             }
             if (cardImageBottomWrapper) cardImageBottomWrapper.appendChild(wrapper);
           });
         }
         const quickAddButtons = this.element.querySelectorAll('.quick-add-button-variants');
         quickAddButtons.forEach(button => {
           button.addEventListener('click', this.handleShopNow.bind(this));
         });
       };
       this.handleShopNow = e => {
         e.preventDefault();
         this.theme.toggleRightDrawer('shop-now', true, {
           url: e.currentTarget.href
         });
       };
       this._isLocalStorageSupported = () => {
         try {
           return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
         } catch (e) {
           return false;
         }
       };
       this.paramStr = arr => {
         var parameters = [];
         for (var property in arr) {
           if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
             parameters.push(encodeURI(arr[property]));
           }
         }
         return parameters.join(',');
       };
       this.isMobile = () => {
         return window.matchMedia('(max-width: 1023px)').matches;
       };
       this.$element = jquery_default()(element);
       this.handle = this.element.dataset.productHandle;
       this.productUrl = this.element.dataset.productUrl;
       this.blocksArray = this.element.dataset.blocks.split(',');
       this.$content = this.$element.find('#recently-viewed-products');
       this.quickShopDesktopEnabled = this.element.dataset.quickShopDesktopEnabled;
       this.quickShopMobileDisabled = this.element.dataset.quickShopMobileDisabled;
       var self = this;
       window.addEventListener('load', event => {
         setTimeout(() => {
           if (self.swiper) {
             self.swiper.resize.resizeHandler();
           }
         }, 1000);
       });
       if (this.$content.hasClass('recently-viewed-loading')) {
         return;
       }
       this.$content.empty().addClass('recently-viewed-loading');
       var recentlyViewedJSON = null;
       if (this._isLocalStorageSupported()) {
         recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
       }
       var _recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];
       if (this.handle) {
         var item = {
           'handle': this.handle
         };
         _recentlyViewed.unshift(item);
       }
       var uniqueArray = _recentlyViewed.length ? get_unique_array(_recentlyViewed) : _recentlyViewed;
       if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
         uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
       }
       if (this._isLocalStorageSupported()) {
         localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
       }
       if (uniqueArray.length > 1 || uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle) {
         this.loadProducts(uniqueArray.filter(item => {
           return item.handle !== this.handle;
         }));
       } else {
         this.$element.remove();
       }
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/global/InfoColumns.js
   
   
   class InfoColumns extends Section {
     constructor(theme, _element, pageLoad) {
       super(theme, _element, pageLoad);
       this.isSlideInViewport = el => {
         const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
         const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
         const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
   
         // Check if the slide is in the visible area
         if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
           return true;
         }
         const absoluteSlideIndex = slideIndex + this.numberOfSlides;
         if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
           return true;
         }
         return false;
       };
       this.onBlockSelect = ({
         element
       }) => {
         if (this.isSlideInViewport(element)) return;
         const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
         const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
         this.swiper.slideTo(index, transitionDuration, false);
       };
       this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
       this.swiperContainer = this.element.querySelector('.swiper-container');
       this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
       const nextEl = this.element.querySelector('.swiper-button--next');
       const prevEl = this.element.querySelector('.swiper-button--prev');
       this.swiper = new swiper_esm_bundle(this.swiperContainer, {
         slidesPerView: 1,
           allowTouchMove: true,
         navigation: {
           nextEl,
           prevEl
           },
         breakpoints: {
           // when window width is >= 768px
           769: {
             slidesPerView: this.slidesPerView
           }
         },
         watchOverflow: true,
         autoHeight: true,
         loop: true,
         pagination: {
           el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
           clickable: true
         }
       });
     }
   }
    ;// CONCATENATED MODULE: ./src/javascripts/global/FyreTestimonials.js
       
       class FyreTestimonials extends Section {
           constructor(theme, _element, pageLoad) {
          super(theme, _element, pageLoad);
          this.isSlideInViewport = el => {
            const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
            const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
            const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
      
            // Check if the slide is in the visible area
            if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
              return true;
            }
            const absoluteSlideIndex = slideIndex + this.numberOfSlides;
            if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
              return true;
            }
            return false;
          };
          this.onBlockSelect = ({
            element
          }) => {
            if (this.isSlideInViewport(element)) return;
            const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
            const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
            this.swiper.slideTo(index, transitionDuration, false);
          };
          this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
          this.swiperContainer = this.element.querySelector('.swiper-container');
          this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
          const nextEl = this.element.querySelector('.swiper-button--next');
          const prevEl = this.element.querySelector('.swiper-button--prev');
          this.swiper = new swiper_esm_bundle(this.swiperContainer, {
            slidesPerView: 1,
              allowTouchMove: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false
              },
            navigation: {
              nextEl,
              prevEl
              },
            breakpoints: {
              // when window width is >= 768px
              769: {
                slidesPerView: this.slidesPerView
              }
            },
            watchOverflow: true,
            autoHeight: true,
            loop: true
            // pagination: {
            //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
            //   clickable: true
            // }
          });
        }
      }
       ;// CONCATENATED MODULE: ./src/javascripts/global/SearchResults.js


       ///'template--product--fyre-results': FyreResults,
    class FyreResults extends Section {
        constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);
        this.isSlideInViewport = el => {
            const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
            const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
            const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
    
            // Check if the slide is in the visible area
            if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
            return true;
            }
            const absoluteSlideIndex = slideIndex + this.numberOfSlides;
            if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
            return true;
            }
            return false;
        };
        this.onBlockSelect = ({
            element
        }) => {
            if (this.isSlideInViewport(element)) return;
            const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
            const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
            this.swiper.slideTo(index, transitionDuration, false);
        };
        this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
        this.swiperContainer = this.element.querySelector('.swiper-container');
        this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
        const nextEl = this.element.querySelector('.swiper-button--next');
        const prevEl = this.element.querySelector('.swiper-button--prev');
        this.swiper = new swiper_esm_bundle(this.swiperContainer, {
            slidesPerView: 1,
            allowTouchMove: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: true
            // },
            navigation: {
            nextEl,
            prevEl
            },
            watchOverflow: true,
            autoHeight: true,
            loop: true
            // pagination: {
            //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
            //   clickable: true
            // }
        });
        }
    };

       
    //FyreTimeline
    class FyreTimeline extends Section {
        constructor(theme, _element, pageLoad) {
        super(theme, _element, pageLoad);
        this.isSlideInViewport = el => {
            const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
            const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
            const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
    
            // Check if the slide is in the visible area
            if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
            return true;
            }
            const absoluteSlideIndex = slideIndex + this.numberOfSlides;
            if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
            return true;
            }
            return false;
        };
        this.onBlockSelect = ({
            element
        }) => {
            if (this.isSlideInViewport(element)) return;
            const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
            const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
            this.swiper.slideTo(index, transitionDuration, false);
        };
        this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
        this.swiperContainer = this.element.querySelector('.swiper-container.main-slider');
       this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);

        this.swiperNav = this.element.querySelector('.swiper-container.slider-nav');
        const nextEl = this.element.querySelector('.swiper-button--next');
        const prevEl = this.element.querySelector('.swiper-button--prev');

            this.swiper2 = new swiper_esm_bundle(this.swiperNav, {
                slidesPerView: 2,
                allowTouchMove: true,
                // autoplay: {
                //     delay: 5000,
                //     disableOnInteraction: true
                // },
                navigation: {
                nextEl,
                prevEl
                },
                watchOverflow: true,
                autoHeight: true,
                loop: false,
                breakpoints: {
            
                    // when window width is >= 768px
                    // 768: {
                    //     slidesPerView: (this.slidesPerView - 2),
                    // },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                 },
                // pagination: {
                //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
                //   clickable: true
                // }
            });

      
            this.swiper = new swiper_esm_bundle(this.swiperContainer, {
                slidesPerView: 1,
                allowTouchMove: true,
                effect: "fade",
                // autoplay: {
                //     delay: 5000,
                //     disableOnInteraction: true
                // },
                // navigation: {
                // nextEl,
                // prevEl
                // },
                watchOverflow: true,
                autoHeight: true,
                loop: false,
                thumbs: {
                    swiper: this.swiper2,
                },
                // pagination: {
                //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
                //   clickable: true
                // }
            });

           

        }
    };
   
       
    class FyreSeenIn extends Section {
        constructor(theme, _element, pageLoad) {
       super(theme, _element, pageLoad);
       this.isSlideInViewport = el => {
         const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
         const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
         const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
   
         // Check if the slide is in the visible area
         if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
           return true;
         }
         const absoluteSlideIndex = slideIndex + this.numberOfSlides;
         if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
           return true;
         }
         return false;
       };
       this.onBlockSelect = ({
         element
       }) => {
         if (this.isSlideInViewport(element)) return;
         const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
         const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
         this.swiper.slideTo(index, transitionDuration, false);
       };
       this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
       this.swiperContainer = this.element.querySelector('.swiper-container');
       this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
       const nextEl = this.element.querySelector('.swiper-button--next');
       const prevEl = this.element.querySelector('.swiper-button--prev');
       this.swiper = new swiper_esm_bundle(this.swiperContainer, {
         slidesPerView: 1,
           allowTouchMove: true,
           autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
            nextEl,
            prevEl
           },
           breakpoints: {
            
            // when window width is >= 768px
            768: {
                slidesPerView: (this.slidesPerView - 2),
                loop: true,
            },
            992: {
                slidesPerView: (this.slidesPerView - 1),
                loop: true,
            },
            1200: {
                slidesPerView: this.slidesPerView,
                allowTouchMove: false,
                loop: false,
            },
         },
         watchOverflow: true,
         autoHeight: true
         // pagination: {
         //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
         //   clickable: true
         // }
       });
     }
   }
       ;

       class FyreComponents extends Section {
        constructor(theme, _element, pageLoad) {
       super(theme, _element, pageLoad);
       this.isSlideInViewport = el => {
         const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
         const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
         const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)
   
         // Check if the slide is in the visible area
         if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
           return true;
         }
         const absoluteSlideIndex = slideIndex + this.numberOfSlides;
         if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
           return true;
         }
         return false;
       };
       this.onBlockSelect = ({
         element
       }) => {
         if (this.isSlideInViewport(element)) return;
         const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
         const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
         this.swiper.slideTo(index, transitionDuration, false);
       };
       this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
       this.swiperContainer = this.element.querySelector('.swiper-container');
       this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
       const nextEl = this.element.querySelector('.swiper-button--next');
       const prevEl = this.element.querySelector('.swiper-button--prev');
       this.swiper = new swiper_esm_bundle(this.swiperContainer, {
         slidesPerView: 1,
           allowTouchMove: true,
        //    autoplay: {
        //         delay: 5000,
        //         disableOnInteraction: false
        //     },
            navigation: {
            nextEl,
            prevEl
           },
           breakpoints: {
            
            // when window width is >= 768px
            768: {
                slidesPerView: (this.slidesPerView - 2),
                loop: true,
            },
            992: {
                slidesPerView: (this.slidesPerView - 1),
                loop: true,
            },
            1200: {
                slidesPerView: this.slidesPerView,
                allowTouchMove: false,
                loop: false,
            },
         },
         watchOverflow: true,
         autoHeight: true
         // pagination: {
         //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
         //   clickable: true
         // }
       });
     }
   }
       ;
       
   class FyrePDPVideos extends Section {
    constructor(theme, _element, pageLoad) {
   super(theme, _element, pageLoad);
   this.isSlideInViewport = el => {
     const slideIndex = parseInt(el.dataset.swiperSlideIndex, 10); // slideIndex contains the index of the slide (relative value which goes from 0 to numberOfSlides-1)
     const activeSlideIndex = parseInt( /** @type {HTMLElement} */this.element.querySelector('.swiper-slide-active').dataset.swiperSlideIndex, 10);
     const lastVisibleIndex = activeSlideIndex + this.slidesPerView - 1; // contains absolute value (can exceed the total number of slides)

     // Check if the slide is in the visible area
     if (slideIndex >= activeSlideIndex && slideIndex <= lastVisibleIndex) {
       return true;
     }
     const absoluteSlideIndex = slideIndex + this.numberOfSlides;
     if (absoluteSlideIndex >= activeSlideIndex && absoluteSlideIndex <= lastVisibleIndex) {
       return true;
     }
     return false;
   };
   this.onBlockSelect = ({
     element
   }) => {
     if (this.isSlideInViewport(element)) return;
     const index = parseInt(element.dataset.swiperSlideIndex, 10) + 1;
     const transitionDuration = 300; // Transition duration (ms) – 300 is the default value
     this.swiper.slideTo(index, transitionDuration, false);
   };
   this.slidesPerView = parseInt(this.element.dataset.slidesPerRow);
   this.swiperContainer = this.element.querySelector('.swiper-container');
   this.numberOfSlides = parseInt( /** @type {HTMLElement} */this.swiperContainer.dataset.numberOfSlides, 10);
   const nextEl = this.element.querySelector('.swiper-button--next');
   const prevEl = this.element.querySelector('.swiper-button--prev');
   this.swiper = new swiper_esm_bundle(this.swiperContainer, {
     slidesPerView: 1,
       allowTouchMove: true,
        navigation: {
        nextEl,
        prevEl
       },
       breakpoints: {
        
        // when window width is >= 768px
        768: {
            slidesPerView: (this.slidesPerView - 1),
        },
        1200: {
            slidesPerView: this.slidesPerView,
            allowTouchMove: false,
        },
     },
     watchOverflow: true,
       autoHeight: true,
       spaceBetween: 20,
     loop: false
     // pagination: {
     //   el: this.swiperContainer.querySelectorAll('.swiper-pagination'),
     //   clickable: true
     // }
   });
 }
}
;// CONCATENATED MODULE: ./src/javascripts/global/SearchResults.js
   
   class SearchResults extends Section {
     /**
      * @param {import('../ThemeBase').default} theme
      * @param {HTMLElement} element
      */
     constructor(theme, element, pageLoad) {
       super(theme, element, pageLoad);
       this.removeAsterisks = () => {
         var pageTitle = document.querySelector('.page--title');
         pageTitle.textContent = pageTitle.textContent.replace('*', '');
         var searchInput = /** @type {HTMLInputElement} */document.querySelector('.search-bar .input-group-field');
         searchInput.value = searchInput.value.replace('*', '');
         var breadcrumbLast = document.querySelector('nav.breadcrumb span:last-child');
         if (breadcrumbLast) {
           breadcrumbLast.textContent = breadcrumbLast.textContent.replace('*', '');
         }
       };
       this.onSearchChange = e => {
         if (this.searchInput.value.length > 0) {
           this.searchClear.style.opacity = '1';
           this.searchClear.tabIndex = 0;
         } else {
           this.searchClear.style.opacity = '0';
           this.searchClear.tabIndex = -1;
         }
       };
       this.clearSearch = e => {
         if (this.searchInput) {
           this.searchInput.value = '';
           this.onSearchChange();
           this.searchInput.focus();
         }
       };
       this.tabClearSearch = e => {
         if (e.keyCode === 13) {
           e.preventDefault();
           this.searchInput.value = '';
           this.onSearchChange();
           this.searchInput.focus();
         }
       };
       this.removeAsterisks();
       this.clearSearch();
       this.searchInput = /** @type {HTMLInputElement} */element.querySelector('input[type="search"]');
       this.searchInput.addEventListener('input', this.onSearchChange);
       this.searchClear = /** @type {HTMLElement} */element.querySelector('.search-drawer--clear');
       this.searchClear.addEventListener('click', this.clearSearch);
       this.searchClear.addEventListener('keydown', this.tabClearSearch);
     }
   }
   ;// CONCATENATED MODULE: ./src/javascripts/Theme.js
   
   
   
   
   
   // import Popup from './global/Popup';
   // import Newsletter from './global/Newsletter';
   // import CartDrawer from './global/CartDrawer';
   // import Drawer from './global/Drawer';
   
   // import LoginPage from './pages/LoginPage';
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   /**
    * @typedef {Object} ShopifyEventDetail
    * @property {string} sectionId
    * @property {string} [blockId]
    * @property {boolean} [load]
    */
   
   /**
    * @typedef {CustomEvent<ShopifyEventDetail>} ShopifyEvent
    */
   
   class Theme extends ThemeBase {
     constructor() {
       super();
       this.THROTTLE_INTERVAL = 400;
       this.SECTIONS = {
         'header': Header,
         'footer-main': Footer,
         'announcement-bar': AnnouncementBar,
         'animated-text': AnimatedText,
         'advanced-layout--custom-html': CustomHtml,
         'advanced-layout--hero': Hero,
         'blog--blog-posts': BlogPosts,
         'collage-builder': VideoHero,
         'template--product--info-columns': InfoColumns,
        //
           'template--product--fyre-testimonials': FyreTestimonials,
           'template--product--fyre-seen-in': FyreSeenIn,
           'template--product--fyre-motive-components': FyreComponents,
           'template--product--fyre-results': FyreResults,
           'template--product--fyre-timeline': FyreTimeline,
           'template--pdp--fyre-videos': FyrePDPVideos,
        //
         'collection--collection-list': CollectionList,
         'collection--featured-collection': FeaturedCollection,
         'countdown-timer': ImageWithText,
         'events-calendar': EventsCalendar,
         'image--gallery': ImageGallery,
         'image--image-with-text-overlay': ImageWithTextOverlay,
         'image--image-with-text': ImageWithText,
         'image--logo-list': LogoList,
         'image--slideshow': Slideshow,
         'newsletter--newsletter': Newsletter,
         'password': Password,
         'products--featured-product': FeaturedProduct,
         'store-information--map': MapSection,
         'template--blog': Blog,
         'template--cart': Cart,
         'template--collection': CollectionSection,
         'template--collections-list': CollectionListSection,
         'template--page-contact': MapSection,
         'template--product': ProductSection,
         'template--product--recently-viewed': RecentlyViewed,
         'template--search': SearchResults,
         'text--rich-text': RichText,
         'text--testimonials': Testimonails,
         'text--text-adverts': TextAdverts,
         'video--video-hero': VideoHero,
         'video--video': Section,
         'featured-menu': FeaturedMenu
       };
       this.VUE_COMPONENTS = {
         'wetheme-dropdown': Dropdown,
         'wetheme-video': Video
       };
       this.loadFadeAnimation = () => {
         document.body.classList.add('loaded');
         if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
           // Safari doesn't support beforeunload very well when using back/forward buttons.
           return;
         }
         window.addEventListener('beforeunload', function () {
           document.body.classList.add('unloading');
         });
       };
       this.loadGlobal = () => {
         const globalEl = document.querySelector('#wetheme-global');
         if (!globalEl) {
           console.warn('Script #wetheme-global with global definitions not found');
           return;
         }
         let global;
         try {
           global = JSON.parse(globalEl.textContent);
         } catch (e) {
           console.warn('Invalid syntax in #wetheme-global', e);
           return;
         }
         this.translations = global.translations;
         this.moneyFormat = global.moneyFormat;
         this.giftwrapProduct = global.giftwrapProduct;
         this.giftwrapEnabled = global.giftwrapEnabled;
         vue_esm.directive('money', {
           bind: (el, binding) => {
             el.innerHTML = this.formatMoney(binding.value);
           },
           update: (el, binding) => {
             if (binding.oldValue !== binding.value) {
               el.innerHTML = this.formatMoney(binding.value);
             }
           }
         });
         vue_esm.directive('responsive', {
           bind: (el, binding) => {
             /* Create product thumbnail:
              *  - Remove file extension, add _1000x, and re-add extension
              *  - Create server relative link
              *  - Create responsive variant (`_{width}x` as size)
              */
   
             let srcset = '';
             if (el.width > 550) {
               srcset += binding.value.replace(/(\.[^.]*)$/, "_550x$1") + ' 550w,';
             }
             if (el.width > 1100) {
               srcset += binding.value.replace(/(\.[^.]*)$/, "_1100x$1") + ' 1100w,';
             }
             if (el.width > 1445) {
               srcset += binding.value.replace(/(\.[^.]*)$/, "_1445x$1") + ' 1445w,';
             }
             if (el.width > 1680) {
               srcset += binding.value.replace(/(\.[^.]*)$/, "_1680x$1") + ' 1680w,';
             }
             if (el.width > 2048) {
               srcset += binding.value.replace(/(\.[^.]*)$/, "_2048x$1") + ' 2048w,';
             }
   
             // Plus the original image size for good measure.
             srcset += binding.value + ' ' + el.width + 'w';
             const img = binding.value.replace(/(\.[^.]*)$/, "_1000x$1").replace('http:', '');
             el.setAttribute('src', img);
             el.setAttribute('srcset', srcset);
             el.setAttribute('loading', 'lazy');
             el.setAttribute('loading', 'lazy');
           }
         });
       };
       this.loadVueComponents = element => {
         Object.entries(this.VUE_COMPONENTS).forEach(([tagName, VueComponent]) => {
           this.loadVueComponent(element, tagName, VueComponent);
         });
       };
       this.loadVueComponent = (element, tagName, Component) => {
         Array.prototype.forEach.call(element.querySelectorAll(tagName), el => {
           const c = new vue_esm({
             el: el.parentNode,
             components: {
               [tagName]: Component
             },
             data: () => {
               return {
                 theme: this
               };
             }
           });
           this.vueComponents.push(c);
         });
       };
       this.loadSection = (element, SectionClass, pageLoad) => {
         const c = new SectionClass(this, element, pageLoad);
         this.sectionById.set(element.dataset.wethemeSectionId, c);
         const type = element.dataset.wethemeSectionType;
         let sections = this.sectionsByType.get(type);
         if (!sections) {
           sections = [];
           this.sectionsByType.set(type, sections);
         }
         sections.push(c);
         this.loadVueComponents(element);
       };
       this.loadSectionsByType = (type, SectionClass, pageLoad) => {
         const selector = `[data-wetheme-section-type="${type}"]`;
         Array.prototype.forEach.call(document.querySelectorAll(selector), element => {
           try {
             this.loadSection(element, SectionClass, pageLoad);
           } catch (e) {
             console.error(`Unable to load section ${type} on element`, element, e);
           }
         });
       };
       this.onLoadAll = () => {
         this.load();
         Object.entries(this.SECTIONS).forEach(([type, SectionClass]) => {
           this.loadSectionsByType(type, SectionClass, true);
         });
         this.showOnScroll();
       };
       this.onSectionLoad = event => {
         // When in section preview, there is no section instance - show the section and return
         if (window.Shopify.visualPreviewMode) {
           this.showOnScroll();
           return;
         }
         const {
           sectionId
         } = event.detail;
         const selector = `[data-wetheme-section-id="${sectionId}"]`;
         const element = /** @type {HTMLElement} */document.querySelector(selector);
         if (!element) {
           console.warn(`Element with ${selector} not found, section won't be loaded`);
           return;
         }
         const type = element.dataset.wethemeSectionType;
         const SectionClass = this.SECTIONS[type];
         if (!SectionClass) {
           console.warn(`Cannot find class with type "${type}"`);
           return;
         }
         // Remove 'fadeInUp' animation from the first section
         let getAnimatedEls = document.querySelectorAll('.show-on-scroll');
         if (getAnimatedEls.length > 0) {
           getAnimatedEls[0].classList.remove('show-on-scroll');
         }
         this.loadSection(element, SectionClass, false);
         this.showOnScroll();
       };
       this.onSectionUnload = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, nothing will be unloaded`);
           return;
         }
         section.destroy({
           element
         });
       };
       this.onSectionSelect = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId,
           load
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, nothing will be selected`);
           return;
         }
         section.onSectionSelect({
           element,
           sectionId,
           load
         });
       };
       this.onSectionDeselect = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, nothing will be deselected`);
           return;
         }
         section.onSectionDeselect({
           element,
           sectionId
         });
       };
       this.onSectionReorder = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, nothing will be done on reorder`);
           return;
         }
         section.onSectionReorder({
           element,
           sectionId
         });
       };
       this.onBlockSelect = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId,
           blockId,
           load
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, block select will do nothing`);
           return;
         }
         section.onBlockSelect({
           element,
           sectionId,
           blockId,
           load
         });
       };
       this.onBlockDeselect = event => {
         const element = /** @type {HTMLElement} */event.target;
         const {
           sectionId,
           blockId
         } = event.detail;
         const section = this.sectionById.get(sectionId);
         if (!section) {
           console.warn(`No section with id ${sectionId}, block deselect will do nothing`);
           return;
         }
         section.onBlockDeselect({
           element,
           sectionId,
           blockId
         });
       };
       this.onRawResize = event => {
         const width = this.getWindowWidth();
   
         // Trigger non-debounced event on all components
         this.registeredComponents.forEach(c => c.onWindowResizeRaw({
           width
         }));
         this.onResize();
       };
       this.onResize = throttle(() => {
         const width = this.getWindowWidth();
         const oldWidth = this.previousWidth;
         const breakpoint = this.getBreakpoint(width);
         this.registeredComponents.forEach(c => {
           c.onWindowResize({
             width,
             oldWidth,
             breakpoint
           });
           if (breakpoint !== this.breakpoint) {
             // Breakpoint has changed, trigger the event
             c.onWindowResizeBreakpoint({
               breakpoint,
               oldBreakpoint: this.breakpoint,
               width
             });
           }
         });
         this.previousWidth = width;
         this.breakpoint = breakpoint;
       }, this.THROTTLE_INTERVAL);
       this.onRawScroll = event => {
         this.onScroll(event);
       };
       this.onScroll = throttle(event => {
         this.showOnScroll();
         this.registeredComponents.forEach(c => {
           c.onWindowScroll();
         });
       }, this.THROTTLE_INTERVAL);
       this.showOnScroll = () => {
         const windowHeight = jquery_default()(window).height();
         jquery_default()('.show-on-scroll').each(function (index, section) {
           var rect = section.getBoundingClientRect();
           if (rect.bottom >= 0 && rect.top < windowHeight) {
             jquery_default()(section).removeClass('show-on-scroll').addClass('shown-on-scroll animated fadeInUp');
           }
         });
       };
       this.onKeyUp = e => {
         // Close drawers when escape is pressed if they are open
         if (e.keyCode == 27) {
           // escape key maps to keycode `27`
           this.closeDrawers();
         }
       };
       this.handleAccordions = () => {
         let detailsElements = document.querySelectorAll('details');
   
         //@ts-ignore
         for (let item of detailsElements) {
           item.addEventListener('click', e => {
             const target = /** @type {HTMLElement} */e.currentTarget;
             setTimeout(() => {
               const isExpanded = item.open ? 'true' : 'false';
               item.firstElementChild.setAttribute('aria-expanded', isExpanded);
             }, 0);
           });
         }
       };
       this.loadYoutubeApi = () => {
         return new Promise((resolve, reject) => {
           if (window.YT) {
             // We already have youtube API loaded, we're done
             resolve(window.YT);
           } else if (!document.querySelector('#youtube_api')) {
             // Resolve once youtube is loaded
             this.youtubeLoadedCallbacks.push({
               resolve,
               reject
             });
             const embedContainers = /** @type {NodeListOf<Element>} */document.querySelectorAll('.type-youtube');
             const videoObserverOptions = {};
             const videoObserverCallback = (watchEntries, videoObserver) => {
               watchEntries.forEach(watchEntry => {
                 if (watchEntry.isIntersecting) {
                   // Youtube API is not yet loaded, create script that loads it
                   this.createScript("youtube_api", "https://www.youtube.com/player_api", true);
                   embedContainers.forEach(embedContainer => {
                     videoObserver.unobserve(embedContainer);
                   });
                 }
               });
             };
             const videoObserver = new IntersectionObserver(videoObserverCallback, videoObserverOptions);
             if (embedContainers.length) {
               embedContainers.forEach(embedContainer => {
                 videoObserver.observe(embedContainer);
               });
             }
           } else {
             // Script for loading youtube API is there, but youtube is not yet loaded
             this.youtubeLoadedCallbacks.push({
               resolve,
               reject
             });
           }
         });
       };
       this.onYoutubeLoaded = () => {
         this.youtubeLoadedCallbacks.forEach(({
           resolve
         }) => {
           resolve(window.YT);
         });
         this.youtubeLoadedCallbacks.splice(0);
       };
       this.loadVimeoApi = () => {
         return new Promise((resolve, reject) => {
           if (window.Vimeo) {
             // Already loaded
             resolve(window.Vimeo);
           } else if (!document.querySelector('#vimeo_api')) {
             // Vimeo API is not yet loaded, create script that loads it
             const script = this.createScript("vimeo_api", "https://player.vimeo.com/api/player.js");
             script.onload = () => {
               resolve(window.Vimeo);
               this.onVimeoLoaded();
             };
           } else {
             this.vimeoLoadedCallbacks.push({
               resolve,
               reject
             });
           }
         });
       };
       this.onVimeoLoaded = () => {
         this.vimeoLoadedCallbacks.forEach(({
           resolve
         }) => {
           resolve(window.Vimeo);
         });
         this.vimeoLoadedCallbacks.splice(0);
       };
       this.loadGoogleMapApi = apiKey => {
         return new Promise((resolve, reject) => {
           if (window.google && window.google.maps && window.google.maps.Geocoder && window.google.maps.Map) {
             resolve(window.google.maps);
           } else if (!document.querySelector('#google_maps_api')) {
             const loadMaps = () => {
               // Google Maps API is not yet loaded, create script that loads it
               const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=onGoogleMapsAPIReady`;
               this.createScript('google_maps_api', url, true);
             };
   
             // Resolve once Maps API is loaded
             this.mapsLoadedCallbacks.push({
               resolve,
               reject
             });
   
             // Google Maps API collides with Shopify payments loading Google Pay,
             // we need to wait for payments to load before loading Maps API
             // TODO: remove once Shopify fixes their payments code
             let attemptsRemaining = 6;
             const checkForPayments = () => {
               // Wait for checkout buttons to be loaded
               const checkoutWrapper = document.querySelector('[data-shopify="dynamic-checkout-cart"]');
               if (attemptsRemaining > 0 && checkoutWrapper && checkoutWrapper.children.length === 0) {
                 attemptsRemaining -= 1;
                 setTimeout(checkForPayments, 500);
               } else {
                 loadMaps();
               }
             };
             checkForPayments();
           } else {
             // Script for loading maps API is there, but it is not yet loaded
             this.mapsLoadedCallbacks.push({
               resolve,
               reject
             });
           }
         });
       };
       this.onGoogleMapsLoaded = () => {
         this.mapsLoadedCallbacks.forEach(({
           resolve
         }) => {
           resolve(window.google.maps);
         });
         this.mapsLoadedCallbacks.splice(0);
       };
       this.onGoogleAuthFailure = reason => {
         this.mapsLoadedCallbacks.forEach(({
           reject
         }) => {
           reject(reason);
         });
         this.mapsLoadedCallbacks.splice(0);
         const event = new CustomEvent('google-maps-auth-failure', {
           detail: {
             reason
           }
         });
         document.body.dispatchEvent(event);
       };
       this._loadCartKey = () => {
         const cerberusKey = 'f1957945-9048-438b-bd2c-0ed182340c65';
         return cerberusKey;
       };
       this.toggleRightDrawer = (type = 'cart', forceOpen = undefined, params = {}) => {
         const event = new CustomEvent(TOGGLE_RIGHT_DRAWER_EVENT, {
           detail: {
             type,
             forceOpen,
             params
           }
         });
         document.documentElement.dispatchEvent(event);
       };
       this.toggleLeftDrawer = (forceOpen = undefined) => {
         const event = new CustomEvent(TOGGLE_LEFT_DRAWER_EVENT, {
           detail: {
             forceOpen
           }
         });
         document.documentElement.dispatchEvent(event);
       };
       this.updateCartDrawer = cart => {
         const event = new CustomEvent(CART_UPDATE_EVENT, {
           detail: {
             cart
           }
         });
         document.documentElement.dispatchEvent(event);
       };
       this.createScript = (id, src, async = false) => {
         const tag = document.createElement('script');
         tag.id = id;
         tag.src = src;
         if (async) {
           tag.defer = true;
           tag.async = true;
         }
         const firstScriptTag = document.getElementsByTagName('script')[0];
         firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
         return tag;
       };
       this.registerComponent = component => {
         this.registeredComponents.push(component);
       };
       this.makeVideoEmbedsResponsive = () => {
         jquery_default()('.template-page iframe, .template-blog iframe, .template-article iframe').each(function (index, iframe) {
           var source = jquery_default()(iframe).attr("src");
           if (source.indexOf("youtube.com") >= 0 || source.indexOf("vimeo.com") >= 0 || source.indexOf("dailymotion.com") >= 0) {
             //create container
             var embedContainer = document.createElement('div');
             jquery_default()(embedContainer).addClass('embed-container');
   
             //clone iframe
             var iframeClone = jquery_default()(iframe).clone();
   
             //put clone in container
             jquery_default()(embedContainer).append(iframeClone);
   
             //embed clone with responsive container
             jquery_default()(iframe).replaceWith(embedContainer);
           }
         });
       };
       this.closeDrawers = e => {
         this.toggleLeftDrawer(false);
         this.toggleRightDrawer('cart', false);
       };
       this.addBadges = (root, timeout) => {
         this.badge.add(root, timeout);
       };
       this.name = 'Flow';
       this.$ = (jquery_default());
   
       // Passive event listeners for jQuery.
       (jquery_default()).event.special.touchstart = {
         setup: function (_, ns, handle) {
           // @ts-ignore
           this.addEventListener('touchstart', handle, {
             passive: !ns.includes('noPreventDefault')
           });
         }
       };
       (jquery_default()).event.special.touchmove = {
         setup: function (_, ns, handle) {
           // @ts-ignore
           this.addEventListener('touchmove', handle, {
             passive: !ns.includes('noPreventDefault')
           });
         }
       };
   
       /** Section by it's unique ID
        * @type {Map<string, Section>}
        */
       this.sectionById = new Map();
   
       /** Array of sections by given section type
        * @type {Map<string, Section[]>}
        */
       this.sectionsByType = new Map();
   
       /** Array of registed components
        * @type {Array<import('./Component').default>}
        */
       this.registeredComponents = [];
   
       /** Array of initialized vue components
        * @type {Array<Object>}
        */
       this.vueComponents = [];
   
       /** @type {Array<{ resolve: (YoutubeApi) => void, reject: (string) => void }>} */
       this.youtubeLoadedCallbacks = [];
       /** @type {Array<{ resolve: (VimeoApi) => void, reject: (string) => void }>} */
       this.vimeoLoadedCallbacks = [];
       /** @type {Array<{ resolve: (MapsApi) => void, reject: (string) => void }>} */
       this.mapsLoadedCallbacks = [];
       this.resizeDebounceTimer = null;
       document.addEventListener('shopify:section:load', this.onSectionLoad);
       document.addEventListener('shopify:section:unload', this.onSectionUnload);
       document.addEventListener('shopify:section:select', this.onSectionSelect);
       document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
       document.addEventListener('shopify:section:reorder', this.onSectionReorder);
       document.addEventListener('shopify:block:select', this.onBlockSelect);
       document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
       document.addEventListener('DOMContentLoaded', this.onLoadAll);
       document.addEventListener('keyup', this.onKeyUp);
       window.addEventListener('resize', this.onRawResize);
       window.addEventListener('scroll', this.onRawScroll);
       this.drawerOverlay = document.querySelector('#DrawerOverlay');
       if (this.drawerOverlay) {
         // We don't have it on password page
         document.querySelector('#DrawerOverlay').addEventListener('click', this.closeDrawers);
       }
   
       // Number of attempts to load Shopify product reviews
       this._spr_remaining_attemtps = 10;
     }
   
     /** This will be execute when whole DOM is loaded */
     load() {
       this.loadGlobal();
       this.breakpoint = this.getBreakpoint();
       this.wow = new (wow_default())().init();
       if (!document.body.classList.contains('password-page')) {
         // this.drawer = new Drawer(this);
         // this.cartDrawer = this.drawer.slideouts.right ? new CartDrawer(this, this.drawer.slideouts.right.menu) : null;
       }
       this.popup = null;
       const popupEl = /** @type {HTMLElement} */document.querySelector('#popup');
       if (popupEl && window.location.pathname !== '/challenge') {
         // Don't show popup when we're filling CAPTCHA for contact form
         this.popup = new Popup(this, popupEl);
       }
       this.verificationPopup = null;
       const verificationEl = /** @type {HTMLElement} */document.querySelector('.verification-popup-container');
       if (verificationEl && window.location.pathname !== '/challenge') {
         // Don't show popup when we're filling CAPTCHA for contact form
         this.verificationPopup = new VerificationPopup(this, verificationEl);
       }
   
       // Newsletter form could be on contact-us page, so outside of sections
       // this.newsletter = new Newsletter(this);
   
       // Login page doesn't have sections, load it here
       if (document.body.classList.contains('template-customers-login')) {
         this.login = new Login(this, document.body);
       }
   
       // Remove 'fadeInUp' animation from the first section
       let getAnimatedEls = document.querySelectorAll('.show-on-scroll');
       if (getAnimatedEls.length > 0) {
         getAnimatedEls[0].classList.remove('show-on-scroll');
       }
       this.handleAccordions();
       this.loadFadeAnimation();
   
       // Right drawer is not part of any component
       this.loadVueComponent(document.body, 'wetheme-right-drawer', global_RightDrawer);
       this.badge = new Badge(this, document.body);
       document.body.addEventListener('mousedown', this._usingMouse);
       document.body.addEventListener('keydown', this._usingTab);
     }
     _usingMouse() {
       document.body.classList.add('using-mouse');
       document.body.classList.remove('using-keyboard');
     }
     _usingTab(evt) {
       if (evt.key === "Tab") {
         document.body.classList.remove('using-mouse');
         document.body.classList.add('using-keyboard');
       }
     }
   }
   
   // Make the theme object instance globally available (without overriding the existing window.wetheme)
   const theme = new Theme();
   for (const [key, value] of Object.entries(theme)) {
     window.wetheme[key] = value;
   }
   window.onYouTubePlayerAPIReady = () => {
     window.wetheme.onYoutubeLoaded();
   };
   window.onGoogleMapsAPIReady = () => {
     window.wetheme.onGoogleMapsLoaded();
   };
   window.gm_authFailure = function () {
     window.wetheme.onGoogleAuthFailure('Google Maps authentication error, API key might be invalid');
   };
   })();
   
   /******/ })()
   ;

  var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
    links[i].rel = 'nofollow noreferrer noopener';
    }
    }


    // Script that closes hides klaviyo teaser when writing a review

    (function () {
  function hideKlaviyoTeaser() {
    // Common Klaviyo onsite teaser containers (varies by account/theme)
    const selectors = [
      '[class*="kl-teaser"]',
      '.kl-teaser',
      '.klaviyo-teaser',
      '[data-testid*="teaser"]'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        // Optional: only hide the one that contains the text "Extra $25 Off"
        if (el.textContent && el.textContent.toLowerCase().includes('extra $25 off')) {
          el.style.display = 'none';
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    const clickedWriteReview =
      e.target.closest('#stamped-main-widget') &&
      (e.target.closest('a,button,[role="button"]')?.textContent || '')
        .toLowerCase()
        .includes('write a review');

    if (clickedWriteReview) hideKlaviyoTeaser();
  });
})();
